import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  s9 as THROW_CCE,
  b3 as listOf,
  p5 as classMeta,
  da as throwUninitializedPropertyAccessException,
  j2 as emptySet,
  k1 as LinkedHashSet,
  o9 as NotImplementedError,
  t5 as fillArrayVal,
  e1 as ArrayList,
  v1 as addAll,
  a2 as collectionSizeOrDefault,
  s3 as plus,
  y3 as setOf,
  j4 as toSet,
  k9 as IllegalStateException,
  r6 as toString,
  aa as noWhenBranchMatchedException,
  q3 as plus_0,
  o2 as first,
  j1 as LinkedHashMap,
  u9 as Triple,
  m4 as union,
  a1 as Unit_getInstance,
  q9 as Pair,
  v9 as UnsupportedOperationException,
  h1 as HashSet,
  l3 as minus,
  g1 as HashMap,
  n4 as compareValues,
  a4 as sortedWith,
  b2 as contentHashCode,
  s2 as joinToString,
  f7 as Regex,
  z9 as lazy,
  c4 as toList,
  n2 as first_0,
  f1 as Collection,
  e6 as isInterface,
  c7 as KProperty1,
  w5 as getPropertyCallableRef,
  s5 as equals,
  y9 as ensureNotNull,
  p2 as flatten,
  h5 as booleanArray,
  n1 as Map,
  l2 as firstOrNull,
  n6 as protoOf,
  g7 as StringBuilder,
  x1 as arrayListOf,
  c3 as listOf_0,
  m3 as mutableListOf,
  z3 as setOf_0,
  r3 as plus_1,
  r2 as intersect,
  y5 as hashCode,
  z5 as interfaceMeta,
  r1 as MutableSet,
  i4 as toMutableSet,
  h2 as emptyList,
  n9 as NoSuchElementException,
  a as getKClassFromExpression,
  z1 as checkIndexOverflow,
  i2 as emptyMap,
  n5 as charSequenceLength,
  m5 as charSequenceGet,
  l8 as titlecase,
  l as toString_0,
  l1 as List,
  g8 as substringAfter,
  z8 as trimIndent,
  d3 as mapCapacity,
  u6 as coerceAtLeast,
  k2 as filterNotNull,
  s8 as toInt,
  y2 as last,
  r9 as RuntimeException,
  b as getKClass,
  w7 as removePrefix,
  d4 as toList_0,
  y1 as asList,
  i7 as contains,
  x5 as getStringHashCode,
  w as Companion_getInstance,
  t3 as plus_2,
  g2 as dropLast,
  x7 as replace,
  d as RegexOption_MULTILINE_getInstance,
  d7 as map,
  e7 as toList_1,
  s7 as lastIndexOfAny,
  v7 as regionMatches,
  k3 as minus_0,
  g3 as maxOrNull,
  q5 as compareTo,
  f5 as println,
  j3 as minus_1,
  s as IntCompanionObject_getInstance,
  h3 as maxWithOrNull,
  x2 as lastOrNull,
  s6 as ObservableProperty,
  u as Delegates_getInstance,
  a7 as KMutableProperty1,
  ea as toString_1,
  f as _Char___init__impl__6a9atx,
  f2 as copyToArray,
  o5 as charSequenceSubSequence,
  g9 as Enum,
  q8 as toIntOrNull,
  b6 as isCharSequence,
  e9 as Char,
  i6 as numberToChar,
  t2 as joinToString_0,
  g4 as toMutableList,
  z2 as last_0,
  x3 as reversed,
  fa as to,
  n3 as mutableMapOf,
  w3 as removeLast,
  e3 as mapOf,
  g6 as isObject,
  h8 as substringBeforeLast,
  p1 as MutableList,
  t9 as THROW_ISE,
  j5 as captureStack,
  i9 as Exception,
  q1 as MutableMap,
  b1 as AbstractList,
  t1 as Set,
  r5 as createThis,
  l9 as IndexOutOfBoundsException,
  v3 as removeLastOrNull,
  i1 as Iterable,
} from './kotlin-kotlin-stdlib.mjs';
import {
  g1 as TypeModelSimple,
  f as SimpleTypeModelStdLib_getInstance,
  k as PrimitiveType,
  i as DataType,
  n as TupleType,
  h as CollectionType,
  a as PropertyCharacteristic_COMPOSITE_getInstance,
  q as UnnamedSuperTypeType,
  h1 as TypeNamespaceAbstract,
  m as StructuredType,
  g as Companion_getInstance_0,
  p as TypeNamespace,
} from './net.akehurst.language-type-model.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '4.0.0-1.9.20-Beta';
    this.buildStamp = '2023-09-29T10:52:17.72021Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '10:52:17 UTC';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
}
class AutomatonBuilder {}
class AutomatonBuilderDefault {
  constructor(rrs, automatonKind, userGoalRuleName, isSkip) {
    this.rt_1 = rrs;
    var tmp = this;
    var tmp0_this = this.rt_1;
    var tmp1 = tmp0_this.ou_1;
    tmp0_this.ou_1 = tmp1 + 1 | 0;
    tmp.st_1 = new ParserStateSet(tmp1, this.rt_1, this.rt_1.pu(userGoalRuleName), isSkip, automatonKind, true);
    this.tt_1 = 0;
    this.ut_1 = ParseAction_GOAL_getInstance();
    this.vt_1 = ParseAction_WIDTH_getInstance();
    this.wt_1 = ParseAction_HEIGHT_getInstance();
    this.xt_1 = ParseAction_GRAFT_getInstance();
  }
  state(ruleNumber, option, position) {
    Companion_getInstance_33();
    if (-1 === ruleNumber) {
      this.qu(this.st_1.pv(), option, position);
    } else {
      this.qu(this.rt_1.au_1.p(ruleNumber), option, position);
    }
  }
  qu(rule, option, position) {
    return this.st_1.qv(listOf(new RulePosition(rule instanceof RuntimeRule ? rule : THROW_CCE(), option, position)));
  }
  transition(action, init) {
    this.rv(action, typeof init === 'function' ? init : THROW_CCE());
  }
  rv(action, init) {
    var b = new TransitionBuilderDefault(this.st_1, action);
    init(b);
    b.eo();
  }
  eo() {
    return this.st_1;
  }
}
class TransitionBuilder {}
class TransitionBuilderDefault {
  constructor(stateSet, action) {
    this.sv_1 = stateSet;
    this.tv_1 = action;
    this.uv_1 = emptySet();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    tmp.xv_1 = tmp$ret$0;
  }
  ctx(stateNumbers) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
  source(stateNumber) {
    return this.zv(this.sv_1.yv().p(stateNumber));
  }
  target(stateNumber) {
    return this.aw(this.sv_1.yv().p(stateNumber));
  }
  zv(state) {
    this.vv_1 = state;
  }
  aw(state) {
    this.wv_1 = state;
  }
  eo() {
    var tmp = _get__src__d2utae(this);
    var tmp_0 = tmp instanceof ParserState ? tmp : THROW_CCE();
    var tmp_1 = _get__tgt__d2v8ix(this);
    var trans = new Transition(tmp_0, tmp_1 instanceof ParserState ? tmp_1 : THROW_CCE(), this.tv_1, this.xv_1);
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg();
  }
}
class BuildCacheAbstract {
  constructor(stateSet) {
    this.bw_1 = stateSet;
    this.cw_1 = true;
    this.dw_1 = new FirstFollowCache3();
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.bw_1.su_1.au_1.o();
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(tmp_1), null);
    var tmp_2 = tmp$ret$0;
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      var tmp$ret$1;
      tmp$ret$1 = null;
      tmp_2[tmp_3] = tmp$ret$1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.ew_1 = tmp_2;
  }
  fw() {
    this.cw_1 = false;
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
  }
}
class BuildCacheLC1 extends BuildCacheAbstract {
  constructor(stateSet) {
    Companion_getInstance_1();
    super(stateSet);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.mx_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.nx_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.ox_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$3 = LinkedHashMap.n8();
    tmp_2.px_1 = tmp$ret$3;
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.ox_1;
    var tmp1_set = stateSet.ww();
    var tmp2_set = new StateInfo(setOf(stateSet.ww()));
    tmp0_set.m3(tmp1_set, tmp2_set);
  }
  gw() {
    this.mx_1.n1();
    this.nx_1.n1();
    this.cw_1 = true;
  }
  iw(rulePositions) {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = rulePositions.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergedStateInfoFor.<anonymous>' call
      tmp$ret$0 = this.ox_1.u3(element);
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    var sis = toSet(tmp$ret$3);
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp0_check = 1 === sis.o();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_check) {
        var tmp$ret$4;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$4 = 'Check failed.';
        var message = tmp$ret$4;
        throw IllegalStateException.y1(toString(message));
      }
    }
    return first(sis);
  }
  hw() {
    return stateInfo4(this);
  }
  jw(prevState, fromState) {
    Debug_getInstance();
    if (false) {
      var tmp = Debug_getInstance();
      var tmp_0 = IndentDelta_INC_AFTER_getInstance();
      tmp.uz(tmp_0, BuildCacheLC1$widthInto$lambda(prevState, fromState));
    }
    this.dw_1.n1();
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = prevState.yy_1;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap_0 = fromState.yy_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_0 = tmp0_flatMap_0.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>.<anonymous>' call
        var parentFollow = fromState.jz_1 ? Companion_getInstance_8().ax_1 : Companion_getInstance_8().yw_1;
        tmp$ret$0 = this.dw_1.jy(element, element_0, parentFollow);
        var list = tmp$ret$0;
        addAll(tmp0_flatMapTo_0, list);
      }
      tmp$ret$1 = tmp0_flatMapTo_0;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var list_0 = tmp$ret$3;
      addAll(tmp0_flatMapTo, list_0);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    var firstTerminals = toSet(tmp$ret$5);
    var tmp$ret$8;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$7;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(firstTerminals, 10));
    var tmp0_iterator_1 = firstTerminals.u();
    while (tmp0_iterator_1.h1()) {
      var item = tmp0_iterator_1.j1();
      var tmp$ret$6;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>' call
      var action = item.ky_1.ny() ? ParseAction_EMBED_getInstance() : ParseAction_WIDTH_getInstance();
      var rp = item.ky_1.vw();
      var lhs = item.ly_1;
      tmp$ret$6 = new WidthInfo(action, rp, lhs);
      tmp0_mapTo.e1(tmp$ret$6);
    }
    tmp$ret$7 = tmp0_mapTo;
    tmp$ret$8 = tmp$ret$7;
    var wis = tmp$ret$8;
    var tmp$ret$22;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$13;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp$ret$12;
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator_2 = wis.u();
    while (tmp0_iterator_2.h1()) {
      var element_1 = tmp0_iterator_2.j1();
      var tmp$ret$9;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>' call
      tmp$ret$9 = new Pair(element_1.wz_1, element_1.vz_1);
      var key = tmp$ret$9;
      var tmp$ret$11;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_1;
      if (value == null) {
        var tmp$ret$10;
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        tmp$ret$10 = ArrayList.i4();
        var answer = tmp$ret$10;
        tmp0_groupByTo.m3(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      tmp$ret$11 = tmp_1;
      var list_1 = tmp$ret$11;
      list_1.e1(element_1);
    }
    tmp$ret$12 = tmp0_groupByTo;
    tmp$ret$13 = tmp$ret$12;
    var tmp1_map = tmp$ret$13;
    var tmp$ret$21;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(tmp1_map.o());
    var tmp$ret$14;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$14 = tmp1_map.l3().u();
    var tmp0_iterator_3 = tmp$ret$14;
    while (tmp0_iterator_3.h1()) {
      var item_0 = tmp0_iterator_3.j1();
      var tmp$ret$20;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>' call
      var rp_0 = item_0.o3().ri_1;
      var action_0 = item_0.o3().si_1;
      var tmp$ret$19;
      // Inline function 'kotlin.collections.reduce' call
      var tmp$ret$17;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = item_0.p3();
      var tmp$ret$16;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator_4 = tmp0_map.u();
      while (tmp0_iterator_4.h1()) {
        var item_1 = tmp0_iterator_4.j1();
        var tmp$ret$15;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>.<anonymous>' call
        tmp$ret$15 = item_1.xz_1;
        tmp0_mapTo_1.e1(tmp$ret$15);
      }
      tmp$ret$16 = tmp0_mapTo_1;
      tmp$ret$17 = tmp$ret$16;
      var tmp1_reduce = tmp$ret$17;
      var iterator = tmp1_reduce.u();
      if (!iterator.h1())
        throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
      var accumulator = iterator.j1();
      while (iterator.h1()) {
        var tmp$ret$18;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>.<anonymous>' call
        var tmp2_anonymous = accumulator;
        var tmp3_anonymous = iterator.j1();
        tmp$ret$18 = tmp2_anonymous.iy(tmp3_anonymous);
        accumulator = tmp$ret$18;
      }
      tmp$ret$19 = accumulator;
      var lhs_0 = tmp$ret$19;
      tmp$ret$20 = new WidthInfo(action_0, rp_0, lhs_0);
      tmp0_mapTo_0.e1(tmp$ret$20);
    }
    tmp$ret$21 = tmp0_mapTo_0;
    tmp$ret$22 = tmp$ret$21;
    var wisMerged = tmp$ret$22;
    Debug_getInstance();
    if (false) {
      var tmp_2 = Debug_getInstance();
      var tmp_3 = IndentDelta_DEC_BEFORE_getInstance();
      tmp_2.uz(tmp_3, BuildCacheLC1$widthInto$lambda_0(prevState, fromState));
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_5 = wisMerged.u();
    while (tmp0_iterator_5.h1()) {
      var element_2 = tmp0_iterator_5.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.ox_1;
      var tmp1_set = element_2.wz_1;
      var tmp2_set = new StateInfo(setOf(element_2.wz_1));
      tmp0_set.m3(tmp1_set, tmp2_set);
    }
    return toSet(wisMerged);
  }
  kw(prevPrev, prevState, fromState) {
    var calc = calcAndCacheHeightOrGraftInto(this, prevPrev, prevState, fromState);
    return calc;
  }
}
class FirstFollowCache3 {
  constructor() {
    var tmp = this;
    tmp.bx_1 = lazyMutableMapNonNull(FirstFollowCache3$_doneFollow$lambda);
    var tmp_0 = this;
    tmp_0.cx_1 = lazyMutableMapNonNull(FirstFollowCache3$_firstTerminal$lambda);
    var tmp_1 = this;
    tmp_1.dx_1 = lazyMutableMapNonNull(FirstFollowCache3$_parentInContext$lambda);
    var tmp_2 = this;
    tmp_2.ex_1 = lazyMutableMapNonNull(FirstFollowCache3$_possibleContexts$lambda);
  }
  n1() {
    this.bx_1.n1();
    this.cx_1.n1();
    this.dx_1.n1();
    this.ex_1.n1();
  }
  wx(rp) {
    return this.ex_1.u3(rp);
  }
  jy(context, rulePosition, parentFollow) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp0_check = !context.vx();
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_check) {
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.FirstFollowCache3.firstTerminalInContext.<anonymous>' call
        tmp$ret$0 = 'firstTerminal(' + context + ',' + rulePosition + ')';
        var message = tmp$ret$0;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var tmp;
    if (this.cx_1.r3(context) ? this.cx_1.u3(context).r3(rulePosition) : false) {
      tmp = this.cx_1.u3(context).u3(rulePosition);
    } else {
      processClosureFor(this, context, rulePosition, parentFollow);
      tmp = this.cx_1.u3(context).u3(rulePosition);
    }
    return tmp;
  }
  xx(contextContext, context, completedRule) {
    var ctx = context.t10() ? contextContext : context;
    var tmp;
    if (this.dx_1.r3(ctx) ? this.dx_1.u3(ctx).r3(completedRule) : false) {
      tmp = this.dx_1.u3(ctx).u3(completedRule);
    } else {
      processClosureFor(this, contextContext, context, Companion_getInstance_8().yw_1);
      tmp = this.dx_1.u3(ctx).u3(completedRule);
    }
    return tmp;
  }
  fx(context, rulePosition, parentExpectedAt) {
    this.n1();
    var graph = new ClosureGraph(context, rulePosition, parentExpectedAt);
    this.v10(graph);
  }
  d10(graph) {
    Debug_getInstance();
    if (false) {
      var tmp = IndentDelta_INC_AFTER_getInstance();
      debug(tmp, FirstFollowCache3$calcFirstTermClosure$lambda(graph));
    }
    if (graph.a10_1.f10_1.cy() ? graph.a10_1.f10_1.vx() : false) {
      return Unit_getInstance();
    }
    var todoList = mutableQueueOf([]);
    todoList.x10(graph.a10_1);
    while (todoList.y10()) {
      var cls = todoList.z10();
      var tmp0_iterator = cls.r10().a11().u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        if (item.s10()) {
          graph.c11(cls, item.vw());
        } else if (item.d11()) {
          var childRps = item.b11();
          var tmp1_iterator = childRps.u();
          while (tmp1_iterator.h1()) {
            var childRp = tmp1_iterator.j1();
            var child = graph.c11(cls, childRp);
            if (null == child) {
            } else {
              todoList.x10(child);
            }
          }
        } else {
          // Inline function 'kotlin.error' call
          throw IllegalStateException.y1('Internal Error: should never happen');
        }
      }
    }
    graph.e11();
    cacheStuff(this, graph);
    Debug_getInstance();
    if (false) {
      var tmp_0 = IndentDelta_DEC_BEFORE_getInstance();
      debug(tmp_0, FirstFollowCache3$calcFirstTermClosure$lambda_0(graph));
    }
  }
  v10(graph) {
    Debug_getInstance();
    if (false) {
      var tmp = IndentDelta_INC_AFTER_getInstance();
      debug(tmp, FirstFollowCache3$calcAllClosure$lambda(graph));
    }
    if (graph.a10_1.f10_1.cy() ? graph.a10_1.f10_1.vx() : false) {
      return Unit_getInstance();
    } else {
      var todoList = mutableQueueOf([]);
      todoList.x10(graph.a10_1);
      while (todoList.y10()) {
        var cls = todoList.z10();
        var tmp0_iterator = cls.r10().a11().u();
        while (tmp0_iterator.h1()) {
          var item = tmp0_iterator.j1();
          if (item.s10()) {
            graph.c11(cls, item.vw());
          } else if (item.d11()) {
            var childRps = item.f11();
            var tmp1_iterator = childRps.u();
            while (tmp1_iterator.h1()) {
              var childRp = tmp1_iterator.j1();
              var child = graph.c11(cls, childRp);
              if (null == child) {
              } else {
                todoList.x10(child);
              }
            }
          } else {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.y1('Internal Error: should never happen');
          }
        }
      }
      graph.e11();
      cacheStuff(this, graph);
    }
    Debug_getInstance();
    if (false) {
      var tmp_0 = IndentDelta_DEC_BEFORE_getInstance();
      debug(tmp_0, FirstFollowCache3$calcAllClosure$lambda_0(graph));
    }
  }
}
class FirstOfResult {
  constructor(needsFirstOfParentNext, result) {
    this.g11_1 = needsFirstOfParentNext;
    this.h11_1 = result;
  }
  toString() {
    return 'FirstOfResult(needsFirstOfParentNext=' + this.g11_1 + ', result=' + this.h11_1 + ')';
  }
  hashCode() {
    var result = this.g11_1 | 0;
    result = imul(result, 31) + this.h11_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FirstOfResult))
      return false;
    var tmp0_other_with_cast = other instanceof FirstOfResult ? other : THROW_CCE();
    if (!(this.g11_1 === tmp0_other_with_cast.g11_1))
      return false;
    if (!this.h11_1.equals(tmp0_other_with_cast.h11_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
  }
}
class FirstOf {
  constructor() {
    Companion_getInstance_2();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.p11_1 = tmp$ret$0;
  }
  r11(rulePosition, ifReachedEnd) {
    this.p11_1.n1();
    var tmp;
    if (rulePosition.vx()) {
      tmp = ifReachedEnd;
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp$ret$0 = LinkedHashMap.n8();
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.hashMapOf' call
      tmp$ret$1 = HashMap.w4();
      var res = firstOfRpNotEmpty(this, rulePosition, tmp_0, tmp$ret$1);
      var tmp_1;
      if (res.g11_1) {
        var tmp_2;
        if (rulePosition.vx()) {
          tmp_2 = res.h11_1.iy(ifReachedEnd);
        } else {
          var next = rulePosition.j1();
          var notSelf = minus(next, rulePosition);
          var tmp$ret$6;
          // Inline function 'kotlin.collections.fold' call
          var tmp$ret$4;
          // Inline function 'kotlin.collections.map' call
          var tmp$ret$3;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(notSelf, 10));
          var tmp0_iterator = notSelf.u();
          while (tmp0_iterator.h1()) {
            var item = tmp0_iterator.j1();
            var tmp$ret$2;
            // Inline function 'net.akehurst.language.agl.agl.automaton.FirstOf.expectedAt.<anonymous>' call
            tmp$ret$2 = this.r11(item, ifReachedEnd);
            tmp0_mapTo.e1(tmp$ret$2);
          }
          tmp$ret$3 = tmp0_mapTo;
          tmp$ret$4 = tmp$ret$3;
          var tmp0_fold = tmp$ret$4;
          var tmp1_fold = Companion_getInstance_8().xw_1;
          var accumulator = tmp1_fold;
          var tmp0_iterator_0 = tmp0_fold.u();
          while (tmp0_iterator_0.h1()) {
            var element = tmp0_iterator_0.j1();
            var tmp$ret$5;
            // Inline function 'net.akehurst.language.agl.agl.automaton.FirstOf.expectedAt.<anonymous>' call
            var tmp2_anonymous = accumulator;
            tmp$ret$5 = tmp2_anonymous.iy(element);
            accumulator = tmp$ret$5;
          }
          tmp$ret$6 = accumulator;
          var ne = tmp$ret$6;
          tmp_2 = res.h11_1.iy(ne);
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = res.h11_1;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.s11_1 = function_0;
  }
  rc(a, b) {
    return this.s11_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.c12_1 = new Lookahead(Companion_getInstance_4().d12_1, Companion_getInstance_4().d12_1);
  }
  j12(automaton, initial) {
    var tmp0_subject = initial.o();
    var tmp;
    if (tmp0_subject === 1) {
      tmp = initial;
    } else {
      var tmp$ret$27;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$18;
      // Inline function 'kotlin.collections.groupBy' call
      var tmp$ret$13;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$4;
      // Inline function 'kotlin.collections.groupBy' call
      var tmp$ret$3;
      // Inline function 'kotlin.collections.groupByTo' call
      var tmp0_groupByTo = LinkedHashMap.n8();
      var tmp0_iterator = initial.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
        tmp$ret$0 = element.u11_1;
        var key = tmp$ret$0;
        var tmp$ret$2;
        // Inline function 'kotlin.collections.getOrPut' call
        var value = tmp0_groupByTo.u3(key);
        var tmp_0;
        if (value == null) {
          var tmp$ret$1;
          // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
          tmp$ret$1 = ArrayList.i4();
          var answer = tmp$ret$1;
          tmp0_groupByTo.m3(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        tmp$ret$2 = tmp_0;
        var list = tmp$ret$2;
        list.e1(element);
      }
      tmp$ret$3 = tmp0_groupByTo;
      tmp$ret$4 = tmp$ret$3;
      var tmp0_map = tmp$ret$4;
      var tmp$ret$12;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(tmp0_map.o());
      var tmp$ret$5;
      // Inline function 'kotlin.collections.iterator' call
      tmp$ret$5 = tmp0_map.l3().u();
      var tmp0_iterator_0 = tmp$ret$5;
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$11;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
        var up = item.o3();
        var tmp$ret$10;
        // Inline function 'kotlin.collections.reduce' call
        var tmp$ret$8;
        // Inline function 'kotlin.collections.map' call
        var tmp0_map_0 = item.p3();
        var tmp$ret$7;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map_0, 10));
        var tmp0_iterator_1 = tmp0_map_0.u();
        while (tmp0_iterator_1.h1()) {
          var item_0 = tmp0_iterator_1.j1();
          var tmp$ret$6;
          // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>.<anonymous>' call
          tmp$ret$6 = item_0.t11_1;
          tmp0_mapTo_0.e1(tmp$ret$6);
        }
        tmp$ret$7 = tmp0_mapTo_0;
        tmp$ret$8 = tmp$ret$7;
        var tmp1_reduce = tmp$ret$8;
        var iterator = tmp1_reduce.u();
        if (!iterator.h1())
          throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
        var accumulator = iterator.j1();
        while (iterator.h1()) {
          var tmp$ret$9;
          // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>.<anonymous>' call
          var tmp2_anonymous = accumulator;
          var tmp3_anonymous = iterator.j1();
          tmp$ret$9 = tmp2_anonymous.k12(automaton, tmp3_anonymous);
          accumulator = tmp$ret$9;
        }
        tmp$ret$10 = accumulator;
        var guard = tmp$ret$10;
        tmp$ret$11 = new Lookahead(guard, up);
        tmp0_mapTo.e1(tmp$ret$11);
      }
      tmp$ret$12 = tmp0_mapTo;
      tmp$ret$13 = tmp$ret$12;
      var tmp1_groupBy = toSet(tmp$ret$13);
      var tmp$ret$17;
      // Inline function 'kotlin.collections.groupByTo' call
      var tmp0_groupByTo_0 = LinkedHashMap.n8();
      var tmp0_iterator_2 = tmp1_groupBy.u();
      while (tmp0_iterator_2.h1()) {
        var element_0 = tmp0_iterator_2.j1();
        var tmp$ret$14;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
        tmp$ret$14 = element_0.t11_1;
        var key_0 = tmp$ret$14;
        var tmp$ret$16;
        // Inline function 'kotlin.collections.getOrPut' call
        var value_0 = tmp0_groupByTo_0.u3(key_0);
        var tmp_1;
        if (value_0 == null) {
          var tmp$ret$15;
          // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
          tmp$ret$15 = ArrayList.i4();
          var answer_0 = tmp$ret$15;
          tmp0_groupByTo_0.m3(key_0, answer_0);
          tmp_1 = answer_0;
        } else {
          tmp_1 = value_0;
        }
        tmp$ret$16 = tmp_1;
        var list_0 = tmp$ret$16;
        list_0.e1(element_0);
      }
      tmp$ret$17 = tmp0_groupByTo_0;
      tmp$ret$18 = tmp$ret$17;
      var tmp2_map = tmp$ret$18;
      var tmp$ret$26;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_1 = ArrayList.f4(tmp2_map.o());
      var tmp$ret$19;
      // Inline function 'kotlin.collections.iterator' call
      tmp$ret$19 = tmp2_map.l3().u();
      var tmp0_iterator_3 = tmp$ret$19;
      while (tmp0_iterator_3.h1()) {
        var item_1 = tmp0_iterator_3.j1();
        var tmp$ret$25;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
        var guard_0 = item_1.o3();
        var tmp$ret$24;
        // Inline function 'kotlin.collections.reduce' call
        var tmp$ret$22;
        // Inline function 'kotlin.collections.map' call
        var tmp0_map_1 = item_1.p3();
        var tmp$ret$21;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(tmp0_map_1, 10));
        var tmp0_iterator_4 = tmp0_map_1.u();
        while (tmp0_iterator_4.h1()) {
          var item_2 = tmp0_iterator_4.j1();
          var tmp$ret$20;
          // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>.<anonymous>' call
          tmp$ret$20 = item_2.u11_1;
          tmp0_mapTo_2.e1(tmp$ret$20);
        }
        tmp$ret$21 = tmp0_mapTo_2;
        tmp$ret$22 = tmp$ret$21;
        var tmp1_reduce_0 = tmp$ret$22;
        var iterator_0 = tmp1_reduce_0.u();
        if (!iterator_0.h1())
          throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
        var accumulator_0 = iterator_0.j1();
        while (iterator_0.h1()) {
          var tmp$ret$23;
          // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>.<anonymous>' call
          var tmp2_anonymous_0 = accumulator_0;
          var tmp3_anonymous_0 = iterator_0.j1();
          tmp$ret$23 = tmp2_anonymous_0.k12(automaton, tmp3_anonymous_0);
          accumulator_0 = tmp$ret$23;
        }
        tmp$ret$24 = accumulator_0;
        var up_0 = tmp$ret$24;
        tmp$ret$25 = new Lookahead(guard_0, up_0);
        tmp0_mapTo_1.e1(tmp$ret$25);
      }
      tmp$ret$26 = tmp0_mapTo_1;
      tmp$ret$27 = tmp$ret$26;
      var merged = toSet(tmp$ret$27);
      var tmp1_subject = merged.o();
      var tmp_2;
      if (tmp1_subject === 1) {
        tmp_2 = merged;
      } else {
        var tmp$ret$29;
        // Inline function 'kotlin.collections.sortedByDescending' call
        var tmp$ret$28;
        // Inline function 'kotlin.comparisons.compareByDescending' call
        var tmp_3 = Lookahead$Companion$merge$lambda;
        tmp$ret$28 = new sam$kotlin_Comparator$0(tmp_3);
        tmp$ret$29 = sortedWith(merged, tmp$ret$28);
        var sortedMerged = tmp$ret$29;
        var tmp$ret$30;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp$ret$30 = LinkedHashSet.r8();
        var result = tmp$ret$30;
        var tmp$ret$31;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp$ret$31 = LinkedHashSet.r8();
        var mergedIntoOther = tmp$ret$31;
        var inductionVariable = 0;
        var last = sortedMerged.o() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var lh1 = sortedMerged.p(i);
            if (mergedIntoOther.w(lh1)) {
            } else {
              var inductionVariable_0 = i + 1 | 0;
              var last_0 = sortedMerged.o();
              if (inductionVariable_0 < last_0)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var lh2 = sortedMerged.p(j);
                  if (lh1.t11_1.l12(lh2.t11_1)) {
                    lh1 = new Lookahead(lh1.t11_1, lh1.u11_1.k12(automaton, lh2.u11_1));
                    mergedIntoOther.e1(lh2);
                  } else {
                  }
                }
                 while (inductionVariable_0 < last_0);
              result.e1(lh1);
            }
          }
           while (inductionVariable <= last);
        tmp_2 = result;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
}
class Lookahead {
  constructor(guard, up) {
    Companion_getInstance_3();
    this.t11_1 = guard;
    this.u11_1 = up;
  }
  hashCode() {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.t11_1, this.u11_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return contentHashCode(tmp$ret$2);
  }
  equals(other) {
    var tmp;
    if (!(other instanceof Lookahead)) {
      tmp = false;
    } else {
      if (!this.u11_1.equals(other.u11_1)) {
        tmp = false;
      } else {
        if (!this.t11_1.equals(other.t11_1)) {
          tmp = false;
        } else {
          tmp = true;
        }
      }
    }
    return tmp;
  }
  toString() {
    return 'LH(' + this.t11_1 + ', ' + this.u11_1 + ')';
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_2 = this;
    this.d12_1 = new LookaheadSet(-1, false, false, false, emptySet());
    this.e12_1 = new LookaheadSet(-2, false, false, true, emptySet());
    this.f12_1 = new LookaheadSet(-3, false, true, false, emptySet());
    this.g12_1 = new LookaheadSet(-4, true, false, false, emptySet());
    this.h12_1 = new LookaheadSet(-5, true, true, false, emptySet());
    this.i12_1 = -6;
  }
}
class LookaheadSet {
  constructor(number, includesRT, includesEOT, matchANY, content) {
    Companion_getInstance_4();
    this.v11_1 = number;
    this.w11_1 = includesRT;
    this.x11_1 = includesEOT;
    this.y11_1 = matchANY;
    this.z11_1 = content;
    var tmp = this;
    tmp.a12_1 = lazy(LookaheadSet$regex$delegate$lambda(this));
  }
  b12() {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    var c = tmp$ret$0;
    if (this.w11_1) {
      c.e1(Companion_getInstance_33().m13_1);
    }
    if (this.x11_1) {
      c.e1(Companion_getInstance_33().l13_1);
    }
    if (this.y11_1) {
      c.e1(Companion_getInstance_33().n13_1);
    }
    c.k1(this.z11_1);
    return c;
  }
  q13() {
    return new LookaheadSetPart(this.w11_1, this.x11_1, this.y11_1, this.z11_1);
  }
  r13(eotLookahead, runtimeLookahead) {
    var tmp;
    if (eotLookahead.w11_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if (runtimeLookahead.w11_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if ((this.y11_1 ? true : this.x11_1 ? eotLookahead.y11_1 : false) ? true : this.w11_1 ? runtimeLookahead.y11_1 : false) {
      tmp = new LookaheadSetPart(false, false, true, emptySet());
    } else {
      var tmp_0;
      if (this.x11_1 ? this.w11_1 : false) {
        var resolvedContent = union(union(this.z11_1, runtimeLookahead.z11_1), eotLookahead.z11_1);
        var eot = eotLookahead.x11_1 ? true : runtimeLookahead.x11_1;
        tmp_0 = new LookaheadSetPart(false, eot, false, resolvedContent);
      } else if (this.x11_1) {
        var resolvedContent_0 = union(this.z11_1, eotLookahead.z11_1);
        var eot_0 = eotLookahead.x11_1;
        tmp_0 = new LookaheadSetPart(false, eot_0, false, resolvedContent_0);
      } else if (this.w11_1) {
        var resolvedContent_1 = union(this.z11_1, runtimeLookahead.z11_1);
        var eot_1 = runtimeLookahead.x11_1;
        tmp_0 = new LookaheadSetPart(false, eot_1, false, resolvedContent_1);
      } else {
        tmp_0 = new LookaheadSetPart(false, false, false, this.z11_1);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  s13(eotLookahead, runtimeLookahead) {
    var tmp;
    if (eotLookahead.w11_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if (runtimeLookahead.dy_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if ((this.y11_1 ? true : this.x11_1 ? eotLookahead.y11_1 : false) ? true : this.w11_1 ? runtimeLookahead.fy_1 : false) {
      tmp = new LookaheadSetPart(false, false, true, emptySet());
    } else {
      var tmp_0;
      if (this.x11_1 ? this.w11_1 : false) {
        var resolvedContent = union(union(this.z11_1, runtimeLookahead.gy_1), eotLookahead.z11_1);
        var eot = eotLookahead.x11_1 ? true : runtimeLookahead.ey_1;
        tmp_0 = new LookaheadSetPart(false, eot, false, resolvedContent);
      } else if (this.x11_1) {
        var resolvedContent_0 = union(this.z11_1, eotLookahead.z11_1);
        var eot_0 = eotLookahead.x11_1;
        tmp_0 = new LookaheadSetPart(false, eot_0, false, resolvedContent_0);
      } else if (this.w11_1) {
        var resolvedContent_1 = union(this.z11_1, runtimeLookahead.gy_1);
        var eot_1 = runtimeLookahead.ey_1;
        tmp_0 = new LookaheadSetPart(false, eot_1, false, resolvedContent_1);
      } else {
        tmp_0 = new LookaheadSetPart(false, false, false, this.z11_1);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  k12(automaton, lookahead) {
    var rt = this.w11_1 ? true : lookahead.w11_1;
    var eot = this.x11_1 ? true : lookahead.x11_1;
    var ma = this.y11_1 ? true : lookahead.y11_1;
    return automaton.t13(rt, eot, ma, union(this.z11_1, lookahead.z11_1));
  }
  u13(automaton, additionalContent) {
    var rt = this.w11_1;
    var eot = this.x11_1;
    var ma = this.y11_1;
    return automaton.t13(rt, eot, ma, union(this.z11_1, additionalContent));
  }
  l12(other) {
    return this.y11_1 ? true : (!this.x11_1 ? other.x11_1 : false) ? false : (!this.w11_1 ? other.w11_1 : false) ? false : this.b12().x(other.b12());
  }
  hashCode() {
    return this.v11_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof LookaheadSet) {
      tmp = this.v11_1 === other.v11_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    var tmp;
    if (this.equals(Companion_getInstance_4().d12_1)) {
      tmp = 'LookaheadSet{' + this.v11_1 + ',[EMPTY]}';
    } else if (this.equals(Companion_getInstance_4().e12_1)) {
      tmp = 'LookaheadSet{' + this.v11_1 + ',[ANY]}';
    } else if (this.equals(Companion_getInstance_4().g12_1)) {
      tmp = 'LookaheadSet{' + this.v11_1 + ',[RT]}';
    } else if (this.equals(Companion_getInstance_4().f12_1)) {
      tmp = 'LookaheadSet{' + this.v11_1 + ',[EOT]}';
    } else {
      var tmp_0 = this.b12();
      tmp = 'LookaheadSet{' + this.v11_1 + ',' + joinToString(tmp_0, ',', '[', ']', VOID, VOID, LookaheadSet$toString$lambda) + '}';
    }
    return tmp;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
  }
  v13(_this__u8e3s4, stateSet) {
    return stateSet.t13(_this__u8e3s4.dy_1, _this__u8e3s4.ey_1, _this__u8e3s4.fy_1, _this__u8e3s4.gy_1);
  }
}
class ParserState {
  constructor(number, rulePositions, stateSet) {
    Companion_getInstance_5();
    this.xy_1 = number;
    this.yy_1 = rulePositions;
    this.zy_1 = stateSet;
    var tmp = this;
    var tmp0_subject = this.zy_1.vu_1;
    var tmp0 = tmp0_subject.bc_1;
    var tmp_0;
    switch (tmp0) {
      case 0:
        tmp_0 = new TransitionCacheLC1();
        break;
      case 1:
        throw NotImplementedError.eg();
      case 2:
        tmp_0 = new TransitionCacheLC1();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.az_1 = tmp_0;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.rulePositionIdentity.<anonymous>' call
      tmp$ret$0 = item.tx_1;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    tmp_1.bz_1 = toSet(tmp$ret$2);
    var tmp_2 = this;
    tmp_2.cz_1 = lazy(ParserState$runtimeRules$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.dz_1 = lazy(ParserState$runtimeRulesAsSet$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.ez_1 = lazy(ParserState$optionList$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.fz_1 = lazy(ParserState$positionList$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.gz_1 = lazy(ParserState$choiceKindList$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.hz_1 = lazy(ParserState$isChoice$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.iz_1 = lazy(ParserState$firstRuleChoiceKind$delegate$lambda(this));
    this.jz_1 = this.z13().cy();
    this.kz_1 = this.z13().equals(this.zy_1.tu_1);
  }
  lz() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = runtimeRules$factory();
    tmp$ret$0 = this.cz_1.p3();
    return tmp$ret$0;
  }
  c14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = runtimeRulesAsSet$factory();
    tmp$ret$0 = this.dz_1.p3();
    return tmp$ret$0;
  }
  d14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = optionList$factory();
    tmp$ret$0 = this.ez_1.p3();
    return tmp$ret$0;
  }
  e14() {
    return this.d14();
  }
  b14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = choiceKindList$factory();
    tmp$ret$0 = this.gz_1.p3();
    return tmp$ret$0;
  }
  a14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = isChoice$factory();
    tmp$ret$0 = this.hz_1.p3();
    return tmp$ret$0;
  }
  f14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = firstRuleChoiceKind$factory();
    tmp$ret$0 = this.iz_1.p3();
    return tmp$ret$0;
  }
  z13() {
    return first_0(this.lz());
  }
  g14() {
    return this.z13().s10();
  }
  vx() {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = this.yy_1;
      var tmp;
      if (isInterface(tmp0_any, Collection)) {
        tmp = tmp0_any.y();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_any.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.automaton.ParserState.<get-isAtEnd>.<anonymous>' call
        tmp$ret$1 = element.vx();
        if (tmp$ret$1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  h14() {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = this.yy_1;
      var tmp;
      if (isInterface(tmp0_any, Collection)) {
        tmp = tmp0_any.y();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_any.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.automaton.ParserState.<get-isNotAtEnd>.<anonymous>' call
        tmp$ret$1 = !element.vx();
        if (tmp$ret$1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  i14(previous) {
    var cache = this.az_1.j14(previous);
    var tmp;
    if (null == cache) {
      Debug_getInstance();
      if (false) {
        // Inline function 'kotlin.check' call
        var tmp0_check = !this.zy_1.av_1;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp0_check) {
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsGoal.<anonymous>' call
          tmp$ret$0 = 'Transitions not built for ' + this + ' -previous-> ' + previous;
          var message = tmp$ret$0;
          throw IllegalStateException.y1(toString(message));
        }
      }
      var filteredTransitions = toList(this.zy_1.zu_1.m14(this, previous));
      var tmp$ret$3;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(filteredTransitions, 10));
      var tmp0_iterator = filteredTransitions.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsGoal.<anonymous>' call
        tmp$ret$1 = this.az_1.n14(previous, item);
        tmp0_mapTo.e1(tmp$ret$1);
      }
      tmp$ret$2 = tmp0_mapTo;
      tmp$ret$3 = tmp$ret$2;
      var storedTrans = tmp$ret$3;
      tmp = storedTrans;
    } else {
      tmp = cache;
    }
    var trans = tmp;
    return trans;
  }
  o14(previous) {
    var cache = this.az_1.j14(previous);
    var tmp;
    if (null == cache) {
      Debug_getInstance();
      if (false) {
        // Inline function 'kotlin.check' call
        var tmp0_check = !this.zy_1.av_1;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp0_check) {
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsInComplete.<anonymous>' call
          tmp$ret$0 = 'Transitions not built for ' + this + ' -previous-> ' + previous;
          var message = tmp$ret$0;
          throw IllegalStateException.y1(toString(message));
        }
      }
      var filteredTransitions = toList(this.zy_1.zu_1.p14(this, previous));
      var tmp$ret$3;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(filteredTransitions, 10));
      var tmp0_iterator = filteredTransitions.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsInComplete.<anonymous>' call
        tmp$ret$1 = this.az_1.n14(previous, item);
        tmp0_mapTo.e1(tmp$ret$1);
      }
      tmp$ret$2 = tmp0_mapTo;
      tmp$ret$3 = tmp$ret$2;
      var storedTrans = tmp$ret$3;
      tmp = storedTrans;
    } else {
      tmp = cache;
    }
    var trans = tmp;
    return trans;
  }
  q14(previous, prevPrev) {
    var cache = this.az_1.r14(previous, prevPrev);
    var tmp;
    if (null == cache) {
      Debug_getInstance();
      if (false) {
        // Inline function 'kotlin.check' call
        var tmp0_check = !this.zy_1.av_1;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp0_check) {
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsComplete.<anonymous>' call
          tmp$ret$0 = 'Transitions not built for ' + this + ' -previous-> ' + previous;
          var message = tmp$ret$0;
          throw IllegalStateException.y1(toString(message));
        }
      }
      var filteredTransitions = toList(this.zy_1.zu_1.s14(this, previous, prevPrev));
      var tmp$ret$3;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(filteredTransitions, 10));
      var tmp0_iterator = filteredTransitions.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.automaton.ParserState.transitionsComplete.<anonymous>' call
        tmp$ret$1 = this.az_1.t14(previous, prevPrev, item);
        tmp0_mapTo.e1(tmp$ret$1);
      }
      tmp$ret$2 = tmp0_mapTo;
      tmp$ret$3 = tmp$ret$2;
      var storedTrans = tmp$ret$3;
      tmp = storedTrans;
    } else {
      tmp = cache;
    }
    var trans = tmp;
    return trans;
  }
  hashCode() {
    return _StateNumber___get_value__impl__2zl2l(this.xy_1) + imul(this.zy_1.ru_1, 31) | 0;
  }
  equals(other) {
    var tmp;
    if (other instanceof ParserState) {
      tmp = this.zy_1.ru_1 === other.zy_1.ru_1 ? _StateNumber___get_value__impl__2zl2l(this.xy_1) === _StateNumber___get_value__impl__2zl2l(other.xy_1) : false;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'State(' + _StateNumber___get_value__impl__2zl2l(this.xy_1) + '/' + this.zy_1.ru_1 + '-' + this.yy_1 + ')';
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.c15_1 = function_0;
  }
  rc(a, b) {
    return this.c15_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class Automaton {}
function asString(withStates, $super) {
  withStates = withStates === VOID ? false : withStates;
  return this.t15(withStates);
}
class ParserStateSet {
  constructor(number, runtimeRuleSet, userGoalRule, isSkip, automatonKind, preBuilt) {
    this.ru_1 = number;
    this.su_1 = runtimeRuleSet;
    this.tu_1 = userGoalRule;
    this.uu_1 = isSkip;
    this.vu_1 = automatonKind;
    this.wu_1 = 0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.xu_1 = tmp$ret$0;
    this.yu_1 = 0;
    this.zu_1 = new RuntimeTransitionCalculator(this);
    this.av_1 = preBuilt;
    var tmp_0 = this;
    tmp_0.bv_1 = lazy(ParserStateSet$buildCache$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.cv_1 = lazy(ParserStateSet$usedRules$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.dv_1 = lazy(ParserStateSet$usedTerminalRules$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.ev_1 = lazy(ParserStateSet$usedNonTerminalRules$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.fv_1 = lazy(ParserStateSet$firstTerminals$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.gv_1 = lazy(ParserStateSet$embeddedRuntimeRuleSet$delegate$lambda(this));
    var tmp_6 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_6.hv_1 = tmp$ret$1;
    var tmp_7 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$2 = ArrayList.i4();
    tmp_7.iv_1 = tmp$ret$2;
    var tmp_8 = this;
    tmp_8.jv_1 = lazy(ParserStateSet$goalRule$delegate$lambda(this));
    var tmp_9 = this;
    tmp_9.kv_1 = lazy(ParserStateSet$startRulePosition$delegate$lambda(this));
    var tmp_10 = this;
    tmp_10.lv_1 = lazy(ParserStateSet$finishRulePosition$delegate$lambda(this));
    var tmp_11 = this;
    tmp_11.mv_1 = lazy(ParserStateSet$startState$delegate$lambda(this));
    var tmp_12 = this;
    tmp_12.nv_1 = lazy(ParserStateSet$finishState$delegate$lambda(this));
    this.ov_1 = new FirstOf();
  }
  u14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = buildCache$factory();
    tmp$ret$0 = this.bv_1.p3();
    return tmp$ret$0;
  }
  d15() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = usedRules$factory();
    tmp$ret$0 = this.cv_1.p3();
    return tmp$ret$0;
  }
  uw() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = usedTerminalRules$factory();
    tmp$ret$0 = this.dv_1.p3();
    return tmp$ret$0;
  }
  lw() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = usedNonTerminalRules$factory();
    tmp$ret$0 = this.ev_1.p3();
    return tmp$ret$0;
  }
  m15() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = firstTerminals$factory();
    tmp$ret$0 = this.fv_1.p3();
    return tmp$ret$0;
  }
  n15() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = embeddedRuntimeRuleSet$factory();
    tmp$ret$0 = this.gv_1.p3();
    return tmp$ret$0;
  }
  yv() {
    return toList(this.iv_1);
  }
  pv() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = goalRule$factory();
    tmp$ret$0 = this.jv_1.p3();
    return tmp$ret$0;
  }
  ww() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = startRulePosition$factory();
    tmp$ret$0 = this.kv_1.p3();
    return tmp$ret$0;
  }
  l15() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = finishRulePosition$factory();
    tmp$ret$0 = this.lv_1.p3();
    return tmp$ret$0;
  }
  w14() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = startState$factory();
    tmp$ret$0 = this.mv_1.p3();
    return tmp$ret$0;
  }
  o15() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = finishState$factory();
    tmp$ret$0 = this.nv_1.p3();
    return tmp$ret$0;
  }
  qv(rulePositions) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.contains' call
      var tmp0_contains = this.hv_1;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.containsKey' call
      tmp$ret$0 = (isInterface(tmp0_contains, Map) ? tmp0_contains : THROW_CCE()).r3(rulePositions);
      tmp$ret$1 = tmp$ret$0;
      var tmp1_check = !tmp$ret$1;
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp1_check) {
        var tmp$ret$2;
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.createState.<anonymous>' call
        tmp$ret$2 = 'State already created for ' + rulePositions;
        var message = tmp$ret$2;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var existing = this.hv_1.u3(rulePositions);
    var tmp;
    if (!(null == existing)) {
      tmp = existing;
    } else {
      var tmp0_this = this;
      var tmp1 = tmp0_this.yu_1;
      tmp0_this.yu_1 = tmp1 + 1 | 0;
      var state = new ParserState(_StateNumber___init__impl__9xx5q7(tmp1), toList(rulePositions), this);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.hv_1;
      tmp2_set.m3(rulePositions, state);
      this.iv_1.o2(_StateNumber___get_value__impl__2zl2l(state.xy_1), state);
      tmp = state;
    }
    return tmp;
  }
  p15(rulePositions) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.contains' call
      var tmp0_contains = this.hv_1;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.containsKey' call
      tmp$ret$0 = (isInterface(tmp0_contains, Map) ? tmp0_contains : THROW_CCE()).r3(rulePositions);
      tmp$ret$1 = tmp$ret$0;
      var tmp1_check = !tmp$ret$1;
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp1_check) {
        var tmp$ret$2;
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.createMergedState.<anonymous>' call
        tmp$ret$2 = 'State already created for ' + rulePositions;
        var message = tmp$ret$2;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var existing = this.hv_1.u3(rulePositions);
    var tmp;
    if (!(null == existing)) {
      tmp = existing;
    } else {
      var si = this.u14().iw(rulePositions);
      var state = this.qv(toList(si.gx_1));
      tmp = state;
    }
    return tmp;
  }
  x14(rulePositions) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.yv();
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.fetchState.<anonymous>' call
        tmp$ret$0 = equals(toSet(element.yy_1), toSet(rulePositions));
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  y14(rulePositions) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.yv();
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.fetchCompatibleState.<anonymous>' call
        tmp$ret$0 = element.yy_1.x(rulePositions);
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var existing = tmp$ret$1;
    return existing;
  }
  v14(rulePositions) {
    var tmp0_elvis_lhs = this.y14(rulePositions);
    return tmp0_elvis_lhs == null ? this.p15(rulePositions) : tmp0_elvis_lhs;
  }
  t13(includeRT, includeEOT, matchAny, content) {
    var tmp;
    if (content.y()) {
      var tmp_0;
      if (matchAny) {
        tmp_0 = Companion_getInstance_4().e12_1;
      } else if ((includeRT ? !includeEOT : false) ? !matchAny : false) {
        tmp_0 = Companion_getInstance_4().g12_1;
      } else if ((!includeRT ? includeEOT : false) ? !matchAny : false) {
        tmp_0 = Companion_getInstance_4().f12_1;
      } else if ((!includeRT ? !includeEOT : false) ? !matchAny : false) {
        tmp_0 = Companion_getInstance_4().d12_1;
      } else if ((includeRT ? !includeEOT : false) ? !matchAny : false) {
        tmp_0 = Companion_getInstance_4().g12_1;
      } else if ((includeRT ? includeEOT : false) ? !matchAny : false) {
        tmp_0 = Companion_getInstance_4().h12_1;
      } else {
        throw IllegalStateException.y1('Internal Error: situation not handled');
      }
      tmp = tmp_0;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_firstOrNull = this.xu_1;
        var tmp0_iterator = tmp0_firstOrNull.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.createLookaheadSet.<anonymous>' call
          tmp$ret$0 = ((element.w11_1 === includeRT ? element.x11_1 === includeEOT : false) ? element.y11_1 === matchAny : false) ? equals(element.z11_1, content) : false;
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var existing = tmp$ret$1;
      var tmp_1;
      if (null == existing) {
        var tmp0_this = this;
        var tmp1 = tmp0_this.wu_1;
        tmp0_this.wu_1 = tmp1 + 1 | 0;
        var num = tmp1;
        var lhs = new LookaheadSet(num, includeRT, includeEOT, matchAny, content);
        this.xu_1.e1(lhs);
        tmp_1 = lhs;
      } else {
        tmp_1 = existing;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  q15(part) {
    return this.t13(part.dy_1, part.ey_1, part.fy_1, part.gy_1);
  }
  r15(sourceState) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = sourceState.lz();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.precedenceRulesFor.<anonymous>' call
      tmp$ret$0 = this.su_1.s15(item);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return firstOrNull(tmp$ret$2);
  }
  eo() {
    if (!this.av_1) {
      this.u14().fw();
      buildAndTraverse(this);
      this.av_1 = true;
      this.u14().gw();
    } else {
    }
    return this;
  }
  hashCode() {
    return this.ru_1;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (tmp0_subject instanceof ParserStateSet) {
      tmp = this.ru_1 === other.ru_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  t15(withStates) {
    return this.u15(withStates);
  }
  u15(withStates) {
    var b = StringBuilder.qa();
    var states = this.yv();
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = states.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
      tmp$ret$0 = element.az_1.v15();
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    var transitions = tmp$ret$2;
    b.a8('UsedRules: ' + this.d15().o() + '  States: ' + states.o() + '  Transitions: ' + transitions.o() + ' ');
    b.a8('\n');
    if (withStates) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = states.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
        var tmp = element_0.az_1.w15();
        var str = '' + element_0 + ' {' + joinToString(tmp, VOID, VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda) + '}';
        b.a8(str).a8('\n');
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$6;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp$ret$3;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = ParserStateSet$usedAutomatonToString$lambda_0;
    tmp$ret$3 = new sam$kotlin_Comparator$0_0(tmp_0);
    tmp$ret$4 = sortedWith(transitions, tmp$ret$3);
    var tmp0_sortedBy = tmp$ret$4;
    var tmp$ret$5;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = ParserStateSet$usedAutomatonToString$lambda_1;
    tmp$ret$5 = new sam$kotlin_Comparator$0_0(tmp_1);
    tmp$ret$6 = sortedWith(tmp0_sortedBy, tmp$ret$5);
    var tmp1_forEach = tmp$ret$6;
    var tmp0_iterator_1 = tmp1_forEach.u();
    while (tmp0_iterator_1.h1()) {
      var element_1 = tmp0_iterator_1.j1();
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
      var tmp_2 = element_1.e15_1.az_1.x15(element_1);
      var prev = joinToString(tmp_2, VOID, VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda_2);
      var tmp_3 = _StateNumber___get_value__impl__2zl2l(element_1.e15_1.xy_1);
      var frStr = '' + tmp_3 + ':(' + joinToString(element_1.e15_1.yy_1, VOID, VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda_3) + ')';
      var toStr = '' + _StateNumber___get_value__impl__2zl2l(element_1.f15_1.xy_1) + ':' + element_1.f15_1.yy_1;
      var trStr = frStr + ' --> ' + toStr;
      var lh = joinToString(element_1.h15_1, '|', VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda_4);
      b.a8(' ' + element_1.g15_1 + ' ');
      b.a8(trStr);
      b.a8(lh);
      b.a8(' {' + prev + '} ');
      b.a8('\n');
    }
    return b.toString();
  }
  toString() {
    return 'ParserStateSet{' + this.ru_1 + ' (' + this.tu_1.mz() + ') }';
  }
}
class RuntimeTransitionCalculator {
  constructor(stateSet) {
    this.k14_1 = stateSet;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    tmp.l14_1 = tmp$ret$0;
  }
  m14(sourceState, previousState) {
    this.l14_1.n1();
    var widthInto = this.k14_1.u14().jw(previousState, sourceState);
    var tmp0_iterator = widthInto.u();
    while (tmp0_iterator.h1()) {
      var wi = tmp0_iterator.j1();
      var tmp = wi.wz_1.qx_1;
      var rr = tmp instanceof RuntimeRule ? tmp : THROW_CCE();
      if (rr.s10()) {
        this.l14_1.e1(createWidthOrEmbeddedTransition(this, sourceState, wi));
      } else {
        // Inline function 'kotlin.error' call
        throw IllegalStateException.y1('Should never happen');
      }
    }
    return this.l14_1;
  }
  s14(sourceState, previousState, prevPrev) {
    this.l14_1.n1();
    var heightOrGraftInto = this.k14_1.u14().kw(prevPrev, previousState, sourceState);
    var tmp0_iterator = heightOrGraftInto.u();
    while (tmp0_iterator.h1()) {
      var hg = tmp0_iterator.j1();
      var tmp1_subject = hg.qy_1;
      var tmp0 = tmp1_subject.bc_1;
      switch (tmp0) {
        case 3:
          if (sourceState.jz_1 ? this.k14_1.uu_1 : false) {
            var to = sourceState;
            this.l14_1.e1(new Transition(sourceState, to, ParseAction_GOAL_getInstance(), setOf(Companion_getInstance_3().c12_1)));
          } else {
            var ts = createGoalTransition3(this, sourceState, hg);
            this.l14_1.e1(ts);
          }

          break;
        case 0:
          var ts_0 = createHeightTransition3(this, sourceState, hg);
          this.l14_1.e1(ts_0);
          ;
          break;
        case 1:
          var ts_1 = createGraftTransition3(this, sourceState, hg);
          this.l14_1.e1(ts_1);
          ;
          break;
        default:
          // Inline function 'kotlin.error' call

          throw IllegalStateException.y1('');
      }
    }
    return this.l14_1;
  }
  p14(source, previous) {
    this.l14_1.n1();
    var widthInto = this.k14_1.u14().jw(previous, source);
    var tmp0_iterator = widthInto.u();
    while (tmp0_iterator.h1()) {
      var wi = tmp0_iterator.j1();
      var ts = createWidthOrEmbeddedTransition(this, source, wi);
      this.l14_1.e1(ts);
    }
    return this.l14_1;
  }
}
class ToEndMultiGraftRuntimeGuard {
  constructor(trans) {
    this.y15_1 = trans;
    var tmp = this;
    var tmp_0 = this.y15_1.f15_1.z13().i11();
    tmp.z15_1 = tmp_0 instanceof RuntimeRuleRhsListSimple ? tmp_0 : THROW_CCE();
    this.a16_1 = this.z15_1.d16_1;
    this.b16_1 = this.z15_1.e16_1;
  }
  g16(numNonSkipChildren) {
    return this.a16_1 <= (numNonSkipChildren + 1 | 0) ? -1 === this.b16_1 ? true : (numNonSkipChildren + 1 | 0) <= this.b16_1 : false;
  }
  h16(numNonSkipChildren) {
    var tmp;
    if (this.a16_1 > numNonSkipChildren) {
      tmp = setOf(this.z15_1.f16_1);
    } else if (!(-1 === this.b16_1) ? this.b16_1 < (numNonSkipChildren + 1 | 0) : false) {
      var tmp$ret$4;
      // Inline function 'kotlin.collections.fold' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = this.y15_1.h15_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.ToEndMultiGraftRuntimeGuard.expectedWhenFailed.<anonymous>' call
        tmp$ret$0 = item.t11_1;
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var tmp1_fold = tmp$ret$2;
      var tmp2_fold = Companion_getInstance_8().xw_1;
      var accumulator = tmp2_fold;
      var tmp0_iterator_0 = tmp1_fold.u();
      while (tmp0_iterator_0.h1()) {
        var element = tmp0_iterator_0.j1();
        var tmp$ret$3;
        // Inline function 'net.akehurst.language.agl.automaton.ToEndMultiGraftRuntimeGuard.expectedWhenFailed.<anonymous>' call
        var tmp3_anonymous = accumulator;
        tmp$ret$3 = tmp3_anonymous.iy(element.q13());
        accumulator = tmp$ret$3;
      }
      tmp$ret$4 = accumulator;
      tmp = tmp$ret$4.b12();
    } else {
      tmp = emptySet();
    }
    return tmp;
  }
  toString() {
    return 'ToEndMulti{' + this.a16_1 + ' <= n}';
  }
}
class ToItemMultiGraftRuntimeGuard {
  constructor(trans) {
    this.i16_1 = trans;
    var tmp = this;
    var tmp_0 = this.i16_1.f15_1.z13().i11();
    tmp.j16_1 = tmp_0 instanceof RuntimeRuleRhsListSimple ? tmp_0 : THROW_CCE();
    this.k16_1 = this.j16_1.d16_1;
    this.l16_1 = this.j16_1.e16_1;
  }
  g16(numNonSkipChildren) {
    return -1 === this.l16_1 ? true : (numNonSkipChildren + 1 | 0) < this.l16_1;
  }
  h16(numNonSkipChildren) {
    return (-1 === this.l16_1 ? true : (numNonSkipChildren + 1 | 0) < this.l16_1) ? emptySet() : emptySet();
  }
  toString() {
    return 'ToItemMulti{n <= ' + this.l16_1 + '}';
  }
}
class ToEndSListGraftRuntimeGuard {
  constructor(trans) {
    this.m16_1 = trans;
    var tmp = this;
    var tmp_0 = this.m16_1.f15_1.z13().i11();
    tmp.n16_1 = tmp_0 instanceof RuntimeRuleRhsList ? tmp_0 : THROW_CCE();
    this.o16_1 = this.n16_1.r16();
    this.p16_1 = this.n16_1.s16();
  }
  g16(numNonSkipChildren) {
    return this.o16_1 <= ((numNonSkipChildren / 2 | 0) + 1 | 0) ? -1 === this.p16_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) <= this.p16_1 : false;
  }
  h16(numNonSkipChildren) {
    return this.o16_1 <= ((numNonSkipChildren / 2 | 0) + 1 | 0) ? emptySet() : (-1 === this.p16_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) <= this.p16_1) ? emptySet() : emptySet();
  }
  toString() {
    return 'ToEndSList{' + this.o16_1 + ' <= n}';
  }
}
class ToItemSListGraftRuntimeGuard {
  constructor(trans) {
    this.t16_1 = trans;
    var tmp = this;
    var tmp_0 = this.t16_1.f15_1.z13().i11();
    tmp.u16_1 = tmp_0 instanceof RuntimeRuleRhsList ? tmp_0 : THROW_CCE();
    this.v16_1 = this.u16_1.r16();
    this.w16_1 = this.u16_1.s16();
  }
  g16(numNonSkipChildren) {
    return -1 === this.w16_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) < this.w16_1;
  }
  h16(numNonSkipChildren) {
    return (-1 === this.w16_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) < this.w16_1) ? emptySet() : emptySet();
  }
  toString() {
    return 'ToItemSList{n <= ' + this.w16_1 + '}';
  }
}
class ToSeparatorSListGraftRuntimeGuard {
  constructor(trans) {
    this.x16_1 = trans;
    var tmp = this;
    var tmp_0 = this.x16_1.f15_1.z13().i11();
    tmp.y16_1 = tmp_0 instanceof RuntimeRuleRhsList ? tmp_0 : THROW_CCE();
    this.z16_1 = this.y16_1.r16();
    this.a17_1 = this.y16_1.s16();
  }
  g16(numNonSkipChildren) {
    return -1 === this.a17_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) < this.a17_1;
  }
  h16(numNonSkipChildren) {
    return (-1 === this.a17_1 ? true : ((numNonSkipChildren / 2 | 0) + 1 | 0) < this.a17_1) ? emptySet() : emptySet();
  }
  toString() {
    return 'ToSeparatorSList{n <= ' + this.a17_1 + '}';
  }
}
class DefaultRuntimeGuard {
  constructor() {
    DefaultRuntimeGuard_instance = this;
  }
  g16(numNonSkipChildren) {
    return true;
  }
  h16(numNonSkipChildren) {
    throw IllegalStateException.y1('Internal Error: should never happen');
  }
  toString() {
    return 'DefaultRuntimeGuard{true}';
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
  }
  b17(trans) {
    var target = trans.f15_1.z13();
    var targetRp = trans.f15_1.yy_1.p(0);
    var tgtRhs = target.i11();
    var tmp0_subject = trans.g15_1;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    if (tmp0 === 1) {
      var tmp1_subject = tgtRhs;
      var tmp_0;
      if (tmp1_subject instanceof RuntimeRuleRhsListSimple) {
        var tmp_1;
        if (targetRp.vx()) {
          tmp_1 = new ToEndMultiGraftRuntimeGuard(trans);
        } else {
          Companion_getInstance_29();
          if (targetRp.sx_1 === 1) {
            tmp_1 = new ToItemMultiGraftRuntimeGuard(trans);
          } else {
            throw NotImplementedError.eg();
          }
        }
        tmp_0 = tmp_1;
      } else {
        if (tmp1_subject instanceof RuntimeRuleRhsListSeparated) {
          var tmp_2;
          if (targetRp.vx()) {
            tmp_2 = new ToEndSListGraftRuntimeGuard(trans);
          } else {
            Companion_getInstance_29();
            if (targetRp.sx_1 === 2) {
              tmp_2 = new ToItemSListGraftRuntimeGuard(trans);
            } else {
              Companion_getInstance_29();
              if (targetRp.sx_1 === 1) {
                tmp_2 = new ToSeparatorSListGraftRuntimeGuard(trans);
              } else {
                throw NotImplementedError.eg();
              }
            }
          }
          tmp_0 = tmp_2;
        } else {
          tmp_0 = DefaultRuntimeGuard_getInstance();
        }
      }
      tmp = tmp_0;
    } else {
      tmp = DefaultRuntimeGuard_getInstance();
    }
    return tmp;
  }
}
class Transition {
  constructor(from, to, action, lookahead) {
    Companion_getInstance_6();
    this.e15_1 = from;
    this.f15_1 = to;
    this.g15_1 = action;
    this.h15_1 = lookahead;
    var tmp = this;
    tmp.i15_1 = lazy(Transition$context$delegate$lambda(this));
    this.j15_1 = Companion_getInstance_6().b17(this);
    var tmp_0 = this;
    tmp_0.k15_1 = lazy(Transition$hashCode_cache$delegate$lambda(this));
  }
  uf() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = context$factory();
    tmp$ret$0 = this.i15_1.p3();
    return tmp$ret$0;
  }
  hashCode() {
    return _get_hashCode_cache__hrfw4t(this);
  }
  equals(other) {
    var tmp0_subject = other;
    if (tmp0_subject instanceof Transition) {
      if (!this.e15_1.equals(other.e15_1))
        return false;
      if (!this.f15_1.equals(other.f15_1))
        return false;
      if (!this.g15_1.equals(other.g15_1))
        return false;
      if (!equals(this.h15_1, other.h15_1))
        return false;
      return true;
    } else {
      return false;
    }
  }
  toString() {
    var tmp = this.uf();
    var ctx = joinToString(tmp, VOID, VOID, VOID, VOID, VOID, Transition$toString$lambda);
    var lhsStr = joinToString(this.h15_1, '|', VOID, VOID, VOID, VOID, Transition$toString$lambda_0);
    return 'Transition: ' + this.e15_1 + ' -- ' + this.g15_1 + lhsStr + ' --> ' + this.f15_1 + ' {' + ctx + '}';
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
  }
}
class TransitionCacheLC1 {
  constructor() {
    Companion_getInstance_7();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.c17_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.d17_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.e17_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$3 = LinkedHashMap.n8();
    tmp_2.f17_1 = tmp$ret$3;
  }
  v15() {
    return toSet(plus(_get__allBuiltIncomplete__j98m7d(this), _get__allBuiltComplete__fb3q3g(this)));
  }
  w15() {
    return toSet(plus(_get__allPreviousIncomplete__5lazpo(this), _get__allPreviousComplete__hn51vr(this)));
  }
  t14(previous, prevPrev, tr) {
    var automaton = tr.e15_1.zy_1;
    var key = new Pair(tr.g15_1, tr.f15_1);
    var existing = this.c17_1.u3(key);
    var ck = new CompleteKey(previous, prevPrev);
    var tmp;
    if (null == existing) {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.c17_1;
      var tmp1_set = new Pair(setOf(ck), tr);
      tmp0_set.m3(key, tmp1_set);
      updateCompleteByPrevious(this, setOf(ck), null, tr);
      tmp = tr;
    } else {
      var toMerge = setOf_0([tr, existing.si_1]);
      var mergedTr = merge(Companion_getInstance_7(), automaton, toMerge);
      var mergedPrev = plus_1(existing.ri_1, ck);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.c17_1;
      var tmp3_set = new Pair(mergedPrev, mergedTr);
      tmp2_set.m3(key, tmp3_set);
      updateCompleteByPrevious(this, mergedPrev, existing.si_1, mergedTr);
      Debug_getInstance();
      if (false) {
        var tmp_0 = Debug_getInstance();
        var tmp_1 = IndentDelta_NONE_getInstance();
        tmp_0.uz(tmp_1, TransitionCacheLC1$addTransitionForComplete$lambda(toMerge));
      }
      Debug_getInstance();
      if (false) {
        var tmp_2 = Debug_getInstance();
        var tmp_3 = IndentDelta_NONE_getInstance();
        tmp_2.uz(tmp_3, TransitionCacheLC1$addTransitionForComplete$lambda_0(mergedTr));
      }
      tmp = mergedTr;
    }
    return tmp;
  }
  n14(previous, tr) {
    var automaton = tr.e15_1.zy_1;
    var key = new Pair(tr.g15_1, tr.f15_1);
    var existing = this.d17_1.u3(key);
    var tmp;
    if (null == existing) {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.d17_1;
      var tmp1_set = new Pair(setOf(previous), tr);
      tmp0_set.m3(key, tmp1_set);
      updateIncompleteByPrevious(this, setOf(previous), null, tr);
      tmp = tr;
    } else {
      var toMerge = setOf_0([tr, existing.si_1]);
      var mergedTr = merge(Companion_getInstance_7(), automaton, toMerge);
      var mergedPrev = plus_1(existing.ri_1, previous);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.d17_1;
      var tmp3_set = new Pair(mergedPrev, mergedTr);
      tmp2_set.m3(key, tmp3_set);
      updateIncompleteByPrevious(this, mergedPrev, existing.si_1, mergedTr);
      Debug_getInstance();
      if (false) {
        var tmp_0 = Debug_getInstance();
        var tmp_1 = IndentDelta_NONE_getInstance();
        tmp_0.uz(tmp_1, TransitionCacheLC1$addTransitionForIncomplete$lambda(toMerge));
      }
      Debug_getInstance();
      if (false) {
        var tmp_2 = Debug_getInstance();
        var tmp_3 = IndentDelta_NONE_getInstance();
        tmp_2.uz(tmp_3, TransitionCacheLC1$addTransitionForIncomplete$lambda_0(mergedTr));
      }
      tmp = mergedTr;
    }
    return tmp;
  }
  r14(previous, prevPrev) {
    return this.e17_1.u3(new CompleteKey(previous, prevPrev));
  }
  j14(previous) {
    return this.f17_1.u3(previous);
  }
  x15(transition) {
    var tmp;
    if (transition.e15_1.vx()) {
      var tmp$ret$5;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_filter = this.e17_1.l3();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList.i4();
      var tmp0_iterator = tmp0_filter.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.previousFor.<anonymous>' call
        tmp$ret$0 = element.p3().w(transition);
        if (tmp$ret$0) {
          tmp0_filterTo.e1(element);
        }
      }
      tmp$ret$1 = tmp0_filterTo;
      tmp$ret$2 = tmp$ret$1;
      var tmp1_map = tmp$ret$2;
      var tmp$ret$4;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
      var tmp0_iterator_0 = tmp1_map.u();
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$3;
        // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.previousFor.<anonymous>' call
        tmp$ret$3 = item.o3();
        tmp0_mapTo.e1(tmp$ret$3);
      }
      tmp$ret$4 = tmp0_mapTo;
      tmp$ret$5 = tmp$ret$4;
      tmp = tmp$ret$5;
    } else {
      var tmp$ret$11;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$8;
      // Inline function 'kotlin.collections.filter' call
      var tmp2_filter = this.f17_1.l3();
      var tmp$ret$7;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo_0 = ArrayList.i4();
      var tmp0_iterator_1 = tmp2_filter.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        var tmp$ret$6;
        // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.previousFor.<anonymous>' call
        tmp$ret$6 = element_0.p3().w(transition);
        if (tmp$ret$6) {
          tmp0_filterTo_0.e1(element_0);
        }
      }
      tmp$ret$7 = tmp0_filterTo_0;
      tmp$ret$8 = tmp$ret$7;
      var tmp3_map = tmp$ret$8;
      var tmp$ret$10;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp3_map, 10));
      var tmp0_iterator_2 = tmp3_map.u();
      while (tmp0_iterator_2.h1()) {
        var item_0 = tmp0_iterator_2.j1();
        var tmp$ret$9;
        // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.previousFor.<anonymous>' call
        tmp$ret$9 = new IncompleteKey(item_0.o3());
        tmp0_mapTo_0.e1(tmp$ret$9);
      }
      tmp$ret$10 = tmp0_mapTo_0;
      tmp$ret$11 = tmp$ret$10;
      tmp = tmp$ret$11;
    }
    return tmp;
  }
  z14(previous, prevPrev, from, action, to, lookahead) {
    var trans = new Transition(from, to, action, lookahead);
    this.t14(previous, prevPrev, trans);
  }
  a15(previous, from, action, to, lookahead) {
    var trans = new Transition(from, to, action, lookahead);
    this.n14(previous, trans);
  }
}
class CompleteKey {
  constructor(previous, prevPrev) {
    this.g17_1 = previous;
    this.h17_1 = prevPrev;
  }
  toString() {
    return '' + _StateNumber___get_value__impl__2zl2l(this.h17_1.xy_1) + '-' + _StateNumber___get_value__impl__2zl2l(this.g17_1.xy_1);
  }
  hashCode() {
    var result = this.g17_1.hashCode();
    result = imul(result, 31) + this.h17_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompleteKey))
      return false;
    var tmp0_other_with_cast = other instanceof CompleteKey ? other : THROW_CCE();
    if (!this.g17_1.equals(tmp0_other_with_cast.g17_1))
      return false;
    if (!this.h17_1.equals(tmp0_other_with_cast.h17_1))
      return false;
    return true;
  }
}
class IncompleteKey {
  constructor(previous) {
    this.i17_1 = previous;
  }
  toString() {
    return '' + _StateNumber___get_value__impl__2zl2l(this.i17_1.xy_1);
  }
  hashCode() {
    return this.i17_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof IncompleteKey))
      return false;
    var tmp0_other_with_cast = other instanceof IncompleteKey ? other : THROW_CCE();
    if (!this.i17_1.equals(tmp0_other_with_cast.i17_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.xw_1 = new LookaheadSetPart(false, false, false, emptySet());
    this.yw_1 = new LookaheadSetPart(true, false, false, emptySet());
    this.zw_1 = new LookaheadSetPart(false, false, true, emptySet());
    this.ax_1 = new LookaheadSetPart(false, true, false, emptySet());
  }
  o11(fullContent) {
    var includeRT = fullContent.w(Companion_getInstance_33().m13_1);
    var includeEOT = fullContent.w(Companion_getInstance_33().l13_1);
    var matchAny = fullContent.w(Companion_getInstance_33().n13_1);
    var content = minus(minus(minus(fullContent, Companion_getInstance_33().m13_1), Companion_getInstance_33().l13_1), Companion_getInstance_33().n13_1);
    return new LookaheadSetPart(includeRT, includeEOT, matchAny, content);
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.j17_1 = function_0;
  }
  rc(a, b) {
    return this.j17_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class LookaheadSetPart {
  constructor(includesRT, includesEOT, matchANY, content) {
    Companion_getInstance_8();
    this.dy_1 = includesRT;
    this.ey_1 = includesEOT;
    this.fy_1 = matchANY;
    this.gy_1 = content;
    var tmp = this;
    tmp.hy_1 = lazy(LookaheadSetPart$regex$delegate$lambda(this));
  }
  b12() {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    var cont = tmp$ret$0;
    if (this.dy_1) {
      cont.e1(Companion_getInstance_33().m13_1);
    }
    if (this.ey_1) {
      cont.e1(Companion_getInstance_33().l13_1);
    }
    if (this.fy_1) {
      cont.e1(Companion_getInstance_33().n13_1);
    }
    cont.k1(this.gy_1);
    return cont;
  }
  k17() {
    return ((!this.dy_1 ? !this.ey_1 : false) ? !this.fy_1 : false) ? this.gy_1.y() : false;
  }
  y10() {
    return !this.k17();
  }
  l17(eotLookahead, runtimeLookahead) {
    var tmp;
    if (eotLookahead.dy_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if (runtimeLookahead.dy_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else if ((this.fy_1 ? true : this.ey_1 ? eotLookahead.fy_1 : false) ? true : this.dy_1 ? runtimeLookahead.fy_1 : false) {
      tmp = new LookaheadSetPart(false, false, true, emptySet());
    } else {
      var tmp_0;
      if (this.ey_1 ? this.dy_1 : false) {
        var resolvedContent = union(union(this.gy_1, runtimeLookahead.gy_1), eotLookahead.gy_1);
        var eot = eotLookahead.ey_1 ? true : runtimeLookahead.ey_1;
        tmp_0 = new LookaheadSetPart(false, eot, false, resolvedContent);
      } else if (this.ey_1) {
        var resolvedContent_0 = union(this.gy_1, eotLookahead.gy_1);
        var eot_0 = eotLookahead.ey_1;
        tmp_0 = new LookaheadSetPart(false, eot_0, false, resolvedContent_0);
      } else if (this.dy_1) {
        var resolvedContent_1 = union(this.gy_1, runtimeLookahead.gy_1);
        var eot_1 = runtimeLookahead.ey_1;
        tmp_0 = new LookaheadSetPart(false, eot_1, false, resolvedContent_1);
      } else {
        tmp_0 = new LookaheadSetPart(false, false, false, this.gy_1);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  m17(lookahead) {
    var rt = this.dy_1 ? lookahead.dy_1 : false;
    var eot = this.ey_1 ? lookahead.ey_1 : false;
    var ma = this.fy_1 ? lookahead.fy_1 : false;
    return new LookaheadSetPart(rt, eot, ma, intersect(this.gy_1, lookahead.gy_1));
  }
  iy(lhs) {
    return this.fy_1 ? Companion_getInstance_8().zw_1 : lhs.fy_1 ? Companion_getInstance_8().zw_1 : new LookaheadSetPart(this.dy_1 ? true : lhs.dy_1, this.ey_1 ? true : lhs.ey_1, false, union(this.gy_1, lhs.gy_1));
  }
  toString() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.b12();
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = LookaheadSetPart$toString$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0_1(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var tmp_0 = tmp$ret$1;
    return 'LHS(' + joinToString(tmp_0, VOID, VOID, VOID, VOID, VOID, LookaheadSetPart$toString$lambda_0) + ')';
  }
  hashCode() {
    var result = this.dy_1 | 0;
    result = imul(result, 31) + (this.ey_1 | 0) | 0;
    result = imul(result, 31) + (this.fy_1 | 0) | 0;
    result = imul(result, 31) + hashCode(this.gy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LookaheadSetPart))
      return false;
    var tmp0_other_with_cast = other instanceof LookaheadSetPart ? other : THROW_CCE();
    if (!(this.dy_1 === tmp0_other_with_cast.dy_1))
      return false;
    if (!(this.ey_1 === tmp0_other_with_cast.ey_1))
      return false;
    if (!(this.fy_1 === tmp0_other_with_cast.fy_1))
      return false;
    if (!equals(this.gy_1, tmp0_other_with_cast.gy_1))
      return false;
    return true;
  }
}
class StateInfo {
  constructor(rulePositions) {
    this.gx_1 = rulePositions;
    this.hx_1 = emptySet();
  }
  toString() {
    return 'StateInfo(rulePositions=' + this.gx_1 + ')';
  }
  hashCode() {
    return hashCode(this.gx_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StateInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StateInfo ? other : THROW_CCE();
    if (!equals(this.gx_1, tmp0_other_with_cast.gx_1))
      return false;
    return true;
  }
}
class TransInfo {
  constructor(prevPrev, prev, action, to, lookahead) {
    this.oy_1 = prevPrev;
    this.py_1 = prev;
    this.qy_1 = action;
    this.ry_1 = to;
    this.sy_1 = lookahead;
  }
  toString() {
    return 'TransInfo(prevPrev=' + this.oy_1 + ', prev=' + this.py_1 + ', action=' + this.qy_1 + ', to=' + this.ry_1 + ', lookahead=' + this.sy_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.oy_1);
    result = imul(result, 31) + hashCode(this.py_1) | 0;
    result = imul(result, 31) + this.qy_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ry_1) | 0;
    result = imul(result, 31) + hashCode(this.sy_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TransInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TransInfo ? other : THROW_CCE();
    if (!equals(this.oy_1, tmp0_other_with_cast.oy_1))
      return false;
    if (!equals(this.py_1, tmp0_other_with_cast.py_1))
      return false;
    if (!this.qy_1.equals(tmp0_other_with_cast.qy_1))
      return false;
    if (!equals(this.ry_1, tmp0_other_with_cast.ry_1))
      return false;
    if (!equals(this.sy_1, tmp0_other_with_cast.sy_1))
      return false;
    return true;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.vy_1 = new LookaheadInfoPart(Companion_getInstance_8().xw_1, Companion_getInstance_8().xw_1);
  }
  wy(initial) {
    return this.n17(initial);
  }
  n17(initial) {
    var r = new LookaheadInfoPart(Companion_getInstance_8().xw_1, Companion_getInstance_8().xw_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = initial.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.Companion.merge2.<anonymous>' call
      var g = r.ty_1.iy(element.ty_1);
      var u = r.uy_1.iy(element.uy_1);
      r = new LookaheadInfoPart(g, u);
    }
    return setOf(r);
  }
}
class LookaheadInfoPart {
  constructor(guard, up) {
    Companion_getInstance_9();
    this.ty_1 = guard;
    this.uy_1 = up;
  }
  toString() {
    return 'LookaheadInfoPart(guard=' + this.ty_1 + ', up=' + this.uy_1 + ')';
  }
  hashCode() {
    var result = this.ty_1.hashCode();
    result = imul(result, 31) + this.uy_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LookaheadInfoPart))
      return false;
    var tmp0_other_with_cast = other instanceof LookaheadInfoPart ? other : THROW_CCE();
    if (!this.ty_1.equals(tmp0_other_with_cast.ty_1))
      return false;
    if (!this.uy_1.equals(tmp0_other_with_cast.uy_1))
      return false;
    return true;
  }
}
class WidthInfo {
  constructor(action, to, lookaheadSet) {
    this.vz_1 = action;
    this.wz_1 = to;
    this.xz_1 = lookaheadSet;
  }
  toString() {
    return 'WidthInfo(action=' + this.vz_1 + ', to=' + this.wz_1 + ', lookaheadSet=' + this.xz_1 + ')';
  }
  hashCode() {
    var result = this.vz_1.hashCode();
    result = imul(result, 31) + this.wz_1.hashCode() | 0;
    result = imul(result, 31) + this.xz_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WidthInfo))
      return false;
    var tmp0_other_with_cast = other instanceof WidthInfo ? other : THROW_CCE();
    if (!this.vz_1.equals(tmp0_other_with_cast.vz_1))
      return false;
    if (!this.wz_1.equals(tmp0_other_with_cast.wz_1))
      return false;
    if (!this.xz_1.equals(tmp0_other_with_cast.xz_1))
      return false;
    return true;
  }
}
class ParentNext {
  constructor(firstPosition, rulePosition, expectedAt, parentExpectedAt) {
    this.yx_1 = firstPosition;
    this.zx_1 = rulePosition;
    this.ay_1 = expectedAt;
    this.by_1 = parentExpectedAt;
  }
  toString() {
    return 'ParentNext(firstPosition=' + this.yx_1 + ', rulePosition=' + this.zx_1 + ', expectedAt=' + this.ay_1 + ', parentExpectedAt=' + this.by_1 + ')';
  }
  hashCode() {
    var result = this.yx_1 | 0;
    result = imul(result, 31) + this.zx_1.hashCode() | 0;
    result = imul(result, 31) + this.ay_1.hashCode() | 0;
    result = imul(result, 31) + this.by_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParentNext))
      return false;
    var tmp0_other_with_cast = other instanceof ParentNext ? other : THROW_CCE();
    if (!(this.yx_1 === tmp0_other_with_cast.yx_1))
      return false;
    if (!this.zx_1.equals(tmp0_other_with_cast.zx_1))
      return false;
    if (!this.ay_1.equals(tmp0_other_with_cast.ay_1))
      return false;
    if (!this.by_1.equals(tmp0_other_with_cast.by_1))
      return false;
    return true;
  }
}
class FirstTerminalInfo {
  constructor(terminalRule, parentExpectedAt) {
    this.ky_1 = terminalRule;
    this.ly_1 = parentExpectedAt;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.ky_1, this.ly_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.my_1 = contentHashCode(tmp$ret$2);
  }
  hashCode() {
    return this.my_1;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof FirstTerminalInfo)) {
      tmp = false;
    } else {
      if (!other.ky_1.equals(this.ky_1)) {
        tmp = false;
      } else {
        if (!other.ly_1.equals(this.ly_1)) {
          tmp = false;
        } else {
          tmp = true;
        }
      }
    }
    return tmp;
  }
  toString() {
    return this.ky_1.mz() + ' ' + this.ly_1;
  }
}
class ClosureItem {}
class ClosureItemAbstractGraph {
  constructor(graph, rulePosition, context, parentExpectedAt) {
    this.e10_1 = graph;
    this.f10_1 = rulePosition;
    this.g10_1 = context;
    this.h10_1 = parentExpectedAt;
    this.i10_1 = false;
    var tmp = this;
    tmp.j10_1 = lazy(ClosureGraph$Companion$ClosureItemAbstractGraph$expectedAt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.k10_1 = lazy(ClosureGraph$Companion$ClosureItemAbstractGraph$children$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.l10_1 = lazy(ClosureGraph$Companion$ClosureItemAbstractGraph$parents$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.n10_1 = lazy(ClosureGraph$Companion$ClosureItemAbstractGraph$parentNext$delegate$lambda(this));
    var tmp_3 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.f10_1, this.g10_1, this.h10_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_3.o10_1 = tmp$ret$2;
  }
  r10() {
    return this.f10_1;
  }
  uf() {
    return this.g10_1;
  }
  p17() {
    return this.h10_1;
  }
  o17() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = expectedAt$factory();
    tmp$ret$0 = this.j10_1.p3();
    return tmp$ret$0;
  }
  v17() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = children$factory();
    tmp$ret$0 = this.k10_1.p3();
    return tmp$ret$0;
  }
  w17(_set____db54di) {
    this.m10_1 = _set____db54di;
  }
  p10() {
    var tmp = this.m10_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('downInfo');
    }
  }
  u10() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = parentNext$factory();
    tmp$ret$0 = this.n10_1.p3();
    return tmp$ret$0;
  }
  q17() {
    if (this.i10_1) {
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.hashSetOf' call
      tmp$ret$0 = HashSet.n6();
      this.w17(tmp$ret$0);
      this.i10_1 = true;
      var children = this.v17();
      if (children.y()) {
        if (this.f10_1.s10()) {
          var firstTerminalInfo = new FirstTerminalInfo(this.f10_1.qx_1, this.h10_1);
          var tmp = this.p10();
          (isInterface(tmp, MutableSet) ? tmp : THROW_CCE()).e1(firstTerminalInfo);
        } else
        ;
      } else {
        var tmp0_iterator = children.u();
        while (tmp0_iterator.h1()) {
          var child = tmp0_iterator.j1();
          child.q17();
          if (child.r10().t10() ? true : child.r10().s10()) {
            var tmp_0 = this.p10();
            (isInterface(tmp_0, MutableSet) ? tmp_0 : THROW_CCE()).k1(child.p10());
          }
        }
      }
    }
  }
  hashCode() {
    return contentHashCode(this.o10_1);
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, ClosureItem) : false)) {
      tmp = false;
    } else {
      if (!this.f10_1.equals(other.r10())) {
        tmp = false;
      } else {
        if (!this.g10_1.equals(other.uf())) {
          tmp = false;
        } else {
          if (!this.h10_1.equals(other.p17())) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
  toString() {
    return '' + this.f10_1 + '[' + this.h10_1 + ']';
  }
}
class ClosureItemRootGraph extends ClosureItemAbstractGraph {
  constructor(graph, context, rulePosition, parentExpectedAt) {
    super(graph, rulePosition, context, parentExpectedAt);
    this.i18_1 = true;
  }
}
class ClosureItemChildGraph extends ClosureItemAbstractGraph {
  constructor(graph, rulePosition, context, parentExpectedAt) {
    super(graph, rulePosition, context, parentExpectedAt);
    this.u18_1 = false;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.r17_1 = new FirstOf();
  }
  r11(rp, parentExpectedAt) {
    var tmp;
    if (rp.vx()) {
      tmp = parentExpectedAt;
    } else {
      var nexts = rp.j1();
      Debug_getInstance();
      if (false) {
        // Inline function 'kotlin.check' call
        var tmp$ret$0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp$ret$0 = !nexts.y();
        var tmp0_check = tmp$ret$0;
        // Inline function 'kotlin.contracts.contract' call
        if (!tmp0_check) {
          var tmp$ret$1;
          // Inline function 'net.akehurst.language.agl.automaton.Companion.expectedAt.<anonymous>' call
          tmp$ret$1 = 'Internal Error: if not a terminal and not atEnd rulePosition.next() should never be empty';
          var message = tmp$ret$1;
          throw IllegalStateException.y1(toString(message));
        }
      }
      var tmp$ret$4;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$3;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(nexts, 10));
      var tmp0_iterator = nexts.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$2;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.expectedAt.<anonymous>' call
        tmp$ret$2 = Companion_getInstance_10().r17_1.r11(item, parentExpectedAt);
        tmp0_mapTo.e1(tmp$ret$2);
      }
      tmp$ret$3 = tmp0_mapTo;
      tmp$ret$4 = tmp$ret$3;
      var allNextExpectedAt = tmp$ret$4;
      var tmp$ret$6;
      // Inline function 'kotlin.collections.fold' call
      var tmp1_fold = Companion_getInstance_8().xw_1;
      var accumulator = tmp1_fold;
      var tmp0_iterator_0 = allNextExpectedAt.u();
      while (tmp0_iterator_0.h1()) {
        var element = tmp0_iterator_0.j1();
        var tmp$ret$5;
        // Inline function 'net.akehurst.language.agl.automaton.Companion.expectedAt.<anonymous>' call
        var tmp2_anonymous = accumulator;
        tmp$ret$5 = tmp2_anonymous.iy(element);
        accumulator = tmp$ret$5;
      }
      tmp$ret$6 = accumulator;
      tmp = tmp$ret$6;
    }
    return tmp;
  }
  u17(parents) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    var result = tmp$ret$0;
    var tmp0_iterator = parents.u();
    while (tmp0_iterator.h1()) {
      var parent = tmp0_iterator.j1();
      var atStart = parent.r10().t10();
      var tmp1_subject = atStart;
      var tmp;
      switch (tmp1_subject) {
        case true:
          tmp = parent.p17();
          break;
        case false:
          tmp = Companion_getInstance_8().xw_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var prntNextContextExpectedAt = tmp;
      var tmp2_iterator = parent.r10().j1().u();
      while (tmp2_iterator.h1()) {
        var prntNext = tmp2_iterator.j1();
        var prntNextExpectedAt = this.r17_1.r11(prntNext, parent.p17());
        var pn = new ParentNext(atStart, prntNext, prntNextExpectedAt, prntNextContextExpectedAt);
        result.e1(pn);
      }
    }
    return result;
  }
}
class ClosureGraph {
  constructor(rootContext, rootRulePosition, rootParentFollow) {
    Companion_getInstance_10();
    var tmp = this;
    tmp.yz_1 = lazyMutableMapNonNull(ClosureGraph$_childrenOf$lambda);
    var tmp_0 = this;
    tmp_0.zz_1 = lazyMutableMapNonNull(ClosureGraph$_parentsOf$lambda);
    this.a10_1 = new ClosureItemRootGraph(this, rootContext, rootRulePosition, rootParentFollow);
  }
  q10() {
    return toMutableSet(this.zz_1.j3());
  }
  e11() {
    this.a10_1.q17();
    var tmp0_iterator = this.q10().u();
    while (tmp0_iterator.h1()) {
      var cls = tmp0_iterator.j1();
      cls.q17();
    }
  }
  s17(parent) {
    return this.yz_1.u3(parent).u3(parent.r10().sx_1);
  }
  t17(child) {
    return this.zz_1.u3(child);
  }
  v18(child, parent) {
    this.yz_1.u3(parent).u3(parent.r10().sx_1).e1(child);
    return this.zz_1.u3(child).e1(parent);
  }
  c11(parent, childRulePosition) {
    var childContext = parent.r10().t10() ? parent.uf() : parent.r10();
    var childParentExpectedAt = parent.o17();
    var child = new ClosureItemChildGraph(this, childRulePosition, childContext, childParentExpectedAt);
    var added = this.v18(child, parent);
    return added ? child : null;
  }
}
class CompletionProvider {}
class CompletionProviderAbstract {
  w18(terminalItem, context) {
    var name = terminalItem.owningRule.isLeaf ? terminalItem.owningRule.name : terminalItem.name;
    var ci = terminalItem.isPattern ? new CompletionItem(CompletionItemKind_PATTERN_getInstance(), '<' + name + '>', terminalItem.value) : new CompletionItem(CompletionItemKind_LITERAL_getInstance(), terminalItem.value, name);
    return listOf(ci);
  }
}
class CompletionProviderDefault extends CompletionProviderAbstract {
  constructor(targetGrammar, typeModel, scopeModel) {
    super();
    this.x18_1 = targetGrammar;
    this.y18_1 = typeModel;
    this.z18_1 = scopeModel;
  }
  provide(nextExpected, context, options) {
    var tmp;
    if (null == context) {
      tmp = emptyList();
    } else {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator = nextExpected.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.default.CompletionProviderDefault.provide.<anonymous>' call
        tmp$ret$0 = provideFor(this, element, 2, context);
        var list = tmp$ret$0;
        addAll(tmp0_flatMapTo, list);
      }
      tmp$ret$1 = tmp0_flatMapTo;
      tmp$ret$2 = tmp$ret$1;
      var items = tmp$ret$2;
      tmp = items;
    }
    return tmp;
  }
}
class TypeModelFromGrammar {
  constructor() {
    TypeModelFromGrammar_instance = this;
    this.a19_1 = new TypeModelFromGrammarConfigurationDefault();
  }
  b19(grammar, defaultGoalRuleName, configuration) {
    var grmrTypeModel = new TypeModelSimple(grammar.name);
    grmrTypeModel.addNamespace(SimpleTypeModelStdLib_getInstance());
    var tmp0_elvis_lhs = defaultGoalRuleName;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.first' call
        var tmp0_first = grammar.grammarRule;
        var tmp0_iterator = tmp0_first.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.default.TypeModelFromGrammar.create.<anonymous>' call
          tmp$ret$0 = !element.isSkip;
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        throw NoSuchElementException.ad('Collection contains no element matching the predicate.');
      }
      tmp = tmp$ret$1.name;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var goalRuleName = tmp;
    var tmp1_elvis_lhs = grammar.findNonTerminalRule(goalRuleName);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var tmp1_error = "Cannot find grammar rule '" + goalRuleName + "'";
      throw IllegalStateException.y1(toString(tmp1_error));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var goalRule = tmp_0;
    var ns = GrammarTypeNamespaceFromGrammar.q19(grmrTypeModel, grammar, grammar);
    grmrTypeModel.addNamespace(ns);
    grmrTypeModel.resolveImports();
    return grmrTypeModel;
  }
  r19(grammar, defaultGoalRuleName, configuration, $super) {
    defaultGoalRuleName = defaultGoalRuleName === VOID ? null : defaultGoalRuleName;
    configuration = configuration === VOID ? TypeModelFromGrammar_getInstance().a19_1 : configuration;
    return $super === VOID ? this.b19(grammar, defaultGoalRuleName, configuration) : $super.b19.call(this, grammar, defaultGoalRuleName, configuration);
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    this.s19_1 = '$value';
    this.t19_1 = '$list';
    this.u19_1 = '$tuple';
    this.v19_1 = '$group';
    this.w19_1 = '$choice';
  }
}
class GrammarTypeNamespace {}
class GrammarTypeNamespaceAbstract extends TypeNamespaceAbstract {
  constructor(imports) {
    super(imports);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.e1a_1 = tmp$ret$0;
  }
  f1a() {
    return this.e1a_1;
  }
  g1a() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.f1a().l3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract.<get-allTypesByRuleName>.<anonymous>' call
      tmp$ret$0 = new Pair(item.o3(), item.p3());
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  findTypeUsageForRule(ruleName) {
    return this.f1a().u3(ruleName);
  }
  asString() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.f1a().l3();
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = GrammarTypeNamespaceAbstract$asString$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0_2(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var rules = tmp$ret$1;
    var ruleToType = joinToString(rules, '\n', VOID, VOID, VOID, VOID, GrammarTypeNamespaceAbstract$asString$lambda_0(this));
    var tmp$ret$3;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp1_sortedBy = this.allTypesByName.l3();
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = GrammarTypeNamespaceAbstract$asString$lambda_1;
    tmp$ret$2 = new sam$kotlin_Comparator$0_2(tmp_0);
    tmp$ret$3 = sortedWith(tmp1_sortedBy, tmp$ret$2);
    var tmp_1 = tmp$ret$3;
    var types = joinToString(tmp_1, '\n', VOID, VOID, VOID, VOID, GrammarTypeNamespaceAbstract$asString$lambda_2(this));
    var s = trimIndent("namespace '" + this.qualifiedName + "' {\n" + ruleToType + '\n\n' + types + '\n}');
    return s;
  }
  get allRuleNameToType() {
    return this.f1a();
  }
  get allTypesByRuleName() {
    return this.g1a();
  }
}
class GrammarTypeNamespaceFromGrammar extends GrammarTypeNamespaceAbstract {
  constructor(qualifiedName, imports) {
    Companion_getInstance_11();
    imports = imports === VOID ? mutableListOf([SimpleTypeModelStdLib_getInstance().sn_1]) : imports;
    super(imports);
    this.i19_1 = qualifiedName;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.j19_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.k19_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.l19_1 = tmp$ret$2;
    this.m19_1 = null;
  }
  wl() {
    return this.i19_1;
  }
  static q19(model, context, grammar, configuration) {
    Companion_getInstance_11();
    configuration = configuration === VOID ? TypeModelFromGrammar_getInstance().a19_1 : configuration;
    var $this = new GrammarTypeNamespaceFromGrammar(grammar.namespace.qualifiedName + '.' + grammar.name);
    $this.o19_1 = context;
    $this.m19_1 = configuration;
    $this.p19_1 = grammar;
    $this.n19_1 = model;
    $this.resolveImports(model);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = grammar.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.<init>.<anonymous>' call
      tmp$ret$0 = !element.isSkip;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var nonSkipRules = tmp$ret$2;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = nonSkipRules.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.<init>.<anonymous>' call
      tmp$ret$3 = Unit_getInstance();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_1 = nonSkipRules.u();
    while (tmp0_iterator_1.h1()) {
      var element_1 = tmp0_iterator_1.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.<init>.<anonymous>' call
      typeForGrammarRule($this, element_1);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp1_forEach = $this.j19_1.l3();
    var tmp0_iterator_2 = tmp1_forEach.u();
    while (tmp0_iterator_2.h1()) {
      var element_2 = tmp0_iterator_2.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.<init>.<anonymous>' call
      var key = element_2.o3();
      var value = element_2.p3();
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = protoOf(GrammarTypeNamespaceAbstract).f1a.call($this);
      tmp0_set.m3(key, value);
    }
    return $this;
  }
  toString() {
    return 'TypeModel(' + this.i19_1 + ')';
  }
  get qualifiedName() {
    return this.wl();
  }
  get allRuleNameToType() {
    return this.f1a();
  }
  get allTypesByRuleName() {
    return this.g1a();
  }
}
class AsmSimpleTreeWalker {}
class ReferenceResolverDefault {
  constructor(scopeModel, rootScope, resolveFunction, _locationMap, _issues) {
    this.h1a_1 = scopeModel;
    this.i1a_1 = rootScope;
    this.j1a_1 = resolveFunction;
    this.k1a_1 = _locationMap;
    this.l1a_1 = _issues;
    this.m1a_1 = mutableStackOf([this.i1a_1]);
  }
  root(root) {
    var tmp0_elvis_lhs = this.i1a_1.rootScope.scopeMap.u3(root.asmPath);
    var elScope = tmp0_elvis_lhs == null ? this.i1a_1 : tmp0_elvis_lhs;
    this.m1a_1.v1a(elScope);
  }
  beforeElement(propertyName, element) {
    var parentScope = this.m1a_1.o1a();
    var tmp0_elvis_lhs = parentScope.rootScope.scopeMap.u3(element.asmPath);
    var elScope = tmp0_elvis_lhs == null ? parentScope : tmp0_elvis_lhs;
    this.m1a_1.v1a(elScope);
  }
  afterElement(propertyName, element) {
    this.m1a_1.w1a();
  }
  property(element, property) {
    if (property.isReference) {
      handleProperty(this, this.h1a_1, element, property);
    } else {
    }
  }
}
class SemanticAnalyserDefault$buildScope$1 {
  constructor($rootScope, this$0) {
    this.d1b_1 = this$0;
    this.c1b_1 = mutableStackOf([$rootScope]);
  }
  root(root) {
    addToScope(this.d1b_1, this.c1b_1.o1a(), root);
  }
  beforeElement(propertyName, element) {
    var scope = this.c1b_1.o1a();
    addToScope(this.d1b_1, scope, element);
    var chScope = createScope(this.d1b_1, scope, element);
    this.c1b_1.v1a(chScope);
  }
  afterElement(propertyName, element) {
    this.c1b_1.w1a();
  }
  property(element, property) {
  }
}
class SemanticAnalyser {}
function analyse(asm, locationMap, context, options, $super) {
  locationMap = locationMap === VOID ? null : locationMap;
  context = context === VOID ? null : context;
  return this.g1b(asm, locationMap, context, options);
}
class SemanticAnalyserDefault {
  constructor(scopeModel) {
    this.x1a_1 = scopeModel;
    this.y1a_1 = new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance());
    var tmp = this;
    var tmp_0 = this.x1a_1;
    tmp.z1a_1 = tmp_0 instanceof ScopeModelAgl ? tmp_0 : THROW_CCE();
  }
  clear() {
    this.y1a_1.clear();
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  e1b(asm, locationMap, context, options) {
    var tmp = this;
    var tmp0_elvis_lhs = locationMap;
    tmp.a1b_1 = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
    if (null == context) {
      this.y1a_1.info(null, 'No context provided, references not checked or resolved, switch of reference checking or provide a context.');
    } else if (!options.checkReferences) {
      this.y1a_1.info(null, "Semantic Analysis option 'checkReferences' is off, references not checked.");
    } else {
      buildScope(this, asm, context.f1b_1);
      var tmp_0;
      if (options.resolveReferences) {
        tmp_0 = true;
      } else {
        this.y1a_1.info(null, "Semantic Analysis option 'resolveReferences' is off, references checked but not resolved.");
        tmp_0 = false;
      }
      var resolve = tmp_0;
      walkReferences(this, asm, locationMap, context.f1b_1, resolve);
    }
    return new SemanticAnalysisResultDefault(this.y1a_1);
  }
  g1b(asm, locationMap, context, options) {
    var tmp = asm instanceof AsmSimple ? asm : THROW_CCE();
    return this.e1b(tmp, locationMap, (context == null ? true : context instanceof ContextSimple) ? context : THROW_CCE(), options);
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    this.h1b_1 = 'net.akehurst.language.agl.syntaxAnalyser';
    this.i1b_1 = 'net.akehurst.language.agl.syntaxAnalyser.scope.model';
  }
}
class SyntaxAnalyser {}
function configure(configurationContext, configuration, $super) {
  configuration = configuration === VOID ? emptyMap() : configuration;
  return this.t1b(configurationContext, configuration);
}
class SyntaxAnalyserFromTreeDataAbstract {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.u1b_1 = tmp$ret$0;
    this.issues = new IssueHolder(LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance());
  }
  v1b() {
    return this.u1b_1;
  }
  w1b() {
    return this.issues;
  }
  clear() {
    this.locationMap.n1();
    this.issues.clear();
  }
  transform(sppt, mapToGrammar) {
    var sentence = (sppt instanceof SPPTFromTreeData ? sppt : THROW_CCE()).g2c_1;
    var treeData = (sppt instanceof SPPTFromTreeData ? sppt : THROW_CCE()).f2c_1;
    this.walkTree(sentence, treeData, false);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.embeddedSyntaxAnalyser.k3();
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserFromTreeDataAbstract.transform.<anonymous>' call
      this.issues.addAll((element instanceof SyntaxAnalyserFromTreeDataAbstract ? element : THROW_CCE()).issues);
    }
    return new SyntaxAnalysisResultDefault(this.asm, this.issues, this.locationMap);
  }
  get locationMap() {
    return this.v1b();
  }
  get asm() {
    return this.s1b();
  }
  get embeddedSyntaxAnalyser() {
    return this.o1b();
  }
}
class SyntaxAnalyserSimpleAbstract extends SyntaxAnalyserFromTreeDataAbstract {
  constructor(grammarNamespaceQualifiedName, typeModel, scopeModel) {
    Companion_getInstance_37();
    super();
    this.grammarNamespaceQualifiedName = grammarNamespaceQualifiedName;
    this.typeModel = typeModel;
    this.scopeModel = scopeModel;
    this.k1b_1 = null;
  }
  p1b() {
    return this.grammarNamespaceQualifiedName;
  }
  q1b() {
    return this.typeModel;
  }
  r1b() {
    return this.scopeModel;
  }
  s1b() {
    var tmp = this.k1b_1;
    return tmp instanceof AsmSimple ? tmp : THROW_CCE();
  }
  clear() {
    super.clear();
    this.k1b_1 = null;
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
  walkTree(sentence, treeData, skipDataAsTree) {
    var syntaxAnalyserStack = mutableStackOf([this]);
    var downStack = mutableStackOf([]);
    var stack = mutableStackOf([]);
    var walker = new SyntaxAnalyserSimpleAbstract$walkTree$walker$1(syntaxAnalyserStack, this, stack, sentence, downStack);
    treeData.traverseTreeDepthFirst(walker, false);
  }
  get embeddedSyntaxAnalyser() {
    return this.o1b();
  }
  static get Companion() {
    return Companion_getInstance_37();
  }
}
class SyntaxAnalyserDefault extends SyntaxAnalyserSimpleAbstract {
  constructor(grammarNamespaceQualifiedName, typeModel, scopeModel) {
    Companion_getInstance_12();
    super(grammarNamespaceQualifiedName, typeModel, scopeModel);
    var tmp = this;
    tmp.n1b_1 = lazyMap(SyntaxAnalyserDefault$embeddedSyntaxAnalyser$lambda(typeModel, this));
  }
  o1b() {
    return this.n1b_1;
  }
}
class TypeModelFromGrammarConfigurationDefault {
  x19(rule) {
    var tmp$ret$4;
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp0_replaceFirstChar = rule.name;
    var tmp;
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNotEmpty' call
    tmp$ret$0 = charSequenceLength(tmp0_replaceFirstChar) > 0;
    if (tmp$ret$0) {
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.agl.default.TypeModelFromGrammarConfigurationDefault.typeNameFor.<anonymous>' call
      var tmp1_anonymous = charSequenceGet(tmp0_replaceFirstChar, 0);
      tmp$ret$1 = titlecase(tmp1_anonymous);
      var tmp_0 = toString(tmp$ret$1);
      var tmp$ret$3;
      // Inline function 'kotlin.text.substring' call
      var tmp$ret$2;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$2 = tmp0_replaceFirstChar;
      tmp$ret$3 = tmp$ret$2.substring(1);
      tmp = tmp_0 + tmp$ret$3;
    } else {
      tmp = tmp0_replaceFirstChar;
    }
    tmp$ret$4 = tmp;
    return tmp$ret$4;
  }
  y19(context, ruleItem, ruleItemType) {
    var tmp0_subject = context;
    var prefix = equals(tmp0_subject, ruleItem.owningRule.grammar) ? '' : lower(ruleItem.owningRule.grammar.name) + '_';
    var tmp$ret$7;
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp1_subject = ruleItem;
    var tmp;
    if (isInterface(tmp1_subject, Terminal)) {
      var tmp2_subject = ruleItemType;
      var tmp_0;
      if (isInterface(tmp2_subject, PrimitiveType)) {
        Companion_getInstance_11();
        tmp_0 = '$value';
      } else {
        if (isInterface(tmp2_subject, CollectionType)) {
          Companion_getInstance_11();
          tmp_0 = '$list';
        } else {
          if (isInterface(tmp2_subject, TupleType)) {
            Companion_getInstance_11();
            tmp_0 = '$tuple';
          } else {
            Companion_getInstance_11();
            tmp_0 = '$value';
          }
        }
      }
      tmp = tmp_0;
    } else {
      if (isInterface(tmp1_subject, Embedded)) {
        tmp = lower(ruleItem.embeddedGoalName);
      } else {
        if (isInterface(tmp1_subject, NonTerminal)) {
          tmp = lower(ruleItem.name);
        } else {
          if (isInterface(tmp1_subject, Group)) {
            Companion_getInstance_11();
            tmp = '$group';
          } else {
            if (isInterface(tmp1_subject, Choice)) {
              Companion_getInstance_11();
              tmp = '$choice';
            } else {
              throw IllegalStateException.y1('Internal error, unhandled subtype of SimpleItem');
            }
          }
        }
      }
    }
    var tmp0_replaceFirstChar = tmp;
    var tmp_1;
    var tmp$ret$0;
    // Inline function 'kotlin.text.isNotEmpty' call
    tmp$ret$0 = charSequenceLength(tmp0_replaceFirstChar) > 0;
    if (tmp$ret$0) {
      var tmp$ret$4;
      // Inline function 'net.akehurst.language.agl.default.TypeModelFromGrammarConfigurationDefault.propertyNameFor.<anonymous>' call
      var tmp1_anonymous = charSequenceGet(tmp0_replaceFirstChar, 0);
      var tmp$ret$3;
      // Inline function 'kotlin.text.lowercase' call
      var tmp$ret$2;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_asDynamic = toString_0(tmp1_anonymous);
      tmp$ret$1 = tmp0_asDynamic;
      var tmp1_unsafeCast = tmp$ret$1.toLowerCase();
      tmp$ret$2 = tmp1_unsafeCast;
      tmp$ret$3 = tmp$ret$2;
      tmp$ret$4 = tmp$ret$3;
      var tmp_2 = toString(tmp$ret$4);
      var tmp$ret$6;
      // Inline function 'kotlin.text.substring' call
      var tmp$ret$5;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$5 = tmp0_replaceFirstChar;
      tmp$ret$6 = tmp$ret$5.substring(1);
      tmp_1 = tmp_2 + tmp$ret$6;
    } else {
      tmp_1 = tmp0_replaceFirstChar;
    }
    tmp$ret$7 = tmp_1;
    var baseName = tmp$ret$7;
    var tmp3_subject = ruleItemType;
    var tmp_3;
    if (isInterface(tmp3_subject, PrimitiveType)) {
      tmp_3 = baseName;
    } else {
      if (isInterface(tmp3_subject, UnnamedSuperTypeType)) {
        tmp_3 = baseName;
      } else {
        if (isInterface(tmp3_subject, CollectionType)) {
          var tmp4_subject = ruleItem;
          var tmp_4;
          if (isInterface(tmp4_subject, NonTerminal)) {
            tmp_4 = lower(ruleItem.name);
          } else {
            if (isInterface(tmp4_subject, Terminal)) {
              Companion_getInstance_11();
              tmp_4 = '$list';
            } else {
              if (isInterface(tmp4_subject, Group)) {
                Companion_getInstance_11();
                tmp_4 = '$list';
              } else {
                tmp_4 = baseName + 'List';
              }
            }
          }
          tmp_3 = tmp_4;
        } else {
          if (isInterface(tmp3_subject, TupleType)) {
            tmp_3 = baseName;
          } else {
            if (isInterface(tmp3_subject, DataType)) {
              tmp_3 = baseName;
            } else {
              tmp_3 = baseName;
            }
          }
        }
      }
    }
    var name = tmp_3;
    return name;
  }
}
class Formatter {}
class FormatterSimple {
  constructor(model) {
    this.x1b_1 = model;
  }
  format(asm) {
    var sb = StringBuilder.qa();
    var tmp0_iterator = (asm instanceof AsmSimple ? asm : THROW_CCE()).rootElements.u();
    while (tmp0_iterator.h1()) {
      var root = tmp0_iterator.j1();
      var str = formatAny(this, root);
      sb.a8(str);
    }
    return new FormatResultDefault(sb.toString(), new IssueHolder(LanguageProcessorPhase_FORMATTER_getInstance()));
  }
  y1b(_this__u8e3s4, model) {
    var tmp0_safe_receiver = model;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rules;
    var formatRule = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u3(_this__u8e3s4.typeName);
    var tmp2_subject = formatRule;
    var tmp;
    if (tmp2_subject == null) {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = _this__u8e3s4.propertiesOrdered;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.formatter.FormatterSimple.format.<anonymous>' call
        var propValue = item.value;
        var tmp0_subject = propValue;
        var tmp_0;
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
          var tmp1_safe_receiver_0 = model;
          var tmp2_elvis_lhs = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.defaultWhiteSpace;
          tmp_0 = propValue + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        } else {
          tmp_0 = formatAny(this, propValue);
        }
        tmp$ret$0 = tmp_0;
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var tmp_1 = tmp$ret$2;
      tmp = joinToString(tmp_1, '', VOID, VOID, VOID, VOID, FormatterSimple$format$lambda);
    } else {
      var tmp_2 = formatRule.formatExpression;
      tmp = this.z1b(tmp_2 instanceof AglFormatExpressionDefault ? tmp_2 : THROW_CCE(), model, _this__u8e3s4);
    }
    return tmp;
  }
  z1b(_this__u8e3s4, model, el) {
    var tmp0_subject = _this__u8e3s4.asm.typeName;
    var tmp;
    switch (tmp0_subject) {
      case 'LiteralString':
        tmp = el.getPropertyAsString('literal_string');
        break;
      case 'TemplateString':
        var templateContentList = _this__u8e3s4.asm.getPropertyAsListOfElement('templateContentList');
        var tmp1_safe_receiver = model;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.defaultWhiteSpace;
        var tmp_0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
        tmp = joinToString(templateContentList, tmp_0, VOID, VOID, VOID, VOID, FormatterSimple$execute$lambda(el, this, model));
        break;
      case 'WhenExpression':
        throw NotImplementedError.eg();
      default:
        var tmp0_error = 'Element type ' + _this__u8e3s4.asm.typeName + ' not handled';
        throw IllegalStateException.y1(toString(tmp0_error));
    }
    return tmp;
  }
}
class AglFormatCompletionProvider extends CompletionProviderAbstract {
  provide(nextExpected, context, options) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = nextExpected.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.agl.grammar.format.AglFormatCompletionProvider.provide.<anonymous>' call
      var tmp0_subject = element;
      var tmp;
      if (isInterface(tmp0_subject, Terminal)) {
        tmp = this.w18(element, context);
      } else {
        tmp = emptyList();
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
}
class Grammar {}
class GrammarAbstract {
  constructor(namespace, name) {
    this.t1c_1 = namespace;
    this.u1c_1 = name;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.v1c_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.w1c_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$2 = ArrayList.i4();
    tmp_1.x1c_1 = tmp$ret$2;
    var tmp_2 = this;
    tmp_2.y1c_1 = lazy(GrammarAbstract$allResolvedGrammarRule$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.z1c_1 = lazy(GrammarAbstract$allResolvedTerminal$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.a1d_1 = lazy(GrammarAbstract$allResolvedSkipTerminal$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.b1d_1 = lazy(GrammarAbstract$allResolvedNonTerminalRule$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.c1d_1 = lazy(GrammarAbstract$allResolvedPreferenceRuleRule$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.d1d_1 = lazy(GrammarAbstract$allResolvedEmbeddedRules$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.e1d_1 = lazy(GrammarAbstract$allResolvedEmbeddedGrammars$delegate$lambda(this));
  }
  ul() {
    return this.t1c_1;
  }
  be() {
    return this.u1c_1;
  }
  wl() {
    return this.namespace.qualifiedName + '.' + this.name;
  }
  f1d() {
    return this.v1c_1;
  }
  g1d() {
    return this.w1c_1;
  }
  h1d() {
    return this.x1c_1;
  }
  i1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedGrammarRule$factory();
    tmp$ret$0 = this.y1c_1.p3();
    return tmp$ret$0;
  }
  j1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedTerminal$factory();
    tmp$ret$0 = this.z1c_1.p3();
    return tmp$ret$0;
  }
  k1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedSkipTerminal$factory();
    tmp$ret$0 = this.a1d_1.p3();
    return tmp$ret$0;
  }
  l1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedNonTerminalRule$factory();
    tmp$ret$0 = this.b1d_1.p3();
    return tmp$ret$0;
  }
  m1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedPreferenceRuleRule$factory();
    tmp$ret$0 = this.c1d_1.p3();
    return tmp$ret$0;
  }
  n1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedEmbeddedRules$factory();
    tmp$ret$0 = this.d1d_1.p3();
    return tmp$ret$0;
  }
  o1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allResolvedEmbeddedGrammars$factory();
    tmp$ret$0 = this.e1d_1.p3();
    return tmp$ret$0;
  }
  findAllSuperNonTerminalRule(ruleName) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this.extends;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.findAllSuperNonTerminalRule.<anonymous>' call
      var tmp0_safe_receiver = element.resolved;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allResolvedGrammarRule;
      tmp$ret$0 = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    var rules = toMutableOrderedSet(tmp$ret$2);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.filter' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator_0 = rules.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.findAllSuperNonTerminalRule.<anonymous>' call
      tmp$ret$3 = !equals(element_0.grammar, this) ? element_0.name === ruleName : false;
      if (tmp$ret$3) {
        tmp0_filterTo.e1(element_0);
      }
    }
    tmp$ret$4 = tmp0_filterTo;
    tmp$ret$5 = tmp$ret$4;
    return tmp$ret$5;
  }
  findAllNonTerminalRule(ruleName) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.findAllNonTerminalRule.<anonymous>' call
      tmp$ret$0 = element.name === ruleName;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  findNonTerminalRule(ruleName) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.findNonTerminalRule.<anonymous>' call
      tmp$ret$0 = element.name === ruleName;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var all = tmp$ret$2;
    var tmp;
    if (all.y()) {
      tmp = null;
    } else if (toSet(all).o() > 1) {
      var tmp1_error = "More than one rule named '" + ruleName + "' in grammar '" + this.name + "', have you remembered the 'override' modifier";
      throw IllegalStateException.y1(toString(tmp1_error));
    } else {
      tmp = first_0(all);
    }
    return tmp;
  }
  findTerminalRule(terminalPattern) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.allResolvedTerminal;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.findTerminalRule.<anonymous>' call
      tmp$ret$0 = element.value === terminalPattern;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var all = tmp$ret$2;
    if (all.y()) {
      // Inline function 'kotlin.error' call
      var tmp1_error = terminalPattern + ' in Grammar(' + this.name + ').findTerminalRule';
      throw IllegalStateException.y1(toString(tmp1_error));
    } else if (all.o() > 1) {
      // Inline function 'kotlin.error' call
      var tmp2_error = 'More than one rule named ' + terminalPattern + ' in Grammar(' + this.name + ').findTerminalRule';
      throw IllegalStateException.y1(toString(tmp2_error));
    }
    return first_0(all);
  }
  hashCode() {
    return getStringHashCode(this.qualifiedName);
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, Grammar) : false)) {
      tmp = false;
    } else {
      tmp = this.qualifiedName === other.qualifiedName;
    }
    return tmp;
  }
  toString() {
    return this.qualifiedName;
  }
  get namespace() {
    return this.ul();
  }
  get name() {
    return this.be();
  }
  get qualifiedName() {
    return this.wl();
  }
  get extends() {
    return this.f1d();
  }
  get grammarRule() {
    return this.g1d();
  }
  get preferenceRule() {
    return this.h1d();
  }
  get allResolvedGrammarRule() {
    return this.i1d();
  }
  get allResolvedTerminal() {
    return this.j1d();
  }
  get allResolvedSkipTerminal() {
    return this.k1d();
  }
  get allResolvedNonTerminalRule() {
    return this.l1d();
  }
  get allResolvedPreferenceRuleRule() {
    return this.m1d();
  }
  get allResolvedEmbeddedRules() {
    return this.n1d();
  }
  get allResolvedEmbeddedGrammars() {
    return this.o1d();
  }
  get options() {
    return this.s1c();
  }
}
class AglFormatGrammar extends GrammarAbstract {
  constructor() {
    AglFormatGrammar_instance = null;
    super(new NamespaceDefault('net.akehurst.language.agl'), 'AglFormat');
    AglFormatGrammar_instance = this;
    this.n1c_1 = 'unit';
    this.o1c_1 = listOf(new GrammarOptionDefault('defaultGoal', 'unit'));
    this.p1c_1 = "\n        namespace net.akehurst.language.agl\n        grammar AglFormat {\n            skip leaf WHITESPACE = \"\\s+\" ;\n            skip leaf MULTI_LINE_COMMENT = \"/\\*[^*]*\\*+(?:[^*/][^*]*\\*+)*/\" ;\n            skip leaf SINGLE_LINE_COMMENT = \"//[\\n\\r]*?\" ;\n        \n            unit = ruleList ;\n            ruleList = [formatRule]* ;\n            formatRule = typeReference '->' formatExpression ;\n            formatExpression\n              = stringExpression\n              | whenExpression\n              ;\n            whenExpression = 'when' '{' whenOptionList '}' ;\n            whenOptionList = whenOption* ;\n            whenOption = expression '->' formatExpression ;\n            stringExpression = literalString | templateString ;\n            literalString = LITERAL_STRING ;\n            templateString = '\"' templateContentList '\"' ;\n            templateContentList = templateContent* ;\n            templateContent = text | templateExpression ;\n            text = RAW_TEXT ;\n            templateExpression = templateExpressionSimple | templateExpressionEmbedded ;\n            templateExpressionSimple = DOLLAR_IDENTIFIER ;\n            templateExpressionEmbedded = '${' expression '}'\n            \n            expression = propertyReference ; //TODO\n            \n            typeReference = IDENTIFIER ;\n            propertyReference = IDENTIFIER ;\n            leaf DOLLAR_IDENTIFIER = '$' IDENTIFIER ;\n            leaf IDENTIFIER = \"[a-zA-Z_][a-zA-Z_0-9-]*\"\n            leaf LITERAL_STRING = \"'([^'\\\\]|\\\\'|\\\\\\\\)*'\" ;\n            leaf RAW_TEXT = \"(\\\\\\\"|[^\\\"])+\" ;\n        }\n    ";
    this.q1c_1 = '\n    ';
    this.r1c_1 = '\n    ';
    this.grammarRule.k1(createRules(AglFormatGrammar_getInstance()));
  }
  s1c() {
    return this.o1c_1;
  }
  toString() {
    AglScopesGrammar_getInstance();
    return trimIndent("\nnamespace net.akehurst.language.agl\ngrammar AglScopes {\n\n    skip WHITESPACE = \"\\s+\" ;\n    skip MULTI_LINE_COMMENT = \"/\\*[^*]*\\*+(?:[^*`/`][^*]*\\*+)*`/`\" ;\n    skip SINGLE_LINE_COMMENT = \"//[\\n\\r]*?\" ;\n\n    declarations = rootIdentifiables scopes references? ;\n    rootIdentifiables = identifiable* ;\n    scopes = scope* ;\n    scope = 'scope' typeReference '{' identifiables '}' ;\n    identifiables = identifiable* ;\n    identifiable = 'identify' typeReference 'by' propertyReferenceOrNothing ;\n\n    references = 'references' '{' referenceDefinitions '}' ;\n    referenceDefinitions = referenceDefinition* ;\n    referenceDefinition = 'in' typeReference '{' referenceExpression* '}' ;\n    referenceExpression = propertyReferenceExpression | collectionReferenceExpression ;\n    propertyReferenceExpression = 'property' propertyReference 'refers-to' typeReferences from ;\n    collectionReferenceExpression = 'forall' navigation '{' referenceExpression '}' ;\n    from = 'from' navigation ;\n    navigation = [propertyReference / '.']+ ;\n    typeReferences = [typeReference / '|']+ ;\n\n    propertyReferenceOrNothing = '\xA7nothing' | propertyReference ;\n    typeReference = IDENTIFIER ;     // same as grammar rule name\n    propertyReference = IDENTIFIER ; // same as grammar rule name\n    leaf IDENTIFIER = \"[a-zA-Z_][a-zA-Z_0-9-]*\" ;\n}\n    ");
  }
}
class AglFormatSemanticAnalyser {
  clear() {
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  p1d(asm, locationMap, context, options) {
    return new SemanticAnalysisResultDefault(new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance()));
  }
  g1b(asm, locationMap, context, options) {
    var tmp = isInterface(asm, AglFormatterModel) ? asm : THROW_CCE();
    return this.p1d(tmp, locationMap, (context == null ? true : isInterface(context, SentenceContext)) ? context : THROW_CCE(), options);
  }
}
class AglFormatSyntaxAnalyser {
  constructor(grammarNamespaceQualifiedName, typeModel, scopeModel) {
    this.q1d_1 = typeModel;
    this.r1d_1 = scopeModel;
    this.s1d_1 = new SyntaxAnalyserDefault(grammarNamespaceQualifiedName, this.q1d_1, this.r1d_1);
    this.t1d_1 = emptyMap();
  }
  v1b() {
    return this.s1d_1.locationMap;
  }
  o1b() {
    return this.t1d_1;
  }
  clear() {
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
  transform(sppt, mapToGrammar) {
    var res = this.s1d_1.transform(sppt, mapToGrammar);
    var asm = new AglFormatterModelDefault(res.asm);
    return new SyntaxAnalysisResultDefault(asm, res.issues, this.v1b());
  }
  get locationMap() {
    return this.v1b();
  }
  get embeddedSyntaxAnalyser() {
    return this.o1b();
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
  }
  fromString(context, aglFormatterModelSentence) {
    var tmp0_elvis_lhs = Agl_getInstance().registry.agl.formatter.processor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Formatter language not found!');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var proc = tmp;
    var tmp_0 = Agl_getInstance();
    return proc.process(aglFormatterModelSentence, tmp_0.options(AglFormatterModelDefault$Companion$fromString$lambda(context)));
  }
}
class AglFormatterModel {}
class AglFormatterModelDefault {
  constructor(asm) {
    Companion_getInstance_13();
    this.asm = asm;
    var tmp = this;
    tmp.u1d_1 = lazy(AglFormatterModelDefault$rules$delegate$lambda(this));
  }
  s1b() {
    return this.asm;
  }
  v1d() {
    return ' ';
  }
  w1d() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = rules$factory();
    tmp$ret$0 = this.u1d_1.p3();
    return tmp$ret$0;
  }
  get defaultWhiteSpace() {
    return this.v1d();
  }
  get rules() {
    return this.w1d();
  }
  static get Companion() {
    return Companion_getInstance_13();
  }
}
class AglFormatterRule {}
class AglFormatterRuleDefault {
  constructor(model, asm) {
    this.x1d_1 = model;
    this.asm = asm;
  }
  y1d() {
    return this.x1d_1;
  }
  s1b() {
    return this.asm;
  }
  z1d() {
    return this.asm.getPropertyAsAsmElement('typeReference').getPropertyAsString('identifier');
  }
  a1e() {
    var fmAsm = this.asm.getPropertyAsAsmElement('formatExpression');
    return new AglFormatExpressionDefault(fmAsm);
  }
  get model() {
    return this.y1d();
  }
  get forTypeName() {
    return this.z1d();
  }
  get formatExpression() {
    return this.a1e();
  }
}
class AglFormatExpression {}
class AglFormatExpressionDefault {
  constructor(asm) {
    this.asm = asm;
  }
  s1b() {
    return this.asm;
  }
}
class AglGrammarCompletionProvider extends CompletionProviderAbstract {
  provide(nextExpected, context, options) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = nextExpected.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.agl.grammar.grammar.AglGrammarCompletionProvider.provide.<anonymous>' call
      var tmp0_subject = element;
      var tmp;
      if (isInterface(tmp0_subject, Terminal)) {
        tmp = this.w18(element, context);
      } else {
        tmp = emptyList();
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
}
class AglGrammarGrammar extends GrammarAbstract {
  constructor() {
    AglGrammarGrammar_instance = null;
    super(new NamespaceDefault('net.akehurst.language.agl'), 'AglGrammar');
    AglGrammarGrammar_instance = this;
    this.n1e_1 = 'grammarDefinition';
    this.o1e_1 = listOf(new GrammarOptionDefault('defaultGoal', 'grammarDefinition'));
    this.p1e_1 = "'namespace' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'grammar' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'extends' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'override' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'skip' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'leaf' {\n  foreground: darkgreen;\n  font-style: bold;\n}\nLITERAL {\n  foreground: blue;\n}\nPATTERN {\n  foreground: darkblue;\n}\nIDENTIFIER {\n  foreground: darkred;\n  font-style: italic;\n}";
    this.grammarRule.k1(createRules_0(this));
  }
  s1c() {
    return this.o1e_1;
  }
  toString() {
    return "namespace net.akehurst.language.agl\n\ngrammar AglGrammar {\n    skip WHITESPACE = \"\\s+\" ;\n    skip MULTI_LINE_COMMENT = \"/\\*[^*]*\\*+(?:[^*`/`][^*]*\\*+)*/\" ;\n    skip SINGLE_LINE_COMMENT = \"//[^\\n\\r]*\" ;\n\n    grammarDefinition = namespace definitions ;\n    namespace = 'namespace' qualifiedName ;\n    definitions = grammar+ ;\n    grammar = 'grammar' IDENTIFIER extendsOpt '{' options rules '}' ;\n    extendsOpt = extends? ;\n    extends = 'extends' extendsList ;\n    extendsList = [qualifiedName / ',']+ ;\n    options = option* ;\n    option = '@' IDENTIFIER ':' value ;\n    value = IDENTIFIER | LITERAL ;\n    rules = rule+ ;\n    rule = grammarRule | overrideRule | preferenceRule ;\n    grammarRule = ruleTypeLabels IDENTIFIER '=' rhs ';' ;\n    overrideRule = 'override' ruleTypeLabels IDENTIFIER overrideOperator rhs ';' ;\n    overrideOperator = '=' | '+=|' ;\n    rhs = empty | concatenation | choice ;\n    ruleTypeLabels = 'skip'? 'leaf'? ;\n    empty = ;\n    choice = ambiguousChoice | priorityChoice | simpleChoice ;\n    ambiguousChoice = [ concatenation / '||' ]2+ ;\n    priorityChoice = [ concatenation / '<' ]2+ ;\n    simpleChoice = [ concatenation / '|' ]2+ ;\n    concatenation = concatenationItem+ ;\n    concatenationItem = simpleItemOrGroup | listOfItems ;\n    simpleItemOrGroup = simpleItem | group ;\n    simpleItem = terminal | nonTerminal | embedded ;\n    listOfItems = simpleList | separatedList ;\n    multiplicity = '*' | '+' | '?' | oneOrMore | range ;\n    oneOrMore = POSITIVE_INTEGER '+' ;\n    range = POSITIVE_INTEGER '..' POSITIVE_INTEGER ;\n    simpleList = simpleItemOrGroup multiplicity ;\n    separatedList = '[' simpleItemOrGroup '/' terminal ']' multiplicity ;\n    group = '(' groupedContent ')' ;\n    groupedContent = concatenation | choice ;\n    nonTerminal = qualifiedName ;\n    embedded = qualifiedName '::' nonTerminal ;\n    terminal = LITERAL | PATTERN ;\n    qualifiedName = [IDENTIFIER / '.']+ ;\n    IDENTIFIER = \"[a-zA-Z_][a-zA-Z_0-9]*\";\n    LITERAL = \"'([^'\\\\]|\\\\'|\\\\\\\\)*'\" ;\n    PATTERN = \"\\\"(\\\\\\\"|[^\\\"])*\\\"\" ;\n    POSITIVE_INTEGER = \"[0-9]+\" ;\n    \n    preferenceRule = 'preference' simpleItem '{' preferenceOptionList '}' ;\n    preferenceOptionList = preferenceOption* ;\n    preferenceOption = nonTerminal choiceNumber 'on' terminalList associativity ;\n    choiceNumber = POSITIVE_INTEGER? ;\n    terminalList = [simpleItem / ',']+ ;\n    associativity = 'left' | 'right' ;\n}";
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.q1e_1 = 'net.akehurst.language.agl.grammar.grammar';
    this.OPTIONS_KEY_AMBIGUITY_ANALYSIS = 'net.akehurst.language.agl.grammar.grammar.ambiguity.analysis';
  }
  r1e() {
    return this.OPTIONS_KEY_AMBIGUITY_ANALYSIS;
  }
}
class AglGrammarSemanticAnalyser {
  constructor(languageRegistry) {
    Companion_getInstance_14();
    this.languageRegistry = languageRegistry;
    this.s1e_1 = new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance());
    this.t1e_1 = null;
    this.u1e_1 = true;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.v1e_1 = tmp$ret$0;
  }
  k1f() {
    return this.languageRegistry;
  }
  clear() {
    this.v1e_1.n1();
    this.s1e_1.clear();
    this.t1e_1 = null;
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  l1f(asm, locationMap, context, options) {
    var tmp = this;
    var tmp0_elvis_lhs = locationMap;
    tmp.t1e_1 = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp_1 = options.other;
    Companion_getInstance_14();
    var tmp_2 = tmp_1.u3('net.akehurst.language.agl.grammar.grammar.ambiguity.analysis');
    var tmp1_elvis_lhs = (tmp_2 == null ? true : typeof tmp_2 === 'boolean') ? tmp_2 : THROW_CCE();
    tmp_0.u1e_1 = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = asm.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyse.<anonymous>' call
      this.languageRegistry.registerGrammar(element);
    }
    checkGrammar(this, asm, AutomatonKind_LOOKAHEAD_1_getInstance());
    return new SemanticAnalysisResultDefault(this.s1e_1);
  }
  g1b(asm, locationMap, context, options) {
    var tmp = isInterface(asm, List) ? asm : THROW_CCE();
    return this.l1f(tmp, locationMap, (context == null ? true : context instanceof GrammarContext) ? context : THROW_CCE(), options);
  }
  static get Companion() {
    return Companion_getInstance_14();
  }
}
class SyntaxAnalyserByMethodRegistrationAbstract extends SyntaxAnalyserFromTreeDataAbstract {
  constructor() {
    super();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.x1f_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.y1f_1 = tmp$ret$1;
    this.z1f_1 = null;
  }
  register(handler) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.x1f_1;
    var tmp1_set = handler.callableName;
    var tmp2_set = typeof handler === 'function' ? handler : THROW_CCE();
    tmp0_set.m3(tmp1_set, tmp2_set);
  }
  registerFor(branchName, handler) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.x1f_1;
    tmp0_set.m3(branchName, handler);
  }
  registerForBeginHandler(branchName, handler) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.y1f_1;
    var tmp1_set = typeof handler === 'function' ? handler : THROW_CCE();
    tmp0_set.m3(branchName, tmp1_set);
  }
  v2g(_set____db54di) {
    this.z1f_1 = _set____db54di;
  }
  w2g() {
    return this.z1f_1;
  }
  s1b() {
    var tmp0_elvis_lhs = this.z1f_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Root of asm not set, walk must have failed');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  walkTree(sentence, treeData, skipDataAsTree) {
    if (this.x1f_1.y()) {
      this.registerHandlers();
    }
    var syntaxAnalyserStack = mutableStackOf([this]);
    var stack = mutableStackOf([]);
    var walker = new SyntaxAnalyserByMethodRegistrationAbstract$walkTree$walker$1(stack, syntaxAnalyserStack, sentence, this);
    treeData.traverseTreeDepthFirst(walker, skipDataAsTree);
    var root = stack.w1a();
    var tmp = this;
    tmp.z1f_1 = isObject(root) ? root : THROW_CCE();
  }
  get embeddedSyntaxAnalyser() {
    return this.o1b();
  }
}
class AglGrammarSyntaxAnalyser extends SyntaxAnalyserByMethodRegistrationAbstract {
  constructor() {
    super();
    this.q1f_1 = new IssueHolder(LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance());
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.r1f_1 = tmp$ret$0;
    this.s1f_1 = emptyMap();
  }
  o1b() {
    return this.s1f_1;
  }
  registerHandlers() {
    this.register(AglGrammarSyntaxAnalyser$grammarDefinition$ref(this));
    this.register(AglGrammarSyntaxAnalyser$namespace$ref(this));
    this.register(AglGrammarSyntaxAnalyser$definitions$ref(this));
    this.register(AglGrammarSyntaxAnalyser$grammar$ref(this));
    this.register(AglGrammarSyntaxAnalyser$options$ref(this));
    this.register(AglGrammarSyntaxAnalyser$option$ref(this));
    this.register(AglGrammarSyntaxAnalyser$value$ref(this));
    this.register(AglGrammarSyntaxAnalyser$extendsOpt$ref(this));
    this.register(AglGrammarSyntaxAnalyser$extends$ref(this));
    this.register(AglGrammarSyntaxAnalyser$extendsList$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rules$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rule$ref(this));
    this.register(AglGrammarSyntaxAnalyser$grammarRule$ref(this));
    this.register(AglGrammarSyntaxAnalyser$overrideRule$ref(this));
    this.register(AglGrammarSyntaxAnalyser$overrideOperator$ref(this));
    this.register(AglGrammarSyntaxAnalyser$preferenceRule$ref(this));
    this.register(AglGrammarSyntaxAnalyser$ruleTypeLabels$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rhs$ref(this));
    this.register(AglGrammarSyntaxAnalyser$empty$ref(this));
    this.register(AglGrammarSyntaxAnalyser$choice$ref(this));
    this.register(AglGrammarSyntaxAnalyser$simpleChoice$ref(this));
    this.register(AglGrammarSyntaxAnalyser$priorityChoice$ref(this));
    this.register(AglGrammarSyntaxAnalyser$ambiguousChoice$ref(this));
    this.register(AglGrammarSyntaxAnalyser$concatenation$ref(this));
    this.register(AglGrammarSyntaxAnalyser$concatenationItem$ref(this));
    this.register(AglGrammarSyntaxAnalyser$simpleItemOrGroup$ref(this));
    this.register(AglGrammarSyntaxAnalyser$simpleItem$ref(this));
    this.register(AglGrammarSyntaxAnalyser$listOfItems$ref(this));
    this.register(AglGrammarSyntaxAnalyser$multiplicity$ref(this));
    this.register(AglGrammarSyntaxAnalyser$range$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeUnBraced$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeBraced$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeMaxOpt$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeMax$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeMaxBounded$ref(this));
    this.register(AglGrammarSyntaxAnalyser$rangeMaxUnbounded$ref(this));
    this.register(AglGrammarSyntaxAnalyser$simpleList$ref(this));
    this.register(AglGrammarSyntaxAnalyser$group$ref(this));
    this.register(AglGrammarSyntaxAnalyser$groupedContent$ref(this));
    this.register(AglGrammarSyntaxAnalyser$separatedList$ref(this));
    this.register(AglGrammarSyntaxAnalyser$nonTerminal$ref(this));
    this.register(AglGrammarSyntaxAnalyser$embedded$ref(this));
    this.register(AglGrammarSyntaxAnalyser$terminal$ref(this));
    this.register(AglGrammarSyntaxAnalyser$qualifiedName$ref(this));
    this.register(AglGrammarSyntaxAnalyser$preferenceOption$ref(this));
    this.register(AglGrammarSyntaxAnalyser$choiceNumber$ref(this));
    this.register(AglGrammarSyntaxAnalyser$associativity$ref(this));
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
}
class SentenceContext {}
class ContextFromGrammar {
  constructor() {
    this.a1g_1 = new ScopeSimple(null, '', '');
    this.b1g_1 = ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).typeModel;
  }
  static new_net_akehurst_language_agl_grammar_grammar_ContextFromGrammar(grammar) {
    var $this = this.new_net_akehurst_language_agl_grammar_grammar_ContextFromGrammar(listOf(grammar));
    return $this;
  }
  static new_net_akehurst_language_agl_grammar_grammar_ContextFromGrammar(grammars) {
    var $this = new ContextFromGrammar();
    $this.createScopeFrom(grammars);
    return $this;
  }
  c1g(_set____db54di) {
    this.a1g_1 = _set____db54di;
  }
  d1g() {
    return this.a1g_1;
  }
  clear() {
    this.a1g_1 = new ScopeSimple(null, '', '');
  }
  createScopeFrom(grammars) {
    var scope = new ScopeSimple(null, '', last(grammars).name);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = grammars.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.ContextFromGrammar.createScopeFrom.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = element.allResolvedGrammarRule;
      var tmp0_iterator_0 = tmp0_forEach.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.grammar.grammar.ContextFromGrammar.createScopeFrom.<anonymous>.<anonymous>' call
        var tmp0_elvis_lhs = _get_namespace__iwxsq2(this).findTypeUsageForRule('grammarRule');
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp0_error = "Type not found for rule '" + element_0.name + "'";
          throw IllegalStateException.y1(toString(tmp0_error));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var rType = tmp;
        scope.addToScope(element_0.name, rType.type.qualifiedName, element_0.name);
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp1_forEach = element.allResolvedTerminal;
      var tmp0_iterator_1 = tmp1_forEach.u();
      while (tmp0_iterator_1.h1()) {
        var element_1 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.grammar.grammar.ContextFromGrammar.createScopeFrom.<anonymous>.<anonymous>' call
        var rTypeName = element_1.isPattern ? 'PATTERN' : 'LITERAL';
        scope.addToScope(element_1.name, rTypeName, element_1.name);
      }
    }
    this.a1g_1 = scope;
  }
  hashCode() {
    return this.a1g_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (!(other instanceof ContextFromGrammar)) {
      tmp = false;
    } else {
      if (!this.a1g_1.equals(other.a1g_1)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return 'ContextFromGrammar';
  }
  get rootScope() {
    return this.d1g();
  }
  set rootScope(value) {
    this.c1g(value);
  }
}
class ConverterToRuntimeRules {
  constructor(grammar) {
    this.w1e_1 = grammar;
    this.x1e_1 = new IssueHolder(LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance());
    var tmp = this;
    tmp.y1e_1 = lazy(ConverterToRuntimeRules$_ruleSetNumber$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.z1e_1 = lazy(ConverterToRuntimeRules$runtimeRuleSet$delegate$lambda(this));
    var tmp_1 = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp_1.a1f_1 = tmp$ret$0;
    this.b1f_1 = emptyList();
    var tmp_2 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_2.c1f_1 = tmp$ret$1;
    var tmp_3 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_3.d1f_1 = tmp$ret$2;
    var tmp_4 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$3 = LinkedHashMap.n8();
    tmp_4.e1f_1 = tmp$ret$3;
    var tmp_5 = this;
    tmp_5.f1f_1 = lazyMutableMapNonNull(ConverterToRuntimeRules$embeddedConverters$lambda);
    var tmp_6 = this;
    tmp_6.g1f_1 = lazy(ConverterToRuntimeRules$_pseudoRuleNameGenerator$delegate$lambda(this));
  }
  h1f() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = runtimeRuleSet$factory();
    tmp$ret$0 = this.z1e_1.p3();
    return tmp$ret$0;
  }
  j1f(runtimeRuleSetNumber, runtimeRuleNumber) {
    return this.e1f_1.u3(new Pair(runtimeRuleSetNumber, runtimeRuleNumber));
  }
}
class GrammarContext {}
class PseudoRuleNames {
  constructor(grammar) {
    this.g1g_1 = grammar;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.h1g_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.i1g_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.j1g_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$3 = LinkedHashMap.n8();
    tmp_2.k1g_1 = tmp$ret$3;
    var tmp_3 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$4 = LinkedHashMap.n8();
    tmp_3.l1g_1 = tmp$ret$4;
    var tmp_4 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$5 = LinkedHashMap.n8();
    tmp_4.m1g_1 = tmp$ret$5;
    var tmp_5 = this;
    var tmp$ret$6;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$6 = LinkedHashMap.n8();
    tmp_5.n1g_1 = tmp$ret$6;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.g1g_1.allResolvedNonTerminalRule;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.agl.grammar.grammar.PseudoRuleNames.<anonymous>' call
      if (element.isLeaf)
      ;
      else if (element.isOneEmbedded)
      ;
      else {
        var pseudoRuleNames = pseudoRulesFor(this, element.rhs);
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = pseudoRuleNames.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          // Inline function 'net.akehurst.language.agl.agl.grammar.grammar.PseudoRuleNames.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.set' call
          var tmp0_set = this.m1g_1;
          var tmp1_set = element_0.ri_1;
          var tmp2_set = element_0.si_1;
          tmp0_set.m3(tmp1_set, tmp2_set);
          // Inline function 'kotlin.collections.set' call
          var tmp3_set = this.n1g_1;
          var tmp4_set = element_0.si_1;
          var tmp5_set = element_0.ri_1;
          tmp3_set.m3(tmp4_set, tmp5_set);
        }
      }
    }
  }
  o1g(item) {
    var tmp0_elvis_lhs = this.m1g_1.u3(item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Internal Error: name for RuleItem '" + item + "' not found";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class RuleBuilder {
  constructor(rule) {
    this.rule = rule;
  }
  t1g() {
    return this.rule;
  }
  empty() {
    this.rule.rhs = new EmptyRuleDefault();
  }
  concatenation(sequence) {
    this.rule.rhs = new ConcatenationDefault(toList_0(sequence));
  }
  choiceLongestFromConcatenation(alternative) {
    this.rule.rhs = new ChoiceLongestDefault(asList(alternative));
  }
  choiceLongestFromConcatenationItem(alternative) {
    this.rule.rhs = new ChoiceLongestDefault(asList(alternative));
  }
  choicePriority(alternative) {
    this.rule.rhs = new ChoicePriorityDefault(asList(alternative));
  }
  optional(item) {
    this.rule.rhs = new OptionalItemDefault(item);
  }
  multi(min, max, item) {
    // Inline function 'kotlin.check' call
    var tmp0_check = !(min === 0 ? max === 1 : false);
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp0_check) {
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.RuleBuilder.multi.<anonymous>' call
      tmp$ret$0 = 'Use optional rather than multi';
      var message = tmp$ret$0;
      throw IllegalStateException.y1(toString(message));
    }
    this.rule.rhs = new SimpleListDefault(min, max, item);
  }
  separatedList(min, max, separator, item) {
    this.rule.rhs = new SeparatedListDefault(min, max, item, separator);
  }
}
class GrammarBuilderDefault {
  constructor(namespace, name) {
    this.namespace = namespace;
    this.name = name;
    this.grammar = new GrammarDefault(this.namespace, this.name, emptyList());
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.a1c_1 = tmp$ret$0;
  }
  ul() {
    return this.namespace;
  }
  be() {
    return this.name;
  }
  u1g() {
    return this.grammar;
  }
  rule(name) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new NormalRuleDefault(this.grammar, name, false, false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarBuilderDefault.rule.<anonymous>' call
    this.grammar.grammarRule.e1(tmp0_also);
    tmp$ret$0 = tmp0_also;
    return new RuleBuilder(tmp$ret$0);
  }
  v1g(name, isLeaf) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new NormalRuleDefault(this.grammar, name, true, isLeaf);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarBuilderDefault.skip.<anonymous>' call
    this.grammar.grammarRule.e1(tmp0_also);
    tmp$ret$0 = tmp0_also;
    return new RuleBuilder(tmp$ret$0);
  }
  skip(name, isLeaf, $super) {
    isLeaf = isLeaf === VOID ? false : isLeaf;
    return this.v1g(name, isLeaf);
  }
  leaf(name) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new NormalRuleDefault(this.grammar, name, false, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarBuilderDefault.leaf.<anonymous>' call
    this.grammar.grammarRule.e1(tmp0_also);
    tmp$ret$0 = tmp0_also;
    return new RuleBuilder(tmp$ret$0);
  }
  terminalLiteral(value) {
    return terminal_0(this, value, false);
  }
  terminalPattern(value) {
    return terminal_0(this, value, true);
  }
  embed(embeddedGrammarName, embeddedGoalName) {
    var qn = embeddedGrammarName;
    var embeddedGrammarRef = new GrammarReferenceDefault(this.namespace, embeddedGrammarName);
    return new EmbeddedDefault(embeddedGoalName, embeddedGrammarRef);
  }
  nonTerminal(name) {
    if (contains(name, '.')) {
      // Inline function 'kotlin.TODO' call
      throw NotImplementedError.eg('An operation is not implemented: Not supported');
    } else {
      return new NonTerminalDefault(name);
    }
  }
  concatenation(sequence) {
    return new ConcatenationDefault(toList_0(sequence));
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
  }
  fromString() {
  }
}
class GrammarDefault extends GrammarAbstract {
  constructor(namespace, name, options) {
    Companion_getInstance_15();
    super(namespace, name);
    this.i1h_1 = namespace;
    this.j1h_1 = name;
    this.k1h_1 = options;
  }
  ul() {
    return this.i1h_1;
  }
  be() {
    return this.j1h_1;
  }
  s1c() {
    return this.k1h_1;
  }
  static get Companion() {
    return Companion_getInstance_15();
  }
}
class GrammarOption {}
class GrammarOptionDefault {
  constructor(name, value) {
    this.l1h_1 = name;
    this.m1h_1 = value;
  }
  be() {
    return this.l1h_1;
  }
  p3() {
    return this.m1h_1;
  }
  ti() {
    return this.l1h_1;
  }
  ui() {
    return this.m1h_1;
  }
  n1h(name, value) {
    return new GrammarOptionDefault(name, value);
  }
  copy(name, value, $super) {
    name = name === VOID ? this.l1h_1 : name;
    value = value === VOID ? this.m1h_1 : value;
    return this.n1h(name, value);
  }
  toString() {
    return 'GrammarOptionDefault(name=' + this.l1h_1 + ', value=' + this.m1h_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.l1h_1);
    result = imul(result, 31) + getStringHashCode(this.m1h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrammarOptionDefault))
      return false;
    var tmp0_other_with_cast = other instanceof GrammarOptionDefault ? other : THROW_CCE();
    if (!(this.l1h_1 === tmp0_other_with_cast.l1h_1))
      return false;
    if (!(this.m1h_1 === tmp0_other_with_cast.m1h_1))
      return false;
    return true;
  }
  get name() {
    return this.be();
  }
  get value() {
    return this.p3();
  }
}
class GrammarReference {}
class GrammarReferenceDefault {
  constructor(localNamespace, nameOrQName) {
    this.o1h_1 = localNamespace;
    this.p1h_1 = nameOrQName;
    this.q1h_1 = null;
  }
  r1h() {
    return this.o1h_1;
  }
  s1h() {
    return this.p1h_1;
  }
  t1h(_set____db54di) {
    this.q1h_1 = _set____db54di;
  }
  u1h() {
    return this.q1h_1;
  }
  resolveAs(resolved) {
    this.q1h_1 = resolved;
  }
  ti() {
    return this.o1h_1;
  }
  ui() {
    return this.p1h_1;
  }
  v1h(localNamespace, nameOrQName) {
    return new GrammarReferenceDefault(localNamespace, nameOrQName);
  }
  copy(localNamespace, nameOrQName, $super) {
    localNamespace = localNamespace === VOID ? this.o1h_1 : localNamespace;
    nameOrQName = nameOrQName === VOID ? this.p1h_1 : nameOrQName;
    return this.v1h(localNamespace, nameOrQName);
  }
  toString() {
    return 'GrammarReferenceDefault(localNamespace=' + this.o1h_1 + ', nameOrQName=' + this.p1h_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.o1h_1);
    result = imul(result, 31) + getStringHashCode(this.p1h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrammarReferenceDefault))
      return false;
    var tmp0_other_with_cast = other instanceof GrammarReferenceDefault ? other : THROW_CCE();
    if (!equals(this.o1h_1, tmp0_other_with_cast.o1h_1))
      return false;
    if (!(this.p1h_1 === tmp0_other_with_cast.p1h_1))
      return false;
    return true;
  }
  get localNamespace() {
    return this.r1h();
  }
  get nameOrQName() {
    return this.s1h();
  }
  get resolved() {
    return this.u1h();
  }
  set resolved(value) {
    this.t1h(value);
  }
}
class GrammarItem {}
class GrammarItemAbstract {
  get grammar() {
    return this.u1g();
  }
}
class RuleItem {}
class ConcatenationItem {}
class SimpleItem {}
class TangibleItem {}
class Terminal {}
class RuleItemAbstract {
  constructor() {
    this._owningRule = null;
    this.index = null;
  }
  i1i(_set____db54di) {
    this._owningRule = _set____db54di;
  }
  j1i() {
    return this._owningRule;
  }
  h1i() {
    var tmp0_elvis_lhs = this._owningRule;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Internal Error: owningRule must be set');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  k1i(_set____db54di) {
    this.index = _set____db54di;
  }
  wm() {
    return this.index;
  }
  get owningRule() {
    return this.h1i();
  }
  get allTerminal() {
    return this.e1i();
  }
  get allNonTerminal() {
    return this.f1i();
  }
  get allEmbedded() {
    return this.g1i();
  }
}
class CompressedLeafRule extends RuleItemAbstract {
  constructor(name, value, isPattern) {
    super();
    this.w1h_1 = name;
    this.x1h_1 = value;
    this.y1h_1 = isPattern;
    this.a1i_1 = setOf(this);
    this.b1i_1 = emptySet();
    this.c1i_1 = emptySet();
  }
  be() {
    return this.w1h_1;
  }
  p3() {
    return this.x1h_1;
  }
  r12() {
    return this.y1h_1;
  }
  d1i(_set____db54di) {
    this.z1h_1 = _set____db54di;
  }
  u1g() {
    var tmp = this.z1h_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('grammar');
    }
  }
  e1i() {
    return this.a1i_1;
  }
  f1i() {
    return this.b1i_1;
  }
  g1i() {
    return this.c1i_1;
  }
  setOwningRule(rule, indices) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
  subItem(index) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
  get name() {
    return this.be();
  }
  get value() {
    return this.p3();
  }
  get isPattern() {
    return this.r12();
  }
  get grammar() {
    return this.u1g();
  }
  set grammar(value) {
    this.d1i(value);
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
  }
  compressRuleItem(compressedName, item) {
    var grammar = item.owningRule.grammar;
    var tmp0_subject = item;
    var tmp;
    if (isInterface(tmp0_subject, Terminal)) {
      tmp = item.isPattern ? new CompressedLeafRule(compressedName, item.value, true) : new CompressedLeafRule(compressedName, toRegEx(this, item.value), false);
    } else {
      if (isInterface(tmp0_subject, Concatenation)) {
        var tmp_0;
        if (1 === item.items.o()) {
          tmp_0 = this.compressRuleItem(compressedName, item.items.p(0));
        } else {
          var tmp$ret$2;
          // Inline function 'kotlin.collections.mapIndexed' call
          var tmp0_mapIndexed = item.items;
          var tmp$ret$1;
          // Inline function 'kotlin.collections.mapIndexedTo' call
          var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp0_mapIndexed, 10));
          var index = 0;
          var tmp0_iterator = tmp0_mapIndexed.u();
          while (tmp0_iterator.h1()) {
            var item_0 = tmp0_iterator.j1();
            var tmp$ret$0;
            // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.Companion.compressRuleItem.<anonymous>' call
            var tmp1 = index;
            index = tmp1 + 1 | 0;
            var tmp1_anonymous = checkIndexOverflow(tmp1);
            tmp$ret$0 = this.compressRuleItem(compressedName + tmp1_anonymous, item_0);
            tmp0_mapIndexedTo.e1(tmp$ret$0);
          }
          tmp$ret$1 = tmp0_mapIndexedTo;
          tmp$ret$2 = tmp$ret$1;
          var items = tmp$ret$2;
          var pattern = joinToString(items, '', VOID, VOID, VOID, VOID, GrammarRuleAbstract$Companion$compressRuleItem$lambda);
          tmp_0 = new CompressedLeafRule(compressedName, pattern, true);
        }
        tmp = tmp_0;
      } else {
        if (isInterface(tmp0_subject, Choice)) {
          var tmp1_subject = item.alternative.o();
          var tmp_1;
          if (tmp1_subject === 1) {
            tmp_1 = this.compressRuleItem(compressedName, item.alternative.p(0));
          } else {
            var tmp$ret$5;
            // Inline function 'kotlin.collections.mapIndexed' call
            var tmp2_mapIndexed = item.alternative;
            var tmp$ret$4;
            // Inline function 'kotlin.collections.mapIndexedTo' call
            var tmp0_mapIndexedTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp2_mapIndexed, 10));
            var index_0 = 0;
            var tmp0_iterator_0 = tmp2_mapIndexed.u();
            while (tmp0_iterator_0.h1()) {
              var item_1 = tmp0_iterator_0.j1();
              var tmp$ret$3;
              // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.Companion.compressRuleItem.<anonymous>' call
              var tmp1_0 = index_0;
              index_0 = tmp1_0 + 1 | 0;
              var tmp3_anonymous = checkIndexOverflow(tmp1_0);
              tmp$ret$3 = this.compressRuleItem(compressedName + tmp3_anonymous, item_1);
              tmp0_mapIndexedTo_0.e1(tmp$ret$3);
            }
            tmp$ret$4 = tmp0_mapIndexedTo_0;
            tmp$ret$5 = tmp$ret$4;
            var ct = tmp$ret$5;
            var pattern_0 = joinToString(ct, '|', VOID, VOID, VOID, VOID, GrammarRuleAbstract$Companion$compressRuleItem$lambda_0);
            tmp_1 = new CompressedLeafRule(compressedName, pattern_0, true);
          }
          tmp = tmp_1;
        } else {
          if (isInterface(tmp0_subject, OptionalItem)) {
            var ct_0 = this.compressRuleItem(compressedName + 'List', item.item);
            var pattern_1 = '(' + ct_0.x1h_1 + ')?';
            tmp = new CompressedLeafRule(compressedName, pattern_1, true);
          } else {
            if (isInterface(tmp0_subject, SimpleList)) {
              var ct_1 = this.compressRuleItem(compressedName + 'List', item.item);
              var min = item.min;
              var max = -1 === item.max ? '' : item.max;
              var pattern_2 = '(' + ct_1.x1h_1 + '){' + min + ',' + toString(max) + '}';
              tmp = new CompressedLeafRule(compressedName, pattern_2, true);
            } else {
              if (isInterface(tmp0_subject, Group)) {
                var ct_2 = this.compressRuleItem(compressedName + 'Group', item.groupedContent);
                var pattern_3 = '(' + ct_2.x1h_1 + ')';
                tmp = new CompressedLeafRule(compressedName, pattern_3, true);
              } else {
                if (isInterface(tmp0_subject, NonTerminal)) {
                  tmp = this.compressRuleItem(compressedName, item.referencedRule(grammar).rhs);
                } else {
                  throw GrammarExeception.o1i('GrammarRule ' + item.owningRule.name + ', compressing ' + getKClassFromExpression(item).n9() + ' to leaf is not yet supported', null);
                }
              }
            }
          }
        }
      }
    }
    var cr = tmp;
    cr.z1h_1 = grammar;
    return cr;
  }
}
class GrammarRule {}
class GrammarRuleAbstract extends GrammarItemAbstract {
  constructor() {
    Companion_getInstance_16();
    super();
    var tmp = this;
    tmp.p1i_1 = lazy(GrammarRuleAbstract$compressedLeaf$delegate$lambda(this));
  }
  q1i() {
    var tmp;
    var tmp_0 = this.rhs;
    if (isInterface(tmp_0, Embedded)) {
      tmp = true;
    } else {
      var tmp_1;
      var tmp_2 = this.rhs;
      if (isInterface(tmp_2, Concatenation)) {
        var tmp_3 = this.rhs;
        var tmp_4 = (isInterface(tmp_3, Concatenation) ? tmp_3 : THROW_CCE()).items.p(0);
        tmp_1 = isInterface(tmp_4, Embedded);
      } else {
        tmp_1 = false;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  r1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = compressedLeaf$factory();
    tmp$ret$0 = this.p1i_1.p3();
    return tmp$ret$0;
  }
  get isOneEmbedded() {
    return this.q1i();
  }
  get compressedLeaf() {
    return this.r1i();
  }
  get grammar() {
    return this.u1g();
  }
  get name() {
    return this.be();
  }
  get isOverride() {
    return this.s1i();
  }
  get isSkip() {
    return this.t1i();
  }
  get isLeaf() {
    return this.g14();
  }
  get rhs() {
    return this.i11();
  }
  static get Companion() {
    return Companion_getInstance_16();
  }
}
class Namespace {}
class NamespaceDefault {
  constructor(qualifiedName) {
    this.u1i_1 = qualifiedName;
  }
  wl() {
    return this.u1i_1;
  }
  toString() {
    return 'namespace ' + this.u1i_1;
  }
  ti() {
    return this.u1i_1;
  }
  v1i(qualifiedName) {
    return new NamespaceDefault(qualifiedName);
  }
  copy(qualifiedName, $super) {
    qualifiedName = qualifiedName === VOID ? this.u1i_1 : qualifiedName;
    return this.v1i(qualifiedName);
  }
  hashCode() {
    return getStringHashCode(this.u1i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NamespaceDefault))
      return false;
    var tmp0_other_with_cast = other instanceof NamespaceDefault ? other : THROW_CCE();
    if (!(this.u1i_1 === tmp0_other_with_cast.u1i_1))
      return false;
    return true;
  }
  get qualifiedName() {
    return this.wl();
  }
}
class NodeType {}
class NodeTypeDefault {
  constructor(identity) {
    this.w1i_1 = identity;
  }
  x1i() {
    return this.w1i_1;
  }
  ti() {
    return this.w1i_1;
  }
  v1i(identity) {
    return new NodeTypeDefault(identity);
  }
  copy(identity, $super) {
    identity = identity === VOID ? this.w1i_1 : identity;
    return this.v1i(identity);
  }
  toString() {
    return 'NodeTypeDefault(identity=' + this.w1i_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.w1i_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeTypeDefault))
      return false;
    var tmp0_other_with_cast = other instanceof NodeTypeDefault ? other : THROW_CCE();
    if (!(this.w1i_1 === tmp0_other_with_cast.w1i_1))
      return false;
    return true;
  }
  get identity() {
    return this.x1i();
  }
}
class NormalRule {}
class NormalRuleDefault extends GrammarRuleAbstract {
  constructor(grammar, name, isSkip, isLeaf) {
    super();
    this.z1i_1 = grammar;
    this.a1j_1 = name;
    this.b1j_1 = isSkip;
    this.c1j_1 = isLeaf;
    this.d1j_1 = false;
    this.e1j_1 = null;
  }
  u1g() {
    return this.z1i_1;
  }
  be() {
    return this.a1j_1;
  }
  t1i() {
    return this.b1j_1;
  }
  g14() {
    return this.c1j_1;
  }
  s1i() {
    return this.d1j_1;
  }
  f1j(value) {
    value.setOwningRule(this, listOf(0));
    this.e1j_1 = value;
  }
  i11() {
    var tmp0_elvis_lhs = this.e1j_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw GrammarExeception.o1i('rhs of rule must be set', null);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(listOf_0([this.a1j_1, this.z1i_1]));
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, NormalRule) : false)) {
      tmp = false;
    } else {
      tmp = this.a1j_1 === other.name ? equals(other.grammar, this.z1i_1) : false;
    }
    return tmp;
  }
  toString() {
    var f = '';
    if (this.b1j_1)
      f = f + 'skip ';
    if (this.c1j_1)
      f = f + 'leaf ';
    return f + this.a1j_1 + ' = ' + this.rhs + ' ;';
  }
  get rhs() {
    return this.i11();
  }
  set rhs(value) {
    this.f1j(value);
  }
}
class OverrideRule {}
class OverrideRuleDefault extends GrammarRuleAbstract {
  constructor(grammar, name, isSkip, isLeaf, overrideKind) {
    super();
    this.h1j_1 = grammar;
    this.i1j_1 = name;
    this.j1j_1 = isSkip;
    this.k1j_1 = isLeaf;
    this.l1j_1 = overrideKind;
    this.m1j_1 = true;
    this.n1j_1 = null;
  }
  u1g() {
    return this.h1j_1;
  }
  be() {
    return this.i1j_1;
  }
  t1i() {
    return this.j1j_1;
  }
  g14() {
    return this.k1j_1;
  }
  o1j() {
    return this.l1j_1;
  }
  s1i() {
    return this.m1j_1;
  }
  p1j(value) {
    value.setOwningRule(this, listOf(0));
    this.n1j_1 = value;
  }
  q1j() {
    var tmp0_elvis_lhs = this.n1j_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw GrammarExeception.o1i('overridenRhs of rule must be set', null);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  i11() {
    var tmp0_subject = this.l1j_1;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        tmp = this.overridenRhs;
        break;
      case 1:
        var or = first_0(this.h1j_1.findAllSuperNonTerminalRule(this.i1j_1));
        var tmp1_subject = or.rhs;
        var tmp_0;
        if (isInterface(tmp1_subject, ChoiceLongest)) {
          var tmp_1 = or.rhs;
          var appendedAlternatives = plus_2((isInterface(tmp_1, ChoiceLongest) ? tmp_1 : THROW_CCE()).alternative, this.overridenRhs);
          var ac = new ChoiceLongestDefault(appendedAlternatives);
          var tmp_2 = or.rhs;
          var indices = ensureNotNull((tmp_2 instanceof ChoiceLongestDefault ? tmp_2 : THROW_CCE()).index);
          var ni = plus_2(plus_2(dropLast(indices, 1), last(indices)), 1);
          ac.setOwningRule(this, ni);
          tmp_0 = ac;
        } else {
          throw IllegalStateException.y1('Cannot append choice to a non-longest-choice rule');
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(listOf_0([this.i1j_1, this.h1j_1]));
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, OverrideRule) : false)) {
      tmp = false;
    } else {
      tmp = this.i1j_1 === other.name ? equals(other.grammar, this.h1j_1) : false;
    }
    return tmp;
  }
  toString() {
    var f = '';
    if (this.j1j_1)
      f = f + 'skip ';
    if (this.k1j_1)
      f = f + 'leaf ';
    return 'override ' + f + this.i1j_1 + ' = ' + this.rhs + ' ;';
  }
  ti() {
    return this.h1j_1;
  }
  ui() {
    return this.i1j_1;
  }
  r1j() {
    return this.j1j_1;
  }
  s1j() {
    return this.k1j_1;
  }
  t1j() {
    return this.l1j_1;
  }
  u1j(grammar, name, isSkip, isLeaf, overrideKind) {
    return new OverrideRuleDefault(grammar, name, isSkip, isLeaf, overrideKind);
  }
  copy(grammar, name, isSkip, isLeaf, overrideKind, $super) {
    grammar = grammar === VOID ? this.h1j_1 : grammar;
    name = name === VOID ? this.i1j_1 : name;
    isSkip = isSkip === VOID ? this.j1j_1 : isSkip;
    isLeaf = isLeaf === VOID ? this.k1j_1 : isLeaf;
    overrideKind = overrideKind === VOID ? this.l1j_1 : overrideKind;
    return this.u1j(grammar, name, isSkip, isLeaf, overrideKind);
  }
  get overrideKind() {
    return this.o1j();
  }
  get overridenRhs() {
    return this.q1j();
  }
  set overridenRhs(value) {
    this.p1j(value);
  }
}
class PreferenceRule {}
class PreferenceRuleDefault extends GrammarItemAbstract {
  constructor(grammar, forItem, optionList) {
    super();
    this.v1j_1 = grammar;
    this.w1j_1 = forItem;
    this.x1j_1 = optionList;
  }
  u1g() {
    return this.v1j_1;
  }
  y1j() {
    return this.w1j_1;
  }
  d14() {
    return this.x1j_1;
  }
  toString() {
    return 'preference ' + this.w1j_1 + ' { ... }';
  }
  ti() {
    return this.v1j_1;
  }
  ui() {
    return this.w1j_1;
  }
  r1j() {
    return this.x1j_1;
  }
  z1j(grammar, forItem, optionList) {
    return new PreferenceRuleDefault(grammar, forItem, optionList);
  }
  copy(grammar, forItem, optionList, $super) {
    grammar = grammar === VOID ? this.v1j_1 : grammar;
    forItem = forItem === VOID ? this.w1j_1 : forItem;
    optionList = optionList === VOID ? this.x1j_1 : optionList;
    return this.z1j(grammar, forItem, optionList);
  }
  hashCode() {
    var result = hashCode(this.v1j_1);
    result = imul(result, 31) + hashCode(this.w1j_1) | 0;
    result = imul(result, 31) + hashCode(this.x1j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferenceRuleDefault))
      return false;
    var tmp0_other_with_cast = other instanceof PreferenceRuleDefault ? other : THROW_CCE();
    if (!equals(this.v1j_1, tmp0_other_with_cast.v1j_1))
      return false;
    if (!equals(this.w1j_1, tmp0_other_with_cast.w1j_1))
      return false;
    if (!equals(this.x1j_1, tmp0_other_with_cast.x1j_1))
      return false;
    return true;
  }
  get forItem() {
    return this.y1j();
  }
  get optionList() {
    return this.d14();
  }
}
class PreferenceOption {}
class PreferenceOptionDefault {
  constructor(item, choiceNumber, onTerminals, associativity) {
    this.a1k_1 = item;
    this.b1k_1 = choiceNumber;
    this.c1k_1 = onTerminals;
    this.d1k_1 = associativity;
  }
  e1k() {
    return this.a1k_1;
  }
  f1k() {
    return this.b1k_1;
  }
  g1k() {
    return this.c1k_1;
  }
  h1k() {
    return this.d1k_1;
  }
  ti() {
    return this.a1k_1;
  }
  ui() {
    return this.b1k_1;
  }
  r1j() {
    return this.c1k_1;
  }
  s1j() {
    return this.d1k_1;
  }
  i1k(item, choiceNumber, onTerminals, associativity) {
    return new PreferenceOptionDefault(item, choiceNumber, onTerminals, associativity);
  }
  copy(item, choiceNumber, onTerminals, associativity, $super) {
    item = item === VOID ? this.a1k_1 : item;
    choiceNumber = choiceNumber === VOID ? this.b1k_1 : choiceNumber;
    onTerminals = onTerminals === VOID ? this.c1k_1 : onTerminals;
    associativity = associativity === VOID ? this.d1k_1 : associativity;
    return this.i1k(item, choiceNumber, onTerminals, associativity);
  }
  toString() {
    return 'PreferenceOptionDefault(item=' + this.a1k_1 + ', choiceNumber=' + this.b1k_1 + ', onTerminals=' + this.c1k_1 + ', associativity=' + this.d1k_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a1k_1);
    result = imul(result, 31) + this.b1k_1 | 0;
    result = imul(result, 31) + hashCode(this.c1k_1) | 0;
    result = imul(result, 31) + this.d1k_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferenceOptionDefault))
      return false;
    var tmp0_other_with_cast = other instanceof PreferenceOptionDefault ? other : THROW_CCE();
    if (!equals(this.a1k_1, tmp0_other_with_cast.a1k_1))
      return false;
    if (!(this.b1k_1 === tmp0_other_with_cast.b1k_1))
      return false;
    if (!equals(this.c1k_1, tmp0_other_with_cast.c1k_1))
      return false;
    if (!this.d1k_1.equals(tmp0_other_with_cast.d1k_1))
      return false;
    return true;
  }
  get item() {
    return this.e1k();
  }
  get choiceNumber() {
    return this.f1k();
  }
  get onTerminals() {
    return this.g1k();
  }
  get associativity() {
    return this.h1k();
  }
}
class Concatenation {}
class ConcatenationDefault extends RuleItemAbstract {
  constructor(items) {
    super();
    this.j1k_1 = items;
    var tmp = this;
    tmp.k1k_1 = lazy(ConcatenationDefault$allTerminal$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.l1k_1 = lazy(ConcatenationDefault$allNonTerminal$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.m1k_1 = lazy(ConcatenationDefault$allEmbedded$delegate$lambda(this));
  }
  a11() {
    return this.j1k_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var i = 0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.j1k_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ConcatenationDefault.setOwningRule.<anonymous>' call
      var tmp0 = i;
      i = tmp0 + 1 | 0;
      var nextIndex = plus_2(indices, tmp0);
      element.setOwningRule(rule, nextIndex);
    }
  }
  subItem(index) {
    return this.j1k_1.p(index);
  }
  e1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allTerminal$factory();
    tmp$ret$0 = this.k1k_1.p3();
    return tmp$ret$0;
  }
  f1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allNonTerminal$factory();
    tmp$ret$0 = this.l1k_1.p3();
    return tmp$ret$0;
  }
  g1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allEmbedded$factory();
    tmp$ret$0 = this.m1k_1.p3();
    return tmp$ret$0;
  }
  toString() {
    return joinToString(this.j1k_1, ' ');
  }
  get items() {
    return this.a11();
  }
}
class Choice {}
class ChoiceAbstract extends RuleItemAbstract {
  constructor(alternative) {
    super();
    this.n1k_1 = alternative;
    var tmp = this;
    tmp.o1k_1 = lazy(ChoiceAbstract$allTerminal$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p1k_1 = lazy(ChoiceAbstract$allNonTerminal$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.q1k_1 = lazy(ChoiceAbstract$allEmbedded$delegate$lambda(this));
  }
  r1k() {
    return this.n1k_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var i = 0;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.alternative;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ChoiceAbstract.setOwningRule.<anonymous>' call
      var tmp0 = i;
      i = tmp0 + 1 | 0;
      var nextIndex = plus_2(indices, tmp0);
      element.setOwningRule(rule, nextIndex);
    }
  }
  subItem(index) {
    return this.alternative.p(index);
  }
  e1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allTerminal$factory_0();
    tmp$ret$0 = this.o1k_1.p3();
    return tmp$ret$0;
  }
  f1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allNonTerminal$factory_0();
    tmp$ret$0 = this.p1k_1.p3();
    return tmp$ret$0;
  }
  g1i() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = allEmbedded$factory_0();
    tmp$ret$0 = this.q1k_1.p3();
    return tmp$ret$0;
  }
  toString() {
    return joinToString(this.alternative, ' | ');
  }
  get alternative() {
    return this.r1k();
  }
}
class ChoiceLongest {}
class ChoiceLongestDefault extends ChoiceAbstract {
  constructor(alternative) {
    super(alternative);
    this.w1k_1 = alternative;
  }
  r1k() {
    return this.w1k_1;
  }
}
class ChoicePriority {}
class ChoicePriorityDefault extends ChoiceAbstract {
  constructor(alternative) {
    super(alternative);
    this.b1l_1 = alternative;
  }
  r1k() {
    return this.b1l_1;
  }
}
class ChoiceAmbiguous {}
class ChoiceAmbiguousDefault extends ChoiceAbstract {
  constructor(alternative) {
    super(alternative);
    this.g1l_1 = alternative;
  }
  r1k() {
    return this.g1l_1;
  }
}
class ConcatenationItemAbstract extends RuleItemAbstract {
  get allEmbedded() {
    return this.g1i();
  }
}
class OptionalItem {}
class OptionalItemDefault extends ConcatenationItemAbstract {
  constructor(item) {
    super();
    this.h1l_1 = item;
  }
  e1k() {
    return this.h1l_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var nextIndex = plus_2(indices, 0);
    this.h1l_1.setOwningRule(rule, nextIndex);
  }
  subItem(index) {
    var tmp;
    if (0 === index) {
      tmp = this.h1l_1;
    } else {
      throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
    }
    return tmp;
  }
  e1i() {
    return this.h1l_1.allTerminal;
  }
  f1i() {
    return this.h1l_1.allNonTerminal;
  }
  g1i() {
    return this.h1l_1.allEmbedded;
  }
  toString() {
    return '' + this.h1l_1 + '?';
  }
  get item() {
    return this.e1k();
  }
}
class SimpleItemAbstract extends ConcatenationItemAbstract {
  get name() {
    return this.be();
  }
  get allEmbedded() {
    return this.g1i();
  }
}
class Group {}
class GroupDefault extends SimpleItemAbstract {
  constructor(groupedContent) {
    super();
    this.m1l_1 = groupedContent;
    this.n1l_1 = '$group';
  }
  o1l() {
    return this.m1l_1;
  }
  be() {
    return this.n1l_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var nextIndex = plus_2(indices, 0);
    this.m1l_1.setOwningRule(rule, nextIndex);
  }
  subItem(index) {
    var tmp;
    if (0 === index) {
      tmp = this.m1l_1;
    } else {
      throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
    }
    return tmp;
  }
  e1i() {
    return this.m1l_1.allTerminal;
  }
  f1i() {
    return this.m1l_1.allNonTerminal;
  }
  g1i() {
    return this.m1l_1.allEmbedded;
  }
  toString() {
    return '( ' + this.m1l_1 + ' )';
  }
  get groupedContent() {
    return this.o1l();
  }
}
class TangibleItemAbstract extends SimpleItemAbstract {
  get allEmbedded() {
    return this.g1i();
  }
}
class EmptyRule {}
class EmptyRuleDefault extends TangibleItemAbstract {
  constructor() {
    super();
    this.p1l_1 = '<empty>';
  }
  be() {
    return this.p1l_1;
  }
  e1i() {
    return emptySet();
  }
  f1i() {
    return emptySet();
  }
  g1i() {
    return emptySet();
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
  }
  subItem(index) {
    throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
  }
  toString() {
    return '/* empty */';
  }
}
class TerminalDefault extends TangibleItemAbstract {
  constructor(value, isPattern) {
    super();
    this.p1g_1 = value;
    this.q1g_1 = isPattern;
    this.s1g_1 = this.q1g_1 ? '"' + this.p1g_1 + '"' : "'" + this.p1g_1 + "'";
  }
  p3() {
    return this.p1g_1;
  }
  r12() {
    return this.q1g_1;
  }
  d1i(_set____db54di) {
    this.r1g_1 = _set____db54di;
  }
  u1g() {
    var tmp = this.r1g_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('grammar');
    }
  }
  be() {
    return this.s1g_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
  }
  subItem(index) {
    throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
  }
  e1i() {
    return setOf(this);
  }
  f1i() {
    return emptySet();
  }
  g1i() {
    return emptySet();
  }
  toString() {
    return this.q1g_1 ? '"' + this.p1g_1 + '"' : "'" + this.p1g_1 + "'";
  }
  get value() {
    return this.p3();
  }
  get isPattern() {
    return this.r12();
  }
  get grammar() {
    return this.u1g();
  }
  set grammar(value) {
    this.d1i(value);
  }
}
class NonTerminal {}
class NonTerminalDefault extends TangibleItemAbstract {
  constructor(name) {
    super();
    this.q1l_1 = name;
  }
  be() {
    return this.q1l_1;
  }
  referencedRuleOrNull(targetGrammar) {
    return targetGrammar.findNonTerminalRule(this.q1l_1);
  }
  referencedRule(targetGrammar) {
    var tmp0_elvis_lhs = this.referencedRuleOrNull(targetGrammar);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = 'Grammar GrammarRule (' + this.q1l_1 + ') not found in grammar (' + targetGrammar.name + ')';
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
  }
  subItem(index) {
    throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
  }
  e1i() {
    return emptySet();
  }
  f1i() {
    return setOf(this);
  }
  g1i() {
    return emptySet();
  }
  toString() {
    return this.q1l_1;
  }
}
class Embedded {}
class EmbeddedDefault extends TangibleItemAbstract {
  constructor(embeddedGoalName, embeddedGrammarReference) {
    super();
    this.r1l_1 = embeddedGoalName;
    this.s1l_1 = embeddedGrammarReference;
  }
  t1l() {
    return this.r1l_1;
  }
  u1l() {
    return this.s1l_1;
  }
  be() {
    return this.r1l_1;
  }
  referencedRule(targetGrammar) {
    var tmp0_elvis_lhs = targetGrammar.findNonTerminalRule(this.name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Grammar GrammarRule '" + this.name + "' not found in grammar '" + targetGrammar.name + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
  }
  subItem(index) {
    throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
  }
  e1i() {
    return emptySet();
  }
  f1i() {
    return emptySet();
  }
  g1i() {
    return setOf(this);
  }
  toString() {
    return this.s1l_1.nameOrQName + '.' + this.r1l_1;
  }
  get embeddedGoalName() {
    return this.t1l();
  }
  get embeddedGrammarReference() {
    return this.u1l();
  }
}
class ListOfItems {}
class ListOfItemsAbstract extends ConcatenationItemAbstract {
  constructor(min, max) {
    super();
    this.v1l_1 = min;
    this.w1l_1 = max;
  }
  r16() {
    return this.v1l_1;
  }
  s16() {
    return this.w1l_1;
  }
  get min() {
    return this.r16();
  }
  get max() {
    return this.s16();
  }
  get allEmbedded() {
    return this.g1i();
  }
  get item() {
    return this.e1k();
  }
}
class SimpleList {}
class SimpleListDefault extends ListOfItemsAbstract {
  constructor(min_, max_, item) {
    super(min_, max_);
    this.z1l_1 = item;
  }
  e1k() {
    return this.z1l_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var nextIndex = plus_2(indices, 0);
    this.z1l_1.setOwningRule(rule, nextIndex);
  }
  subItem(index) {
    var tmp;
    if (0 === index) {
      tmp = this.z1l_1;
    } else {
      throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
    }
    return tmp;
  }
  e1i() {
    return this.z1l_1.allTerminal;
  }
  f1i() {
    return this.z1l_1.allNonTerminal;
  }
  g1i() {
    return this.z1l_1.allEmbedded;
  }
  toString() {
    var mult = (0 === this.min ? 1 === this.max : false) ? '?' : (0 === this.min ? -1 === this.max : false) ? '*' : (1 === this.min ? -1 === this.max : false) ? '+' : -1 === this.max ? ' ' + this.min + '+' : ' ' + this.min + '..' + this.max;
    return '' + this.z1l_1 + mult;
  }
}
class SeparatedList {}
class SeparatedListDefault extends ListOfItemsAbstract {
  constructor(min_, max_, item, separator) {
    super(min_, max_);
    this.c1m_1 = item;
    this.d1m_1 = separator;
  }
  e1k() {
    return this.c1m_1;
  }
  e1m() {
    return this.d1m_1;
  }
  setOwningRule(rule, indices) {
    this._owningRule = rule;
    this.index = indices;
    var nextIndex = plus_2(indices, 0);
    this.c1m_1.setOwningRule(rule, nextIndex);
    this.d1m_1.setOwningRule(rule, nextIndex);
  }
  subItem(index) {
    var tmp0_subject = index;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = this.c1m_1;
        break;
      case 1:
        tmp = this.d1m_1;
        break;
      default:
        throw GrammarRuleItemNotFoundException.l1l('subitem ' + index + ' not found');
    }
    return tmp;
  }
  e1i() {
    return plus_0(this.c1m_1.allTerminal, this.d1m_1.allTerminal);
  }
  f1i() {
    return plus_0(this.c1m_1.allNonTerminal, this.d1m_1.allNonTerminal);
  }
  g1i() {
    return plus_0(this.c1m_1.allEmbedded, this.d1m_1.allEmbedded);
  }
  toString() {
    var mult = (0 === this.min ? 1 === this.max : false) ? '?' : (0 === this.min ? -1 === this.max : false) ? '*' : (1 === this.min ? -1 === this.max : false) ? '+' : -1 === this.max ? ' ' + this.min + '+' : ' ' + this.min + '..' + this.max;
    return '[' + this.c1m_1 + ' / ' + this.d1m_1 + ']' + mult;
  }
  get separator() {
    return this.e1m();
  }
}
class AglScopesCompletionProvider extends CompletionProviderAbstract {
  provide(nextExpected, context, options) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = nextExpected.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.agl.grammar.scopes.AglScopesCompletionProvider.provide.<anonymous>' call
      var tmp0_subject = element;
      var tmp;
      if (isInterface(tmp0_subject, Terminal)) {
        tmp = this.w18(element, context);
      } else {
        tmp = emptyList();
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
}
class AglScopesGrammar extends GrammarAbstract {
  constructor() {
    AglScopesGrammar_instance = null;
    super(new NamespaceDefault('net.akehurst.language.agl'), 'AglScopes');
    AglScopesGrammar_instance = this;
    this.r1m_1 = 'declarations';
    this.s1m_1 = listOf(new GrammarOptionDefault('defaultGoal', 'declarations'));
    this.t1m_1 = "\nnamespace net.akehurst.language.agl\ngrammar AglScopes {\n\n    skip WHITESPACE = \"\\s+\" ;\n    skip MULTI_LINE_COMMENT = \"/\\*[^*]*\\*+(?:[^*`/`][^*]*\\*+)*`/`\" ;\n    skip SINGLE_LINE_COMMENT = \"//[\\n\\r]*?\" ;\n\n    declarations = rootIdentifiables scopes references? ;\n    rootIdentifiables = identifiable* ;\n    scopes = scope* ;\n    scope = 'scope' typeReference '{' identifiables '}' ;\n    identifiables = identifiable* ;\n    identifiable = 'identify' typeReference 'by' propertyReferenceOrNothing ;\n\n    references = 'references' '{' referenceDefinitions '}' ;\n    referenceDefinitions = referenceDefinition* ;\n    referenceDefinition = 'in' typeReference '{' referenceExpression* '}' ;\n    referenceExpression = propertyReferenceExpression | collectionReferenceExpression ;\n    propertyReferenceExpression = 'property' propertyReference 'refers-to' typeReferences from ;\n    collectionReferenceExpression = 'forall' navigation '{' referenceExpression '}' ;\n    from = 'from' navigation ;\n    navigation = [propertyReference / '.']+ ;\n    typeReferences = [typeReference / '|']+ ;\n\n    propertyReferenceOrNothing = '\xA7nothing' | propertyReference ;\n    typeReference = IDENTIFIER ;     // same as grammar rule name\n    propertyReference = IDENTIFIER ; // same as grammar rule name\n    leaf IDENTIFIER = \"[a-zA-Z_][a-zA-Z_0-9-]*\" ;\n}\n    ";
    this.u1m_1 = "'scope' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'identify' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'by' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'references' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'in' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'property' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'refers-to' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'|' {\n  foreground: darkgreen;\n  font-style: bold;\n}";
    this.v1m_1 = '\n@TODO\nReferences -> when {\n    referenceDefinitions.isEmpty -> "references { }"\n    else -> "\n      references {\n        referenceDefinitions\n      }\n    "\n}\nReferenceDefinitions -> [referenceDefinition / \'\\n\']\nReferenceDefinition -> "in \xA7typeReference property \xA7propertyReference refers-to \xA7typeReferences"\n    ';
    this.grammarRule.k1(createRules_1(this));
  }
  s1c() {
    return this.s1m_1;
  }
  toString() {
    return "namespace net.akehurst.language.agl\ngrammar AglScopes {\n\n    skip WHITESPACE = \"\\s+\" ;\n    skip MULTI_LINE_COMMENT = \"/\\*[^*]*\\*+(?:[^*`/`][^*]*\\*+)*`/`\" ;\n    skip SINGLE_LINE_COMMENT = \"//[\\n\\r]*?\" ;\n\n    declarations = rootIdentifiables scopes references? ;\n    rootIdentifiables = identifiable* ;\n    scopes = scope* ;\n    scope = 'scope' typeReference '{' identifiables '}' ;\n    identifiables = identifiable* ;\n    identifiable = 'identify' typeReference 'by' propertyReferenceOrNothing ;\n\n    references = 'references' '{' referenceDefinitions '}' ;\n    referenceDefinitions = referenceDefinition* ;\n    referenceDefinition = 'in' typeReference '{' referenceExpression* '}' ;\n    referenceExpression = propertyReferenceExpression | collectionReferenceExpression ;\n    propertyReferenceExpression = 'property' propertyReference 'refers-to' typeReferences from ;\n    collectionReferenceExpression = 'forall' navigation '{' referenceExpression '}' ;\n    from = 'from' navigation ;\n    navigation = [propertyReference / '.']+ ;\n    typeReferences = [typeReference / '|']+ ;\n\n    propertyReferenceOrNothing = '\xA7nothing' | propertyReference ;\n    typeReference = IDENTIFIER ;     // same as grammar rule name\n    propertyReference = IDENTIFIER ; // same as grammar rule name\n    leaf IDENTIFIER = \"[a-zA-Z_][a-zA-Z_0-9-]*\" ;\n}";
  }
}
class AglScopesSemanticAnalyser {
  clear() {
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  w1m(asm, locationMap, context, options) {
    var tmp0_elvis_lhs = locationMap;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mapOf' call
      tmp$ret$0 = emptyMap();
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var locMap = tmp;
    var issues = new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance());
    if (!(null == context)) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = asm.scopes;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.iterator' call
      tmp$ret$1 = tmp0_forEach.l3().u();
      var tmp0_iterator = tmp$ret$1;
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.agl.grammar.scopes.AglScopesSemanticAnalyser.analyse.<anonymous>' call
        var tmp$ret$2;
        // Inline function 'kotlin.collections.component2' call
        tmp$ret$2 = element.p3();
        var scope = tmp$ret$2;
        var tmp_0;
        if (Companion_getInstance_17().ROOT_SCOPE_TYPE_NAME === scope.scopeFor) {
          tmp_0 = 'In root scope';
        } else {
          var tmp_1 = context.rootScope;
          Companion_getInstance_36();
          if (tmp_1.isMissing(scope.scopeFor, '$Type')) {
            var loc = locMap.u3(new PropertyValue(scope, 'typeReference'));
            issues.error(loc, "Type '" + scope.scopeFor + "' not found in scope");
          } else {
          }
          tmp_0 = "In scope for '" + scope.scopeFor + "'";
        }
        var msgStart = tmp_0;
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_forEach_0 = scope.identifiables;
        var tmp0_iterator_0 = tmp0_forEach_0.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          // Inline function 'net.akehurst.language.agl.agl.grammar.scopes.AglScopesSemanticAnalyser.analyse.<anonymous>.<anonymous>' call
          var typeScope = context.rootScope.childScopes.u3(element_0.typeName);
          if (null == typeScope) {
            var loc_0 = locMap.u3(new PropertyValue(element_0, 'typeReference'));
            issues.error(loc_0, "Type '" + element_0.typeName + "' not found in scope");
          } else if (Companion_getInstance_17().IDENTIFY_BY_NOTHING === element_0.propertyName)
          ;
          else {
            Companion_getInstance_36();
            if (typeScope.isMissing(element_0.propertyName, '$Property')) {
              var loc_1 = locMap.u3(new PropertyValue(element_0, 'propertyName'));
              issues.error(loc_1, msgStart + ", '" + element_0.propertyName + "' not found for identifying property of '" + element_0.typeName + "'");
            } else {
            }
          }
        }
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp1_forEach = asm.references;
      var tmp0_iterator_1 = tmp1_forEach.u();
      while (tmp0_iterator_1.h1()) {
        var element_1 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.agl.grammar.scopes.AglScopesSemanticAnalyser.analyse.<anonymous>' call
        var tmp_2 = context.rootScope;
        Companion_getInstance_36();
        if (tmp_2.isMissing(element_1.inTypeName, '$Type')) {
          var loc_2 = locMap.u3(new PropertyValue(element_1, 'in'));
          issues.error(loc_2, "Referring type '" + element_1.inTypeName + "' not found in scope");
        } else {
          var typeScope_0 = context.rootScope.childScopes.u3(element_1.inTypeName);
          if (null == typeScope_0) {
            var loc_3 = locMap.u3(new PropertyValue(element_1, 'propertyReference'));
            issues.error(loc_3, "Child scope '" + element_1.inTypeName + "' not found");
          } else {
            Companion_getInstance_36();
            if (typeScope_0.isMissing(element_1.referringPropertyName, '$Property')) {
              var loc_4 = locMap.u3(new PropertyValue(element_1, 'propertyReference'));
              issues.error(loc_4, "For reference in '" + element_1.inTypeName + "' referring property '" + element_1.referringPropertyName + "' not found");
            }
          }
        }
        // Inline function 'kotlin.collections.forEachIndexed' call
        var tmp0_forEachIndexed = element_1.refersToTypeName;
        var index = 0;
        var tmp0_iterator_2 = tmp0_forEachIndexed.u();
        while (tmp0_iterator_2.h1()) {
          var item = tmp0_iterator_2.j1();
          // Inline function 'net.akehurst.language.agl.agl.grammar.scopes.AglScopesSemanticAnalyser.analyse.<anonymous>.<anonymous>' call
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          var tmp1_anonymous = checkIndexOverflow(tmp1);
          var tmp_3 = context.rootScope;
          Companion_getInstance_36();
          if (tmp_3.isMissing(item, '$Type')) {
            var loc_5 = locMap.u3(new PropertyValue(element_1, 'typeReferences[' + tmp1_anonymous + ']'));
            issues.error(loc_5, "For reference in '" + element_1.inTypeName + "' referred to type '" + item + "' not found");
          }
        }
      }
    }
    return new SemanticAnalysisResultDefault(issues);
  }
  g1b(asm, locationMap, context, options) {
    var tmp = asm instanceof ScopeModelAgl ? asm : THROW_CCE();
    return this.w1m(tmp, locationMap, (context == null ? true : isInterface(context, SentenceContext)) ? context : THROW_CCE(), options);
  }
}
class PropertyValue {
  constructor(asmObject, value) {
    this.asmObject = asmObject;
    this.value = value;
  }
  x1m() {
    return this.asmObject;
  }
  p3() {
    return this.value;
  }
  ti() {
    return this.asmObject;
  }
  ui() {
    return this.value;
  }
  y1m(asmObject, value) {
    return new PropertyValue(asmObject, value);
  }
  copy(asmObject, value, $super) {
    asmObject = asmObject === VOID ? this.asmObject : asmObject;
    value = value === VOID ? this.value : value;
    return this.y1m(asmObject, value);
  }
  toString() {
    return 'PropertyValue(asmObject=' + toString(this.asmObject) + ', value=' + this.value + ')';
  }
  hashCode() {
    var result = hashCode(this.asmObject);
    result = imul(result, 31) + getStringHashCode(this.value) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertyValue))
      return false;
    var tmp0_other_with_cast = other instanceof PropertyValue ? other : THROW_CCE();
    if (!equals(this.asmObject, tmp0_other_with_cast.asmObject))
      return false;
    if (!(this.value === tmp0_other_with_cast.value))
      return false;
    return true;
  }
}
class AglScopesSyntaxAnalyser extends SyntaxAnalyserByMethodRegistrationAbstract {
  constructor() {
    super();
    this.d1n_1 = emptyMap();
  }
  registerHandlers() {
    super.register(AglScopesSyntaxAnalyser$declarations$ref(this));
    super.register(AglScopesSyntaxAnalyser$rootIdentifiables$ref(this));
    super.register(AglScopesSyntaxAnalyser$scopes$ref(this));
    super.register(AglScopesSyntaxAnalyser$scope$ref(this));
    super.register(AglScopesSyntaxAnalyser$identifiables$ref(this));
    super.register(AglScopesSyntaxAnalyser$identifiable$ref(this));
    super.register(AglScopesSyntaxAnalyser$referencesOpt$ref(this));
    super.register(AglScopesSyntaxAnalyser$references$ref(this));
    super.register(AglScopesSyntaxAnalyser$referenceDefinitions$ref(this));
    super.register(AglScopesSyntaxAnalyser$referenceDefinition$ref(this));
    super.register(AglScopesSyntaxAnalyser$typeReferences$ref(this));
    super.register(AglScopesSyntaxAnalyser$propertyReferenceOrNothing$ref(this));
    super.register(AglScopesSyntaxAnalyser$typeReference$ref(this));
    super.register(AglScopesSyntaxAnalyser$propertyReference$ref(this));
  }
  o1b() {
    return this.d1n_1;
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    this.ROOT_SCOPE_TYPE_NAME = '\xA7root';
    this.IDENTIFY_BY_NOTHING = '\xA7nothing';
  }
  e1n() {
    return this.ROOT_SCOPE_TYPE_NAME;
  }
  f1n() {
    return this.IDENTIFY_BY_NOTHING;
  }
  fromString(context, aglScopeModelSentence) {
    var tmp0_elvis_lhs = Agl_getInstance().registry.agl.scopes.processor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Scopes language not found!');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var proc = tmp;
    var tmp_0 = Agl_getInstance();
    return proc.process(aglScopeModelSentence, tmp_0.options(ScopeModelAgl$Companion$fromString$lambda(context)));
  }
}
class ScopeModel {}
class ScopeModelAgl {
  constructor() {
    Companion_getInstance_17();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.scopes = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.references = tmp$ret$1;
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.scopes;
    var tmp1_set = Companion_getInstance_17().ROOT_SCOPE_TYPE_NAME;
    var tmp2_set = new ScopeDefinition(Companion_getInstance_17().ROOT_SCOPE_TYPE_NAME);
    tmp0_set.m3(tmp1_set, tmp2_set);
  }
  g1n() {
    return this.scopes;
  }
  h1n() {
    return this.references;
  }
  isScopeDefinition(scopeFor) {
    return this.scopes.r3(scopeFor);
  }
  isReference(inTypeName, propertyName) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = this.references;
      var tmp;
      if (isInterface(tmp0_any, Collection)) {
        tmp = tmp0_any.y();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_any.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$1;
        // Inline function 'net.akehurst.language.agl.grammar.scopes.ScopeModelAgl.isReference.<anonymous>' call
        tmp$ret$1 = element.inTypeName === inTypeName ? element.referringPropertyName === propertyName : false;
        if (tmp$ret$1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  getReferablePropertyNameFor(scopeFor, typeName) {
    var scope = this.scopes.u3(scopeFor);
    var tmp0_safe_receiver = scope;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.identifiables;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp1_safe_receiver.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.grammar.scopes.ScopeModelAgl.getReferablePropertyNameFor.<anonymous>' call
          tmp$ret$0 = element.typeName === typeName;
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var identifiable = tmp;
    var tmp2_safe_receiver = identifiable;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.propertyName;
  }
  getReferredToTypeNameFor(inTypeName, referringPropertyName) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.references;
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.grammar.scopes.ScopeModelAgl.getReferredToTypeNameFor.<anonymous>' call
        tmp$ret$0 = element.inTypeName === inTypeName ? element.referringPropertyName === referringPropertyName : false;
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var def = tmp$ret$1;
    var tmp0_safe_receiver = def;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.refersToTypeName;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  shouldCreateReference(scopeFor, typeName) {
    return !(null == this.getReferablePropertyNameFor(scopeFor, typeName));
  }
  static get Companion() {
    return Companion_getInstance_17();
  }
}
class ScopeDefinition {
  constructor(scopeFor) {
    this.scopeFor = scopeFor;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.identifiables = tmp$ret$0;
  }
  i1n() {
    return this.scopeFor;
  }
  j1n() {
    return this.identifiables;
  }
  ti() {
    return this.scopeFor;
  }
  v1i(scopeFor) {
    return new ScopeDefinition(scopeFor);
  }
  copy(scopeFor, $super) {
    scopeFor = scopeFor === VOID ? this.scopeFor : scopeFor;
    return this.v1i(scopeFor);
  }
  toString() {
    return 'ScopeDefinition(scopeFor=' + this.scopeFor + ')';
  }
  hashCode() {
    return getStringHashCode(this.scopeFor);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeDefinition ? other : THROW_CCE();
    if (!(this.scopeFor === tmp0_other_with_cast.scopeFor))
      return false;
    return true;
  }
}
class Identifiable {
  constructor(typeName, propertyName) {
    this.typeName = typeName;
    this.propertyName = propertyName;
  }
  k1n() {
    return this.typeName;
  }
  l1n() {
    return this.propertyName;
  }
  ti() {
    return this.typeName;
  }
  ui() {
    return this.propertyName;
  }
  n1h(typeName, propertyName) {
    return new Identifiable(typeName, propertyName);
  }
  copy(typeName, propertyName, $super) {
    typeName = typeName === VOID ? this.typeName : typeName;
    propertyName = propertyName === VOID ? this.propertyName : propertyName;
    return this.n1h(typeName, propertyName);
  }
  toString() {
    return 'Identifiable(typeName=' + this.typeName + ', propertyName=' + this.propertyName + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.typeName);
    result = imul(result, 31) + getStringHashCode(this.propertyName) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Identifiable))
      return false;
    var tmp0_other_with_cast = other instanceof Identifiable ? other : THROW_CCE();
    if (!(this.typeName === tmp0_other_with_cast.typeName))
      return false;
    if (!(this.propertyName === tmp0_other_with_cast.propertyName))
      return false;
    return true;
  }
}
class ReferenceDefinition {
  constructor(inTypeName, referringPropertyName, refersToTypeName) {
    this.inTypeName = inTypeName;
    this.referringPropertyName = referringPropertyName;
    this.refersToTypeName = refersToTypeName;
  }
  m1n() {
    return this.inTypeName;
  }
  n1n() {
    return this.referringPropertyName;
  }
  o1n() {
    return this.refersToTypeName;
  }
  ti() {
    return this.inTypeName;
  }
  ui() {
    return this.referringPropertyName;
  }
  r1j() {
    return this.refersToTypeName;
  }
  p1n(inTypeName, referringPropertyName, refersToTypeName) {
    return new ReferenceDefinition(inTypeName, referringPropertyName, refersToTypeName);
  }
  copy(inTypeName, referringPropertyName, refersToTypeName, $super) {
    inTypeName = inTypeName === VOID ? this.inTypeName : inTypeName;
    referringPropertyName = referringPropertyName === VOID ? this.referringPropertyName : referringPropertyName;
    refersToTypeName = refersToTypeName === VOID ? this.refersToTypeName : refersToTypeName;
    return this.p1n(inTypeName, referringPropertyName, refersToTypeName);
  }
  toString() {
    return 'ReferenceDefinition(inTypeName=' + this.inTypeName + ', referringPropertyName=' + this.referringPropertyName + ', refersToTypeName=' + this.refersToTypeName + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.inTypeName);
    result = imul(result, 31) + getStringHashCode(this.referringPropertyName) | 0;
    result = imul(result, 31) + hashCode(this.refersToTypeName) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof ReferenceDefinition ? other : THROW_CCE();
    if (!(this.inTypeName === tmp0_other_with_cast.inTypeName))
      return false;
    if (!(this.referringPropertyName === tmp0_other_with_cast.referringPropertyName))
      return false;
    if (!equals(this.refersToTypeName, tmp0_other_with_cast.refersToTypeName))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.q1n_1 = ensureNotNull(ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).grammar).qualifiedName;
    this.r1n_1 = ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).typeModel;
    this.s1n_1 = ensureNotNull(ensureNotNull(Agl_getInstance().registry.agl.style.processor).grammar).qualifiedName;
    this.t1n_1 = ensureNotNull(Agl_getInstance().registry.agl.style.processor).typeModel;
    var tmp = this;
    var tmp0_elvis_lhs = _get_aglGrammarNamespace__uctayx(this).findTypeUsageForRule('grammarRule');
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1("Internal error: type for 'grammarRule' not found");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.u1n_1 = tmp_0;
  }
}
class AglStyleCompletionProvider {
  constructor() {
    Companion_getInstance_18();
  }
  provide(nextExpected, context, options) {
    var tmp;
    if (null == context) {
      tmp = emptyList();
    } else {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator = nextExpected.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.provide.<anonymous>' call
        tmp$ret$0 = provideForTerminalItem(this, element, context);
        var list = tmp$ret$0;
        addAll(tmp0_flatMapTo, list);
      }
      tmp$ret$1 = tmp0_flatMapTo;
      tmp$ret$2 = tmp$ret$1;
      var items = tmp$ret$2;
      tmp = items;
    }
    return tmp;
  }
}
class AglStyleGrammar extends GrammarAbstract {
  constructor() {
    AglStyleGrammar_instance = null;
    super(new NamespaceDefault('net.akehurst.language.agl'), 'AglStyle');
    AglStyleGrammar_instance = this;
    this.h1o_1 = 'rules';
    this.i1o_1 = listOf(new GrammarOptionDefault('defaultGoal', 'rules'));
    this.j1o_1 = 'META_IDENTIFIER {\n  foreground: orange;\n  font-style: bold;\n}\nIDENTIFIER {\n  foreground: blue;\n  font-style: bold;\n}\nLITERAL {\n  foreground: blue;\n  font-style: bold;\n}\nPATTERN {\n  foreground: darkblue;\n  font-style: bold;\n}\nSTYLE_ID {\n  foreground: darkred;\n  font-style: italic;\n}';
    this.k1o_1 = '\nreferences {\n    in scope property typeReference refers-to GrammarRule\n    in identifiable property typeReference refers-to GrammarRule\n    in referenceDefinition property typeReference refers-to GrammarRule\n    in referenceDefinition property propertyReference refers-to GrammarRule\n}\n    ';
    this.grammarRule.k1(createRules_2(this));
  }
  s1c() {
    return this.i1o_1;
  }
  toString() {
    return 'namespace net.akehurst.language.agl\ngrammar AglStyle {\n    skip WHITESPACE = "\\s+" ;\n\tskip SINGLE_LINE_COMMENT = "/\\*[^*]*\\*+([^*/][^*]*\\*+)*/" ;\n\tskip MULTI_LINE_COMMENT = "//[^\\n\\r]*" ;\n\n    rules = rule* ;\n    rule = selectorExpression \'{\' styleList \'}\' ;\n    selectorExpression\n     = selectorAndComposition\n     | selectorSingle\n     ; //TODO\n    selectorAndComposition = [selectorSingle /\',\']2+ ;\n    selectorSingle = LITERAL | PATTERN | IDENTIFIER | META_IDENTIFIER ;\n    styleList = style* ;\n    style = STYLE_ID \':\' STYLE_VALUE \';\' ;\n    \n    leaf LITERAL = "\'([^\'\\\\]|\\\\.)+\'" ;\n    leaf PATTERN = "\\"([^\\"\\\\]|\\\\.)+\\"" ;\n    leaf IDENTIFIER = "[a-zA-Z_][a-zA-Z_0-9-]*" ;\n    leaf META_IDENTIFIER = "[\\\\$][a-zA-Z_][a-zA-Z_0-9-]*" ;\n    leaf STYLE_ID = "[-a-zA-Z_][-a-zA-Z_0-9]*" ;\n    leaf STYLE_VALUE = "[^;: \\t\\n\\x0B\\f\\r]+" ;\n}';
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.l1o_1 = ensureNotNull(ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).grammar).qualifiedName;
    this.m1o_1 = ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).typeModel;
    var tmp = this;
    var tmp0_elvis_lhs = _get_aglGrammarNamespace__uctayx_0(this).findTypeUsageForRule('grammarRule');
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1("Internal error: type for 'grammarRule' not found");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.n1o_1 = tmp_0;
  }
}
class AglStyleSemanticAnalyser {
  constructor() {
    Companion_getInstance_19();
  }
  clear() {
  }
  configure(configurationContext, configuration) {
    return emptyList();
  }
  o1o(asm, locationMap, context, options) {
    var tmp0_elvis_lhs = locationMap;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mapOf' call
      tmp$ret$0 = emptyMap();
      tmp = tmp$ret$0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var locMap = tmp;
    var issues = new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance());
    if (!(null == context)) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = asm.rules;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleSemanticAnalyser.analyse.<anonymous>' call
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_forEach_0 = element.selector;
        var tmp0_iterator_0 = tmp0_forEach_0.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleSemanticAnalyser.analyse.<anonymous>.<anonymous>' call
          var loc = locMap.u3(element_0);
          var tmp0_subject = element_0.kind;
          var tmp0 = tmp0_subject.bc_1;
          switch (tmp0) {
            case 0:
              if (context.rootScope.isMissing(element_0.value, 'LITERAL')) {
                issues.error(loc, 'Terminal Literal ' + element_0.value + ' not found for style rule');
              }

              break;
            case 1:
              if (context.rootScope.isMissing(element_0.value, 'PATTERN')) {
                issues.error(loc, 'Terminal Pattern ' + element_0.value + ' not found for style rule');
              }

              break;
            case 2:
              Companion_getInstance_20();
              if ('$keyword' === element_0.value) {
              } else {
                if (context.rootScope.isMissing(element_0.value, Companion_getInstance_19().n1o_1.type.qualifiedName)) {
                  issues.error(loc, "Grammar Rule '" + element_0.value + "' not found for style rule");
                }
              }

              break;
            case 3:
              ;
              break;
          }
        }
      }
    }
    return new SemanticAnalysisResultDefault(issues);
  }
  g1b(asm, locationMap, context, options) {
    var tmp = isInterface(asm, AglStyleModel) ? asm : THROW_CCE();
    return this.o1o(tmp, locationMap, (context == null ? true : isInterface(context, SentenceContext)) ? context : THROW_CCE(), options);
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.KEYWORD_STYLE_ID = '$keyword';
  }
  p1o() {
    return this.KEYWORD_STYLE_ID;
  }
}
class AglStyleSyntaxAnalyser extends SyntaxAnalyserByMethodRegistrationAbstract {
  constructor() {
    Companion_getInstance_20();
    super();
    this.u1o_1 = emptyMap();
  }
  registerHandlers() {
    super.register(AglStyleSyntaxAnalyser$rules$ref(this));
    super.register(AglStyleSyntaxAnalyser$rule$ref(this));
    super.register(AglStyleSyntaxAnalyser$selectorExpression$ref(this));
    super.register(AglStyleSyntaxAnalyser$selectorAndComposition$ref(this));
    super.register(AglStyleSyntaxAnalyser$selectorSingle$ref(this));
    super.register(AglStyleSyntaxAnalyser$styleList$ref(this));
    super.register(AglStyleSyntaxAnalyser$style$ref(this));
  }
  o1b() {
    return this.u1o_1;
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
  v1o(nodeInfo, children, sentence) {
    return new AglStyleModelDefault(isInterface(children, List) ? children : THROW_CCE());
  }
  w1o(nodeInfo, children, sentence) {
    var tmp = children.p(0);
    var selector = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
    var rule = new AglStyleRule(selector);
    var tmp_0 = children.p(2);
    var styles = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = styles.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.style.AglStyleSyntaxAnalyser.rule.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = rule.styles;
      var tmp1_set = element.name;
      tmp0_set.m3(tmp1_set, element);
    }
    return rule;
  }
  x1o(nodeInfo, children, sentence) {
    var tmp0_subject = nodeInfo.alt.option;
    var tmp;
    switch (tmp0_subject) {
      case 0:
        var tmp_0 = children.p(0);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
        break;
      case 1:
        var tmp_1 = children.p(0);
        tmp = listOf(tmp_1 instanceof AglStyleSelector ? tmp_1 : THROW_CCE());
        break;
      default:
        throw IllegalStateException.y1("Internal error: alternative 'selectorExpression' not handled");
    }
    return tmp;
  }
  y1o(nodeInfo, children, sentence) {
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
    var tmp0_toSeparatedList = isInterface(children, List) ? children : THROW_CCE();
    tmp$ret$0 = ListSeparatedArrayList.u1f(tmp0_toSeparatedList);
    return tmp$ret$0.a11();
  }
  z1o(nodeInfo, children, sentence) {
    var isPattern = nodeInfo.node.rule.mz() === 'PATTERN';
    var tmp = children.p(0);
    var mt = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    var tmp_0;
    if (isPattern) {
      tmp_0 = replace(mt, '\\"', '"');
    } else {
      tmp_0 = replace(replace(mt, "\\'", "'"), '\\\\', '\\');
    }
    var value = tmp_0;
    var tmp0_subject = nodeInfo.alt.option;
    var tmp_1;
    switch (tmp0_subject) {
      case 0:
        tmp_1 = AglStyleSelectorKind_LITERAL_getInstance();
        break;
      case 1:
        tmp_1 = AglStyleSelectorKind_PATTERN_getInstance();
        break;
      case 2:
        tmp_1 = AglStyleSelectorKind_RULE_NAME_getInstance();
        break;
      case 3:
        tmp_1 = AglStyleSelectorKind_META_getInstance();
        break;
      default:
        throw IllegalStateException.y1('Internal error: AglStyleSelectorKind not handled');
    }
    var kind = tmp_1;
    return new AglStyleSelector(mt, kind);
  }
  a1p(nodeInfo, children, sentence) {
    return isInterface(children, List) ? children : THROW_CCE();
  }
  b1p(nodeInfo, children, sentence) {
    var tmp = children.p(0);
    var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    var tmp_0 = children.p(2);
    var value = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
    return new AglStyle(name, value);
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
  }
  fromString(context, aglStyleModelSentence) {
    var tmp0_elvis_lhs = Agl_getInstance().registry.agl.style.processor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Scopes language not found!');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var proc = tmp;
    var tmp_0 = Agl_getInstance();
    return proc.process(aglStyleModelSentence, tmp_0.options(AglStyleModelDefault$Companion$fromString$lambda(context)));
  }
}
class AglStyleModel {}
class AglStyleModelDefault {
  constructor(rules) {
    Companion_getInstance_21();
    this.c1p_1 = rules;
  }
  w1d() {
    return this.c1p_1;
  }
  toString() {
    return joinToString(this.c1p_1, '\n', VOID, VOID, VOID, VOID, AglStyleModelDefault$toString$lambda);
  }
  get rules() {
    return this.w1d();
  }
}
class sam$kotlin_Comparator$0_2 {
  constructor(function_0) {
    this.d1p_1 = function_0;
  }
  rc(a, b) {
    return this.d1p_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class GrammarTypeNamespaceSimple extends GrammarTypeNamespaceAbstract {
  constructor(qualifiedName, imports) {
    super(imports);
    this.k1p_1 = qualifiedName;
  }
  wl() {
    return this.k1p_1;
  }
  get qualifiedName() {
    return this.wl();
  }
  get allRuleNameToType() {
    return this.f1a();
  }
  get allTypesByRuleName() {
    return this.g1a();
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.l1p_1 = 10;
    this.m1p_1 = '\x03';
    this.n1p_1 = new Regex('\n', setOf(RegexOption_MULTILINE_getInstance()));
    this.o1p_1 = new CompleteTreeDataNode(Companion_getInstance_33().o13_1, -1, -1, -1, -1);
  }
  p1p(text) {
    var tmp = this.n1p_1.mb(text);
    return toList_1(map(tmp, InputFromString$Companion$eolPositions$lambda));
  }
}
class InputFromString {
  constructor(numTerminalRules, sentenceText) {
    Companion_getInstance_22();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.q1p_1 = tmp$ret$0;
    this.r1p_1 = new SentenceDefault(sentenceText);
    this.s1p_1 = new CompletedNodesStore(numTerminalRules, sentenceText.length + 1 | 0);
  }
  d1q(position) {
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.maxOf' call
    Companion_getInstance_22();
    var tmp0_maxOf = position - 10 | 0;
    tmp$ret$0 = Math.max(0, tmp0_maxOf);
    var startIndex = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.comparisons.minOf' call
    var tmp1_minOf = this.r1p_1.u1p().length;
    Companion_getInstance_22();
    var tmp2_minOf = position + 10 | 0;
    tmp$ret$1 = Math.min(tmp1_minOf, tmp2_minOf);
    var endIndex = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.text.substring' call
    var tmp3_substring = this.r1p_1.u1p();
    var tmp$ret$2;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$2 = tmp3_substring;
    tmp$ret$3 = tmp$ret$2.substring(startIndex, position);
    var forText = tmp$ret$3;
    var tmp$ret$5;
    // Inline function 'kotlin.text.substring' call
    var tmp4_substring = this.r1p_1.u1p();
    var tmp$ret$4;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$4 = tmp4_substring;
    tmp$ret$5 = tmp$ret$4.substring(position, endIndex);
    var aftText = tmp$ret$5;
    var startOfLine = lastIndexOfAny(forText, listOf_0(['\n', '\r']));
    var tmp;
    if (-1 === startOfLine) {
      tmp = 0;
    } else {
      tmp = startOfLine + 1 | 0;
    }
    var s = tmp;
    var tmp$ret$7;
    // Inline function 'kotlin.text.substring' call
    var tmp$ret$6;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$6 = forText;
    tmp$ret$7 = tmp$ret$6.substring(s);
    var forTextAfterLastEol = tmp$ret$7;
    var startOrStartOfLine = startIndex + startOfLine | 0;
    var prefix = startOfLine > 0 ? '' : startIndex > 0 ? '...' : '';
    var postFix = endIndex < this.r1p_1.u1p().length ? '...' : '';
    return prefix + forTextAfterLastEol + '^' + aftText + postFix;
  }
  e1q() {
    this.s1p_1.n1();
  }
  f1q(position) {
    return position >= this.r1p_1.u1p().length;
  }
  t1p(position, terminalRule) {
    var r = this.q1p_1.u3(new Pair(position, terminalRule));
    var tmp;
    if (!(null == r)) {
      tmp = r;
    } else {
      var rhs = terminalRule.i11();
      var tmp_0;
      if (this.f1q(position)) {
        tmp_0 = terminalRule.equals(Companion_getInstance_33().l13_1) ? true : false;
      } else {
        if (rhs instanceof RuntimeRuleRhsPattern) {
          tmp_0 = rhs.g1q().jb(this.r1p_1.u1p(), position);
        } else {
          if (rhs instanceof RuntimeRuleRhsLiteral) {
            tmp_0 = regionMatches(this.r1p_1.u1p(), position, rhs.n12_1, 0, rhs.n12_1.length);
          } else {
            throw IllegalStateException.y1('Internal Error: not handled');
          }
        }
      }
      var matched = tmp_0;
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.q1p_1;
      var tmp1_set = new Pair(position, terminalRule);
      tmp0_set.m3(tmp1_set, matched);
      tmp = matched;
    }
    return tmp;
  }
  v1p(position, terminalRule) {
    var rhs = terminalRule.i11();
    var tmp;
    if (this.f1q(position)) {
      tmp = terminalRule.equals(Companion_getInstance_33().l13_1) ? new MatchResult(Companion_getInstance_22().m1p_1, emptyList()) : null;
    } else {
      if (rhs instanceof RuntimeRuleRhsPattern) {
        tmp = matchRegEx2(this, position, rhs.g1q());
      } else {
        if (rhs instanceof RuntimeRuleRhsLiteral) {
          tmp = matchLiteral(this, position, terminalRule);
        } else {
          throw IllegalStateException.y1('Internal Error: not handled');
        }
      }
    }
    var matched = tmp;
    return matched;
  }
  h1q(terminalRuntimeRule, inputPosition) {
    var existing = this.s1p_1.i1q(terminalRuntimeRule, inputPosition);
    if (null == existing) {
      existing = tryCreateLeaf(this, terminalRuntimeRule, inputPosition);
    }
    var tmp;
    if (Companion_getInstance_22().o1p_1 === existing) {
      tmp = null;
    } else {
      tmp = existing;
    }
    return tmp;
  }
  j1q(startPosition, length) {
    return this.r1p_1.j1q(startPosition, length);
  }
}
class GrowArgs {
  constructor(buildTree, noLookahead, heightGraftOnly, nonEmptyWidthOnly, reportErrors, reportGrammarAmbiguities) {
    this.k1q_1 = buildTree;
    this.l1q_1 = noLookahead;
    this.m1q_1 = heightGraftOnly;
    this.n1q_1 = nonEmptyWidthOnly;
    this.o1q_1 = reportErrors;
    this.p1q_1 = reportGrammarAmbiguities;
  }
  toString() {
    return 'GrowArgs(buildTree=' + this.k1q_1 + ', noLookahead=' + this.l1q_1 + ', heightGraftOnly=' + this.m1q_1 + ', nonEmptyWidthOnly=' + this.n1q_1 + ', reportErrors=' + this.o1q_1 + ', reportGrammarAmbiguities=' + this.p1q_1 + ')';
  }
  hashCode() {
    var result = this.k1q_1 | 0;
    result = imul(result, 31) + (this.l1q_1 | 0) | 0;
    result = imul(result, 31) + (this.m1q_1 | 0) | 0;
    result = imul(result, 31) + (this.n1q_1 | 0) | 0;
    result = imul(result, 31) + (this.o1q_1 | 0) | 0;
    result = imul(result, 31) + (this.p1q_1 | 0) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GrowArgs))
      return false;
    var tmp0_other_with_cast = other instanceof GrowArgs ? other : THROW_CCE();
    if (!(this.k1q_1 === tmp0_other_with_cast.k1q_1))
      return false;
    if (!(this.l1q_1 === tmp0_other_with_cast.l1q_1))
      return false;
    if (!(this.m1q_1 === tmp0_other_with_cast.m1q_1))
      return false;
    if (!(this.n1q_1 === tmp0_other_with_cast.n1q_1))
      return false;
    if (!(this.o1q_1 === tmp0_other_with_cast.o1q_1))
      return false;
    if (!(this.p1q_1 === tmp0_other_with_cast.p1q_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    this.q1q_1 = new InputLocation(0, 0, 1, 0);
    this.r1q_1 = new GrowArgs(false, true, false, true, true, true);
    this.s1q_1 = new GrowArgs(false, true, true, false, false, true);
    this.t1q_1 = new GrowArgs(false, false, false, false, true, false);
  }
}
class sam$kotlin_Comparator$0_3 {
  constructor(function_0) {
    this.s1t_1 = function_0;
  }
  rc(a, b) {
    return this.s1t_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class sam$kotlin_Comparator$0_4 {
  constructor(function_0) {
    this.t1t_1 = function_0;
  }
  rc(a, b) {
    return this.t1t_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class RuntimeParser {
  constructor(stateSet, skipStateSet, cacheSkip, userGoalRule, input, _issues) {
    Companion_getInstance_23();
    this.d1r_1 = stateSet;
    this.e1r_1 = skipStateSet;
    this.f1r_1 = cacheSkip;
    this.g1r_1 = userGoalRule;
    this.h1r_1 = input;
    this.i1r_1 = _issues;
    this.j1r_1 = new ParseGraph(this.h1r_1, this.d1r_1.ru_1);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.listOf' call
    tmp$ret$0 = emptyList();
    tmp.k1r_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.l1r_1 = tmp$ret$1;
    this.m1r_1 = null;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.n1r_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp0_safe_receiver = this.e1r_1;
    var tmp_3;
    if (tmp0_safe_receiver == null) {
      tmp_3 = null;
    } else {
      var tmp$ret$4;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.skipParser.<anonymous>' call
      if (this.d1r_1.av_1) {
        this.e1r_1.eo();
      }
      tmp$ret$3 = new RuntimeParser(tmp0_safe_receiver, null, false, this.e1r_1.tu_1, new InputFromString(this.e1r_1.uw().o(), this.h1r_1.r1p_1.u1p()), this.i1r_1);
      tmp$ret$4 = tmp$ret$3;
      tmp_3 = tmp$ret$4;
    }
    tmp_2.o1r_1 = tmp_3;
    this.p1r_1 = 0;
  }
  e1q() {
    this.j1r_1.e1q();
  }
  l1t(startPosition, possibleEndOfText, parseArgs) {
    var gState = this.d1r_1.w14();
    var tmp;
    if (this.d1r_1.uu_1) {
      tmp = null;
    } else {
      var tmp$ret$7;
      // Inline function 'kotlin.collections.fold' call
      var tmp$ret$5;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = gState.yy_1;
      var tmp$ret$4;
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator = tmp0_flatMap.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$3;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.start.<anonymous>' call
        var tmp$ret$2;
        // Inline function 'kotlin.collections.map' call
        var tmp$ret$1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
        var tmp0_iterator_0 = possibleEndOfText.u();
        while (tmp0_iterator_0.h1()) {
          var item = tmp0_iterator_0.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.start.<anonymous>.<anonymous>' call
          tmp$ret$0 = this.d1r_1.ov_1.r11(element, item.q13());
          tmp0_mapTo.e1(tmp$ret$0);
        }
        tmp$ret$1 = tmp0_mapTo;
        tmp$ret$2 = tmp$ret$1;
        tmp$ret$3 = tmp$ret$2;
        var list = tmp$ret$3;
        addAll(tmp0_flatMapTo, list);
      }
      tmp$ret$4 = tmp0_flatMapTo;
      tmp$ret$5 = tmp$ret$4;
      var tmp1_fold = tmp$ret$5;
      var tmp2_fold = Companion_getInstance_8().xw_1;
      var accumulator = tmp2_fold;
      var tmp0_iterator_1 = tmp1_fold.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        var tmp$ret$6;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.start.<anonymous>' call
        var tmp3_anonymous = accumulator;
        tmp$ret$6 = tmp3_anonymous.iy(element_0);
        accumulator = tmp$ret$6;
      }
      tmp$ret$7 = accumulator;
      var skipLhsp = tmp$ret$7;
      var endOfSkipLookaheadSet = this.d1r_1.q15(skipLhsp);
      tmp = tryParseSkipUntilNone(this, setOf(endOfSkipLookaheadSet), startPosition, parseArgs);
    }
    var initialSkipData = tmp;
    var runtimeLookahead = possibleEndOfText;
    var gn = this.j1r_1.u1t(gState, startPosition, runtimeLookahead, initialSkipData);
  }
  v1t(message) {
    this.m1r_1 = message;
  }
  w1t() {
    var m = this.m1r_1;
    if (null == m) {
    } else {
      throw ParserTerminatedException.a1u(m);
    }
  }
  o1t(possibleEndOfText, growArgs) {
    this.l1r_1.n1();
    this.k1r_1 = this.j1r_1.b1u();
    var steps = 0;
    var progressSteps = lazyMutableMapNonNull(RuntimeParser$grow3$lambda);
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    var doneEmpties = tmp$ret$0;
    var currentNextInputPosition = this.j1r_1.c1u();
    while (this.j1r_1.d1u() ? this.j1r_1.c1u() <= currentNextInputPosition : false) {
      this.w1t();
      var graph = this.j1r_1;
      Debug_getInstance();
      if (false) {
        println('' + steps + ' --------------------------------------');
        println(graph);
      }
      var head = this.j1r_1.e1u();
      if (head.f1u() ? doneEmpties.w(new Pair(head.e1s(), graph.d1s(head))) : false) {
        this.j1r_1.c1s(head);
      } else {
        if (head.f1u()) {
          doneEmpties.e1(new Pair(head.e1s(), graph.d1s(head)));
        }
        growHead(this, head, possibleEndOfText, growArgs);
        var tmp0 = steps;
        steps = tmp0 + 1 | 0;
      }
      var progStep = progressSteps.u3(head);
      if (progStep > 1000) {
        Message_getInstance();
        this.v1t('The Parser has exceeded the configured number of non-progressing steps, self-terminated as it is likely it will never stop.');
      } else {
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = progStep + 1 | 0;
        progressSteps.m3(head, tmp0_set);
      }
    }
    return steps;
  }
  w1s(atPosition, runtimeLhs, lh, possibleEndOfText, growArgs) {
    var tmp;
    if (null == this.o1r_1) {
      tmp = null;
    } else {
      var tmp_0;
      if (lh.x11_1 ? true : lh.w11_1) {
        var tmp$ret$5;
        // Inline function 'kotlin.collections.flatMap' call
        var tmp$ret$4;
        // Inline function 'kotlin.collections.flatMapTo' call
        var tmp0_flatMapTo = ArrayList.i4();
        var tmp0_iterator = runtimeLhs.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$3;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.parseSkipIfAny.<anonymous>' call
          var tmp$ret$2;
          // Inline function 'kotlin.collections.map' call
          var tmp$ret$1;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
          var tmp0_iterator_0 = possibleEndOfText.u();
          while (tmp0_iterator_0.h1()) {
            var item = tmp0_iterator_0.j1();
            var tmp$ret$0;
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.parseSkipIfAny.<anonymous>.<anonymous>' call
            tmp$ret$0 = this.d1r_1.q15(lh.r13(item, element));
            tmp0_mapTo.e1(tmp$ret$0);
          }
          tmp$ret$1 = tmp0_mapTo;
          tmp$ret$2 = tmp$ret$1;
          tmp$ret$3 = tmp$ret$2;
          var list = tmp$ret$3;
          addAll(tmp0_flatMapTo, list);
        }
        tmp$ret$4 = tmp0_flatMapTo;
        tmp$ret$5 = tmp$ret$4;
        tmp_0 = toSet(tmp$ret$5);
      } else {
        tmp_0 = setOf(lh);
      }
      var skipLh = tmp_0;
      tmp = tryParseSkipUntilNone(this, skipLh, atPosition, growArgs);
    }
    return tmp;
  }
  g1u(possibleEndOfText, runtimeLookaheadSet, transition) {
    var tmp = first_0(transition.f15_1.lz()).i11();
    var embeddedRhs = tmp instanceof RuntimeRuleRhsEmbedded ? tmp : THROW_CCE();
    var embeddedRuntimeRuleSet = embeddedRhs.k11_1;
    var embeddedStartRule = embeddedRhs.l11_1;
    var embeddedS0 = embeddedRuntimeRuleSet.m11(embeddedStartRule.mz(), this.d1r_1.vu_1).w14();
    var embeddedSkipStateSet = embeddedRuntimeRuleSet.h1u();
    var embeddedParser = new RuntimeParser(embeddedS0.zy_1, embeddedSkipStateSet, this.f1r_1, embeddedStartRule, this.h1r_1, this.i1r_1);
    var tmp0_safe_receiver = this.e1r_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m15();
    var skipTerms = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
    var endingLookahead = first(transition.h15_1).t11_1;
    var embeddedPossibleEOT = endingLookahead.u13(embeddedS0.zy_1, skipTerms);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = runtimeLookaheadSet.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.createEmbeddedRuntimeParser.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
      var tmp0_iterator_0 = possibleEndOfText.u();
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.createEmbeddedRuntimeParser.<anonymous>.<anonymous>' call
        tmp$ret$0 = Companion_getInstance_5().v13(embeddedPossibleEOT.r13(item, element), embeddedS0.zy_1);
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    var embeddedEOT = toSet(tmp$ret$5);
    return new Pair(embeddedParser, embeddedEOT);
  }
  u1r(head, transition, possibleEndOfText, parseArgs) {
    var tmp;
    if (parseArgs.m1q_1) {
      tmp = false;
    } else {
      var tmp0_container = this.g1u(possibleEndOfText, head.u1q_1.r1r_1, transition);
      var embeddedParser = tmp0_container.ti();
      var embeddedEOT = tmp0_container.ui();
      var endingLookahead = first(transition.h15_1).t11_1;
      var startPosition = head.x1q_1;
      embeddedParser.l1t(startPosition, embeddedEOT, parseArgs);
      var seasons = 1;
      var maxNumHeads = embeddedParser.j1r_1.i1u();
      do {
        embeddedParser.o1t(embeddedEOT, parseArgs);
        var tmp1 = seasons;
        seasons = tmp1 + 1 | 0;
        var tmp$ret$0;
        // Inline function 'kotlin.math.max' call
        var tmp0_max = maxNumHeads;
        var tmp1_max = embeddedParser.j1r_1.i1u();
        tmp$ret$0 = Math.max(tmp0_max, tmp1_max);
        maxNumHeads = tmp$ret$0;
      }
       while (embeddedParser.j1r_1.n1t() ? embeddedParser.j1r_1.m1t().y() ? true : !embeddedParser.j1r_1.a1s_1 : false);
      var match = embeddedParser.j1r_1.z1r_1.q1t_1;
      var tmp_0;
      if (!(match.root == null)) {
        var embeddedS0 = embeddedParser.d1r_1.w14();
        var tmp2_safe_receiver = match.root;
        var ni = ensureNotNull(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e1t_1);
        var tmp$ret$6;
        // Inline function 'kotlin.collections.flatMap' call
        var tmp2_flatMap = head.u1q_1.r1r_1;
        var tmp$ret$5;
        // Inline function 'kotlin.collections.flatMapTo' call
        var tmp0_flatMapTo = ArrayList.i4();
        var tmp0_iterator = tmp2_flatMap.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$4;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doEmbedded.<anonymous>' call
          var tmp$ret$3;
          // Inline function 'kotlin.collections.map' call
          var tmp$ret$2;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
          var tmp0_iterator_0 = possibleEndOfText.u();
          while (tmp0_iterator_0.h1()) {
            var item = tmp0_iterator_0.j1();
            var tmp$ret$1;
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doEmbedded.<anonymous>.<anonymous>' call
            tmp$ret$1 = Companion_getInstance_5().v13(endingLookahead.r13(item, element), embeddedS0.zy_1);
            tmp0_mapTo.e1(tmp$ret$1);
          }
          tmp$ret$2 = tmp0_mapTo;
          tmp$ret$3 = tmp$ret$2;
          tmp$ret$4 = tmp$ret$3;
          var list = tmp$ret$4;
          addAll(tmp0_flatMapTo, list);
        }
        tmp$ret$5 = tmp0_flatMapTo;
        tmp$ret$6 = tmp$ret$5;
        var skipLh = toSet(tmp$ret$6);
        var skipData = tryParseSkipUntilNone(this, skipLh, ni, parseArgs);
        Debug_getInstance();
        if (false) {
          var tmp_1 = Debug_getInstance();
          var tmp_2 = IndentDelta_NONE_getInstance();
          tmp_1.uz(tmp_2, RuntimeParser$doEmbedded$lambda(head, transition));
        }
        tmp_0 = this.j1r_1.j1u(head, transition.f15_1, head.u1q_1.r1r_1, startPosition, ni, match, skipData);
      } else {
        recordFailedEmbedded(this, parseArgs, head.x1q_1, transition, embeddedParser.l1r_1);
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
}
class ScanOnDemandParser {
  constructor(runtimeRuleSet) {
    this.k1u_1 = runtimeRuleSet;
    this.l1u_1 = null;
    this.m1u_1 = new IssueHolder(LanguageProcessorPhase_PARSE_getInstance());
  }
  v1t(message) {
    var tmp0_safe_receiver = this.l1u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.v1t(message);
    }
  }
  x1u(goalRuleName, automatonKind) {
    this.k1u_1.y1u(goalRuleName, automatonKind);
  }
  z1u(sentence, options) {
    // Inline function 'kotlin.check' call
    var tmp0_check = sentence.length < IntCompanionObject_getInstance().MAX_VALUE;
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp0_check) {
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.parse.<anonymous>' call
      tmp$ret$0 = 'The parser can only handle a max sentence size < ' + IntCompanionObject_getInstance().MAX_VALUE + ' characters, requested size was ' + sentence.length;
      var message = tmp$ret$0;
      throw IllegalStateException.y1(toString(message));
    }
    var tmp0_elvis_lhs = options.goalRuleName;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Must define a goal rule in options');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var goalRuleName = tmp;
    var automatonKind = options.automatonKind;
    var reportErrors = options.reportErrors;
    var reportGrammarAmbiguities = options.reportGrammarAmbiguities;
    var cacheSkip = options.cacheSkip;
    this.m1u_1.clear();
    var input = new InputFromString(this.k1u_1.a1v().o(), sentence);
    var rp = createRuntimeParser(this, goalRuleName, input, automatonKind, cacheSkip);
    this.l1u_1 = rp;
    var possibleEndOfText = setOf(Companion_getInstance_4().f12_1);
    var parseArgs = new GrowArgs(true, false, false, false, reportErrors, reportGrammarAmbiguities);
    rp.l1t(0, possibleEndOfText, parseArgs);
    var seasons = 1;
    var maxNumHeads = rp.j1r_1.i1u();
    var totalWork = maxNumHeads;
    while (rp.j1r_1.d1u() ? rp.j1r_1.m1t().y() ? true : !rp.j1r_1.a1s_1 : false) {
      Debug_getInstance();
      if (false) {
        println('' + seasons + ' ===================================');
      }
      var steps = rp.o1t(possibleEndOfText, parseArgs);
      seasons = seasons + steps | 0;
      var tmp$ret$1;
      // Inline function 'kotlin.math.max' call
      var tmp1_max = maxNumHeads;
      var tmp2_max = rp.j1r_1.i1u();
      tmp$ret$1 = Math.max(tmp1_max, tmp2_max);
      maxNumHeads = tmp$ret$1;
      totalWork = totalWork + rp.j1r_1.i1u() | 0;
    }
    var tmp_0 = rp.j1r_1.z1r_1.q1t_1;
    var match = tmp_0 instanceof TreeDataComplete ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (!(match.root == null)) {
      var sppt = new SPPTFromTreeData(match, input.r1p_1, seasons, maxNumHeads);
      tmp_1 = new ParseResultDefault(sppt, this.m1u_1);
    } else {
      var nextExpected = findNextExpectedAfterError3(this, input, rp.l1r_1, rp.d1r_1.vu_1, rp.d1r_1);
      addParseIssue(this, input, rp, nextExpected, seasons, maxNumHeads);
      var sppt_0 = null;
      tmp_1 = new ParseResultDefault(sppt_0, this.m1u_1);
    }
    return tmp_1;
  }
  b1v(sentence, position, options) {
    var tmp0_elvis_lhs = options.goalRuleName;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('Must define a goal rule in options');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var goalRuleName = tmp;
    var automatonKind = options.automatonKind;
    var cacheSkip = options.cacheSkip;
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = sentence;
    tmp$ret$1 = tmp$ret$0.substring(0, position);
    var usedText = tmp$ret$1;
    var input = new InputFromString(this.k1u_1.a1v().o(), usedText);
    var rp = createRuntimeParser(this, goalRuleName, input, automatonKind, cacheSkip);
    this.l1u_1 = rp;
    var possibleEndOfText = setOf(Companion_getInstance_4().f12_1);
    var parseArgs = Companion_getInstance_23().t1q_1;
    rp.l1t(0, possibleEndOfText, parseArgs);
    var seasons = 1;
    while (rp.j1r_1.n1t() ? rp.j1r_1.m1t().y() ? true : !rp.j1r_1.a1s_1 : false) {
      rp.o1t(possibleEndOfText, parseArgs);
      var tmp1 = seasons;
      seasons = tmp1 + 1 | 0;
    }
    var tmp_0;
    if (rp.l1r_1.y()) {
      tmp_0 = emptySet();
    } else {
      var nextExpected = findNextExpectedAfterError3(this, input, rp.l1r_1, rp.d1r_1.vu_1, rp.d1r_1);
      tmp_0 = nextExpected.si_1;
    }
    return tmp_0;
  }
  c1v(sentence, position, options) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this.b1v(sentence, position, options);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.expectedTerminalsAt.<anonymous>' call
      tmp$ret$0 = element.s10() ? listOf(element) : emptyList();
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  }
}
class sam$kotlin_Comparator$0_5 {
  constructor(function_0) {
    this.d1v_1 = function_0;
  }
  rc(a, b) {
    return this.d1v_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class Scanner {
  constructor(runtimeRuleSet) {
    this.f1v_1 = runtimeRuleSet;
  }
  g1v(inputText, includeSkipRules) {
    var undefined_0 = Companion_getInstance_33().o13_1;
    var input = new InputFromString(this.f1v_1.a1v().o(), inputText);
    var terminals = includeSkipRules ? this.f1v_1.a1v() : this.f1v_1.h1v();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var result = tmp$ret$0;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = terminals;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$1;
      // Inline function 'net.akehurst.language.agl.agl.parser.Scanner.scan.<anonymous>' call
      tmp$ret$1 = !element.q11();
      if (tmp$ret$1) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$2 = tmp0_filterTo;
    tmp$ret$3 = tmp$ret$2;
    terminals = tmp$ret$3;
    var startPosition = 0;
    var nextInputPosition = 0;
    var currentUndefinedText = '';
    var currentUndefinedStart = -1;
    while (!input.f1q(nextInputPosition)) {
      var tmp$ret$7;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp1_mapNotNull = terminals;
      var tmp$ret$6;
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var tmp0_mapNotNullTo = ArrayList.i4();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = tmp1_mapNotNull.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.agl.agl.parser.Scanner.scan.<anonymous>' call
        var match = input.v1p(nextInputPosition, element_0);
        var tmp;
        if (null == match) {
          tmp = null;
        } else {
          var ni = nextInputPosition + match.matchedText.length | 0;
          var loc = input.j1q(startPosition, ni - startPosition | 0);
          var matchedText = match.matchedText;
          tmp = new LeafData(element_0.mz(), element_0.r12(), loc, matchedText, emptyList());
        }
        tmp$ret$4 = tmp;
        var tmp0_safe_receiver = tmp$ret$4;
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp$ret$5;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
          tmp$ret$5 = Unit_getInstance();
        }
      }
      tmp$ret$6 = tmp0_mapNotNullTo;
      tmp$ret$7 = tmp$ret$6;
      var matches = tmp$ret$7;
      var tmp_0 = Scanner$scan$lambda;
      var longest = maxWithOrNull(matches, new sam$kotlin_Comparator$0_5(tmp_0));
      if (null == longest ? true : longest.location.length === 0) {
        var text = toString_0(charSequenceGet(inputText, nextInputPosition));
        if (-1 === currentUndefinedStart) {
          currentUndefinedStart = nextInputPosition;
        }
        currentUndefinedText = currentUndefinedText + text;
        nextInputPosition = nextInputPosition + 1 | 0;
      } else {
        if (!(-1 === currentUndefinedStart)) {
          var loc_0 = input.j1q(currentUndefinedStart, currentUndefinedText.length);
          var ud = new LeafData(undefined_0.mz(), false, loc_0, currentUndefinedText, emptyList());
          result.e1(ud);
          currentUndefinedStart = -1;
          currentUndefinedText = '';
        }
        result.e1(longest);
        nextInputPosition = nextInputPosition + longest.location.length | 0;
      }
      startPosition = nextInputPosition;
    }
    if (!(-1 === currentUndefinedStart)) {
      var loc_1 = input.j1q(currentUndefinedStart, currentUndefinedText.length);
      var ud_0 = new LeafData(undefined_0.mz(), false, loc_1, currentUndefinedText, emptyList());
      result.e1(ud_0);
    }
    return result;
  }
}
class SentenceDefault {
  constructor(text) {
    this.i1v_1 = text;
    var tmp = this;
    tmp.j1v_1 = lazy(SentenceDefault$_eolPositions$delegate$lambda(this));
  }
  u1p() {
    return this.i1v_1;
  }
  k1v(node) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.i1v_1;
    var tmp1_substring = node.startPosition;
    var tmp2_substring = node.nextInputNoSkip;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_substring;
    tmp$ret$1 = tmp$ret$0.substring(tmp1_substring, tmp2_substring);
    return tmp$ret$1;
  }
  j1q(position, length) {
    var tmp;
    if (0 === position) {
      tmp = new InputLocation(position, 1, 1, length);
    } else if (_get__eolPositions__1oecae(this).y()) {
      tmp = new InputLocation(position, position + 1 | 0, 1, length);
    } else {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_filter = _get__eolPositions__1oecae(this);
      var tmp$ret$1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList.i4();
      var tmp0_iterator = tmp0_filter.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.agl.parser.SentenceDefault.locationFor.<anonymous>' call
        tmp$ret$0 = element < position;
        if (tmp$ret$0) {
          tmp0_filterTo.e1(element);
        }
      }
      tmp$ret$1 = tmp0_filterTo;
      tmp$ret$2 = tmp$ret$1;
      var line = tmp$ret$2.o();
      var col = 0 === line ? position + 1 | 0 : position - _get__eolPositions__1oecae(this).p(line - 1 | 0) | 0;
      tmp = new InputLocation(position, col, line + 1 | 0, length);
    }
    return tmp;
  }
  v1f(node) {
    return this.j1q(node.startPosition, node.nextInputNoSkip - node.startPosition | 0);
  }
}
class FailedParseReason {
  constructor(position, transition) {
    this.h1t_1 = position;
    this.i1t_1 = transition;
  }
}
class FailedParseReasonWidthTo extends FailedParseReason {}
class FailedParseReasonGraftRTG extends FailedParseReason {
  constructor(position, transition, prevNumNonSkipChildren) {
    super(position, transition);
    this.w1u_1 = prevNumNonSkipChildren;
  }
}
class FailedParseReasonLookahead extends FailedParseReason {
  constructor(position, transition, runtimeLhs, possibleEndOfText) {
    super(position, transition);
    this.s1u_1 = runtimeLhs;
    this.t1u_1 = possibleEndOfText;
  }
}
class FailedParseReasonEmbedded extends FailedParseReason {
  constructor(position, transition, embededFailedParseReasons) {
    super(position, transition);
    this.p1u_1 = embededFailedParseReasons;
  }
}
class Agl_0 {
  constructor() {
    Agl_instance = this;
    this.version = '4.0.0-1.9.20-Beta';
    this.buildStamp = '2023-09-29T10:52:17.72021Z[UTC]';
    this.registry = new LanguageRegistryDefault();
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  l1v() {
    return this.registry;
  }
  configurationEmpty() {
    return new LanguageProcessorConfigurationDefault(null, null, null, null, null, null, null, null, null);
  }
  configurationDefault() {
    var tmp = Agl_getInstance();
    return tmp.configuration(VOID, Agl$configurationDefault$lambda);
  }
  parseOptions(init) {
    var b = new ParseOptionsBuilder();
    init(b);
    return b.build();
  }
  options(init) {
    var b = new ProcessOptionsBuilder();
    init(b);
    return b.build();
  }
  m1v(base, init) {
    var b = new LanguageProcessorConfigurationBuilder(base);
    init(b);
    return b.build();
  }
  configuration(base, init, $super) {
    base = base === VOID ? null : base;
    return this.m1v(base, init);
  }
  n1v(grammar, configuration) {
    var tmp0_elvis_lhs = configuration;
    var config = tmp0_elvis_lhs == null ? this.configurationEmpty() : tmp0_elvis_lhs;
    return new LanguageProcessorDefault(grammar, config);
  }
  processorFromGrammar(grammar, configuration, $super) {
    configuration = configuration === VOID ? null : configuration;
    return this.n1v(grammar, configuration);
  }
  o1v(grammarDefinitionStr, scopeModelStr, styleModelStr, formatterModelStr, grammarAglOptions) {
    var tmp = Agl_getInstance();
    var tmp_0 = Agl_getInstance().configurationDefault();
    var config = tmp.configuration(tmp_0, Agl$processorFromStringDefault$lambda(scopeModelStr, styleModelStr, formatterModelStr));
    var proc = this.processorFromString(grammarDefinitionStr, config, grammarAglOptions);
    return proc;
  }
  processorFromStringDefault(grammarDefinitionStr, scopeModelStr, styleModelStr, formatterModelStr, grammarAglOptions, $super) {
    scopeModelStr = scopeModelStr === VOID ? null : scopeModelStr;
    styleModelStr = styleModelStr === VOID ? null : styleModelStr;
    formatterModelStr = formatterModelStr === VOID ? null : formatterModelStr;
    grammarAglOptions = grammarAglOptions === VOID ? null : grammarAglOptions;
    return this.o1v(grammarDefinitionStr, scopeModelStr, styleModelStr, formatterModelStr, grammarAglOptions);
  }
  p1v(grammarDefinitionStr, configuration, aglOptions) {
    var tmp;
    try {
      var tmp_0 = Agl_getInstance();
      var tmp0_elvis_lhs = aglOptions;
      var res = tmp_0.grammarFromString(grammarDefinitionStr, tmp0_elvis_lhs == null ? ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).optionsDefault() : tmp0_elvis_lhs);
      var tmp_1;
      if (null == res.asm ? true : 0 === ensureNotNull(res.asm).o()) {
        tmp_1 = new LanguageProcessorResult(null, res.issues);
      } else {
        var tmp_2;
        var tmp1_safe_receiver = configuration;
        if (null == (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.targetGrammarName)) {
          var tmp2_safe_receiver = res.asm;
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : lastOrNull(tmp2_safe_receiver);
          var tmp_3;
          if (tmp3_elvis_lhs == null) {
            var tmp0_error = 'Unable to create processor for ' + grammarDefinitionStr;
            throw IllegalStateException.y1(toString(tmp0_error));
          } else {
            tmp_3 = tmp3_elvis_lhs;
          }
          tmp_2 = tmp_3;
        } else {
          var tmp4_safe_receiver = res.asm;
          var tmp_4;
          if (tmp4_safe_receiver == null) {
            tmp_4 = null;
          } else {
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var tmp0_iterator = tmp4_safe_receiver.u();
              while (tmp0_iterator.h1()) {
                var element = tmp0_iterator.j1();
                var tmp$ret$0;
                // Inline function 'net.akehurst.language.agl.processor.Agl.processorFromString.<anonymous>' call
                tmp$ret$0 = element.name === configuration.targetGrammarName;
                if (tmp$ret$0) {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            tmp_4 = tmp$ret$1;
          }
          var tmp5_elvis_lhs = tmp_4;
          var tmp_5;
          if (tmp5_elvis_lhs == null) {
            var tmp1_error = "Unable to find target grammar '" + configuration.targetGrammarName + "' in " + grammarDefinitionStr;
            throw IllegalStateException.y1(toString(tmp1_error));
          } else {
            tmp_5 = tmp5_elvis_lhs;
          }
          tmp_2 = tmp_5;
        }
        var grammar = tmp_2;
        var proc = this.processorFromGrammar(grammar, configuration);
        tmp_1 = new LanguageProcessorResult(proc, res.issues);
      }
      tmp = tmp_1;
    } catch ($p) {
      var tmp_6;
      if ($p instanceof Error) {
        var e = $p;
        throw LanguageProcessorException.s1v('Unable to create processor for grammarDefinitionStr: ' + e.message, e);
      } else {
        throw $p;
      }
      tmp = tmp_6;
    }
    return tmp;
  }
  processorFromString(grammarDefinitionStr, configuration, aglOptions, $super) {
    configuration = configuration === VOID ? null : configuration;
    aglOptions = aglOptions === VOID ? null : aglOptions;
    return this.p1v(grammarDefinitionStr, configuration, aglOptions);
  }
  processorFromGeneratedCode(generated) {
    return new LanguageProcessorFromGenerated(generated);
  }
  fromString(proc, aglOptions, sentence) {
    return proc.process(sentence, aglOptions);
  }
  t1v(sentence, aglOptions) {
    var tmp;
    if (null == sentence) {
      tmp = new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
    } else {
      var res = ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).process(sentence, aglOptions);
      var tmp0_elvis_lhs = res.asm;
      tmp = new ProcessResultDefault(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, res.issues);
    }
    return tmp;
  }
  grammarFromString(sentence, aglOptions, $super) {
    aglOptions = aglOptions === VOID ? null : aglOptions;
    return this.t1v(sentence, aglOptions);
  }
}
class FormatterAbstract {}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($grammar, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.v1v_1 = this$0;
    super($grammar, $box);
  }
  w1v(property, oldValue, newValue) {
    var tmp;
    if (!(oldValue === newValue)) {
      this.v1v_1._processor_cache.e1q();
      var tmp0_forEach = this.v1v_1.grammarObservers;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract.grammar$delegate.<anonymous>.<anonymous>' call
        element(oldValue, newValue);
      }
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : isInterface(oldValue, Grammar)) ? oldValue : THROW_CCE();
    return this.w1v(property, tmp, (newValue == null ? true : isInterface(newValue, Grammar)) ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_0 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.u1w_1 = this$0;
    super($tmp1_observable, $box);
  }
  v1w(property, oldValue, newValue) {
    var tmp;
    if (!(oldValue == newValue)) {
      this.u1w_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'string') ? oldValue : THROW_CCE();
    return this.v1w(property, tmp, (newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_1 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.x1w_1 = this$0;
    super($tmp1_observable, $box);
  }
  v1w(property, oldValue, newValue) {
    var tmp;
    if (!(oldValue == newValue)) {
      this.x1w_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'string') ? oldValue : THROW_CCE();
    return this.v1w(property, tmp, (newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_2 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.z1w_1 = this$0;
    super($tmp1_observable, $box);
  }
  a1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.z1w_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.a1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_3 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.c1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  d1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.c1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.d1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_4 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.f1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  g1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.f1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.g1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_5 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.i1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  j1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.i1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.j1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_6 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.l1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  m1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.l1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.m1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_7 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.o1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  p1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.o1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.p1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_8 extends ObservableProperty {
  constructor($tmp1_observable, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.r1x_1 = this$0;
    super($tmp1_observable, $box);
  }
  s1x(property, oldValue, newValue) {
    var tmp;
    if (!equals(oldValue, newValue)) {
      this.r1x_1._processor_cache.e1q();
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'function') ? oldValue : THROW_CCE();
    return this.s1x(property, tmp, (newValue == null ? true : typeof newValue === 'function') ? newValue : THROW_CCE());
  }
}
class LanguageDefinition {}
class LanguageDefinitionAbstract {
  constructor(grammar, buildForDefaultGoal, initialConfiguration) {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable = Delegates_getInstance();
    tmp$ret$0 = new _no_name_provided__qut3iv(grammar, this);
    tmp.x1v_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_0 = Delegates_getInstance();
    var tmp1_observable = initialConfiguration.targetGrammarName;
    tmp$ret$1 = new _no_name_provided__qut3iv_0(tmp1_observable, this);
    tmp_0.y1v_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_1 = Delegates_getInstance();
    var tmp1_observable_0 = initialConfiguration.defaultGoalRuleName;
    tmp$ret$2 = new _no_name_provided__qut3iv_1(tmp1_observable_0, this);
    tmp_1.z1v_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$3 = ArrayList.i4();
    tmp_2.a1w_1 = tmp$ret$3;
    var tmp_3 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$4 = ArrayList.i4();
    tmp_3.b1w_1 = tmp$ret$4;
    var tmp_4 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$5 = ArrayList.i4();
    tmp_4.c1w_1 = tmp$ret$5;
    var tmp_5 = this;
    var tmp$ret$6;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$6 = ArrayList.i4();
    tmp_5.d1w_1 = tmp$ret$6;
    var tmp_6 = this;
    var tmp$ret$7;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$7 = ArrayList.i4();
    tmp_6.e1w_1 = tmp$ret$7;
    var tmp_7 = this;
    var tmp$ret$8;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$8 = ArrayList.i4();
    tmp_7.f1w_1 = tmp$ret$8;
    var tmp_8 = this;
    var tmp$ret$9;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$9 = ArrayList.i4();
    tmp_8.g1w_1 = tmp$ret$9;
    var tmp_9 = this;
    var tmp$ret$10;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$10 = ArrayList.i4();
    tmp_9.h1w_1 = tmp$ret$10;
    var tmp_10 = this;
    var tmp$ret$11;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$11 = ArrayList.i4();
    tmp_10.i1w_1 = tmp$ret$11;
    var tmp_11 = this;
    var tmp$ret$12;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = cached(LanguageDefinitionAbstract$_processor_cache$lambda(this, buildForDefaultGoal));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract._processor_cache.<anonymous>' call
    var tmp_12 = tmp0_apply;
    tmp_12.s1w_1 = LanguageDefinitionAbstract$_processor_cache$lambda_0(this);
    tmp$ret$12 = tmp0_apply;
    tmp_11._processor_cache = tmp$ret$12;
    this._issues = new IssueHolder(LanguageProcessorPhase_ALL_getInstance());
    this._style = null;
    var tmp_13 = this;
    var tmp$ret$13;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_2 = Delegates_getInstance();
    var tmp1_observable_1 = initialConfiguration.scopeModelResolver;
    tmp$ret$13 = new _no_name_provided__qut3iv_2(tmp1_observable_1, this);
    tmp_13.j1w_1 = tmp$ret$13;
    var tmp_14 = this;
    var tmp$ret$14;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_3 = Delegates_getInstance();
    var tmp1_observable_2 = initialConfiguration.typeModelResolver;
    tmp$ret$14 = new _no_name_provided__qut3iv_3(tmp1_observable_2, this);
    tmp_14.k1w_1 = tmp$ret$14;
    var tmp_15 = this;
    var tmp$ret$15;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_4 = Delegates_getInstance();
    var tmp1_observable_3 = initialConfiguration.syntaxAnalyserResolver;
    tmp$ret$15 = new _no_name_provided__qut3iv_4(tmp1_observable_3, this);
    tmp_15.l1w_1 = tmp$ret$15;
    var tmp_16 = this;
    var tmp$ret$16;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_5 = Delegates_getInstance();
    var tmp1_observable_4 = initialConfiguration.semanticAnalyserResolver;
    tmp$ret$16 = new _no_name_provided__qut3iv_5(tmp1_observable_4, this);
    tmp_16.m1w_1 = tmp$ret$16;
    var tmp_17 = this;
    var tmp$ret$17;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_6 = Delegates_getInstance();
    var tmp1_observable_5 = initialConfiguration.formatterResolver;
    tmp$ret$17 = new _no_name_provided__qut3iv_6(tmp1_observable_5, this);
    tmp_17.n1w_1 = tmp$ret$17;
    var tmp_18 = this;
    var tmp$ret$18;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_7 = Delegates_getInstance();
    var tmp1_observable_6 = initialConfiguration.styleResolver;
    tmp$ret$18 = new _no_name_provided__qut3iv_7(tmp1_observable_6, this);
    tmp_18.o1w_1 = tmp$ret$18;
    var tmp_19 = this;
    var tmp$ret$19;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_8 = Delegates_getInstance();
    var tmp1_observable_7 = initialConfiguration.completionProvider;
    tmp$ret$19 = new _no_name_provided__qut3iv_8(tmp1_observable_7, this);
    tmp_19.p1w_1 = tmp$ret$19;
  }
  v1x(_set____db54di) {
    return this.x1v_1.ck(this, grammar$factory(), _set____db54di);
  }
  u1g() {
    return this.x1v_1.ak(this, grammar$factory_0());
  }
  x1x(_set____db54di) {
    return this.y1v_1.ck(this, targetGrammarName$factory(), _set____db54di);
  }
  y1x() {
    return this.y1v_1.ak(this, targetGrammarName$factory_0());
  }
  z1x(_set____db54di) {
    return this.z1v_1.ck(this, defaultGoalRule$factory(), _set____db54di);
  }
  a1y() {
    return this.z1v_1.ak(this, defaultGoalRule$factory_0());
  }
  d1y(value) {
    var tmp0_safe_receiver = this.processor;
    var oldValue = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scopeModel;
    if (!equals(oldValue, value)) {
      this._scopeModelResolver = LanguageDefinitionAbstract$_set_scopeModel_$lambda_vpsoum(value);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = this.scopeModelObservers;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract.<set-scopeModel>.<anonymous>' call
        element(oldValue, value);
      }
    }
  }
  r1b() {
    var tmp0_safe_receiver = this.processor;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.scopeModel;
  }
  e1y() {
    var tmp0_safe_receiver = this.processor;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.syntaxAnalyser;
  }
  f1y() {
    var tmp0_safe_receiver = this.processor;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.semanticAnalyser;
  }
  g1y() {
    var tmp0_safe_receiver = this.processor;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.formatter;
  }
  h1y() {
    return this._processor_cache.p3();
  }
  w1b() {
    return this._issues;
  }
  k1y(value) {
    var oldValue = this._style;
    if (!equals(oldValue, value)) {
      this._styleResolver = LanguageDefinitionAbstract$_set_style_$lambda_f7taq6(value);
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = this.styleObservers;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract.<set-style>.<anonymous>' call
        element(oldValue, value);
      }
    }
  }
  l1y() {
    var tmp;
    if (null == this._style) {
      var tmp0_safe_receiver = this._styleResolver;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract.<get-style>.<anonymous>' call
        var p = this.processor;
        var tmp_1;
        if (null == p) {
          tmp_1 = null;
        } else {
          var r = tmp0_safe_receiver(p);
          this._issues.addAll(r.issues);
          tmp_1 = r.asm;
        }
        tmp$ret$0 = tmp_1;
        tmp$ret$1 = tmp$ret$0;
        tmp_0 = tmp$ret$1;
      }
      tmp = tmp_0;
    } else {
      tmp = this._style;
    }
    return tmp;
  }
  m1y() {
    return this.a1w_1;
  }
  n1y() {
    return this.b1w_1;
  }
  o1y() {
    return this.c1w_1;
  }
  p1y() {
    return this.d1w_1;
  }
  q1y() {
    return this.e1w_1;
  }
  r1y() {
    return this.f1w_1;
  }
  s1y() {
    return this.g1w_1;
  }
  t1y() {
    return this.h1w_1;
  }
  u1y() {
    return this.i1w_1;
  }
  toString() {
    return this.identity;
  }
  v1y() {
    return this._processor_cache;
  }
  w1y(_set____db54di) {
    this._issues = _set____db54di;
  }
  x1y() {
    return this._issues;
  }
  y1y() {
    return this._style;
  }
  z1y(_set____db54di) {
    return this.j1w_1.ck(this, _scopeModelResolver$factory(), _set____db54di);
  }
  a1z() {
    return this.j1w_1.ak(this, _scopeModelResolver$factory_0());
  }
  b1z(_set____db54di) {
    return this.k1w_1.ck(this, _typeModelResolver$factory(), _set____db54di);
  }
  c1z() {
    return this.k1w_1.ak(this, _typeModelResolver$factory_0());
  }
  d1z(_set____db54di) {
    return this.l1w_1.ck(this, _syntaxAnalyserResolver$factory(), _set____db54di);
  }
  e1z() {
    return this.l1w_1.ak(this, _syntaxAnalyserResolver$factory_0());
  }
  f1z(_set____db54di) {
    return this.m1w_1.ck(this, _semanticAnalyserResolver$factory(), _set____db54di);
  }
  g1z() {
    return this.m1w_1.ak(this, _semanticAnalyserResolver$factory_0());
  }
  h1z(_set____db54di) {
    return this.n1w_1.ck(this, _formatterResolver$factory(), _set____db54di);
  }
  i1z() {
    return this.n1w_1.ak(this, _formatterResolver$factory_0());
  }
  j1z(_set____db54di) {
    return this.o1w_1.ck(this, _styleResolver$factory(), _set____db54di);
  }
  k1z() {
    return this.o1w_1.ak(this, _styleResolver$factory_0());
  }
  l1z(_set____db54di) {
    return this.p1w_1.ck(this, _completionProviderResolver$factory(), _set____db54di);
  }
  m1z() {
    return this.p1w_1.ak(this, _completionProviderResolver$factory_0());
  }
  get identity() {
    return this.x1i();
  }
  get grammarStr() {
    return this.u1x();
  }
  set grammarStr(value) {
    this.t1x(value);
  }
  get grammar() {
    return this.u1g();
  }
  set grammar(value) {
    this.v1x(value);
  }
  get isModifiable() {
    return this.w1x();
  }
  get targetGrammarName() {
    return this.y1x();
  }
  set targetGrammarName(value) {
    this.x1x(value);
  }
  get defaultGoalRule() {
    return this.a1y();
  }
  set defaultGoalRule(value) {
    this.z1x(value);
  }
  get scopeModelStr() {
    return this.c1y();
  }
  set scopeModelStr(value) {
    this.b1y(value);
  }
  get scopeModel() {
    return this.r1b();
  }
  set scopeModel(value) {
    this.d1y(value);
  }
  get syntaxAnalyser() {
    return this.e1y();
  }
  get semanticAnalyser() {
    return this.f1y();
  }
  get formatter() {
    return this.g1y();
  }
  get processor() {
    return this.h1y();
  }
  get issues() {
    return this.w1b();
  }
  get styleStr() {
    return this.j1y();
  }
  set styleStr(value) {
    this.i1y(value);
  }
  get style() {
    return this.l1y();
  }
  set style(value) {
    this.k1y(value);
  }
  get processorObservers() {
    return this.m1y();
  }
  get grammarStrObservers() {
    return this.n1y();
  }
  get grammarObservers() {
    return this.o1y();
  }
  get scopeStrObservers() {
    return this.p1y();
  }
  get scopeModelObservers() {
    return this.q1y();
  }
  get formatterStrObservers() {
    return this.r1y();
  }
  get formatterObservers() {
    return this.s1y();
  }
  get styleStrObservers() {
    return this.t1y();
  }
  get styleObservers() {
    return this.u1y();
  }
  get _scopeModelResolver() {
    return this.a1z();
  }
  set _scopeModelResolver(value) {
    this.z1y(value);
  }
  get _typeModelResolver() {
    return this.c1z();
  }
  set _typeModelResolver(value) {
    this.b1z(value);
  }
  get _syntaxAnalyserResolver() {
    return this.e1z();
  }
  set _syntaxAnalyserResolver(value) {
    this.d1z(value);
  }
  get _semanticAnalyserResolver() {
    return this.g1z();
  }
  set _semanticAnalyserResolver(value) {
    this.f1z(value);
  }
  get _formatterResolver() {
    return this.i1z();
  }
  set _formatterResolver(value) {
    this.h1z(value);
  }
  get _styleResolver() {
    return this.k1z();
  }
  set _styleResolver(value) {
    this.j1z(value);
  }
  get _completionProviderResolver() {
    return this.m1z();
  }
  set _completionProviderResolver(value) {
    this.l1z(value);
  }
  get configuration() {
    return this.o1z();
  }
  set configuration(value) {
    this.n1z(value);
  }
}
class _no_name_provided__qut3iv_9 extends ObservableProperty {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.q20_1 = this$0;
    super(null, $box);
  }
  v1w(property, oldValue, newValue) {
    var tmp;
    if (this.q20_1.k20_1) {
      updateGrammarStr(this.q20_1, oldValue, newValue);
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'string') ? oldValue : THROW_CCE();
    return this.v1w(property, tmp, (newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_10 extends ObservableProperty {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.s20_1 = this$0;
    super(null, $box);
  }
  v1w(property, oldValue, newValue) {
    var tmp;
    if (this.s20_1.k20_1) {
      updateScopeModelStr(this.s20_1, oldValue, newValue);
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'string') ? oldValue : THROW_CCE();
    return this.v1w(property, tmp, (newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  }
}
class _no_name_provided__qut3iv_11 extends ObservableProperty {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.u20_1 = this$0;
    super(null, $box);
  }
  v1w(property, oldValue, newValue) {
    var tmp;
    if (this.u20_1.k20_1) {
      updateStyleStr(this.u20_1, oldValue, newValue);
      tmp = Unit_getInstance();
    }
    return tmp;
  }
  yj(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : typeof oldValue === 'string') ? oldValue : THROW_CCE();
    return this.v1w(property, tmp, (newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  }
}
class LanguageDefinitionDefault extends LanguageDefinitionAbstract {
  constructor(identity, grammarStrArg, aglOptions, buildForDefaultGoal, initialConfiguration) {
    super(null, buildForDefaultGoal, initialConfiguration);
    this.i20_1 = identity;
    this.j20_1 = aglOptions;
    this.k20_1 = true;
    this.l20_1 = true;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable = Delegates_getInstance();
    tmp$ret$0 = new _no_name_provided__qut3iv_9(this);
    tmp.m20_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_0 = Delegates_getInstance();
    tmp$ret$1 = new _no_name_provided__qut3iv_10(this);
    tmp_0.n20_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.properties.Delegates.observable' call
    var tmp0_observable_1 = Delegates_getInstance();
    tmp$ret$2 = new _no_name_provided__qut3iv_11(this);
    tmp_1.o20_1 = tmp$ret$2;
    this.t1x(grammarStrArg);
  }
  x1i() {
    return this.i20_1;
  }
  w1x() {
    return this.l20_1;
  }
  n1z(value) {
    updateConfiguration(this, value);
    this._processor_cache.e1q();
  }
  o1z() {
    return new LanguageProcessorConfigurationDefault(this.targetGrammarName, this.defaultGoalRule, this._typeModelResolver, this._scopeModelResolver, this._syntaxAnalyserResolver, this._semanticAnalyserResolver, this._formatterResolver, this._styleResolver, this._completionProviderResolver);
  }
  t1x(_set____db54di) {
    return this.m20_1.ck(this, grammarStr$factory(), _set____db54di);
  }
  u1x() {
    return this.m20_1.ak(this, grammarStr$factory_0());
  }
  b1y(_set____db54di) {
    return this.n20_1.ck(this, scopeModelStr$factory(), _set____db54di);
  }
  c1y() {
    return this.n20_1.ak(this, scopeModelStr$factory_0());
  }
  i1y(_set____db54di) {
    return this.o20_1.ck(this, styleStr$factory(), _set____db54di);
  }
  j1y() {
    return this.o20_1.ak(this, styleStr$factory_0());
  }
  update(grammarStr, scopeModelStr, styleStr) {
    this.k20_1 = false;
    var oldGrammarStr = this.u1x();
    var oldScopeModelStr = this.c1y();
    var oldStyleStr = this.j1y();
    this.t1x(grammarStr);
    this.b1y(scopeModelStr);
    this.i1y(styleStr);
    updateGrammarStr(this, oldGrammarStr, grammarStr);
    updateScopeModelStr(this, oldScopeModelStr, scopeModelStr);
    updateStyleStr(this, oldStyleStr, styleStr);
    this.k20_1 = true;
  }
}
class LanguageDefinitionFromAsm extends LanguageDefinitionAbstract {
  constructor(identity, grammar, buildForDefaultGoal, initialConfiguration) {
    super(grammar, buildForDefaultGoal, initialConfiguration);
    this.o21_1 = identity;
    this.p21_1 = initialConfiguration;
    this.q21_1 = false;
  }
  x1i() {
    return this.o21_1;
  }
  n1z(value) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('Cannot set the configuration of a LanguageDefinitionFromAsm');
  }
  o1z() {
    return this.p21_1;
  }
  t1x(value) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('Cannot set the grammar of a LanguageDefinitionFromAsm using a String');
  }
  u1x() {
    return toString_1(this.grammar);
  }
  w1x() {
    return this.q21_1;
  }
  b1y(value) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('Cannot set the scopeModel of a LanguageDefinitionFromAsm using a String');
  }
  c1y() {
    return toString_1(this.scopeModel);
  }
  i1y(value) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('Cannot set the styleStr of a LanguageDefinitionFromAsm using a String');
  }
  j1y() {
    return toString_1(this.style);
  }
  update(grammarStr, scopeModelStr, styleStr) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('Cannot update a LanguageDefinitionFromAsm using Strings');
  }
}
class LanguageProcessor {}
function buildFor(options, $super) {
  options = options === VOID ? null : options;
  return this.o22(options);
}
function parse(sentence, options, $super) {
  options = options === VOID ? null : options;
  return this.p22(sentence, options);
}
function syntaxAnalysis(sppt, options, $super) {
  options = options === VOID ? null : options;
  return this.q22(sppt, options);
}
function semanticAnalysis(asm, options, $super) {
  options = options === VOID ? null : options;
  return this.r22(asm, options);
}
function process(sentence, options, $super) {
  options = options === VOID ? null : options;
  return this.s22(sentence, options);
}
function format(sentence, options, $super) {
  options = options === VOID ? null : options;
  return this.t22(sentence, options);
}
function formatAsm(asm, options, $super) {
  options = options === VOID ? null : options;
  return this.u22(asm, options);
}
function expectedTerminalsAt(sentence, position, desiredDepth, options, $super) {
  options = options === VOID ? null : options;
  return this.v22(sentence, position, desiredDepth, options);
}
function expectedItemsAt(sentence, position, desiredDepth, options, $super) {
  options = options === VOID ? null : options;
  return this.w22(sentence, position, desiredDepth, options);
}
class LanguageProcessorAbstract {
  constructor() {
    this.r21_1 = new IssueHolder(LanguageProcessorPhase_ALL_getInstance());
    var tmp = this;
    tmp.s21_1 = lazy(LanguageProcessorAbstract$_scanner$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.t21_1 = lazy(LanguageProcessorAbstract$parser$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.u21_1 = lazy(LanguageProcessorAbstract$spptParser$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.v21_1 = lazy(LanguageProcessorAbstract$defaultGoalRuleName$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.w21_1 = lazy(LanguageProcessorAbstract$typeModel$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.x21_1 = lazy(LanguageProcessorAbstract$scopeModel$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.y21_1 = lazy(LanguageProcessorAbstract$syntaxAnalyser$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.z21_1 = lazy(LanguageProcessorAbstract$semanticAnalyser$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.a22_1 = lazy(LanguageProcessorAbstract$formatterModel$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.b22_1 = lazy(LanguageProcessorAbstract$formatter$delegate$lambda(this));
    var tmp_9 = this;
    tmp_9.c22_1 = lazy(LanguageProcessorAbstract$completionProvider$delegate$lambda(this));
  }
  w1b() {
    return this.r21_1;
  }
  e22() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = parser$factory();
    tmp$ret$0 = this.t21_1.p3();
    return tmp$ret$0;
  }
  g22() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = spptParser$factory();
    tmp$ret$0 = this.u21_1.p3();
    return tmp$ret$0;
  }
  d22() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = defaultGoalRuleName$factory();
    tmp$ret$0 = this.v21_1.p3();
    return tmp$ret$0;
  }
  q1b() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = typeModel$factory();
    tmp$ret$0 = this.w21_1.p3();
    return tmp$ret$0;
  }
  r1b() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = scopeModel$factory();
    tmp$ret$0 = this.x21_1.p3();
    return tmp$ret$0;
  }
  e1y() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = syntaxAnalyser$factory();
    tmp$ret$0 = this.y21_1.p3();
    return tmp$ret$0;
  }
  f1y() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = semanticAnalyser$factory();
    tmp$ret$0 = this.z21_1.p3();
    return tmp$ret$0;
  }
  h22() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = formatterModel$factory();
    tmp$ret$0 = this.a22_1.p3();
    return tmp$ret$0;
  }
  g1y() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = formatter$factory();
    tmp$ret$0 = this.b22_1.p3();
    return tmp$ret$0;
  }
  i22() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = completionProvider$factory();
    tmp$ret$0 = this.c22_1.p3();
    return tmp$ret$0;
  }
  usedAutomatonFor(goalRuleName) {
    var tmp = this.e22();
    return (tmp instanceof ScanOnDemandParser ? tmp : THROW_CCE()).k1u_1.j22(goalRuleName);
  }
  interrupt(message) {
    this.e22().v1t(message);
  }
  parseOptionsDefault() {
    return new ParseOptionsDefault(this.d22());
  }
  optionsDefault() {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new ProcessOptionsDefault();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.optionsDefault.<anonymous>' call
    tmp0_also.k22_1.goalRuleName = this.d22();
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  o22(options) {
    var tmp0_elvis_lhs = options;
    var opts = tmp0_elvis_lhs == null ? this.parseOptionsDefault() : tmp0_elvis_lhs;
    if (null == opts.goalRuleName) {
      opts.goalRuleName = this.d22();
    }
    this.e22().x1u(ensureNotNull(opts.goalRuleName), opts.automatonKind);
    return this;
  }
  scan(sentence) {
    return _get__scanner__baey98(this).g1v(sentence, false);
  }
  p22(sentence, options) {
    var tmp0_elvis_lhs = options;
    var opts = tmp0_elvis_lhs == null ? this.parseOptionsDefault() : tmp0_elvis_lhs;
    if (null == opts.goalRuleName) {
      opts.goalRuleName = this.d22();
    }
    return this.e22().z1u(sentence, opts);
  }
  q22(sppt, options) {
    var opts = defaultOptions(this, options);
    var tmp0_elvis_lhs = this.e1y();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "the processor for grammar '" + this.u1g().qualifiedName + "' was not configured with a SyntaxAnalyser";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var sa = tmp;
    sa.clear();
    return sa.transform(sppt, this.f22());
  }
  r22(asm, options) {
    var opts = defaultOptions(this, options);
    var tmp0_elvis_lhs = this.f1y();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "the processor for grammar '" + this.u1g().qualifiedName + "' was not configured with a SemanticAnalyser";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var semAnalyser = tmp;
    semAnalyser.clear();
    var tmp1_elvis_lhs = opts.semanticAnalysis.locationMap;
    var lm = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
    return semAnalyser.analyse(asm, lm, opts.semanticAnalysis.context, opts.semanticAnalysis);
  }
  s22(sentence, options) {
    var opts = defaultOptions(this, options);
    var parseResult = this.parse(sentence, opts.parse);
    var tmp;
    if (null == parseResult.sppt ? true : !opts.syntaxAnalysis.active) {
      tmp = new ProcessResultDefault(null, parseResult.issues);
    } else {
      var synxResult = this.syntaxAnalysis(ensureNotNull(parseResult.sppt), opts);
      var tmp_0;
      if ((null == synxResult.asm ? true : !opts.semanticAnalysis.active) ? true : null == this.f1y()) {
        var issues = plus_3(parseResult.issues, synxResult.issues);
        if (null == this.f1y()) {
          issues.info(null, 'There is no SemanticAnalyser configured');
        }
        if (null == this.f1y()) {
          issues.info(null, 'There was no ASM returned by the SyntaxAnalyser');
        }
        tmp_0 = new ProcessResultDefault(synxResult.asm, issues);
      } else {
        opts.semanticAnalysis.locationMap = synxResult.locationMap;
        var result = this.semanticAnalysis(ensureNotNull(synxResult.asm), opts);
        tmp_0 = new ProcessResultDefault(synxResult.asm, plus_3(plus_3(parseResult.issues, synxResult.issues), result.issues));
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  t22(sentence, options) {
    var opts = defaultOptions(this, options);
    var parseResult = this.parse(sentence, opts.parse);
    var tmp;
    if (null == parseResult.sppt) {
      tmp = new FormatResultDefault(null, parseResult.issues);
    } else {
      var synxResult = this.syntaxAnalysis(ensureNotNull(parseResult.sppt));
      var tmp_0;
      if (null == synxResult.asm) {
        tmp_0 = new FormatResultDefault(null, plus_3(parseResult.issues, synxResult.issues));
      } else {
        var frmtResult = this.formatAsm(ensureNotNull(synxResult.asm));
        tmp_0 = new FormatResultDefault(frmtResult.sentence, plus_3(plus_3(parseResult.issues, synxResult.issues), frmtResult.issues));
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  u22(asm, options) {
    var opts = defaultOptions(this, options);
    var tmp0_elvis_lhs = this.g1y();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "the processor for grammar '" + this.u1g().qualifiedName + "' was not configured with a Formatter";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var frmtr = tmp;
    return frmtr.format(asm);
  }
  v22(sentence, position, desiredDepth, options) {
    var opts = defaultOptions(this, options);
    var parserExpected = this.e22().c1v(sentence, position, opts.parse);
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = parserExpected.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.expectedTerminalsAt.<anonymous>' call
      var tmp;
      if (element.equals(Companion_getInstance_33().l13_1)) {
        tmp = null;
      } else if (element.equals(Companion_getInstance_33().p13_1)) {
        tmp = null;
      } else {
        var rhs = element.i11();
        var tmp0_subject = rhs;
        var tmp_0;
        if (tmp0_subject instanceof RuntimeRuleRhsLiteral) {
          tmp_0 = new CompletionItem(CompletionItemKind_LITERAL_getInstance(), rhs.n12_1, element.mz());
        } else {
          if (tmp0_subject instanceof RuntimeRuleRhsPattern) {
            tmp_0 = new CompletionItem(CompletionItemKind_PATTERN_getInstance(), '<' + element.mz() + '>', rhs.p12_1);
          } else {
            tmp_0 = new CompletionItem(CompletionItemKind_LITERAL_getInstance(), element.mz(), element.mz());
          }
        }
        tmp = tmp_0;
      }
      tmp$ret$0 = tmp;
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    var terminalItems = tmp$ret$3;
    return new ExpectedAtResultDefault(terminalItems, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
  }
  w22(sentence, position, desiredDepth, options) {
    var tmp;
    if (!(null == this.i22())) {
      var opts = defaultOptions(this, options);
      var parserExpected = this.e22().c1v(sentence, position, opts.parse);
      var tmp$ret$3;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var tmp0_mapNotNullTo = ArrayList.i4();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = parserExpected.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.expectedItemsAt.<anonymous>' call
        tmp$ret$0 = this.f22()(element.mw_1, element.nw_1);
        var tmp0_safe_receiver = tmp$ret$0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          var tmp$ret$1;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
          tmp$ret$1 = Unit_getInstance();
        }
      }
      tmp$ret$2 = tmp0_mapNotNullTo;
      tmp$ret$3 = tmp$ret$2;
      var grammarItems = toSet(tmp$ret$3);
      var items = ensureNotNull(this.i22()).provide(grammarItems, opts.completionProvider.context, opts.completionProvider.options);
      tmp = new ExpectedAtResultDefault(items, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
    } else {
      tmp = this.expectedTerminalsAt(sentence, position, desiredDepth, options);
    }
    return tmp;
  }
  get issues() {
    return this.w1b();
  }
  get grammar() {
    return this.u1g();
  }
  get spptParser() {
    return this.g22();
  }
  get typeModel() {
    return this.q1b();
  }
  get scopeModel() {
    return this.r1b();
  }
  get syntaxAnalyser() {
    return this.e1y();
  }
  get semanticAnalyser() {
    return this.f1y();
  }
  get formatterModel() {
    return this.h22();
  }
  get formatter() {
    return this.g1y();
  }
  get completionProvider() {
    return this.i22();
  }
}
class LanguageProcessorDefault extends LanguageProcessorAbstract {
  constructor(grammar, configuration) {
    super();
    this.j23_1 = grammar;
    this.k23_1 = configuration;
    var tmp = this;
    tmp.l23_1 = lazy(LanguageProcessorDefault$_converterToRuntimeRules$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.m23_1 = lazy(LanguageProcessorDefault$runtimeRuleSet$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.n23_1 = LanguageProcessorDefault$mapToGrammar$lambda(this);
  }
  u1g() {
    return this.j23_1;
  }
  o1z() {
    return this.k23_1;
  }
  h1f() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = runtimeRuleSet$factory_0();
    tmp$ret$0 = this.m23_1.p3();
    return tmp$ret$0;
  }
  f22() {
    return this.n23_1;
  }
  get grammar() {
    return this.u1g();
  }
  get issues() {
    return this.w1b();
  }
  get spptParser() {
    return this.g22();
  }
  get typeModel() {
    return this.q1b();
  }
  get scopeModel() {
    return this.r1b();
  }
  get syntaxAnalyser() {
    return this.e1y();
  }
  get semanticAnalyser() {
    return this.f1y();
  }
  get formatterModel() {
    return this.h22();
  }
  get formatter() {
    return this.g1y();
  }
  get completionProvider() {
    return this.i22();
  }
}
class LanguageProcessorFromGenerated extends LanguageProcessorAbstract {
  constructor(generated) {
    super();
    this.a24_1 = generated;
    var tmp = this;
    var tmp_0 = this.a24_1.j24();
    tmp.b24_1 = tmp_0 instanceof RuntimeRuleSet ? tmp_0 : THROW_CCE();
    this.c24_1 = this.a24_1.f22();
    var tmp_1 = this;
    var tmp0_elvis_lhs = this.a24_1.r1b();
    tmp_1.d24_1 = tmp0_elvis_lhs == null ? new ScopeModelAgl() : tmp0_elvis_lhs;
    this.e24_1 = this.a24_1.e1y();
    this.f24_1 = this.a24_1.g1y();
    this.g24_1 = this.a24_1.f1y();
    this.h24_1 = this.a24_1.u1g();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.a24_1.k24();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = tmp0_forEach.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorFromGenerated.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$1 = element.o3();
      var userGoalRuleName = tmp$ret$1;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$2 = element.p3();
      var automaton = tmp$ret$2;
      this.b24_1.l24(userGoalRuleName, automaton);
    }
  }
  o1z() {
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
  h1f() {
    return this.b24_1;
  }
  f22() {
    return this.c24_1;
  }
  r1b() {
    return this.d24_1;
  }
  e1y() {
    return this.e24_1;
  }
  g1y() {
    return this.f24_1;
  }
  f1y() {
    return this.g24_1;
  }
  u1g() {
    return this.h24_1;
  }
  get scopeModel() {
    return this.r1b();
  }
  get syntaxAnalyser() {
    return this.e1y();
  }
  get formatter() {
    return this.g1y();
  }
  get semanticAnalyser() {
    return this.f1y();
  }
  get grammar() {
    return this.u1g();
  }
  get issues() {
    return this.w1b();
  }
  get spptParser() {
    return this.g22();
  }
  get typeModel() {
    return this.q1b();
  }
  get formatterModel() {
    return this.h22();
  }
  get completionProvider() {
    return this.i22();
  }
}
class AglLanguages {}
class LanguageRegistryDefault$agl$1 {
  constructor(this$0) {
    this.q24_1 = AglGrammarGrammar_getInstance().qualifiedName;
    this.r24_1 = AglStyleGrammar_getInstance().qualifiedName;
    this.s24_1 = AglFormatGrammar_getInstance().qualifiedName;
    this.t24_1 = AglScopesGrammar_getInstance().qualifiedName;
    var tmp = this;
    var tmp_0 = AglGrammarGrammar_getInstance();
    var tmp_1 = Agl_getInstance();
    tmp.u24_1 = this$0.b25(new LanguageDefinitionFromAsm(this.q24_1, tmp_0, false, tmp_1.configuration(VOID, LanguageRegistryDefault$agl$o$grammar$lambda(this$0))));
    var tmp_2 = this;
    var tmp_3 = AglScopesGrammar_getInstance();
    var tmp_4 = Agl_getInstance();
    tmp_2.v24_1 = this$0.b25(new LanguageDefinitionFromAsm(this.t24_1, tmp_3, false, tmp_4.configuration(VOID, LanguageRegistryDefault$agl$o$scopes$lambda)));
    var tmp_5 = this;
    var tmp_6 = AglFormatGrammar_getInstance();
    var tmp_7 = Agl_getInstance();
    tmp_5.w24_1 = this$0.b25(new LanguageDefinitionFromAsm(this.s24_1, tmp_6, false, tmp_7.configuration(VOID, LanguageRegistryDefault$agl$o$formatter$lambda)));
    var tmp_8 = this;
    var tmp_9 = AglStyleGrammar_getInstance();
    var tmp_10 = Agl_getInstance();
    tmp_8.x24_1 = this$0.b25(new LanguageDefinitionFromAsm(this.r24_1, tmp_9, false, tmp_10.configuration(VOID, LanguageRegistryDefault$agl$o$style$lambda)));
  }
  m24() {
    return this.q24_1;
  }
  n24() {
    return this.r24_1;
  }
  o24() {
    return this.s24_1;
  }
  p24() {
    return this.t24_1;
  }
  u1g() {
    return this.u24_1;
  }
  g1n() {
    return this.v24_1;
  }
  g1y() {
    return this.w24_1;
  }
  l1y() {
    return this.x24_1;
  }
  get grammarLanguageIdentity() {
    return this.m24();
  }
  get styleLanguageIdentity() {
    return this.n24();
  }
  get formatLanguageIdentity() {
    return this.o24();
  }
  get scopesLanguageIdentity() {
    return this.p24();
  }
  get grammar() {
    return this.u1g();
  }
  get scopes() {
    return this.g1n();
  }
  get formatter() {
    return this.g1y();
  }
  get style() {
    return this.l1y();
  }
}
class GrammarRegistry {}
class LanguageRegistry {}
class LanguageRegistryDefault {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.y24_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.z24_1 = tmp$ret$1;
    var tmp_1 = this;
    tmp_1.a25_1 = new LanguageRegistryDefault$agl$1(this);
  }
  c25() {
    return this.a25_1;
  }
  b25(definition) {
    var tmp;
    if (this.z24_1.r3(definition.identity)) {
      var tmp0_error = "LanguageDefinition '" + definition.identity + "' is already registered, please unregister the old one first";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp1_set = this.z24_1;
      var tmp2_set = definition.identity;
      tmp1_set.m3(tmp2_set, definition);
      tmp = definition;
    }
    return tmp;
  }
  register(identity, grammarStr, aglOptions, buildForDefaultGoal, configuration) {
    return this.b25(new LanguageDefinitionDefault(identity, grammarStr, aglOptions, buildForDefaultGoal, configuration));
  }
  unregister(identity) {
    this.z24_1.q3(identity);
  }
  findOrNull(identity) {
    var tmp = this.z24_1.u3(identity);
    return (tmp == null ? true : isInterface(tmp, LanguageDefinition)) ? tmp : THROW_CCE();
  }
  findOrPlaceholder(identity, aglOptions, configuration) {
    var existing = this.findOrNull(identity);
    var tmp;
    if (null == existing) {
      var tmp0_elvis_lhs = configuration;
      var placeholder = new LanguageDefinitionDefault(identity, null, aglOptions, false, tmp0_elvis_lhs == null ? Agl_getInstance().configurationEmpty() : tmp0_elvis_lhs);
      tmp = this.b25(placeholder);
    } else {
      tmp = existing;
    }
    return tmp;
  }
  d25(qualifiedName) {
    return this.y24_1.u3(qualifiedName);
  }
  findGrammarOrNull(localNamespace, nameOrQName) {
    var tmp0_elvis_lhs = this.d25(localNamespace.qualifiedName + '.' + nameOrQName);
    return tmp0_elvis_lhs == null ? this.d25(nameOrQName) : tmp0_elvis_lhs;
  }
  registerGrammar(grammar) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.y24_1;
    var tmp1_set = grammar.qualifiedName;
    tmp0_set.m3(tmp1_set, grammar);
  }
  get agl() {
    return this.c25();
  }
}
class IssueCollection {}
class IssueHolder {
  constructor(defaultPhase) {
    this.e25_1 = defaultPhase;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    tmp.f25_1 = tmp$ret$0;
  }
  g25() {
    return this.f25_1;
  }
  h25() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.f25_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.processor.IssueHolder.<get-errors>.<anonymous>' call
      tmp$ret$0 = element.kind.equals(LanguageIssueKind_ERROR_getInstance());
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  i25() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.f25_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.processor.IssueHolder.<get-warnings>.<anonymous>' call
      tmp$ret$0 = element.kind.equals(LanguageIssueKind_WARNING_getInstance());
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  j25() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.f25_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.processor.IssueHolder.<get-informations>.<anonymous>' call
      tmp$ret$0 = element.kind.equals(LanguageIssueKind_INFORMATION_getInstance());
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  clear() {
    this.f25_1.n1();
  }
  k25(kind, phase, location, message, data) {
    this.f25_1.e1(new LanguageIssue(kind, phase, location, message, data));
  }
  raise(kind, phase, location, message, data, $super) {
    data = data === VOID ? null : data;
    return this.k25(kind, phase, location, message, data);
  }
  l25(location, message, data) {
    return this.raise(LanguageIssueKind_INFORMATION_getInstance(), this.e25_1, location, message, data);
  }
  info(location, message, data, $super) {
    data = data === VOID ? null : data;
    return this.l25(location, message, data);
  }
  m25(location, message, data) {
    return this.raise(LanguageIssueKind_WARNING_getInstance(), this.e25_1, location, message, data);
  }
  warn(location, message, data, $super) {
    data = data === VOID ? null : data;
    return this.m25(location, message, data);
  }
  n25(location, message, data) {
    return this.raise(LanguageIssueKind_ERROR_getInstance(), this.e25_1, location, message, data);
  }
  error(location, message, data, $super) {
    data = data === VOID ? null : data;
    return this.n25(location, message, data);
  }
  addAll(other) {
    this.f25_1.k1(other.all);
  }
  o() {
    return this.f25_1.o();
  }
  u() {
    return this.f25_1.u();
  }
  y() {
    return this.f25_1.y();
  }
  o25(element) {
    return this.f25_1.w(element);
  }
  w(element) {
    if (!(element instanceof LanguageIssue))
      return false;
    return this.o25(element instanceof LanguageIssue ? element : THROW_CCE());
  }
  p25(elements) {
    return this.f25_1.x(elements);
  }
  x(elements) {
    return this.p25(elements);
  }
  toString() {
    return joinToString(this.f25_1, '\n', VOID, VOID, VOID, VOID, IssueHolder$toString$lambda);
  }
  get all() {
    return this.g25();
  }
  get errors() {
    return this.h25();
  }
  get warnings() {
    return this.i25();
  }
  get informations() {
    return this.j25();
  }
}
class LanguageProcessorResult {
  constructor(processor, issues) {
    this.processor = processor;
    this.issues = issues;
  }
  h1y() {
    return this.processor;
  }
  w1b() {
    return this.issues;
  }
}
class ParseResult {}
class ParseResultDefault {
  constructor(sppt, issues) {
    this.q25_1 = sppt;
    this.r25_1 = issues;
  }
  s25() {
    return this.q25_1;
  }
  w1b() {
    return this.r25_1;
  }
  ti() {
    return this.q25_1;
  }
  ui() {
    return this.r25_1;
  }
  t25(sppt, issues) {
    return new ParseResultDefault(sppt, issues);
  }
  copy(sppt, issues, $super) {
    sppt = sppt === VOID ? this.q25_1 : sppt;
    issues = issues === VOID ? this.r25_1 : issues;
    return this.t25(sppt, issues);
  }
  toString() {
    return 'ParseResultDefault(sppt=' + this.q25_1 + ', issues=' + this.r25_1 + ')';
  }
  hashCode() {
    var result = this.q25_1 == null ? 0 : hashCode(this.q25_1);
    result = imul(result, 31) + hashCode(this.r25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ParseResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof ParseResultDefault ? other : THROW_CCE();
    if (!equals(this.q25_1, tmp0_other_with_cast.q25_1))
      return false;
    if (!equals(this.r25_1, tmp0_other_with_cast.r25_1))
      return false;
    return true;
  }
  get sppt() {
    return this.s25();
  }
  get issues() {
    return this.w1b();
  }
}
class SyntaxAnalysisResult {}
class SyntaxAnalysisResultDefault {
  constructor(asm, issues, locationMap) {
    this.u25_1 = asm;
    this.v25_1 = issues;
    this.w25_1 = locationMap;
  }
  s1b() {
    return this.u25_1;
  }
  w1b() {
    return this.v25_1;
  }
  v1b() {
    return this.w25_1;
  }
  ti() {
    return this.u25_1;
  }
  ui() {
    return this.v25_1;
  }
  r1j() {
    return this.w25_1;
  }
  x25(asm, issues, locationMap) {
    return new SyntaxAnalysisResultDefault(asm, issues, locationMap);
  }
  copy(asm, issues, locationMap, $super) {
    asm = asm === VOID ? this.u25_1 : asm;
    issues = issues === VOID ? this.v25_1 : issues;
    locationMap = locationMap === VOID ? this.w25_1 : locationMap;
    return this.x25(asm, issues, locationMap);
  }
  toString() {
    return 'SyntaxAnalysisResultDefault(asm=' + this.u25_1 + ', issues=' + this.v25_1 + ', locationMap=' + this.w25_1 + ')';
  }
  hashCode() {
    var result = this.u25_1 == null ? 0 : hashCode(this.u25_1);
    result = imul(result, 31) + hashCode(this.v25_1) | 0;
    result = imul(result, 31) + hashCode(this.w25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SyntaxAnalysisResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof SyntaxAnalysisResultDefault ? other : THROW_CCE();
    if (!equals(this.u25_1, tmp0_other_with_cast.u25_1))
      return false;
    if (!equals(this.v25_1, tmp0_other_with_cast.v25_1))
      return false;
    if (!equals(this.w25_1, tmp0_other_with_cast.w25_1))
      return false;
    return true;
  }
  get asm() {
    return this.s1b();
  }
  get issues() {
    return this.w1b();
  }
  get locationMap() {
    return this.v1b();
  }
}
class SemanticAnalysisResult {}
class SemanticAnalysisResultDefault {
  constructor(issues) {
    this.y25_1 = issues;
  }
  w1b() {
    return this.y25_1;
  }
  ti() {
    return this.y25_1;
  }
  z25(issues) {
    return new SemanticAnalysisResultDefault(issues);
  }
  copy(issues, $super) {
    issues = issues === VOID ? this.y25_1 : issues;
    return this.z25(issues);
  }
  toString() {
    return 'SemanticAnalysisResultDefault(issues=' + this.y25_1 + ')';
  }
  hashCode() {
    return hashCode(this.y25_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SemanticAnalysisResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof SemanticAnalysisResultDefault ? other : THROW_CCE();
    if (!equals(this.y25_1, tmp0_other_with_cast.y25_1))
      return false;
    return true;
  }
  get issues() {
    return this.w1b();
  }
}
class ProcessResult {}
class ProcessResultDefault {
  constructor(asm, issues) {
    this.a26_1 = asm;
    this.b26_1 = issues;
  }
  s1b() {
    return this.a26_1;
  }
  w1b() {
    return this.b26_1;
  }
  ti() {
    return this.a26_1;
  }
  ui() {
    return this.b26_1;
  }
  c26(asm, issues) {
    return new ProcessResultDefault(asm, issues);
  }
  copy(asm, issues, $super) {
    asm = asm === VOID ? this.a26_1 : asm;
    issues = issues === VOID ? this.b26_1 : issues;
    return this.c26(asm, issues);
  }
  toString() {
    return 'ProcessResultDefault(asm=' + this.a26_1 + ', issues=' + this.b26_1 + ')';
  }
  hashCode() {
    var result = this.a26_1 == null ? 0 : hashCode(this.a26_1);
    result = imul(result, 31) + hashCode(this.b26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessResultDefault ? other : THROW_CCE();
    if (!equals(this.a26_1, tmp0_other_with_cast.a26_1))
      return false;
    if (!equals(this.b26_1, tmp0_other_with_cast.b26_1))
      return false;
    return true;
  }
  get asm() {
    return this.s1b();
  }
  get issues() {
    return this.w1b();
  }
}
class FormatResult {}
class FormatResultDefault {
  constructor(sentence, issues) {
    this.d26_1 = sentence;
    this.e26_1 = issues;
  }
  f26() {
    return this.d26_1;
  }
  w1b() {
    return this.e26_1;
  }
  ti() {
    return this.d26_1;
  }
  ui() {
    return this.e26_1;
  }
  g26(sentence, issues) {
    return new FormatResultDefault(sentence, issues);
  }
  copy(sentence, issues, $super) {
    sentence = sentence === VOID ? this.d26_1 : sentence;
    issues = issues === VOID ? this.e26_1 : issues;
    return this.g26(sentence, issues);
  }
  toString() {
    return 'FormatResultDefault(sentence=' + this.d26_1 + ', issues=' + this.e26_1 + ')';
  }
  hashCode() {
    var result = this.d26_1 == null ? 0 : getStringHashCode(this.d26_1);
    result = imul(result, 31) + hashCode(this.e26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FormatResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof FormatResultDefault ? other : THROW_CCE();
    if (!(this.d26_1 == tmp0_other_with_cast.d26_1))
      return false;
    if (!equals(this.e26_1, tmp0_other_with_cast.e26_1))
      return false;
    return true;
  }
  get sentence() {
    return this.f26();
  }
  get issues() {
    return this.w1b();
  }
}
class ExpectedAtResult {}
class ExpectedAtResultDefault {
  constructor(items, issues) {
    this.h26_1 = items;
    this.i26_1 = issues;
  }
  a11() {
    return this.h26_1;
  }
  w1b() {
    return this.i26_1;
  }
  ti() {
    return this.h26_1;
  }
  ui() {
    return this.i26_1;
  }
  j26(items, issues) {
    return new ExpectedAtResultDefault(items, issues);
  }
  copy(items, issues, $super) {
    items = items === VOID ? this.h26_1 : items;
    issues = issues === VOID ? this.i26_1 : issues;
    return this.j26(items, issues);
  }
  toString() {
    return 'ExpectedAtResultDefault(items=' + this.h26_1 + ', issues=' + this.i26_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.h26_1);
    result = imul(result, 31) + hashCode(this.i26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ExpectedAtResultDefault))
      return false;
    var tmp0_other_with_cast = other instanceof ExpectedAtResultDefault ? other : THROW_CCE();
    if (!equals(this.h26_1, tmp0_other_with_cast.h26_1))
      return false;
    if (!equals(this.i26_1, tmp0_other_with_cast.i26_1))
      return false;
    return true;
  }
  get items() {
    return this.a11();
  }
  get issues() {
    return this.w1b();
  }
}
class RegexMatcherBuilder {
  constructor(pattern) {
    this.k26_1 = pattern;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.l26_1 = tmp$ret$0;
    this.m26_1 = 0;
    this.n26_1 = new MutableStack();
    this.o26_1 = Companion_getInstance_24().u26_1;
  }
  s26(orig, nullTransitions, map) {
    var clone = new Transition_0(orig.v26_1, orig.w26_1);
    clone.x26_1 = cloneState(this, orig.x26_1, nullTransitions, map);
    if (null == clone.x26_1) {
      nullTransitions.e1(clone);
    }
    return clone;
  }
  a27(orig) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var coutgoing = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    var cstart = ensureNotNull(cloneState(this, orig.b27_1, coutgoing, tmp$ret$1));
    return new Fragment(cstart, coutgoing);
  }
  d27() {
    var state = createState(this, false);
    var trans = new Transition_0(TransitionKind_MATCHER_getInstance(), Companion_getInstance_26().f27_1);
    state.r26_1.e1(trans);
    var frag = new Fragment(state, state.r26_1);
    this.n26_1.v1a(frag);
  }
  h27() {
    var state = createState(this, false);
    var trans = new Transition_0(TransitionKind_MATCHER_getInstance(), Companion_getInstance_26().g27_1);
    state.r26_1.e1(trans);
    var frag = new Fragment(state, state.r26_1);
    this.n26_1.v1a(frag);
  }
  i27(value) {
    var state = createState(this, false);
    var trans = new Transition_0(TransitionKind_MATCHER_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), value));
    state.r26_1.e1(trans);
    var frag = new Fragment(state, state.r26_1);
    this.n26_1.v1a(frag);
  }
  j27(matcher) {
    var state = createState(this, false);
    var trans = new Transition_0(TransitionKind_MATCHER_getInstance(), matcher);
    state.r26_1.e1(trans);
    var frag = new Fragment(state, state.r26_1);
    this.n26_1.v1a(frag);
  }
  k27() {
    var tmp0_subject = this.n26_1.o();
    switch (tmp0_subject) {
      case 0:
        break;
      case 1:
        break;
      default:
        var f2 = this.n26_1.w1a();
        var f1 = this.n26_1.w1a();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_forEach = f1.c27_1;
        var tmp0_iterator = tmp0_forEach.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          // Inline function 'net.akehurst.language.agl.regex.RegexMatcherBuilder.concatenate.<anonymous>' call
          element.x26_1 = f2.b27_1;
        }

        var frag = new Fragment(f1.b27_1, f2.c27_1);
        this.n26_1.v1a(frag);
        ;
        break;
    }
  }
  l27() {
    var f2 = this.n26_1.w1a();
    var f1 = this.n26_1.w1a();
    var split = createState(this, true);
    var t1 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    t1.x26_1 = f1.b27_1;
    var t2 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    t2.x26_1 = f2.b27_1;
    split.r26_1.e1(t1);
    split.r26_1.e1(t2);
    var frag = new Fragment(split, plus(f1.c27_1, f2.c27_1));
    this.n26_1.v1a(frag);
  }
  m27() {
    var f1 = this.n26_1.w1a();
    var split = createState(this, true);
    var t1 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    t1.x26_1 = f1.b27_1;
    var t2 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    split.r26_1.e1(t1);
    split.r26_1.e1(t2);
    var frag = new Fragment(split, plus_2(f1.c27_1, t2));
    this.n26_1.v1a(frag);
  }
  n27() {
    var f1 = this.n26_1.w1a();
    var split = createState(this, true);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = f1.c27_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.regex.RegexMatcherBuilder.multi1n.<anonymous>' call
      element.x26_1 = split;
    }
    var t1 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    t1.x26_1 = f1.b27_1;
    var t2 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    split.r26_1.e1(t1);
    split.r26_1.e1(t2);
    var frag = new Fragment(f1.b27_1, listOf(t2));
    this.n26_1.v1a(frag);
  }
  o27() {
    var f1 = this.n26_1.w1a();
    var split = createState(this, true);
    var t1 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    t1.x26_1 = f1.b27_1;
    var t2 = new Transition_0(TransitionKind_EMPTY_getInstance(), Companion_getInstance_26().e27_1);
    split.r26_1.e1(t1);
    split.r26_1.e1(t2);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = f1.c27_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.regex.RegexMatcherBuilder.multi0n.<anonymous>' call
      element.x26_1 = split;
    }
    var frag = new Fragment(split, listOf(t2));
    this.n26_1.v1a(frag);
  }
  p27(n, m) {
    var repFrag = this.n26_1.w1a();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var nRepetitions = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var r = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var nextFrag = this.a27(repFrag);
        nRepetitions.e1(nextFrag);
      }
       while (inductionVariable < n);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    var mRepetitions = tmp$ret$1;
    if (-1 === m) {
      mRepetitions.e1(this.a27(repFrag));
    } else {
      var inductionVariable_0 = n;
      if (inductionVariable_0 < m)
        do {
          var r_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var nextFrag_0 = this.a27(repFrag);
          mRepetitions.e1(nextFrag_0);
        }
         while (inductionVariable_0 < m);
    }
    var needConcat = false;
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < n)
      do {
        var r_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var nextFrag_1 = nRepetitions.p(r_1);
        this.n26_1.v1a(nextFrag_1);
        if (needConcat) {
          this.k27();
        } else {
          needConcat = true;
        }
      }
       while (inductionVariable_1 < n);
    if (-1 === m) {
      this.n26_1.v1a(mRepetitions.p(0));
      this.o27();
      if (needConcat) {
        this.k27();
      } else {
        needConcat = true;
      }
    } else {
      var inductionVariable_2 = n;
      if (inductionVariable_2 < m)
        do {
          var r_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var nextFrag_2 = mRepetitions.p(r_2 - n | 0);
          this.n26_1.v1a(nextFrag_2);
          this.m27();
          if (needConcat) {
            this.k27();
          } else {
            needConcat = true;
          }
        }
         while (inductionVariable_2 < m);
    }
  }
  eo() {
    return new RegexMatcherImpl(this.k26_1, this.o26_1, this.l26_1);
  }
  q27() {
    if (this.n26_1.k17()) {
    } else {
      var f1 = this.n26_1.w1a();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = f1.c27_1;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.regex.RegexMatcherBuilder.concatenateGoal.<anonymous>' call
        element.x26_1 = Companion_getInstance_24().t26_1;
      }
      this.o26_1 = f1.b27_1;
    }
  }
}
class Companion_22 {
  constructor() {
    Companion_instance_22 = this;
    this.t26_1 = new State(-1, false);
    this.u26_1 = new State(-2, false);
  }
}
class RegexMatcher {}
function match(text, startPosition, $super) {
  startPosition = startPosition === VOID ? 0 : startPosition;
  return this.k28(text, startPosition);
}
class RegexMatcherImpl {
  constructor(pattern, start, nfa) {
    Companion_getInstance_24();
    this.c28_1 = pattern;
    this.d28_1 = start;
    this.e28_1 = nfa;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var ns = tmp$ret$0;
    addNextStates(ns, this.d28_1);
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$1 = copyToArray(ns);
    tmp.f28_1 = tmp$ret$1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.e28_1;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.regex.RegexMatcherImpl.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach_0 = element.r26_1;
      var tmp0_iterator_0 = tmp0_forEach_0.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.regex.RegexMatcherImpl.<anonymous>.<anonymous>' call
        element_0.j28();
      }
    }
    this.g28_1 = ArrayList.f4(10);
    this.h28_1 = ArrayList.f4(10);
    this.i28_1 = ArrayList.f4(10);
  }
  k28(text, startPosition) {
    var pos = startPosition;
    this.g28_1.n1();
    this.h28_1.n1();
    this.g28_1.e1(this.f28_1);
    var maxMatchedPos = -1;
    $l$loop: while (true) {
      var tmp;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp0_isNotEmpty = this.g28_1;
      tmp$ret$0 = !tmp0_isNotEmpty.y();
      if (tmp$ret$0) {
        tmp = pos < charSequenceLength(text);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      if (charSequenceGet(text, pos) === _Char___init__impl__6a9atx(10)) {
        this.i28_1.e1(pos);
      }
      var inductionVariable = 0;
      var last = this.g28_1.o();
      if (inductionVariable < last)
        do {
          var ss = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var states = this.g28_1.p(ss);
          var inductionVariable_0 = 0;
          var last_0 = states.length;
          if (inductionVariable_0 < last_0)
            do {
              var s = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var state = states[s];
              var outgoing = state.r26_1;
              var inductionVariable_1 = 0;
              var last_1 = outgoing.o();
              if (inductionVariable_1 < last_1)
                do {
                  var t = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var trans = outgoing.p(t);
                  if (matches(this, trans.w26_1, text, pos)) {
                    this.h28_1.e1(trans.l28());
                    if (trans.z26_1) {
                      var tmp$ret$1;
                      // Inline function 'kotlin.comparisons.maxOf' call
                      var tmp1_maxOf = maxMatchedPos;
                      var tmp2_maxOf = pos;
                      tmp$ret$1 = Math.max(tmp1_maxOf, tmp2_maxOf);
                      maxMatchedPos = tmp$ret$1;
                    }
                  }
                }
                 while (inductionVariable_1 < last_1);
            }
             while (inductionVariable_0 < last_0);
        }
         while (inductionVariable < last);
      var t_0 = this.g28_1;
      this.g28_1 = this.h28_1;
      this.h28_1 = t_0;
      this.h28_1.n1();
      var tmp3 = pos;
      pos = tmp3 + 1 | 0;
    }
    var tmp_0;
    if (!(maxMatchedPos === -1)) {
      var tmp$ret$2;
      // Inline function 'kotlin.text.substring' call
      var tmp3_substring = maxMatchedPos + 1 | 0;
      tmp$ret$2 = toString(charSequenceSubSequence(text, startPosition, tmp3_substring));
      var matchedText = tmp$ret$2;
      tmp_0 = new MatchResult(matchedText, this.i28_1);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  toString() {
    return 'Regex{' + this.c28_1 + '}';
  }
}
class EscapeKind extends Enum {}
class Companion_23 {
  constructor() {
    Companion_instance_23 = this;
    this.PREC_GROUP_OPEN = 1;
    this.PREC_GROUP_CLOSE = 1;
    this.PREC_LITERAL = 2;
    this.PREC_MULTI_01 = 3;
    this.PREC_MULTI_0n = 4;
    this.PREC_MULTI_1n = 5;
    this.PREC_REP = 6;
    this.PREC_CONCAT = 7;
    this.PREC_CHOICE = 8;
    this.PREDEFINED_DIGIT = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
    var tmp = this;
    var tmp_0 = EscapeKind_SINGLE_getInstance();
    var tmp_1 = MatcherKind_NEGATED_getInstance();
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.PREDEFINED_DIGIT_NEGATED = new Pair(tmp_0, new CharacterMatcher(tmp_1, VOID, VOID, tmp$ret$2));
    var tmp_2 = this;
    var tmp_3 = EscapeKind_SINGLE_getInstance();
    var tmp_4 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf_0 = [new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(10)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(11)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(12)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(13)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(133)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(8233))];
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_arrayOf_0;
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    tmp_2.PREDEFINED_UNICODE_LINEBREAK = new Pair(tmp_3, new CharacterMatcher(tmp_4, VOID, VOID, tmp$ret$5));
    var tmp_5 = this;
    var tmp_6 = EscapeKind_SINGLE_getInstance();
    var tmp_7 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$8;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf_1 = [new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(32)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(9)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(10)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(11)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(12)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(13))];
    var tmp$ret$7;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$6;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$6 = tmp0_arrayOf_1;
    tmp$ret$7 = tmp$ret$6;
    tmp$ret$8 = tmp$ret$7;
    tmp_5.PREDEFINED_WHITESPACE = new Pair(tmp_6, new CharacterMatcher(tmp_7, VOID, VOID, tmp$ret$8));
    var tmp_8 = this;
    var tmp_9 = EscapeKind_SINGLE_getInstance();
    var tmp_10 = MatcherKind_NEGATED_getInstance();
    var tmp$ret$14;
    // Inline function 'kotlin.arrayOf' call
    var tmp_11 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$11;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf_2 = [new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(32)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(9)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(10)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(11)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(12)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(13))];
    var tmp$ret$10;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$9;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$9 = tmp0_arrayOf_2;
    tmp$ret$10 = tmp$ret$9;
    tmp$ret$11 = tmp$ret$10;
    var tmp1_arrayOf = [new CharacterMatcher(tmp_11, VOID, VOID, tmp$ret$11)];
    var tmp$ret$13;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$12;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$12 = tmp1_arrayOf;
    tmp$ret$13 = tmp$ret$12;
    tmp$ret$14 = tmp$ret$13;
    tmp_8.PREDEFINED_WHITESPACE_NEGATED = new Pair(tmp_9, new CharacterMatcher(tmp_10, VOID, VOID, tmp$ret$14));
    var tmp_12 = this;
    var tmp_13 = EscapeKind_SINGLE_getInstance();
    var tmp_14 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$17;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf_3 = [new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(95)), new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))];
    var tmp$ret$16;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$15;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$15 = tmp0_arrayOf_3;
    tmp$ret$16 = tmp$ret$15;
    tmp$ret$17 = tmp$ret$16;
    tmp_12.PREDEFINED_WORD = new Pair(tmp_13, new CharacterMatcher(tmp_14, VOID, VOID, tmp$ret$17));
    var tmp_15 = this;
    var tmp_16 = EscapeKind_SINGLE_getInstance();
    var tmp_17 = MatcherKind_NEGATED_getInstance();
    var tmp$ret$23;
    // Inline function 'kotlin.arrayOf' call
    var tmp_18 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$20;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf_4 = [new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(95)), new CharacterMatcher(MatcherKind_RANGE_getInstance(), _Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))];
    var tmp$ret$19;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$18;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$18 = tmp0_arrayOf_4;
    tmp$ret$19 = tmp$ret$18;
    tmp$ret$20 = tmp$ret$19;
    var tmp1_arrayOf_0 = [new CharacterMatcher(tmp_18, VOID, VOID, tmp$ret$20)];
    var tmp$ret$22;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$21;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$21 = tmp1_arrayOf_0;
    tmp$ret$22 = tmp$ret$21;
    tmp$ret$23 = tmp$ret$22;
    tmp_15.PREDEFINED_WORD_NEGATED = new Pair(tmp_16, new CharacterMatcher(tmp_17, VOID, VOID, tmp$ret$23));
  }
  m28() {
    return this.PREC_GROUP_OPEN;
  }
  n28() {
    return this.PREC_GROUP_CLOSE;
  }
  o28() {
    return this.PREC_LITERAL;
  }
  p28() {
    return this.PREC_MULTI_01;
  }
  q28() {
    return this.PREC_MULTI_0n;
  }
  r28() {
    return this.PREC_MULTI_1n;
  }
  s28() {
    return this.PREC_REP;
  }
  t28() {
    return this.PREC_CONCAT;
  }
  u28() {
    return this.PREC_CHOICE;
  }
  v28() {
    return this.PREDEFINED_DIGIT;
  }
  w28() {
    return this.PREDEFINED_DIGIT_NEGATED;
  }
  x28() {
    return this.PREDEFINED_UNICODE_LINEBREAK;
  }
  y28() {
    return this.PREDEFINED_WHITESPACE;
  }
  z28() {
    return this.PREDEFINED_WHITESPACE_NEGATED;
  }
  a29() {
    return this.PREDEFINED_WORD;
  }
  b29() {
    return this.PREDEFINED_WORD_NEGATED;
  }
}
class RegexParser {
  constructor(pattern) {
    Companion_getInstance_25();
    this.r27_1 = pattern;
    this.s27_1 = this.r27_1 + '\x00';
    this.t27_1 = 0;
    this.u27_1 = new RegexMatcherBuilder(this.r27_1);
  }
  v27() {
    parsePattern(this);
    return this.u27_1.eo();
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_24 = this;
    this.e27_1 = new CharacterMatcher(MatcherKind_EMPTY_getInstance());
    this.f27_1 = new CharacterMatcher(MatcherKind_ANY_getInstance());
    this.g27_1 = new CharacterMatcher(MatcherKind_END_OF_LINE_OR_INPUT_getInstance());
  }
}
class CharacterMatcher {
  constructor(kind, literal, max, options) {
    Companion_getInstance_26();
    literal = literal === VOID ? _Char___init__impl__6a9atx(0) : literal;
    max = max === VOID ? _Char___init__impl__6a9atx(0) : max;
    var tmp;
    if (options === VOID) {
      var tmp$ret$2;
      var tmp$ret$2_0;
      // Inline function 'kotlin.arrayOf' call
      var tmp0_arrayOf = [Companion_getInstance_26().e27_1];
      var tmp$ret$1;
      var tmp$ret$1_0;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_arrayOf;
      tmp$ret$0_0 = Unit_getInstance();
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$1_0 = Unit_getInstance();
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$2_0 = Unit_getInstance();
      tmp = tmp$ret$2;
    } else {
      tmp = options;
    }
    options = tmp;
    this.w27_1 = kind;
    this.x27_1 = literal;
    this.y27_1 = max;
    this.z27_1 = options;
    this.a28_1 = this.x27_1;
    this.b28_1 = this.z27_1[0];
  }
  toString() {
    var tmp0_subject = this.w27_1;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        throw IllegalStateException.y1('should not happen');
      case 1:
        tmp = 'ANY';
        break;
      case 2:
        tmp = '$';
        break;
      case 3:
        tmp = '!(' + this.b28_1 + ')';
        break;
      case 4:
        tmp = "'" + new Char(this.x27_1) + "'";
        break;
      case 5:
        tmp = '{' + joinToString_0(this.z27_1, ',') + '}';
        break;
      case 6:
        tmp = '[' + new Char(this.a28_1) + '-' + new Char(this.y27_1) + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class MatcherKind extends Enum {}
class State {
  constructor(number, isSplit) {
    this.p26_1 = number;
    this.q26_1 = isSplit;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.r26_1 = tmp$ret$0;
  }
  hashCode() {
    return this.p26_1;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (tmp0_subject instanceof State) {
      tmp = this.p26_1 === other.p26_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'State{' + this.p26_1 + '}';
  }
}
class Fragment {
  constructor(start, outgoing) {
    this.b27_1 = start;
    this.c27_1 = outgoing;
  }
}
class Transition_0 {
  constructor(kind, matcher) {
    this.v26_1 = kind;
    this.w26_1 = matcher;
    this.x26_1 = null;
    this.z26_1 = false;
  }
  l28() {
    var tmp = this.y26_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('nextStates');
    }
  }
  j28() {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var ns = tmp$ret$0;
    this.z26_1 = addNextStates(ns, this.x26_1);
    var tmp = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$1 = copyToArray(ns);
    tmp.y26_1 = tmp$ret$1;
  }
  toString() {
    var tmp0_safe_receiver = this.x26_1;
    return '-' + this.w26_1 + '->(' + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p26_1) + ')';
  }
}
class TransitionKind extends Enum {}
class CompletedNodesStore {
  constructor(num, inputLength) {
    this.w1p_1 = num;
    this.x1p_1 = inputLength;
    this.y1p_1 = HashMap.w4();
    this.z1p_1 = null;
    this.a1q_1 = HashMap.w4();
    this.b1q_1 = null;
  }
  n1() {
    this.y1p_1.n1();
    this.z1p_1 = null;
    this.a1q_1.n1();
    this.b1q_1 = null;
  }
  c1q(runtimeRule, inputPosition, value) {
    Companion_getInstance_33();
    if (runtimeRule.nw_1 === -1) {
      this.z1p_1 = value;
    } else {
      Companion_getInstance_33();
      if (runtimeRule.nw_1 === -2) {
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = this.a1q_1;
        tmp0_set.m3(inputPosition, value);
      } else {
        Companion_getInstance_33();
        if (runtimeRule.nw_1 === -3) {
          this.b1q_1 = value;
        } else {
          // Inline function 'kotlin.collections.set' call
          var tmp1_set = this.y1p_1;
          var tmp2_set = new Pair(runtimeRule, inputPosition);
          tmp1_set.m3(tmp2_set, value);
        }
      }
    }
  }
  i1q(runtimeRule, inputPosition) {
    var tmp;
    Companion_getInstance_33();
    if (runtimeRule.nw_1 === -1) {
      tmp = this.z1p_1;
    } else {
      Companion_getInstance_33();
      if (runtimeRule.nw_1 === -2) {
        tmp = this.a1q_1.u3(inputPosition);
      } else {
        Companion_getInstance_33();
        if (runtimeRule.nw_1 === -3) {
          tmp = this.b1q_1;
        } else {
          tmp = this.y1p_1.u3(new Pair(runtimeRule, inputPosition));
        }
      }
    }
    return tmp;
  }
}
class ToProcessTriple {
  constructor(growingNode, previous, remainingHead) {
    this.d29_1 = growingNode;
    this.e29_1 = previous;
    this.f29_1 = remainingHead;
  }
  toString() {
    return '' + this.d29_1 + ' ==> ' + this.e29_1 + ' ==> ' + this.f29_1;
  }
  hashCode() {
    var result = this.d29_1.hashCode();
    result = imul(result, 31) + (this.e29_1 == null ? 0 : this.e29_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f29_1 == null ? 0 : this.f29_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ToProcessTriple))
      return false;
    var tmp0_other_with_cast = other instanceof ToProcessTriple ? other : THROW_CCE();
    if (!this.d29_1.equals(tmp0_other_with_cast.d29_1))
      return false;
    if (!equals(this.e29_1, tmp0_other_with_cast.e29_1))
      return false;
    if (!equals(this.f29_1, tmp0_other_with_cast.f29_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_25 = this;
  }
}
class MergeOptions extends Enum {}
class sam$kotlin_Comparator$0_6 {
  constructor(function_0) {
    this.q29_1 = function_0;
  }
  rc(a, b) {
    return this.q29_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class ParseGraph {
  constructor(input, stateSetNumber) {
    Companion_getInstance_27();
    this.v1r_1 = input;
    this.w1r_1 = stateSetNumber;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp$ret$0 = LinkedHashSet.r8();
    tmp.x1r_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp_1 = ParseGraph$_gss$lambda;
    tmp_0.y1r_1 = GraphStructuredStack.s29(binaryHeap(new sam$kotlin_Comparator$0_6(tmp_1)));
    this.z1r_1 = new TreeData(this.w1r_1);
    this.a1s_1 = true;
  }
  m1t() {
    return this.x1r_1;
  }
  n1t() {
    return !this.y1r_1.k17();
  }
  i1u() {
    return this.y1r_1.i1u();
  }
  d1u() {
    return this.y1r_1.d1u();
  }
  c1u() {
    var root = this.y1r_1.t29();
    return null == root ? IntCompanionObject_getInstance().MAX_VALUE : root.x1q_1;
  }
  e1u() {
    return ensureNotNull(this.y1r_1.t29());
  }
  u29(state, runtimeLookaheadSet, startPosition, nextInputPositionBeforeSkip, nextInputPositionAfterSkip, numNonSkipChildren, childrenPriorities) {
    var listSize = Companion_getInstance_28().v29(first_0(state.lz()), numNonSkipChildren);
    return new GrowingNodeIndex(new RuntimeState(state, runtimeLookaheadSet), startPosition, nextInputPositionBeforeSkip, nextInputPositionAfterSkip, listSize, childrenPriorities);
  }
  b1u() {
    var tmp$ret$8;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this.y1r_1.w29();
    var tmp$ret$7;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$6;
      // Inline function 'net.akehurst.language.agl.runtime.graph.ParseGraph.peekAllNextToProcess.<anonymous>' call
      var gn = element;
      var previous = this.y1r_1.p29(gn);
      var tmp;
      if (previous.y()) {
        tmp = listOf(new ToProcessTriple(gn, null, null));
      } else {
        var tmp$ret$5;
        // Inline function 'kotlin.collections.flatMap' call
        var tmp$ret$4;
        // Inline function 'kotlin.collections.flatMapTo' call
        var tmp0_flatMapTo_0 = ArrayList.i4();
        var tmp0_iterator_0 = previous.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          var tmp$ret$3;
          // Inline function 'net.akehurst.language.agl.runtime.graph.ParseGraph.peekAllNextToProcess.<anonymous>.<anonymous>' call
          var heads = this.y1r_1.p29(element_0);
          var tmp_0;
          if (heads.y()) {
            tmp_0 = listOf(new ToProcessTriple(gn, element_0, null));
          } else {
            var tmp$ret$2;
            // Inline function 'kotlin.collections.map' call
            var tmp$ret$1;
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(heads, 10));
            var tmp0_iterator_1 = heads.u();
            while (tmp0_iterator_1.h1()) {
              var item = tmp0_iterator_1.j1();
              var tmp$ret$0;
              // Inline function 'net.akehurst.language.agl.runtime.graph.ParseGraph.peekAllNextToProcess.<anonymous>.<anonymous>.<anonymous>' call
              tmp$ret$0 = new ToProcessTriple(gn, element_0, item);
              tmp0_mapTo.e1(tmp$ret$0);
            }
            tmp$ret$1 = tmp0_mapTo;
            tmp$ret$2 = tmp$ret$1;
            tmp_0 = tmp$ret$2;
          }
          tmp$ret$3 = tmp_0;
          var list = tmp$ret$3;
          addAll(tmp0_flatMapTo_0, list);
        }
        tmp$ret$4 = tmp0_flatMapTo_0;
        tmp$ret$5 = tmp$ret$4;
        tmp = tmp$ret$5;
      }
      tmp$ret$6 = tmp;
      var list_0 = tmp$ret$6;
      addAll(tmp0_flatMapTo, list_0);
    }
    tmp$ret$7 = tmp0_flatMapTo;
    tmp$ret$8 = tmp$ret$7;
    return tmp$ret$8;
  }
  e1q() {
    this.v1r_1.e1q();
    this.y1r_1.n1();
    this.x1r_1.n1();
    this.z1r_1 = new TreeData(this.w1r_1);
  }
  o29(head) {
    return this.y1r_1.x29(head);
  }
  d1s(gn) {
    return this.y1r_1.p29(gn);
  }
  u1t(goalState, startPosition, runtimeLookahead, initialSkipData) {
    var tmp0_safe_receiver = initialSkipData;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1t_1;
    var nextInputPositionAfterSkip = tmp2_elvis_lhs == null ? startPosition : tmp2_elvis_lhs;
    var st = this.u29(goalState, runtimeLookahead, nextInputPositionAfterSkip, nextInputPositionAfterSkip, nextInputPositionAfterSkip, 0, null);
    this.y1r_1.k29(st);
    this.z1r_1.y29(st, initialSkipData);
    return st;
  }
  j1t(head, newState, runtimeLookaheadSet, startPosition, nextInputPosition, skipData) {
    var tmp0_safe_receiver = skipData;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1t_1;
    var nextInputPositionAfterSkip = tmp2_elvis_lhs == null ? nextInputPosition : tmp2_elvis_lhs;
    var newHead = this.u29(newState, runtimeLookaheadSet, startPosition, nextInputPosition, nextInputPositionAfterSkip, 0, null);
    if (!(null == skipData)) {
      this.z1r_1.z29(newHead.l29(), skipData);
    }
    addGrowingHead(this, head, newHead);
    return true;
  }
  j1u(head, newState, runtimeLookaheadSet, startPosition, nextInputPosition, embeddedTreeData, skipData) {
    var tmp0_safe_receiver = skipData;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.root;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1t_1;
    var nextInputPositionAfterSkip = tmp2_elvis_lhs == null ? nextInputPosition : tmp2_elvis_lhs;
    var newHead = this.u29(newState, runtimeLookaheadSet, startPosition, nextInputPosition, nextInputPositionAfterSkip, 0, null);
    if (!(null == skipData)) {
      this.z1r_1.z29(newHead.l29(), skipData);
    }
    var children = embeddedTreeData.childrenFor(ensureNotNull(embeddedTreeData.root));
    var child = first_0(children).si_1.p(0);
    this.z1r_1.a2a(newHead.l29(), child, embeddedTreeData);
    addGrowingHead(this, head, newHead);
    return true;
  }
  k1t(head, previous, parentState, parentRuntimeLookaheadSet, buildSPPT) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp0_check = head.c1r();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_check) {
        var tmp$ret$0;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$0 = 'Check failed.';
        var message = tmp$ret$0;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var child = head.l29();
    var childrenPriorities = listOf(head.e1s().e14());
    var parent = this.u29(parentState, parentRuntimeLookaheadSet, head.v1q_1, head.w1q_1, head.x1q_1, 1, childrenPriorities);
    var tmp;
    if (parent.c1r()) {
      var newParent = parent.l29();
      var existingComplete = this.z1r_1.c2a(newParent);
      var tmp_0;
      if (!(null == existingComplete)) {
        var shouldDrop = mergeDecision(this, existingComplete, newParent);
        var tmp0_subject = shouldDrop;
        var tmp0 = tmp0_subject.bc_1;
        var tmp_1;
        switch (tmp0) {
          case 1:
            tmp_1 = preferNewCompleteParentFirstChild(this, existingComplete, parent, child, previous);
            break;
          case 0:
            tmp_1 = preferExistingCompleteParentFirstChild(this, existingComplete, parent, child, previous);
            break;
          case 3:
            tmp_1 = keepBothCompleteParentsFirstChild(this, existingComplete, parent, child, previous);
            break;
          case 2:
            tmp_1 = useExistingCompleteParentFirstChild(this, parent, child, previous);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_0 = tmp_1;
      } else {
        this.z1r_1.m29(newParent, child, false);
        addGrowingHead(this, previous, parent);
        tmp_0 = true;
      }
      tmp = tmp_0;
    } else {
      this.z1r_1.b2a(parent, child);
      addGrowingHead(this, previous, parent);
      tmp = true;
    }
    return tmp;
  }
  p1s(head, previous, prevPrev, newParentState, newParentRuntimeLookaheadSet, buildSPPT) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp0_check = head.c1r();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_check) {
        var tmp$ret$0;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$0 = 'Check failed.';
        var message = tmp$ret$0;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var child = head.l29();
    var newParentNumNonSkipChildren = previous.y1q_1 + 1 | 0;
    var childPrio = listOf(head.e1s().e14());
    var tmp0_safe_receiver = previous.z1q_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : plus(tmp0_safe_receiver, childPrio);
    var childrenPriorities = tmp1_elvis_lhs == null ? childPrio : tmp1_elvis_lhs;
    var newParent = this.u29(newParentState, newParentRuntimeLookaheadSet, previous.v1q_1, head.w1q_1, head.x1q_1, newParentNumNonSkipChildren, childrenPriorities);
    var tmp;
    if (newParent.c1r()) {
      var existingComplete = this.z1r_1.c2a(newParent.l29());
      var tmp_0;
      if (!(null == existingComplete)) {
        var shouldDrop = mergeDecision(this, existingComplete, newParent.l29());
        var tmp2_subject = shouldDrop;
        var tmp0 = tmp2_subject.bc_1;
        var tmp_1;
        switch (tmp0) {
          case 1:
            tmp_1 = preferNewCompleteParentLastChild(this, previous, newParent, child, prevPrev);
            break;
          case 0:
            tmp_1 = preferExistingCompleteParentLastChild(this, previous, newParent, child, prevPrev);
            break;
          case 3:
            tmp_1 = keepBothCompleteParentsLastChild(this, previous, newParent, child, prevPrev);
            break;
          case 2:
            tmp_1 = useExistingCompleteParentLastChild(this, newParent, child, prevPrev);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_0 = tmp_1;
      } else {
        if (buildSPPT) {
          this.z1r_1.n29(previous, newParent.l29(), child, false);
        }
        addGrowingHead(this, prevPrev, newParent);
        tmp_0 = true;
      }
      tmp = tmp_0;
    } else {
      if (buildSPPT) {
        this.z1r_1.d2a(previous, newParent, child);
      }
      addGrowingHead(this, prevPrev, newParent);
      tmp = true;
    }
    return tmp;
  }
  r29(head) {
    if (!head.g14() ? !head.c1r() : false) {
      {
        this.z1r_1.e2a(head);
      }
    }
  }
  c1s(head) {
    var tmp = this.y1r_1;
    var dropped = tmp.f2a(head, ParseGraph$dropStackWithHead$lambda(this));
  }
  o1s(lookaheadGuard, eotLookahead, runtimeLookahead, nextInputPosition) {
    var tmp;
    if (lookaheadGuard.y11_1) {
      tmp = true;
    } else if (runtimeLookahead.w11_1) {
      throw IllegalStateException.y1('Runtime lookahead must be real lookahead values');
    } else if (eotLookahead.w11_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else {
      var rtResolved = runtimeLookahead.r13(eotLookahead, runtimeLookahead);
      var lhs = lookaheadGuard.s13(eotLookahead, rtResolved);
      var tmp_0;
      if (lhs.fy_1) {
        tmp_0 = true;
      } else if (lhs.ey_1 ? this.v1r_1.f1q(nextInputPosition) : false) {
        tmp_0 = true;
      } else if (lhs.gy_1.y()) {
        tmp_0 = false;
      } else {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp0_any = lhs.gy_1;
          var tmp_1;
          if (isInterface(tmp0_any, Collection)) {
            tmp_1 = tmp0_any.y();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = tmp0_any.u();
          while (tmp0_iterator.h1()) {
            var element = tmp0_iterator.j1();
            var tmp$ret$1;
            // Inline function 'net.akehurst.language.agl.runtime.graph.ParseGraph.isLookingAt.<anonymous>' call
            tmp$ret$1 = this.v1r_1.t1p(nextInputPosition, element);
            if (tmp$ret$1) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp_0 = tmp$ret$0;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  f1s(lookaheadGuard, eotLookahead, runtimeLookahead, nextInputPosition) {
    var tmp;
    if (lookaheadGuard.fy_1) {
      tmp = true;
    } else if (runtimeLookahead.dy_1) {
      throw IllegalStateException.y1('Runtime lookahead must be real lookahead values');
    } else if (eotLookahead.dy_1) {
      throw IllegalStateException.y1('EOT lookahead must be real lookahead values');
    } else {
      var rtResolved = runtimeLookahead.l17(eotLookahead, runtimeLookahead);
      var lhs = lookaheadGuard.l17(eotLookahead, rtResolved);
      var tmp_0;
      if (lhs.fy_1) {
        tmp_0 = true;
      } else if (lhs.ey_1 ? this.v1r_1.f1q(nextInputPosition) : false) {
        tmp_0 = true;
      } else if (lhs.gy_1.y()) {
        tmp_0 = false;
      } else {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp0_any = lhs.gy_1;
          var tmp_1;
          if (isInterface(tmp0_any, Collection)) {
            tmp_1 = tmp0_any.y();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var tmp0_iterator = tmp0_any.u();
          while (tmp0_iterator.h1()) {
            var element = tmp0_iterator.j1();
            var tmp$ret$1;
            // Inline function 'net.akehurst.language.agl.runtime.graph.ParseGraph.isLookingAt.<anonymous>' call
            tmp$ret$1 = this.v1r_1.t1p(nextInputPosition, element);
            if (tmp$ret$1) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp_0 = tmp$ret$0;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  b1s(goal) {
    doRecordGoal(this, goal.l29());
  }
  toString() {
    var heads = this.y1r_1.w29();
    var tmp = '[' + heads.o() + '] ';
    return tmp + joinToString(heads, '\n', VOID, VOID, VOID, VOID, ParseGraph$toString$lambda(this));
  }
}
class RuntimeState {
  constructor(state, runtimeLookaheadSet) {
    this.q1r_1 = state;
    this.r1r_1 = runtimeLookaheadSet;
    var tmp = this;
    tmp.s1r_1 = lazy(RuntimeState$uncompressed$delegate$lambda(this));
    var tmp_0 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.q1r_1, this.r1r_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_0.t1r_1 = contentHashCode(tmp$ret$2);
  }
  vx() {
    return this.q1r_1.vx();
  }
  i14(previous) {
    return this.q1r_1.i14(previous);
  }
  o14(previous) {
    return this.q1r_1.o14(previous);
  }
  q14(previous, prevPrev) {
    return this.q1r_1.q14(previous, prevPrev);
  }
  hashCode() {
    return this.t1r_1;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof RuntimeState)) {
      tmp = false;
    } else {
      if (!this.q1r_1.equals(other.q1r_1)) {
        tmp = false;
      } else {
        if (!equals(this.r1r_1, other.r1r_1)) {
          tmp = false;
        } else {
          tmp = true;
        }
      }
    }
    return tmp;
  }
  toString() {
    return 'RS{' + this.q1r_1.yy_1 + '[' + joinToString(this.r1r_1, '|', VOID, VOID, VOID, VOID, RuntimeState$toString$lambda) + ']}';
  }
}
class StateInfoUncompressed {
  constructor(rulePosition, follow) {
    this.g2a_1 = rulePosition;
    this.h2a_1 = follow;
  }
  toString() {
    return 'StateInfoUncompressed(rulePosition=' + this.g2a_1 + ', follow=' + this.h2a_1 + ')';
  }
  hashCode() {
    var result = this.g2a_1.hashCode();
    result = imul(result, 31) + hashCode(this.h2a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StateInfoUncompressed))
      return false;
    var tmp0_other_with_cast = other instanceof StateInfoUncompressed ? other : THROW_CCE();
    if (!this.g2a_1.equals(tmp0_other_with_cast.g2a_1))
      return false;
    if (!equals(this.h2a_1, tmp0_other_with_cast.h2a_1))
      return false;
    return true;
  }
}
class TreeData {
  constructor(forStateSetNumber) {
    this.p1t_1 = forStateSetNumber;
    this.q1t_1 = new TreeDataComplete(this.p1t_1);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.r1t_1 = tmp$ret$0;
  }
  c2a(node) {
    var tmp = this.q1t_1.preferred(node);
    return (tmp == null ? true : isInterface(tmp, SpptDataNode)) ? tmp : THROW_CCE();
  }
  y29(gni, initialSkipData) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var growing = tmp$ret$0;
    setGrowingChildren(this, gni, growing);
    this.q1t_1.start(initialSkipData);
  }
  e2a(node) {
    var childrenOfRemoved = removeGrowingNode(this, node);
  }
  a2a(parent, child, embeddedTreeData) {
    var completeChildren = listOf(child);
    this.q1t_1.setChildren(parent, completeChildren, true);
    this.q1t_1.setEmbeddedTreeFor(parent, embeddedTreeData);
  }
  m29(parent, child, isAlternative) {
    var completeChildren = listOf(child);
    this.q1t_1.setChildren(parent, completeChildren, isAlternative);
  }
  b2a(parent, child) {
    var growing = this.r1t_1.u3(parent);
    if (null == growing) {
      setGrowingChildren(this, parent, mutableListOf([child]));
    } else {
      setGrowingChildren(this, parent, mutableListOf([child]));
    }
  }
  n29(oldParent, newParent, nextChild, isAlternative) {
    var children = ensureNotNull(this.r1t_1.u3(oldParent));
    var nextChildIndex = children.o();
    var cpy = toMutableList(children);
    if (cpy.o() > nextChildIndex) {
      cpy.z(nextChildIndex, nextChild);
    } else if (cpy.o() === nextChildIndex) {
      cpy.e1(nextChild);
    } else {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.y1('Internal error: should never happen');
    }
    this.q1t_1.setChildren(newParent, cpy, isAlternative);
  }
  d2a(oldParent, newParent, nextChild) {
    var children = ensureNotNull(this.r1t_1.u3(oldParent));
    var nextChildIndex = children.o();
    var cpy = toMutableList(children);
    if (cpy.o() > nextChildIndex) {
      cpy.z(nextChildIndex, nextChild);
    } else if (cpy.o() === nextChildIndex) {
      cpy.e1(nextChild);
    } else {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.y1('Internal error: should never happen');
    }
    setGrowingChildren(this, newParent, cpy);
    if (null == this.r1t_1.u3(newParent)) {
    } else {
    }
  }
  z29(leafNodeIndex, skipData) {
    this.q1t_1.setSkipDataAfter(leafNodeIndex, skipData);
  }
  hashCode() {
    return this.p1t_1;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof TreeData)) {
      tmp = false;
    } else {
      tmp = other.p1t_1 === this.p1t_1;
    }
    return tmp;
  }
  toString() {
    return 'TreeData{' + this.p1t_1 + '}';
  }
}
class SpptDataNode {}
class CompleteNodeIndex {
  constructor(state, startPosition, nextInputPositionBeforeSkip, nextInputPositionAfterSkip) {
    this.b1t_1 = state;
    this.c1t_1 = startPosition;
    this.d1t_1 = nextInputPositionBeforeSkip;
    this.e1t_1 = nextInputPositionAfterSkip;
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp0_all = this.b1t_1.yy_1;
        var tmp;
        if (isInterface(tmp0_all, Collection)) {
          tmp = tmp0_all.y();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp0_iterator = tmp0_all.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$1;
          // Inline function 'net.akehurst.language.agl.runtime.graph.CompleteNodeIndex.<anonymous>' call
          tmp$ret$1 = element.vx();
          if (!tmp$ret$1) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      var tmp1_check = tmp$ret$0;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp1_check) {
        var tmp$ret$2;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$2 = 'Check failed.';
        var message = tmp$ret$2;
        throw IllegalStateException.y1(toString(message));
      }
    }
    var tmp_0 = this;
    var tmp$ret$5;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.c14(), this.c1t_1, this.e1t_1];
    var tmp$ret$4;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$3;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$3 = tmp0_arrayOf;
    tmp$ret$4 = tmp$ret$3;
    tmp$ret$5 = tmp$ret$4;
    tmp_0.f1t_1 = contentHashCode(tmp$ret$5);
    var tmp_1 = this;
    tmp_1.g1t_1 = lazy(CompleteNodeIndex$firstRule$delegate$lambda(this));
  }
  i2a() {
    return this.c1t_1;
  }
  t1g() {
    return this.b1t_1.z13();
  }
  c14() {
    return this.b1t_1.c14();
  }
  j2a() {
    return this.e1t_1;
  }
  k2a() {
    return this.d1t_1;
  }
  l2a() {
    return this.b1t_1.e14().p(0);
  }
  e14() {
    return this.b1t_1.e14();
  }
  hashCode() {
    return this.f1t_1;
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, SpptDataNode) : false)) {
      tmp = false;
    } else {
      if (!(this.c1t_1 === other.startPosition)) {
        tmp = false;
      } else {
        if (!(this.j2a() === other.nextInputPosition)) {
          tmp = false;
        } else {
          if (!this.t1g().equals(other.rule)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
  toString() {
    var tmp = this.c14();
    return 'CNI{' + this.c1t_1 + '-' + this.d1t_1 + ',' + joinToString(tmp, ',', '(', ')', VOID, VOID, CompleteNodeIndex$toString$lambda) + '|' + this.l2a() + '}';
  }
  get startPosition() {
    return this.i2a();
  }
  get rule() {
    return this.t1g();
  }
  get nextInputPosition() {
    return this.j2a();
  }
  get nextInputNoSkip() {
    return this.k2a();
  }
  get option() {
    return this.l2a();
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_26 = this;
  }
  v29(runtimeRule, numNonSkipChildren) {
    var tmp0_subject = runtimeRule.i11();
    var tmp;
    if (tmp0_subject instanceof RuntimeRuleRhsNonTerminal) {
      tmp = numNonSkipChildren;
    } else {
      if (tmp0_subject instanceof RuntimeRuleRhsTerminal) {
        tmp = 0;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
}
class GrowingNodeIndex {
  constructor(runtimeState, startPosition, nextInputPositionBeforeSkip, nextInputPositionAfterSkip, numNonSkipChildren, childrenPriorities) {
    Companion_getInstance_28();
    this.u1q_1 = runtimeState;
    this.v1q_1 = startPosition;
    this.w1q_1 = nextInputPositionBeforeSkip;
    this.x1q_1 = nextInputPositionAfterSkip;
    this.y1q_1 = numNonSkipChildren;
    this.z1q_1 = childrenPriorities;
    var tmp = this;
    tmp.a1r_1 = lazy(GrowingNodeIndex$complete$delegate$lambda(this));
    var tmp_0 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.u1q_1, this.v1q_1, this.x1q_1, this.y1q_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_0.b1r_1 = contentHashCode(tmp$ret$2);
  }
  l29() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = complete$factory();
    tmp$ret$0 = this.a1r_1.p3();
    return tmp$ret$0;
  }
  c1r() {
    return this.u1q_1.vx();
  }
  cy() {
    return this.u1q_1.q1r_1.jz_1;
  }
  e1s() {
    return this.u1q_1.q1r_1;
  }
  g14() {
    return this.u1q_1.q1r_1.g14();
  }
  f1u() {
    return this.v1q_1 === this.w1q_1;
  }
  hashCode() {
    return this.b1r_1;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(tmp0_subject instanceof GrowingNodeIndex)) {
      tmp = false;
    } else {
      tmp = !this.u1q_1.equals(other.u1q_1) ? false : !(this.v1q_1 === other.v1q_1) ? false : !(this.x1q_1 === other.x1q_1) ? false : !(this.y1q_1 === other.y1q_1) ? false : true;
    }
    return tmp;
  }
  toString() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.u1q_1.r1r_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.graph.GrowingNodeIndex.toString.<anonymous>' call
      var tmp = item.b12();
      tmp$ret$0 = joinToString(tmp, VOID, VOID, VOID, VOID, VOID, GrowingNodeIndex$toString$lambda);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var ct = tmp$ret$2;
    var ctStr = joinToString(ct, '|', '[', ']', VOID, VOID, GrowingNodeIndex$toString$lambda_0);
    return 'GNI{state=' + this.u1q_1.q1r_1 + ',lhs=' + ctStr + ',sp=' + this.v1q_1 + ',np=' + this.x1q_1 + ',nc=' + this.y1q_1 + '}';
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_27 = this;
    this.m2a_1 = 0;
    this.n2a_1 = -1;
    this.o2a_1 = 0;
    this.p2a_1 = 1;
    this.q2a_1 = 0;
    this.r2a_1 = 1;
    this.s2a_1 = 0;
    this.t2a_1 = 1;
    this.u2a_1 = 1;
    this.v2a_1 = 1;
    this.w2a_1 = 2;
  }
}
class RulePosition {
  constructor(rule, option, position) {
    Companion_getInstance_29();
    this.qx_1 = rule;
    this.rx_1 = option;
    this.sx_1 = position;
    this.tx_1 = new RuleOption(this.qx_1, this.rx_1);
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.qx_1, this.rx_1, this.sx_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.ux_1 = contentHashCode(tmp$ret$2);
  }
  t10() {
    Companion_getInstance_29();
    return 0 === this.sx_1;
  }
  vx() {
    Companion_getInstance_29();
    return -1 === this.sx_1;
  }
  cy() {
    return this.qx_1.cy();
  }
  s10() {
    return this.qx_1.s10();
  }
  a11() {
    var tmp;
    if (this.vx()) {
      tmp = emptySet();
    } else {
      tmp = this.qx_1.i11().y2a(this.rx_1, this.sx_1);
    }
    return tmp;
  }
  z2a() {
    Companion_getInstance_29();
    return new RulePosition(this.qx_1, this.rx_1, -1);
  }
  j1() {
    return this.vx() ? emptySet() : this.qx_1.i11().a2b(this);
  }
  hashCode() {
    return this.ux_1;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof RulePosition)) {
      tmp = false;
    } else {
      if (!(this.sx_1 === other.sx_1)) {
        tmp = false;
      } else {
        if (!(this.rx_1 === other.rx_1)) {
          tmp = false;
        } else {
          if (!this.qx_1.equals(other.qx_1)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
  toString() {
    var tmp;
    if (this.qx_1.equals(Companion_getInstance_33().l13_1)) {
      Companion_getInstance_33();
      tmp = '<EOT>';
    } else {
      tmp = this.qx_1.mz();
    }
    var r = tmp;
    var rhs = this.qx_1.i11();
    var tmp0_subject = rhs;
    var tmp_0;
    if (tmp0_subject instanceof RuntimeRuleRhsTerminal) {
      tmp_0 = this.rx_1;
    } else {
      if (tmp0_subject instanceof RuntimeRuleRhsNonTerminal) {
        var tmp1_subject = rhs;
        var tmp_1;
        if (tmp1_subject instanceof RuntimeRuleRhsGoal) {
          tmp_1 = this.rx_1;
        } else {
          if (tmp1_subject instanceof RuntimeRuleRhsConcatenation) {
            tmp_1 = this.rx_1;
          } else {
            if (tmp1_subject instanceof RuntimeRuleRhsChoice) {
              tmp_1 = this.rx_1;
            } else {
              if (tmp1_subject instanceof RuntimeRuleRhsOptional) {
                var tmp2_subject = this.rx_1;
                var tmp_2;
                Companion_getInstance_29();
                if (tmp2_subject === 1) {
                  tmp_2 = 'E';
                } else {
                  Companion_getInstance_29();
                  if (tmp2_subject === 0) {
                    tmp_2 = 'I';
                  } else {
                    tmp_2 = this.rx_1;
                  }
                }
                tmp_1 = tmp_2;
              } else {
                if (tmp1_subject instanceof RuntimeRuleRhsList) {
                  var tmp3_subject = this.rx_1;
                  var tmp_3;
                  Companion_getInstance_29();
                  if (tmp3_subject === 1) {
                    tmp_3 = 'E';
                  } else {
                    Companion_getInstance_29();
                    if (tmp3_subject === 0) {
                      tmp_3 = 'I';
                    } else {
                      tmp_3 = this.rx_1;
                    }
                  }
                  tmp_1 = tmp_3;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        tmp_0 = tmp_1;
      } else {
        noWhenBranchMatchedException();
      }
    }
    var o = tmp_0;
    var tmp4_subject = this.sx_1;
    {
      var pos;
      switch (tmp4_subject) {
        case 0:
          pos = 'SR';
          break;
        case -1:
          pos = 'ER';
          break;
        default:
          pos = this.sx_1.toString();
          break;
      }
    }
    var tmp5_subject = rhs;
    var tmp_4;
    if (tmp5_subject instanceof RuntimeRuleRhsTerminal) {
      tmp_4 = pos;
    } else {
      if (tmp5_subject instanceof RuntimeRuleRhsNonTerminal) {
        var tmp6_subject = rhs;
        var tmp_5;
        if (tmp6_subject instanceof RuntimeRuleRhsGoal) {
          tmp_5 = pos;
        } else {
          if (tmp6_subject instanceof RuntimeRuleRhsConcatenation) {
            tmp_5 = pos;
          } else {
            if (tmp6_subject instanceof RuntimeRuleRhsChoice) {
              tmp_5 = pos;
            } else {
              if (tmp6_subject instanceof RuntimeRuleRhsOptional) {
                var tmp7_subject = this.sx_1;
                var tmp_6;
                Companion_getInstance_29();
                if (tmp7_subject === 0) {
                  tmp_6 = 'BR';
                } else {
                  Companion_getInstance_29();
                  if (tmp7_subject === -1) {
                    tmp_6 = 'ER';
                  } else {
                    tmp_6 = pos;
                  }
                }
                tmp_5 = tmp_6;
              } else {
                if (tmp6_subject instanceof RuntimeRuleRhsList) {
                  var tmp8_subject = rhs;
                  var tmp_7;
                  if (tmp8_subject instanceof RuntimeRuleRhsListSimple) {
                    var tmp9_subject = this.sx_1;
                    var tmp_8;
                    Companion_getInstance_29();
                    if (tmp9_subject === 0) {
                      tmp_8 = 'BR';
                    } else {
                      Companion_getInstance_29();
                      if (tmp9_subject === 1) {
                        tmp_8 = 'MI';
                      } else {
                        Companion_getInstance_29();
                        if (tmp9_subject === -1) {
                          tmp_8 = 'ER';
                        } else {
                          tmp_8 = pos;
                        }
                      }
                    }
                    tmp_7 = tmp_8;
                  } else {
                    if (tmp8_subject instanceof RuntimeRuleRhsListSeparated) {
                      var tmp10_subject = this.sx_1;
                      var tmp_9;
                      Companion_getInstance_29();
                      if (tmp10_subject === 0) {
                        tmp_9 = 'BR';
                      } else {
                        Companion_getInstance_29();
                        if (tmp10_subject === 1) {
                          tmp_9 = 'LS';
                        } else {
                          Companion_getInstance_29();
                          if (tmp10_subject === 2) {
                            tmp_9 = 'LI';
                          } else {
                            Companion_getInstance_29();
                            if (tmp10_subject === -1) {
                              tmp_9 = 'ER';
                            } else {
                              tmp_9 = pos;
                            }
                          }
                        }
                      }
                      tmp_7 = tmp_9;
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                  tmp_5 = tmp_7;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        tmp_4 = tmp_5;
      } else {
        noWhenBranchMatchedException();
      }
    }
    var p = tmp_4;
    return 'RP(' + this.qx_1.mw_1 + '/' + r + ',' + toString(o) + ',' + p + ')';
  }
}
class RuleOption {
  constructor(runtimeRule, option) {
    this.b2b_1 = runtimeRule;
    this.c2b_1 = option;
    this.d2b_1 = this.b2b_1.cy();
  }
  toString() {
    return 'RuleOption{' + this.b2b_1.mz() + ',' + this.c2b_1 + '}';
  }
  hashCode() {
    var result = this.b2b_1.hashCode();
    result = imul(result, 31) + this.c2b_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuleOption))
      return false;
    var tmp0_other_with_cast = other instanceof RuleOption ? other : THROW_CCE();
    if (!this.b2b_1.equals(tmp0_other_with_cast.b2b_1))
      return false;
    if (!(this.c2b_1 === tmp0_other_with_cast.c2b_1))
      return false;
    return true;
  }
}
class Assoc extends Enum {}
class RuntimePreferenceOption {
  constructor(precedence, target, option, operators, associativity) {
    this.j1s_1 = precedence;
    this.k1s_1 = target;
    this.l1s_1 = option;
    this.m1s_1 = operators;
    this.n1s_1 = associativity;
  }
  toString() {
    return 'RuntimePreferenceOption(precedence=' + this.j1s_1 + ', target=' + this.k1s_1 + ', option=' + this.l1s_1 + ', operators=' + this.m1s_1 + ', associativity=' + this.n1s_1 + ')';
  }
  hashCode() {
    var result = this.j1s_1;
    result = imul(result, 31) + this.k1s_1.hashCode() | 0;
    result = imul(result, 31) + this.l1s_1 | 0;
    result = imul(result, 31) + hashCode(this.m1s_1) | 0;
    result = imul(result, 31) + this.n1s_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuntimePreferenceOption))
      return false;
    var tmp0_other_with_cast = other instanceof RuntimePreferenceOption ? other : THROW_CCE();
    if (!(this.j1s_1 === tmp0_other_with_cast.j1s_1))
      return false;
    if (!this.k1s_1.equals(tmp0_other_with_cast.k1s_1))
      return false;
    if (!(this.l1s_1 === tmp0_other_with_cast.l1s_1))
      return false;
    if (!equals(this.m1s_1, tmp0_other_with_cast.m1s_1))
      return false;
    if (!this.n1s_1.equals(tmp0_other_with_cast.n1s_1))
      return false;
    return true;
  }
}
class RuntimePreferenceRule {
  constructor(contextRule, options) {
    this.g1s_1 = contextRule;
    this.h1s_1 = options;
  }
  i1s(to, lh) {
    var tmp$ret$6;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.h1s_1;
    var tmp$ret$5;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$4;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimePreferenceRule.precedenceFor.<anonymous>' call
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp;
        if (isInterface(to, Collection)) {
          tmp = to.y();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator_0 = to.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          var tmp$ret$1;
          // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimePreferenceRule.precedenceFor.<anonymous>.<anonymous>' call
          tmp$ret$1 = element_0.qx_1.equals(element.k1s_1) ? element_0.rx_1 === element.l1s_1 : false;
          if (tmp$ret$1) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      var rpMatch = tmp$ret$0;
      var tmp_0;
      if (rpMatch) {
        var tmp$ret$2;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp0_any = element.m1s_1;
          var tmp_1;
          if (isInterface(tmp0_any, Collection)) {
            tmp_1 = tmp0_any.y();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$2 = false;
            break $l$block_2;
          }
          var tmp0_iterator_1 = tmp0_any.u();
          while (tmp0_iterator_1.h1()) {
            var element_1 = tmp0_iterator_1.j1();
            var tmp$ret$3;
            // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimePreferenceRule.precedenceFor.<anonymous>.<anonymous>' call
            tmp$ret$3 = lh.b12().w(element_1);
            if (tmp$ret$3) {
              tmp$ret$2 = true;
              break $l$block_2;
            }
          }
          tmp$ret$2 = false;
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = false;
      }
      tmp$ret$4 = tmp_0;
      if (tmp$ret$4) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$5 = tmp0_filterTo;
    tmp$ret$6 = tmp$ret$5;
    var r = tmp$ret$6;
    return r;
  }
}
class RuntimeRule {
  constructor(runtimeRuleSetNumber, ruleNumber, name, isSkip) {
    this.mw_1 = runtimeRuleSetNumber;
    this.nw_1 = ruleNumber;
    this.ow_1 = name;
    this.pw_1 = isSkip;
    var tmp = this;
    tmp.rw_1 = lazy(RuntimeRule$asTerminalRulePosition$delegate$lambda(this));
    var tmp_0 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.mw_1, this.nw_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp_0.sw_1 = contentHashCode(tmp$ret$2);
  }
  f1g(value) {
    this.qw_1 = value;
  }
  i11() {
    return _get__rhs__d2tz9p(this);
  }
  mz() {
    var tmp0_elvis_lhs = this.ow_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (this.s10()) {
        tmp_0 = toString(this.i11());
      } else {
        throw IllegalStateException.y1('Internal Error: no tag');
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  cy() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsGoal;
  }
  q11() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsEmpty;
  }
  ny() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsEmbedded;
  }
  r12() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsPattern;
  }
  s10() {
    var tmp0_subject = this.i11();
    var tmp;
    if (tmp0_subject instanceof RuntimeRuleRhsNonTerminal) {
      tmp = false;
    } else {
      if (tmp0_subject instanceof RuntimeRuleRhsEmpty) {
        tmp = true;
      } else {
        if (tmp0_subject instanceof RuntimeRuleRhsLiteral) {
          tmp = true;
        } else {
          if (tmp0_subject instanceof RuntimeRuleRhsPattern) {
            tmp = true;
          } else {
            if (tmp0_subject instanceof RuntimeRuleRhsEmbedded) {
              tmp = true;
            } else {
              if (tmp0_subject instanceof RuntimeRuleRhsCommonTerminal) {
                tmp = true;
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  d11() {
    var tmp0_subject = this.i11();
    var tmp;
    if (tmp0_subject instanceof RuntimeRuleRhsTerminal) {
      tmp = false;
    } else {
      if (tmp0_subject instanceof RuntimeRuleRhsGoal) {
        tmp = true;
      } else {
        if (tmp0_subject instanceof RuntimeRuleRhsConcatenation) {
          tmp = true;
        } else {
          if (tmp0_subject instanceof RuntimeRuleRhsChoice) {
            tmp = true;
          } else {
            if (tmp0_subject instanceof RuntimeRuleRhsOptional) {
              tmp = true;
            } else {
              if (tmp0_subject instanceof RuntimeRuleRhsList) {
                tmp = true;
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  a14() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsChoice;
  }
  e2b() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsOptional;
  }
  f2b() {
    var tmp;
    var tmp_0 = this.i11();
    if (tmp_0 instanceof RuntimeRuleRhsList) {
      var tmp_1 = this.i11();
      tmp = 0 === (tmp_1 instanceof RuntimeRuleRhsList ? tmp_1 : THROW_CCE()).r16();
    } else {
      tmp = false;
    }
    return tmp;
  }
  gn() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsList;
  }
  g2b() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsListSimple;
  }
  h2b() {
    var tmp = this.i11();
    return tmp instanceof RuntimeRuleRhsListSeparated;
  }
  vw() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = asTerminalRulePosition$factory();
    tmp$ret$0 = this.rw_1.p3();
    return tmp$ret$0;
  }
  f11() {
    return plus_0(this.b11(), this.tw());
  }
  tw() {
    return this.i11().tw();
  }
  b11() {
    return this.i11().b11();
  }
  b15() {
    return this.i11().b15();
  }
  i2b() {
    var tmp;
    if (this.s10()) {
      tmp = this.mz() === this.i11().i2b() ? this.mz() : this.mz() + '(' + this.i11().i2b() + ')';
    } else if (this.d11()) {
      tmp = this.mz() + ' = ' + this.i11().i2b();
    } else {
      throw IllegalStateException.y1('All rules should be either Terminal or NonTerminal');
    }
    return tmp;
  }
  hashCode() {
    return this.sw_1;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof RuntimeRule)) {
      tmp = false;
    } else {
      if (!(this.mw_1 === other.mw_1)) {
        tmp = false;
      } else {
        if (!(this.nw_1 === other.nw_1)) {
          tmp = false;
        } else {
          tmp = true;
        }
      }
    }
    return tmp;
  }
  toString() {
    var tmp;
    if (this.s10()) {
      tmp = this.mz() === toString(this.i11()) ? this.mz() : this.mz() + '(' + this.i11() + ')';
    } else if (this.d11()) {
      tmp = this.mz() + ' = ' + this.i11();
    } else {
      throw IllegalStateException.y1('All rules should be either Terminal or NonTerminal');
    }
    return tmp;
  }
}
class RuntimeRuleKind extends Enum {}
class Companion_28 {
  constructor() {
    Companion_instance_28 = this;
  }
  e1g(literalEscaped) {
    return replace(literalEscaped, '\\"', '"');
  }
}
class RuntimeRuleRhs {
  constructor(rule) {
    this.x2a_1 = rule;
  }
  i2b() {
    return toString(this);
  }
}
class RuntimeRuleRhsTerminal extends RuntimeRuleRhs {
  b15() {
    return emptyList();
  }
  tw() {
    return emptySet();
  }
  b11() {
    return emptySet();
  }
  y2a(option, position) {
    return emptySet();
  }
  a2b(current) {
    return emptySet();
  }
}
class RuntimeRuleRhsPattern extends RuntimeRuleRhsTerminal {
  constructor(rule, patternUnescaped) {
    Companion_getInstance_30();
    super(rule);
    this.p12_1 = patternUnescaped;
    var tmp = this;
    tmp.q12_1 = lazy(RuntimeRuleRhsPattern$regex$delegate$lambda(this));
  }
  g1q() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = regex$factory();
    tmp$ret$0 = this.q12_1.p3();
    return tmp$ret$0;
  }
  toString() {
    return '"' + this.p12_1 + '"';
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_29 = this;
  }
  e1g(literalEscaped) {
    return replace(replace(literalEscaped, "\\'", "'"), '\\\\', '\\');
  }
}
class RuntimeRuleRhsLiteral extends RuntimeRuleRhsTerminal {
  constructor(rule, literalUnescaped) {
    Companion_getInstance_31();
    super(rule);
    this.n12_1 = literalUnescaped;
  }
  toString() {
    return "'" + this.n12_1 + "'";
  }
}
class RuntimeRuleRhsEmbedded extends RuntimeRuleRhsTerminal {
  constructor(rule, embeddedRuntimeRuleSet, embeddedStartRule) {
    super(rule);
    this.k11_1 = embeddedRuntimeRuleSet;
    this.l11_1 = embeddedStartRule;
  }
  i2b() {
    return 'EMBED ::' + this.l11_1.mz();
  }
  toString() {
    return 'EMBED ' + this.k11_1.yt_1 + '::' + this.l11_1.mz() + '[' + this.l11_1.nw_1 + ']';
  }
}
class RuntimeRuleRhsNonTerminal extends RuntimeRuleRhs {}
class RuntimeRuleRhsConcatenation extends RuntimeRuleRhsNonTerminal {
  constructor(rule, concatItems) {
    super(rule);
    this.l2b_1 = concatItems;
  }
  b15() {
    return listOf(this.l2b_1);
  }
  tw() {
    return toSet(_get__rulePositions__zi96g4(this));
  }
  b11() {
    Companion_getInstance_29();
    return setOf(new RulePosition(this.x2a_1, 0, 0));
  }
  y2a(option, position) {
    return position < this.l2b_1.o() ? setOf(this.l2b_1.p(position)) : emptySet();
  }
  a2b(current) {
    var np = current.sx_1 + 1 | 0;
    return np === this.l2b_1.o() ? setOf(last_0(this.tw())) : np < this.l2b_1.o() ? setOf(_get__rulePositions__zi96g4(this).p(np - 1 | 0)) : emptySet();
  }
  i2b() {
    return 'CONCAT(' + joinToString(this.l2b_1, ' ', VOID, VOID, VOID, VOID, RuntimeRuleRhsConcatenation$_get_asString_$lambda_a0weeq) + ')';
  }
  toString() {
    return 'CONCAT(' + joinToString(this.l2b_1, ' ', VOID, VOID, VOID, VOID, RuntimeRuleRhsConcatenation$toString$lambda) + ')';
  }
}
class RuntimeRuleRhsChoice extends RuntimeRuleRhsNonTerminal {
  constructor(rule, choiceKind, options) {
    super(rule);
    this.x13_1 = choiceKind;
    this.y13_1 = options;
  }
  b15() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.y13_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsChoice.<get-rhsItems>.<anonymous>' call
      tmp$ret$0 = item.b15().p(0);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  tw() {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMapIndexed' call
    var tmp0_flatMapIndexed = this.y13_1;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapIndexedTo' call
    var tmp0_flatMapIndexedTo = ArrayList.i4();
    var index = 0;
    var tmp0_iterator = tmp0_flatMapIndexed.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsChoice.<get-rulePositionsNotAtStart>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = element.tw();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator_0 = tmp0_map.u();
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsChoice.<get-rulePositionsNotAtStart>.<anonymous>.<anonymous>' call
        tmp$ret$0 = new RulePosition(this.x2a_1, tmp1_anonymous, item.sx_1);
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapIndexedTo, list);
    }
    tmp$ret$4 = tmp0_flatMapIndexedTo;
    tmp$ret$5 = tmp$ret$4;
    return toSet(tmp$ret$5);
  }
  y2a(option, position) {
    return this.y13_1.p(option).y2a(0, position);
  }
  b11() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapIndexed' call
    var tmp0_mapIndexed = this.y13_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp0_mapIndexed, 10));
    var index = 0;
    var tmp0_iterator = tmp0_mapIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsChoice.<get-rulePositionsAtStart>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      Companion_getInstance_29();
      tmp$ret$0 = new RulePosition(this.x2a_1, tmp1_anonymous, 0);
      tmp0_mapIndexedTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapIndexedTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  }
  a2b(current) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.y13_1.p(current.rx_1).a2b(current);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsChoice.nextRulePositions.<anonymous>' call
      tmp$ret$0 = new RulePosition(this.x2a_1, current.rx_1, item.sx_1);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  }
  i2b() {
    return 'CHOICE(' + joinToString(this.y13_1, ' | ', VOID, VOID, VOID, VOID, RuntimeRuleRhsChoice$_get_asString_$lambda_pebp4n) + ')';
  }
  toString() {
    return 'CHOICE(' + joinToString(this.y13_1, ' | ', VOID, VOID, VOID, VOID, RuntimeRuleRhsChoice$toString$lambda) + ')';
  }
}
class RuntimeRuleRhsOptional extends RuntimeRuleRhsNonTerminal {
  constructor(rule, optionalItem) {
    super(rule);
    this.n2b_1 = optionalItem;
  }
  b15() {
    return listOf_0([listOf(this.n2b_1), listOf(Companion_getInstance_33().p13_1)]);
  }
  b11() {
    Companion_getInstance_29();
    Companion_getInstance_29();
    var tmp = new RulePosition(this.x2a_1, 0, 0);
    Companion_getInstance_29();
    Companion_getInstance_29();
    return setOf_0([tmp, new RulePosition(this.x2a_1, 1, 0)]);
  }
  tw() {
    Companion_getInstance_29();
    Companion_getInstance_29();
    var tmp = new RulePosition(this.x2a_1, 0, -1);
    Companion_getInstance_29();
    Companion_getInstance_29();
    return setOf_0([tmp, new RulePosition(this.x2a_1, 1, -1)]);
  }
  y2a(option, position) {
    var tmp0_subject = option;
    var tmp;
    Companion_getInstance_29();
    if (tmp0_subject === 1) {
      var tmp1_subject = position;
      var tmp_0;
      Companion_getInstance_29();
      if (tmp1_subject === 0) {
        tmp_0 = setOf(Companion_getInstance_33().p13_1);
      } else {
        tmp_0 = emptySet();
      }
      tmp = tmp_0;
    } else {
      Companion_getInstance_29();
      if (tmp0_subject === 0) {
        var tmp2_subject = position;
        var tmp_1;
        Companion_getInstance_29();
        if (tmp2_subject === 0) {
          tmp_1 = setOf(this.n2b_1);
        } else {
          Companion_getInstance_29();
          if (tmp2_subject === -1) {
            tmp_1 = emptySet();
          } else {
            tmp_1 = emptySet();
          }
        }
        tmp = tmp_1;
      } else {
        throw IllegalStateException.y1('Internal Error: Invalid option value for Optional');
      }
    }
    return tmp;
  }
  a2b(current) {
    return current.t10() ? setOf(current.z2a()) : emptySet();
  }
  toString() {
    return 'OPTIONAL ' + this.n2b_1.mz();
  }
}
class RuntimeRuleRhsList extends RuntimeRuleRhsNonTerminal {
  constructor(rule) {
    Companion_getInstance_32();
    super(rule);
  }
}
class RuntimeRuleRhsListSimple extends RuntimeRuleRhsList {
  constructor(rule, min, max, repeatedRhsItem) {
    super(rule);
    this.d16_1 = min;
    this.e16_1 = max;
    this.f16_1 = repeatedRhsItem;
  }
  r16() {
    return this.d16_1;
  }
  s16() {
    return this.e16_1;
  }
  b15() {
    return this.d16_1 === 0 ? listOf_0([listOf(this.f16_1), listOf(Companion_getInstance_33().p13_1)]) : listOf(listOf(this.f16_1));
  }
  b11() {
    var tmp;
    if (this.d16_1 < 0) {
      throw IllegalStateException.y1('Internal Error: min must be > 0');
    } else {
      var tmp_0;
      Companion_getInstance_32();
      if (!(-1 === this.e16_1)) {
        tmp_0 = this.d16_1 > this.e16_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        throw IllegalStateException.y1('Internal Error: max must be > min');
      } else {
        if (this.e16_1 === 0) {
          Companion_getInstance_29();
          Companion_getInstance_29();
          tmp = setOf(new RulePosition(this.x2a_1, 1, 0));
        } else {
          if (this.d16_1 > 0) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp = setOf(new RulePosition(this.x2a_1, 0, 0));
          } else {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_1 = new RulePosition(this.x2a_1, 0, 0);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp = setOf_0([tmp_1, new RulePosition(this.x2a_1, 1, 0)]);
          }
        }
      }
    }
    return tmp;
  }
  tw() {
    var tmp;
    if (this.d16_1 < 0) {
      throw IllegalStateException.y1('Internal Error: min must be > 0');
    } else {
      var tmp_0;
      Companion_getInstance_32();
      if (!(-1 === this.e16_1)) {
        tmp_0 = this.d16_1 > this.e16_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        throw IllegalStateException.y1('Internal Error: max must be > min');
      } else {
        if (this.e16_1 === 0) {
          Companion_getInstance_29();
          Companion_getInstance_29();
          tmp = setOf(new RulePosition(this.x2a_1, 1, -1));
        } else {
          if (this.d16_1 > 0) {
            var tmp0_subject = this.e16_1;
            var tmp_1;
            if (tmp0_subject === 1) {
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_1 = setOf(new RulePosition(this.x2a_1, 0, -1));
            } else {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_2 = new RulePosition(this.x2a_1, 0, 1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_1 = setOf_0([tmp_2, new RulePosition(this.x2a_1, 0, -1)]);
            }
            tmp = tmp_1;
          } else {
            var tmp1_subject = this.e16_1;
            var tmp_3;
            if (tmp1_subject === 1) {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_4 = new RulePosition(this.x2a_1, 0, -1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_3 = setOf_0([tmp_4, new RulePosition(this.x2a_1, 1, -1)]);
            } else {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_5 = new RulePosition(this.x2a_1, 0, 1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_6 = new RulePosition(this.x2a_1, 0, -1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_3 = setOf_0([tmp_5, tmp_6, new RulePosition(this.x2a_1, 1, -1)]);
            }
            tmp = tmp_3;
          }
        }
      }
    }
    return tmp;
  }
  y2a(option, position) {
    var tmp0_subject = option;
    var tmp;
    Companion_getInstance_29();
    if (tmp0_subject === 1) {
      var tmp1_subject = position;
      var tmp_0;
      Companion_getInstance_29();
      if (tmp1_subject === 0) {
        tmp_0 = setOf(Companion_getInstance_33().p13_1);
      } else {
        tmp_0 = emptySet();
      }
      tmp = tmp_0;
    } else {
      Companion_getInstance_29();
      if (tmp0_subject === 0) {
        var tmp2_subject = position;
        var tmp_1;
        Companion_getInstance_29();
        if (tmp2_subject === 0) {
          tmp_1 = setOf(this.f16_1);
        } else {
          Companion_getInstance_29();
          if (tmp2_subject === 1) {
            tmp_1 = setOf(this.f16_1);
          } else {
            tmp_1 = emptySet();
          }
        }
        tmp = tmp_1;
      } else {
        var tmp0_error = 'Internal Error: Invalid option value for SimpleList - ' + option;
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
    return tmp;
  }
  a2b(current) {
    var tmp0_subject = current.rx_1;
    var tmp;
    Companion_getInstance_29();
    if (tmp0_subject === 1) {
      tmp = (current.t10() ? 0 === this.d16_1 : false) ? setOf(current.z2a()) : emptySet();
    } else {
      Companion_getInstance_29();
      if (tmp0_subject === 0) {
        var tmp1_subject = current.sx_1;
        var tmp_0;
        Companion_getInstance_29();
        if (tmp1_subject === 0) {
          var tmp_1;
          if (1 === this.e16_1) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf(new RulePosition(this.x2a_1, 0, -1));
          } else if (2 <= this.d16_1) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf(new RulePosition(this.x2a_1, 0, 1));
          } else {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_2 = new RulePosition(this.x2a_1, 0, 1);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf_0([tmp_2, new RulePosition(this.x2a_1, 0, -1)]);
          }
          tmp_0 = tmp_1;
        } else {
          Companion_getInstance_29();
          if (tmp1_subject === 1) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_3 = new RulePosition(this.x2a_1, 0, 1);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_0 = setOf_0([tmp_3, new RulePosition(this.x2a_1, 0, -1)]);
          } else {
            Companion_getInstance_29();
            if (tmp1_subject === -1) {
              tmp_0 = emptySet();
            } else {
              tmp_0 = emptySet();
            }
          }
        }
        tmp = tmp_0;
      } else {
        var tmp0_error = 'Internal Error: Invalid option value for SimpleList - ' + current.rx_1;
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
    return tmp;
  }
  toString() {
    return 'LIST ' + this.f16_1.mz() + ' {' + this.d16_1 + ', ' + this.e16_1 + '}';
  }
}
class RuntimeRuleRhsListSeparated extends RuntimeRuleRhsList {
  constructor(rule, min, max, repeatedRhsItem, separatorRhsItem) {
    super(rule);
    this.p2b_1 = min;
    this.q2b_1 = max;
    this.r2b_1 = repeatedRhsItem;
    this.s2b_1 = separatorRhsItem;
  }
  r16() {
    return this.p2b_1;
  }
  s16() {
    return this.q2b_1;
  }
  b15() {
    return this.p2b_1 === 0 ? listOf_0([listOf(this.r2b_1), listOf(this.s2b_1), listOf(Companion_getInstance_33().p13_1)]) : listOf_0([listOf(this.r2b_1), listOf(this.s2b_1)]);
  }
  b11() {
    var tmp;
    if (this.p2b_1 < 0) {
      throw IllegalStateException.y1('Internal Error: min must be > 0');
    } else {
      var tmp_0;
      Companion_getInstance_32();
      if (!(-1 === this.q2b_1)) {
        tmp_0 = this.p2b_1 > this.q2b_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        throw IllegalStateException.y1('Internal Error: max must be > min');
      } else {
        if (this.q2b_1 === 0) {
          Companion_getInstance_29();
          Companion_getInstance_29();
          tmp = setOf(new RulePosition(this.x2a_1, 1, 0));
        } else {
          if (this.p2b_1 > 0) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp = setOf(new RulePosition(this.x2a_1, 0, 0));
          } else {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_1 = new RulePosition(this.x2a_1, 0, 0);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp = setOf_0([tmp_1, new RulePosition(this.x2a_1, 1, 0)]);
          }
        }
      }
    }
    return tmp;
  }
  tw() {
    var tmp;
    if (this.p2b_1 < 0) {
      throw IllegalStateException.y1('Internal Error: min must be > 0');
    } else {
      var tmp_0;
      Companion_getInstance_32();
      if (!(-1 === this.q2b_1)) {
        tmp_0 = this.p2b_1 > this.q2b_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        throw IllegalStateException.y1('Internal Error: max must be > min');
      } else {
        if (this.q2b_1 === 0) {
          Companion_getInstance_29();
          Companion_getInstance_29();
          tmp = setOf(new RulePosition(this.x2a_1, 1, -1));
        } else {
          if (this.p2b_1 > 0) {
            var tmp0_subject = this.q2b_1;
            var tmp_1;
            if (tmp0_subject === 1) {
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_1 = setOf(new RulePosition(this.x2a_1, 0, -1));
            } else {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_2 = new RulePosition(this.x2a_1, 0, 2);
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_3 = new RulePosition(this.x2a_1, 0, 1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_1 = setOf_0([tmp_2, tmp_3, new RulePosition(this.x2a_1, 0, -1)]);
            }
            tmp = tmp_1;
          } else {
            var tmp1_subject = this.q2b_1;
            var tmp_4;
            if (tmp1_subject === 1) {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_5 = new RulePosition(this.x2a_1, 0, -1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_4 = setOf_0([tmp_5, new RulePosition(this.x2a_1, 1, -1)]);
            } else {
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_6 = new RulePosition(this.x2a_1, 0, 2);
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_7 = new RulePosition(this.x2a_1, 0, 1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              var tmp_8 = new RulePosition(this.x2a_1, 0, -1);
              Companion_getInstance_29();
              Companion_getInstance_29();
              tmp_4 = setOf_0([tmp_6, tmp_7, tmp_8, new RulePosition(this.x2a_1, 1, -1)]);
            }
            tmp = tmp_4;
          }
        }
      }
    }
    return tmp;
  }
  y2a(option, position) {
    var tmp0_subject = option;
    var tmp;
    Companion_getInstance_29();
    if (tmp0_subject === 1) {
      var tmp1_subject = position;
      var tmp_0;
      Companion_getInstance_29();
      if (tmp1_subject === 0) {
        tmp_0 = setOf(Companion_getInstance_33().p13_1);
      } else {
        tmp_0 = emptySet();
      }
      tmp = tmp_0;
    } else {
      Companion_getInstance_29();
      if (tmp0_subject === 0) {
        var tmp2_subject = position;
        var tmp_1;
        Companion_getInstance_29();
        if (tmp2_subject === 0) {
          tmp_1 = setOf(this.r2b_1);
        } else {
          Companion_getInstance_29();
          if (tmp2_subject === 2) {
            tmp_1 = setOf(this.r2b_1);
          } else {
            Companion_getInstance_29();
            if (tmp2_subject === 1) {
              tmp_1 = setOf(this.s2b_1);
            } else {
              tmp_1 = emptySet();
            }
          }
        }
        tmp = tmp_1;
      } else {
        var tmp0_error = 'Internal Error: Invalid option value for SeparatedList - ' + option;
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
    return tmp;
  }
  a2b(current) {
    var tmp0_subject = current.rx_1;
    var tmp;
    Companion_getInstance_29();
    if (tmp0_subject === 1) {
      tmp = (current.t10() ? this.p2b_1 === 0 : false) ? setOf(current.z2a()) : emptySet();
    } else {
      Companion_getInstance_29();
      if (tmp0_subject === 0) {
        var tmp1_subject = current.sx_1;
        var tmp_0;
        Companion_getInstance_29();
        if (tmp1_subject === 0) {
          var tmp_1;
          if (1 === this.q2b_1) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf(new RulePosition(this.x2a_1, 0, -1));
          } else if (2 <= this.p2b_1) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf(new RulePosition(this.x2a_1, 0, 1));
          } else {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_2 = new RulePosition(this.x2a_1, 0, 1);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_1 = setOf_0([tmp_2, new RulePosition(this.x2a_1, 0, -1)]);
          }
          tmp_0 = tmp_1;
        } else {
          Companion_getInstance_29();
          if (tmp1_subject === 2) {
            Companion_getInstance_29();
            Companion_getInstance_29();
            var tmp_3 = new RulePosition(this.x2a_1, 0, 1);
            Companion_getInstance_29();
            Companion_getInstance_29();
            tmp_0 = setOf_0([tmp_3, new RulePosition(this.x2a_1, 0, -1)]);
          } else {
            Companion_getInstance_29();
            if (tmp1_subject === 1) {
              var tmp_4;
              if (this.q2b_1 > 1 ? true : -1 === this.q2b_1) {
                Companion_getInstance_29();
                Companion_getInstance_29();
                tmp_4 = setOf(new RulePosition(this.x2a_1, 0, 2));
              } else {
                throw IllegalStateException.y1('This should never happen!');
              }
              tmp_0 = tmp_4;
            } else {
              Companion_getInstance_29();
              if (tmp1_subject === -1) {
                tmp_0 = emptySet();
              } else {
                throw IllegalStateException.y1('This should never happen!');
              }
            }
          }
        }
        tmp = tmp_0;
      } else {
        var tmp0_error = 'Internal Error: Invalid option value for SeparatedList - ' + current.rx_1;
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
    return tmp;
  }
  toString() {
    return 'SLIST ' + this.r2b_1.mz() + ' ' + this.s2b_1.mz() + ' {' + this.p2b_1 + ', ' + this.q2b_1 + '}';
  }
}
class RuntimeRuleChoiceKind extends Enum {}
class RuntimeRuleRhsGoal extends RuntimeRuleRhsNonTerminal {
  constructor(rule, userGoalRuleItem) {
    super(rule);
    this.u2b_1 = userGoalRuleItem;
    this.v2b_1 = listOf(listOf(this.u2b_1));
  }
  b15() {
    return this.v2b_1;
  }
  tw() {
    Companion_getInstance_29();
    var tmp = new RulePosition(this.x2a_1, 0, 0);
    Companion_getInstance_29();
    return setOf_0([tmp, new RulePosition(this.x2a_1, 0, -1)]);
  }
  b11() {
    Companion_getInstance_29();
    return setOf(new RulePosition(this.x2a_1, 0, 0));
  }
  y2a(option, position) {
    var tmp0_subject = position;
    return tmp0_subject === 0 ? setOf(this.u2b_1) : emptySet();
  }
  a2b(current) {
    return current.t10() ? setOf(last_0(this.tw())) : emptySet();
  }
  toString() {
    return 'GOAL (' + this.u2b_1.mz() + '[' + this.u2b_1.nw_1 + ']';
  }
}
class RuntimeRuleRhsEmpty extends RuntimeRuleRhsTerminal {
  toString() {
    return Companion_getInstance_33().p13_1.mz();
  }
}
class RuntimeRuleRhsCommonTerminal extends RuntimeRuleRhsTerminal {
  toString() {
    return this.x2a_1.mz();
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_30 = this;
    this.w2b_1 = -1;
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_31 = this;
    this.s12_1 = 0;
    var tmp = this;
    tmp.t12_1 = lazyMutableMapNonNull(RuntimeRuleSet$Companion$numberForGrammar$lambda);
    this.u12_1 = -1;
    this.v12_1 = -1;
    this.w12_1 = -2;
    this.x12_1 = -3;
    this.y12_1 = -4;
    this.z12_1 = -6;
    this.a13_1 = -7;
    this.b13_1 = -8;
    this.c13_1 = -9;
    this.d13_1 = '<EOT>';
    this.e13_1 = '<GOAL>';
    this.f13_1 = '<SKIP-MULTI>';
    this.g13_1 = '<SKIP-CHOICE>';
    this.h13_1 = '<RT>';
    this.i13_1 = '<ANY>';
    this.j13_1 = '<UNDEFINED>';
    this.k13_1 = '<EMPTY>';
    var tmp_0 = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new RuntimeRule(-1, -2, '<EOT>', false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.runtime.structure.Companion.END_OF_TEXT.<anonymous>' call
    tmp0_also.f1g(new RuntimeRuleRhsCommonTerminal(tmp0_also));
    tmp$ret$0 = tmp0_also;
    tmp_0.l13_1 = tmp$ret$0;
    var tmp_1 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also_0 = new RuntimeRule(-1, -6, '<RT>', false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.runtime.structure.Companion.USE_RUNTIME_LOOKAHEAD.<anonymous>' call
    tmp0_also_0.f1g(new RuntimeRuleRhsCommonTerminal(tmp0_also_0));
    tmp$ret$1 = tmp0_also_0;
    tmp_1.m13_1 = tmp$ret$1;
    var tmp_2 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.also' call
    var tmp0_also_1 = new RuntimeRule(-1, -7, '<ANY>', false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.runtime.structure.Companion.ANY_LOOKAHEAD.<anonymous>' call
    tmp0_also_1.f1g(new RuntimeRuleRhsCommonTerminal(tmp0_also_1));
    tmp$ret$2 = tmp0_also_1;
    tmp_2.n13_1 = tmp$ret$2;
    var tmp_3 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.also' call
    var tmp0_also_2 = new RuntimeRule(-1, -8, '<UNDEFINED>', false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.runtime.structure.Companion.UNDEFINED_RULE.<anonymous>' call
    tmp0_also_2.f1g(new RuntimeRuleRhsCommonTerminal(tmp0_also_2));
    tmp$ret$3 = tmp0_also_2;
    tmp_3.o13_1 = tmp$ret$3;
    var tmp_4 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.also' call
    var tmp0_also_3 = new RuntimeRule(-1, -9, '<EMPTY>', false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.runtime.structure.Companion.EMPTY.<anonymous>' call
    tmp0_also_3.f1g(new RuntimeRuleRhsEmpty(tmp0_also_3));
    tmp$ret$4 = tmp0_also_3;
    tmp_4.p13_1 = tmp$ret$4;
  }
}
class sam$kotlin_Comparator$0_7 {
  constructor(function_0) {
    this.x2b_1 = function_0;
  }
  rc(a, b) {
    return this.x2b_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class RuntimeRuleSet {
  constructor(number, qualifiedName, runtimeRules, precedenceRules) {
    Companion_getInstance_33();
    this.yt_1 = number;
    this.zt_1 = qualifiedName;
    this.au_1 = runtimeRules;
    this.bu_1 = precedenceRules;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.cu_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.du_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.eu_1 = tmp$ret$2;
    var tmp_2 = this;
    tmp_2.fu_1 = lazyMutableMapNonNull(RuntimeRuleSet$goalRuleFor$lambda(this));
    var tmp_3 = this;
    tmp_3.gu_1 = lazy(RuntimeRuleSet$skipRules$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.hu_1 = lazy(RuntimeRuleSet$skipTerminals$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.iu_1 = lazy(RuntimeRuleSet$nonSkipRules$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.ju_1 = lazy(RuntimeRuleSet$nonSkipTerminals$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.ku_1 = lazy(RuntimeRuleSet$terminalRules$delegate$lambda(this));
    var tmp_8 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$3 = LinkedHashMap.n8();
    tmp_8.lu_1 = tmp$ret$3;
    var tmp_9 = this;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$4 = LinkedHashMap.n8();
    tmp_9.mu_1 = tmp$ret$4;
    var tmp_10 = this;
    tmp_10.nu_1 = lazy(RuntimeRuleSet$skipParserStateSet$delegate$lambda(this));
    this.ou_1 = 0;
    var tmp0_iterator = this.au_1.u();
    while (tmp0_iterator.h1()) {
      var rr = tmp0_iterator.j1();
      if (rr.s10()) {
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = this.du_1;
        var tmp1_set = rr.mz();
        var tmp2_set = rr.nw_1;
        tmp0_set.m3(tmp1_set, tmp2_set);
      } else if (rr.d11()) {
        // Inline function 'kotlin.collections.set' call
        var tmp3_set = this.cu_1;
        var tmp4_set = rr.mz();
        var tmp5_set = rr.nw_1;
        tmp3_set.m3(tmp4_set, tmp5_set);
      } else if (rr.ny()) {
        // Inline function 'kotlin.collections.set' call
        var tmp6_set = this.eu_1;
        var tmp7_set = rr.mz();
        var tmp8_set = rr.nw_1;
        tmp6_set.m3(tmp7_set, tmp8_set);
      }
    }
  }
  y2b() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = skipRules$factory();
    tmp$ret$0 = this.gu_1.p3();
    return tmp$ret$0;
  }
  n11() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = skipTerminals$factory();
    tmp$ret$0 = this.hu_1.p3();
    return tmp$ret$0;
  }
  h1v() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = nonSkipTerminals$factory();
    tmp$ret$0 = this.ju_1.p3();
    return tmp$ret$0;
  }
  a1v() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = terminalRules$factory();
    tmp$ret$0 = this.ku_1.p3();
    return tmp$ret$0;
  }
  h1u() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = skipParserStateSet$factory();
    tmp$ret$0 = this.nu_1.p3();
    return tmp$ret$0;
  }
  i1f(goalRuleName, automatonKind) {
    this.y1u(goalRuleName, automatonKind);
    return ensureNotNull(this.lu_1.u3(goalRuleName));
  }
  j22(goalRuleName) {
    return ensureNotNull(this.lu_1.u3(goalRuleName));
  }
  y1u(userGoalRuleName, automatonKind) {
    var ss = this.m11(userGoalRuleName, automatonKind);
    return ss.eo();
  }
  l24(userGoalRuleName, automaton) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.lu_1;
    var tmp1_set = automaton instanceof ParserStateSet ? automaton : THROW_CCE();
    tmp0_set.m3(userGoalRuleName, tmp1_set);
  }
  m11(userGoalRuleName, automatonKind) {
    var stateSet = this.lu_1.u3(userGoalRuleName);
    if (null == stateSet) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.ou_1;
      tmp0_this.ou_1 = tmp1 + 1 | 0;
      stateSet = new ParserStateSet(tmp1, this, this.pu(userGoalRuleName), false, automatonKind, false);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.lu_1;
      var tmp1_set = stateSet;
      tmp0_set.m3(userGoalRuleName, tmp1_set);
    }
    return stateSet;
  }
  pu(tag) {
    var tmp0_elvis_lhs = this.cu_1.u3(tag);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.du_1.u3(tag) : tmp0_elvis_lhs;
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.eu_1.u3(tag) : tmp1_elvis_lhs;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp0_error = "Internal Error: RuntimeRule '" + tag + "' not found";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var number = tmp;
    return this.au_1.p(number);
  }
  z2b(tag) {
    var tmp0_elvis_lhs = this.du_1.u3(tag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ParserException.d2c('Terminal RuntimeRule ' + tag + ' not found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var number = tmp;
    return this.au_1.p(number);
  }
  s15(precedenceContext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.bu_1;
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.precedenceRulesFor.<anonymous>' call
        tmp$ret$0 = element.g1s_1.equals(precedenceContext);
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  toString() {
    var tmp$ret$4;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.au_1;
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = RuntimeRuleSet$toString$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0_7(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var tmp1_map = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
    var tmp0_iterator = tmp1_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.toString.<anonymous>' call
      tmp$ret$2 = '  ' + item.i2b();
      tmp0_mapTo.e1(tmp$ret$2);
    }
    tmp$ret$3 = tmp0_mapTo;
    tmp$ret$4 = tmp$ret$3;
    var rulesStr = joinToString(tmp$ret$4, '\n');
    return trimIndent("\nRuntimeRuleSet '" + this.zt_1 + "' {\n" + rulesStr + '\n}\n');
  }
  hashCode() {
    return this.yt_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof RuntimeRuleSet) {
      tmp = this.yt_1 === other.yt_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class sam$kotlin_Comparator$0_8 {
  constructor(function_0) {
    this.e2c_1 = function_0;
  }
  rc(a, b) {
    return this.e2c_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class SharedPackedParseTreeVisitor {}
function visitNode(target, arg) {
  var tmp0_subject = target;
  var tmp;
  if (isInterface(tmp0_subject, SPPTLeaf)) {
    tmp = this.visitLeaf(target, arg);
  } else {
    if (isInterface(tmp0_subject, SPPTBranch)) {
      tmp = this.visitBranch(target, arg);
    } else {
      var tmp0_error = 'Unknown subtype of SPPTNode ' + getKClassFromExpression(target).n9();
      throw IllegalStateException.y1(toString(tmp0_error));
    }
  }
  return tmp;
}
class CountTreesVisitor {
  visitTree(target, arg) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg();
  }
  visitLeaf(target, arg) {
    return 1;
  }
  visitBranch(target, arg) {
    var currentCount = 0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = target.childrenAlternatives.l3();
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = CountTreesVisitor$visitBranch$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0_8(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var tmp0_iterator = tmp$ret$1.u();
    while (tmp0_iterator.h1()) {
      var tmp1_loop_parameter = tmp0_iterator.j1();
      var tmp$ret$2;
      // Inline function 'kotlin.collections.component1' call
      tmp$ret$2 = tmp1_loop_parameter.o3();
      var alt = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.collections.component2' call
      tmp$ret$3 = tmp1_loop_parameter.p3();
      var children = tmp$ret$3;
      if (children.y()) {
        currentCount = currentCount + 1 | 0;
      } else {
        var max = 0;
        var inductionVariable = 0;
        var last = children.o();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$4;
            // Inline function 'kotlin.comparisons.maxOf' call
            var tmp1_maxOf = max;
            var tmp_0 = children.p(i);
            var tmp2_maxOf = this.visitNode(tmp_0, Unit_getInstance());
            tmp$ret$4 = Math.max(tmp1_maxOf, tmp2_maxOf);
            max = tmp$ret$4;
          }
           while (inductionVariable < last);
        currentCount = currentCount + max | 0;
      }
    }
    return currentCount;
  }
}
class SharedPackedParseTree {}
function toStringAllWithIndent(indentIncrement, skipDataAsTree, $super) {
  skipDataAsTree = skipDataAsTree === VOID ? false : skipDataAsTree;
  return this.z2c(indentIncrement, skipDataAsTree);
}
class SPPTFromTreeData {
  constructor(treeData, sentence, seasons, maxNumHeads) {
    this.f2c_1 = treeData;
    this.g2c_1 = sentence;
    this.h2c_1 = seasons;
    this.i2c_1 = maxNumHeads;
    var tmp = this;
    tmp.j2c_1 = lazy(SPPTFromTreeData$_tokensByLine$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.k2c_1 = lazy(SPPTFromTreeData$asSentence$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.l2c_1 = lazy(SPPTFromTreeData$countTrees$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.m2c_1 = lazy(SPPTFromTreeData$toStringAll$delegate$lambda(this));
  }
  t2c() {
    return this.f2c_1;
  }
  u2c() {
    return this.h2c_1;
  }
  v2c() {
    return this.i2c_1;
  }
  w2c() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = asSentence$factory();
    tmp$ret$0 = this.k2c_1.p3();
    return tmp$ret$0;
  }
  x2c() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = countTrees$factory();
    tmp$ret$0 = this.l2c_1.p3();
    return tmp$ret$0;
  }
  y2c() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = toStringAll$factory();
    tmp$ret$0 = this.m2c_1.p3();
    return tmp$ret$0;
  }
  traverseTreeDepthFirst(callback, skipDataAsTree) {
    this.f2c_1.traverseTreeDepthFirst(callback, skipDataAsTree);
  }
  tokensByLineAll() {
    return _get__tokensByLine__ebyq43(this);
  }
  tokensByLine(line) {
    var tbl = _get__tokensByLine__ebyq43(this);
    var tmp;
    if (tbl.y() ? true : line >= tbl.o()) {
      tmp = emptyList();
    } else {
      tmp = tbl.p(line);
    }
    return tmp;
  }
  z2c(indentIncrement, skipDataAsTree) {
    var walker = new SpptWalkerToString(this.g2c_1, indentIncrement);
    this.f2c_1.traverseTreeDepthFirst(walker, skipDataAsTree);
    return walker.s2c();
  }
  hashCode() {
    return this.f2c_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, SharedPackedParseTree) : false)) {
      tmp = false;
    } else {
      if (!this.f2c_1.matches(other.treeData)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  get treeData() {
    return this.t2c();
  }
  get seasons() {
    return this.u2c();
  }
  get maxNumHeads() {
    return this.v2c();
  }
  get asSentence() {
    return this.w2c();
  }
  get countTrees() {
    return this.x2c();
  }
  get toStringAll() {
    return this.y2c();
  }
}
class SPPTParser {}
function parse_0(treeAsString, addTree, $super) {
  addTree = addTree === VOID ? false : addTree;
  return this.j2d(treeAsString, addTree);
}
class SPPTParserDefault {
  constructor(rootRuntimeRuleSet, embeddedRuntimeRuleSets) {
    embeddedRuntimeRuleSets = embeddedRuntimeRuleSets === VOID ? emptyMap() : embeddedRuntimeRuleSets;
    this.e2d_1 = rootRuntimeRuleSet;
    this.f2d_1 = embeddedRuntimeRuleSets;
    this.g2d_1 = null;
  }
  i2d() {
    var tmp = this.h2d_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tree');
    }
  }
  clear() {
  }
  j2d(treeAsString, addTree) {
    var tp = new TreeParser(treeAsString, this.f2d_1);
    var tmp;
    if (addTree) {
      tmp = this.g2d_1;
    } else {
      tmp = null;
    }
    var oldTree = tmp;
    var td = tp.u2d(this.e2d_1, oldTree);
    this.g2d_1 = td;
    var tmp_0 = this;
    tmp_0.h2d_1 = new SPPTFromTreeData(td instanceof TreeDataComplete ? td : THROW_CCE(), new SentenceDefault(tp.f26()), -1, -1);
    return this.i2d();
  }
  get tree() {
    return this.i2d();
  }
}
class TreeParser {
  constructor(treeAsString, embeddedRuntimeRuleSets) {
    this.k2d_1 = treeAsString;
    this.l2d_1 = embeddedRuntimeRuleSets;
    this.m2d_1 = new SimpleScanner(this.k2d_1, Tokens_getInstance().y2d_1);
    this.n2d_1 = 0;
    this.o2d_1 = 0;
    this.p2d_1 = mutableStackOf([]);
    this.q2d_1 = mutableStackOf([]);
    this.r2d_1 = mutableStackOf([]);
    this.s2d_1 = mutableStackOf([]);
    this.t2d_1 = StringBuilder.qa();
  }
  f26() {
    return this.t2d_1.toString();
  }
  u2d(rootRuntimeRuleSet, oldTree) {
    beginTree(this, rootRuntimeRuleSet, oldTree);
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    this.r2d_1.v1a(tmp$ret$0);
    while (this.m2d_1.r2e()) {
      if (this.m2d_1.s2e([Tokens_getInstance().z2d_1])) {
        scanEmpty(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().b2e_1, Tokens_getInstance().g2e_1, Tokens_getInstance().e2e_1])) {
        scanLeafLiteral(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().b2e_1, Tokens_getInstance().g2e_1, Tokens_getInstance().b2e_1, Tokens_getInstance().c2e_1, Tokens_getInstance().b2e_1, Tokens_getInstance().h2e_1])) {
        scanEmbedded(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().b2e_1, Tokens_getInstance().d2e_1, Tokens_getInstance().h2e_1])) {
        scanBranchStartWithOption(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().b2e_1, Tokens_getInstance().h2e_1])) {
        scanBranchStart(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().e2e_1])) {
        scanLiteral(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().f2e_1, Tokens_getInstance().g2e_1, Tokens_getInstance().e2e_1])) {
        scanPattern(this);
      } else if (this.m2d_1.s2e([Tokens_getInstance().i2e_1])) {
        scanBranchEnd(this);
      } else {
        scanError(this);
      }
    }
    var urn = last(this.r2d_1.w1a());
    return endTree(this, urn);
  }
  toString() {
    return this.m2d_1.toString();
  }
}
class SimpleScanner {
  constructor(input, skip) {
    this.v2d_1 = input;
    this.w2d_1 = skip;
    this.x2d_1 = this.t2e(0).si_1;
  }
  r2e() {
    return this.x2d_1 < charSequenceLength(this.v2d_1);
  }
  s2e(patterns) {
    var pos = this.x2d_1;
    var indexedObject = patterns;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var pat = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var match = pat.match(this.v2d_1, pos);
      var tmp1_subject = match;
      if (tmp1_subject == null)
        return false;
      else {
        pos = pos + match.matchedText.length | 0;
        pos = this.t2e(pos).si_1;
      }
    }
    return true;
  }
  j2e(pattern) {
    var match = pattern.match(this.v2d_1, this.x2d_1);
    var tmp;
    if (!(null == match)) {
      var matchStr = match.matchedText;
      var tmp0_this = this;
      tmp0_this.x2d_1 = tmp0_this.x2d_1 + matchStr.length | 0;
      this.x2d_1 = this.t2e(this.x2d_1).si_1;
      tmp = matchStr;
    } else {
      var tmp0_error = 'Error scanning for pattern ' + pattern + ' at Position ' + this.x2d_1;
      throw IllegalStateException.y1(toString(tmp0_error));
    }
    return tmp;
  }
  t2e(at) {
    var pos = at;
    var match = this.w2d_1.match(this.v2d_1, pos);
    var tmp;
    if (!(null == match)) {
      var matchStr = match.matchedText;
      pos = pos + matchStr.length | 0;
      tmp = new Pair(matchStr, pos);
    } else {
      tmp = new Pair('', pos);
    }
    return tmp;
  }
  toString() {
    var x = 5;
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp1_substring = this.v2d_1;
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var tmp0_maxOf = this.x2d_1 - x | 0;
    tmp$ret$0 = Math.max(0, tmp0_maxOf);
    var tmp2_substring = tmp$ret$0;
    var tmp3_substring = this.x2d_1;
    tmp$ret$1 = toString(charSequenceSubSequence(tmp1_substring, tmp2_substring, tmp3_substring));
    var before = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.text.substring' call
    var tmp6_substring = this.v2d_1;
    var tmp7_substring = this.x2d_1;
    var tmp$ret$2;
    // Inline function 'kotlin.comparisons.minOf' call
    var tmp4_minOf = charSequenceLength(this.v2d_1);
    var tmp5_minOf = this.x2d_1 + x | 0;
    tmp$ret$2 = Math.min(tmp4_minOf, tmp5_minOf);
    var tmp8_substring = tmp$ret$2;
    tmp$ret$3 = toString(charSequenceSubSequence(tmp6_substring, tmp7_substring, tmp8_substring));
    var after = tmp$ret$3;
    return before + '^' + after;
  }
}
class Tokens {
  constructor() {
    Tokens_instance = this;
    this.y2d_1 = regexMatcher('\\s+');
    this.z2d_1 = regexMatcher('\xA7empty|<EMPTY>');
    this.a2e_1 = regexMatcher('[a-zA-Z_\xA7][.a-zA-Z_0-9\xA7]*');
    this.b2e_1 = regexMatcher('[a-zA-Z_\xA7][a-zA-Z_0-9\xA7]*');
    this.c2e_1 = regexMatcher('::');
    this.d2e_1 = regexMatcher('[|][0-9]+');
    this.e2e_1 = regexMatcher("'([^'\\\\]|\\\\.)*'");
    this.f2e_1 = regexMatcher('"([^"\\\\]|\\\\.)*"');
    this.g2e_1 = regexMatcher('[:]');
    this.h2e_1 = regexMatcher('[{]');
    this.i2e_1 = regexMatcher('[}]');
  }
}
class NodeStart {
  constructor(ref, option, sentenceStartPosition, sentenceNextInputPosition) {
    this.k2e_1 = ref;
    this.l2e_1 = option;
    this.m2e_1 = sentenceStartPosition;
    this.n2e_1 = sentenceNextInputPosition;
  }
  toString() {
    return 'NodeStart(ref=' + this.k2e_1 + ', option=' + this.l2e_1 + ', sentenceStartPosition=' + this.m2e_1 + ', sentenceNextInputPosition=' + this.n2e_1 + ')';
  }
  hashCode() {
    var result = this.k2e_1.hashCode();
    result = imul(result, 31) + this.l2e_1 | 0;
    result = imul(result, 31) + this.m2e_1 | 0;
    result = imul(result, 31) + this.n2e_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeStart))
      return false;
    var tmp0_other_with_cast = other instanceof NodeStart ? other : THROW_CCE();
    if (!this.k2e_1.equals(tmp0_other_with_cast.k2e_1))
      return false;
    if (!(this.l2e_1 === tmp0_other_with_cast.l2e_1))
      return false;
    if (!(this.m2e_1 === tmp0_other_with_cast.m2e_1))
      return false;
    if (!(this.n2e_1 === tmp0_other_with_cast.n2e_1))
      return false;
    return true;
  }
}
class RuleReference {
  constructor(qname, name) {
    this.o2e_1 = qname;
    this.p2e_1 = name;
  }
  q2e() {
    return !(null == this.o2e_1);
  }
  toString() {
    return 'RuleReference(qname=' + this.o2e_1 + ', name=' + this.p2e_1 + ')';
  }
  hashCode() {
    var result = this.o2e_1 == null ? 0 : this.o2e_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RuleReference))
      return false;
    var tmp0_other_with_cast = other instanceof RuleReference ? other : THROW_CCE();
    if (!equals(this.o2e_1, tmp0_other_with_cast.o2e_1))
      return false;
    if (!(this.p2e_1 === tmp0_other_with_cast.p2e_1))
      return false;
    return true;
  }
}
class QName {
  constructor(full) {
    this.u2e_1 = full;
  }
  toString() {
    return 'QName(full=' + this.u2e_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.u2e_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof QName))
      return false;
    var tmp0_other_with_cast = other instanceof QName ? other : THROW_CCE();
    if (!(this.u2e_1 === tmp0_other_with_cast.u2e_1))
      return false;
    return true;
  }
}
class SpptWalker {}
class SpptWalkerToInputSentence {
  constructor(sentence) {
    this.q2c_1 = sentence;
    this.r2c_1 = mutableStackOf([]);
  }
  s2c() {
    var tmp = this.r2c_1.c29();
    return joinToString(tmp, '', VOID, VOID, VOID, VOID, SpptWalkerToInputSentence$_get_output_$lambda_e38anc);
  }
  beginTree() {
  }
  endTree() {
  }
  skip(startPosition, nextInputPosition) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.q2c_1.u1p();
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_substring;
    tmp$ret$1 = tmp$ret$0.substring(startPosition, nextInputPosition);
    var matchedText = tmp$ret$1;
    if (this.r2c_1.k17()) {
      this.r2c_1.v1a(new Pair(-1, matchedText));
    } else {
      var p = this.r2c_1.w1a();
      this.r2c_1.v1a(new Pair(p.ri_1, p.si_1 + matchedText));
    }
  }
  leaf(nodeInfo) {
    var matchedText = this.q2c_1.k1v(nodeInfo.node);
    this.r2c_1.v1a(new Pair(nodeInfo.alt.option, matchedText));
  }
  beginBranch(nodeInfo) {
  }
  endBranch(nodeInfo) {
    var numChildren = ensureNotNull(nodeInfo.numChildrenAlternatives.u3(nodeInfo.alt.option));
    var chText = reversed(this.r2c_1.v2e(numChildren));
    var text = joinToString(chText, '', VOID, VOID, VOID, VOID, SpptWalkerToInputSentence$endBranch$lambda);
    this.r2c_1.v1a(new Pair(nodeInfo.alt.option, text));
  }
  beginEmbedded(nodeInfo) {
    this.beginBranch(nodeInfo);
  }
  endEmbedded(nodeInfo) {
    this.endBranch(nodeInfo);
  }
  error(msg, path) {
    var p = path();
    var txt = 'Error at ' + last(p).startPosition + ": '" + msg + "'";
    this.r2c_1.v1a(new Pair(-1, txt));
    println(txt);
  }
}
class SpptWalkerToString {
  constructor(sentence, indentDelta) {
    this.a2d_1 = sentence;
    this.b2d_1 = indentDelta;
    this.c2d_1 = '';
    this.d2d_1 = StringBuilder.qa();
  }
  s2c() {
    return this.d2d_1.toString();
  }
  beginTree() {
  }
  endTree() {
    this.d2d_1.a8('\n');
  }
  skip(startPosition, nextInputPosition) {
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.a2d_1.u1p();
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_substring;
    tmp$ret$1 = tmp$ret$0.substring(startPosition, nextInputPosition);
    var matchedText = replace(replace(tmp$ret$1, '\n', '\u23CE'), '\t', '\u2B72');
    this.d2d_1.a8(this.c2d_1 + "<SKIP> : '" + matchedText + "'\n");
  }
  leaf(nodeInfo) {
    var chNum = nodeInfo.child.index;
    var siblings = nodeInfo.child.total;
    var ind = siblings === 1 ? '' : this.c2d_1;
    var eol = siblings === 1 ? ' ' : '\n';
    var matchedText = replace(replace(replace(this.a2d_1.k1v(nodeInfo.node), '\n', '\u23CE'), '\t', '\u2B72'), "'", "\\'");
    if (nodeInfo.node.rule.q11()) {
      this.d2d_1.a8(ind + nodeInfo.node.rule.mz() + eol);
    } else if (nodeInfo.node.rule.r12()) {
      this.d2d_1.a8(ind + nodeInfo.node.rule.mz() + " : '" + matchedText + "'" + eol);
    } else if ("'" + matchedText + "'" === nodeInfo.node.rule.mz()) {
      this.d2d_1.a8(ind + "'" + matchedText + "'" + eol);
    } else {
      this.d2d_1.a8(ind + nodeInfo.node.rule.mz() + " : '" + matchedText + "'" + eol);
    }
  }
  beginBranch(nodeInfo) {
    var option = nodeInfo.alt.index;
    var total = nodeInfo.alt.totalMatched;
    var chNum = nodeInfo.child.index;
    var siblings = nodeInfo.child.total + (nodeInfo.alt.totalMatched - 1 | 0) | 0;
    var totChildren = nodeInfo.totalChildrenFromAllAlternatives + nodeInfo.numSkipChildren | 0;
    var eol = totChildren <= 1 ? ' ' : '\n';
    var tmp;
    if (nodeInfo.alt.totalMatched <= 1) {
      tmp = nodeInfo.node.rule.mz();
    } else {
      tmp = nodeInfo.node.rule.mz() + '|' + nodeInfo.alt.option;
    }
    var tag = tmp;
    if (siblings === 1) {
      this.d2d_1.a8(tag + ' {' + eol);
    } else {
      this.d2d_1.a8(this.c2d_1 + tag + ' {' + eol);
    }
    if (!(totChildren === 1)) {
      var tmp0_this = this;
      tmp0_this.c2d_1 = tmp0_this.c2d_1 + this.b2d_1;
    }
  }
  endBranch(nodeInfo) {
    var chNum = nodeInfo.child.index;
    var siblings = nodeInfo.child.total + (nodeInfo.alt.totalMatched - 1 | 0) | 0;
    var totChildren = nodeInfo.totalChildrenFromAllAlternatives + nodeInfo.numSkipChildren | 0;
    var eol = siblings === 1 ? ' ' : '\n';
    if (!(totChildren === 1)) {
      var tmp = this;
      var tmp$ret$1;
      // Inline function 'kotlin.text.substring' call
      var tmp0_substring = this.c2d_1;
      var tmp1_substring = this.b2d_1.length;
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_substring;
      tmp$ret$1 = tmp$ret$0.substring(tmp1_substring);
      tmp.c2d_1 = tmp$ret$1;
    }
    var ind = totChildren === 1 ? '' : this.c2d_1;
    this.d2d_1.a8(ind + '}' + eol);
  }
  beginEmbedded(nodeInfo) {
    var tag = nodeInfo.node.rule.mz();
    this.d2d_1.a8(this.c2d_1 + tag + ' : <EMBED>::');
  }
  endEmbedded(nodeInfo) {
  }
  error(msg, path) {
    var p = path();
    this.d2d_1.a8(this.c2d_1 + 'Error at ' + last(p).startPosition + ": '" + msg + "'");
    println(this.c2d_1 + 'Error at ' + last(p).startPosition + ": '" + msg + "'");
  }
}
class ToStringVisitor {}
class TokensByLineVisitor$visitTree$callback$1 {
  constructor($treeData, this$0, $nodeLabelStack) {
    this.w2e_1 = $treeData;
    this.x2e_1 = this$0;
    this.y2e_1 = $nodeLabelStack;
  }
  error(msg, path) {
    return Unit_getInstance();
  }
  beginTree() {
  }
  endTree() {
  }
  skip(startPosition, nextInputPosition) {
    return Unit_getInstance();
  }
  leaf(nodeInfo) {
    var skipNodes = this.w2e_1.skipNodesAfter(nodeInfo.node);
    this.x2e_1.z2e(nodeInfo, skipNodes, this.y2e_1.c29());
  }
  beginBranch(nodeInfo) {
    return this.y2e_1.v1a(nodeInfo.node.rule.mz());
  }
  endBranch(nodeInfo) {
    this.y2e_1.w1a();
  }
  beginEmbedded(nodeInfo) {
    this.beginBranch(nodeInfo);
  }
  endEmbedded(nodeInfo) {
    return this.endBranch(nodeInfo);
  }
}
class TokensByLineVisitor {
  constructor(sentence) {
    this.n2c_1 = sentence;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.o2c_1 = tmp$ret$0;
  }
  a2f(_this__u8e3s4, index) {
    if (index >= _this__u8e3s4.o()) {
      var inductionVariable = _this__u8e3s4.o() - 1 | 0;
      if (inductionVariable < index)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0;
          // Inline function 'kotlin.collections.mutableListOf' call
          tmp$ret$0 = ArrayList.i4();
          _this__u8e3s4.e1(tmp$ret$0);
        }
         while (inductionVariable < index);
    }
    return _this__u8e3s4.p(index);
  }
  p2c(target, arg) {
    var treeData = (target instanceof SPPTFromTreeData ? target : THROW_CCE()).f2c_1;
    var nodeLabelStack = mutableStackOf([]);
    var callback = new TokensByLineVisitor$visitTree$callback$1(treeData, this, nodeLabelStack);
    treeData.traverseTreeDepthFirst(callback, true);
  }
  z2e(nodeInfo, skipNodes, tagList) {
    var name = nodeInfo.node.rule.mz();
    var isPattern = nodeInfo.node.rule.r12();
    var tags = plus_2(tagList, name);
    var location = this.n2c_1.v1f(nodeInfo.node);
    var matchedText = this.n2c_1.k1v(nodeInfo.node);
    var eolPositions = Companion_getInstance_22().p1p(matchedText);
    if (get_isEmptyMatch(nodeInfo.node))
    ;
    else if (eolPositions.y()) {
      this.a2f(this.o2c_1, location.line - 1 | 0).e1(new LeafData(name, isPattern, location, matchedText, tags));
    } else {
      var line = location.line;
      var indexPos = 0;
      var startPos = nodeInfo.node.startPosition;
      var startLinePos = startPos;
      var column = location.column;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = eolPositions.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.sppt.TokensByLineVisitor.processLeaf.<anonymous>' call
        var tmp$ret$1;
        // Inline function 'kotlin.text.substring' call
        var tmp0_substring = indexPos;
        var tmp1_substring = element + 1 | 0;
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = matchedText;
        tmp$ret$1 = tmp$ret$0.substring(tmp0_substring, tmp1_substring);
        var lineText = tmp$ret$1;
        var loc = new InputLocation(startLinePos, column, line, lineText.length);
        var segmentLeaf = new LeafData(name, isPattern, loc, lineText, tags);
        this.a2f(this.o2c_1, line - 1 | 0).e1(segmentLeaf);
        var tmp0 = line;
        line = tmp0 + 1 | 0;
        indexPos = indexPos + lineText.length | 0;
        startLinePos = startLinePos + lineText.length | 0;
        column = 1;
      }
      var tmp$ret$3;
      // Inline function 'kotlin.text.substring' call
      var tmp0_substring_0 = indexPos;
      var tmp$ret$2;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$2 = matchedText;
      tmp$ret$3 = tmp$ret$2.substring(tmp0_substring_0);
      var lineText_0 = tmp$ret$3;
      var tmp$ret$4;
      // Inline function 'kotlin.text.isNotEmpty' call
      tmp$ret$4 = charSequenceLength(lineText_0) > 0;
      if (tmp$ret$4) {
        var loc_0 = new InputLocation(startLinePos, column, line, lineText_0.length);
        var segmentLeaf_0 = new LeafData(name, isPattern, loc_0, lineText_0, tags);
        this.a2f(this.o2c_1, line - 1 | 0).e1(segmentLeaf_0);
      }
    }
  }
}
class CompleteTreeDataNode {
  constructor(rule, startPosition, nextInputPosition, nextInputNoSkip, option) {
    this.q1s_1 = rule;
    this.r1s_1 = startPosition;
    this.s1s_1 = nextInputPosition;
    this.t1s_1 = nextInputNoSkip;
    this.u1s_1 = option;
    var tmp = this;
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.q1s_1, this.r1s_1, this.s1s_1];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    tmp.v1s_1 = contentHashCode(tmp$ret$2);
  }
  t1g() {
    return this.q1s_1;
  }
  i2a() {
    return this.r1s_1;
  }
  j2a() {
    return this.s1s_1;
  }
  k2a() {
    return this.t1s_1;
  }
  l2a() {
    return this.u1s_1;
  }
  hashCode() {
    return this.v1s_1;
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, SpptDataNode) : false)) {
      tmp = false;
    } else {
      if (!(this.r1s_1 === other.startPosition)) {
        tmp = false;
      } else {
        if (!(this.s1s_1 === other.nextInputPosition)) {
          tmp = false;
        } else {
          if (!equals(this.q1s_1, other.rule)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
  toString() {
    return 'CN(' + this.q1s_1.mz() + '|' + this.u1s_1 + ',' + this.r1s_1 + '-' + this.s1s_1 + ')';
  }
  ti() {
    return this.q1s_1;
  }
  ui() {
    return this.r1s_1;
  }
  r1j() {
    return this.s1s_1;
  }
  s1j() {
    return this.t1s_1;
  }
  t1j() {
    return this.u1s_1;
  }
  b2f(rule, startPosition, nextInputPosition, nextInputNoSkip, option) {
    return new CompleteTreeDataNode(rule, startPosition, nextInputPosition, nextInputNoSkip, option);
  }
  copy(rule, startPosition, nextInputPosition, nextInputNoSkip, option, $super) {
    rule = rule === VOID ? this.q1s_1 : rule;
    startPosition = startPosition === VOID ? this.r1s_1 : startPosition;
    nextInputPosition = nextInputPosition === VOID ? this.s1s_1 : nextInputPosition;
    nextInputNoSkip = nextInputNoSkip === VOID ? this.t1s_1 : nextInputNoSkip;
    option = option === VOID ? this.u1s_1 : option;
    return this.b2f(rule, startPosition, nextInputPosition, nextInputNoSkip, option);
  }
  get rule() {
    return this.t1g();
  }
  get startPosition() {
    return this.i2a();
  }
  get nextInputPosition() {
    return this.j2a();
  }
  get nextInputNoSkip() {
    return this.k2a();
  }
  get option() {
    return this.l2a();
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_32 = this;
  }
}
class TreeDataComplete {
  constructor(forStateSetNumber, root, initialSkip) {
    Companion_getInstance_34();
    root = root === VOID ? null : root;
    initialSkip = initialSkip === VOID ? null : initialSkip;
    this.forStateSetNumber = forStateSetNumber;
    this.root = root;
    this.initialSkip = initialSkip;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.x1s_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$1 = HashMap.w4();
    tmp_0.y1s_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$2 = HashMap.w4();
    tmp_1.z1s_1 = tmp$ret$2;
    var tmp_2 = this;
    var tmp$ret$3;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$3 = HashMap.w4();
    tmp_2.a1t_1 = tmp$ret$3;
  }
  c2f() {
    return this.forStateSetNumber;
  }
  k17() {
    return (((null == this.root ? null == this.initialSkip : false) ? this.x1s_1.y() : false) ? this.z1s_1.y() : false) ? this.a1t_1.y() : false;
  }
  d2f() {
    return this.x1s_1;
  }
  e2f() {
    return this.root;
  }
  f2f() {
    return this.initialSkip;
  }
  g2f() {
    return first_0(first_0(this.childrenFor(ensureNotNull(this.root))).si_1);
  }
  setUserGoalChildrenAfterInitialSkip(nug, userGoalChildren) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.x1s_1;
    var tmp1_set = mutableMapOf([to(0, toMutableList(userGoalChildren))]);
    tmp0_set.m3(nug, tmp1_set);
  }
  childrenFor(node) {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.x1s_1.j3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>' call
      tmp$ret$0 = (element.startPosition === node.startPosition ? element.nextInputPosition === node.nextInputPosition : false) ? equals(element.rule, node.rule) : false;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var keys = tmp$ret$2;
    var tmp0_subject = keys.o();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        tmp = emptyList();
        break;
      case 1:
        var tmp$ret$5;
        // Inline function 'kotlin.collections.map' call
        var tmp1_map = ensureNotNull(this.x1s_1.u3(keys.p(0))).l3();
        var tmp$ret$4;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
        var tmp0_iterator_0 = tmp1_map.u();
        while (tmp0_iterator_0.h1()) {
          var item = tmp0_iterator_0.j1();
          var tmp$ret$3;
          // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>' call
          tmp$ret$3 = new Pair(item.o3(), item.p3());
          tmp0_mapTo.e1(tmp$ret$3);
        }
        tmp$ret$4 = tmp0_mapTo;
        tmp$ret$5 = tmp$ret$4;

        tmp = tmp$ret$5;
        break;
      default:
        var preferred = _get_preferred__p9krn4(keys.p(0), Companion_getInstance_34());
        Debug_getInstance();
        if (false) {
          // Inline function 'kotlin.check' call
          var tmp$ret$6;
          $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp_0;
            if (isInterface(keys, Collection)) {
              tmp_0 = keys.y();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$6 = true;
              break $l$block_0;
            }
            var tmp0_iterator_1 = keys.u();
            while (tmp0_iterator_1.h1()) {
              var element_0 = tmp0_iterator_1.j1();
              var tmp$ret$7;
              // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>' call
              tmp$ret$7 = _get_preferred__p9krn4(element_0, Companion_getInstance_34()).equals(preferred);
              if (!tmp$ret$7) {
                tmp$ret$6 = false;
                break $l$block_0;
              }
            }
            tmp$ret$6 = true;
          }
          var tmp2_check = tmp$ret$6;
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!tmp2_check) {
            var tmp$ret$8;
            // Inline function 'kotlin.check.<anonymous>' call
            tmp$ret$8 = 'Check failed.';
            var message = tmp$ret$8;
            throw IllegalStateException.y1(toString(message));
          }
        }

        var tmp_1;
        if (this.y1s_1.r3(preferred)) {
          var tmp$ret$12;
          // Inline function 'kotlin.collections.map' call
          var tmp$ret$9;
          // Inline function 'kotlin.collections.get' call
          var tmp3_get = this.x1s_1;
          var tmp4_get = this.y1s_1.u3(preferred);
          tmp$ret$9 = (isInterface(tmp3_get, Map) ? tmp3_get : THROW_CCE()).u3(tmp4_get);
          var tmp5_map = ensureNotNull(tmp$ret$9).l3();
          var tmp$ret$11;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp5_map, 10));
          var tmp0_iterator_2 = tmp5_map.u();
          while (tmp0_iterator_2.h1()) {
            var item_0 = tmp0_iterator_2.j1();
            var tmp$ret$10;
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>' call
            tmp$ret$10 = new Pair(item_0.o3(), item_0.p3());
            tmp0_mapTo_0.e1(tmp$ret$10);
          }
          tmp$ret$11 = tmp0_mapTo_0;
          tmp$ret$12 = tmp$ret$11;
          tmp_1 = tmp$ret$12;
        } else {
          var tmp$ret$18;
          // Inline function 'kotlin.collections.flatMap' call
          var tmp$ret$17;
          // Inline function 'kotlin.collections.flatMapTo' call
          var tmp0_flatMapTo = ArrayList.i4();
          var tmp0_iterator_3 = keys.u();
          while (tmp0_iterator_3.h1()) {
            var element_1 = tmp0_iterator_3.j1();
            var tmp$ret$16;
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>' call
            var tmp$ret$15;
            // Inline function 'kotlin.collections.map' call
            var tmp0_map = ensureNotNull(this.x1s_1.u3(element_1)).l3();
            var tmp$ret$14;
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
            var tmp0_iterator_4 = tmp0_map.u();
            while (tmp0_iterator_4.h1()) {
              var item_1 = tmp0_iterator_4.j1();
              var tmp$ret$13;
              // Inline function 'net.akehurst.language.agl.sppt.TreeDataComplete.childrenFor.<anonymous>.<anonymous>' call
              tmp$ret$13 = new Pair(item_1.o3(), item_1.p3());
              tmp0_mapTo_1.e1(tmp$ret$13);
            }
            tmp$ret$14 = tmp0_mapTo_1;
            tmp$ret$15 = tmp$ret$14;
            tmp$ret$16 = tmp$ret$15;
            var list = tmp$ret$16;
            addAll(tmp0_flatMapTo, list);
          }
          tmp$ret$17 = tmp0_flatMapTo;
          tmp$ret$18 = tmp$ret$17;
          tmp_1 = tmp$ret$18;
        }

        tmp = tmp_1;
        break;
    }
    return tmp;
  }
  skipDataAfter(node) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.get' call
    var tmp0_get = this.z1s_1;
    tmp$ret$0 = (isInterface(tmp0_get, Map) ? tmp0_get : THROW_CCE()).u3(node);
    return tmp$ret$0;
  }
  embeddedFor(node) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.get' call
    var tmp0_get = this.a1t_1;
    tmp$ret$0 = (isInterface(tmp0_get, Map) ? tmp0_get : THROW_CCE()).u3(node);
    return tmp$ret$0;
  }
  skipNodesAfter(node) {
    var skipTreeData = this.skipDataAfter(node);
    var tmp0_subject = skipTreeData;
    var tmp;
    if (tmp0_subject == null) {
      tmp = emptyList();
    } else {
      var sur = skipTreeData.userRoot;
      var skpCh = skipTreeData.childrenFor(sur);
      return skpCh.p(0).si_1;
    }
    return tmp;
  }
  reset() {
    this.root = null;
    this.initialSkip = null;
    this.x1s_1.n1();
    this.y1s_1.n1();
    this.z1s_1.n1();
    this.a1t_1.n1();
  }
  preferred(node) {
    return this.y1s_1.u3(_get_preferred__p9krn4(node, Companion_getInstance_34()));
  }
  setRoot(root) {
    this.root = root;
  }
  start(initialSkipData) {
    this.initialSkip = initialSkipData;
  }
  remove(node) {
    this.x1s_1.q3(node);
    this.y1s_1.q3(_get_preferred__p9krn4(node, Companion_getInstance_34()));
    this.z1s_1.q3(node);
  }
  setChildren(parent, completeChildren, isAlternative) {
    setCompletedBy(this, parent, completeChildren, isAlternative);
  }
  setSkipDataAfter(leafNodeIndex, skipData) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.z1s_1;
    tmp0_set.m3(leafNodeIndex, skipData);
  }
  setEmbeddedTreeFor(n, treeData) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.a1t_1;
    tmp0_set.m3(n, treeData);
  }
  traverseTreeDepthFirst(callback, skipDataAsTree) {
    var walker = new TreeDataWalkerDepthFirst(this);
    walker.k2f(callback, skipDataAsTree);
  }
  matches(other) {
    return !equals(this.initialSkip, other.initialSkip) ? false : !this.a1t_1.equals(other.a1t_1) ? false : !this.z1s_1.equals(other.z1s_1) ? false : !this.y1s_1.equals(other.y1s_1) ? false : !this.x1s_1.equals(other.x1s_1) ? false : true;
  }
  hashCode() {
    return this.forStateSetNumber;
  }
  equals(other) {
    var tmp;
    if (!(other instanceof TreeDataComplete)) {
      tmp = false;
    } else {
      tmp = other.forStateSetNumber === this.forStateSetNumber;
    }
    return tmp;
  }
  toString() {
    return 'TreeData{' + this.forStateSetNumber + '}';
  }
  get isEmpty() {
    return this.k17();
  }
  get completeChildren() {
    return this.d2f();
  }
  get userRoot() {
    return this.g2f();
  }
  static get Companion() {
    return Companion_getInstance_34();
  }
}
class PreferredNode {
  constructor(rule, startPosition) {
    this.l2f_1 = rule;
    this.m2f_1 = startPosition;
  }
  toString() {
    return 'PN(' + this.l2f_1.mz() + ',' + this.m2f_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.l2f_1);
    result = imul(result, 31) + this.m2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferredNode))
      return false;
    var tmp0_other_with_cast = other instanceof PreferredNode ? other : THROW_CCE();
    if (!equals(this.l2f_1, tmp0_other_with_cast.l2f_1))
      return false;
    if (!(this.m2f_1 === tmp0_other_with_cast.m2f_1))
      return false;
    return true;
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_33 = this;
  }
}
class sam$kotlin_Comparator$0_9 {
  constructor(function_0) {
    this.y2f_1 = function_0;
  }
  rc(a, b) {
    return this.y2f_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class sam$kotlin_Comparator$0_10 {
  constructor(function_0) {
    this.z2f_1 = function_0;
  }
  rc(a, b) {
    return this.z2f_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class TreeDataWalkerDepthFirst {
  constructor(treeData) {
    Companion_getInstance_35();
    this.h2f_1 = treeData;
    this.i2f_1 = new MutableStack();
    this.j2f_1 = new MutableStack();
  }
  k2f(callback, skipDataAsTree) {
    callback.beginTree();
    var goal = ensureNotNull(this.h2f_1.root);
    var userRoot = this.h2f_1.childrenFor(goal).p(0).si_1.p(0);
    var parentAlt = new AltInfo(0, 0, 1);
    if (userRoot.rule.s10()) {
      var urchildOfTotal = new ChildInfo(0, 0, 1);
      var altOfTotal = new AltInfo(0, 0, 1);
      this.j2f_1.v1a(new StackInfo(false, userRoot, parentAlt, altOfTotal, urchildOfTotal, emptyMap(), -1));
    } else {
      var urchildOfTotal_0 = new ChildInfo(0, 0, 1);
      var tmp$ret$1;
      // Inline function 'kotlin.collections.sortedBy' call
      var tmp0_sortedBy = this.h2f_1.childrenFor(userRoot);
      var tmp$ret$0;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = TreeDataWalkerDepthFirst$traverse$lambda;
      tmp$ret$0 = new sam$kotlin_Comparator$0_9(tmp);
      tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
      var uralternatives = tmp$ret$1;
      var altInfo = new AlternativesInfo(userRoot, true);
      this.i2f_1.v1a(altInfo);
      this.j2f_1.v1a(altInfo);
      var tmp$ret$4;
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(uralternatives, 10)), 16);
      var tmp$ret$3;
      // Inline function 'kotlin.collections.associateTo' call
      var tmp0_associateTo = LinkedHashMap.o8(capacity);
      var tmp0_iterator = uralternatives.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp$ret$2;
        // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>' call
        tmp$ret$2 = new Pair(element.ri_1, element.si_1.o());
        var tmp0_plusAssign = tmp$ret$2;
        tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
      }
      tmp$ret$3 = tmp0_associateTo;
      tmp$ret$4 = tmp$ret$3;
      var numChildrenAlternatives = tmp$ret$4;
      var inductionVariable = uralternatives.o() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp1_container = uralternatives.p(i);
          var alt = tmp1_container.ti();
          var children = tmp1_container.ui();
          var altOfTotal_0 = new AltInfo(alt, i, uralternatives.o());
          var tmp_0 = numSkipChildren(this, this.h2f_1.initialSkip);
          var tmp$ret$11;
          // Inline function 'kotlin.collections.fold' call
          var tmp$ret$7;
          // Inline function 'kotlin.collections.filter' call
          var tmp$ret$6;
          // Inline function 'kotlin.collections.filterTo' call
          var tmp0_filterTo = ArrayList.i4();
          var tmp0_iterator_0 = children.u();
          while (tmp0_iterator_0.h1()) {
            var element_0 = tmp0_iterator_0.j1();
            var tmp$ret$5;
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>' call
            tmp$ret$5 = element_0.rule.s10();
            if (tmp$ret$5) {
              tmp0_filterTo.e1(element_0);
            }
          }
          tmp$ret$6 = tmp0_filterTo;
          tmp$ret$7 = tmp$ret$6;
          var tmp1_fold = tmp$ret$7;
          var accumulator = 0;
          var tmp0_iterator_1 = tmp1_fold.u();
          while (tmp0_iterator_1.h1()) {
            var element_1 = tmp0_iterator_1.j1();
            var tmp$ret$10;
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>' call
            var tmp2_anonymous = accumulator;
            var tmp0_safe_receiver = this.h2f_1.skipDataAfter(element_1);
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              var tmp$ret$9;
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp$ret$8;
              // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>.<anonymous>' call
              tmp$ret$8 = tmp2_anonymous + numSkipChildren(this, tmp0_safe_receiver) | 0;
              tmp$ret$9 = tmp$ret$8;
              tmp_1 = tmp$ret$9;
            }
            var tmp1_elvis_lhs = tmp_1;
            tmp$ret$10 = tmp1_elvis_lhs == null ? tmp2_anonymous : tmp1_elvis_lhs;
            accumulator = tmp$ret$10;
          }
          tmp$ret$11 = accumulator;
          var urnumSkipChildren = tmp_0 + tmp$ret$11 | 0;
          var stackData = new StackInfo(true, userRoot, parentAlt, altOfTotal_0, urchildOfTotal_0, numChildrenAlternatives, urnumSkipChildren);
          altInfo.x2f_1.e1(new Pair(stackData, children));
        }
         while (0 <= inductionVariable);
    }
    while (this.j2f_1.y10()) {
      var info = this.j2f_1.w1a();
      traverseStackData(this, callback, skipDataAsTree, info);
    }
    callback.endTree();
  }
  n2f(callback, skipDataAsTree) {
    var goal = ensureNotNull(this.h2f_1.root);
    var skipMulti = this.h2f_1.childrenFor(goal).p(0).si_1.p(0);
    var multi = this.h2f_1.childrenFor(skipMulti).p(0).si_1;
    var parentAlt = new AltInfo(0, 0, 1);
    var inductionVariable = multi.o() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var n = multi.p(i);
        var childOfTotal = new ChildInfo(i, i, multi.o() + 1 | 0);
        var skp = this.h2f_1.childrenFor(n).p(0).si_1.p(0);
        this.j2f_1.v1a(new StackInfo(false, skp, parentAlt, new AltInfo(0, 0, 1), childOfTotal, emptyMap(), -1));
      }
       while (0 <= inductionVariable);
    while (this.j2f_1.y10()) {
      var info = this.j2f_1.w1a();
      traverseStackData(this, callback, skipDataAsTree, info);
    }
  }
}
class StackData {}
class AlternativesInfo {
  constructor(node, isRoot) {
    this.v2f_1 = node;
    this.w2f_1 = isRoot;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.x2f_1 = tmp$ret$0;
  }
  toString() {
    return 'AlternativesInfo(node=' + this.v2f_1 + ', isRoot=' + this.w2f_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.v2f_1);
    result = imul(result, 31) + (this.w2f_1 | 0) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AlternativesInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AlternativesInfo ? other : THROW_CCE();
    if (!equals(this.v2f_1, tmp0_other_with_cast.v2f_1))
      return false;
    if (!(this.w2f_1 === tmp0_other_with_cast.w2f_1))
      return false;
    return true;
  }
}
class SpptDataNodeInfo {}
class StackInfo {
  constructor(done, node, parentAlt, alt, child, numChildrenAlternatives, numSkipChildren) {
    this.o2f_1 = done;
    this.p2f_1 = node;
    this.q2f_1 = parentAlt;
    this.r2f_1 = alt;
    this.s2f_1 = child;
    this.t2f_1 = numChildrenAlternatives;
    this.u2f_1 = numSkipChildren;
  }
  a2g() {
    return this.p2f_1;
  }
  b2g() {
    return this.q2f_1;
  }
  c2g() {
    return this.r2f_1;
  }
  d2g() {
    return this.s2f_1;
  }
  e2g() {
    return this.t2f_1;
  }
  f2g() {
    return this.u2f_1;
  }
  g2g() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.fold' call
    var tmp0_fold = this.t2f_1.k3();
    var accumulator = 0;
    var tmp0_iterator = tmp0_fold.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.sppt.StackInfo.<get-totalChildrenFromAllAlternatives>.<anonymous>' call
      var tmp1_anonymous = accumulator;
      tmp$ret$0 = tmp1_anonymous + element | 0;
      accumulator = tmp$ret$0;
    }
    tmp$ret$1 = accumulator;
    return tmp$ret$1;
  }
  toString() {
    return 'StackInfo(done=' + this.o2f_1 + ', node=' + this.p2f_1 + ', parentAlt=' + this.q2f_1 + ', alt=' + this.r2f_1 + ', child=' + this.s2f_1 + ', numChildrenAlternatives=' + this.t2f_1 + ', numSkipChildren=' + this.u2f_1 + ')';
  }
  hashCode() {
    var result = this.o2f_1 | 0;
    result = imul(result, 31) + hashCode(this.p2f_1) | 0;
    result = imul(result, 31) + this.q2f_1.hashCode() | 0;
    result = imul(result, 31) + this.r2f_1.hashCode() | 0;
    result = imul(result, 31) + this.s2f_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.t2f_1) | 0;
    result = imul(result, 31) + this.u2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StackInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StackInfo ? other : THROW_CCE();
    if (!(this.o2f_1 === tmp0_other_with_cast.o2f_1))
      return false;
    if (!equals(this.p2f_1, tmp0_other_with_cast.p2f_1))
      return false;
    if (!this.q2f_1.equals(tmp0_other_with_cast.q2f_1))
      return false;
    if (!this.r2f_1.equals(tmp0_other_with_cast.r2f_1))
      return false;
    if (!this.s2f_1.equals(tmp0_other_with_cast.s2f_1))
      return false;
    if (!equals(this.t2f_1, tmp0_other_with_cast.t2f_1))
      return false;
    if (!(this.u2f_1 === tmp0_other_with_cast.u2f_1))
      return false;
    return true;
  }
  get node() {
    return this.a2g();
  }
  get parentAlt() {
    return this.b2g();
  }
  get alt() {
    return this.c2g();
  }
  get child() {
    return this.d2g();
  }
  get numChildrenAlternatives() {
    return this.e2g();
  }
  get numSkipChildren() {
    return this.f2g();
  }
  get totalChildrenFromAllAlternatives() {
    return this.g2g();
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_34 = this;
    this.TYPE_NAME_FOR_TYPES = '$Type';
    this.TYPE_NAME_FOR_PROPERTIES = '$Property';
  }
  h2g() {
    return this.TYPE_NAME_FOR_TYPES;
  }
  i2g() {
    return this.TYPE_NAME_FOR_PROPERTIES;
  }
}
class ContextFromTypeModel {
  constructor() {
    Companion_getInstance_36();
    this.j2g_1 = new ScopeSimple(null, '', '');
  }
  static new_net_akehurst_language_agl_syntaxAnalyser_ContextFromTypeModel(grammarNamespaceQualifiedName, typeModel) {
    Companion_getInstance_36();
    var $this = new ContextFromTypeModel();
    $this.createScopeFrom(grammarNamespaceQualifiedName, typeModel);
    return $this;
  }
  c1g(_set____db54di) {
    this.j2g_1 = _set____db54di;
  }
  d1g() {
    return this.j2g_1;
  }
  clear() {
    this.j2g_1 = new ScopeSimple(null, '', '');
  }
  createScopeFrom(grammarNamespaceQualifiedName, typeModel) {
    var tmp = typeModel.namespace.u3(grammarNamespaceQualifiedName);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, GrammarTypeNamespace) : false) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "TypeNamespace '" + grammarNamespaceQualifiedName + "' not found";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var ns = tmp_0;
    var scope = new ScopeSimple(null, '', grammarNamespaceQualifiedName);
    // Inline function 'kotlin.collections.forEach' call
    var tmp1_forEach = ns.allRuleNameToType;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = tmp1_forEach.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.syntaxAnalyser.ContextFromTypeModel.createScopeFrom.<anonymous>' call
      var tmp_1 = element.p3().type.name;
      Companion_getInstance_36();
      scope.addToScope(tmp_1, '$Type', element.p3().type.name);
      var type = element.p3().type;
      var tmp0_subject = type;
      if (isInterface(tmp0_subject, PrimitiveType))
      ;
      else {
        if (isInterface(tmp0_subject, CollectionType))
        ;
        else {
          if (isInterface(tmp0_subject, UnnamedSuperTypeType))
          ;
          else {
            if (isInterface(tmp0_subject, TupleType)) {
            } else {
              if (isInterface(tmp0_subject, DataType)) {
                var chs = scope.createOrGetChildScope(type.name, type.name, type.name);
                // Inline function 'kotlin.collections.forEach' call
                var tmp0_forEach = type.property.k3();
                var tmp0_iterator_0 = tmp0_forEach.u();
                while (tmp0_iterator_0.h1()) {
                  var element_0 = tmp0_iterator_0.j1();
                  // Inline function 'net.akehurst.language.agl.syntaxAnalyser.ContextFromTypeModel.createScopeFrom.<anonymous>.<anonymous>' call
                  var tmp_2 = element_0.name;
                  Companion_getInstance_36();
                  chs.addToScope(tmp_2, '$Property', element_0.name);
                }
              } else {
                var tmp1_subject = type;
                if (equals(tmp1_subject, typeModel.NothingType))
                ;
                else if (equals(tmp1_subject, typeModel.AnyType))
                ;
              }
            }
          }
        }
      }
    }
    this.j2g_1 = scope;
  }
  hashCode() {
    return this.j2g_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (!(other instanceof ContextFromTypeModel)) {
      tmp = false;
    } else {
      if (!this.j2g_1.equals(other.j2g_1)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return 'ContextFromTypeModel';
  }
  get rootScope() {
    return this.d1g();
  }
  set rootScope(value) {
    this.c1g(value);
  }
  static get Companion() {
    return Companion_getInstance_36();
  }
}
class ContextSimple {
  constructor() {
    this.f1b_1 = new ScopeSimple(null, '', Companion_getInstance_17().ROOT_SCOPE_TYPE_NAME);
  }
  k2g(_set____db54di) {
    this.f1b_1 = _set____db54di;
  }
  d1g() {
    return this.f1b_1;
  }
  hashCode() {
    return this.f1b_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (!(other instanceof ContextSimple)) {
      tmp = false;
    } else {
      if (!this.f1b_1.equals(other.f1b_1)) {
        tmp = false;
      } else {
        tmp = true;
      }
    }
    return tmp;
  }
  toString() {
    return 'ContextSimple';
  }
  get rootScope() {
    return this.d1g();
  }
  set rootScope(value) {
    this.k2g(value);
  }
}
class Scope {}
class ScopeSimple {
  constructor(parent, forReferenceInParent, forTypeName) {
    this.parent = parent;
    this.forReferenceInParent = forReferenceInParent;
    this.forTypeName = forTypeName;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.scopeMap = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.q1a_1 = tmp$ret$1;
    var tmp_1 = this;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$2 = LinkedHashMap.n8();
    tmp_1.r1a_1 = tmp$ret$2;
    var tmp_2 = this;
    tmp_2.s1a_1 = lazy(ScopeSimple$rootScope$delegate$lambda(this));
    this.t1a_1 = this.q1a_1;
    var tmp_3 = this;
    tmp_3.u1a_1 = lazy(ScopeSimple$path$delegate$lambda(this));
  }
  l2g() {
    return this.parent;
  }
  m2g() {
    return this.forReferenceInParent;
  }
  z1d() {
    return this.forTypeName;
  }
  n2g() {
    return this.scopeMap;
  }
  d1g() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = rootScope$factory();
    tmp$ret$0 = this.s1a_1.p3();
    return tmp$ret$0;
  }
  o2g() {
    return this.t1a_1;
  }
  a11() {
    return this.r1a_1;
  }
  p2g() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = path$factory();
    tmp$ret$0 = this.u1a_1.p3();
    return tmp$ret$0;
  }
  createOrGetChildScope(forReferenceInParent, forTypeName, elementId) {
    var child = this.q1a_1.u3(forReferenceInParent);
    if (null == child) {
      child = new ScopeSimple(this, forReferenceInParent, forTypeName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.q1a_1;
      var tmp1_set = child;
      tmp0_set.m3(forReferenceInParent, tmp1_set);
    }
    // Inline function 'kotlin.collections.set' call
    var tmp2_set = this.rootScope.scopeMap;
    var tmp3_set = child;
    tmp2_set.m3(elementId, tmp3_set);
    return child;
  }
  addToScope(referableName, typeName, asmElementId) {
    var m = this.r1a_1.u3(typeName);
    if (null == m) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp$ret$0 = LinkedHashMap.n8();
      m = tmp$ret$0;
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.r1a_1;
      var tmp1_set = m;
      tmp0_set.m3(typeName, tmp1_set);
    }
    // Inline function 'kotlin.collections.set' call
    var tmp2_set = m;
    tmp2_set.m3(referableName, asmElementId);
  }
  findOrNull(referableName, typeName) {
    var tmp0_safe_receiver = this.items.u3(typeName);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3(referableName);
  }
  isMissing(referableName, typeName) {
    return null == this.findOrNull(referableName, typeName);
  }
  hashCode() {
    var tmp$ret$2;
    // Inline function 'kotlin.arrayOf' call
    var tmp0_arrayOf = [this.parent, this.forReferenceInParent, this.forTypeName];
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_arrayOf;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return contentHashCode(tmp$ret$2);
  }
  equals(other) {
    var tmp;
    if (!(other instanceof ScopeSimple)) {
      tmp = false;
    } else {
      if (!equals(this.parent, other.parent)) {
        tmp = false;
      } else {
        if (!(this.forReferenceInParent === other.forReferenceInParent)) {
          tmp = false;
        } else {
          if (!(this.forTypeName === other.forTypeName)) {
            tmp = false;
          } else {
            tmp = true;
          }
        }
      }
    }
    return tmp;
  }
  toString() {
    return null == this.parent ? '/' + this.forTypeName : '' + this.parent + '/' + this.forTypeName;
  }
  get rootScope() {
    return this.d1g();
  }
  get childScopes() {
    return this.o2g();
  }
  get items() {
    return this.a11();
  }
  get path() {
    return this.p2g();
  }
}
class SyntaxAnalyserByMethodRegistrationAbstract$walkTree$walker$1 {
  constructor($stack, $syntaxAnalyserStack, $sentence, this$0) {
    this.q2g_1 = $stack;
    this.r2g_1 = $syntaxAnalyserStack;
    this.s2g_1 = $sentence;
    this.t2g_1 = this$0;
  }
  beginTree() {
  }
  endTree() {
  }
  leaf(nodeInfo) {
    if (nodeInfo.node.rule.q11()) {
      this.q2g_1.v1a(null);
    } else {
      var handlerName = nodeInfo.node.rule.mz();
      var handler = findBranchHandler(this.r2g_1.o1a(), handlerName, false);
      var tmp0_subject = handler;
      var tmp;
      if (tmp0_subject == null) {
        tmp = this.s2g_1.k1v(nodeInfo.node);
      } else {
        var res = handler(nodeInfo, emptyList(), this.s2g_1);
        var tmp1_safe_receiver = res;
        if (tmp1_safe_receiver == null)
          null;
        else {
          var tmp$ret$0;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_set = this.t2g_1.locationMap;
          var tmp1_set = this.s2g_1.v1f(nodeInfo.node);
          tmp0_set.m3(res, tmp1_set);
          tmp$ret$0 = Unit_getInstance();
        }
        tmp = res;
      }
      var obj = tmp;
      this.q2g_1.v1a(obj);
    }
  }
  beginBranch(nodeInfo) {
    var branchName = nodeInfo.node.rule.mz();
    var handler = findBranchHandler(this.r2g_1.o1a(), branchName, true);
    if (null == handler) {
    } else {
      var numChildren = nodeInfo.child.index;
      var siblings = this.q2g_1.u2g(numChildren);
      handler(nodeInfo, siblings, this.s2g_1);
    }
  }
  endBranch(nodeInfo) {
    var opt = nodeInfo.alt.option;
    var numChildren = ensureNotNull(nodeInfo.numChildrenAlternatives.u3(opt));
    var children = this.q2g_1.v2e(numChildren);
    var adjChildren = nodeInfo.node.rule.gn() ? reversed(children) : reversed(children);
    if (nodeInfo.node.rule.e2b()) {
      var obj = adjChildren.p(0);
      var tmp0_safe_receiver = obj;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_set = this.t2g_1.locationMap;
        var tmp1_set = this.s2g_1.v1f(nodeInfo.node);
        tmp0_set.m3(obj, tmp1_set);
        tmp$ret$0 = Unit_getInstance();
      }
      this.q2g_1.v1a(obj);
    } else {
      var branchName = nodeInfo.node.rule.mz();
      var handler = findBranchHandler(this.r2g_1.o1a(), branchName, false);
      if (null == handler) {
        this.q2g_1.v1a(adjChildren);
      } else {
        var ch = ((nodeInfo.node.rule.f2b() ? 1 === children.o() : false) ? null == children.p(0) : false) ? emptyList() : adjChildren;
        var obj_0 = handler(nodeInfo, ch, this.s2g_1);
        var tmp1_safe_receiver = obj_0;
        if (tmp1_safe_receiver == null)
          null;
        else {
          var tmp$ret$1;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp0_set_0 = this.t2g_1.locationMap;
          var tmp1_set_0 = this.s2g_1.v1f(nodeInfo.node);
          tmp0_set_0.m3(obj_0, tmp1_set_0);
          tmp$ret$1 = Unit_getInstance();
        }
        this.q2g_1.v1a(obj_0);
      }
    }
  }
  beginEmbedded(nodeInfo) {
    var tmp = nodeInfo.node.rule;
    var tmp_0 = (tmp instanceof RuntimeRule ? tmp : THROW_CCE()).i11();
    var embeddedRhs = tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE();
    var embName = embeddedRhs.k11_1.zt_1;
    var tmp_1 = this.t2g_1.embeddedSyntaxAnalyser.u3(embName);
    var tmp0_elvis_lhs = (tmp_1 == null ? true : tmp_1 instanceof SyntaxAnalyserByMethodRegistrationAbstract) ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Embedded SyntaxAnalyser not found for '" + embName + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var embSyntaxAnalyser = tmp_2;
    this.r2g_1.v1a(embSyntaxAnalyser);
  }
  endEmbedded(nodeInfo) {
    this.r2g_1.w1a();
    var handlerName = nodeInfo.node.rule.mz();
    var handler = findBranchHandler(this.r2g_1.o1a(), handlerName, false);
    var children = this.q2g_1.v2e(1);
    var tmp0_subject = handler;
    var tmp;
    if (tmp0_subject == null) {
      tmp = children.p(0);
    } else {
      var res = handler(nodeInfo, children, this.s2g_1);
      var tmp1_safe_receiver = res;
      if (tmp1_safe_receiver == null)
        null;
      else {
        var tmp$ret$0;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_set = this.t2g_1.locationMap;
        var tmp1_set = this.s2g_1.v1f(nodeInfo.node);
        tmp0_set.m3(res, tmp1_set);
        tmp$ret$0 = Unit_getInstance();
      }
      tmp = res;
    }
    var obj = tmp;
    this.q2g_1.v1a(obj);
  }
  error(msg, path) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
  skip(startPosition, nextInputPosition) {
  }
}
class NodeTypes {
  constructor(forNode, forChildren) {
    this.forNode = forNode;
    this.forChildren = forChildren;
  }
  x2g() {
    return this.forNode;
  }
  y2g() {
    return this.forChildren;
  }
  static new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(t) {
    var $this = new NodeTypes(t, t);
    return $this;
  }
  ti() {
    return this.forNode;
  }
  ui() {
    return this.forChildren;
  }
  z2g(forNode, forChildren) {
    return new NodeTypes(forNode, forChildren);
  }
  copy(forNode, forChildren, $super) {
    forNode = forNode === VOID ? this.forNode : forNode;
    forChildren = forChildren === VOID ? this.forChildren : forChildren;
    return this.z2g(forNode, forChildren);
  }
  toString() {
    return 'NodeTypes(forNode=' + this.forNode + ', forChildren=' + this.forChildren + ')';
  }
  hashCode() {
    var result = hashCode(this.forNode);
    result = imul(result, 31) + hashCode(this.forChildren) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeTypes))
      return false;
    var tmp0_other_with_cast = other instanceof NodeTypes ? other : THROW_CCE();
    if (!equals(this.forNode, tmp0_other_with_cast.forNode))
      return false;
    if (!equals(this.forChildren, tmp0_other_with_cast.forChildren))
      return false;
    return true;
  }
}
class DownData {
  constructor(path, typeUse) {
    this.path = path;
    this.typeUse = typeUse;
  }
  p2g() {
    return this.path;
  }
  a2h() {
    return this.typeUse;
  }
  ti() {
    return this.path;
  }
  ui() {
    return this.typeUse;
  }
  b2h(path, typeUse) {
    return new DownData(path, typeUse);
  }
  copy(path, typeUse, $super) {
    path = path === VOID ? this.path : path;
    typeUse = typeUse === VOID ? this.typeUse : typeUse;
    return this.b2h(path, typeUse);
  }
  toString() {
    return 'DownData(path=' + this.path + ', typeUse=' + this.typeUse + ')';
  }
  hashCode() {
    var result = this.path.hashCode();
    result = imul(result, 31) + this.typeUse.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DownData))
      return false;
    var tmp0_other_with_cast = other instanceof DownData ? other : THROW_CCE();
    if (!this.path.equals(tmp0_other_with_cast.path))
      return false;
    if (!this.typeUse.equals(tmp0_other_with_cast.typeUse))
      return false;
    return true;
  }
}
class ChildData {
  constructor(nodeInfo, value) {
    this.nodeInfo = nodeInfo;
    this.value = value;
  }
  c2h() {
    return this.nodeInfo;
  }
  p3() {
    return this.value;
  }
  ti() {
    return this.nodeInfo;
  }
  ui() {
    return this.value;
  }
  d2h(nodeInfo, value) {
    return new ChildData(nodeInfo, value);
  }
  copy(nodeInfo, value, $super) {
    nodeInfo = nodeInfo === VOID ? this.nodeInfo : nodeInfo;
    value = value === VOID ? this.value : value;
    return this.d2h(nodeInfo, value);
  }
  toString() {
    return 'ChildData(nodeInfo=' + this.nodeInfo + ', value=' + toString_1(this.value) + ')';
  }
  hashCode() {
    var result = hashCode(this.nodeInfo);
    result = imul(result, 31) + (this.value == null ? 0 : hashCode(this.value)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChildData))
      return false;
    var tmp0_other_with_cast = other instanceof ChildData ? other : THROW_CCE();
    if (!equals(this.nodeInfo, tmp0_other_with_cast.nodeInfo))
      return false;
    if (!equals(this.value, tmp0_other_with_cast.value))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_35 = this;
    this.e2h_1 = 'net.akehurst.language.agl.syntaxAnalyser';
    this.CONFIGURATION_KEY_AGL_SCOPE_MODEL = 'net.akehurst.language.agl.syntaxAnalyser.scope.model';
  }
  f2h() {
    return this.CONFIGURATION_KEY_AGL_SCOPE_MODEL;
  }
  g2h(_this__u8e3s4) {
    return _this__u8e3s4.owner.property.o() === 1;
  }
  h2h(_this__u8e3s4) {
    return _this__u8e3s4.b15().o() === 1 ? _this__u8e3s4.b15().p(0).o() === 1 : false;
  }
}
class SyntaxAnalyserSimpleAbstract$walkTree$walker$1 {
  constructor($syntaxAnalyserStack, this$0, $stack, $sentence, $downStack) {
    this.k2h_1 = $syntaxAnalyserStack;
    this.l2h_1 = this$0;
    this.m2h_1 = $stack;
    this.n2h_1 = $sentence;
    this.o2h_1 = $downStack;
    this.j2h_1 = true;
  }
  beginTree() {
    var tmp = this.k2h_1.o1a();
    var tmp0_elvis_lhs = this.l2h_1.k1b_1;
    setAsm(tmp, tmp0_elvis_lhs == null ? new AsmSimple() : tmp0_elvis_lhs);
    this.j2h_1 = true;
  }
  endTree() {
    var root = this.m2h_1.w1a();
    addAsmRoot(this.k2h_1.o1a(), ensureNotNull(root.value));
  }
  leaf(nodeInfo) {
    var value = createValueFromLeaf(this.k2h_1.o1a(), this.n2h_1, nodeInfo);
    this.m2h_1.v1a(new ChildData(nodeInfo, value));
  }
  beginBranch(nodeInfo) {
    var parentDownData = this.o2h_1.p2h();
    var p = this.o2h_1.k17() ? Companion_getInstance_39().ROOT.plus(this.l2h_1.asm.rootElements.o().toString()) : null == parentDownData ? Companion_getInstance_39().ROOT.plus('<error>') : this.j2h_1 ? parentDownData.path : pathFor(this.k2h_1.o1a(), parentDownData.path, parentDownData.typeUse.forChildren.type, nodeInfo);
    var tmp;
    if (this.j2h_1) {
      this.j2h_1 = false;
      var tmp0_elvis_lhs = findTypeUsageForRule(this.k2h_1.o1a(), nodeInfo.node.rule.mz());
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp0_error = 'Type not found for ' + nodeInfo.node.rule.mz();
        throw IllegalStateException.y1(toString(tmp0_error));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var typeUse = tmp_0;
      tmp = typeUse;
    } else {
      var tmp_1 = this.k2h_1.o1a();
      var tmp1_safe_receiver = parentDownData;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.typeUse;
      tmp = typeForNode(tmp_1, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.forChildren, nodeInfo);
    }
    var tu = tmp;
    var ddcomp = resolveCompressed(this.l2h_1, p, tu, nodeInfo);
    this.o2h_1.v1a(ddcomp);
  }
  endBranch(nodeInfo) {
    var opt = nodeInfo.alt.option;
    var numChildren = ensureNotNull(nodeInfo.numChildrenAlternatives.u3(opt));
    var children = this.m2h_1.v2e(numChildren);
    var adjChildren = reversed(children);
    var downData = this.o2h_1.w1a();
    var value = equals(this.l2h_1.typeModel.NothingType, downData.typeUse.forNode.type) ? null : createValueFromBranch(this.k2h_1.o1a(), this.n2h_1, downData, nodeInfo, adjChildren);
    var tmp0_safe_receiver = value;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_set = this.l2h_1.locationMap;
      var tmp1_set = this.n2h_1.v1f(nodeInfo.node);
      tmp0_set.m3(tmp0_safe_receiver, tmp1_set);
      tmp$ret$0 = Unit_getInstance();
    }
    this.m2h_1.v1a(new ChildData(nodeInfo, value));
  }
  beginEmbedded(nodeInfo) {
    var tmp = nodeInfo.node.rule;
    var tmp_0 = (tmp instanceof RuntimeRule ? tmp : THROW_CCE()).i11();
    var embeddedRhs = tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE();
    var embRuleName = embeddedRhs.l11_1.mz();
    var embGrmName = embeddedRhs.k11_1.zt_1;
    var tmp_1 = this.l2h_1.embeddedSyntaxAnalyser.u3(embGrmName);
    var tmp0_elvis_lhs = (tmp_1 == null ? true : tmp_1 instanceof SyntaxAnalyserSimpleAbstract) ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Embedded SyntaxAnalyser not found for '" + embGrmName + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var embSyntaxAnalyser = tmp_2;
    this.k2h_1.v1a(embSyntaxAnalyser);
    var parentDownData = ensureNotNull(this.o2h_1.o1a());
    var p = pathFor(this.k2h_1.o1a(), parentDownData.path, parentDownData.typeUse.forChildren.type, nodeInfo);
    var tmp1_elvis_lhs = findTypeUsageForRule(this.k2h_1.o1a(), embRuleName);
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      var tmp1_error = 'Type not found for ' + embRuleName;
      throw IllegalStateException.y1(toString(tmp1_error));
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tu = tmp_3;
    var dd = resolveCompressed(this.l2h_1, p, tu, nodeInfo);
    this.o2h_1.v1a(dd);
  }
  endEmbedded(nodeInfo) {
    var embSyntaxAnalyser = this.k2h_1.w1a();
    var embeddedAsm = ensureNotNull(embSyntaxAnalyser.k1b_1);
    this.o2h_1.w1a();
    var value = last(embeddedAsm.rootElements);
    removeAsmRoot(this.l2h_1, value);
    var tmp0_safe_receiver = value;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_set = this.l2h_1.locationMap;
      var tmp1_set = this.n2h_1.v1f(nodeInfo.node);
      tmp0_set.m3(tmp0_safe_receiver, tmp1_set);
      tmp$ret$0 = Unit_getInstance();
    }
    this.m2h_1.v1a(new ChildData(nodeInfo, value));
  }
  skip(startPosition, nextInputPosition) {
  }
  error(msg, path) {
    this.l2h_1.issues.error(null, "Error 'msg' at '" + joinToString(path(), '/') + "'");
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_36 = this;
    this.q2h_1 = 'net.akehurst.language.agl.syntaxAnalyser';
    this.CONFIGURATION_KEY_AGL_SCOPE_MODEL = 'net.akehurst.language.agl.syntaxAnalyser.scope.model';
  }
  f2h() {
    return this.CONFIGURATION_KEY_AGL_SCOPE_MODEL;
  }
  g2h(_this__u8e3s4) {
    return _this__u8e3s4.owner.property.o() === 1;
  }
  h2h(_this__u8e3s4) {
    return _this__u8e3s4.b15().o() === 1 ? _this__u8e3s4.b15().p(0).o() === 1 : false;
  }
}
class SyntaxAnalyserSimpleStreamPushAbstract$walkTree$walker$1 {
  constructor($syntaxAnalyserStack, $sentence, $stack, $downStack, this$0) {
    this.s2h_1 = $syntaxAnalyserStack;
    this.t2h_1 = $sentence;
    this.u2h_1 = $stack;
    this.v2h_1 = $downStack;
    this.w2h_1 = this$0;
  }
  beginTree() {
    this.s2h_1.o1a().startAsm();
  }
  endTree() {
    this.s2h_1.o1a().finishAsm();
  }
  leaf(nodeInfo) {
    var tmp = SimpleTypeModelStdLib_getInstance().String.type;
    var type = isInterface(tmp, PrimitiveType) ? tmp : THROW_CCE();
    createPrimitiveValue(this.s2h_1.o1a(), this.t2h_1, type, nodeInfo);
    this.u2h_1.v1a(new ChildData(nodeInfo, null));
  }
  beginBranch(nodeInfo) {
    var parentDownData = this.v2h_1.p2h();
    var p = this.v2h_1.k17() ? Companion_getInstance_39().ROOT : null == parentDownData ? Companion_getInstance_39().ROOT.plus('<error>') : pathFor_0(this.s2h_1.o1a(), parentDownData.path, parentDownData.typeUse.forChildren.type, nodeInfo);
    var tmp;
    if (this.v2h_1.k17()) {
      var tmp0_elvis_lhs = findTypeUsageForRule_0(this.s2h_1.o1a(), nodeInfo.node.rule.mz());
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp0_error = 'Type not found for ' + nodeInfo.node.rule.mz();
        throw IllegalStateException.y1(toString(tmp0_error));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var typeUse = tmp_0;
      tmp = typeUse;
    } else {
      var tmp_1 = this.s2h_1.o1a();
      var tmp1_safe_receiver = parentDownData;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.typeUse;
      tmp = typeForNode_0(tmp_1, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.forChildren, nodeInfo);
    }
    var tu = tmp;
    var tuc = resolveCompressed_0(this.w2h_1, tu, nodeInfo);
    var dd = equals(tuc.forNode.type, this.w2h_1.typeModel.NothingType) ? null : new DownData(p, tuc);
    this.v2h_1.v1a(dd);
    var tmp3_subject = tuc.forNode.type;
    if (isInterface(tmp3_subject, PrimitiveType))
    ;
    else {
      if (isInterface(tmp3_subject, UnnamedSuperTypeType))
      ;
      else {
        if (isInterface(tmp3_subject, CollectionType)) {
          var tmp4_subject = tuc.forNode.type;
          if (equals(tmp4_subject, SimpleTypeModelStdLib_getInstance().List)) {
            this.w2h_1.startList();
          } else if (equals(tmp4_subject, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            this.w2h_1.startListSeparated();
          } else {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.y1('Should not happen');
          }
        } else {
          if (isInterface(tmp3_subject, TupleType)) {
            this.w2h_1.startTuple();
          } else {
            if (isInterface(tmp3_subject, DataType)) {
              var tmp_2 = tuc.forNode.type;
              this.w2h_1.startAsmElement(p, isInterface(tmp_2, DataType) ? tmp_2 : THROW_CCE());
            } else {
              var tmp5_subject = tuc.forNode.type;
              if (equals(tmp5_subject, this.w2h_1.typeModel.NothingType))
              ;
              else if (equals(tmp5_subject, this.w2h_1.typeModel.AnyType))
              ;
              else {
                // Inline function 'kotlin.error' call
                throw IllegalStateException.y1('Shold not happen');
              }
            }
          }
        }
      }
    }
  }
  endBranch(nodeInfo) {
    var opt = nodeInfo.alt.option;
    var numChildren = ensureNotNull(nodeInfo.numChildrenAlternatives.u3(opt));
    var children = this.u2h_1.v2e(numChildren);
    var adjChildren = reversed(children);
    var downData = this.v2h_1.w1a();
    var value = null == downData ? null : createValueFromBranch_0(this.s2h_1.o1a(), this.t2h_1, downData, nodeInfo, adjChildren);
    var tmp0_safe_receiver = value;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp0_set = this.w2h_1.locationMap;
      var tmp1_set = this.t2h_1.v1f(nodeInfo.node);
      tmp0_set.m3(tmp0_safe_receiver, tmp1_set);
      tmp$ret$0 = Unit_getInstance();
    }
    this.u2h_1.v1a(new ChildData(nodeInfo, value));
  }
  beginEmbedded(nodeInfo) {
    var tmp = nodeInfo.node.rule;
    var tmp_0 = (tmp instanceof RuntimeRule ? tmp : THROW_CCE()).i11();
    var embeddedRhs = tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE();
    var embRuleName = embeddedRhs.l11_1.mz();
    var embGrmName = embeddedRhs.k11_1.zt_1;
    var tmp_1 = this.w2h_1.embeddedSyntaxAnalyser.u3(embGrmName);
    var tmp0_elvis_lhs = (tmp_1 == null ? true : tmp_1 instanceof SyntaxAnalyserSimpleStreamPushAbstract) ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Embedded SyntaxAnalyser not found for '" + embGrmName + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    var embSyntaxAnalyser = tmp_2;
    this.s2h_1.v1a(embSyntaxAnalyser);
    var parentDownData = ensureNotNull(this.v2h_1.o1a());
    var p = pathFor_0(this.s2h_1.o1a(), parentDownData.path, parentDownData.typeUse.forChildren.type, nodeInfo);
    var tmp1_elvis_lhs = findTypeUsageForRule_0(this.s2h_1.o1a(), embRuleName);
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      var tmp1_error = 'Type not found for ' + embRuleName;
      throw IllegalStateException.y1(toString(tmp1_error));
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tu = tmp_3;
    var tuc = resolveCompressed_0(this.w2h_1, tu, nodeInfo);
    var dd = equals(tuc.forNode.type, this.w2h_1.typeModel.NothingType) ? null : new DownData(p, tuc);
    this.v2h_1.v1a(dd);
  }
  endEmbedded(nodeInfo) {
    var embSyntaxAnalyser = this.s2h_1.w1a();
    this.u2h_1.v1a(new ChildData(nodeInfo, null));
  }
  skip(startPosition, nextInputPosition) {
  }
  error(msg, path) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.eg('An operation is not implemented: not implemented');
  }
}
class SyntaxAnalyserSimpleStreamPushAbstract extends SyntaxAnalyserFromTreeDataAbstract {
  constructor(grammarNamespaceQualifiedName, typeModel, scopeModel) {
    Companion_getInstance_38();
    super();
    this.grammarNamespaceQualifiedName = grammarNamespaceQualifiedName;
    this.typeModel = typeModel;
    this.scopeModel = scopeModel;
  }
  p1b() {
    return this.grammarNamespaceQualifiedName;
  }
  q1b() {
    return this.typeModel;
  }
  r1b() {
    return this.scopeModel;
  }
  clear() {
    super.clear();
  }
  t1b(configurationContext, configuration) {
    return emptyList();
  }
  walkTree(sentence, treeData, skipDataAsTree) {
    var syntaxAnalyserStack = mutableStackOf([this]);
    var downStack = mutableStackOf([]);
    var stack = mutableStackOf([]);
    var walker = new SyntaxAnalyserSimpleStreamPushAbstract$walkTree$walker$1(syntaxAnalyserStack, sentence, stack, downStack, this);
    treeData.traverseTreeDepthFirst(walker, false);
  }
  get embeddedSyntaxAnalyser() {
    return this.o1b();
  }
  static get Companion() {
    return Companion_getInstance_38();
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_37 = this;
    this.ROOT = new AsmElementPath('/');
  }
  x2h() {
    return this.ROOT;
  }
}
class AsmElementPath {
  constructor(value) {
    Companion_getInstance_39();
    this.value = value;
  }
  p3() {
    return this.value;
  }
  plus(segment) {
    return this.equals(Companion_getInstance_39().ROOT) ? new AsmElementPath('/' + segment) : new AsmElementPath(this.value + '/' + segment);
  }
  l2g() {
    return Companion_getInstance_39().ROOT.equals(this) ? null : new AsmElementPath(substringBeforeLast(this.value, '/'));
  }
  ti() {
    return this.value;
  }
  v1i(value) {
    return new AsmElementPath(value);
  }
  copy(value, $super) {
    value = value === VOID ? this.value : value;
    return this.v1i(value);
  }
  toString() {
    return 'AsmElementPath(value=' + this.value + ')';
  }
  hashCode() {
    return getStringHashCode(this.value);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AsmElementPath))
      return false;
    var tmp0_other_with_cast = other instanceof AsmElementPath ? other : THROW_CCE();
    if (!(this.value === tmp0_other_with_cast.value))
      return false;
    return true;
  }
  get parent() {
    return this.l2g();
  }
  static get Companion() {
    return Companion_getInstance_39();
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_38 = this;
  }
  y2h(_this__u8e3s4, indent, currentIndent) {
    var tmp0_subject = _this__u8e3s4;
    var tmp;
    if (typeof tmp0_subject === 'string') {
      tmp = "'" + toString(_this__u8e3s4) + "'";
    } else {
      if (isInterface(tmp0_subject, List)) {
        var tmp1_subject = _this__u8e3s4.o();
        var tmp_0;
        switch (tmp1_subject) {
          case 0:
            tmp_0 = '[]';
            break;
          case 1:
            var tmp2_safe_receiver = _this__u8e3s4.p(0);
            tmp_0 = '[' + (tmp2_safe_receiver == null ? null : this.y2h(tmp2_safe_receiver, indent, currentIndent)) + ']';
            break;
          default:
            var newIndent = currentIndent + indent;
            var tmp_1 = '\n' + newIndent;
            var tmp_2 = '[\n' + newIndent;
            var tmp_3 = '\n' + currentIndent + ']';
            tmp_0 = joinToString(_this__u8e3s4, tmp_1, tmp_2, tmp_3, VOID, VOID, AsmSimple$Companion$asStringAny$lambda(indent, newIndent));
            break;
        }
        tmp = tmp_0;
      } else {
        if (tmp0_subject instanceof AsmElementSimple) {
          tmp = _this__u8e3s4.asString(indent, currentIndent);
        } else {
          var tmp0_error = "property value type not handled '" + getKClassFromExpression(_this__u8e3s4) + "'";
          throw IllegalStateException.y1(toString(tmp0_error));
        }
      }
    }
    return tmp;
  }
  asStringAny$default(_this__u8e3s4, indent, currentIndent, $super) {
    currentIndent = currentIndent === VOID ? '' : currentIndent;
    return $super === VOID ? this.y2h(_this__u8e3s4, indent, currentIndent) : $super.y2h.call(this, _this__u8e3s4, indent, currentIndent);
  }
}
class sam$kotlin_Comparator$0_11 {
  constructor(function_0) {
    this.z2h_1 = function_0;
  }
  rc(a, b) {
    return this.z2h_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class AsmSimple {
  constructor() {
    Companion_getInstance_40();
    this.b1b_1 = 0;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.rootElements = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$1 = LinkedHashMap.n8();
    tmp_0.elementIndex = tmp$ret$1;
  }
  a2i() {
    return this.rootElements;
  }
  b2i() {
    return this.elementIndex;
  }
  addRoot(root) {
    var tmp = this.rootElements;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).e1(root);
  }
  removeRoot(root) {
    var tmp = this.rootElements;
    (isInterface(tmp, MutableList) ? tmp : THROW_CCE()).f1(root);
  }
  createElement(asmPath, typeName) {
    var el = new AsmElementSimple(asmPath, typeName);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.elementIndex;
    tmp0_set.m3(asmPath, el);
    return el;
  }
  traverseDepthFirst(callback) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = this.rootElements;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.api.asm.AsmSimple.traverseDepthFirst.<anonymous>' call
      traverseDepthFirst$traverse(callback, null, element);
    }
  }
  c2i(indent, currentIndent) {
    return joinToString(this.rootElements, '\n', VOID, VOID, VOID, VOID, AsmSimple$asString$lambda(indent, currentIndent));
  }
  asString(indent, currentIndent, $super) {
    currentIndent = currentIndent === VOID ? '' : currentIndent;
    return this.c2i(indent, currentIndent);
  }
  static get Companion() {
    return Companion_getInstance_40();
  }
}
class sam$kotlin_Comparator$0_12 {
  constructor(function_0) {
    this.d2i_1 = function_0;
  }
  rc(a, b) {
    return this.d2i_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class AsmElementSimple {
  constructor(asmPath, typeName) {
    this.asmPath = asmPath;
    this.typeName = typeName;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.p1a_1 = tmp$ret$0;
    this.properties = this.p1a_1;
  }
  e2i() {
    return this.asmPath;
  }
  k1n() {
    return this.typeName;
  }
  nm() {
    return this.properties;
  }
  f2i() {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = this.properties.k3();
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = AsmElementSimple$_get_propertiesOrdered_$lambda_5oy69n;
    tmp$ret$0 = new sam$kotlin_Comparator$0_12(tmp);
    tmp$ret$1 = sortedWith(tmp0_sortedBy, tmp$ret$0);
    return tmp$ret$1;
  }
  v17() {
    var tmp$ret$7;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filterNot' call
    var tmp0_filterNot = this.properties.k3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterNotTo' call
    var tmp0_filterNotTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filterNot.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.<get-children>.<anonymous>' call
      tmp$ret$0 = element.isReference;
      if (!tmp$ret$0) {
        tmp0_filterNotTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterNotTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_flatMap = tmp$ret$2;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator_0 = tmp1_flatMap.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.<get-children>.<anonymous>' call
      var tmp;
      var tmp_0 = element_0.value;
      if (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) {
        tmp = element_0.value;
      } else {
        tmp = listOf(element_0.value);
      }
      tmp$ret$3 = tmp;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    var tmp2_filterIsInstance = tmp$ret$5;
    var tmp$ret$6;
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var tmp0_filterIsInstanceTo = ArrayList.i4();
    var tmp0_iterator_1 = tmp2_filterIsInstance.u();
    while (tmp0_iterator_1.h1()) {
      var element_1 = tmp0_iterator_1.j1();
      if (element_1 instanceof AsmElementSimple) {
        tmp0_filterIsInstanceTo.e1(element_1);
      }
    }
    tmp$ret$6 = tmp0_filterIsInstanceTo;
    tmp$ret$7 = tmp$ret$6;
    return tmp$ret$7;
  }
  hasProperty(name) {
    return this.properties.r3(name);
  }
  getPropertyOrNull(name) {
    var tmp0_safe_receiver = this.properties.u3(name);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value;
  }
  getPropertyAsStringOrNull(name) {
    var tmp = this.getPropertyOrNull(name);
    return (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
  }
  getPropertyAsAsmElementOrNull(name) {
    var tmp = this.getPropertyOrNull(name);
    return (tmp == null ? true : tmp instanceof AsmElementSimple) ? tmp : THROW_CCE();
  }
  getPropertyAsReferenceOrNull(name) {
    var tmp = this.getPropertyOrNull(name);
    return (tmp == null ? true : tmp instanceof AsmElementReference) ? tmp : THROW_CCE();
  }
  getPropertyAsListOrNull(name) {
    var tmp = this.getPropertyOrNull(name);
    return (tmp == null ? true : isInterface(tmp, List)) ? tmp : THROW_CCE();
  }
  getProperty(name) {
    var tmp0_safe_receiver = this.properties.u3(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_error = "Cannot find property '" + name + "' in element type '" + this.typeName + "' with path '" + this.asmPath + "' ";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  getPropertyAsString(name) {
    var tmp = this.getProperty(name);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  }
  getPropertyAsAsmElement(name) {
    var tmp = this.getProperty(name);
    return tmp instanceof AsmElementSimple ? tmp : THROW_CCE();
  }
  getPropertyAsReference(name) {
    var tmp = this.getProperty(name);
    return tmp instanceof AsmElementReference ? tmp : THROW_CCE();
  }
  getPropertyAsList(name) {
    var tmp = this.getProperty(name);
    return isInterface(tmp, List) ? tmp : THROW_CCE();
  }
  getPropertyAsListOfElement(name) {
    var tmp = this.getProperty(name);
    return isInterface(tmp, List) ? tmp : THROW_CCE();
  }
  setProperty(name, value, isReference, childIndex) {
    if (isReference) {
      var ref = new AsmElementReference((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), null);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.p1a_1;
      var tmp1_set = new AsmElementProperty(name, childIndex, ref, true);
      tmp0_set.m3(name, tmp1_set);
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.p1a_1;
      var tmp3_set = new AsmElementProperty(name, childIndex, value, false);
      tmp2_set.m3(name, tmp3_set);
    }
  }
  setPropertyFromDeclaration(declaration, value, isReference) {
    if (isReference) {
      var ref = new AsmElementReference((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), null);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.p1a_1;
      var tmp1_set = declaration.name;
      var tmp2_set = new AsmElementProperty(declaration.name, declaration.index, ref, true);
      tmp0_set.m3(tmp1_set, tmp2_set);
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp3_set = this.p1a_1;
      var tmp4_set = declaration.name;
      var tmp5_set = new AsmElementProperty(declaration.name, declaration.index, value, false);
      tmp3_set.m3(tmp4_set, tmp5_set);
    }
  }
  addAllProperty(value) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = value.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.addAllProperty.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.p1a_1;
      var tmp1_set = element.name;
      tmp0_set.m3(tmp1_set, element);
    }
  }
  equalTo(other) {
    var tmp;
    if (!this.asmPath.equals(other.asmPath)) {
      tmp = false;
    } else if (!(this.typeName === other.typeName)) {
      tmp = false;
    } else if (!(this.properties.o() === other.properties.o())) {
      tmp = false;
    } else {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp0_all = this.properties;
        if (tmp0_all.y()) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var tmp$ret$1;
        // Inline function 'kotlin.collections.iterator' call
        tmp$ret$1 = tmp0_all.l3().u();
        var tmp0_iterator = tmp$ret$1;
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$4;
          // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.equalTo.<anonymous>' call
          var tmp$ret$2;
          // Inline function 'kotlin.collections.component1' call
          tmp$ret$2 = element.o3();
          var k = tmp$ret$2;
          var tmp$ret$3;
          // Inline function 'kotlin.collections.component2' call
          tmp$ret$3 = element.p3();
          var v = tmp$ret$3;
          var o = other.properties.u3(k);
          var tmp_0;
          if (null == o) {
            tmp_0 = false;
          } else {
            tmp_0 = v.equalTo(o);
          }
          tmp$ret$4 = tmp_0;
          if (!tmp$ret$4) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    }
    return tmp;
  }
  c2i(indent, currentIndent) {
    var newIndent = currentIndent + indent;
    var tmp = this.properties.k3();
    var tmp_0 = '\n' + newIndent;
    var tmp_1 = '{\n' + newIndent;
    var tmp_2 = '\n' + currentIndent + '}';
    var propsStr = joinToString(tmp, tmp_0, tmp_1, tmp_2, VOID, VOID, AsmElementSimple$asString$lambda(indent, newIndent));
    return ':' + this.typeName + ' ' + propsStr;
  }
  asString(indent, currentIndent, $super) {
    currentIndent = currentIndent === VOID ? '' : currentIndent;
    return this.c2i(indent, currentIndent);
  }
  hashCode() {
    return this.asmPath.hashCode();
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (tmp0_subject instanceof AsmElementSimple) {
      tmp = this.asmPath.equals(other.asmPath);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return ':' + this.typeName + '(' + this.asmPath + ')';
  }
  get propertiesOrdered() {
    return this.f2i();
  }
  get children() {
    return this.v17();
  }
}
class AsmElementReference {
  constructor(reference, value) {
    this.reference = reference;
    this.value = value;
  }
  g2i() {
    return this.reference;
  }
  h2i(_set____db54di) {
    this.value = _set____db54di;
  }
  p3() {
    return this.value;
  }
  equalTo(other) {
    return !(this.reference === other.reference) ? false : true;
  }
  toString() {
    var tmp0_subject = this.value;
    return tmp0_subject == null ? '<unresolved> &' + this.reference : "&{'" + ensureNotNull(this.value).asmPath.value + "' : " + ensureNotNull(this.value).typeName + '}';
  }
}
class AsmElementProperty {
  constructor(name, childIndex, value, isReference) {
    this.name = name;
    this.childIndex = childIndex;
    this.value = value;
    this.isReference = isReference;
  }
  be() {
    return this.name;
  }
  i2i() {
    return this.childIndex;
  }
  p3() {
    return this.value;
  }
  xm() {
    return this.isReference;
  }
  equalTo(other) {
    var tmp;
    if (!(this.name === other.name)) {
      tmp = false;
    } else if (!(this.isReference === other.isReference)) {
      tmp = false;
    } else {
      var t = this.value;
      var o = other.value;
      var tmp_0;
      if (this.isReference) {
        var tmp_1;
        var tmp_2;
        if (t instanceof AsmElementReference) {
          tmp_2 = o instanceof AsmElementReference;
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = t.equalTo(o);
        } else {
          var tmp0_error = 'Cannot compare property values: ' + toString_1(t) + ' and ' + toString_1(o);
          throw IllegalStateException.y1(toString(tmp0_error));
        }
        tmp_0 = tmp_1;
      } else {
        var tmp_3;
        var tmp_4;
        if (t instanceof AsmElementSimple) {
          tmp_4 = o instanceof AsmElementSimple;
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp_3 = t.equalTo(o);
        } else {
          tmp_3 = equals(t, o);
        }
        tmp_0 = tmp_3;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_subject = this.value;
    var tmp;
    if (tmp0_subject instanceof AsmElementSimple) {
      tmp = this.name + ' = :' + this.value.typeName;
    } else {
      if (!(tmp0_subject == null) ? isInterface(tmp0_subject, List) : false) {
        tmp = this.name + ' = [...]';
      } else {
        if (!(tmp0_subject == null) ? typeof tmp0_subject === 'string' : false) {
          tmp = this.isReference ? this.name + ' = &' + toString_1(this.value) : this.name + ' = ' + toString_1(this.value);
        } else {
          tmp = this.name + ' = ' + toString_1(this.value);
        }
      }
    }
    return tmp;
  }
}
class AsmSimpleBuilder {
  constructor(_scopeModel, _context, resolveReferences) {
    this.j2i_1 = _scopeModel;
    this.k2i_1 = _context;
    this.l2i_1 = resolveReferences;
    this.m2i_1 = new AsmSimple();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.n2i_1 = tmp$ret$0;
  }
  string(value) {
    this.m2i_1.addRoot(value);
  }
  element(typeName, init) {
    var path = Companion_getInstance_39().ROOT.plus(this.m2i_1.rootElements.o().toString());
    var tmp0_safe_receiver = this.k2i_1;
    var b = new AsmElementSimpleBuilder(this.j2i_1, this.n2i_1, this.m2i_1, path, typeName, true, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f1b_1);
    init(b);
    return b.build();
  }
  tuple(init) {
    return this.element(Companion_getInstance_0().NAME, init);
  }
  listOfString(items) {
    var path = Companion_getInstance_39().ROOT.plus(this.m2i_1.rootElements.o().toString());
    var list = asList(items);
    this.m2i_1.addRoot(list);
    return list;
  }
  list(init) {
    var path = Companion_getInstance_39().ROOT.plus(this.m2i_1.rootElements.o().toString());
    var tmp0_safe_receiver = this.k2i_1;
    var b = new ListAsmElementSimpleBuilder(this.j2i_1, this.n2i_1, this.m2i_1, path, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f1b_1);
    init(b);
    var list = b.build();
    this.m2i_1.addRoot(list);
    return list;
  }
  build() {
    var issues = new IssueHolder(LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance());
    if (this.l2i_1 ? !(null == this.k2i_1) : false) {
      var resolveFunction = AsmSimpleBuilder$build$lambda(this);
      this.m2i_1.traverseDepthFirst(new ReferenceResolverDefault(this.j2i_1, this.k2i_1.f1b_1, resolveFunction, null, issues));
    }
    return this.m2i_1;
  }
}
class AsmElementSimpleBuilder {
  constructor(_scopeModel, _scopeMap, _asm, _asmPath, _typeName, _isRoot, _parentScope) {
    this.o2i_1 = _scopeModel;
    this.p2i_1 = _scopeMap;
    this.q2i_1 = _asm;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = this.q2i_1.createElement(_asmPath, _typeName);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.api.asm.AsmElementSimpleBuilder._element.<anonymous>' call
    if (_isRoot) {
      this.q2i_1.addRoot(tmp0_also);
    }
    tmp$ret$0 = tmp0_also;
    tmp.r2i_1 = tmp$ret$0;
    var tmp_0 = this;
    tmp_0.s2i_1 = lazy(AsmElementSimpleBuilder$_elementScope$delegate$lambda(_parentScope, this, _asmPath));
  }
  propertyUnnamedString(value) {
    Companion_getInstance_11();
    return _property(this, '$value', value);
  }
  propertyString(name, value) {
    return _property(this, name, value);
  }
  propertyNull(name) {
    return _property(this, name, null);
  }
  propertyUnnamedElement(typeName, init) {
    Companion_getInstance_11();
    return this.propertyElementExplicitType('$value', typeName, init);
  }
  propertyTuple(name, init) {
    return this.propertyElementExplicitType(name, Companion_getInstance_0().NAME, init);
  }
  propertyElement(name, init) {
    return this.propertyElementExplicitType(name, name, init);
  }
  propertyElementExplicitType(name, typeName, init) {
    var newPath = this.r2i_1.asmPath.plus(name);
    var b = new AsmElementSimpleBuilder(this.o2i_1, this.p2i_1, this.q2i_1, newPath, typeName, false, _get__elementScope__jy0q92(this));
    init(b);
    var el = b.build();
    this.r2i_1.setProperty(name, el, false, 0);
    return el;
  }
  propertyUnnamedListOfString(list) {
    Companion_getInstance_11();
    return _property(this, '$list', list);
  }
  propertyListOfString(name, list) {
    return _property(this, name, list);
  }
  propertyUnnamedListOfElement(init) {
    Companion_getInstance_11();
    return this.propertyListOfElement('$list', init);
  }
  propertyListOfElement(name, init) {
    var newPath = this.r2i_1.asmPath.plus(name);
    var b = new ListAsmElementSimpleBuilder(this.o2i_1, this.p2i_1, this.q2i_1, newPath, _get__elementScope__jy0q92(this));
    init(b);
    var list = b.build();
    this.r2i_1.setProperty(name, list, false, 0);
    return list;
  }
  reference(name, elementReference) {
    this.r2i_1.setProperty(name, elementReference, true, 0);
  }
  build() {
    var es = _get__elementScope__jy0q92(this);
    if (null == es) {
    } else {
      var scopeFor = es.forTypeName;
      var referablePropertyName = this.o2i_1.getReferablePropertyNameFor(scopeFor, this.r2i_1.typeName);
      var tmp0_safe_receiver = referablePropertyName;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.api.asm.AsmElementSimpleBuilder.build.<anonymous>' call
        tmp$ret$0 = this.r2i_1.getPropertyAsStringOrNull(tmp0_safe_receiver);
        tmp$ret$1 = tmp$ret$0;
        tmp = tmp$ret$1;
      }
      var referableName = tmp;
      if (!(null == referableName)) {
        es.addToScope(referableName, this.r2i_1.typeName, this.r2i_1.asmPath);
      }
    }
    return this.r2i_1;
  }
}
class ListAsmElementSimpleBuilder {
  constructor(_scopeModel, _scopeMap, _asm, _asmPath, _parentScope) {
    this.t2i_1 = _scopeModel;
    this.u2i_1 = _scopeMap;
    this.v2i_1 = _asm;
    this.w2i_1 = _asmPath;
    this.x2i_1 = _parentScope;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.y2i_1 = tmp$ret$0;
  }
  string(value) {
    this.y2i_1.e1(value);
  }
  list(init) {
    var newPath = this.w2i_1.plus(this.y2i_1.o().toString());
    var b = new ListAsmElementSimpleBuilder(this.t2i_1, this.u2i_1, this.v2i_1, newPath, this.x2i_1);
    init(b);
    var list = b.build();
    this.y2i_1.e1(list);
  }
  element(typeName, init) {
    var newPath = this.w2i_1.plus(this.y2i_1.o().toString());
    var b = new AsmElementSimpleBuilder(this.t2i_1, this.u2i_1, this.v2i_1, newPath, typeName, false, this.x2i_1);
    init(b);
    var el = b.build();
    this.y2i_1.e1(el);
    return el;
  }
  tuple(init) {
    return this.element(Companion_getInstance_0().NAME, init);
  }
  build() {
    return this.y2i_1;
  }
}
class AsmSimpleBuilderMarker {
  equals(other) {
    if (!(other instanceof AsmSimpleBuilderMarker))
      return false;
    var tmp0_other_with_cast = other instanceof AsmSimpleBuilderMarker ? other : THROW_CCE();
    return true;
  }
  hashCode() {
    return 0;
  }
  toString() {
    return '@net.akehurst.language.api.asm.AsmSimpleBuilderMarker()';
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_39 = this;
  }
  build(rrs, automatonKind, userGoalRule, isSkip, init) {
    return automaton(rrs instanceof RuntimeRuleSet ? rrs : THROW_CCE(), automatonKind, userGoalRule, isSkip, init);
  }
}
class ParseAction extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get HEIGHT() {
    return ParseAction_HEIGHT_getInstance();
  }
  static get GRAFT() {
    return ParseAction_GRAFT_getInstance();
  }
  static get WIDTH() {
    return ParseAction_WIDTH_getInstance();
  }
  static get GOAL() {
    return ParseAction_GOAL_getInstance();
  }
  static get EMBED() {
    return ParseAction_EMBED_getInstance();
  }
}
class AglAutomatonDslMarker {
  equals(other) {
    if (!(other instanceof AglAutomatonDslMarker))
      return false;
    var tmp0_other_with_cast = other instanceof AglAutomatonDslMarker ? other : THROW_CCE();
    return true;
  }
  hashCode() {
    return 0;
  }
  toString() {
    return '@net.akehurst.language.api.automaton.AglAutomatonDslMarker()';
  }
}
class FormatModelBuilder {
  constructor() {
    this.b2j_1 = new AsmSimple();
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.c2j_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.also' call
    var tmp0_also = this.b2j_1.createElement(new AsmElementPath(''), 'Unit');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.api.formatter.FormatModelBuilder.rules.<anonymous>' call
    this.b2j_1.addRoot(tmp0_also);
    tmp0_also.setProperty('ruleList', this.c2j_1, false, 0);
    tmp$ret$1 = tmp0_also;
    tmp_0.d2j_1 = tmp$ret$1;
  }
  rule(forTypeName, init) {
    var b = new FormatExpressionBuilder(this.b2j_1);
    init(b);
    var expr = b.build();
    var formatRuleElement = this.b2j_1.createElement(new AsmElementPath(''), 'FormatRule');
    var typeReference = this.b2j_1.createElement(new AsmElementPath(''), 'TypeReference');
    typeReference.setProperty('identifier', forTypeName, false, 0);
    formatRuleElement.setProperty('typeReference', typeReference, false, 0);
    formatRuleElement.setProperty('formatExpression', expr, false, 0);
    this.c2j_1.e1(formatRuleElement);
  }
  build() {
    return new AglFormatterModelDefault(this.b2j_1);
  }
}
class FormatExpressionBuilder {
  constructor(_asm) {
    this.e2j_1 = _asm;
  }
  literalString(value) {
    var el = this.e2j_1.createElement(new AsmElementPath(''), 'LiteralString');
    el.setProperty('literal_string', value, false, 0);
    this.f2j_1 = el;
  }
  build() {
    return _get__exp__d2m08d(this);
  }
}
class GrammarExeception extends RuntimeException {
  constructor(message, cause) {
    return new.target.o1i(message, cause);
  }
  static o1i(message, cause) {
    var $this = super.ug(message, cause);
    captureStack($this, $this.n1i_1);
    return $this;
  }
}
class GrammarLoader {}
class GrammarRegistry_0 {}
class Associativity extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
}
class OverrideKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get REPLACE() {
    return OverrideKind_REPLACE_getInstance();
  }
  static get APPEND_ALTERNATIVE() {
    return OverrideKind_APPEND_ALTERNATIVE_getInstance();
  }
}
class GrammarRuleItemNotFoundException extends RuntimeException {
  constructor(message) {
    return new.target.l1l(message);
  }
  static l1l(message) {
    var $this = super.u6(message);
    captureStack($this, $this.k1l_1);
    return $this;
  }
}
class GrammarRuleNotFoundException extends RuntimeException {
  constructor(message) {
    return new.target.n2j(message);
  }
  static n2j(message) {
    var $this = super.u6(message);
    captureStack($this, $this.m2j_1);
    return $this;
  }
}
class SeparatedListKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get Flat() {
    return SeparatedListKind_Flat_getInstance();
  }
  static get Left() {
    return SeparatedListKind_Left_getInstance();
  }
  static get Right() {
    return SeparatedListKind_Right_getInstance();
  }
}
class GrammarTypeModelBuilder {
  constructor(namespaceQualifiedName, imports) {
    this.q2j_1 = new GrammarTypeNamespaceSimple(namespaceQualifiedName, imports);
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.r2j_1 = tmp$ret$0;
  }
  eo() {
    return this.q2j_1;
  }
}
class Message {
  constructor() {
    Message_instance = this;
    this.s2j_1 = 'The Parser has exceeded the configured number of non-progressing steps, self-terminated as it is likely it will never stop.';
  }
}
class InputLocation {
  constructor(position, column, line, length) {
    this.position = position;
    this.column = column;
    this.line = line;
    this.length = length;
  }
  t2j() {
    return this.position;
  }
  u2j() {
    return this.column;
  }
  v2j() {
    return this.line;
  }
  w2j(_set____db54di) {
    this.length = _set____db54di;
  }
  a() {
    return this.length;
  }
  x2j() {
    return this.position + this.length | 0;
  }
  ti() {
    return this.position;
  }
  ui() {
    return this.column;
  }
  r1j() {
    return this.line;
  }
  s1j() {
    return this.length;
  }
  y2j(position, column, line, length) {
    return new InputLocation(position, column, line, length);
  }
  copy(position, column, line, length, $super) {
    position = position === VOID ? this.position : position;
    column = column === VOID ? this.column : column;
    line = line === VOID ? this.line : line;
    length = length === VOID ? this.length : length;
    return this.y2j(position, column, line, length);
  }
  toString() {
    return 'InputLocation(position=' + this.position + ', column=' + this.column + ', line=' + this.line + ', length=' + this.length + ')';
  }
  hashCode() {
    var result = this.position;
    result = imul(result, 31) + this.column | 0;
    result = imul(result, 31) + this.line | 0;
    result = imul(result, 31) + this.length | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InputLocation))
      return false;
    var tmp0_other_with_cast = other instanceof InputLocation ? other : THROW_CCE();
    if (!(this.position === tmp0_other_with_cast.position))
      return false;
    if (!(this.column === tmp0_other_with_cast.column))
      return false;
    if (!(this.line === tmp0_other_with_cast.line))
      return false;
    if (!(this.length === tmp0_other_with_cast.length))
      return false;
    return true;
  }
  get endPosition() {
    return this.x2j();
  }
}
class ParseTreeException extends RuntimeException {
  static new_net_akehurst_language_api_parser_ParseTreeException(message, cause) {
    var $this = super.ug(message, cause);
    init_net_akehurst_language_api_parser_ParseTreeException($this);
    return $this;
  }
  static new_net_akehurst_language_api_parser_ParseTreeException(message) {
    var $this = super.u6(message);
    init_net_akehurst_language_api_parser_ParseTreeException($this);
    return $this;
  }
}
class ParserConstructionFailedException extends RuntimeException {
  constructor(message) {
    return new.target.f2k(message);
  }
  static f2k(message) {
    var $this = super.u6(message);
    captureStack($this, $this.e2k_1);
    return $this;
  }
}
class ParserException extends RuntimeException {
  constructor(message) {
    return new.target.d2c(message);
  }
  static d2c(message) {
    var $this = super.u6(message);
    captureStack($this, $this.c2c_1);
    return $this;
  }
}
class ParserTerminatedException extends RuntimeException {
  constructor(message) {
    return new.target.a1u(message);
  }
  static a1u(message) {
    var $this = super.u6(message);
    captureStack($this, $this.z1t_1);
    return $this;
  }
}
class ParseFailedException extends RuntimeException {
  constructor(message, longestMatch, location, expected, contextInText) {
    return new.target.j2k(message, longestMatch, location, expected, contextInText);
  }
  static j2k(message, longestMatch, location, expected, contextInText) {
    var $this = super.u6(message + ', at line ' + location.line + ' column ' + location.column + ', expected one of ' + expected + '\n...' + contextInText + '...');
    captureStack($this, $this.i2k_1);
    $this.longestMatch = longestMatch;
    $this.location = location;
    $this.expected = expected;
    $this.contextInText = contextInText;
    return $this;
  }
  k2k() {
    return this.longestMatch;
  }
  l2k() {
    return this.location;
  }
  m2k() {
    return this.expected;
  }
  n2k() {
    return this.contextInText;
  }
}
class AutomatonKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get LOOKAHEAD_NONE() {
    return AutomatonKind_LOOKAHEAD_NONE_getInstance();
  }
  static get LOOKAHEAD_SIMPLE() {
    return AutomatonKind_LOOKAHEAD_SIMPLE_getInstance();
  }
  static get LOOKAHEAD_1() {
    return AutomatonKind_LOOKAHEAD_1_getInstance();
  }
}
class AutomatonKind_api_0 {
  constructor() {
    AutomatonKind_api_instance = this;
    this.LOOKAHEAD_NONE = AutomatonKind_LOOKAHEAD_NONE_getInstance();
    this.LOOKAHEAD_SIMPLE = AutomatonKind_LOOKAHEAD_SIMPLE_getInstance();
    this.LOOKAHEAD_1 = AutomatonKind_LOOKAHEAD_1_getInstance();
  }
  q2k() {
    return this.LOOKAHEAD_NONE;
  }
  r2k() {
    return this.LOOKAHEAD_SIMPLE;
  }
  s2k() {
    return this.LOOKAHEAD_1;
  }
}
class CompletionItemKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get LITERAL() {
    return CompletionItemKind_LITERAL_getInstance();
  }
  static get PATTERN() {
    return CompletionItemKind_PATTERN_getInstance();
  }
  static get SEGMENT() {
    return CompletionItemKind_SEGMENT_getInstance();
  }
}
class CompletionItem {
  constructor(kind, text, name) {
    this.kind = kind;
    this.text = text;
    this.name = name;
    this.description = '';
  }
  v2k() {
    return this.kind;
  }
  u1p() {
    return this.text;
  }
  be() {
    return this.name;
  }
  w2k(_set____db54di) {
    this.description = _set____db54di;
  }
  x2k() {
    return this.description;
  }
  ti() {
    return this.kind;
  }
  ui() {
    return this.text;
  }
  r1j() {
    return this.name;
  }
  y2k(kind, text, name) {
    return new CompletionItem(kind, text, name);
  }
  copy(kind, text, name, $super) {
    kind = kind === VOID ? this.kind : kind;
    text = text === VOID ? this.text : text;
    name = name === VOID ? this.name : name;
    return this.y2k(kind, text, name);
  }
  toString() {
    return 'CompletionItem(kind=' + this.kind + ', text=' + this.text + ', name=' + this.name + ')';
  }
  hashCode() {
    var result = this.kind.hashCode();
    result = imul(result, 31) + getStringHashCode(this.text) | 0;
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletionItem))
      return false;
    var tmp0_other_with_cast = other instanceof CompletionItem ? other : THROW_CCE();
    if (!this.kind.equals(tmp0_other_with_cast.kind))
      return false;
    if (!(this.text === tmp0_other_with_cast.text))
      return false;
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    return true;
  }
}
class LanguageProcessorException extends Exception {
  constructor(message, cause) {
    return new.target.s1v(message, cause);
  }
  static s1v(message, cause) {
    var $this = super.sg(message, cause);
    captureStack($this, $this.r1v_1);
    return $this;
  }
}
class LanguageIssueKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get ERROR() {
    return LanguageIssueKind_ERROR_getInstance();
  }
  static get WARNING() {
    return LanguageIssueKind_WARNING_getInstance();
  }
  static get INFORMATION() {
    return LanguageIssueKind_INFORMATION_getInstance();
  }
}
class LanguageProcessorPhase extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get GRAMMAR() {
    return LanguageProcessorPhase_GRAMMAR_getInstance();
  }
  static get PARSE() {
    return LanguageProcessorPhase_PARSE_getInstance();
  }
  static get SYNTAX_ANALYSIS() {
    return LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance();
  }
  static get SEMANTIC_ANALYSIS() {
    return LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance();
  }
  static get INTERPRETER() {
    return LanguageProcessorPhase_INTERPRETER_getInstance();
  }
  static get GENERATOR() {
    return LanguageProcessorPhase_GENERATOR_getInstance();
  }
  static get FORMATTER() {
    return LanguageProcessorPhase_FORMATTER_getInstance();
  }
  static get ALL() {
    return LanguageProcessorPhase_ALL_getInstance();
  }
}
class LanguageIssue {
  constructor(kind, phase, location, message, data) {
    data = data === VOID ? null : data;
    this.kind = kind;
    this.phase = phase;
    this.location = location;
    this.message = message;
    this.data = data;
  }
  v2k() {
    return this.kind;
  }
  d2l() {
    return this.phase;
  }
  l2k() {
    return this.location;
  }
  j9() {
    return this.message;
  }
  e2l() {
    return this.data;
  }
  ti() {
    return this.kind;
  }
  ui() {
    return this.phase;
  }
  r1j() {
    return this.location;
  }
  s1j() {
    return this.message;
  }
  t1j() {
    return this.data;
  }
  f2l(kind, phase, location, message, data) {
    return new LanguageIssue(kind, phase, location, message, data);
  }
  copy(kind, phase, location, message, data, $super) {
    kind = kind === VOID ? this.kind : kind;
    phase = phase === VOID ? this.phase : phase;
    location = location === VOID ? this.location : location;
    message = message === VOID ? this.message : message;
    data = data === VOID ? this.data : data;
    return this.f2l(kind, phase, location, message, data);
  }
  toString() {
    return 'LanguageIssue(kind=' + this.kind + ', phase=' + this.phase + ', location=' + this.location + ', message=' + this.message + ', data=' + toString_1(this.data) + ')';
  }
  hashCode() {
    var result = this.kind.hashCode();
    result = imul(result, 31) + this.phase.hashCode() | 0;
    result = imul(result, 31) + (this.location == null ? 0 : this.location.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.message) | 0;
    result = imul(result, 31) + (this.data == null ? 0 : hashCode(this.data)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LanguageIssue))
      return false;
    var tmp0_other_with_cast = other instanceof LanguageIssue ? other : THROW_CCE();
    if (!this.kind.equals(tmp0_other_with_cast.kind))
      return false;
    if (!this.phase.equals(tmp0_other_with_cast.phase))
      return false;
    if (!equals(this.location, tmp0_other_with_cast.location))
      return false;
    if (!(this.message === tmp0_other_with_cast.message))
      return false;
    if (!equals(this.data, tmp0_other_with_cast.data))
      return false;
    return true;
  }
}
class LanguageProcessorConfiguration {}
class ParseOptions {}
class SyntaxAnalysisOptions {}
class SemanticAnalysisOptions {}
class CompletionProviderOptions {}
class ProcessOptions {}
class LanguageProcessorConfigurationBuilder {
  constructor(base) {
    this.base = base;
    this.e2m_1 = null;
    this.f2m_1 = null;
    this.g2m_1 = null;
    this.h2m_1 = null;
    this.i2m_1 = null;
    this.j2m_1 = null;
    this.k2m_1 = null;
    this.l2m_1 = null;
    this.m2m_1 = null;
  }
  n2m() {
    return this.base;
  }
  targetGrammarName(value) {
    this.e2m_1 = value;
  }
  defaultGoalRuleName(value) {
    this.f2m_1 = value;
  }
  typeModelResolver(func) {
    this.g2m_1 = func;
  }
  scopeModelResolver(func) {
    this.h2m_1 = func;
  }
  syntaxAnalyserResolver(func) {
    this.i2m_1 = func;
  }
  semanticAnalyserResolver(value) {
    this.j2m_1 = value;
  }
  formatterResolver(func) {
    this.k2m_1 = func;
  }
  styleResolver(func) {
    this.l2m_1 = func;
  }
  completionProvider(value) {
    this.m2m_1 = value;
  }
  build() {
    var tmp0_subject = this.base;
    var tmp;
    if (tmp0_subject == null) {
      tmp = new LanguageProcessorConfigurationDefault(this.e2m_1, this.f2m_1, this.g2m_1, this.h2m_1, this.i2m_1, this.j2m_1, this.k2m_1, this.l2m_1, this.m2m_1);
    } else {
      if (tmp0_subject instanceof LanguageProcessorConfigurationDefault) {
        var tmp1_elvis_lhs = this.e2m_1;
        var tmp_0 = tmp1_elvis_lhs == null ? this.base.o2m_1 : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.f2m_1;
        var tmp_1 = tmp2_elvis_lhs == null ? this.base.p2m_1 : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = this.g2m_1;
        var tmp_2 = tmp3_elvis_lhs == null ? this.base.q2m_1 : tmp3_elvis_lhs;
        var tmp4_elvis_lhs = this.h2m_1;
        var tmp_3 = tmp4_elvis_lhs == null ? this.base.r2m_1 : tmp4_elvis_lhs;
        var tmp5_elvis_lhs = this.i2m_1;
        var tmp_4 = tmp5_elvis_lhs == null ? this.base.s2m_1 : tmp5_elvis_lhs;
        var tmp6_elvis_lhs = this.j2m_1;
        var tmp_5 = tmp6_elvis_lhs == null ? this.base.t2m_1 : tmp6_elvis_lhs;
        var tmp7_elvis_lhs = this.k2m_1;
        var tmp_6 = tmp7_elvis_lhs == null ? this.base.u2m_1 : tmp7_elvis_lhs;
        var tmp8_elvis_lhs = this.l2m_1;
        var tmp_7 = tmp8_elvis_lhs == null ? this.base.v2m_1 : tmp8_elvis_lhs;
        var tmp9_elvis_lhs = this.m2m_1;
        tmp = new LanguageProcessorConfigurationDefault(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp9_elvis_lhs == null ? this.base.w2m_1 : tmp9_elvis_lhs);
      } else {
        var tmp0_error = 'Cannot override LanguageProcessorConfiguration of type ' + getKClassFromExpression(this.base).n9();
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
    return tmp;
  }
}
class ProcessOptionsBuilder {
  constructor() {
    this.x2m_1 = new ParseOptionsDefault();
    this.y2m_1 = new SyntaxAnalysisOptionsDefault();
    this.z2m_1 = new SemanticAnalysisOptionsDefault();
    this.a2n_1 = new CompletionProviderOptionsDefault();
  }
  parse(init) {
    var b = new ParseOptionsBuilder();
    init(b);
    this.x2m_1 = b.build();
  }
  syntaxAnalysis(init) {
    var b = new SyntaxAnalysisOptionsBuilder();
    init(b);
    this.y2m_1 = b.build();
  }
  semanticAnalysis(init) {
    var b = new SemanticAnalysisOptionsBuilder();
    init(b);
    this.z2m_1 = b.build();
  }
  completionProvider(init) {
    var b = new CompletionProviderOptionsBuilder();
    init(b);
    this.a2n_1 = b.build();
  }
  build() {
    return new ProcessOptionsDefault(this.x2m_1, this.y2m_1, this.z2m_1, this.a2n_1);
  }
}
class ParseOptionsBuilder {
  constructor() {
    this.b2n_1 = null;
    this.c2n_1 = AutomatonKind_LOOKAHEAD_1_getInstance();
    this.d2n_1 = true;
    this.e2n_1 = false;
    this.f2n_1 = true;
  }
  goalRuleName(value) {
    this.b2n_1 = value;
  }
  automatonKind(value) {
    this.c2n_1 = value;
  }
  reportErrors(value) {
    this.d2n_1 = value;
  }
  reportGrammarAmbiguities(value) {
    this.e2n_1 = value;
  }
  cacheSkip(value) {
    this.f2n_1 = value;
  }
  build() {
    return new ParseOptionsDefault(this.b2n_1, this.c2n_1, this.d2n_1, this.e2n_1, this.f2n_1);
  }
}
class SyntaxAnalysisOptionsBuilder {
  constructor() {
    this.g2n_1 = true;
  }
  active(value) {
    this.g2n_1 = value;
  }
  build() {
    return new SyntaxAnalysisOptionsDefault(this.g2n_1);
  }
}
class SemanticAnalysisOptionsBuilder {
  constructor() {
    this.h2n_1 = true;
    this.i2n_1 = emptyMap();
    this.j2n_1 = null;
    this.k2n_1 = true;
    this.l2n_1 = true;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.m2n_1 = tmp$ret$0;
  }
  active(value) {
    this.h2n_1 = value;
  }
  locationMap(value) {
    this.i2n_1 = value;
  }
  context(value) {
    this.j2n_1 = value;
  }
  checkReferences(value) {
    this.k2n_1 = value;
  }
  resolveReferences(value) {
    this.l2n_1 = value;
  }
  option(key, value) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.m2n_1;
    tmp0_set.m3(key, value);
  }
  build() {
    return new SemanticAnalysisOptionsDefault(this.h2n_1, this.i2n_1, this.j2n_1, this.k2n_1, this.l2n_1, this.m2n_1);
  }
}
class CompletionProviderOptionsBuilder {
  constructor() {
    this.n2n_1 = null;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.o2n_1 = tmp$ret$0;
  }
  context(value) {
    this.n2n_1 = value;
  }
  option(key, value) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.o2n_1;
    tmp0_set.m3(key, value);
  }
  build() {
    return new CompletionProviderOptionsDefault(this.n2n_1, this.o2n_1);
  }
}
class LanguageProcessorConfigurationDefault {
  constructor(targetGrammarName, defaultGoalRuleName, typeModelResolver, scopeModelResolver, syntaxAnalyserResolver, semanticAnalyserResolver, formatterResolver, styleResolver, completionProvider) {
    this.o2m_1 = targetGrammarName;
    this.p2m_1 = defaultGoalRuleName;
    this.q2m_1 = typeModelResolver;
    this.r2m_1 = scopeModelResolver;
    this.s2m_1 = syntaxAnalyserResolver;
    this.t2m_1 = semanticAnalyserResolver;
    this.u2m_1 = formatterResolver;
    this.v2m_1 = styleResolver;
    this.w2m_1 = completionProvider;
  }
  y1x() {
    return this.o2m_1;
  }
  d22() {
    return this.p2m_1;
  }
  g2l() {
    return this.q2m_1;
  }
  h2l() {
    return this.r2m_1;
  }
  i2l() {
    return this.s2m_1;
  }
  j2l() {
    return this.t2m_1;
  }
  k2l() {
    return this.u2m_1;
  }
  l2l() {
    return this.v2m_1;
  }
  i22() {
    return this.w2m_1;
  }
  get targetGrammarName() {
    return this.y1x();
  }
  get defaultGoalRuleName() {
    return this.d22();
  }
  get typeModelResolver() {
    return this.g2l();
  }
  get scopeModelResolver() {
    return this.h2l();
  }
  get syntaxAnalyserResolver() {
    return this.i2l();
  }
  get semanticAnalyserResolver() {
    return this.j2l();
  }
  get formatterResolver() {
    return this.k2l();
  }
  get styleResolver() {
    return this.l2l();
  }
  get completionProvider() {
    return this.i22();
  }
}
class LanguageProcessorConfigurationDslMarker {
  equals(other) {
    if (!(other instanceof LanguageProcessorConfigurationDslMarker))
      return false;
    var tmp0_other_with_cast = other instanceof LanguageProcessorConfigurationDslMarker ? other : THROW_CCE();
    return true;
  }
  hashCode() {
    return 0;
  }
  toString() {
    return '@net.akehurst.language.api.processor.LanguageProcessorConfigurationDslMarker()';
  }
}
class ParseOptionsDefault {
  constructor(goalRuleName, automatonKind, reportErrors, reportGrammarAmbiguities, cacheSkip) {
    goalRuleName = goalRuleName === VOID ? null : goalRuleName;
    automatonKind = automatonKind === VOID ? AutomatonKind_LOOKAHEAD_1_getInstance() : automatonKind;
    reportErrors = reportErrors === VOID ? true : reportErrors;
    reportGrammarAmbiguities = reportGrammarAmbiguities === VOID ? false : reportGrammarAmbiguities;
    cacheSkip = cacheSkip === VOID ? true : cacheSkip;
    this.p2n_1 = goalRuleName;
    this.q2n_1 = automatonKind;
    this.r2n_1 = reportErrors;
    this.s2n_1 = reportGrammarAmbiguities;
    this.t2n_1 = cacheSkip;
  }
  m2l(_set____db54di) {
    this.p2n_1 = _set____db54di;
  }
  n2l() {
    return this.p2n_1;
  }
  o2l() {
    return this.q2n_1;
  }
  p2l() {
    return this.r2n_1;
  }
  q2l() {
    return this.s2n_1;
  }
  r2l() {
    return this.t2n_1;
  }
  get goalRuleName() {
    return this.n2l();
  }
  set goalRuleName(value) {
    this.m2l(value);
  }
  get automatonKind() {
    return this.o2l();
  }
  get reportErrors() {
    return this.p2l();
  }
  get reportGrammarAmbiguities() {
    return this.q2l();
  }
  get cacheSkip() {
    return this.r2l();
  }
}
class SyntaxAnalysisOptionsDefault {
  constructor(active) {
    active = active === VOID ? true : active;
    this.u2n_1 = active;
  }
  s2l(_set____db54di) {
    this.u2n_1 = _set____db54di;
  }
  t2l() {
    return this.u2n_1;
  }
  get active() {
    return this.t2l();
  }
  set active(value) {
    this.s2l(value);
  }
}
class SemanticAnalysisOptionsDefault {
  constructor(active, locationMap, context, checkReferences, resolveReferences, other) {
    active = active === VOID ? true : active;
    locationMap = locationMap === VOID ? emptyMap() : locationMap;
    context = context === VOID ? null : context;
    checkReferences = checkReferences === VOID ? true : checkReferences;
    resolveReferences = resolveReferences === VOID ? true : resolveReferences;
    var tmp;
    if (other === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp$ret$0 = LinkedHashMap.n8();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = other;
    }
    other = tmp;
    this.v2n_1 = active;
    this.w2n_1 = locationMap;
    this.x2n_1 = context;
    this.y2n_1 = checkReferences;
    this.z2n_1 = resolveReferences;
    this.a2o_1 = other;
  }
  s2l(_set____db54di) {
    this.v2n_1 = _set____db54di;
  }
  t2l() {
    return this.v2n_1;
  }
  u2l(_set____db54di) {
    this.w2n_1 = _set____db54di;
  }
  v1b() {
    return this.w2n_1;
  }
  v2l(_set____db54di) {
    this.x2n_1 = _set____db54di;
  }
  uf() {
    return this.x2n_1;
  }
  w2l(_set____db54di) {
    this.y2n_1 = _set____db54di;
  }
  x2l() {
    return this.y2n_1;
  }
  y2l(_set____db54di) {
    this.z2n_1 = _set____db54di;
  }
  z2l() {
    return this.z2n_1;
  }
  a2m() {
    return this.a2o_1;
  }
  get active() {
    return this.t2l();
  }
  set active(value) {
    this.s2l(value);
  }
  get locationMap() {
    return this.v1b();
  }
  set locationMap(value) {
    this.u2l(value);
  }
  get context() {
    return this.uf();
  }
  set context(value) {
    this.v2l(value);
  }
  get checkReferences() {
    return this.x2l();
  }
  set checkReferences(value) {
    this.w2l(value);
  }
  get resolveReferences() {
    return this.z2l();
  }
  set resolveReferences(value) {
    this.y2l(value);
  }
  get other() {
    return this.a2m();
  }
}
class CompletionProviderOptionsDefault {
  constructor(context, options) {
    context = context === VOID ? null : context;
    var tmp;
    if (options === VOID) {
      var tmp$ret$0;
      var tmp$ret$0_0;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp$ret$0 = LinkedHashMap.n8();
      tmp$ret$0_0 = Unit_getInstance();
      tmp = tmp$ret$0;
    } else {
      tmp = options;
    }
    options = tmp;
    this.b2o_1 = context;
    this.c2o_1 = options;
  }
  v2l(_set____db54di) {
    this.b2o_1 = _set____db54di;
  }
  uf() {
    return this.b2o_1;
  }
  s1c() {
    return this.c2o_1;
  }
  get context() {
    return this.uf();
  }
  set context(value) {
    this.v2l(value);
  }
  get options() {
    return this.s1c();
  }
}
class ProcessOptionsDefault {
  constructor(parse, syntaxAnalysis, semanticAnalysis, completionProvider) {
    parse = parse === VOID ? new ParseOptionsDefault() : parse;
    syntaxAnalysis = syntaxAnalysis === VOID ? new SyntaxAnalysisOptionsDefault() : syntaxAnalysis;
    semanticAnalysis = semanticAnalysis === VOID ? new SemanticAnalysisOptionsDefault() : semanticAnalysis;
    completionProvider = completionProvider === VOID ? new CompletionProviderOptionsDefault() : completionProvider;
    this.k22_1 = parse;
    this.l22_1 = syntaxAnalysis;
    this.m22_1 = semanticAnalysis;
    this.n22_1 = completionProvider;
  }
  b2m() {
    return this.k22_1;
  }
  c2m() {
    return this.l22_1;
  }
  d2m() {
    return this.m22_1;
  }
  i22() {
    return this.n22_1;
  }
  get parse() {
    return this.b2m();
  }
  get syntaxAnalysis() {
    return this.c2m();
  }
  get semanticAnalysis() {
    return this.d2m();
  }
  get completionProvider() {
    return this.i22();
  }
}
class ProcessOptionsDslMarker {
  equals(other) {
    if (!(other instanceof ProcessOptionsDslMarker))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessOptionsDslMarker ? other : THROW_CCE();
    return true;
  }
  hashCode() {
    return 0;
  }
  toString() {
    return '@net.akehurst.language.api.processor.ProcessOptionsDslMarker()';
  }
}
class MatchResult {
  constructor(matchedText, eolPositions) {
    this.matchedText = matchedText;
    this.eolPositions = eolPositions;
  }
  d2o() {
    return this.matchedText;
  }
  e2o() {
    return this.eolPositions;
  }
  ti() {
    return this.matchedText;
  }
  ui() {
    return this.eolPositions;
  }
  f2o(matchedText, eolPositions) {
    return new MatchResult(matchedText, eolPositions);
  }
  copy(matchedText, eolPositions, $super) {
    matchedText = matchedText === VOID ? this.matchedText : matchedText;
    eolPositions = eolPositions === VOID ? this.eolPositions : eolPositions;
    return this.f2o(matchedText, eolPositions);
  }
  toString() {
    return 'MatchResult(matchedText=' + this.matchedText + ', eolPositions=' + this.eolPositions + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.matchedText);
    result = imul(result, 31) + hashCode(this.eolPositions) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchResult))
      return false;
    var tmp0_other_with_cast = other instanceof MatchResult ? other : THROW_CCE();
    if (!(this.matchedText === tmp0_other_with_cast.matchedText))
      return false;
    if (!equals(this.eolPositions, tmp0_other_with_cast.eolPositions))
      return false;
    return true;
  }
}
class SPPTNode {}
class SPPTBranch {}
class SPPTException extends RuntimeException {
  constructor(message, cause) {
    return new.target.z2o(message, cause);
  }
  static z2o(message, cause) {
    var $this = super.ug(message, cause);
    captureStack($this, $this.y2o_1);
    return $this;
  }
}
class SPPTLeaf {}
class SPPTNodeIdentity {}
class ChildInfo {
  constructor(propertyIndex, index, total) {
    this.propertyIndex = propertyIndex;
    this.index = index;
    this.total = total;
  }
  e2p() {
    return this.propertyIndex;
  }
  wm() {
    return this.index;
  }
  f2p() {
    return this.total;
  }
  ti() {
    return this.propertyIndex;
  }
  ui() {
    return this.index;
  }
  r1j() {
    return this.total;
  }
  g2p(propertyIndex, index, total) {
    return new ChildInfo(propertyIndex, index, total);
  }
  copy(propertyIndex, index, total, $super) {
    propertyIndex = propertyIndex === VOID ? this.propertyIndex : propertyIndex;
    index = index === VOID ? this.index : index;
    total = total === VOID ? this.total : total;
    return this.g2p(propertyIndex, index, total);
  }
  toString() {
    return 'ChildInfo(propertyIndex=' + this.propertyIndex + ', index=' + this.index + ', total=' + this.total + ')';
  }
  hashCode() {
    var result = this.propertyIndex;
    result = imul(result, 31) + this.index | 0;
    result = imul(result, 31) + this.total | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ChildInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ChildInfo ? other : THROW_CCE();
    if (!(this.propertyIndex === tmp0_other_with_cast.propertyIndex))
      return false;
    if (!(this.index === tmp0_other_with_cast.index))
      return false;
    if (!(this.total === tmp0_other_with_cast.total))
      return false;
    return true;
  }
}
class AltInfo {
  constructor(option, index, totalMatched) {
    this.option = option;
    this.index = index;
    this.totalMatched = totalMatched;
  }
  l2a() {
    return this.option;
  }
  wm() {
    return this.index;
  }
  h2p() {
    return this.totalMatched;
  }
  ti() {
    return this.option;
  }
  ui() {
    return this.index;
  }
  r1j() {
    return this.totalMatched;
  }
  g2p(option, index, totalMatched) {
    return new AltInfo(option, index, totalMatched);
  }
  copy(option, index, totalMatched, $super) {
    option = option === VOID ? this.option : option;
    index = index === VOID ? this.index : index;
    totalMatched = totalMatched === VOID ? this.totalMatched : totalMatched;
    return this.g2p(option, index, totalMatched);
  }
  toString() {
    return 'AltInfo(option=' + this.option + ', index=' + this.index + ', totalMatched=' + this.totalMatched + ')';
  }
  hashCode() {
    var result = this.option;
    result = imul(result, 31) + this.index | 0;
    result = imul(result, 31) + this.totalMatched | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AltInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AltInfo ? other : THROW_CCE();
    if (!(this.option === tmp0_other_with_cast.option))
      return false;
    if (!(this.index === tmp0_other_with_cast.index))
      return false;
    if (!(this.totalMatched === tmp0_other_with_cast.totalMatched))
      return false;
    return true;
  }
}
class LeafData {
  constructor(name, isPattern, location, matchedText, tagList) {
    this.name = name;
    this.isPattern = isPattern;
    this.location = location;
    this.matchedText = matchedText;
    this.tagList = tagList;
    var tmp = this;
    tmp.e1v_1 = lazy(LeafData$metaTags$delegate$lambda(this));
  }
  be() {
    return this.name;
  }
  r12() {
    return this.isPattern;
  }
  l2k() {
    return this.location;
  }
  d2o() {
    return this.matchedText;
  }
  c2p() {
    return this.tagList;
  }
  d2p() {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = metaTags$factory();
    tmp$ret$0 = this.e1v_1.p3();
    return tmp$ret$0;
  }
  ti() {
    return this.name;
  }
  ui() {
    return this.isPattern;
  }
  r1j() {
    return this.location;
  }
  s1j() {
    return this.matchedText;
  }
  t1j() {
    return this.tagList;
  }
  i2p(name, isPattern, location, matchedText, tagList) {
    return new LeafData(name, isPattern, location, matchedText, tagList);
  }
  copy(name, isPattern, location, matchedText, tagList, $super) {
    name = name === VOID ? this.name : name;
    isPattern = isPattern === VOID ? this.isPattern : isPattern;
    location = location === VOID ? this.location : location;
    matchedText = matchedText === VOID ? this.matchedText : matchedText;
    tagList = tagList === VOID ? this.tagList : tagList;
    return this.i2p(name, isPattern, location, matchedText, tagList);
  }
  toString() {
    return 'LeafData(name=' + this.name + ', isPattern=' + this.isPattern + ', location=' + this.location + ', matchedText=' + this.matchedText + ', tagList=' + this.tagList + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.name);
    result = imul(result, 31) + (this.isPattern | 0) | 0;
    result = imul(result, 31) + this.location.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.matchedText) | 0;
    result = imul(result, 31) + hashCode(this.tagList) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LeafData))
      return false;
    var tmp0_other_with_cast = other instanceof LeafData ? other : THROW_CCE();
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!(this.isPattern === tmp0_other_with_cast.isPattern))
      return false;
    if (!this.location.equals(tmp0_other_with_cast.location))
      return false;
    if (!(this.matchedText === tmp0_other_with_cast.matchedText))
      return false;
    if (!equals(this.tagList, tmp0_other_with_cast.tagList))
      return false;
    return true;
  }
  get metaTags() {
    return this.d2p();
  }
}
class AglStyleRule {
  constructor(selector) {
    this.selector = selector;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.styles = tmp$ret$0;
  }
  j2p() {
    return this.selector;
  }
  k2p(_set____db54di) {
    this.styles = _set____db54di;
  }
  l2p() {
    return this.styles;
  }
  getStyle(name) {
    return this.styles.u3(name);
  }
  toCss() {
    var tmp = joinToString(this.selector, ', ', VOID, VOID, VOID, VOID, AglStyleRule$toCss$lambda);
    var tmp_0 = this.styles.k3();
    return trimIndent('\n            ' + tmp + ' {\n                ' + joinToString(tmp_0, '\n', VOID, VOID, VOID, VOID, AglStyleRule$toCss$lambda_0) + '\n            }\n         ');
  }
  ti() {
    return this.selector;
  }
  m2p(selector) {
    return new AglStyleRule(selector);
  }
  copy(selector, $super) {
    selector = selector === VOID ? this.selector : selector;
    return this.m2p(selector);
  }
  toString() {
    return 'AglStyleRule(selector=' + this.selector + ')';
  }
  hashCode() {
    return hashCode(this.selector);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AglStyleRule))
      return false;
    var tmp0_other_with_cast = other instanceof AglStyleRule ? other : THROW_CCE();
    if (!equals(this.selector, tmp0_other_with_cast.selector))
      return false;
    return true;
  }
}
class AglStyleSelectorKind extends Enum {
  get name() {
    return this.be();
  }
  get ordinal() {
    return this.ce();
  }
  static get LITERAL() {
    return AglStyleSelectorKind_LITERAL_getInstance();
  }
  static get PATTERN() {
    return AglStyleSelectorKind_PATTERN_getInstance();
  }
  static get RULE_NAME() {
    return AglStyleSelectorKind_RULE_NAME_getInstance();
  }
  static get META() {
    return AglStyleSelectorKind_META_getInstance();
  }
}
class AglStyleSelector {
  constructor(value, kind) {
    this.value = value;
    this.kind = kind;
  }
  p3() {
    return this.value;
  }
  v2k() {
    return this.kind;
  }
  ti() {
    return this.value;
  }
  ui() {
    return this.kind;
  }
  p2p(value, kind) {
    return new AglStyleSelector(value, kind);
  }
  copy(value, kind, $super) {
    value = value === VOID ? this.value : value;
    kind = kind === VOID ? this.kind : kind;
    return this.p2p(value, kind);
  }
  toString() {
    return 'AglStyleSelector(value=' + this.value + ', kind=' + this.kind + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.value);
    result = imul(result, 31) + this.kind.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AglStyleSelector))
      return false;
    var tmp0_other_with_cast = other instanceof AglStyleSelector ? other : THROW_CCE();
    if (!(this.value === tmp0_other_with_cast.value))
      return false;
    if (!this.kind.equals(tmp0_other_with_cast.kind))
      return false;
    return true;
  }
}
class AglStyle {
  constructor(name, value) {
    this.name = name;
    this.value = value;
  }
  be() {
    return this.name;
  }
  p3() {
    return this.value;
  }
  toCss() {
    return this.name + ' : ' + this.value + ' ;';
  }
  ti() {
    return this.name;
  }
  ui() {
    return this.value;
  }
  n1h(name, value) {
    return new AglStyle(name, value);
  }
  copy(name, value, $super) {
    name = name === VOID ? this.name : name;
    value = value === VOID ? this.value : value;
    return this.n1h(name, value);
  }
  toString() {
    return 'AglStyle(name=' + this.name + ', value=' + this.value + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.name);
    result = imul(result, 31) + getStringHashCode(this.value) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AglStyle))
      return false;
    var tmp0_other_with_cast = other instanceof AglStyle ? other : THROW_CCE();
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!(this.value === tmp0_other_with_cast.value))
      return false;
    return true;
  }
}
class GraphStructuredStack {
  constructor(_growingHeadHeap, previous, count) {
    this.g29_1 = _growingHeadHeap;
    this.h29_1 = previous;
    this.i29_1 = count;
  }
  static s29(headHeap) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    var tmp = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$1 = HashMap.w4();
    var $this = new GraphStructuredStack(headHeap, tmp, tmp$ret$1);
    return $this;
  }
  k17() {
    return (this.h29_1.y() ? this.i29_1.y() : false) ? this.g29_1.y() : false;
  }
  i1u() {
    return this.g29_1.o();
  }
  d1u() {
    return this.g29_1.q2p();
  }
  t29() {
    return this.g29_1.r2p();
  }
  w29() {
    return toList(this.g29_1);
  }
  n1() {
    this.i29_1.n1();
    this.h29_1.n1();
    this.g29_1.n1();
  }
  k29(head) {
    this.g29_1.s2p(head, head);
    var set = this.h29_1.u3(head);
    var tmp;
    if (null == set) {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.h29_1;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.hashSetOf' call
      tmp$ret$0 = HashSet.n6();
      var tmp1_set = tmp$ret$0;
      tmp0_set.m3(head, tmp1_set);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.i29_1;
      tmp2_set.m3(head, 0);
      tmp = true;
    } else {
      tmp = false;
    }
    var createdNewHead = tmp;
    Debug_getInstance();
    if (false) {
      check(this);
    }
    return createdNewHead;
  }
  j29(currentHead, nextHead) {
    this.g29_1.q3(currentHead);
    var set = this.h29_1.u3(nextHead);
    if (null == set) {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.hashSetOf' call
      tmp$ret$0 = HashSet.n6();
      set = tmp$ret$0;
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.h29_1;
      var tmp1_set = set;
      tmp0_set.m3(nextHead, tmp1_set);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = this.i29_1;
      tmp2_set.m3(nextHead, 0);
      this.g29_1.s2p(nextHead, nextHead);
    } else {
    }
    var added = set.e1(currentHead);
    if (added) {
      var hc = this.i29_1.u3(currentHead);
      if (null == hc) {
        // Inline function 'kotlin.collections.set' call
        var tmp3_set = this.h29_1;
        var tmp$ret$1;
        // Inline function 'kotlin.collections.hashSetOf' call
        tmp$ret$1 = HashSet.n6();
        var tmp4_set = tmp$ret$1;
        tmp3_set.m3(currentHead, tmp4_set);
        // Inline function 'kotlin.collections.set' call
        var tmp5_set = this.i29_1;
        tmp5_set.m3(currentHead, 1);
      } else {
        // Inline function 'kotlin.collections.set' call
        var tmp6_set = this.i29_1;
        var tmp7_set = hc + 1 | 0;
        tmp6_set.m3(currentHead, tmp7_set);
      }
    } else {
    }
    Debug_getInstance();
    if (false) {
      check(this);
    }
  }
  p29(head) {
    var tmp0_safe_receiver = this.h29_1.u3(head);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toMutableSet(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  x29(head) {
    this.g29_1.q3(head);
    var count = this.i29_1.u3(head);
    var tmp;
    if (null == count) {
      tmp = emptySet();
    } else {
      var tmp_0;
      if (count === 0) {
        this.i29_1.q3(head);
        var prev = toMutableSet(ensureNotNull(this.h29_1.q3(head)));
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator = prev.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.pop.<anonymous>' call
          var c = ensureNotNull(this.i29_1.u3(element));
          // Inline function 'kotlin.collections.set' call
          var tmp0_set = this.i29_1;
          var tmp1_set = c - 1 | 0;
          tmp0_set.m3(element, tmp1_set);
        }
        Debug_getInstance();
        if (false) {
          check(this);
        }
        tmp_0 = prev;
      } else {
        var prev_0 = toMutableSet(ensureNotNull(this.h29_1.u3(head)));
        Debug_getInstance();
        if (false) {
          check(this);
        }
        tmp_0 = prev_0;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  f2a(head, ifDropped) {
    var d = this.g29_1.q3(head);
    return removeStack(this, head, ifDropped);
  }
  toString() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this.i29_1.l3();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.toString.<anonymous>' call
      tmp$ret$0 = element.p3() === 0;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var heads = tmp$ret$2;
    var tmp;
    if (heads.y()) {
      var tmp_0;
      if (this.h29_1.y() ? this.i29_1.y() : false) {
        tmp_0 = '<empty>';
      } else {
        tmp_0 = '<error>';
      }
      tmp = tmp_0;
    } else {
      tmp = joinToString(heads, '\n', VOID, VOID, VOID, VOID, GraphStructuredStack$toString$lambda(this));
    }
    return tmp;
  }
}
class LazyMap {
  constructor(accessor) {
    this.t2p_1 = accessor;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.u2p_1 = tmp$ret$0;
  }
  u3(key) {
    var tmp;
    if (this.u2p_1.r3(key)) {
      tmp = this.u2p_1.u3(key);
    } else {
      var v = this.t2p_1(key);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.u2p_1;
      tmp0_set.m3(key, v);
      tmp = v;
    }
    return tmp;
  }
  l3() {
    return this.u2p_1.l3();
  }
  j3() {
    return this.u2p_1.j3();
  }
  o() {
    return this.u2p_1.o();
  }
  k3() {
    return this.u2p_1.k3();
  }
  r3(key) {
    return this.u2p_1.r3(key);
  }
  s3(value) {
    return this.u2p_1.s3(value);
  }
  y() {
    return this.u2p_1.y();
  }
}
class LazyMutableMapNonNull {
  constructor(accessor) {
    this.b10_1 = accessor;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp$ret$0 = HashMap.w4();
    tmp.c10_1 = tmp$ret$0;
  }
  u3(key) {
    var tmp;
    if (this.c10_1.r3(key)) {
      var tmp0_elvis_lhs = this.c10_1.u3(key);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        throw Exception.kf('This map should never contain nulls');
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      var v = this.b10_1(key);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = this.c10_1;
      tmp0_set.m3(key, v);
      tmp = v;
    }
    return tmp;
  }
  l3() {
    return this.c10_1.l3();
  }
  j3() {
    return this.c10_1.j3();
  }
  o() {
    return this.c10_1.o();
  }
  k3() {
    return this.c10_1.k3();
  }
  r3(key) {
    return this.c10_1.r3(key);
  }
  s3(value) {
    return this.c10_1.s3(value);
  }
  y() {
    return this.c10_1.y();
  }
  n1() {
    this.c10_1.n1();
  }
  m3(key, value) {
    return this.c10_1.m3(key, value);
  }
  n3(from) {
    this.c10_1.n3(from);
  }
  q3(key) {
    return this.c10_1.q3(key);
  }
}
class ListSeparatedArrayList extends AbstractList {
  static u1f(elements) {
    var $this = super.n();
    $this.t1f_1 = elements;
    return $this;
  }
  o() {
    return this.t1f_1.o();
  }
  p(index) {
    return this.t1f_1.p(index);
  }
  a11() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filterIndexed' call
    var tmp0_filterIndexed = this.t1f_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIndexedTo' call
    var tmp0_filterIndexedTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = tmp0_filterIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.filterIndexedTo.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp0_anonymous = checkIndexOverflow(tmp1);
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.collections.ListSeparatedArrayList.<get-items>.<anonymous>' call
      tmp$ret$0 = (tmp0_anonymous % 2 | 0) === 0;
      if (tmp$ret$0) {
        tmp0_filterIndexedTo.e1(item);
      }
    }
    tmp$ret$1 = tmp0_filterIndexedTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp = tmp$ret$2;
    return isInterface(tmp, List) ? tmp : THROW_CCE();
  }
  i2h() {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filterIndexed' call
    var tmp0_filterIndexed = this.t1f_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterIndexedTo' call
    var tmp0_filterIndexedTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = tmp0_filterIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.filterIndexedTo.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp0_anonymous = checkIndexOverflow(tmp1);
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.collections.ListSeparatedArrayList.<get-separators>.<anonymous>' call
      tmp$ret$0 = (tmp0_anonymous % 2 | 0) === 1;
      if (tmp$ret$0) {
        tmp0_filterIndexedTo.e1(item);
      }
    }
    tmp$ret$1 = tmp0_filterIndexedTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp = tmp$ret$2;
    return isInterface(tmp, List) ? tmp : THROW_CCE();
  }
}
class MutableQueue {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.w10_1 = tmp$ret$0;
  }
  y10() {
    return !(this.w10_1.o() === 0);
  }
  x10(item) {
    this.w10_1.e1(item);
  }
  z10() {
    return this.w10_1.a2(0);
  }
  toString() {
    return joinToString(this.w10_1, ',', VOID, VOID, VOID, VOID, MutableQueue$toString$lambda);
  }
}
class MutableStack {
  constructor() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.n1a_1 = tmp$ret$0;
  }
  o() {
    return this.n1a_1.o();
  }
  k17() {
    return this.n1a_1.o() === 0;
  }
  y10() {
    return !(this.n1a_1.o() === 0);
  }
  c29() {
    return this.n1a_1;
  }
  v1a(item) {
    this.n1a_1.e1(item);
  }
  o1a() {
    return last(this.n1a_1);
  }
  p2h() {
    return lastOrNull(this.n1a_1);
  }
  u2g(n) {
    return this.n1a_1.r2(this.n1a_1.o() - n | 0, this.n1a_1.o());
  }
  w1a() {
    return removeLast(this.n1a_1);
  }
  v2e(n) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    var removed = tmp$ret$0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        removed.e1(removeLast(this.n1a_1));
      }
       while (inductionVariable < n);
    return removed;
  }
}
class OrderedSet {}
class MutableOrderedSetImpl {
  static w2p(collection) {
    var $this = createThis(MutableOrderedSetImpl);
    init_net_akehurst_language_agl_collections_MutableOrderedSetImpl($this);
    $this.v2p_1 = LinkedHashSet.s8(collection);
    return $this;
  }
  p(index) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var tmp0_forEachIndexed = this.v2p_1;
    var index_0 = 0;
    var tmp0_iterator = tmp0_forEachIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.collections.MutableOrderedSetImpl.get.<anonymous>' call
      var tmp1 = index_0;
      index_0 = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      if (index === tmp1_anonymous)
        return item;
    }
    throw IndexOutOfBoundsException.t('' + index);
  }
  o() {
    return this.v2p_1.o();
  }
  u() {
    return this.v2p_1.u();
  }
  y() {
    return this.v2p_1.y();
  }
  w(element) {
    return this.v2p_1.w(element);
  }
  x(elements) {
    return this.v2p_1.x(elements);
  }
  e1(element) {
    return this.v2p_1.e1(element);
  }
  k1(elements) {
    return this.v2p_1.k1(elements);
  }
  f1(element) {
    return this.v2p_1.f1(element);
  }
  l1(elements) {
    return this.v2p_1.l1(elements);
  }
  m1(elements) {
    return this.v2p_1.m1(elements);
  }
  n1() {
    this.v2p_1.n1();
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, OrderedSet) : false)) {
      tmp = false;
    } else {
      if (!(other.o() === this.o())) {
        tmp = false;
      } else {
        var inductionVariable = 0;
        var last = this.o();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals(this.p(i), other.p(i)))
              return false;
          }
           while (inductionVariable < last);
        tmp = true;
      }
    }
    return tmp;
  }
  hashCode() {
    return this.v2p_1.hashCode();
  }
  toString() {
    return this.v2p_1.toString();
  }
}
class OrderedSetImpl {
  static y2p(collection) {
    var $this = createThis(OrderedSetImpl);
    init_net_akehurst_language_agl_collections_OrderedSetImpl($this);
    $this.x2p_1 = LinkedHashSet.s8(collection);
    return $this;
  }
  p(index) {
    // Inline function 'kotlin.collections.forEachIndexed' call
    var tmp0_forEachIndexed = this.x2p_1;
    var index_0 = 0;
    var tmp0_iterator = tmp0_forEachIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.collections.OrderedSetImpl.get.<anonymous>' call
      var tmp1 = index_0;
      index_0 = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      if (index === tmp1_anonymous)
        return item;
    }
    throw IndexOutOfBoundsException.t('' + index);
  }
  o() {
    return this.x2p_1.o();
  }
  u() {
    return this.x2p_1.u();
  }
  y() {
    return this.x2p_1.y();
  }
  w(element) {
    return this.x2p_1.w(element);
  }
  x(elements) {
    return this.x2p_1.x(elements);
  }
  equals(other) {
    var tmp;
    if (!(!(other == null) ? isInterface(other, OrderedSet) : false)) {
      tmp = false;
    } else {
      if (!(other.o() === this.o())) {
        tmp = false;
      } else {
        var inductionVariable = 0;
        var last = this.o();
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals(this.p(i), other.p(i)))
              return false;
          }
           while (!(i === last));
        tmp = true;
      }
    }
    return tmp;
  }
  hashCode() {
    return this.x2p_1.hashCode();
  }
  toString() {
    return this.x2p_1.toString();
  }
}
class Entry {}
class Entry_0 {
  constructor(key, value) {
    this.b2q_1 = key;
    this.c2q_1 = value;
  }
  o3() {
    return this.b2q_1;
  }
  p3() {
    return this.c2q_1;
  }
  hashCode() {
    var tmp$ret$0;
    // Inline function 'kotlin.hashCode' call
    var tmp0_hashCode = this.b2q_1;
    var tmp0_safe_receiver = tmp0_hashCode;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(tmp$ret$0, 31);
    var tmp$ret$1;
    // Inline function 'kotlin.hashCode' call
    var tmp1_hashCode = this.c2q_1;
    var tmp0_safe_receiver_0 = tmp1_hashCode;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
    return tmp + tmp$ret$1 | 0;
  }
  equals(other) {
    var tmp0_subject = other;
    var tmp;
    if (!(!(tmp0_subject == null) ? isInterface(tmp0_subject, Entry) : false)) {
      tmp = false;
    } else {
      tmp = equals(this.b2q_1, other.o3()) ? equals(this.c2q_1, other.p3()) : false;
    }
    return tmp;
  }
  toString() {
    return '' + this.b2q_1 + ' -> ' + this.c2q_1;
  }
}
class sam$kotlin_Comparator$0_13 {
  constructor(function_0) {
    this.e2q_1 = function_0;
  }
  rc(a, b) {
    return this.e2q_1(a, b);
  }
  compare(a, b) {
    return this.rc(a, b);
  }
}
class BinaryHeapComparable$iterator$1 {
  constructor(this$0) {
    var tmp = this;
    var tmp_0 = BinaryHeapComparable$iterator$o$_sorted$lambda(this$0);
    tmp.f2q_1 = sortedWith(this$0.a2q_1, new sam$kotlin_Comparator$0_13(tmp_0));
    this.g2q_1 = 0;
  }
  h1() {
    return this.g2q_1 < this.f2q_1.o();
  }
  j1() {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = this.f2q_1.p(this.g2q_1).p3();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.collections.<no name provided>.next.<anonymous>' call
    var tmp0_this = this;
    var tmp1 = tmp0_this.g2q_1;
    tmp0_this.g2q_1 = tmp1 + 1 | 0;
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
}
class BinaryHeapComparable {
  constructor(comparator) {
    this.z2p_1 = comparator;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.a2q_1 = tmp$ret$0;
  }
  o() {
    return this.a2q_1.o();
  }
  r2p() {
    var tmp0_subject = this.a2q_1.o();
    return tmp0_subject === 0 ? null : this.a2q_1.p(0).p3();
  }
  s2p(key, value) {
    return this.h2q(key, value);
  }
  y() {
    return 0 === this.o();
  }
  q2p() {
    return !(0 === this.o());
  }
  h2q(key, value) {
    var e = new Entry_0(key, value);
    this.a2q_1.e1(e);
    upHeap(this, this.a2q_1.o() - 1 | 0, key);
  }
  i2q() {
    var tmp;
    if (0 === this.o()) {
      tmp = null;
    } else {
      this.d2q(0, this.a2q_1.o() - 1 | 0);
      var oldRoot = removeLastOrNull(this.a2q_1);
      downHeap(this, 0);
      var tmp0_safe_receiver = oldRoot;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p3();
    }
    return tmp;
  }
  q3(key) {
    var tmp;
    if (0 === this.o()) {
      tmp = null;
    } else if (equals(key, this.a2q_1.p(0).o3())) {
      tmp = this.i2q();
    } else if (equals(key, last(this.a2q_1).o3())) {
      tmp = this.a2q_1.a2(this.a2q_1.o() - 1 | 0).p3();
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.indexOfFirst' call
        var tmp0_indexOfFirst = this.a2q_1;
        var index = 0;
        var tmp0_iterator = tmp0_indexOfFirst.u();
        while (tmp0_iterator.h1()) {
          var item = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.collections.BinaryHeapComparable.remove.<anonymous>' call
          tmp$ret$0 = equals(item.o3(), key);
          if (tmp$ret$0) {
            tmp$ret$1 = index;
            break $l$block;
          }
          var tmp1 = index;
          index = tmp1 + 1 | 0;
        }
        tmp$ret$1 = -1;
      }
      var index_0 = tmp$ret$1;
      var tmp_0;
      if (index_0 >= 0) {
        this.d2q(index_0, this.a2q_1.o() - 1 | 0);
        var old = this.a2q_1.a2(this.a2q_1.o() - 1 | 0);
        downHeap(this, index_0);
        tmp_0 = old.p3();
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  n1() {
    this.a2q_1.n1();
  }
  d2q(i1, i2) {
    var t = this.a2q_1.p(i1);
    this.a2q_1.z(i1, this.a2q_1.p(i2));
    this.a2q_1.z(i2, t);
  }
  u() {
    return new BinaryHeapComparable$iterator$1(this);
  }
  toString() {
    var tmp0_subject = this.o();
    var tmp;
    if (tmp0_subject === 0) {
      tmp = '{}';
    } else {
      tmp = joinToString(this.a2q_1, '\n', VOID, VOID, VOID, VOID, BinaryHeapComparable$toString$lambda);
    }
    return tmp;
  }
}
class IndentDelta extends Enum {}
class Debug {
  constructor() {
    Debug_instance = this;
    this.nz_1 = false;
    this.oz_1 = false;
    this.pz_1 = false;
    this.qz_1 = false;
    this.rz_1 = false;
    this.sz_1 = '  ';
    this.tz_1 = '';
  }
  uz(indentDelta, lazyMessage) {
    if (((false ? true : false) ? true : false) ? true : false) {
      var tmp0_subject = indentDelta;
      var tmp0 = tmp0_subject.bc_1;
      switch (tmp0) {
        case 3:
          var tmp = this;
          var tmp$ret$1;
          // Inline function 'kotlin.text.substring' call
          var tmp0_substring = this.tz_1;
          var tmp1_substring = '  '.length;
          var tmp$ret$0;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$0 = tmp0_substring;
          tmp$ret$1 = tmp$ret$0.substring(tmp1_substring);

          tmp.tz_1 = tmp$ret$1;
          break;
        case 1:
          var tmp1_this = this;
          tmp1_this.tz_1 = tmp1_this.tz_1 + '  ';
          break;
        default:
          ;
          break;
      }
      println(this.tz_1 + lazyMessage());
      var tmp2_subject = indentDelta;
      var tmp0_0 = tmp2_subject.bc_1;
      switch (tmp0_0) {
        case 4:
          var tmp_0 = this;
          var tmp$ret$3;
          // Inline function 'kotlin.text.substring' call
          var tmp2_substring = this.tz_1;
          var tmp3_substring = '  '.length;
          var tmp$ret$2;
          // Inline function 'kotlin.js.asDynamic' call
          tmp$ret$2 = tmp2_substring;
          tmp$ret$3 = tmp$ret$2.substring(tmp3_substring);

          tmp_0.tz_1 = tmp$ret$3;
          break;
        case 2:
          var tmp3_this = this;
          tmp3_this.tz_1 = tmp3_this.tz_1 + '  ';
          break;
        default:
          ;
          break;
      }
    }
  }
}
class UNINITIALIZED_VALUE {
  constructor() {
    UNINITIALIZED_VALUE_instance = this;
  }
}
class Companion_40 {
  constructor() {
    Companion_instance_40 = this;
  }
}
class CachedValue {
  constructor(initializer) {
    Companion_getInstance_42();
    this.q1w_1 = initializer;
    this.r1w_1 = UNINITIALIZED_VALUE_getInstance();
    var tmp = this;
    tmp.s1w_1 = CachedValue$resetAction$lambda;
  }
  p3() {
    if (this.r1w_1 === UNINITIALIZED_VALUE_getInstance()) {
      this.r1w_1 = this.q1w_1();
    }
    var tmp = this.r1w_1;
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  }
  e1q() {
    if (equals(this.r1w_1, UNINITIALIZED_VALUE_getInstance())) {
    } else {
      var tmp = this.r1w_1;
      var old = (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
      this.r1w_1 = UNINITIALIZED_VALUE_getInstance();
      this.s1w_1(old);
    }
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function automaton(rrs, automatonKind, userGoalRule, isSkip, init) {
  var b = new AutomatonBuilderDefault(rrs, automatonKind, userGoalRule, isSkip);
  init(b);
  return b.eo();
}
function _get__src__d2utae($this) {
  var tmp = $this.vv_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('_src');
  }
}
function _get__tgt__d2v8ix($this) {
  var tmp = $this.wv_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('_tgt');
  }
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _get__allRulePositionsForStates__bd3x7w($this) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0_flatMap = $this.bw_1.lw();
  // Inline function 'kotlin.collections.flatMapTo' call
  var tmp0_flatMapTo = ArrayList.i4();
  var tmp0_iterator = tmp0_flatMap.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.<get-_allRulePositionsForStates>.<anonymous>' call
    var list = element.tw();
    addAll(tmp0_flatMapTo, list);
  }
  var tmp = tmp0_flatMapTo;
  // Inline function 'kotlin.collections.map' call
  var tmp1_map = $this.bw_1.uw();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
  var tmp0_iterator_0 = tmp1_map.u();
  while (tmp0_iterator_0.h1()) {
    var item = tmp0_iterator_0.j1();
    var tmp$ret$3;
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.<get-_allRulePositionsForStates>.<anonymous>' call
    tmp$ret$3 = item.vw();
    tmp0_mapTo.e1(tmp$ret$3);
  }
  return plus(tmp, tmp0_mapTo);
}
function stateInfo4($this) {
  var startRulePosition = $this.bw_1.ww();
  var context = startRulePosition;
  var parentNextFollow = Companion_getInstance_8().ax_1;
  $this.dw_1.fx(context, startRulePosition, parentNextFollow);
  var mergedStateInfos = calcStateInfos($this);
  var tmp0_iterator = mergedStateInfos.u();
  while (tmp0_iterator.h1()) {
    var stateInfo = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.mutableSetOf' call
    var transInfo = LinkedHashSet.r8();
    var tmp1_iterator = stateInfo.gx_1.u();
    while (tmp1_iterator.h1()) {
      var srcRp = tmp1_iterator.j1();
      // Inline function 'kotlin.collections.set' call
      $this.ox_1.m3(srcRp, stateInfo);
      var ti = srcRp.vx() ? calcTransInfoForComplete($this, srcRp) : calcTransInfoForIncomplete($this, srcRp);
      transInfo.k1(ti);
    }
    var merged = mergeTransInfo($this, transInfo, emptySet());
    stateInfo.hx_1 = merged;
  }
  return mergedStateInfos;
}
function mergeStates($this, rulePositions) {
  return noMergeStates($this, rulePositions);
}
function noMergeStates($this, rulePositions) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(rulePositions, 10));
  var tmp0_iterator = rulePositions.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.noMergeStates.<anonymous>' call
    tmp$ret$0 = new StateInfo(setOf(item));
    tmp0_mapTo.e1(tmp$ret$0);
  }
  return toSet(tmp0_mapTo);
}
function calcStateInfos($this) {
  var stateRps = _get__allRulePositionsForStates__bd3x7w($this);
  var merged = mergeStates($this, stateRps);
  return merged;
}
function calcTransInfoForComplete($this, srcRp) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!srcRp.vx()) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  // Inline function 'kotlin.collections.mutableSetOf' call
  var transInfo = LinkedHashSet.r8();
  var contexts = $this.dw_1.wx(srcRp);
  var tmp0_iterator = contexts.u();
  while (tmp0_iterator.h1()) {
    var ctx = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.mutableSetOf' call
    var hgtis = LinkedHashSet.r8();
    var contextContexts = $this.dw_1.wx(ctx);
    var tmp1_iterator = contextContexts.u();
    while (tmp1_iterator.h1()) {
      var ctxCtx = tmp1_iterator.j1();
      var pns = $this.dw_1.xx(ctxCtx, ctx, srcRp.qx_1);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(pns, 10));
      var tmp0_iterator_0 = pns.u();
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$3;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcTransInfoForComplete.<anonymous>' call
        var action = item.zx_1.cy() ? ParseAction_GOAL_getInstance() : item.yx_1 ? ParseAction_HEIGHT_getInstance() : ParseAction_GRAFT_getInstance();
        var tgt = item.zx_1;
        var follow = item.ay_1;
        var grd = follow;
        var tmp;
        switch (action.bc_1) {
          case 0:
            tmp = item.by_1;
            break;
          case 4:
          case 2:
          case 1:
          case 3:
            tmp = Companion_getInstance_8().xw_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var up = tmp;
        tmp$ret$3 = new TransInfo(setOf(setOf(ctxCtx)), setOf(setOf(ctx)), action, setOf(tgt), setOf(new LookaheadInfoPart(grd, up)));
        tmp0_mapTo.e1(tmp$ret$3);
      }
      var hgInfo = toSet(tmp0_mapTo);
      hgtis.k1(hgInfo);
    }
    transInfo.k1(hgtis);
  }
  var mergedTransInfo = mergeTransInfo($this, transInfo, emptySet());
  return mergedTransInfo;
}
function calcTransInfoForIncomplete($this, srcRp) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!srcRp.vx()) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  // Inline function 'kotlin.collections.mutableSetOf' call
  var transInfo = LinkedHashSet.r8();
  var contexts = $this.dw_1.wx(srcRp);
  var tmp0_iterator = contexts.u();
  while (tmp0_iterator.h1()) {
    var ctx = tmp0_iterator.j1();
    var tmp;
    if (srcRp.cy()) {
      tmp = Companion_getInstance_8().ax_1;
    } else {
      var ctxCtxs = $this.dw_1.wx(ctx);
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_0 = ctxCtxs.u();
      while (tmp0_iterator_0.h1()) {
        var element = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcTransInfoForIncomplete.<anonymous>' call
        var list = $this.dw_1.xx(element, ctx, srcRp.qx_1);
        addAll(tmp0_flatMapTo, list);
      }
      var x = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.fold' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(x, 10));
      var tmp0_iterator_1 = x.u();
      while (tmp0_iterator_1.h1()) {
        var item = tmp0_iterator_1.j1();
        var tmp$ret$5;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcTransInfoForIncomplete.<anonymous>' call
        tmp$ret$5 = item.ay_1;
        tmp0_mapTo.e1(tmp$ret$5);
      }
      var accumulator = Companion_getInstance_8().xw_1;
      var tmp0_iterator_2 = tmp0_mapTo.u();
      while (tmp0_iterator_2.h1()) {
        var element_0 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcTransInfoForIncomplete.<anonymous>' call
        accumulator = accumulator.iy(element_0);
      }
      tmp = accumulator;
    }
    var parentFollow = tmp;
    var ftis = $this.dw_1.jy(ctx, srcRp, parentFollow);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(ftis, 10));
    var tmp0_iterator_3 = ftis.u();
    while (tmp0_iterator_3.h1()) {
      var item_0 = tmp0_iterator_3.j1();
      var tmp$ret$10;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcTransInfoForIncomplete.<anonymous>' call
      var action = item_0.ky_1.ny() ? ParseAction_EMBED_getInstance() : ParseAction_WIDTH_getInstance();
      var trp = item_0.ky_1.vw();
      var lhs = item_0.ly_1;
      tmp$ret$10 = new TransInfo(setOf(emptySet()), setOf(setOf(ctx)), action, setOf(trp), setOf(new LookaheadInfoPart(lhs, Companion_getInstance_8().xw_1)));
      tmp0_mapTo_0.e1(tmp$ret$10);
    }
    var wis = tmp0_mapTo_0;
    transInfo.k1(toSet(wis));
  }
  var mergedTransInfo = mergeTransInfo($this, transInfo, emptySet());
  return mergedTransInfo;
}
function mergeTransInfo($this, ti1, ti2) {
  var total = null == ti1 ? ti2 : plus_0(ti1, ti2);
  // Inline function 'kotlin.collections.mutableSetOf' call
  var embed = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var width = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var heightComplete = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var graftComplete = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var heightIncomplete = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var graftIncomplete = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.mutableSetOf' call
  var goals = LinkedHashSet.r8();
  var tmp0_iterator = total.u();
  while (tmp0_iterator.h1()) {
    var ti = tmp0_iterator.j1();
    switch (ti.qy_1.bc_1) {
      case 3:
        goals.e1(ti);
        break;
      case 4:
        embed.e1(ti);
        break;
      case 2:
        width.e1(ti);
        break;
      case 1:
        if (first(ti.ry_1).vx()) {
          graftComplete.e1(ti);
        } else {
          graftIncomplete.e1(ti);
        }

        break;
      case 0:
        if (first(ti.ry_1).vx()) {
          heightComplete.e1(ti);
        } else {
          heightIncomplete.e1(ti);
        }

        break;
    }
  }
  var mw = mergeWidth($this, width);
  var mhc = mergeHeightComplete($this, heightComplete);
  var mhi = mergeHeightIncomplete($this, heightIncomplete);
  var mgc = mergeGraftComplete($this, graftComplete);
  var mgi = mergeGraftIncomplete($this, graftIncomplete);
  var res = plus_0(plus_0(plus_0(plus_0(plus_0(plus_0(mw, mhc), mhi), mgc), mgi), goals), embed);
  return res;
}
function mergeWidth($this, transInfo) {
  var tmp;
  if (transInfo.y()) {
    tmp = transInfo;
  } else {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = transInfo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>' call
      var key = element.ry_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.i4();
        tmp0_groupByTo.m3(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.e1(element);
    }
    var grouped = tmp0_groupByTo;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(grouped.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = grouped.l3().u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$23;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>' call
        var list_0 = element_0.oy_1;
        addAll(tmp0_flatMapTo, list_0);
      }
      var prevPrev = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp1_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_2 = tmp1_flatMap.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>' call
        var list_1 = element_1.py_1;
        addAll(tmp0_flatMapTo_0, list_1);
      }
      var prev = toSet(tmp0_flatMapTo_0);
      var action = ParseAction_WIDTH_getInstance();
      // Inline function 'kotlin.collections.flatMap' call
      var tmp2_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_3 = tmp2_flatMap.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>' call
        var list_2 = element_2.ry_1;
        addAll(tmp0_flatMapTo_1, list_2);
      }
      var to = toSet(tmp0_flatMapTo_1);
      // Inline function 'kotlin.collections.fold' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp3_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_2 = ArrayList.i4();
      var tmp0_iterator_4 = tmp3_flatMap.u();
      while (tmp0_iterator_4.h1()) {
        var element_3 = tmp0_iterator_4.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        var tmp0_map = element_3.sy_1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
        var tmp0_iterator_5 = tmp0_map.u();
        while (tmp0_iterator_5.h1()) {
          var item_0 = tmp0_iterator_5.j1();
          var tmp$ret$15;
          // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>.<anonymous>' call
          tmp$ret$15 = item_0.ty_1;
          tmp0_mapTo_0.e1(tmp$ret$15);
        }
        var list_3 = tmp0_mapTo_0;
        addAll(tmp0_flatMapTo_2, list_3);
      }
      var accumulator = Companion_getInstance_8().xw_1;
      var tmp0_iterator_6 = tmp0_flatMapTo_2.u();
      while (tmp0_iterator_6.h1()) {
        var element_4 = tmp0_iterator_6.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeWidth.<anonymous>.<anonymous>' call
        accumulator = accumulator.iy(element_4);
      }
      var grd = accumulator;
      var lhs = setOf(new LookaheadInfoPart(grd, Companion_getInstance_8().xw_1));
      tmp$ret$23 = new TransInfo(prevPrev, prev, action, to, lhs);
      tmp0_mapTo.e1(tmp$ret$23);
    }
    var merged = toSet(tmp0_mapTo);
    tmp = merged;
  }
  return tmp;
}
function mergeHeightComplete($this, transInfo) {
  var tmp;
  if (transInfo.y()) {
    tmp = transInfo;
  } else {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = transInfo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightComplete.<anonymous>' call
      var key = element.ry_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.i4();
        tmp0_groupByTo.m3(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.e1(element);
    }
    var grouped = tmp0_groupByTo;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(grouped.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = grouped.l3().u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$15;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightComplete.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightComplete.<anonymous>.<anonymous>' call
        var list_0 = element_0.oy_1;
        addAll(tmp0_flatMapTo, list_0);
      }
      var prevPrev = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp1_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_2 = tmp1_flatMap.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightComplete.<anonymous>.<anonymous>' call
        var list_1 = element_1.py_1;
        addAll(tmp0_flatMapTo_0, list_1);
      }
      var prev = toSet(tmp0_flatMapTo_0);
      var action = ParseAction_HEIGHT_getInstance();
      var to = item.o3();
      var tmp_1 = Companion_getInstance_9();
      // Inline function 'kotlin.collections.flatMap' call
      var tmp2_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_3 = tmp2_flatMap.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightComplete.<anonymous>.<anonymous>' call
        var list_2 = element_2.sy_1;
        addAll(tmp0_flatMapTo_1, list_2);
      }
      var lhs = tmp_1.wy(toSet(tmp0_flatMapTo_1));
      tmp$ret$15 = new TransInfo(prevPrev, prev, action, to, lhs);
      tmp0_mapTo.e1(tmp$ret$15);
    }
    var merged = toSet(tmp0_mapTo);
    tmp = merged;
  }
  return tmp;
}
function mergeHeightIncomplete($this, transInfo) {
  var tmp;
  if (transInfo.y()) {
    tmp = transInfo;
  } else {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = transInfo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightIncomplete.<anonymous>' call
      var key = element.ry_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.i4();
        tmp0_groupByTo.m3(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.e1(element);
    }
    var grouped = tmp0_groupByTo;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(grouped.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = grouped.l3().u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$15;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightIncomplete.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightIncomplete.<anonymous>.<anonymous>' call
        var list_0 = element_0.oy_1;
        addAll(tmp0_flatMapTo, list_0);
      }
      var prevPrev = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp1_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_2 = tmp1_flatMap.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightIncomplete.<anonymous>.<anonymous>' call
        var list_1 = element_1.py_1;
        addAll(tmp0_flatMapTo_0, list_1);
      }
      var prev = toSet(tmp0_flatMapTo_0);
      var action = ParseAction_HEIGHT_getInstance();
      var to = item.o3();
      var tmp_1 = Companion_getInstance_9();
      // Inline function 'kotlin.collections.flatMap' call
      var tmp2_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_3 = tmp2_flatMap.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeHeightIncomplete.<anonymous>.<anonymous>' call
        var list_2 = element_2.sy_1;
        addAll(tmp0_flatMapTo_1, list_2);
      }
      var lhs = tmp_1.wy(toSet(tmp0_flatMapTo_1));
      tmp$ret$15 = new TransInfo(prevPrev, prev, action, to, lhs);
      tmp0_mapTo.e1(tmp$ret$15);
    }
    var merged = toSet(tmp0_mapTo);
    tmp = merged;
  }
  return tmp;
}
function mergeGraftComplete($this, transInfo) {
  var tmp;
  if (transInfo.y()) {
    tmp = transInfo;
  } else {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = transInfo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>' call
      var key = element.ry_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.i4();
        tmp0_groupByTo.m3(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.e1(element);
    }
    var grouped = tmp0_groupByTo;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(grouped.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = grouped.l3().u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$20;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>.<anonymous>' call
        var list_0 = element_0.oy_1;
        addAll(tmp0_flatMapTo, list_0);
      }
      var prevPrev = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp1_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_2 = tmp1_flatMap.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>.<anonymous>' call
        var list_1 = element_1.py_1;
        addAll(tmp0_flatMapTo_0, list_1);
      }
      var prev = toSet(tmp0_flatMapTo_0);
      var action = ParseAction_GRAFT_getInstance();
      var to = item.o3();
      // Inline function 'kotlin.collections.fold' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp2_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_3 = tmp2_flatMap.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        var tmp0_map = element_2.sy_1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
        var tmp0_iterator_4 = tmp0_map.u();
        while (tmp0_iterator_4.h1()) {
          var item_0 = tmp0_iterator_4.j1();
          var tmp$ret$12;
          // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>.<anonymous>.<anonymous>' call
          tmp$ret$12 = item_0.ty_1;
          tmp0_mapTo_0.e1(tmp$ret$12);
        }
        var list_2 = tmp0_mapTo_0;
        addAll(tmp0_flatMapTo_1, list_2);
      }
      var accumulator = Companion_getInstance_8().xw_1;
      var tmp0_iterator_5 = tmp0_flatMapTo_1.u();
      while (tmp0_iterator_5.h1()) {
        var element_3 = tmp0_iterator_5.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftComplete.<anonymous>.<anonymous>' call
        accumulator = accumulator.iy(element_3);
      }
      var grd = accumulator;
      var lhs = setOf(new LookaheadInfoPart(grd, Companion_getInstance_8().xw_1));
      tmp$ret$20 = new TransInfo(prevPrev, prev, action, to, lhs);
      tmp0_mapTo.e1(tmp$ret$20);
    }
    var merged = toSet(tmp0_mapTo);
    tmp = merged;
  }
  return tmp;
}
function mergeGraftIncomplete($this, transInfo) {
  var tmp;
  if (transInfo.y()) {
    tmp = transInfo;
  } else {
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var tmp0_groupByTo = LinkedHashMap.n8();
    var tmp0_iterator = transInfo.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>' call
      var key = element.ry_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = tmp0_groupByTo.u3(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.i4();
        tmp0_groupByTo.m3(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      list.e1(element);
    }
    var grouped = tmp0_groupByTo;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(grouped.o());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = grouped.l3().u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$20;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>.<anonymous>' call
        var list_0 = element_0.oy_1;
        addAll(tmp0_flatMapTo, list_0);
      }
      var prevPrev = toSet(tmp0_flatMapTo);
      // Inline function 'kotlin.collections.flatMap' call
      var tmp1_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_2 = tmp1_flatMap.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>.<anonymous>' call
        var list_1 = element_1.py_1;
        addAll(tmp0_flatMapTo_0, list_1);
      }
      var prev = toSet(tmp0_flatMapTo_0);
      var action = ParseAction_GRAFT_getInstance();
      var to = item.o3();
      // Inline function 'kotlin.collections.fold' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp2_flatMap = item.p3();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_3 = tmp2_flatMap.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        var tmp0_map = element_2.sy_1;
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
        var tmp0_iterator_4 = tmp0_map.u();
        while (tmp0_iterator_4.h1()) {
          var item_0 = tmp0_iterator_4.j1();
          var tmp$ret$12;
          // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>.<anonymous>.<anonymous>' call
          tmp$ret$12 = item_0.ty_1;
          tmp0_mapTo_0.e1(tmp$ret$12);
        }
        var list_2 = tmp0_mapTo_0;
        addAll(tmp0_flatMapTo_1, list_2);
      }
      var accumulator = Companion_getInstance_8().xw_1;
      var tmp0_iterator_5 = tmp0_flatMapTo_1.u();
      while (tmp0_iterator_5.h1()) {
        var element_3 = tmp0_iterator_5.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.mergeGraftIncomplete.<anonymous>.<anonymous>' call
        accumulator = accumulator.iy(element_3);
      }
      var grd = accumulator;
      var lhs = setOf(new LookaheadInfoPart(grd, Companion_getInstance_8().xw_1));
      tmp$ret$20 = new TransInfo(prevPrev, prev, action, to, lhs);
      tmp0_mapTo.e1(tmp$ret$20);
    }
    var merged = toSet(tmp0_mapTo);
    tmp = merged;
  }
  return tmp;
}
function calcAndCacheHeightOrGraftInto($this, prevPrev, prev, from) {
  var hgi = calcHeightOrGraftInto($this, prevPrev, prev, from);
  cacheHeightOrGraftInto($this, prevPrev, prev, from, hgi);
  return hgi;
}
function cacheHeightOrGraftInto($this, prevPrev, prev, from, hgis) {
  var key = new Triple(prevPrev.yy_1, prev.yy_1, from.lz());
  var tmp0_elvis_lhs = $this.px_1.u3(key);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.cacheHeightOrGraftInto.<anonymous>' call
    // Inline function 'kotlin.collections.mutableMapOf' call
    var x = LinkedHashMap.n8();
    // Inline function 'kotlin.collections.set' call
    $this.px_1.m3(key, x);
    tmp = x;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var map = tmp;
  var tmp1_iterator = hgis.u();
  while (tmp1_iterator.h1()) {
    var hg = tmp1_iterator.j1();
    var existing = map.u3(hg.ry_1);
    if (null == existing) {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = hg.ry_1;
      map.m3(tmp0_set, hg);
    } else {
      var lhs = union(hg.sy_1, existing.sy_1);
      // Inline function 'kotlin.collections.set' call
      var tmp1_set = hg.ry_1;
      var tmp2_set = new TransInfo(existing.oy_1, existing.py_1, hg.qy_1, hg.ry_1, lhs);
      map.m3(tmp1_set, tmp2_set);
    }
  }
}
function calcHeightOrGraftInto($this, prevPrev, prev, from) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var rls = LinkedHashSet.r8();
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0_flatMap = prevPrev.yy_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var tmp0_flatMapTo = ArrayList.i4();
  var tmp0_iterator = tmp0_flatMap.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>' call
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap_0 = prev.yy_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo_0 = ArrayList.i4();
    var tmp0_iterator_0 = tmp0_flatMap_0.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0_flatMap_1 = from.lz();
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      var tmp0_iterator_1 = tmp0_flatMap_1.u();
      while (tmp0_iterator_1.h1()) {
        var element_1 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>.<anonymous>.<anonymous>' call
        var list = $this.dw_1.xx(element, element_0, element_1);
        addAll(tmp0_flatMapTo_1, list);
      }
      var parentsOfFrom = toSet(tmp0_flatMapTo_1);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(parentsOfFrom, 10));
      var tmp0_iterator_2 = parentsOfFrom.u();
      while (tmp0_iterator_2.h1()) {
        var item = tmp0_iterator_2.j1();
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>.<anonymous>.<anonymous>' call
        var action = item.zx_1.cy() ? ParseAction_GOAL_getInstance() : item.yx_1 ? ParseAction_HEIGHT_getInstance() : ParseAction_GRAFT_getInstance();
        var tgt = item.zx_1;
        var grd = item.ay_1;
        var up = item.by_1;
        rls.e1(tgt.qx_1);
        tmp$ret$4 = new TransInfo(setOf(setOf(element)), setOf(setOf(element_0)), action, setOf(tgt), setOf(new LookaheadInfoPart(grd, up)));
        tmp0_mapTo.e1(tmp$ret$4);
      }
      var list_0 = tmp0_mapTo;
      addAll(tmp0_flatMapTo_0, list_0);
    }
    var list_1 = tmp0_flatMapTo_0;
    addAll(tmp0_flatMapTo, list_1);
  }
  var hgInfo = toSet(tmp0_flatMapTo);
  var merged = mergeTransInfo($this, hgInfo, emptySet());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var tmp0_flatMapTo_2 = ArrayList.i4();
  var tmp0_iterator_3 = rls.u();
  while (tmp0_iterator_3.h1()) {
    var element_2 = tmp0_iterator_3.j1();
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>' call
    var list_2 = element_2.tw();
    addAll(tmp0_flatMapTo_2, list_2);
  }
  var rps = tmp0_flatMapTo_2;
  var mergedSateInfoNotAtEnd = mergeStates($this, rps);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_4 = mergedSateInfoNotAtEnd.u();
  while (tmp0_iterator_4.h1()) {
    var element_3 = tmp0_iterator_4.j1();
    // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_5 = element_3.gx_1.u();
    while (tmp0_iterator_5.h1()) {
      var element_4 = tmp0_iterator_5.j1();
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.calcHeightOrGraftInto.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      $this.ox_1.m3(element_4, element_3);
    }
  }
  return merged;
}
function BuildCacheLC1$widthInto$lambda($prevState, $fromState) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = $fromState.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.BuildCacheLC1.widthInto.<anonymous>.<anonymous>' call
      tmp$ret$0 = item.qx_1.mz();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return 'START calcWidthInfo(' + $prevState + ', ' + $fromState + ') - ' + tmp$ret$2;
  };
}
function BuildCacheLC1$widthInto$lambda_0($prevState, $fromState) {
  return function () {
    return 'FINISH calcWidthInfo(' + $prevState + ', ' + $fromState + ')';
  };
}
function processClosureFor($this, context, rulePosition, parentFollow) {
  var graph = new ClosureGraph(context, rulePosition, parentFollow);
  var cls = graph.a10_1;
  var doit;
  switch ($this.bx_1.u3(context).u3(cls)) {
    case null:
      doit = true;
      break;
    case true:
      doit = false;
      break;
    default:
      doit = false;
      break;
  }
  if (doit) {
    // Inline function 'kotlin.collections.set' call
    $this.bx_1.u3(context).m3(cls, true);
    $this.d10(graph);
  }
}
function addFirstTerminalInContext($this, prev, rulePosition, firstTerminalInfo) {
  Debug_getInstance();
  if (false) {
    var tmp = IndentDelta_NONE_getInstance();
    debug(tmp, FirstFollowCache3$addFirstTerminalInContext$lambda(prev, rulePosition, firstTerminalInfo));
  }
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!prev.vx()) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  $this.cx_1.u3(prev).u3(rulePosition).e1(firstTerminalInfo);
}
function addParentInContext($this, prev, completedRule, parentNext) {
  Debug_getInstance();
  if (false) {
    var tmp = IndentDelta_NONE_getInstance();
    debug(tmp, FirstFollowCache3$addParentInContext$lambda(prev, completedRule, parentNext));
  }
  $this.dx_1.u3(prev).u3(completedRule).k1(parentNext);
}
function addPossibleContext($this, rp, ctx) {
  $this.ex_1.u3(rp).e1(ctx);
}
function cacheStuff($this, graph) {
  var tmp0_iterator = graph.a10_1.p10().u();
  while (tmp0_iterator.h1()) {
    var dwn = tmp0_iterator.j1();
    doForRoot($this, graph.a10_1.f10_1, graph.a10_1.g10_1, dwn);
  }
  var tmp1_iterator = graph.q10().u();
  while (tmp1_iterator.h1()) {
    var cls = tmp1_iterator.j1();
    if (cls.p10().y()) {
      addPossibleContext($this, cls.r10(), cls.uf());
    } else {
      if (cls.r10().t10()) {
        doForNonRoot($this, cls);
      } else if (cls.r10().s10()) {
        doForNonRoot($this, cls);
      } else {
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_0 = cls.p10().u();
        while (tmp0_iterator_0.h1()) {
          var element = tmp0_iterator_0.j1();
          // Inline function 'net.akehurst.language.agl.automaton.FirstFollowCache3.cacheStuff.<anonymous>' call
          doForRoot($this, cls.r10(), cls.uf(), element);
        }
      }
    }
  }
}
function doForRoot($this, rulePosition, context, downInfo) {
  addFirstTerminalInContext($this, context, rulePosition, downInfo);
  addPossibleContext($this, rulePosition, context);
}
function doForNonRoot($this, cls) {
  var context = cls.uf();
  var rulePosition = cls.r10();
  var parentNext = cls.u10();
  var completedRule = rulePosition.qx_1;
  addParentInContext($this, context, completedRule, parentNext);
  addPossibleContext($this, rulePosition, context);
}
function FirstFollowCache3$_doneFollow$lambda(it) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap.n8();
}
function FirstFollowCache3$_firstTerminal$lambda(it) {
  return lazyMutableMapNonNull(FirstFollowCache3$_firstTerminal$lambda$lambda);
}
function FirstFollowCache3$_firstTerminal$lambda$lambda(it) {
  // Inline function 'kotlin.collections.hashSetOf' call
  return HashSet.n6();
}
function FirstFollowCache3$_parentInContext$lambda(it) {
  return lazyMutableMapNonNull(FirstFollowCache3$_parentInContext$lambda$lambda);
}
function FirstFollowCache3$_parentInContext$lambda$lambda(it) {
  // Inline function 'kotlin.collections.hashSetOf' call
  return HashSet.n6();
}
function FirstFollowCache3$_possibleContexts$lambda(it) {
  // Inline function 'kotlin.collections.hashSetOf' call
  return HashSet.n6();
}
function FirstFollowCache3$addFirstTerminalInContext$lambda($prev, $rulePosition, $firstTerminalInfo) {
  return function () {
    return 'add firstTerm(' + $prev + ',' + $rulePosition + ') = ' + $firstTerminalInfo;
  };
}
function FirstFollowCache3$addParentInContext$lambda($prev, $completedRule, $parentNext) {
  return function () {
    return 'add parentOf(' + $prev + ',' + $completedRule.mz() + ') = ' + $parentNext;
  };
}
function FirstFollowCache3$calcFirstTermClosure$lambda($graph) {
  return function () {
    return 'START calcFirstTermClosure: ' + $graph.a10_1;
  };
}
function FirstFollowCache3$calcFirstTermClosure$lambda_0($graph) {
  return function () {
    return 'FINISH calcFirstTermClosure: ' + $graph.a10_1;
  };
}
function FirstFollowCache3$calcAllClosure$lambda($graph) {
  return function () {
    return 'START calcFirstTermClosure: ' + $graph.a10_1;
  };
}
function FirstFollowCache3$calcAllClosure$lambda_0($graph) {
  return function () {
    return 'FINISH calcFirstTermClosure: ' + $graph.a10_1;
  };
}
var Companion_instance_0;
function Companion_getInstance_2() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function firstOfRpNotEmpty($this, rulePosition, doneRp, done) {
  var existing = doneRp.u3(rulePosition);
  if (null == existing) {
    if (rulePosition.vx()) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException.y1('Internal Error');
    }
    var needsNext = false;
    var result = Companion_getInstance_8().xw_1;
    var rps = setOf(rulePosition);
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!rps.y()) {
        break $l$loop;
      }
      // Inline function 'kotlin.collections.mutableSetOf' call
      var nrps = LinkedHashSet.r8();
      var tmp0_iterator = rps.u();
      while (tmp0_iterator.h1()) {
        var rp = tmp0_iterator.j1();
        if (rp.vx()) {
          needsNext = true;
        } else {
          var tmp1_iterator = rp.a11().u();
          while (tmp1_iterator.h1()) {
            var item = tmp1_iterator.j1();
            var rhs = item.i11();
            if (rhs instanceof RuntimeRuleRhsEmpty) {
              nrps.k1(rp.j1());
            } else {
              if (rhs instanceof RuntimeRuleRhsGoal) {
                // Inline function 'kotlin.TODO' call
                throw NotImplementedError.eg();
              } else {
                if (rhs instanceof RuntimeRuleRhsEmbedded) {
                  var embSS = rhs.k11_1.m11(rhs.l11_1.mz(), AutomatonKind_LOOKAHEAD_1_getInstance());
                  var tmp$ret$2;
                  // Inline function 'kotlin.collections.hashMapOf' call
                  tmp$ret$2 = HashMap.w4();
                  var f = firstOfNotEmpty(embSS.ov_1, rhs.l11_1, doneRp, tmp$ret$2);
                  var embSkipTerms = rhs.k11_1.n11();
                  result = result.iy(f.h11_1).iy(Companion_getInstance_8().o11(embSkipTerms));
                  if (f.g11_1) {
                    needsNext = true;
                  }
                } else {
                  if (rhs instanceof RuntimeRuleRhsTerminal)
                    result = result.iy(new LookaheadSetPart(false, false, false, setOf(item)));
                  else {
                    if (rhs instanceof RuntimeRuleRhsNonTerminal) {
                      var f_0 = firstOfNotEmpty($this, item, doneRp, done);
                      result = result.iy(f_0.h11_1);
                      if (f_0.g11_1) {
                        var rpnxt = rp.j1();
                        var notSelf = minus(rpnxt, rp);
                        nrps.k1(notSelf);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      rps = nrps;
    }
    existing = new FirstOfResult(needsNext, result);
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = existing;
    doneRp.m3(rulePosition, tmp1_set);
  }
  return existing;
}
function firstOfNotEmpty($this, rule, doneRp, done) {
  var tmp;
  if (0 > rule.nw_1) {
    var tmp0_subject = rule.nw_1;
    var tmp_0;
    Companion_getInstance_33();
    if (tmp0_subject === -1) {
      throw NotImplementedError.eg();
    } else {
      Companion_getInstance_33();
      if (tmp0_subject === -2) {
        throw NotImplementedError.eg();
      } else {
        Companion_getInstance_33();
        if (tmp0_subject === -3) {
          tmp_0 = firstOfNotEmptySafe($this, rule, doneRp, done);
        } else {
          Companion_getInstance_33();
          if (tmp0_subject === -4) {
            tmp_0 = firstOfNotEmptySafe($this, rule, doneRp, done);
          } else {
            Companion_getInstance_33();
            if (tmp0_subject === -6) {
              throw NotImplementedError.eg();
            } else {
              var tmp0_error = 'unsupported rule number ' + rule;
              throw IllegalStateException.y1(toString(tmp0_error));
            }
          }
        }
      }
    }
    tmp = tmp_0;
  } else if (done.r3(rule.nw_1)) {
    var tmp1_elvis_lhs = $this.p11_1.u3(rule.nw_1);
    tmp = tmp1_elvis_lhs == null ? new FirstOfResult(false, Companion_getInstance_8().xw_1) : tmp1_elvis_lhs;
  } else {
    var result = null;
    if (null == result) {
      // Inline function 'kotlin.collections.set' call
      var tmp1_set = rule.nw_1;
      done.m3(tmp1_set, true);
      result = firstOfNotEmptySafe($this, rule, doneRp, done);
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = $this.p11_1;
      var tmp3_set = rule.nw_1;
      var tmp4_set = result;
      tmp2_set.m3(tmp3_set, tmp4_set);
    }
    tmp = result;
  }
  return tmp;
}
function firstOfNotEmptySafe($this, rule, doneRp, done) {
  var needsNext = false;
  var result = Companion_getInstance_8().xw_1;
  var rps = rule.b11();
  var tmp0_iterator = rps.u();
  while (tmp0_iterator.h1()) {
    var rp = tmp0_iterator.j1();
    var tmp1_iterator = rp.a11().u();
    while (tmp1_iterator.h1()) {
      var item = tmp1_iterator.j1();
      var rhs = item.i11();
      if (item.q11())
        needsNext = true;
      else {
        if (rhs instanceof RuntimeRuleRhsGoal) {
          // Inline function 'kotlin.error' call
          throw IllegalStateException.y1('should never happen');
        } else {
          if (rhs instanceof RuntimeRuleRhsEmbedded) {
            var embSS = rhs.k11_1.m11(rhs.l11_1.mz(), AutomatonKind_LOOKAHEAD_1_getInstance());
            var tmp$ret$0;
            // Inline function 'kotlin.collections.hashMapOf' call
            tmp$ret$0 = HashMap.w4();
            var f = firstOfNotEmpty(embSS.ov_1, rhs.l11_1, doneRp, tmp$ret$0);
            var embSkipTerms = rhs.k11_1.n11();
            result = result.iy(f.h11_1).iy(Companion_getInstance_8().o11(embSkipTerms));
            if (f.g11_1) {
              needsNext = true;
            }
          } else {
            if (rhs instanceof RuntimeRuleRhsTerminal)
              result = result.iy(new LookaheadSetPart(false, false, false, setOf(item)));
            else {
              if (rhs instanceof RuntimeRuleRhsNonTerminal) {
                var f_0 = firstOfRpNotEmpty($this, rp, doneRp, done);
                result = result.iy(f_0.h11_1);
                needsNext = needsNext ? true : f_0.g11_1;
              }
            }
          }
        }
      }
    }
  }
  return new FirstOfResult(needsNext, result);
}
function Lookahead$Companion$merge$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
  var tmp = b.t11_1.b12().o();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
  tmp$ret$1 = a.t11_1.b12().o();
  return compareValues(tmp, tmp$ret$1);
}
var Companion_instance_1;
function Companion_getInstance_3() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_4() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function LookaheadSet$regex$delegate$lambda$lambda(it) {
  var tmp;
  if (it.r12()) {
    var tmp_0 = it.i11();
    tmp = (tmp_0 instanceof RuntimeRuleRhsPattern ? tmp_0 : THROW_CCE()).p12_1;
  } else {
    var tmp_1 = it.i11();
    tmp = '\\Q' + (tmp_1 instanceof RuntimeRuleRhsLiteral ? tmp_1 : THROW_CCE()).n12_1 + '\\E';
  }
  return tmp;
}
function LookaheadSet$regex$delegate$lambda(this$0) {
  return function () {
    var str = joinToString(this$0.z11_1, ')|(', '(', ')', VOID, VOID, LookaheadSet$regex$delegate$lambda$lambda);
    return Regex.hb(str);
  };
}
function LookaheadSet$toString$lambda(it) {
  return it.mz();
}
var Companion_instance_3;
function Companion_getInstance_5() {
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function ParserState$runtimeRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.runtimeRules$delegate.<anonymous>.<anonymous>' call
      var tmp = item.qx_1;
      tmp$ret$0 = tmp instanceof RuntimeRule ? tmp : THROW_CCE();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toList(tmp$ret$2);
  };
}
function ParserState$runtimeRulesAsSet$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.runtimeRulesAsSet$delegate.<anonymous>.<anonymous>' call
      var tmp = item.qx_1;
      tmp$ret$0 = tmp instanceof RuntimeRule ? tmp : THROW_CCE();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ParserState$optionList$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.optionList$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = item.rx_1;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toList(tmp$ret$2);
  };
}
function ParserState$positionList$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.yy_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.positionList$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = item.sx_1;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toList(tmp$ret$2);
  };
}
function ParserState$choiceKindList$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_mapNotNull = this$0.yy_1;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp0_mapNotNull.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserState.choiceKindList$delegate.<anonymous>.<anonymous>' call
      var rhs = element.qx_1.i11();
      var tmp0_subject = rhs;
      var tmp;
      if (tmp0_subject instanceof RuntimeRuleRhsChoice) {
        tmp = rhs.x13_1;
      } else {
        tmp = null;
      }
      tmp$ret$0 = tmp;
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    return toList(toSet(tmp$ret$3));
  };
}
function ParserState$isChoice$delegate$lambda(this$0) {
  return function () {
    return this$0.z13().a14();
  };
}
function ParserState$firstRuleChoiceKind$delegate$lambda(this$0) {
  return function () {
    var tmp;
    Debug_getInstance();
    if (false) {
      var tmp0_check = 1 === this$0.b14().o();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (!tmp0_check) {
        var tmp$ret$0;
        // Inline function 'kotlin.check.<anonymous>' call
        tmp$ret$0 = 'Check failed.';
        var message = tmp$ret$0;
        throw IllegalStateException.y1(toString(message));
      }
      tmp = tmp_0;
    }
    return this$0.b14().p(0);
  };
}
function runtimeRules$factory() {
  return getPropertyCallableRef('runtimeRules', 1, KProperty1, function (receiver) {
    return receiver.lz();
  }, null);
}
function runtimeRulesAsSet$factory() {
  return getPropertyCallableRef('runtimeRulesAsSet', 1, KProperty1, function (receiver) {
    return receiver.c14();
  }, null);
}
function optionList$factory() {
  return getPropertyCallableRef('optionList', 1, KProperty1, function (receiver) {
    return receiver.d14();
  }, null);
}
function choiceKindList$factory() {
  return getPropertyCallableRef('choiceKindList', 1, KProperty1, function (receiver) {
    return receiver.b14();
  }, null);
}
function isChoice$factory() {
  return getPropertyCallableRef('isChoice', 1, KProperty1, function (receiver) {
    return receiver.a14();
  }, null);
}
function firstRuleChoiceKind$factory() {
  return getPropertyCallableRef('firstRuleChoiceKind', 1, KProperty1, function (receiver) {
    return receiver.f14();
  }, null);
}
function buildAndTraverse($this) {
  var stateInfos = $this.u14().hw();
  var tmp0_iterator = stateInfos.u();
  while (tmp0_iterator.h1()) {
    var si = tmp0_iterator.j1();
    if (!equals(si.gx_1, $this.w14().yy_1)) {
      Debug_getInstance();
      if (false) {
        // Inline function 'kotlin.check' call
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp0_any = $this.hv_1;
          if (tmp0_any.y()) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          // Inline function 'kotlin.collections.iterator' call
          var tmp0_iterator_0 = tmp0_any.l3().u();
          while (tmp0_iterator_0.h1()) {
            var element = tmp0_iterator_0.j1();
            // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.buildAndTraverse.<anonymous>' call
            if (equals(toSet(element.o3()), si.gx_1)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        // Inline function 'kotlin.contracts.contract' call
        if (!!tmp$ret$0) {
          // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.buildAndTraverse.<anonymous>' call
          var message = 'State already created for ' + si + '.rulePositions';
          throw IllegalStateException.y1(toString(message));
        }
      }
      var state = $this.v14(toList(si.gx_1));
    }
  }
  var tmp1_iterator = stateInfos.u();
  while (tmp1_iterator.h1()) {
    var si_0 = tmp1_iterator.j1();
    var state_0 = ensureNotNull($this.x14(toList(si_0.gx_1)));
    var tmp2_iterator = si_0.hx_1.u();
    while (tmp2_iterator.h1()) {
      var ti = tmp2_iterator.j1();
      var from = state_0;
      var action = ti.qy_1;
      var tmp3_elvis_lhs = $this.y14(toList(ti.ry_1));
      var tmp;
      if (tmp3_elvis_lhs == null) {
        var tmp2_error = 'Internal error, state not created for ' + ti.ry_1;
        throw IllegalStateException.y1(toString(tmp2_error));
      } else {
        tmp = tmp3_elvis_lhs;
      }
      var to = tmp;
      // Inline function 'kotlin.collections.map' call
      var tmp3_map = ti.sy_1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp3_map, 10));
      var tmp0_iterator_1 = tmp3_map.u();
      while (tmp0_iterator_1.h1()) {
        var item = tmp0_iterator_1.j1();
        var tmp$ret$4;
        // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.buildAndTraverse.<anonymous>' call
        tmp$ret$4 = new Lookahead(Companion_getInstance_5().v13(item.ty_1, $this), Companion_getInstance_5().v13(item.uy_1, $this));
        tmp0_mapTo.e1(tmp$ret$4);
      }
      var lhs = toSet(tmp0_mapTo);
      var tmp4_iterator = ti.py_1.u();
      while (tmp4_iterator.h1()) {
        var ps = tmp4_iterator.j1();
        var tmp5_elvis_lhs = $this.y14(toList(ps));
        var tmp_0;
        if (tmp5_elvis_lhs == null) {
          var tmp4_error = 'Internal error, state not created for ' + ps;
          throw IllegalStateException.y1(toString(tmp4_error));
        } else {
          tmp_0 = tmp5_elvis_lhs;
        }
        var prev = tmp_0;
        if (state_0.h14()) {
          state_0.az_1.a15(prev, from, action, to, lhs);
        } else {
          var tmp6_iterator = ti.oy_1.u();
          while (tmp6_iterator.h1()) {
            var pps = tmp6_iterator.j1();
            var tmp7_elvis_lhs = $this.y14(toList(pps));
            var tmp_1;
            if (tmp7_elvis_lhs == null) {
              var tmp5_error = 'Internal error, state not created for ' + pps;
              throw IllegalStateException.y1(toString(tmp5_error));
            } else {
              tmp_1 = tmp7_elvis_lhs;
            }
            var prevPrev = tmp_1;
            state_0.az_1.z14(prev, prevPrev, from, action, to, lhs);
          }
        }
      }
    }
  }
}
function calcUsedRules($this, rule, used, done) {
  var tmp;
  if (rule.cy()) {
    used.e1(rule);
    var tmp0_iterator = flatten(rule.b15()).u();
    while (tmp0_iterator.h1()) {
      var sr = tmp0_iterator.j1();
      calcUsedRules($this, sr instanceof RuntimeRule ? sr : THROW_CCE(), used, done);
    }
    tmp = used;
  } else if (rule.nw_1 >= 0 ? done[rule.nw_1] : false) {
    tmp = used;
  } else {
    var tmp_0;
    if (rule.d11()) {
      used.e1(rule);
      if (rule.nw_1 >= 0) {
        done[rule.nw_1] = true;
      }
      var tmp1_iterator = flatten(rule.b15()).u();
      while (tmp1_iterator.h1()) {
        var sr_0 = tmp1_iterator.j1();
        calcUsedRules($this, sr_0 instanceof RuntimeRule ? sr_0 : THROW_CCE(), used, done);
      }
      tmp_0 = used;
    } else {
      used.e1(rule);
      if (rule.nw_1 > 0) {
        done[rule.nw_1] = true;
      }
      tmp_0 = used;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function calcUsedRules$default($this, rule, used, done, $super) {
  var tmp;
  if (used === VOID) {
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp = LinkedHashSet.r8();
  } else {
    tmp = used;
  }
  used = tmp;
  done = done === VOID ? booleanArray($this.su_1.au_1.o()) : done;
  return calcUsedRules($this, rule, used, done);
}
function ParserStateSet$buildCache$delegate$lambda(this$0) {
  return function () {
    var tmp0_subject = this$0.vu_1;
    var tmp0 = tmp0_subject.bc_1;
    var tmp;
    switch (tmp0) {
      case 0:
        throw NotImplementedError.eg();
      case 1:
        throw NotImplementedError.eg();
      case 2:
        tmp = new BuildCacheLC1(this$0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
}
function ParserStateSet$usedRules$delegate$lambda(this$0) {
  return function () {
    return calcUsedRules$default(this$0, first_0(this$0.w14().lz()));
  };
}
function ParserStateSet$usedTerminalRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.d15();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedTerminalRules$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.s10();
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ParserStateSet$usedNonTerminalRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.d15();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedNonTerminalRules$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.d11();
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ParserStateSet$firstTerminals$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.w14().i14(this$0.w14());
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.firstTerminals$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = item.f15_1.z13();
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ParserStateSet$embeddedRuntimeRuleSet$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.d15();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.embeddedRuntimeRuleSet$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.ny();
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var embRules = toSet(tmp$ret$2);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.map' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(embRules, 10));
    var tmp0_iterator_0 = embRules.u();
    while (tmp0_iterator_0.h1()) {
      var item = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.embeddedRuntimeRuleSet$delegate.<anonymous>.<anonymous>' call
      var tmp = item.i11();
      var rhs = tmp instanceof RuntimeRuleRhsEmbedded ? tmp : THROW_CCE();
      tmp$ret$3 = rhs.k11_1;
      tmp0_mapTo.e1(tmp$ret$3);
    }
    tmp$ret$4 = tmp0_mapTo;
    tmp$ret$5 = tmp$ret$4;
    return toSet(tmp$ret$5);
  };
}
function ParserStateSet$goalRule$delegate$lambda(this$0) {
  return function () {
    return this$0.su_1.fu_1.u3(this$0.tu_1);
  };
}
function ParserStateSet$startRulePosition$delegate$lambda(this$0) {
  return function () {
    var tmp = this$0.pv();
    Companion_getInstance_29();
    return new RulePosition(tmp, 0, 0);
  };
}
function ParserStateSet$finishRulePosition$delegate$lambda(this$0) {
  return function () {
    var tmp = this$0.pv();
    Companion_getInstance_29();
    return new RulePosition(tmp, 0, -1);
  };
}
function ParserStateSet$startState$delegate$lambda(this$0) {
  return function () {
    return this$0.qv(listOf(this$0.ww()));
  };
}
function ParserStateSet$finishState$delegate$lambda(this$0) {
  return function () {
    return this$0.qv(listOf(this$0.l15()));
  };
}
function ParserStateSet$usedAutomatonToString$lambda(it) {
  return toString(it);
}
function ParserStateSet$usedAutomatonToString$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
  var tmp = toString(a.e15_1.yy_1);
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
  tmp$ret$1 = toString(b.e15_1.yy_1);
  return compareValues(tmp, tmp$ret$1);
}
function ParserStateSet$usedAutomatonToString$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
  var tmp = toString(a.f15_1.yy_1);
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.automaton.ParserStateSet.usedAutomatonToString.<anonymous>' call
  tmp$ret$1 = toString(b.f15_1.yy_1);
  return compareValues(tmp, tmp$ret$1);
}
function ParserStateSet$usedAutomatonToString$lambda_2(it) {
  return toString(it);
}
function ParserStateSet$usedAutomatonToString$lambda_3(it) {
  return '' + it;
}
function ParserStateSet$usedAutomatonToString$lambda_4(it) {
  var tmp = it.t11_1.b12();
  var tmp_0 = joinToString(tmp, VOID, VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda$lambda);
  var tmp_1 = it.u11_1.b12();
  return '[' + tmp_0 + '](' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, ParserStateSet$usedAutomatonToString$lambda$lambda_0) + ')';
}
function ParserStateSet$usedAutomatonToString$lambda$lambda(it) {
  return it.mz();
}
function ParserStateSet$usedAutomatonToString$lambda$lambda_0(it) {
  return it.mz();
}
function buildCache$factory() {
  return getPropertyCallableRef('buildCache', 1, KProperty1, function (receiver) {
    return receiver.u14();
  }, null);
}
function usedRules$factory() {
  return getPropertyCallableRef('usedRules', 1, KProperty1, function (receiver) {
    return receiver.d15();
  }, null);
}
function usedTerminalRules$factory() {
  return getPropertyCallableRef('usedTerminalRules', 1, KProperty1, function (receiver) {
    return receiver.uw();
  }, null);
}
function usedNonTerminalRules$factory() {
  return getPropertyCallableRef('usedNonTerminalRules', 1, KProperty1, function (receiver) {
    return receiver.lw();
  }, null);
}
function firstTerminals$factory() {
  return getPropertyCallableRef('firstTerminals', 1, KProperty1, function (receiver) {
    return receiver.m15();
  }, null);
}
function embeddedRuntimeRuleSet$factory() {
  return getPropertyCallableRef('embeddedRuntimeRuleSet', 1, KProperty1, function (receiver) {
    return receiver.n15();
  }, null);
}
function goalRule$factory() {
  return getPropertyCallableRef('goalRule', 1, KProperty1, function (receiver) {
    return receiver.pv();
  }, null);
}
function startRulePosition$factory() {
  return getPropertyCallableRef('startRulePosition', 1, KProperty1, function (receiver) {
    return receiver.ww();
  }, null);
}
function finishRulePosition$factory() {
  return getPropertyCallableRef('finishRulePosition', 1, KProperty1, function (receiver) {
    return receiver.l15();
  }, null);
}
function startState$factory() {
  return getPropertyCallableRef('startState', 1, KProperty1, function (receiver) {
    return receiver.w14();
  }, null);
}
function finishState$factory() {
  return getPropertyCallableRef('finishState', 1, KProperty1, function (receiver) {
    return receiver.o15();
  }, null);
}
function createWidthOrEmbeddedTransition($this, sourceState, wi) {
  var rp = wi.wz_1;
  var lookaheadInfo = new Lookahead(Companion_getInstance_5().v13(wi.xz_1, $this.k14_1), Companion_getInstance_4().d12_1);
  var to = $this.k14_1.v14(listOf(rp));
  return new Transition(sourceState, to, wi.vz_1, setOf(lookaheadInfo));
}
function createHeightTransition3($this, sourceState, hg) {
  var to = $this.k14_1.v14(toList(hg.ry_1));
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = hg.sy_1;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.automaton.RuntimeTransitionCalculator.createHeightTransition3.<anonymous>' call
    tmp$ret$0 = new Lookahead(Companion_getInstance_5().v13(item.ty_1, $this.k14_1), Companion_getInstance_5().v13(item.uy_1, $this.k14_1));
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var lookaheadInfo = toSet(tmp0_mapTo);
  var trs = new Transition(sourceState, to, ParseAction_HEIGHT_getInstance(), lookaheadInfo);
  return trs;
}
function createGraftTransition3($this, sourceState, hg) {
  var to = $this.k14_1.v14(toList(hg.ry_1));
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = hg.sy_1;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.automaton.RuntimeTransitionCalculator.createGraftTransition3.<anonymous>' call
    tmp$ret$0 = new Lookahead(Companion_getInstance_5().v13(item.ty_1, $this.k14_1), Companion_getInstance_4().d12_1);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var lookaheadInfo = toSet(tmp0_mapTo);
  var trs = new Transition(sourceState, to, ParseAction_GRAFT_getInstance(), lookaheadInfo);
  return trs;
}
function createGoalTransition3($this, sourceState, hg) {
  var to = $this.k14_1.o15();
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = hg.sy_1;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.automaton.RuntimeTransitionCalculator.createGoalTransition3.<anonymous>' call
    tmp$ret$0 = new Lookahead(Companion_getInstance_4().f12_1, Companion_getInstance_4().d12_1);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var lookaheadInfo = toSet(tmp0_mapTo);
  var trs = new Transition(sourceState, to, ParseAction_GOAL_getInstance(), lookaheadInfo);
  return trs;
}
var DefaultRuntimeGuard_instance;
function DefaultRuntimeGuard_getInstance() {
  if (DefaultRuntimeGuard_instance === VOID)
    new DefaultRuntimeGuard();
  return DefaultRuntimeGuard_instance;
}
var Companion_instance_4;
function Companion_getInstance_6() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function _get_hashCode_cache__hrfw4t($this) {
  // Inline function 'kotlin.getValue' call
  hashCode_cache$factory();
  return $this.k15_1.p3();
}
function Transition$context$delegate$lambda(this$0) {
  return function () {
    return toSet(this$0.e15_1.az_1.x15(this$0));
  };
}
function Transition$hashCode_cache$delegate$lambda(this$0) {
  return function () {
    return arrayListOf([this$0.e15_1, this$0.f15_1, this$0.g15_1, this$0.h15_1]).hashCode();
  };
}
function Transition$toString$lambda(it) {
  return toString(it);
}
function Transition$toString$lambda_0(it) {
  var tmp = it.t11_1.b12();
  var tmp_0 = joinToString(tmp, VOID, VOID, VOID, VOID, VOID, Transition$toString$lambda$lambda);
  var tmp_1 = it.u11_1.b12();
  return '[' + tmp_0 + '](' + joinToString(tmp_1, VOID, VOID, VOID, VOID, VOID, Transition$toString$lambda$lambda_0) + ')';
}
function Transition$toString$lambda$lambda(it) {
  return it.mz();
}
function Transition$toString$lambda$lambda_0(it) {
  return it.mz();
}
function context$factory() {
  return getPropertyCallableRef('context', 1, KProperty1, function (receiver) {
    return receiver.uf();
  }, null);
}
function hashCode_cache$factory() {
  return getPropertyCallableRef('hashCode_cache', 1, KProperty1, function (receiver) {
    return _get_hashCode_cache__hrfw4t(receiver);
  }, null);
}
function merge($this, automaton, set) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var tmp0_groupByTo = LinkedHashMap.n8();
  var tmp0_iterator = set.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
    var key = listOf_0([element.e15_1, element.g15_1, element.f15_1]);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = tmp0_groupByTo.u3(key);
    var tmp;
    if (value == null) {
      // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
      var answer = ArrayList.i4();
      tmp0_groupByTo.m3(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.e1(element);
  }
  var grouped = tmp0_groupByTo;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(grouped.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = grouped.l3().u();
  while (tmp0_iterator_0.h1()) {
    var item = tmp0_iterator_0.j1();
    var tmp$ret$9;
    // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>' call
    var tmp_0 = item.o3().p(0);
    var from = tmp_0 instanceof ParserState ? tmp_0 : THROW_CCE();
    var tmp_1 = item.o3().p(1);
    var action = tmp_1 instanceof ParseAction ? tmp_1 : THROW_CCE();
    var tmp_2 = item.o3().p(2);
    var to = tmp_2 instanceof ParserState ? tmp_2 : THROW_CCE();
    var tmp_3 = Companion_getInstance_3();
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = item.p3();
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator_1 = tmp0_flatMap.u();
    while (tmp0_iterator_1.h1()) {
      var element_0 = tmp0_iterator_1.j1();
      // Inline function 'net.akehurst.language.agl.automaton.Companion.merge.<anonymous>.<anonymous>' call
      var list_0 = element_0.h15_1;
      addAll(tmp0_flatMapTo, list_0);
    }
    var lhs = tmp_3.j12(automaton, toSet(tmp0_flatMapTo));
    tmp$ret$9 = new Transition(from, to, action, lhs);
    tmp0_mapTo.e1(tmp$ret$9);
  }
  var merged = tmp0_mapTo;
  var tmp_4;
  if (merged.o() === 1) {
    tmp_4 = first_0(merged);
  } else {
    Debug_getInstance();
    if (false) {
      var tmp_5 = Debug_getInstance();
      var tmp_6 = IndentDelta_NONE_getInstance();
      tmp_5.uz(tmp_6, TransitionCacheLC1$Companion$merge$lambda(set));
    }
    var tmp0_error = 'Internal Error: transitions not merged\n' + joinToString(merged, '\n', VOID, VOID, VOID, VOID, TransitionCacheLC1$Companion$merge$lambda_0);
    throw IllegalStateException.y1(toString(tmp0_error));
  }
  return tmp_4;
}
function TransitionCacheLC1$Companion$merge$lambda$lambda(it) {
  return it.toString();
}
function TransitionCacheLC1$Companion$merge$lambda($set) {
  return function () {
    return 'Tried to Merge:\n  ' + joinToString($set, '\n  ', VOID, VOID, VOID, VOID, TransitionCacheLC1$Companion$merge$lambda$lambda);
  };
}
function TransitionCacheLC1$Companion$merge$lambda_0(it) {
  return it.toString();
}
var Companion_instance_5;
function Companion_getInstance_7() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
function _get__allBuiltIncomplete__j98m7d($this) {
  return flatten($this.f17_1.k3());
}
function _get__allBuiltComplete__fb3q3g($this) {
  return flatten($this.e17_1.k3());
}
function _get__allPreviousIncomplete__5lazpo($this) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = $this.f17_1.j3();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.<get-_allPreviousIncomplete>.<anonymous>' call
    tmp$ret$0 = new IncompleteKey(item);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  return tmp0_mapTo;
}
function _get__allPreviousComplete__hn51vr($this) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = $this.e17_1.j3();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.automaton.TransitionCacheLC1.<get-_allPreviousComplete>.<anonymous>' call
    tmp0_mapTo.e1(item);
  }
  return tmp0_mapTo;
}
function updateIncompleteByPrevious($this, previousSet, oldTransition, newTransition) {
  var tmp0_iterator = previousSet.u();
  while (tmp0_iterator.h1()) {
    var pS = tmp0_iterator.j1();
    var trans = $this.f17_1.u3(pS);
    if (null == trans) {
      trans = mutableListOf([newTransition]);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = $this.f17_1;
      var tmp1_set = trans;
      tmp0_set.m3(pS, tmp1_set);
    } else {
      if (!(null == oldTransition)) {
        trans.f1(oldTransition);
      }
      trans.e1(newTransition);
    }
  }
}
function updateCompleteByPrevious($this, prevKeySet, oldTransition, newTransition) {
  var tmp0_iterator = prevKeySet.u();
  while (tmp0_iterator.h1()) {
    var pk = tmp0_iterator.j1();
    var trans = $this.e17_1.u3(pk);
    if (null == trans) {
      trans = mutableListOf([newTransition]);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = $this.e17_1;
      var tmp1_set = trans;
      tmp0_set.m3(pk, tmp1_set);
    } else {
      if (!(null == oldTransition)) {
        trans.f1(oldTransition);
      }
      trans.e1(newTransition);
    }
  }
}
function TransitionCacheLC1$addTransitionForComplete$lambda$lambda(it) {
  return it.toString();
}
function TransitionCacheLC1$addTransitionForComplete$lambda($toMerge) {
  return function () {
    return 'Merged:\n  ' + joinToString($toMerge, '\n  ', VOID, VOID, VOID, VOID, TransitionCacheLC1$addTransitionForComplete$lambda$lambda);
  };
}
function TransitionCacheLC1$addTransitionForComplete$lambda_0($mergedTr) {
  return function () {
    return 'Into:\n  ' + $mergedTr;
  };
}
function TransitionCacheLC1$addTransitionForIncomplete$lambda$lambda(it) {
  return it.toString();
}
function TransitionCacheLC1$addTransitionForIncomplete$lambda($toMerge) {
  return function () {
    return 'Merged:\n  ' + joinToString($toMerge, '\n  ', VOID, VOID, VOID, VOID, TransitionCacheLC1$addTransitionForIncomplete$lambda$lambda);
  };
}
function TransitionCacheLC1$addTransitionForIncomplete$lambda_0($mergedTr) {
  return function () {
    return 'Into:\n  ' + $mergedTr;
  };
}
var Companion_instance_6;
function Companion_getInstance_8() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
function LookaheadSetPart$regex$delegate$lambda$lambda(it) {
  var tmp0_subject = it.i11();
  var tmp;
  if (tmp0_subject instanceof RuntimeRuleRhsLiteral) {
    var tmp_0 = it.i11();
    tmp = '\\Q' + (tmp_0 instanceof RuntimeRuleRhsLiteral ? tmp_0 : THROW_CCE()).n12_1 + '\\E';
  } else {
    if (tmp0_subject instanceof RuntimeRuleRhsPattern) {
      var tmp_1 = it.i11();
      tmp = (tmp_1 instanceof RuntimeRuleRhsPattern ? tmp_1 : THROW_CCE()).p12_1;
    } else {
      throw IllegalStateException.y1('Internal Error: rhs not a literal that can be joined to a regex');
    }
  }
  return tmp;
}
function LookaheadSetPart$regex$delegate$lambda(this$0) {
  return function () {
    var str = joinToString(this$0.gy_1, ')|(', '(', ')', VOID, VOID, LookaheadSetPart$regex$delegate$lambda$lambda);
    return Regex.hb(str);
  };
}
function LookaheadSetPart$toString$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.automaton.LookaheadSetPart.toString.<anonymous>' call
  var tmp = a.mz();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.automaton.LookaheadSetPart.toString.<anonymous>' call
  tmp$ret$1 = b.mz();
  return compareValues(tmp, tmp$ret$1);
}
function LookaheadSetPart$toString$lambda_0(it) {
  return it.mz();
}
var Companion_instance_7;
function Companion_getInstance_9() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function ClosureGraph$Companion$ClosureItemAbstractGraph$expectedAt$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_10().r11(this$0.f10_1, this$0.h10_1);
  };
}
function ClosureGraph$Companion$ClosureItemAbstractGraph$children$delegate$lambda(this$0) {
  return function () {
    return this$0.e10_1.s17(this$0);
  };
}
function ClosureGraph$Companion$ClosureItemAbstractGraph$parents$delegate$lambda(this$0) {
  return function () {
    return this$0.e10_1.t17(this$0);
  };
}
function ClosureGraph$Companion$ClosureItemAbstractGraph$parentNext$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_10().u17(this$0.e10_1.t17(this$0));
  };
}
var Companion_instance_8;
function Companion_getInstance_10() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ClosureGraph$_childrenOf$lambda(it) {
  return lazyMutableMapNonNull(ClosureGraph$_childrenOf$lambda$lambda);
}
function ClosureGraph$_childrenOf$lambda$lambda(it) {
  // Inline function 'kotlin.collections.hashSetOf' call
  return HashSet.n6();
}
function ClosureGraph$_parentsOf$lambda(it) {
  // Inline function 'kotlin.collections.hashSetOf' call
  return HashSet.n6();
}
function expectedAt$factory() {
  return getPropertyCallableRef('expectedAt', 1, KProperty1, function (receiver) {
    return receiver.o17();
  }, null);
}
function children$factory() {
  return getPropertyCallableRef('children', 1, KProperty1, function (receiver) {
    return receiver.v17();
  }, null);
}
function parentNext$factory() {
  return getPropertyCallableRef('parentNext', 1, KProperty1, function (receiver) {
    return receiver.u10();
  }, null);
}
function provideFor($this, item, desiredDepth, context) {
  var rule = item.owningRule;
  var cis = getItems($this, item, desiredDepth, context, emptySet());
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var tmp0_mapNotNullTo = ArrayList.i4();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = cis.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
    // Inline function 'net.akehurst.language.agl.default.CompletionProviderDefault.provideFor.<anonymous>' call
    if (element == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_mapNotNullTo.e1(element);
    }
  }
  return toList(toSet(tmp0_mapNotNullTo));
}
function getItems($this, item, desiredDepth, context, done) {
  var tmp;
  if (done.w(item)) {
    tmp = emptyList();
  } else {
    var tmp_0;
    if (isInterface(item, EmptyRule)) {
      tmp_0 = listOf(null);
    } else {
      if (isInterface(item, Choice)) {
        // Inline function 'kotlin.collections.flatMap' call
        var tmp0_flatMap = item.alternative;
        // Inline function 'kotlin.collections.flatMapTo' call
        var tmp0_flatMapTo = ArrayList.i4();
        var tmp0_iterator = tmp0_flatMap.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          // Inline function 'net.akehurst.language.agl.default.CompletionProviderDefault.getItems.<anonymous>' call
          var list = getItems($this, element, desiredDepth, context, plus_1(done, item));
          addAll(tmp0_flatMapTo, list);
        }
        tmp_0 = tmp0_flatMapTo;
      } else {
        if (isInterface(item, Concatenation)) {
          var items = getItems($this, item.items.p(0), desiredDepth, context, plus_1(done, item));
          var index = 1;
          $l$loop: while (true) {
            var tmp_1;
            if (index < item.items.o()) {
              var tmp$ret$3;
              $l$block_0: {
                // Inline function 'kotlin.collections.any' call
                var tmp1_any = items;
                var tmp_2;
                if (isInterface(tmp1_any, Collection)) {
                  tmp_2 = tmp1_any.y();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$3 = false;
                  break $l$block_0;
                }
                var tmp0_iterator_0 = tmp1_any.u();
                while (tmp0_iterator_0.h1()) {
                  var element_0 = tmp0_iterator_0.j1();
                  // Inline function 'net.akehurst.language.agl.default.CompletionProviderDefault.getItems.<anonymous>' call
                  if (element_0 == null) {
                    tmp$ret$3 = true;
                    break $l$block_0;
                  }
                }
                tmp$ret$3 = false;
              }
              tmp_1 = tmp$ret$3;
            } else {
              tmp_1 = false;
            }
            if (!tmp_1) {
              break $l$loop;
            }
            // Inline function 'kotlin.collections.mapNotNull' call
            var tmp2_mapNotNull = items;
            // Inline function 'kotlin.collections.mapNotNullTo' call
            var tmp0_mapNotNullTo = ArrayList.i4();
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_1 = tmp2_mapNotNull.u();
            while (tmp0_iterator_1.h1()) {
              var element_1 = tmp0_iterator_1.j1();
              // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
              // Inline function 'net.akehurst.language.agl.default.CompletionProviderDefault.getItems.<anonymous>' call
              if (element_1 == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                tmp0_mapNotNullTo.e1(element_1);
              }
            }
            items = plus(tmp0_mapNotNullTo, getItems($this, item.items.p(index), desiredDepth, context, plus_1(done, item)));
            index = index + 1 | 0;
          }
          tmp_0 = items;
        } else {
          if (isInterface(item, Terminal)) {
            tmp_0 = $this.w18(item, context);
          } else {
            if (isInterface(item, NonTerminal)) {
              tmp_0 = getItems($this, item.referencedRule($this.x18_1).rhs, desiredDepth - 1 | 0, context, plus_1(done, item));
            } else {
              if (isInterface(item, SeparatedList)) {
                var items_0 = getItems($this, item.item, desiredDepth, context, plus_1(done, item));
                var tmp_3;
                if (item.min === 0) {
                  tmp_3 = plus(items_0, listOf(null));
                } else {
                  tmp_3 = plus(items_0, emptyList());
                }
                tmp_0 = tmp_3;
              } else {
                if (isInterface(item, SimpleList)) {
                  var items_1 = getItems($this, item.item, desiredDepth, context, plus_1(done, item));
                  var tmp_4;
                  if (item.min === 0) {
                    tmp_4 = plus(items_1, listOf(null));
                  } else {
                    tmp_4 = plus(items_1, emptyList());
                  }
                  tmp_0 = tmp_4;
                } else {
                  if (isInterface(item, Group)) {
                    tmp_0 = getItems($this, item.groupedContent, desiredDepth, context, plus_1(done, item));
                  } else {
                    throw IllegalStateException.y1('not yet supported!');
                  }
                }
              }
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  return tmp;
}
var TypeModelFromGrammar_instance;
function TypeModelFromGrammar_getInstance() {
  if (TypeModelFromGrammar_instance === VOID)
    new TypeModelFromGrammar();
  return TypeModelFromGrammar_instance;
}
var Companion_instance_9;
function Companion_getInstance_11() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function _get_model__e5yfy0($this) {
  var tmp = $this.n19_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('model');
  }
}
function _get_contextGrammar__5lii99($this) {
  var tmp = $this.o19_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('contextGrammar');
  }
}
function _get_grammar__y8y3sm($this) {
  var tmp = $this.p19_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('grammar');
  }
}
function findOrCreateElementType($this, rule, ifCreate) {
  var ruleName = rule.name;
  var existing = $this.j19_1.u3(ruleName);
  var tmp;
  if (null == existing) {
    var tmp0_safe_receiver = $this.m19_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x19(rule);
    var elTypeName = tmp1_elvis_lhs == null ? ruleName : tmp1_elvis_lhs;
    var et = $this.findOwnedOrCreateDataTypeNamed(elTypeName);
    var tt = et.instance();
    // Inline function 'kotlin.collections.set' call
    $this.j19_1.m3(ruleName, tt);
    ifCreate(et);
    tmp = tt;
  } else {
    tmp = existing;
  }
  return tmp;
}
function typeModelForEmbedded($this, ruleItem) {
  var embTm = GrammarTypeNamespaceFromGrammar.q19(_get_model__e5yfy0($this), _get_contextGrammar__5lii99($this), ensureNotNull(ruleItem.embeddedGrammarReference.resolved), $this.m19_1);
  if (!_get_model__e5yfy0($this).namespace.r3(embTm.i19_1)) {
    _get_model__e5yfy0($this).addNamespace(embTm);
  }
  protoOf(GrammarTypeNamespaceAbstract).addImport.call($this, embTm.i19_1);
  return embTm;
}
function typeForGrammarRule($this, rule) {
  var type = $this.j19_1.u3(rule.name);
  var tmp;
  if (!(null == type)) {
    tmp = type;
  } else {
    var tmp_0;
    if (rule.isLeaf) {
      tmp_0 = SimpleTypeModelStdLib_getInstance().String;
    } else {
      var rhs = rule.rhs;
      var tmp_1;
      if (isInterface(rhs, EmptyRule)) {
        tmp_1 = findOrCreateElementType($this, rule, GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda);
      } else {
        if (isInterface(rhs, Terminal)) {
          tmp_1 = elementTypeFor($this, rule, listOf(rhs));
        } else {
          if (isInterface(rhs, NonTerminal)) {
            tmp_1 = elementTypeFor($this, rule, listOf(rhs));
          } else {
            if (isInterface(rhs, Embedded)) {
              tmp_1 = elementTypeFor($this, rule, listOf(rhs));
            } else {
              if (isInterface(rhs, Concatenation)) {
                tmp_1 = elementTypeFor($this, rule, rhs.items);
              } else {
                if (isInterface(rhs, Choice)) {
                  tmp_1 = typeForChoiceRule($this, rhs, rule);
                } else {
                  if (isInterface(rhs, OptionalItem)) {
                    tmp_1 = findOrCreateElementType($this, rule, GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_0($this, rhs));
                  } else {
                    if (isInterface(rhs, SimpleList)) {
                      tmp_1 = findOrCreateElementType($this, rule, GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_1($this, rhs));
                    } else {
                      if (isInterface(rhs, SeparatedList)) {
                        tmp_1 = findOrCreateElementType($this, rule, GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_2($this, rhs));
                      } else {
                        if (isInterface(rhs, Group)) {
                          tmp_1 = typeForGroup($this, rhs, false);
                        } else {
                          var tmp0_error = "Internal error, unhandled subtype of rule '" + rule.name + "'.rhs '" + getKClassFromExpression(rhs).n9() + "' when getting TypeModel from grammar '" + $this.i19_1 + "'";
                          throw IllegalStateException.y1(toString(tmp0_error));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      tmp_0 = tmp_1;
    }
    var ruleTypeUse = tmp_0;
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = $this.j19_1;
    var tmp2_set = rule.name;
    tmp1_set.m3(tmp2_set, ruleTypeUse);
    tmp = ruleTypeUse;
  }
  return tmp;
}
function typeForRuleItem($this, ruleItem, forProperty) {
  var type = $this.k19_1.u3(ruleItem);
  var tmp;
  if (!(null == type)) {
    tmp = type;
  } else {
    var tmp_0;
    if (isInterface(ruleItem, EmptyRule)) {
      tmp_0 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
    } else {
      if (isInterface(ruleItem, Terminal)) {
        tmp_0 = forProperty ? SimpleTypeModelStdLib_getInstance().NothingType.instance() : SimpleTypeModelStdLib_getInstance().String;
      } else {
        if (isInterface(ruleItem, NonTerminal)) {
          var refRule = ruleItem.referencedRule(_get_grammar__y8y3sm($this));
          var tmp_1;
          if (refRule.isLeaf) {
            tmp_1 = SimpleTypeModelStdLib_getInstance().String;
          } else {
            var tmp_2 = refRule.rhs;
            if (isInterface(tmp_2, EmptyRule)) {
              tmp_1 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
            } else {
              tmp_1 = typeForGrammarRule($this, refRule);
            }
          }
          tmp_0 = tmp_1;
        } else {
          if (isInterface(ruleItem, Embedded)) {
            var embTmfg = typeModelForEmbedded($this, ruleItem);
            var embTm = embTmfg;
            var tmp1_elvis_lhs = embTm.findTypeUsageForRule(ruleItem.name);
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              throw IllegalStateException.y1('Should never happen');
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }
            tmp_0 = tmp_3;
          } else {
            if (isInterface(ruleItem, Choice)) {
              tmp_0 = typeForChoiceRuleItem($this, ruleItem, forProperty);
            } else {
              if (isInterface(ruleItem, Concatenation)) {
                tmp_0 = tupleTypeFor($this, ruleItem, ruleItem.items);
              } else {
                if (isInterface(ruleItem, Group)) {
                  tmp_0 = typeForGroup($this, ruleItem, forProperty);
                } else {
                  if (isInterface(ruleItem, OptionalItem)) {
                    var itemType = typeForRuleItem($this, ruleItem.item, forProperty);
                    var tmp2_subject = itemType.type;
                    var tmp_4;
                    if (equals(tmp2_subject, SimpleTypeModelStdLib_getInstance().NothingType)) {
                      tmp_4 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
                    } else {
                      var t = itemType.type.instance(emptyList(), true);
                      // Inline function 'kotlin.collections.set' call
                      $this.k19_1.m3(ruleItem, t);
                      tmp_4 = t;
                    }
                    tmp_0 = tmp_4;
                  } else {
                    if (isInterface(ruleItem, SimpleList)) {
                      // Inline function 'kotlin.collections.mutableListOf' call
                      var typeArgs = ArrayList.i4();
                      var t_0 = SimpleTypeModelStdLib_getInstance().List.instance(typeArgs);
                      // Inline function 'kotlin.collections.set' call
                      $this.k19_1.m3(ruleItem, t_0);
                      var itemType_0 = typeForRuleItem($this, ruleItem.item, forProperty);
                      var tmp3_subject = itemType_0.type;
                      var tmp_5;
                      if (equals(tmp3_subject, SimpleTypeModelStdLib_getInstance().NothingType)) {
                        $this.k19_1.q3(ruleItem);
                        tmp_5 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
                      } else {
                        typeArgs.e1(itemType_0);
                        tmp_5 = t_0;
                      }
                      tmp_0 = tmp_5;
                    } else {
                      if (isInterface(ruleItem, SeparatedList)) {
                        // Inline function 'kotlin.collections.mutableListOf' call
                        var typeArgs_0 = ArrayList.i4();
                        var t_1 = SimpleTypeModelStdLib_getInstance().ListSeparated.instance(typeArgs_0);
                        // Inline function 'kotlin.collections.set' call
                        $this.k19_1.m3(ruleItem, t_1);
                        var itemType_1 = typeForRuleItem($this, ruleItem.item, forProperty);
                        var sepType = typeForRuleItem($this, ruleItem.separator, forProperty);
                        var tmp_6;
                        if (equals(itemType_1.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
                          $this.k19_1.q3(ruleItem);
                          tmp_6 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
                        } else if (equals(sepType.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
                          var lt = SimpleTypeModelStdLib_getInstance().List.instance(listOf(itemType_1));
                          // Inline function 'kotlin.collections.set' call
                          $this.k19_1.m3(ruleItem, lt);
                          tmp_6 = lt;
                        } else {
                          typeArgs_0.e1(itemType_1);
                          typeArgs_0.e1(sepType);
                          tmp_6 = t_1;
                        }
                        tmp_0 = tmp_6;
                      } else {
                        throw IllegalStateException.y1('Internal error, unhandled subtype of RuleItem');
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var ruleType = tmp_0;
    // Inline function 'kotlin.collections.set' call
    $this.k19_1.m3(ruleItem, ruleType);
    tmp = ruleType;
  }
  return tmp;
}
function elementTypeFor($this, rule, items) {
  var concatType = findOrCreateElementType($this, rule, GrammarTypeNamespaceFromGrammar$elementTypeFor$lambda(items, $this));
  return concatType;
}
function tupleTypeFor($this, ruleItem, items) {
  var concatType = $this.createTupleType();
  var t = concatType.instance();
  // Inline function 'kotlin.collections.set' call
  $this.k19_1.m3(ruleItem, t);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = items.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.tupleTypeFor.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp1_anonymous = checkIndexOverflow(tmp1);
    createPropertyDeclaration($this, concatType, item, tmp1_anonymous);
  }
  var tmp;
  if (concatType.property.y()) {
    // Inline function 'kotlin.collections.set' call
    var tmp2_set = $this.k19_1;
    var tmp3_set = SimpleTypeModelStdLib_getInstance().NothingType.instance();
    tmp2_set.m3(ruleItem, tmp3_set);
    tmp = SimpleTypeModelStdLib_getInstance().NothingType.instance();
  } else {
    tmp = t;
  }
  return tmp;
}
function typeForGroup($this, group, forProperty) {
  var content = group.groupedContent;
  var tmp;
  if (isInterface(content, Choice)) {
    tmp = typeForChoiceRuleItem($this, content, forProperty);
  } else {
    var tmp_0;
    if (isInterface(content, Concatenation)) {
      tmp_0 = content.items;
    } else {
      tmp_0 = listOf(content);
    }
    var items = tmp_0;
    tmp = tupleTypeFor($this, group, items);
  }
  return tmp;
}
function typeForChoiceRule($this, choice, choiceRule) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = choice.alternative;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
    tmp$ret$0 = typeForRuleItem($this, item, false);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var subtypes = tmp0_mapTo;
  var tmp;
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp_0;
    if (isInterface(subtypes, Collection)) {
      tmp_0 = subtypes.y();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var tmp0_iterator_0 = subtypes.u();
    while (tmp0_iterator_0.h1()) {
      var element = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
      if (!equals(element.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  if (tmp$ret$3) {
    var tmp_1 = SimpleTypeModelStdLib_getInstance().NothingType;
    var tmp_2 = emptyList();
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(subtypes, Collection)) {
        tmp_3 = subtypes.y();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$5 = false;
        break $l$block_2;
      }
      var tmp0_iterator_1 = subtypes.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
        if (element_0.isNullable) {
          tmp$ret$5 = true;
          break $l$block_2;
        }
      }
      tmp$ret$5 = false;
    }
    tmp = tmp_1.instance(tmp_2, tmp$ret$5);
  } else {
    var tmp$ret$7;
    $l$block_4: {
      // Inline function 'kotlin.collections.all' call
      var tmp_4;
      if (isInterface(subtypes, Collection)) {
        tmp_4 = subtypes.y();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$7 = true;
        break $l$block_4;
      }
      var tmp0_iterator_2 = subtypes.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
        var tmp_5 = element_1.type;
        if (!isInterface(tmp_5, PrimitiveType)) {
          tmp$ret$7 = false;
          break $l$block_4;
        }
      }
      tmp$ret$7 = true;
    }
    if (tmp$ret$7) {
      tmp = SimpleTypeModelStdLib_getInstance().String;
    } else {
      var tmp$ret$9;
      $l$block_6: {
        // Inline function 'kotlin.collections.all' call
        var tmp_6;
        if (isInterface(subtypes, Collection)) {
          tmp_6 = subtypes.y();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$9 = true;
          break $l$block_6;
        }
        var tmp0_iterator_3 = subtypes.u();
        while (tmp0_iterator_3.h1()) {
          var element_2 = tmp0_iterator_3.j1();
          // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
          var tmp_7 = element_2.type;
          if (!isInterface(tmp_7, DataType)) {
            tmp$ret$9 = false;
            break $l$block_6;
          }
        }
        tmp$ret$9 = true;
      }
      if (tmp$ret$9) {
        tmp = findOrCreateElementType($this, choiceRule, GrammarTypeNamespaceFromGrammar$typeForChoiceRule$lambda(subtypes));
      } else {
        var tmp$ret$11;
        $l$block_8: {
          // Inline function 'kotlin.collections.all' call
          var tmp_8;
          if (isInterface(subtypes, Collection)) {
            tmp_8 = subtypes.y();
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp$ret$11 = true;
            break $l$block_8;
          }
          var tmp0_iterator_4 = subtypes.u();
          while (tmp0_iterator_4.h1()) {
            var element_3 = tmp0_iterator_4.j1();
            // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
            if (!equals(element_3.type, SimpleTypeModelStdLib_getInstance().List)) {
              tmp$ret$11 = false;
              break $l$block_8;
            }
          }
          tmp$ret$11 = true;
        }
        if (tmp$ret$11) {
          var itemType = SimpleTypeModelStdLib_getInstance().AnyType.instance();
          var choiceType = SimpleTypeModelStdLib_getInstance().List.instance(listOf(itemType));
          tmp = choiceType;
        } else {
          var tmp$ret$13;
          $l$block_10: {
            // Inline function 'kotlin.collections.all' call
            var tmp_9;
            if (isInterface(subtypes, Collection)) {
              tmp_9 = subtypes.y();
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              tmp$ret$13 = true;
              break $l$block_10;
            }
            var tmp0_iterator_5 = subtypes.u();
            while (tmp0_iterator_5.h1()) {
              var element_4 = tmp0_iterator_5.j1();
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
              var tmp_10 = element_4.type;
              if (!isInterface(tmp_10, TupleType)) {
                tmp$ret$13 = false;
                break $l$block_10;
              }
            }
            tmp$ret$13 = true;
          }
          if (tmp$ret$13) {
            var tmp_11;
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
            var tmp0_iterator_6 = subtypes.u();
            while (tmp0_iterator_6.h1()) {
              var item_0 = tmp0_iterator_6.j1();
              var tmp$ret$18;
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
              // Inline function 'kotlin.collections.map' call
              var tmp_12 = item_0.type;
              var tmp0_map_0 = (isInterface(tmp_12, TupleType) ? tmp_12 : THROW_CCE()).property.k3();
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(tmp0_map_0, 10));
              var tmp0_iterator_7 = tmp0_map_0.u();
              while (tmp0_iterator_7.h1()) {
                var item_1 = tmp0_iterator_7.j1();
                var tmp$ret$15;
                // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>.<anonymous>' call
                tmp$ret$15 = new Pair(item_1.name, item_1);
                tmp0_mapTo_1.e1(tmp$ret$15);
              }
              tmp$ret$18 = toSet(tmp0_mapTo_1);
              tmp0_mapTo_0.e1(tmp$ret$18);
            }
            if (1 === toSet(tmp0_mapTo_0).o()) {
              var t = first_0(subtypes);
              var tmp_13;
              var tmp_14;
              var tmp_15 = t.type;
              if (isInterface(tmp_15, TupleType)) {
                var tmp_16 = t.type;
                tmp_14 = (isInterface(tmp_16, TupleType) ? tmp_16 : THROW_CCE()).properties.y();
              } else {
                tmp_14 = false;
              }
              if (tmp_14) {
                tmp_13 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
              } else {
                tmp_13 = t;
              }
              tmp_11 = tmp_13;
            } else {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
              var tmp0_iterator_8 = subtypes.u();
              while (tmp0_iterator_8.h1()) {
                var item_2 = tmp0_iterator_8.j1();
                // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
                tmp0_mapTo_2.e1(item_2);
              }
              tmp_11 = protoOf(GrammarTypeNamespaceAbstract).createUnnamedSuperTypeType.call($this, tmp0_mapTo_2).instance();
            }
            tmp = tmp_11;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_3 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
            var tmp0_iterator_9 = subtypes.u();
            while (tmp0_iterator_9.h1()) {
              var item_3 = tmp0_iterator_9.j1();
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>' call
              tmp0_mapTo_3.e1(item_3);
            }
            tmp = protoOf(GrammarTypeNamespaceAbstract).createUnnamedSuperTypeType.call($this, tmp0_mapTo_3).instance();
          }
        }
      }
    }
  }
  return tmp;
}
function typeForChoiceRuleItem($this, choice, forProperty) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = choice.alternative;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
    tmp$ret$0 = typeForRuleItem($this, item, forProperty);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var subtypes = tmp0_mapTo;
  var tmp;
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp_0;
    if (isInterface(subtypes, Collection)) {
      tmp_0 = subtypes.y();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var tmp0_iterator_0 = subtypes.u();
    while (tmp0_iterator_0.h1()) {
      var element = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
      if (!equals(element.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  if (tmp$ret$3) {
    var tmp_1 = SimpleTypeModelStdLib_getInstance().NothingType;
    var tmp_2 = emptyList();
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(subtypes, Collection)) {
        tmp_3 = subtypes.y();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$5 = false;
        break $l$block_2;
      }
      var tmp0_iterator_1 = subtypes.u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
        if (element_0.isNullable) {
          tmp$ret$5 = true;
          break $l$block_2;
        }
      }
      tmp$ret$5 = false;
    }
    tmp = tmp_1.instance(tmp_2, tmp$ret$5);
  } else {
    var tmp$ret$7;
    $l$block_4: {
      // Inline function 'kotlin.collections.all' call
      var tmp_4;
      if (isInterface(subtypes, Collection)) {
        tmp_4 = subtypes.y();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$7 = true;
        break $l$block_4;
      }
      var tmp0_iterator_2 = subtypes.u();
      while (tmp0_iterator_2.h1()) {
        var element_1 = tmp0_iterator_2.j1();
        // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
        var tmp_5 = element_1.type;
        if (!isInterface(tmp_5, PrimitiveType)) {
          tmp$ret$7 = false;
          break $l$block_4;
        }
      }
      tmp$ret$7 = true;
    }
    if (tmp$ret$7) {
      tmp = SimpleTypeModelStdLib_getInstance().String;
    } else {
      var tmp$ret$9;
      $l$block_6: {
        // Inline function 'kotlin.collections.all' call
        var tmp_6;
        if (isInterface(subtypes, Collection)) {
          tmp_6 = subtypes.y();
        } else {
          tmp_6 = false;
        }
        if (tmp_6) {
          tmp$ret$9 = true;
          break $l$block_6;
        }
        var tmp0_iterator_3 = subtypes.u();
        while (tmp0_iterator_3.h1()) {
          var element_2 = tmp0_iterator_3.j1();
          // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
          var tmp_7 = element_2.type;
          if (!isInterface(tmp_7, DataType)) {
            tmp$ret$9 = false;
            break $l$block_6;
          }
        }
        tmp$ret$9 = true;
      }
      if (tmp$ret$9) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
        var tmp0_iterator_4 = subtypes.u();
        while (tmp0_iterator_4.h1()) {
          var item_0 = tmp0_iterator_4.j1();
          // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
          tmp0_mapTo_0.e1(item_0);
        }
        tmp = protoOf(GrammarTypeNamespaceAbstract).createUnnamedSuperTypeType.call($this, tmp0_mapTo_0).instance();
      } else {
        var tmp$ret$14;
        $l$block_8: {
          // Inline function 'kotlin.collections.all' call
          var tmp_8;
          if (isInterface(subtypes, Collection)) {
            tmp_8 = subtypes.y();
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            tmp$ret$14 = true;
            break $l$block_8;
          }
          var tmp0_iterator_5 = subtypes.u();
          while (tmp0_iterator_5.h1()) {
            var element_3 = tmp0_iterator_5.j1();
            // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
            if (!equals(element_3.type, SimpleTypeModelStdLib_getInstance().List)) {
              tmp$ret$14 = false;
              break $l$block_8;
            }
          }
          tmp$ret$14 = true;
        }
        if (tmp$ret$14) {
          var itemType = SimpleTypeModelStdLib_getInstance().AnyType.instance();
          var choiceType = SimpleTypeModelStdLib_getInstance().List.instance(listOf(itemType));
          tmp = choiceType;
        } else {
          var tmp$ret$16;
          $l$block_10: {
            // Inline function 'kotlin.collections.all' call
            var tmp_9;
            if (isInterface(subtypes, Collection)) {
              tmp_9 = subtypes.y();
            } else {
              tmp_9 = false;
            }
            if (tmp_9) {
              tmp$ret$16 = true;
              break $l$block_10;
            }
            var tmp0_iterator_6 = subtypes.u();
            while (tmp0_iterator_6.h1()) {
              var element_4 = tmp0_iterator_6.j1();
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
              var tmp_10 = element_4.type;
              if (!isInterface(tmp_10, TupleType)) {
                tmp$ret$16 = false;
                break $l$block_10;
              }
            }
            tmp$ret$16 = true;
          }
          if (tmp$ret$16) {
            var tmp_11;
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
            var tmp0_iterator_7 = subtypes.u();
            while (tmp0_iterator_7.h1()) {
              var item_1 = tmp0_iterator_7.j1();
              var tmp$ret$21;
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
              // Inline function 'kotlin.collections.map' call
              var tmp_12 = item_1.type;
              var tmp0_map_0 = (isInterface(tmp_12, TupleType) ? tmp_12 : THROW_CCE()).property.k3();
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(tmp0_map_0, 10));
              var tmp0_iterator_8 = tmp0_map_0.u();
              while (tmp0_iterator_8.h1()) {
                var item_2 = tmp0_iterator_8.j1();
                var tmp$ret$18;
                // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>.<anonymous>' call
                tmp$ret$18 = new Pair(item_2.name, item_2);
                tmp0_mapTo_2.e1(tmp$ret$18);
              }
              tmp$ret$21 = toSet(tmp0_mapTo_2);
              tmp0_mapTo_1.e1(tmp$ret$21);
            }
            if (1 === toSet(tmp0_mapTo_1).o()) {
              var t = first_0(subtypes);
              var tmp_13;
              var tmp_14;
              var tmp_15 = t.type;
              if (isInterface(tmp_15, TupleType)) {
                var tmp_16 = t.type;
                tmp_14 = (isInterface(tmp_16, TupleType) ? tmp_16 : THROW_CCE()).properties.y();
              } else {
                tmp_14 = false;
              }
              if (tmp_14) {
                tmp_13 = SimpleTypeModelStdLib_getInstance().NothingType.instance();
              } else {
                tmp_13 = t;
              }
              tmp_11 = tmp_13;
            } else {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_3 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
              var tmp0_iterator_9 = subtypes.u();
              while (tmp0_iterator_9.h1()) {
                var item_3 = tmp0_iterator_9.j1();
                // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
                tmp0_mapTo_3.e1(item_3);
              }
              tmp_11 = protoOf(GrammarTypeNamespaceAbstract).createUnnamedSuperTypeType.call($this, tmp0_mapTo_3).instance();
            }
            tmp = tmp_11;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_4 = ArrayList.f4(collectionSizeOrDefault(subtypes, 10));
            var tmp0_iterator_10 = subtypes.u();
            while (tmp0_iterator_10.h1()) {
              var item_4 = tmp0_iterator_10.j1();
              // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRuleItem.<anonymous>' call
              tmp0_mapTo_4.e1(item_4);
            }
            tmp = protoOf(GrammarTypeNamespaceAbstract).createUnnamedSuperTypeType.call($this, tmp0_mapTo_4).instance();
          }
        }
      }
    }
  }
  return tmp;
}
function createPropertyDeclaration($this, et, ruleItem, childIndex) {
  if (!isInterface(ruleItem, EmptyRule)) {
    if (!isInterface(ruleItem, Terminal)) {
      if (isInterface(ruleItem, Embedded)) {
        createPropertyDeclarationForEmbedded($this, et, ruleItem, childIndex);
      } else {
        if (isInterface(ruleItem, NonTerminal)) {
          var refRule = ruleItem.referencedRule(_get_grammar__y8y3sm($this));
          createPropertyDeclarationForReferencedRule($this, refRule, et, ruleItem, childIndex);
        } else {
          if (isInterface(ruleItem, Concatenation)) {
            // Inline function 'kotlin.TODO' call
            throw NotImplementedError.eg('An operation is not implemented: Concatenation');
          } else {
            if (isInterface(ruleItem, Choice)) {
              var tu = typeForRuleItem($this, ruleItem, true);
              var tmp1_subject = tu.type;
              if (!equals(tmp1_subject, SimpleTypeModelStdLib_getInstance().NothingType)) {
                var n = propertyNameFor($this, et, ruleItem, tu.type);
                createUniquePropertyDeclaration($this, et, n, tu, childIndex);
              }
            } else {
              if (isInterface(ruleItem, OptionalItem)) {
                var t = typeForRuleItem($this, ruleItem, true);
                if (!equals(t.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
                  createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem.item, t.type), t, childIndex);
                }
              } else {
                if (isInterface(ruleItem, SimpleList)) {
                  var t_0 = typeForRuleItem($this, ruleItem, true);
                  if (!equals(t_0.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
                    createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem.item, t_0.type), t_0, childIndex);
                  }
                } else {
                  if (isInterface(ruleItem, SeparatedList)) {
                    var t_1 = typeForRuleItem($this, ruleItem, true);
                    if (!equals(t_1.type, SimpleTypeModelStdLib_getInstance().NothingType)) {
                      createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem.item, t_1.type), t_1, childIndex);
                    }
                  } else {
                    if (isInterface(ruleItem, Group)) {
                      var gt = typeForGroup($this, ruleItem, true);
                      var tmp2_subject = gt.type;
                      if (!equals(tmp2_subject, SimpleTypeModelStdLib_getInstance().NothingType)) {
                        var content = ruleItem.groupedContent;
                        var tmp;
                        if (isInterface(content, Choice)) {
                          tmp = propertyNameFor($this, et, content, gt.type);
                        } else {
                          tmp = propertyNameFor($this, et, ruleItem, gt.type);
                        }
                        var pName = tmp;
                        createUniquePropertyDeclaration($this, et, pName, gt, childIndex);
                      }
                    } else {
                      throw IllegalStateException.y1('Internal error, unhandled subtype of ConcatenationItem');
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function createPropertyDeclarationForReferencedRule($this, refRule, et, ruleItem, childIndex) {
  var rhs = refRule.rhs;
  if (isInterface(rhs, Terminal)) {
    createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, SimpleTypeModelStdLib_getInstance().String.type), SimpleTypeModelStdLib_getInstance().String, childIndex);
  } else {
    if (isInterface(rhs, Concatenation)) {
      var t = typeForRuleItem($this, ruleItem, true);
      createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, t.type), t, childIndex);
    } else {
      if (isInterface(rhs, ListOfItems)) {
        var tmp;
        if (isInterface(rhs, SimpleList)) {
          var tmp2_subject = rhs.item;
          var tmp_0;
          if (isInterface(tmp2_subject, Terminal)) {
            tmp_0 = true;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          if (isInterface(rhs, SeparatedList)) {
            var tmp3_subject = rhs.item;
            var tmp_1;
            if (isInterface(tmp3_subject, Terminal)) {
              tmp_1 = true;
            } else {
              tmp_1 = false;
            }
            tmp = tmp_1;
          } else {
            var tmp0_error = 'Internal Error: not handled ' + getKClassFromExpression(rhs).n9();
            throw IllegalStateException.y1(toString(tmp0_error));
          }
        }
        var ignore = tmp;
        if (!ignore) {
          var propType = typeForRuleItem($this, rhs, true);
          createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, propType.type), propType, childIndex);
        }
      } else {
        if (isInterface(rhs, Choice)) {
          var choiceType = typeForChoiceRule($this, rhs, refRule);
          var pName = propertyNameFor($this, et, ruleItem, choiceType.type);
          createUniquePropertyDeclaration($this, et, pName, choiceType, childIndex);
        } else {
          var propType_0 = typeForRuleItem($this, ruleItem, true);
          createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, propType_0.type), propType_0, childIndex);
        }
      }
    }
  }
}
function createPropertyDeclarationForEmbedded($this, et, ruleItem, childIndex) {
  var embTm = typeModelForEmbedded($this, ruleItem);
  var refRule = ruleItem.referencedRule(ensureNotNull(ruleItem.embeddedGrammarReference.resolved));
  var rhs = refRule.rhs;
  if (isInterface(rhs, Terminal)) {
    createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, SimpleTypeModelStdLib_getInstance().String.type), SimpleTypeModelStdLib_getInstance().String, childIndex);
  } else {
    if (isInterface(rhs, Concatenation)) {
      var t = typeForRuleItem(embTm, ruleItem, true);
      createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, t.type), t, childIndex);
    } else {
      if (isInterface(rhs, ListOfItems)) {
        var tmp;
        if (isInterface(rhs, SimpleList)) {
          var tmp2_subject = rhs.item;
          var tmp_0;
          if (isInterface(tmp2_subject, Terminal)) {
            tmp_0 = true;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          if (isInterface(rhs, SeparatedList)) {
            var tmp3_subject = rhs.item;
            var tmp_1;
            if (isInterface(tmp3_subject, Terminal)) {
              tmp_1 = true;
            } else {
              tmp_1 = false;
            }
            tmp = tmp_1;
          } else {
            var tmp0_error = 'Internal Error: not handled ' + getKClassFromExpression(rhs).n9();
            throw IllegalStateException.y1(toString(tmp0_error));
          }
        }
        var ignore = tmp;
        if (!ignore) {
          var propType = typeForRuleItem(embTm, rhs, true);
          createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, propType.type), propType, childIndex);
        }
      } else {
        if (isInterface(rhs, Choice)) {
          var choiceType = typeForChoiceRule(embTm, rhs, refRule);
          var pName = propertyNameFor($this, et, ruleItem, choiceType.type);
          createUniquePropertyDeclaration($this, et, pName, choiceType, childIndex);
        } else {
          var propType_0 = typeForRuleItem(embTm, ruleItem, true);
          createUniquePropertyDeclaration($this, et, propertyNameFor($this, et, ruleItem, propType_0.type), propType_0, childIndex);
        }
      }
    }
  }
}
function propertyNameFor($this, et, ruleItem, ruleItemType) {
  var tmp;
  if ($this.m19_1 == null) {
    var tmp_0;
    if (isInterface(ruleItem, EmptyRule)) {
      throw IllegalStateException.y1('should not happen');
    } else {
      if (isInterface(ruleItem, Terminal)) {
        var tmp_1;
        if (isInterface(ruleItemType, PrimitiveType)) {
          Companion_getInstance_11();
          tmp_1 = '$value';
        } else {
          if (isInterface(ruleItemType, CollectionType)) {
            Companion_getInstance_11();
            tmp_1 = '$list';
          } else {
            if (isInterface(ruleItemType, TupleType)) {
              Companion_getInstance_11();
              tmp_1 = '$tuple';
            } else {
              Companion_getInstance_11();
              tmp_1 = '$value';
            }
          }
        }
        tmp_0 = tmp_1;
      } else {
        if (isInterface(ruleItem, Embedded)) {
          tmp_0 = lower(ruleItem.embeddedGoalName);
        } else {
          if (isInterface(ruleItem, NonTerminal)) {
            tmp_0 = ruleItem.name;
          } else {
            if (isInterface(ruleItem, Group)) {
              Companion_getInstance_11();
              tmp_0 = '$group';
            } else {
              throw IllegalStateException.y1('Internal error, unhandled subtype of SimpleItem');
            }
          }
        }
      }
    }
    tmp = tmp_0;
  } else {
    tmp = ensureNotNull($this.m19_1).y19(_get_contextGrammar__5lii99($this), ruleItem, ruleItemType);
  }
  return tmp;
}
function createUniquePropertyDeclaration($this, et, name, type, childIndex) {
  var uniqueName = createUniquePropertyNameFor($this, et, name);
  var characteristics = setOf(PropertyCharacteristic_COMPOSITE_getInstance());
  return et.appendProperty(uniqueName, type, characteristics, childIndex);
}
function createUniquePropertyNameFor($this, et, name) {
  var key = new Pair(et, name);
  var nameCount = $this.l19_1.u3(key);
  var tmp;
  if (null == nameCount) {
    // Inline function 'kotlin.collections.set' call
    $this.l19_1.m3(key, 2);
    tmp = name;
  } else {
    // Inline function 'kotlin.collections.set' call
    var tmp1_set = $this.l19_1;
    var tmp2_set = nameCount + 1 | 0;
    tmp1_set.m3(key, tmp2_set);
    tmp = name + nameCount;
  }
  var uniqueName = tmp;
  return uniqueName;
}
function GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda(it) {
  return Unit_getInstance();
}
function GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_0(this$0, $rhs) {
  return function (et) {
    createPropertyDeclaration(this$0, et, $rhs, 0);
    return Unit_getInstance();
  };
}
function GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_1(this$0, $rhs) {
  return function (et) {
    createPropertyDeclaration(this$0, et, $rhs, 0);
    return Unit_getInstance();
  };
}
function GrammarTypeNamespaceFromGrammar$typeForGrammarRule$lambda_2(this$0, $rhs) {
  return function (et) {
    createPropertyDeclaration(this$0, et, $rhs, 0);
    return Unit_getInstance();
  };
}
function GrammarTypeNamespaceFromGrammar$elementTypeFor$lambda($items, this$0) {
  return function (newType) {
    var index = 0;
    var tmp0_iterator = $items.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.elementTypeFor.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp0_anonymous = checkIndexOverflow(tmp1);
      createPropertyDeclaration(this$0, newType, item, tmp0_anonymous);
    }
    return Unit_getInstance();
  };
}
function GrammarTypeNamespaceFromGrammar$typeForChoiceRule$lambda($subtypes) {
  return function (newType) {
    var tmp0_iterator = $subtypes.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.default.GrammarTypeNamespaceFromGrammar.typeForChoiceRule.<anonymous>.<anonymous>' call
      var tmp = element.type;
      (isInterface(tmp, DataType) ? tmp : THROW_CCE()).addSupertype(newType.name);
      newType.addSubtype(element.type.name);
    }
    return Unit_getInstance();
  };
}
function error($this, element, message) {
  var tmp0_safe_receiver = $this.k1a_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map) : false) ? tmp0_safe_receiver : THROW_CCE()).u3(element);
  }
  $this.l1a_1.error(tmp, message);
}
function handleProperty($this, scopeModel, element, property) {
  var elScope = $this.m1a_1.o1a();
  var v = property.value;
  if (null != v) {
    if (v instanceof AsmElementReference) {
      var typeNames = scopeModel.getReferredToTypeNameFor(element.typeName, property.name);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var tmp0_mapNotNullTo = ArrayList.i4();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = typeNames.u();
      while (tmp0_iterator.h1()) {
        var element_0 = tmp0_iterator.j1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'net.akehurst.language.agl.default.ReferenceResolverDefault.handleProperty.<anonymous>' call
        var tmp0_safe_receiver = elScope.findOrNull(v.reference, element_0);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        }
      }
      var referredList = tmp0_mapNotNullTo;
      if (1 < referredList.o()) {
        error($this, element, "Multiple options for '" + v.reference + "' as reference for '" + element.typeName + '.' + property.name + "'");
      } else {
        var referred = firstOrNull(referredList);
        if (null == referred) {
          error($this, element, "Cannot find '" + v.reference + "' as reference for '" + element.typeName + '.' + property.name + "'");
        } else {
          if (!(null == $this.j1a_1)) {
            var rel = $this.j1a_1(referred);
            if (null == rel) {
              error($this, element, "Asm does not contain element '" + v.reference + "' as reference for '" + element.typeName + '.' + property.name + "'");
            } else {
              v.value = rel;
            }
          }
        }
      }
    } else {
      error($this, element, "Cannot resolve reference property '" + element.typeName + '.' + property.name + "' because it is not defined as a reference");
    }
  }
}
function _get__locationMap__uz16lf($this) {
  var tmp = $this.a1b_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('_locationMap');
  }
}
function walkReferences($this, asm, locationMap, rootScope, resolve) {
  var tmp;
  if (resolve) {
    tmp = SemanticAnalyserDefault$walkReferences$lambda(asm);
  } else {
    tmp = null;
  }
  var resolveFunction = tmp;
  asm.traverseDepthFirst(new ReferenceResolverDefault($this.x1a_1, rootScope, resolveFunction, locationMap, $this.y1a_1));
}
function buildScope($this, asm, rootScope) {
  asm.traverseDepthFirst(new SemanticAnalyserDefault$buildScope$1(rootScope, $this));
}
function createScope($this, scope, el) {
  var tmp;
  if (ensureNotNull($this.z1a_1).isScopeDefinition(el.typeName)) {
    var refInParent = createReferenceLocalToScope(ensureNotNull($this.z1a_1), scope, el);
    var tmp_0;
    if (!(null == refInParent)) {
      var newScope = scope.createOrGetChildScope(refInParent, el.typeName, el.asmPath);
      tmp_0 = newScope;
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.get' call
      var tmp0_get = _get__locationMap__uz16lf($this);
      tmp$ret$0 = (isInterface(tmp0_get, Map) ? tmp0_get : THROW_CCE()).u3(el);
      $this.y1a_1.error(tmp$ret$0, 'Trying to create child scope but cannot create a reference for ' + el);
      tmp_0 = scope;
    }
    tmp = tmp_0;
  } else {
    tmp = scope;
  }
  return tmp;
}
function addToScope($this, scope, el) {
  if (ensureNotNull($this.z1a_1).shouldCreateReference(scope.forTypeName, el.typeName)) {
    var scopeLocalReference = createReferenceLocalToScope(ensureNotNull($this.z1a_1), scope, el);
    if (!(null == scopeLocalReference)) {
      var contextRef = el.asmPath;
      scope.addToScope(scopeLocalReference, el.typeName, contextRef);
    } else {
      var tmp$ret$0;
      // Inline function 'kotlin.collections.get' call
      var tmp0_get = _get__locationMap__uz16lf($this);
      tmp$ret$0 = (isInterface(tmp0_get, Map) ? tmp0_get : THROW_CCE()).u3(el);
      $this.y1a_1.error(tmp$ret$0, "Cannot create a local reference in '" + scope + "' for " + el);
    }
  }
}
function SemanticAnalyserDefault$walkReferences$lambda($asm) {
  return function (ref) {
    return $asm.elementIndex.u3(ref);
  };
}
var Companion_instance_10;
function Companion_getInstance_12() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function SyntaxAnalyserDefault$embeddedSyntaxAnalyser$lambda($typeModel, this$0) {
  return function (embGramName) {
    return new SyntaxAnalyserDefault(embGramName, $typeModel, this$0.scopeModel);
  };
}
function lower(_this__u8e3s4) {
  var tmp;
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.toUpperCase() === _this__u8e3s4) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = _this__u8e3s4.toLowerCase();
  } else {
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      var tmp$ret$8;
      // Inline function 'net.akehurst.language.agl.default.lower.<anonymous>' call
      var tmp0_anonymous = charSequenceGet(_this__u8e3s4, 0);
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$8 = toString_0(tmp0_anonymous).toLowerCase();
      var tmp_1 = toString(tmp$ret$8);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = tmp_1 + _this__u8e3s4.substring(1);
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function formatAny($this, o) {
  var tmp;
  if (o == null) {
    tmp = '';
  } else {
    if (o instanceof AsmElementSimple) {
      tmp = $this.y1b(o, $this.x1b_1);
    } else {
      if (!(o == null) ? isInterface(o, List) : false) {
        tmp = joinToString(o, '', VOID, VOID, VOID, VOID, FormatterSimple$formatAny$lambda($this));
      } else {
        var tmp0_error = "Internal Error: type '" + getKClassFromExpression(o).n9() + "' not supported";
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
  }
  return tmp;
}
function FormatterSimple$formatAny$lambda(this$0) {
  return function (it) {
    return formatAny(this$0, it);
  };
}
function FormatterSimple$format$lambda(it) {
  return it;
}
function FormatterSimple$execute$lambda($el, this$0, $model) {
  return function (it) {
    var tmp0_subject = it.typeName;
    var tmp;
    switch (tmp0_subject) {
      case 'Text':
        tmp = it.getPropertyAsString('raw_text');
        break;
      case 'TemplateExpressionSimple':
        var id = substringAfter(it.getPropertyAsString('dollar_identifier'), '$');
        var pv = $el.getProperty(id);
        var tmp1_subject = pv;
        var tmp_0;
        if (typeof tmp1_subject === 'string') {
          tmp_0 = pv;
        } else {
          if (tmp1_subject instanceof AsmElementSimple) {
            tmp_0 = this$0.y1b(pv, $model);
          } else {
            var tmp0_error = 'property ' + toString(pv) + ' not handled';
            throw IllegalStateException.y1(toString(tmp0_error));
          }
        }

        tmp = tmp_0;
        break;
      case 'TemplateExpressionEmbedded':
        throw NotImplementedError.eg();
      default:
        var tmp1_error = 'Element type ' + it.typeName + ' not handled';
        throw IllegalStateException.y1(toString(tmp1_error));
    }
    return tmp;
  };
}
function createRules($this) {
  var b = new GrammarBuilderDefault(new NamespaceDefault('net.akehurst.language.agl'), 'AglFormat');
  b.skip('WHITESPACE', true).concatenation([b.terminalPattern('\\s+')]);
  b.skip('MULTI_LINE_COMMENT', true).concatenation([b.terminalPattern('/\\*[^*]*\\*+(?:[^*/][^*]*\\*+)*/')]);
  b.skip('SINGLE_LINE_COMMENT', true).concatenation([b.terminalPattern('//[^\\n\\r]*')]);
  b.rule('unit').concatenation([b.nonTerminal('ruleList')]);
  b.rule('ruleList').multi(0, -1, b.nonTerminal('formatRule'));
  b.rule('formatRule').concatenation([b.nonTerminal('typeReference'), b.terminalLiteral('->'), b.nonTerminal('formatExpression')]);
  b.rule('formatExpression').choiceLongestFromConcatenationItem([b.nonTerminal('stringExpression'), b.nonTerminal('whenExpression')]);
  b.rule('whenExpression').concatenation([b.terminalLiteral('when'), b.terminalLiteral('{'), b.nonTerminal('whenOptionList'), b.terminalLiteral('}')]);
  b.rule('whenOptionList').multi(0, -1, b.nonTerminal('whenOption'));
  b.rule('whenOption').concatenation([b.nonTerminal('expression'), b.terminalLiteral('->'), b.nonTerminal('formatExpression')]);
  b.rule('stringExpression').choiceLongestFromConcatenationItem([b.nonTerminal('literalString'), b.nonTerminal('templateString')]);
  b.rule('literalString').concatenation([b.nonTerminal('LITERAL_STRING')]);
  b.rule('templateString').concatenation([b.terminalLiteral('"'), b.nonTerminal('templateContentList'), b.terminalLiteral('"')]);
  b.rule('templateContentList').multi(0, -1, b.nonTerminal('templateContent'));
  b.rule('templateContent').choiceLongestFromConcatenationItem([b.nonTerminal('text'), b.nonTerminal('templateExpression')]);
  b.rule('text').concatenation([b.nonTerminal('RAW_TEXT')]);
  b.rule('templateExpression').choiceLongestFromConcatenationItem([b.nonTerminal('templateExpressionSimple'), b.nonTerminal('templateExpressionEmbedded')]);
  b.rule('templateExpressionSimple').concatenation([b.nonTerminal('DOLLAR_IDENTIFIER')]);
  b.rule('templateExpressionEmbedded').concatenation([b.terminalLiteral('${'), b.nonTerminal('expression'), b.terminalLiteral('}')]);
  b.rule('expression').concatenation([b.nonTerminal('propertyReference')]);
  b.rule('propertyReference').concatenation([b.nonTerminal('IDENTIFIER')]);
  b.rule('typeReference').concatenation([b.nonTerminal('IDENTIFIER')]);
  b.leaf('DOLLAR_IDENTIFIER').concatenation([b.terminalPattern('[$][a-zA-Z_][a-zA-Z_0-9-]*')]);
  b.leaf('IDENTIFIER').concatenation([b.terminalPattern('[a-zA-Z_][a-zA-Z_0-9-]*')]);
  b.leaf('LITERAL_STRING').concatenation([b.terminalPattern("'([^'\\\\]|\\\\.)*'")]);
  b.leaf('RAW_TEXT').concatenation([b.terminalPattern('([^$"\\\\]|\\\\.)+')]);
  return b.grammar.grammarRule;
}
var AglFormatGrammar_instance;
function AglFormatGrammar_getInstance() {
  if (AglFormatGrammar_instance === VOID)
    new AglFormatGrammar();
  return AglFormatGrammar_instance;
}
function AglFormatterModelDefault$Companion$fromString$lambda$lambda($context) {
  return function ($this$semanticAnalysis) {
    $this$semanticAnalysis.context($context);
    return Unit_getInstance();
  };
}
function AglFormatterModelDefault$Companion$fromString$lambda($context) {
  return function ($this$options) {
    $this$options.semanticAnalysis(AglFormatterModelDefault$Companion$fromString$lambda$lambda($context));
    return Unit_getInstance();
  };
}
var Companion_instance_11;
function Companion_getInstance_13() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function AglFormatterModelDefault$rules$delegate$lambda(this$0) {
  return function () {
    var tmp0_subject = this$0.asm;
    var tmp;
    if (tmp0_subject == null) {
      tmp = emptyMap();
    } else {
      var tmp$ret$2;
      // Inline function 'kotlin.collections.associate' call
      var tmp_0 = this$0.asm.rootElements.p(0);
      var tmp0_associate = (tmp_0 instanceof AsmElementSimple ? tmp_0 : THROW_CCE()).getPropertyAsList('ruleList');
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp0_associate, 10)), 16);
      var tmp$ret$1;
      // Inline function 'kotlin.collections.associateTo' call
      var tmp0_associateTo = LinkedHashMap.o8(capacity);
      var tmp0_iterator = tmp0_associate.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.grammar.format.AglFormatterModelDefault.rules$delegate.<anonymous>.<anonymous>' call
        var tmp0_subject_0 = element;
        var tmp_1;
        if (tmp0_subject_0 instanceof AsmElementSimple) {
          var rule = new AglFormatterRuleDefault(this$0, element);
          tmp_1 = new Pair(rule.forTypeName, rule);
        } else {
          var tmp0_error = "Cannot map '" + toString(element) + "' to an AglFormatterRule";
          throw IllegalStateException.y1(toString(tmp0_error));
        }
        tmp$ret$0 = tmp_1;
        var tmp0_plusAssign = tmp$ret$0;
        tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
      }
      tmp$ret$1 = tmp0_associateTo;
      tmp$ret$2 = tmp$ret$1;
      tmp = tmp$ret$2;
    }
    return tmp;
  };
}
function rules$factory() {
  return getPropertyCallableRef('rules', 1, KProperty1, function (receiver) {
    return receiver.rules;
  }, null);
}
function createRules_0($this) {
  var b = new GrammarBuilderDefault(new NamespaceDefault('net.akehurst.language.agl'), 'AglGrammar');
  b.skip('WHITESPACE', true).concatenation([b.terminalPattern('\\s+')]);
  b.skip('MULTI_LINE_COMMENT', true).concatenation([b.terminalPattern('/\\*[^*]*\\*+([^*/][^*]*\\*+)*/')]);
  b.skip('SINGLE_LINE_COMMENT', true).concatenation([b.terminalPattern('//[^\\n\\r]*')]);
  b.rule('grammarDefinition').concatenation([b.nonTerminal('namespace'), b.nonTerminal('definitions')]);
  b.rule('definitions').multi(1, -1, b.nonTerminal('grammar'));
  b.rule('namespace').concatenation([b.terminalLiteral('namespace'), b.nonTerminal('qualifiedName')]);
  b.rule('grammar').concatenation([b.terminalLiteral('grammar'), b.nonTerminal('IDENTIFIER'), b.nonTerminal('extendsOpt'), b.terminalLiteral('{'), b.nonTerminal('options'), b.nonTerminal('rules'), b.terminalLiteral('}')]);
  b.rule('options').multi(0, -1, b.nonTerminal('option'));
  b.rule('option').concatenation([b.terminalLiteral('@'), b.nonTerminal('IDENTIFIER'), b.terminalLiteral(':'), b.nonTerminal('value')]);
  b.rule('value').choiceLongestFromConcatenationItem([b.nonTerminal('IDENTIFIER'), b.nonTerminal('LITERAL')]);
  b.rule('extendsOpt').optional(b.nonTerminal('extends'));
  b.rule('extends').concatenation([b.terminalLiteral('extends'), b.nonTerminal('extendsList')]);
  b.rule('extendsList').separatedList(1, -1, b.terminalLiteral(','), b.nonTerminal('qualifiedName'));
  b.rule('rules').multi(1, -1, b.nonTerminal('rule'));
  b.rule('rule').choiceLongestFromConcatenationItem([b.nonTerminal('overrideRule'), b.nonTerminal('grammarRule'), b.nonTerminal('preferenceRule')]);
  b.rule('grammarRule').concatenation([b.nonTerminal('ruleTypeLabels'), b.nonTerminal('IDENTIFIER'), b.terminalLiteral('='), b.nonTerminal('rhs'), b.terminalLiteral(';')]);
  b.rule('overrideRule').concatenation([b.terminalLiteral('override'), b.nonTerminal('ruleTypeLabels'), b.nonTerminal('IDENTIFIER'), b.nonTerminal('overrideOperator'), b.nonTerminal('rhs'), b.terminalLiteral(';')]);
  b.rule('overrideOperator').choiceLongestFromConcatenationItem([b.terminalLiteral('='), b.terminalLiteral('+=|')]);
  b.rule('ruleTypeLabels').concatenation([b.nonTerminal('isSkip'), b.nonTerminal('isLeaf')]);
  b.rule('isSkip').optional(b.terminalLiteral('skip'));
  b.rule('isLeaf').optional(b.terminalLiteral('leaf'));
  b.rule('rhs').choiceLongestFromConcatenationItem([b.nonTerminal('empty'), b.nonTerminal('concatenation'), b.nonTerminal('choice')]);
  b.rule('empty').empty();
  b.rule('choice').choiceLongestFromConcatenationItem([b.nonTerminal('ambiguousChoice'), b.nonTerminal('priorityChoice'), b.nonTerminal('simpleChoice')]);
  b.rule('ambiguousChoice').separatedList(2, -1, b.terminalLiteral('||'), b.nonTerminal('concatenation'));
  b.rule('priorityChoice').separatedList(2, -1, b.terminalLiteral('<'), b.nonTerminal('concatenation'));
  b.rule('simpleChoice').separatedList(2, -1, b.terminalLiteral('|'), b.nonTerminal('concatenation'));
  b.rule('concatenation').multi(1, -1, b.nonTerminal('concatenationItem'));
  b.rule('concatenationItem').choiceLongestFromConcatenationItem([b.nonTerminal('simpleItemOrGroup'), b.nonTerminal('listOfItems')]);
  b.rule('simpleItemOrGroup').choiceLongestFromConcatenationItem([b.nonTerminal('simpleItem'), b.nonTerminal('group')]);
  b.rule('simpleItem').choiceLongestFromConcatenationItem([b.nonTerminal('terminal'), b.nonTerminal('nonTerminal'), b.nonTerminal('embedded')]);
  b.rule('listOfItems').choiceLongestFromConcatenationItem([b.nonTerminal('simpleList'), b.nonTerminal('separatedList')]);
  b.rule('multiplicity').choiceLongestFromConcatenationItem([b.terminalLiteral('*'), b.terminalLiteral('+'), b.terminalLiteral('?'), b.nonTerminal('range')]);
  b.rule('range').choiceLongestFromConcatenationItem([b.nonTerminal('rangeUnBraced'), b.nonTerminal('rangeBraced')]);
  b.rule('rangeUnBraced').concatenation([b.nonTerminal('POSITIVE_INTEGER'), b.nonTerminal('rangeMaxOpt')]);
  b.rule('rangeBraced').concatenation([b.terminalLiteral('{'), b.nonTerminal('POSITIVE_INTEGER'), b.nonTerminal('rangeMaxOpt'), b.terminalLiteral('}')]);
  b.rule('rangeMaxOpt').optional(b.nonTerminal('rangeMax'));
  b.rule('rangeMax').choiceLongestFromConcatenationItem([b.nonTerminal('rangeMaxUnbounded'), b.nonTerminal('rangeMaxBounded')]);
  b.rule('rangeMaxUnbounded').concatenation([b.terminalLiteral('+')]);
  b.rule('rangeMaxBounded').concatenation([b.terminalLiteral('..'), b.nonTerminal('POSITIVE_INTEGER_GT_ZERO')]);
  b.rule('simpleList').concatenation([b.nonTerminal('simpleItemOrGroup'), b.nonTerminal('multiplicity')]);
  b.rule('separatedList').concatenation([b.terminalLiteral('['), b.nonTerminal('simpleItemOrGroup'), b.terminalLiteral('/'), b.nonTerminal('simpleItemOrGroup'), b.terminalLiteral(']'), b.nonTerminal('multiplicity')]);
  b.rule('group').concatenation([b.terminalLiteral('('), b.nonTerminal('groupedContent'), b.terminalLiteral(')')]);
  b.rule('groupedContent').choiceLongestFromConcatenationItem([b.nonTerminal('concatenation'), b.nonTerminal('choice')]);
  b.rule('nonTerminal').concatenation([b.nonTerminal('IDENTIFIER')]);
  b.rule('embedded').concatenation([b.nonTerminal('qualifiedName'), b.terminalLiteral('::'), b.nonTerminal('nonTerminal')]);
  b.rule('qualifiedName').separatedList(1, -1, b.terminalLiteral('.'), b.nonTerminal('IDENTIFIER'));
  b.rule('terminal').choiceLongestFromConcatenationItem([b.nonTerminal('LITERAL'), b.nonTerminal('PATTERN')]);
  b.leaf('LITERAL').concatenation([b.terminalPattern("'([^'\\\\]|\\\\.)+'")]);
  b.leaf('PATTERN').concatenation([b.terminalPattern('"([^"\\\\]|\\\\.)+"')]);
  b.leaf('IDENTIFIER').concatenation([b.terminalPattern('[a-zA-Z_][a-zA-Z_0-9-]*')]);
  b.leaf('POSITIVE_INTEGER').concatenation([b.terminalPattern('[0-9]+')]);
  b.leaf('POSITIVE_INTEGER_GT_ZERO').concatenation([b.terminalPattern('[1-9][0-9]*')]);
  b.rule('preferenceRule').concatenation([b.terminalLiteral('preference'), b.nonTerminal('simpleItem'), b.terminalLiteral('{'), b.nonTerminal('preferenceOptionList'), b.terminalLiteral('}')]);
  b.rule('preferenceOptionList').multi(1, -1, b.nonTerminal('preferenceOption'));
  b.rule('preferenceOption').concatenation([b.nonTerminal('nonTerminal'), b.nonTerminal('choiceNumber'), b.terminalLiteral('on'), b.nonTerminal('terminalList'), b.nonTerminal('associativity')]);
  b.rule('choiceNumber').optional(b.nonTerminal('POSITIVE_INTEGER'));
  b.rule('terminalList').separatedList(1, -1, b.terminalLiteral(','), b.nonTerminal('simpleItem'));
  b.rule('associativity').choiceLongestFromConcatenationItem([b.terminalLiteral('left'), b.terminalLiteral('right')]);
  return b.grammar.grammarRule;
}
var AglGrammarGrammar_instance;
function AglGrammarGrammar_getInstance() {
  if (AglGrammarGrammar_instance === VOID)
    new AglGrammarGrammar();
  return AglGrammarGrammar_instance;
}
var Companion_instance_12;
function Companion_getInstance_14() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function issueWarn($this, item, message, data) {
  var tmp0_safe_receiver = $this.t1e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map) : false) ? tmp0_safe_receiver : THROW_CCE()).u3(item);
  }
  var location = tmp;
  $this.s1e_1.warn(location, message, data);
}
function issueError($this, item, message, data) {
  var tmp0_safe_receiver = $this.t1e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.get' call
    tmp = ((!(tmp0_safe_receiver == null) ? isInterface(tmp0_safe_receiver, Map) : false) ? tmp0_safe_receiver : THROW_CCE()).u3(item);
  }
  var location = tmp;
  $this.s1e_1.error(location, message, data);
}
function checkGrammar($this, grammarList, automatonKind) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = grammarList.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkGrammar.<anonymous>' call
    checkExtendsExist($this, element.extends);
    analyseGrammar($this, element);
    checkRuleUsage($this, element);
    if ($this.s1e_1.errors.y() ? $this.u1e_1 : false) {
      checkForAmbiguities($this, element, automatonKind);
    }
  }
}
function checkExtendsExist($this, refs) {
  var tmp0_iterator = refs.u();
  while (tmp0_iterator.h1()) {
    var it = tmp0_iterator.j1();
    checkGrammarExists($this, it);
  }
}
function checkGrammarExists($this, ref) {
  var g = $this.languageRegistry.findGrammarOrNull(ref.localNamespace, ref.nameOrQName);
  if (null == g) {
    issueError($this, ref, "Grammar '" + ref.nameOrQName + "' not found", null);
  } else {
    ref.resolveAs(g);
  }
}
function checkRuleUsage($this, grammar) {
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = ensureNotNull($this.v1e_1.u3(grammar)).l3().u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkRuleUsage.<anonymous>' call
    if (element.p3() !== true) {
      issueWarn($this, element.o3(), "Grammar Rule '" + element.o3().name + "' is not used.", null);
    }
  }
}
function analyseGrammar($this, grammar) {
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.v1e_1;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var tmp1_set = LinkedHashMap.n8();
  tmp0_set.m3(grammar, tmp1_set);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = grammar.grammarRule.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyseGrammar.<anonymous>' call
    if (ensureNotNull($this.v1e_1.u3(grammar)).r3(element)) {
      issueError($this, element, "More than one rule named '" + element.name + "' found in grammar '" + grammar.name + "'", null);
    } else if (element.isSkip) {
      // Inline function 'kotlin.collections.set' call
      ensureNotNull($this.v1e_1.u3(grammar)).m3(element, true);
    } else {
      // Inline function 'kotlin.collections.set' call
      ensureNotNull($this.v1e_1.u3(grammar)).m3(element, false);
    }
  }
  // Inline function 'kotlin.collections.set' call
  var tmp3_set = ensureNotNull($this.v1e_1.u3(grammar));
  var tmp4_set = grammar.grammarRule.p(0);
  tmp3_set.m3(tmp4_set, true);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = grammar.grammarRule.u();
  while (tmp0_iterator_0.h1()) {
    var element_0 = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyseGrammar.<anonymous>' call
    var rhs = element_0.rhs;
    analyseRuleItem($this, grammar, rhs);
  }
}
function analyseRuleItem($this, grammar, rhs) {
  if (!isInterface(rhs, EmptyRule)) {
    if (!isInterface(rhs, Terminal)) {
      if (isInterface(rhs, Embedded)) {
        checkGrammarExists($this, rhs.embeddedGrammarReference);
      } else {
        if (isInterface(rhs, Concatenation)) {
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator = rhs.items.u();
          while (tmp0_iterator.h1()) {
            var element = tmp0_iterator.j1();
            // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyseRuleItem.<anonymous>' call
            analyseRuleItem($this, grammar, element);
          }
        } else {
          if (isInterface(rhs, Choice)) {
            // Inline function 'kotlin.collections.forEach' call
            var tmp0_iterator_0 = rhs.alternative.u();
            while (tmp0_iterator_0.h1()) {
              var element_0 = tmp0_iterator_0.j1();
              // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyseRuleItem.<anonymous>' call
              analyseRuleItem($this, grammar, element_0);
            }
          } else {
            if (isInterface(rhs, Group)) {
              analyseRuleItem($this, grammar, rhs.groupedContent);
            } else {
              if (isInterface(rhs, OptionalItem)) {
                analyseRuleItem($this, grammar, rhs.item);
              } else {
                if (isInterface(rhs, SimpleList)) {
                  analyseRuleItem($this, grammar, rhs.item);
                } else {
                  if (isInterface(rhs, SeparatedList)) {
                    analyseRuleItem($this, grammar, rhs.item);
                    analyseRuleItem($this, grammar, rhs.separator);
                  } else {
                    if (isInterface(rhs, NonTerminal)) {
                      var all = grammar.findAllNonTerminalRule(rhs.name);
                      if (all.y()) {
                        issueError($this, rhs, "GrammarRule '" + rhs.name + "' not found in grammar '" + grammar.name + "'", null);
                      } else if (all.o() > 1) {
                        // Inline function 'kotlin.collections.set' call
                        var tmp2_set = ensureNotNull($this.v1e_1.u3(grammar));
                        var tmp3_set = first_0(all);
                        tmp2_set.m3(tmp3_set, true);
                        issueError($this, rhs, "More than one rule named '" + rhs.name + "' found in grammar '" + grammar.name + "'", null);
                        // Inline function 'kotlin.collections.forEach' call
                        var tmp0_iterator_1 = all.u();
                        while (tmp0_iterator_1.h1()) {
                          var element_1 = tmp0_iterator_1.j1();
                          // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.analyseRuleItem.<anonymous>' call
                          if (equals(element_1.grammar, grammar)) {
                            issueError($this, element_1, "More than one rule named '" + rhs.name + "' found in grammar '" + grammar.name + "'", null);
                          } else {
                            issueError($this, element_1, "More than one rule named '" + rhs.name + "' found in grammar '" + grammar.name + "', you need to 'override' to resolve", null);
                          }
                        }
                      } else {
                        // Inline function 'kotlin.collections.set' call
                        var tmp4_set = ensureNotNull($this.v1e_1.u3(grammar));
                        var tmp5_set = first_0(all);
                        tmp4_set.m3(tmp5_set, true);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function checkForAmbiguities($this, grammar, automatonKind) {
  var conv = new ConverterToRuntimeRules(grammar);
  var rrs = conv.h1f();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var tmp0_iterator = grammar.grammarRule.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>' call
      if (!element.isSkip) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    throw NoSuchElementException.ad('Collection contains no element matching the predicate.');
  }
  var goalRuleName = tmp$ret$1.name;
  var automaton = rrs.i1f(goalRuleName, automatonKind);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = automaton.yv().u();
  while (tmp0_iterator_0.h1()) {
    var element_0 = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>' call
    var trans = element_0.az_1.v15();
    if (trans.o() > 1) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = trans.u();
      while (tmp0_iterator_1.h1()) {
        var element_1 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var tmp0_filterTo = ArrayList.i4();
        var tmp0_iterator_2 = trans.u();
        while (tmp0_iterator_2.h1()) {
          var element_2 = tmp0_iterator_2.j1();
          // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          switch (element_2.g15_1.bc_1) {
            case 2:
            case 4:
              var tmp_0;
              if (equals(element_1.h15_1, element_2.h15_1) ? element_1.f15_1.equals(element_2.f15_1) : false) {
                // Inline function 'kotlin.collections.isNotEmpty' call
                tmp_0 = !intersect(element_1.uf(), element_2.uf()).y();
              } else {
                tmp_0 = false;
              }

              tmp = tmp_0;
              break;
            case 3:
            case 0:
            case 1:
              var tmp_1;
              if (equals(element_1.h15_1, element_2.h15_1)) {
                // Inline function 'kotlin.collections.isNotEmpty' call
                tmp_1 = !intersect(element_1.uf(), element_2.uf()).y();
              } else {
                tmp_1 = false;
              }

              tmp = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          if (tmp) {
            tmp0_filterTo.e1(element_2);
          }
        }
        var same = tmp0_filterTo;
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_3 = same.u();
        while (tmp0_iterator_3.h1()) {
          var element_3 = tmp0_iterator_3.j1();
          // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>' call
          if (!(element_1 === element_3)) {
            // Inline function 'kotlin.collections.reduce' call
            // Inline function 'kotlin.collections.map' call
            var tmp0_map = element_1.h15_1;
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
            var tmp0_iterator_4 = tmp0_map.u();
            while (tmp0_iterator_4.h1()) {
              var item = tmp0_iterator_4.j1();
              var tmp$ret$7;
              // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              tmp$ret$7 = item.t11_1.q13();
              tmp0_mapTo.e1(tmp$ret$7);
            }
            var iterator = tmp0_mapTo.u();
            if (!iterator.h1())
              throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
            var accumulator = iterator.j1();
            while (iterator.h1()) {
              // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              var tmp2_anonymous = accumulator;
              var tmp3_anonymous = iterator.j1();
              accumulator = tmp2_anonymous.m17(tmp3_anonymous);
            }
            var lhg1 = accumulator;
            // Inline function 'kotlin.collections.reduce' call
            // Inline function 'kotlin.collections.map' call
            var tmp4_map = element_3.h15_1;
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp4_map, 10));
            var tmp0_iterator_5 = tmp4_map.u();
            while (tmp0_iterator_5.h1()) {
              var item_0 = tmp0_iterator_5.j1();
              var tmp$ret$12;
              // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              tmp$ret$12 = item_0.t11_1.q13();
              tmp0_mapTo_0.e1(tmp$ret$12);
            }
            var iterator_0 = tmp0_mapTo_0.u();
            if (!iterator_0.h1())
              throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
            var accumulator_0 = iterator_0.j1();
            while (iterator_0.h1()) {
              // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
              var tmp6_anonymous = accumulator_0;
              var tmp7_anonymous = iterator_0.j1();
              accumulator_0 = tmp6_anonymous.m17(tmp7_anonymous);
            }
            var lhg2 = accumulator_0;
            var lhi = lhg1.m17(lhg2);
            if (lhi.y10()) {
              var ori1 = conv.j1f(first_0(element_1.f15_1.lz()).mw_1, first_0(element_1.f15_1.lz()).nw_1);
              var ori2 = conv.j1f(first_0(element_3.f15_1.lz()).mw_1, first_0(element_3.f15_1.lz()).nw_1);
              var or2 = ori2 == null ? null : ori2.owningRule;
              // Inline function 'kotlin.collections.map' call
              var tmp8_map = lhi.b12();
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(tmp8_map, 10));
              var tmp0_iterator_6 = tmp8_map.u();
              while (tmp0_iterator_6.h1()) {
                var item_1 = tmp0_iterator_6.j1();
                var tmp$ret$17;
                // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSemanticAnalyser.checkForAmbiguities.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                tmp$ret$17 = item_1.mz();
                tmp0_mapTo_1.e1(tmp$ret$17);
              }
              var lhStr = tmp0_mapTo_1;
              var msg = 'Ambiguity on ' + lhStr + ' with ' + (or2 == null ? null : or2.name);
              issueWarn($this, ori1, msg, null);
            }
          }
        }
      }
    }
  }
}
function grammarDefinition($this, target, children, sentence) {
  var namespace = children.p(0);
  var tmp = children.p(1);
  var definitions = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  return definitions;
}
function definitions($this, target, children, sentence) {
  var definitions = isInterface(children, List) ? children : THROW_CCE();
  return definitions;
}
function namespace($this, target, children, sentence) {
  var tmp = children.p(1);
  var qualifiedName = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var ns = new NamespaceDefault(qualifiedName);
  // Inline function 'kotlin.collections.set' call
  $this.r1f_1.m3('namespace', ns);
  return ns;
}
function grammar($this, target, children, sentence) {
  var tmp = $this.r1f_1.u3('namespace');
  var namespace = (!(tmp == null) ? isInterface(tmp, Namespace) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(1);
  var name = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(2);
  var tmp0_elvis_lhs = (tmp_1 == null ? true : isInterface(tmp_1, List)) ? tmp_1 : THROW_CCE();
  var extends_0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  var tmp_2 = children.p(4);
  var options = (!(tmp_2 == null) ? isInterface(tmp_2, List) : false) ? tmp_2 : THROW_CCE();
  var tmp_3 = children.p(5);
  var rules = (!(tmp_3 == null) ? isInterface(tmp_3, List) : false) ? tmp_3 : THROW_CCE();
  var grmr = new GrammarDefault(namespace, name, options);
  grmr.extends.k1(extends_0);
  // Inline function 'kotlin.collections.set' call
  $this.r1f_1.m3('grammar', grmr);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = rules.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.grammar.<anonymous>' call
    var item = element(grmr);
    if (isInterface(item, OverrideRule)) {
      grmr.grammarRule.e1(item);
    } else {
      if (isInterface(item, GrammarRule)) {
        grmr.grammarRule.e1(item);
      } else {
        if (isInterface(item, PreferenceRule)) {
          grmr.preferenceRule.e1(item);
        } else {
          throw IllegalStateException.y1('Not handled');
        }
      }
    }
  }
  return grmr;
}
function options($this, target, children, sentence) {
  return isInterface(children, List) ? children : THROW_CCE();
}
function option($this, target, children, sentence) {
  var tmp = children.p(1);
  var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var value = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  return new GrammarOptionDefault(name, value);
}
function value_0($this, target, children, sentence) {
  var tmp;
  switch (target.alt.option) {
    case 0:
      var tmp_0 = children.p(0);
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
      break;
    case 1:
      // Inline function 'kotlin.let' call

      var tmp_1 = children.p(0);
      var tmp0_let = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE();
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.value.<anonymous>' call

      // Inline function 'kotlin.text.substring' call

      var tmp0_substring = tmp0_let.length - 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call

      tmp = tmp0_let.substring(1, tmp0_substring);
      break;
    default:
      throw IllegalStateException.y1('Unsupported choice');
  }
  return tmp;
}
function extendsOpt($this, target, children, sentence) {
  var tmp;
  if (null == children.p(0)) {
    tmp = emptyList();
  } else {
    var tmp_0 = children.p(0);
    tmp = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
  }
  return tmp;
}
function extends_0($this, target, children, sentence) {
  var tmp = children.p(1);
  return (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
}
function extendsList($this, target, children, sentence) {
  var tmp = $this.r1f_1.u3('namespace');
  var localNamespace = (!(tmp == null) ? isInterface(tmp, Namespace) : false) ? tmp : THROW_CCE();
  var extendNameList = isInterface(children, List) ? children : THROW_CCE();
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var sl = ListSeparatedArrayList.u1f(extendNameList);
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = sl.a11();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.extendsList.<anonymous>' call
    // Inline function 'kotlin.also' call
    var tmp0_also = new GrammarReferenceDefault(localNamespace, item);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.extendsList.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = $this.locationMap;
    var tmp1_set = sentence.v1f(target.node);
    tmp0_set.m3(tmp0_also, tmp1_set);
    tmp0_mapTo.e1(tmp0_also);
  }
  var extendedGrammars = tmp0_mapTo;
  return extendedGrammars;
}
function rules($this, target, children, sentence) {
  return isInterface(children, List) ? children : THROW_CCE();
}
function rule($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : THROW_CCE();
}
function grammarRule($this, target, children, sentence) {
  var tmp = children.p(0);
  var type = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var isSkip = type.w('skip');
  var isLeaf = type.w('leaf');
  var tmp_0 = children.p(1);
  var name = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(3);
  var rhs = (!(tmp_1 == null) ? isInterface(tmp_1, RuleItem) : false) ? tmp_1 : THROW_CCE();
  return AglGrammarSyntaxAnalyser$grammarRule$lambda(name, isSkip, isLeaf, rhs, $this, sentence, target);
}
function overrideRule($this, target, children, sentence) {
  var tmp = children.p(1);
  var type = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var isSkip = type.w('skip');
  var isLeaf = type.w('leaf');
  var tmp_0 = children.p(2);
  var identifier = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(3);
  var overrideOperator = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE();
  var tmp_2;
  switch (overrideOperator) {
    case '=':
      tmp_2 = OverrideKind_REPLACE_getInstance();
      break;
    case '+=|':
      tmp_2 = OverrideKind_APPEND_ALTERNATIVE_getInstance();
      break;
    default:
      var tmp0_error = 'overrideOperator ' + overrideOperator + ' not handled';
      throw IllegalStateException.y1(toString(tmp0_error));
  }
  var overrideKind = tmp_2;
  var tmp_3 = children.p(4);
  var rhs = (!(tmp_3 == null) ? isInterface(tmp_3, RuleItem) : false) ? tmp_3 : THROW_CCE();
  return AglGrammarSyntaxAnalyser$overrideRule$lambda(identifier, isSkip, isLeaf, overrideKind, rhs, $this, sentence, target);
}
function overrideOperator($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
}
function ruleTypeLabels($this, target, children, sentence) {
  return filterNotNull(isInterface(children, List) ? children : THROW_CCE());
}
function rhs($this, target, children, sentence) {
  var tmp = children.p(0);
  var rhs = (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
  var tmp_0;
  if (isInterface(rhs, Concatenation)) {
    tmp_0 = reduceConcatenation($this, rhs);
  } else {
    tmp_0 = rhs;
  }
  var rhs2 = tmp_0;
  return rhs2;
}
function empty($this, target, children, sentence) {
  return new EmptyRuleDefault();
}
function choice($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
}
function simpleChoice($this, target, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var simpleChoice = ListSeparatedArrayList.u1f(children);
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = simpleChoice.a11();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.simpleChoice.<anonymous>' call
    tmp$ret$1 = reduceConcatenation($this, item);
    tmp0_mapTo.e1(tmp$ret$1);
  }
  var alternative = tmp0_mapTo;
  return new ChoiceLongestDefault(alternative);
}
function priorityChoice($this, target, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var priorityChoice = ListSeparatedArrayList.u1f(children);
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = priorityChoice.a11();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.priorityChoice.<anonymous>' call
    tmp$ret$1 = reduceConcatenation($this, item);
    tmp0_mapTo.e1(tmp$ret$1);
  }
  var alternative = tmp0_mapTo;
  return new ChoicePriorityDefault(alternative);
}
function ambiguousChoice($this, target, children, sentence) {
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var ambiguousChoice = ListSeparatedArrayList.u1f(children);
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = ambiguousChoice.a11();
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.ambiguousChoice.<anonymous>' call
    tmp$ret$1 = reduceConcatenation($this, item);
    tmp0_mapTo.e1(tmp$ret$1);
  }
  var alternative = tmp0_mapTo;
  return new ChoiceAmbiguousDefault(alternative);
}
function concatenation($this, target, children, sentence) {
  var items = isInterface(children, List) ? children : THROW_CCE();
  return new ConcatenationDefault(items);
}
function concatenationItem($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
}
function simpleItemOrGroup($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
}
function simpleItem($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, SimpleItem) : false) ? tmp : THROW_CCE();
}
function listOfItems($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, ConcatenationItem) : false) ? tmp : THROW_CCE();
}
function multiplicity($this, target, children, sentence) {
  var m = children.p(0);
  var tmp;
  if (!(m == null) ? typeof m === 'string' : false) {
    var tmp_0;
    switch (m) {
      case '*':
        tmp_0 = new Pair(0, -1);
        break;
      case '+':
        tmp_0 = new Pair(1, -1);
        break;
      case '?':
        tmp_0 = new Pair(0, 1);
        break;
      default:
        throw IllegalStateException.y1('should not happen');
    }
    tmp = tmp_0;
  } else {
    if (m instanceof Pair) {
      tmp = m instanceof Pair ? m : THROW_CCE();
    } else {
      throw IllegalStateException.y1('should not happen');
    }
  }
  return tmp;
}
function range($this, target, children, sentence) {
  var tmp = children.p(0);
  return tmp instanceof Pair ? tmp : THROW_CCE();
}
function rangeUnBraced($this, target, children, sentence) {
  var tmp = children.p(0);
  var min = toInt((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
  var tmp_0;
  if (children.p(1) == null) {
    tmp_0 = min;
  } else {
    var tmp_1 = children.p(1);
    tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
  }
  var max = tmp_0;
  return new Pair(min, max);
}
function rangeBraced($this, target, children, sentence) {
  var tmp = children.p(1);
  var min = toInt((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
  var tmp_0;
  if (null == children.p(2)) {
    tmp_0 = min;
  } else {
    var tmp_1 = children.p(2);
    tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
  }
  var max = tmp_0;
  return new Pair(min, max);
}
function rangeMaxOpt($this, target, children, sentence) {
  var tmp = children.p(0);
  return (tmp == null ? true : typeof tmp === 'number') ? tmp : THROW_CCE();
}
function rangeMax($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
}
function rangeMaxUnbounded($this, target, children, sentence) {
  return -1;
}
function rangeMaxBounded($this, target, children, sentence) {
  var tmp = children.p(1);
  return toInt((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
}
function simpleList($this, target, children, sentence) {
  var tmp = children.p(1);
  var tmp0_container = tmp instanceof Pair ? tmp : THROW_CCE();
  var min = tmp0_container.ti();
  var max = tmp0_container.ui();
  var tmp_0 = children.p(0);
  var item = (!(tmp_0 == null) ? isInterface(tmp_0, RuleItem) : false) ? tmp_0 : THROW_CCE();
  return (min === 0 ? max === 1 : false) ? new OptionalItemDefault(item) : new SimpleListDefault(min, max, item);
}
function separatedList($this, target, children, sentence) {
  var tmp = children.p(5);
  var tmp0_container = tmp instanceof Pair ? tmp : THROW_CCE();
  var min = tmp0_container.ti();
  var max = tmp0_container.ui();
  var tmp_0 = children.p(3);
  var separator = (!(tmp_0 == null) ? isInterface(tmp_0, RuleItem) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(1);
  var item = (!(tmp_1 == null) ? isInterface(tmp_1, RuleItem) : false) ? tmp_1 : THROW_CCE();
  return new SeparatedListDefault(min, max, item, separator);
}
function group($this, target, children, sentence) {
  var tmp = children.p(1);
  var groupContent = (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
  var tmp_0;
  if (isInterface(groupContent, Choice)) {
    tmp_0 = groupContent;
  } else {
    if (isInterface(groupContent, Concatenation)) {
      var reduced = reduceConcatenation($this, groupContent);
      tmp_0 = new GroupDefault(reduced);
    } else {
      var tmp0_error = 'Internal Error: subtype of RuleItem not handled - ' + getKClassFromExpression(groupContent).n9();
      throw IllegalStateException.y1(toString(tmp0_error));
    }
  }
  return tmp_0;
}
function groupedContent($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? isInterface(tmp, RuleItem) : false) ? tmp : THROW_CCE();
}
function nonTerminal($this, target, children, sentence) {
  var tmp = children.p(0);
  var nonTerminalRef = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var nt = new NonTerminalDefault(nonTerminalRef);
  return nt;
}
function embedded($this, target, children, sentence) {
  var tmp = $this.r1f_1.u3('namespace');
  var namespace = (!(tmp == null) ? isInterface(tmp, Namespace) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(0);
  var embeddedGrammarStr = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(2);
  var embeddedStartRuleRef = (!(tmp_1 == null) ? isInterface(tmp_1, NonTerminal) : false) ? tmp_1 : THROW_CCE();
  var embeddedGrammarRef = new GrammarReferenceDefault(namespace, embeddedGrammarStr);
  return new EmbeddedDefault(embeddedStartRuleRef.name, embeddedGrammarRef);
}
function terminal($this, target, children, sentence) {
  var isPattern = target.alt.option === 0 ? false : true;
  var tmp = children.p(0);
  var mt = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  // Inline function 'kotlin.text.substring' call
  var tmp0_substring = mt.length - 1 | 0;
  // Inline function 'kotlin.js.asDynamic' call
  var escaped = mt.substring(1, tmp0_substring);
  return new TerminalDefault(escaped, isPattern);
}
function qualifiedName($this, target, children, sentence) {
  return joinToString(isInterface(children, List) ? children : THROW_CCE(), '');
}
function preferenceRule($this, target, children, sentence) {
  var tmp = children.p(1);
  var forItem = (!(tmp == null) ? isInterface(tmp, SimpleItem) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var optionList = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
  return AglGrammarSyntaxAnalyser$preferenceRule$lambda(forItem, optionList, $this, sentence, target);
}
function preferenceOption($this, target, children, arg) {
  var tmp = children.p(0);
  var item = (!(tmp == null) ? isInterface(tmp, NonTerminal) : false) ? tmp : THROW_CCE();
  var tmp_0;
  if (null == children.p(1)) {
    tmp_0 = 0;
  } else {
    var tmp_1 = children.p(1);
    if (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) {
      var tmp_2 = children.p(1);
      tmp_0 = toInt((!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : THROW_CCE());
    } else {
      var tmp_3 = children.p(1);
      tmp_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'number' : false) ? tmp_3 : THROW_CCE();
    }
  }
  var choiceNumber = tmp_0;
  var tmp_4 = children.p(3);
  var terminalList = (!(tmp_4 == null) ? isInterface(tmp_4, List) : false) ? tmp_4 : THROW_CCE();
  var tmp_5 = children.p(4);
  var assStr = (!(tmp_5 == null) ? typeof tmp_5 === 'string' : false) ? tmp_5 : THROW_CCE();
  var tmp_6;
  switch (assStr) {
    case 'left':
      tmp_6 = Associativity_LEFT_getInstance();
      break;
    case 'right':
      tmp_6 = Associativity_RIGHT_getInstance();
      break;
    default:
      var tmp0_error = "Internal Error: associativity value '" + assStr + "' not supported";
      throw IllegalStateException.y1(toString(tmp0_error));
  }
  var associativity = tmp_6;
  return new PreferenceOptionDefault(item, choiceNumber, terminalList, associativity);
}
function choiceNumber($this, target, children, sentence) {
  var tmp = children.p(0);
  var n = (tmp == null ? true : typeof tmp === 'string') ? tmp : THROW_CCE();
  return n == null ? null : toInt(n);
}
function associativity($this, target, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
}
function reduceConcatenation($this, concat) {
  var tmp;
  if (concat.items.o() === 1) {
    var tmp1_subject = concat.items.p(0);
    var tmp_0;
    if (isInterface(tmp1_subject, TangibleItem)) {
      tmp_0 = concat.items.p(0);
    } else {
      if (isInterface(tmp1_subject, OptionalItem)) {
        tmp_0 = concat.items.p(0);
      } else {
        if (isInterface(tmp1_subject, ListOfItems)) {
          tmp_0 = concat.items.p(0);
        } else {
          if (isInterface(tmp1_subject, Choice)) {
            tmp_0 = concat.items.p(0);
          } else {
            if (isInterface(tmp1_subject, Group)) {
              var tmp_1 = concat.items.p(0);
              var content = (isInterface(tmp_1, Group) ? tmp_1 : THROW_CCE()).groupedContent;
              var tmp_2;
              if (isInterface(content, Choice)) {
                tmp_2 = content;
              } else {
                tmp_2 = concat;
              }
              tmp_0 = tmp_2;
            } else {
              var tmp0_error = 'Internal Error: subtype of ConcatenationItem not handled - ' + getKClassFromExpression(concat.items.p(0)).n9();
              throw IllegalStateException.y1(toString(tmp0_error));
            }
          }
        }
      }
    }
    tmp = tmp_0;
  } else {
    tmp = concat;
  }
  return tmp;
}
function AglGrammarSyntaxAnalyser$grammarDefinition$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return grammarDefinition($boundThis, p0, p1, p2);
  };
  l.callableName = 'grammarDefinition';
  return l;
}
function AglGrammarSyntaxAnalyser$namespace$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return namespace($boundThis, p0, p1, p2);
  };
  l.callableName = 'namespace';
  return l;
}
function AglGrammarSyntaxAnalyser$definitions$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return definitions($boundThis, p0, p1, p2);
  };
  l.callableName = 'definitions';
  return l;
}
function AglGrammarSyntaxAnalyser$grammar$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return grammar($boundThis, p0, p1, p2);
  };
  l.callableName = 'grammar';
  return l;
}
function AglGrammarSyntaxAnalyser$options$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return options($boundThis, p0, p1, p2);
  };
  l.callableName = 'options';
  return l;
}
function AglGrammarSyntaxAnalyser$option$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return option($boundThis, p0, p1, p2);
  };
  l.callableName = 'option';
  return l;
}
function AglGrammarSyntaxAnalyser$value$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return value_0($boundThis, p0, p1, p2);
  };
  l.callableName = 'value';
  return l;
}
function AglGrammarSyntaxAnalyser$extendsOpt$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return extendsOpt($boundThis, p0, p1, p2);
  };
  l.callableName = 'extendsOpt';
  return l;
}
function AglGrammarSyntaxAnalyser$extends$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return extends_0($boundThis, p0, p1, p2);
  };
  l.callableName = 'extends';
  return l;
}
function AglGrammarSyntaxAnalyser$extendsList$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return extendsList($boundThis, p0, p1, p2);
  };
  l.callableName = 'extendsList';
  return l;
}
function AglGrammarSyntaxAnalyser$rules$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rules($boundThis, p0, p1, p2);
  };
  l.callableName = 'rules';
  return l;
}
function AglGrammarSyntaxAnalyser$rule$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rule($boundThis, p0, p1, p2);
  };
  l.callableName = 'rule';
  return l;
}
function AglGrammarSyntaxAnalyser$grammarRule$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return grammarRule($boundThis, p0, p1, p2);
  };
  l.callableName = 'grammarRule';
  return l;
}
function AglGrammarSyntaxAnalyser$overrideRule$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return overrideRule($boundThis, p0, p1, p2);
  };
  l.callableName = 'overrideRule';
  return l;
}
function AglGrammarSyntaxAnalyser$overrideOperator$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return overrideOperator($boundThis, p0, p1, p2);
  };
  l.callableName = 'overrideOperator';
  return l;
}
function AglGrammarSyntaxAnalyser$preferenceRule$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return preferenceRule($boundThis, p0, p1, p2);
  };
  l.callableName = 'preferenceRule';
  return l;
}
function AglGrammarSyntaxAnalyser$ruleTypeLabels$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return ruleTypeLabels($boundThis, p0, p1, p2);
  };
  l.callableName = 'ruleTypeLabels';
  return l;
}
function AglGrammarSyntaxAnalyser$rhs$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rhs($boundThis, p0, p1, p2);
  };
  l.callableName = 'rhs';
  return l;
}
function AglGrammarSyntaxAnalyser$empty$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return empty($boundThis, p0, p1, p2);
  };
  l.callableName = 'empty';
  return l;
}
function AglGrammarSyntaxAnalyser$choice$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return choice($boundThis, p0, p1, p2);
  };
  l.callableName = 'choice';
  return l;
}
function AglGrammarSyntaxAnalyser$simpleChoice$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return simpleChoice($boundThis, p0, p1, p2);
  };
  l.callableName = 'simpleChoice';
  return l;
}
function AglGrammarSyntaxAnalyser$priorityChoice$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return priorityChoice($boundThis, p0, p1, p2);
  };
  l.callableName = 'priorityChoice';
  return l;
}
function AglGrammarSyntaxAnalyser$ambiguousChoice$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return ambiguousChoice($boundThis, p0, p1, p2);
  };
  l.callableName = 'ambiguousChoice';
  return l;
}
function AglGrammarSyntaxAnalyser$concatenation$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return concatenation($boundThis, p0, p1, p2);
  };
  l.callableName = 'concatenation';
  return l;
}
function AglGrammarSyntaxAnalyser$concatenationItem$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return concatenationItem($boundThis, p0, p1, p2);
  };
  l.callableName = 'concatenationItem';
  return l;
}
function AglGrammarSyntaxAnalyser$simpleItemOrGroup$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return simpleItemOrGroup($boundThis, p0, p1, p2);
  };
  l.callableName = 'simpleItemOrGroup';
  return l;
}
function AglGrammarSyntaxAnalyser$simpleItem$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return simpleItem($boundThis, p0, p1, p2);
  };
  l.callableName = 'simpleItem';
  return l;
}
function AglGrammarSyntaxAnalyser$listOfItems$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return listOfItems($boundThis, p0, p1, p2);
  };
  l.callableName = 'listOfItems';
  return l;
}
function AglGrammarSyntaxAnalyser$multiplicity$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return multiplicity($boundThis, p0, p1, p2);
  };
  l.callableName = 'multiplicity';
  return l;
}
function AglGrammarSyntaxAnalyser$range$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return range($boundThis, p0, p1, p2);
  };
  l.callableName = 'range';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeUnBraced$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeUnBraced($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeUnBraced';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeBraced$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeBraced($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeBraced';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeMaxOpt$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeMaxOpt($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeMaxOpt';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeMax$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeMax($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeMax';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeMaxBounded$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeMaxBounded($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeMaxBounded';
  return l;
}
function AglGrammarSyntaxAnalyser$rangeMaxUnbounded$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rangeMaxUnbounded($boundThis, p0, p1, p2);
  };
  l.callableName = 'rangeMaxUnbounded';
  return l;
}
function AglGrammarSyntaxAnalyser$simpleList$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return simpleList($boundThis, p0, p1, p2);
  };
  l.callableName = 'simpleList';
  return l;
}
function AglGrammarSyntaxAnalyser$group$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return group($boundThis, p0, p1, p2);
  };
  l.callableName = 'group';
  return l;
}
function AglGrammarSyntaxAnalyser$groupedContent$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return groupedContent($boundThis, p0, p1, p2);
  };
  l.callableName = 'groupedContent';
  return l;
}
function AglGrammarSyntaxAnalyser$separatedList$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return separatedList($boundThis, p0, p1, p2);
  };
  l.callableName = 'separatedList';
  return l;
}
function AglGrammarSyntaxAnalyser$nonTerminal$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return nonTerminal($boundThis, p0, p1, p2);
  };
  l.callableName = 'nonTerminal';
  return l;
}
function AglGrammarSyntaxAnalyser$embedded$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return embedded($boundThis, p0, p1, p2);
  };
  l.callableName = 'embedded';
  return l;
}
function AglGrammarSyntaxAnalyser$terminal$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return terminal($boundThis, p0, p1, p2);
  };
  l.callableName = 'terminal';
  return l;
}
function AglGrammarSyntaxAnalyser$qualifiedName$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return qualifiedName($boundThis, p0, p1, p2);
  };
  l.callableName = 'qualifiedName';
  return l;
}
function AglGrammarSyntaxAnalyser$preferenceOption$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return preferenceOption($boundThis, p0, p1, p2);
  };
  l.callableName = 'preferenceOption';
  return l;
}
function AglGrammarSyntaxAnalyser$choiceNumber$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return choiceNumber($boundThis, p0, p1, p2);
  };
  l.callableName = 'choiceNumber';
  return l;
}
function AglGrammarSyntaxAnalyser$associativity$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return associativity($boundThis, p0, p1, p2);
  };
  l.callableName = 'associativity';
  return l;
}
function AglGrammarSyntaxAnalyser$grammarRule$lambda($name, $isSkip, $isLeaf, $rhs, this$0, $sentence, $target) {
  return function (grammar) {
    var result = new NormalRuleDefault(grammar, $name, $isSkip, $isLeaf);
    result.rhs = $rhs;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.grammarRule.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this$0.locationMap;
    var tmp1_set = $sentence.v1f($target.node);
    tmp0_set.m3(result, tmp1_set);
    tmp$ret$0 = result;
    return tmp$ret$0;
  };
}
function AglGrammarSyntaxAnalyser$overrideRule$lambda($identifier, $isSkip, $isLeaf, $overrideKind, $rhs, this$0, $sentence, $target) {
  return function (grammar) {
    var result = new OverrideRuleDefault(grammar, $identifier, $isSkip, $isLeaf, $overrideKind);
    result.overridenRhs = $rhs;
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.overrideRule.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this$0.locationMap;
    var tmp1_set = $sentence.v1f($target.node);
    tmp0_set.m3(result, tmp1_set);
    tmp$ret$0 = result;
    return tmp$ret$0;
  };
}
function AglGrammarSyntaxAnalyser$preferenceRule$lambda($forItem, $optionList, this$0, $sentence, $target) {
  return function (grammar) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = new PreferenceRuleDefault(grammar, $forItem, $optionList);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.grammar.AglGrammarSyntaxAnalyser.preferenceRule.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this$0.locationMap;
    var tmp1_set = $sentence.v1f($target.node);
    tmp0_set.m3(tmp0_also, tmp1_set);
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  };
}
function _get_namespace__iwxsq2($this) {
  var tmp = $this.b1g_1.namespace.u3(ensureNotNull(ensureNotNull(Agl_getInstance().registry.agl.grammar.processor).grammar).qualifiedName);
  var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.y1('');
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function _get__ruleSetNumber__ss0daz($this) {
  // Inline function 'kotlin.getValue' call
  _ruleSetNumber$factory();
  return $this.y1e_1.p3();
}
function _get__pseudoRuleNameGenerator__sdgpi4($this) {
  // Inline function 'kotlin.getValue' call
  _pseudoRuleNameGenerator$factory();
  return $this.g1f_1.p3();
}
function nextRule($this, name, isSkip) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!$this.a1f_1.r3(name)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var newRule = new RuntimeRule(_get__ruleSetNumber__ss0daz($this), $this.a1f_1.o(), name, isSkip);
  // Inline function 'kotlin.collections.set' call
  $this.a1f_1.m3(name, newRule);
  return newRule;
}
function terminalRule($this, name, value, kind, isPattern, isSkip) {
  // Inline function 'kotlin.also' call
  var tmp0_also = new RuntimeRule(_get__ruleSetNumber__ss0daz($this), $this.a1f_1.o(), name, isSkip);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.terminalRule.<anonymous>' call
  if (isPattern) {
    var unescaped = Companion_getInstance_30().e1g(value);
    tmp0_also.f1g(new RuntimeRuleRhsPattern(tmp0_also, unescaped));
  } else {
    var unescaped_0 = Companion_getInstance_31().e1g(value);
    tmp0_also.f1g(new RuntimeRuleRhsLiteral(tmp0_also, unescaped_0));
  }
  var newRule = tmp0_also;
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!$this.a1f_1.r3(newRule.mz())) {
      // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.terminalRule.<anonymous>' call
      var message = "Already got rule with tag '" + name + "'";
      throw IllegalStateException.y1(toString(message));
    }
  }
  // Inline function 'kotlin.collections.set' call
  var tmp2_set = $this.a1f_1;
  var tmp3_set = newRule.mz();
  tmp2_set.m3(tmp3_set, newRule);
  // Inline function 'kotlin.collections.set' call
  $this.c1f_1.m3(value, newRule);
  return newRule;
}
function embeddedRule($this, embeddedRuleName, isSkip, embeddedGrammar, embeddedGoalRuleName) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!$this.a1f_1.r3(embeddedRuleName)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var embeddedConverter = $this.f1f_1.u3(embeddedGrammar);
  var embeddedRuntimeRuleSet = embeddedConverter.h1f();
  var embeddedStartRuntimeRule = embeddedRuntimeRuleSet.pu(embeddedGoalRuleName);
  // Inline function 'kotlin.also' call
  var tmp1_also = new RuntimeRule(_get__ruleSetNumber__ss0daz($this), $this.a1f_1.o(), embeddedRuleName, isSkip);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.embeddedRule.<anonymous>' call
  tmp1_also.f1g(new RuntimeRuleRhsEmbedded(tmp1_also, embeddedRuntimeRuleSet, embeddedStartRuntimeRule));
  var newRule = tmp1_also;
  // Inline function 'kotlin.collections.set' call
  var tmp2_set = $this.a1f_1;
  var tmp3_set = newRule.mz();
  tmp2_set.m3(tmp3_set, newRule);
  // Inline function 'kotlin.collections.set' call
  var tmp4_set = $this.d1f_1;
  var tmp5_set = new Pair(embeddedGrammar, embeddedGoalRuleName);
  tmp4_set.m3(tmp5_set, newRule);
  return newRule;
}
function findNamedRule($this, name) {
  return $this.a1f_1.u3(name);
}
function findTerminal($this, value) {
  return $this.c1f_1.u3(value);
}
function findEmbedded($this, grammar, goalRuleName) {
  return $this.d1f_1.u3(new Pair(grammar, goalRuleName));
}
function buildCompressedRule($this, target, isSkip) {
  var ci = target.compressedLeaf;
  var tmp;
  if (ci.isPattern) {
    tmp = terminalRule($this, target.name, ci.value, RuntimeRuleKind_TERMINAL_getInstance(), true, isSkip);
  } else {
    tmp = terminalRule($this, target.name, ci.value, RuntimeRuleKind_TERMINAL_getInstance(), false, isSkip);
  }
  var rule = tmp;
  return rule;
}
function convertGrammar($this, target, arg) {
  // Inline function 'kotlin.collections.map' call
  var tmp0_map = target.allResolvedGrammarRule;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
  var tmp0_iterator = tmp0_map.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.convertGrammar.<anonymous>' call
    tmp$ret$0 = convertGrammarRule($this, item, arg);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var rules = toSet(tmp0_mapTo);
  var tmp = $this;
  // Inline function 'kotlin.collections.map' call
  var tmp1_map = target.allResolvedPreferenceRuleRule;
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
  var tmp0_iterator_0 = tmp1_map.u();
  while (tmp0_iterator_0.h1()) {
    var item_0 = tmp0_iterator_0.j1();
    var tmp$ret$3;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.convertGrammar.<anonymous>' call
    tmp$ret$3 = convertPreferenceRule($this, item_0, arg);
    tmp0_mapTo_0.e1(tmp$ret$3);
  }
  tmp.b1f_1 = tmp0_mapTo_0;
  return rules;
}
function convertPreferenceRule($this, target, arg) {
  var forItem = target.forItem;
  var tmp;
  if (isInterface(forItem, NonTerminal)) {
    tmp = ensureNotNull(findNamedRule($this, forItem.name));
  } else {
    if (isInterface(forItem, Embedded)) {
      throw NotImplementedError.eg();
    } else {
      if (isInterface(forItem, Terminal)) {
        tmp = ensureNotNull(findTerminal($this, forItem.name));
      } else {
        var tmp0_error = "Internal Error: subtype '" + getKClassFromExpression(forItem).n9() + "' of SimpleItem not handled";
        throw IllegalStateException.y1(toString(tmp0_error));
      }
    }
  }
  var contextRule = tmp;
  // Inline function 'kotlin.collections.mapIndexed' call
  var tmp1_mapIndexed = target.optionList;
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp1_mapIndexed, 10));
  var index = 0;
  var tmp0_iterator = tmp1_mapIndexed.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$3;
    // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.convertPreferenceRule.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var prec = checkIndexOverflow(tmp1);
    var tgt = ensureNotNull(findNamedRule($this, item.item.name));
    var opt = item.choiceNumber;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = item.onTerminals;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator_0 = tmp0_map.u();
    while (tmp0_iterator_0.h1()) {
      var item_0 = tmp0_iterator_0.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.convertPreferenceRule.<anonymous>.<anonymous>' call
      var tmp_0;
      if (isInterface(item_0, Terminal)) {
        var tmp1_elvis_lhs = findTerminal($this, item_0.value);
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          var tmp0_error_0 = "Terminal '" + item_0.value + "' not found";
          throw IllegalStateException.y1(toString(tmp0_error_0));
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp_0 = tmp_1;
      } else {
        if (isInterface(item_0, NonTerminal)) {
          var r = findNamedRule($this, item_0.name);
          var tmp_2;
          if (null == r) {
            var tmp1_error = "Rule named '" + item_0.name + "' not found";
            throw IllegalStateException.y1(toString(tmp1_error));
          } else if (!r.s10()) {
            var tmp2_error = "Rule named '" + item_0.name + "' is not a terminal";
            throw IllegalStateException.y1(toString(tmp2_error));
          } else {
            tmp_2 = r;
          }
          tmp_0 = tmp_2;
        } else {
          if (isInterface(item_0, Embedded)) {
            throw NotImplementedError.eg();
          } else {
            var tmp3_error = "Internal Error: subtype '" + getKClassFromExpression(forItem).n9() + "' of SimpleItem not handled";
            throw IllegalStateException.y1(toString(tmp3_error));
          }
        }
      }
      tmp$ret$0 = tmp_0;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    var terminals = toSet(tmp0_mapTo);
    var tmp_3;
    switch (item.associativity.bc_1) {
      case 0:
        tmp_3 = Assoc_LEFT_getInstance();
        break;
      case 1:
        tmp_3 = Assoc_RIGHT_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var assoc = tmp_3;
    tmp$ret$3 = new RuntimePreferenceOption(prec, tgt, opt, terminals, assoc);
    tmp0_mapIndexedTo.e1(tmp$ret$3);
  }
  var options = tmp0_mapIndexedTo;
  return new RuntimePreferenceRule(contextRule, options);
}
function convertGrammarRule($this, target, arg) {
  var rule = findNamedRule($this, target.name);
  var rhs = target.rhs;
  var tmp;
  if (null == rule) {
    var tmp_0;
    if (target.isLeaf) {
      var tmp_1;
      if (isInterface(rhs, Terminal)) {
        var rrule = terminalRule($this, target.name, rhs.value, RuntimeRuleKind_TERMINAL_getInstance(), rhs.isPattern, target.isSkip);
        tmp_1 = new Pair(rrule, rhs);
      } else {
        var tmp_2;
        var tmp_3;
        if (isInterface(rhs, Concatenation)) {
          tmp_3 = rhs.items.o() === 1;
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          var tmp_4 = rhs.items.p(0);
          tmp_2 = isInterface(tmp_4, Terminal);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          var tmp_5 = rhs.items.p(0);
          var t = isInterface(tmp_5, Terminal) ? tmp_5 : THROW_CCE();
          var rrule_0 = terminalRule($this, target.name, t.value, RuntimeRuleKind_TERMINAL_getInstance(), t.isPattern, target.isSkip);
          tmp_1 = new Pair(rrule_0, t);
        } else {
          var tmp_6;
          var tmp_7;
          if (isInterface(rhs, Choice)) {
            tmp_7 = rhs.alternative.o() === 1;
          } else {
            tmp_7 = false;
          }
          if (tmp_7) {
            var tmp_8 = rhs.alternative.p(0);
            tmp_6 = isInterface(tmp_8, Terminal);
          } else {
            tmp_6 = false;
          }
          if (tmp_6) {
            var tmp_9 = rhs.alternative.p(0);
            var t_0 = isInterface(tmp_9, Terminal) ? tmp_9 : THROW_CCE();
            var rrule_1 = terminalRule($this, target.name, t_0.value, RuntimeRuleKind_TERMINAL_getInstance(), t_0.isPattern, target.isSkip);
            tmp_1 = new Pair(rrule_1, t_0);
          } else {
            var rrule_2 = buildCompressedRule($this, target, target.isSkip);
            tmp_1 = new Pair(rrule_2, rhs);
          }
        }
      }
      tmp_0 = tmp_1;
    } else if (target.isOneEmbedded) {
      var embeddedRuleName = target.name;
      var tmp_10;
      var tmp_11 = target.rhs;
      if (isInterface(tmp_11, Embedded)) {
        var tmp_12 = target.rhs;
        tmp_10 = isInterface(tmp_12, Embedded) ? tmp_12 : THROW_CCE();
      } else {
        var tmp_13 = target.rhs;
        var tmp_14 = (isInterface(tmp_13, Concatenation) ? tmp_13 : THROW_CCE()).items.p(0);
        tmp_10 = isInterface(tmp_14, Embedded) ? tmp_14 : THROW_CCE();
      }
      var e = tmp_10;
      var embeddedRule_0 = embeddedRule($this, embeddedRuleName, false, ensureNotNull(e.embeddedGrammarReference.resolved), e.embeddedGoalName);
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = $this.e1f_1;
      var tmp1_set = new Pair(embeddedRule_0.mw_1, embeddedRule_0.nw_1);
      tmp0_set.m3(tmp1_set, e);
      tmp_0 = new Pair(embeddedRule_0, e);
    } else {
      var nrule = nextRule($this, target.name, target.isSkip);
      var rrhs = createRhs($this, nrule, target.rhs, target.name);
      nrule.f1g(rrhs);
      tmp_0 = new Pair(nrule, target.rhs);
    }
    var tmp0_container = tmp_0;
    var rrule_3 = tmp0_container.ti();
    var ruleItem = tmp0_container.ui();
    // Inline function 'kotlin.collections.set' call
    var tmp2_set = $this.e1f_1;
    var tmp3_set = new Pair(rrule_3.mw_1, rrule_3.nw_1);
    tmp2_set.m3(tmp3_set, ruleItem);
    tmp = rrule_3;
  } else {
    tmp = rule;
  }
  return tmp;
}
function createRhs($this, rule, target, arg) {
  var tmp;
  if (isInterface(target, EmptyRule)) {
    tmp = new RuntimeRuleRhsConcatenation(rule, listOf(Companion_getInstance_33().p13_1));
  } else {
    if (isInterface(target, Terminal)) {
      tmp = new RuntimeRuleRhsConcatenation(rule, listOf(convertTerminal($this, target, arg)));
    } else {
      if (isInterface(target, NonTerminal)) {
        var item = convertNonTerminal($this, target, arg);
        tmp = new RuntimeRuleRhsConcatenation(rule, listOf(item));
      } else {
        if (isInterface(target, Concatenation)) {
          Debug_getInstance();
          if (false) {
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.check' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(target.items.o() > 1)) {
              // Inline function 'kotlin.check.<anonymous>' call
              var message = 'Check failed.';
              throw IllegalStateException.y1(toString(message));
            }
          }
          // Inline function 'kotlin.collections.map' call
          var tmp1_map = target.items;
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
          var tmp0_iterator = tmp1_map.u();
          while (tmp0_iterator.h1()) {
            var item_0 = tmp0_iterator.j1();
            var tmp$ret$1;
            // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.createRhs.<anonymous>' call
            tmp$ret$1 = runtimeRuleForRuleItem($this, item_0, arg);
            tmp0_mapTo.e1(tmp$ret$1);
          }
          var items = tmp0_mapTo;
          tmp = new RuntimeRuleRhsConcatenation(rule, items);
        } else {
          if (isInterface(target, Choice)) {
            tmp = createRhsForChoice($this, rule, target, arg);
          } else {
            if (isInterface(target, OptionalItem)) {
              tmp = createRhsForOptional($this, rule, target, arg);
            } else {
              if (isInterface(target, SimpleList)) {
                tmp = createRhsForSimpleList($this, rule, target, arg);
              } else {
                if (isInterface(target, SeparatedList)) {
                  tmp = createRhsForSeparatedList($this, rule, target, arg);
                } else {
                  if (isInterface(target, Group)) {
                    var content = target.groupedContent;
                    var tmp_0;
                    if (isInterface(content, Choice)) {
                      tmp_0 = createRhsForChoice($this, rule, content, arg);
                    } else {
                      var groupRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
                      tmp_0 = createRhs($this, rule, target.groupedContent, groupRuleName);
                    }
                    tmp = tmp_0;
                  } else {
                    throw IllegalStateException.y1('Unsupported');
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function runtimeRuleForRuleItem($this, target, arg) {
  var tmp;
  if (isInterface(target, EmptyRule)) {
    tmp = Companion_getInstance_33().p13_1;
  } else {
    if (isInterface(target, Terminal)) {
      tmp = convertTerminal($this, target, arg);
    } else {
      if (isInterface(target, NonTerminal)) {
        tmp = convertNonTerminal($this, target, arg);
      } else {
        if (isInterface(target, Embedded)) {
          tmp = convertEmbedded($this, target, arg);
        } else {
          if (isInterface(target, OptionalItem)) {
            tmp = createPseudoRuleForOptionalItem($this, target, arg);
          } else {
            if (isInterface(target, SimpleList)) {
              tmp = createPseudoRuleForSimpleList($this, target, arg);
            } else {
              if (isInterface(target, SeparatedList)) {
                tmp = createPseudoRuleForSeparatedList($this, target, arg);
              } else {
                if (isInterface(target, Group)) {
                  tmp = createPseudoRuleForGroup($this, target, arg);
                } else {
                  if (isInterface(target, Choice)) {
                    tmp = createPseudoRuleForChoice($this, target, arg);
                  } else {
                    var tmp0_error = '' + getKClassFromExpression(target) + ' is not a supported subtype of RuleItem';
                    throw IllegalStateException.y1(toString(tmp0_error));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function convertTerminal($this, target, arg) {
  var existing = findTerminal($this, target.value);
  var tmp;
  if (null == existing) {
    var terminalRule_0 = terminalRule($this, null, target.value, RuntimeRuleKind_TERMINAL_getInstance(), target.isPattern, false);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = $this.e1f_1;
    var tmp1_set = new Pair(terminalRule_0.mw_1, terminalRule_0.nw_1);
    tmp0_set.m3(tmp1_set, target);
    tmp = terminalRule_0;
  } else {
    tmp = existing;
  }
  return tmp;
}
function convertNonTerminal($this, target, arg) {
  var refName = target.name;
  var tmp0_elvis_lhs = findNamedRule($this, refName);
  return tmp0_elvis_lhs == null ? convertGrammarRule($this, target.referencedRule(ensureNotNull($this.w1e_1)), arg) : tmp0_elvis_lhs;
}
function convertEmbedded($this, target, arg) {
  var existing = findEmbedded($this, ensureNotNull(target.embeddedGrammarReference.resolved), target.embeddedGoalName);
  var tmp;
  if (null == existing) {
    var embeddedRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
    var embeddedRule_0 = embeddedRule($this, embeddedRuleName, false, ensureNotNull(target.embeddedGrammarReference.resolved), target.embeddedGoalName);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = $this.e1f_1;
    var tmp1_set = new Pair(embeddedRule_0.mw_1, embeddedRule_0.nw_1);
    tmp0_set.m3(tmp1_set, target);
    tmp = embeddedRule_0;
  } else {
    tmp = existing;
  }
  return tmp;
}
function createRhsForChoiceAlternative($this, rule, target, arg) {
  var tmp;
  if (isInterface(target, Concatenation)) {
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = target.items;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.createRhsForChoiceAlternative.<anonymous>' call
      tmp$ret$0 = runtimeRuleForRuleItem($this, item, arg);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp = tmp0_mapTo;
  } else {
    if (isInterface(target, ConcatenationItem)) {
      tmp = listOf(runtimeRuleForRuleItem($this, target, arg));
    } else {
      throw NotImplementedError.eg();
    }
  }
  var items = tmp;
  return new RuntimeRuleRhsConcatenation(rule, items);
}
function createPseudoRuleForGroup($this, target, arg) {
  var content = target.groupedContent;
  var tmp;
  if (isInterface(content, Choice)) {
    tmp = createPseudoRuleForChoice($this, content, arg);
  } else {
    tmp = createPseudoRuleForGroupContent($this, target, arg);
  }
  return tmp;
}
function createPseudoRuleForChoice($this, target, arg) {
  var chRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
  var nrule = createPseudoRule($this, target, chRuleName);
  var rhs = createRhsForChoice($this, nrule, target, chRuleName);
  nrule.f1g(rhs);
  return nrule;
}
function createPseudoRuleForGroupContent($this, target, arg) {
  var grRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
  var nrule = createPseudoRule($this, target.groupedContent, grRuleName);
  var rhs = createRhs($this, nrule, target.groupedContent, grRuleName);
  nrule.f1g(rhs);
  return nrule;
}
function createPseudoRule($this, target, psudeoRuleName) {
  var nrule = nextRule($this, psudeoRuleName, false);
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.e1f_1;
  var tmp1_set = new Pair(nrule.mw_1, nrule.nw_1);
  tmp0_set.m3(tmp1_set, target);
  return nrule;
}
function createPseudoRuleForOptionalItem($this, target, arg) {
  var optRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
  var nrule = nextRule($this, optRuleName, false);
  nrule.f1g(createRhsForOptional($this, nrule, target, optRuleName));
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.e1f_1;
  var tmp1_set = new Pair(nrule.mw_1, nrule.nw_1);
  tmp0_set.m3(tmp1_set, target);
  return nrule;
}
function createPseudoRuleForSimpleList($this, target, arg) {
  var multiRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
  var nrule = nextRule($this, multiRuleName, false);
  nrule.f1g(createRhsForSimpleList($this, nrule, target, multiRuleName));
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.e1f_1;
  var tmp1_set = new Pair(nrule.mw_1, nrule.nw_1);
  tmp0_set.m3(tmp1_set, target);
  return nrule;
}
function createPseudoRuleForSeparatedList($this, target, arg) {
  var sListRuleName = _get__pseudoRuleNameGenerator__sdgpi4($this).o1g(target);
  var nrule = nextRule($this, sListRuleName, false);
  nrule.f1g(createRhsForSeparatedList($this, nrule, target, sListRuleName));
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.e1f_1;
  var tmp1_set = new Pair(nrule.mw_1, nrule.nw_1);
  tmp0_set.m3(tmp1_set, target);
  return nrule;
}
function createRhsForChoice($this, rule, target, arg) {
  var tmp;
  if (target.alternative.o() === 1) {
    throw IllegalStateException.y1('Internal Error: choice should have more than one alternative');
  } else {
    var tmp_0;
    if (isInterface(target, ChoiceLongest)) {
      tmp_0 = RuntimeRuleChoiceKind_LONGEST_PRIORITY_getInstance();
    } else {
      if (isInterface(target, ChoicePriority)) {
        tmp_0 = RuntimeRuleChoiceKind_PRIORITY_LONGEST_getInstance();
      } else {
        if (isInterface(target, ChoiceAmbiguous)) {
          tmp_0 = RuntimeRuleChoiceKind_AMBIGUOUS_getInstance();
        } else {
          throw RuntimeException.u6('unsupported');
        }
      }
    }
    var choiceKind = tmp_0;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = target.alternative;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.ConverterToRuntimeRules.createRhsForChoice.<anonymous>' call
      tmp$ret$0 = createRhsForChoiceAlternative($this, rule, item, arg);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    var items = tmp0_mapTo;
    tmp = new RuntimeRuleRhsChoice(rule, choiceKind, items);
  }
  return tmp;
}
function createRhsForOptional($this, rule, target, arg) {
  var item = runtimeRuleForRuleItem($this, target.item, arg);
  return new RuntimeRuleRhsOptional(rule, item);
}
function createRhsForSimpleList($this, rule, target, arg) {
  var item = runtimeRuleForRuleItem($this, target.item, arg);
  return new RuntimeRuleRhsListSimple(rule, target.min, target.max, item);
}
function createRhsForSeparatedList($this, rule, target, arg) {
  var item = runtimeRuleForRuleItem($this, target.item, arg);
  var separator = runtimeRuleForRuleItem($this, target.separator, arg);
  return new RuntimeRuleRhsListSeparated(rule, target.min, target.max, item, separator);
}
function ConverterToRuntimeRules$_ruleSetNumber$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_33().t12_1.u3(this$0.w1e_1);
  };
}
function ConverterToRuntimeRules$runtimeRuleSet$delegate$lambda(this$0) {
  return function () {
    convertGrammar(this$0, this$0.w1e_1, '');
    var rules = toList(this$0.a1f_1.k3());
    return new RuntimeRuleSet(_get__ruleSetNumber__ss0daz(this$0), this$0.w1e_1.qualifiedName, rules, this$0.b1f_1);
  };
}
function ConverterToRuntimeRules$embeddedConverters$lambda(embeddedGrammar) {
  var embeddedConverter = new ConverterToRuntimeRules(embeddedGrammar);
  return embeddedConverter;
}
function ConverterToRuntimeRules$_pseudoRuleNameGenerator$delegate$lambda(this$0) {
  return function () {
    return new PseudoRuleNames(this$0.w1e_1);
  };
}
function _ruleSetNumber$factory() {
  return getPropertyCallableRef('_ruleSetNumber', 1, KProperty1, function (receiver) {
    return _get__ruleSetNumber__ss0daz(receiver);
  }, null);
}
function runtimeRuleSet$factory() {
  return getPropertyCallableRef('runtimeRuleSet', 1, KProperty1, function (receiver) {
    return receiver.h1f();
  }, null);
}
function _pseudoRuleNameGenerator$factory() {
  return getPropertyCallableRef('_pseudoRuleNameGenerator', 1, KProperty1, function (receiver) {
    return _get__pseudoRuleNameGenerator__sdgpi4(receiver);
  }, null);
}
function pseudoRulesFor($this, item) {
  var tmp;
  if (isInterface(item, Embedded)) {
    tmp = setOf(new Pair(item, createEmbeddedRuleName($this, ensureNotNull(item.embeddedGrammarReference.resolved).name, item.embeddedGoalName)));
  } else {
    if (isInterface(item, Terminal)) {
      tmp = emptySet();
    } else {
      if (isInterface(item, NonTerminal)) {
        tmp = emptySet();
      } else {
        if (isInterface(item, EmptyRule)) {
          tmp = emptySet();
        } else {
          if (isInterface(item, Choice)) {
            // Inline function 'kotlin.collections.flatMap' call
            var tmp0_flatMap = item.alternative;
            // Inline function 'kotlin.collections.flatMapTo' call
            var tmp0_flatMapTo = ArrayList.i4();
            var tmp0_iterator = tmp0_flatMap.u();
            while (tmp0_iterator.h1()) {
              var element = tmp0_iterator.j1();
              // Inline function 'net.akehurst.language.agl.agl.grammar.grammar.PseudoRuleNames.pseudoRulesFor.<anonymous>' call
              var list = pseudoRulesFor($this, element);
              addAll(tmp0_flatMapTo, list);
            }
            tmp = plus_1(toSet(tmp0_flatMapTo), new Pair(item, createChoiceRuleName($this, item.owningRule.name)));
          } else {
            if (isInterface(item, Concatenation)) {
              // Inline function 'kotlin.collections.flatMap' call
              var tmp1_flatMap = item.items;
              // Inline function 'kotlin.collections.flatMapTo' call
              var tmp0_flatMapTo_0 = ArrayList.i4();
              var tmp0_iterator_0 = tmp1_flatMap.u();
              while (tmp0_iterator_0.h1()) {
                var element_0 = tmp0_iterator_0.j1();
                // Inline function 'net.akehurst.language.agl.agl.grammar.grammar.PseudoRuleNames.pseudoRulesFor.<anonymous>' call
                var list_0 = pseudoRulesFor($this, element_0);
                addAll(tmp0_flatMapTo_0, list_0);
              }
              tmp = toSet(tmp0_flatMapTo_0);
            } else {
              if (isInterface(item, OptionalItem)) {
                tmp = plus_1(pseudoRulesFor($this, item.item), new Pair(item, createOptionalItemRuleName($this, item.owningRule.name)));
              } else {
                if (isInterface(item, SimpleList)) {
                  tmp = plus_1(pseudoRulesFor($this, item.item), new Pair(item, createSimpleListRuleName($this, item.owningRule.name)));
                } else {
                  if (isInterface(item, SeparatedList)) {
                    tmp = plus_1(plus_0(pseudoRulesFor($this, item.item), pseudoRulesFor($this, item.separator)), new Pair(item, createSeparatedListRuleName($this, item.owningRule.name)));
                  } else {
                    if (isInterface(item, Group)) {
                      var tmp1_subject = item.groupedContent;
                      var tmp_0;
                      if (isInterface(tmp1_subject, Choice)) {
                        tmp_0 = plus_1(pseudoRulesFor($this, item.groupedContent), new Pair(item, createChoiceRuleName($this, item.owningRule.name)));
                      } else {
                        tmp_0 = plus_1(pseudoRulesFor($this, item.groupedContent), new Pair(item, createGroupRuleName($this, item.owningRule.name)));
                      }
                      tmp = tmp_0;
                    } else {
                      var tmp2_error = 'Internal Error: subtype of ' + getKClass(RuleItem).n9() + ' ' + getKClassFromExpression(item).n9() + ' not handled';
                      throw IllegalStateException.y1(toString(tmp2_error));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function createEmbeddedRuleName($this, grammarName, goalName) {
  var baseName = grammarName + '\xA7' + goalName;
  var tmp0_elvis_lhs = $this.h1g_1.u3(baseName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.h1g_1;
  var tmp1_set = n;
  tmp0_set.m3(baseName, tmp1_set);
  return '\xA7' + removePrefix(baseName, '\xA7') + '\xA7embedded' + n;
}
function createGroupRuleName($this, parentRuleName) {
  var tmp0_elvis_lhs = $this.i1g_1.u3(parentRuleName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.i1g_1;
  var tmp1_set = n;
  tmp0_set.m3(parentRuleName, tmp1_set);
  return '\xA7' + removePrefix(parentRuleName, '\xA7') + '\xA7group' + n;
}
function createChoiceRuleName($this, parentRuleName) {
  var tmp0_elvis_lhs = $this.j1g_1.u3(parentRuleName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.j1g_1;
  var tmp1_set = n;
  tmp0_set.m3(parentRuleName, tmp1_set);
  return '\xA7' + removePrefix(parentRuleName, '\xA7') + '\xA7choice' + n;
}
function createOptionalItemRuleName($this, parentRuleName) {
  var tmp0_elvis_lhs = $this.k1g_1.u3(parentRuleName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.k1g_1;
  var tmp1_set = n;
  tmp0_set.m3(parentRuleName, tmp1_set);
  return '\xA7' + removePrefix(parentRuleName, '\xA7') + '\xA7opt' + n;
}
function createSimpleListRuleName($this, parentRuleName) {
  var tmp0_elvis_lhs = $this.k1g_1.u3(parentRuleName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.k1g_1;
  var tmp1_set = n;
  tmp0_set.m3(parentRuleName, tmp1_set);
  return '\xA7' + removePrefix(parentRuleName, '\xA7') + '\xA7multi' + n;
}
function createSeparatedListRuleName($this, parentRuleName) {
  var tmp0_elvis_lhs = $this.l1g_1.u3(parentRuleName);
  var n = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  n = n + 1 | 0;
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.l1g_1;
  var tmp1_set = n;
  tmp0_set.m3(parentRuleName, tmp1_set);
  return '\xA7' + removePrefix(parentRuleName, '\xA7') + '\xA7sepList' + n;
}
function terminal_0($this, value, isPattern) {
  var t = $this.a1c_1.u3(value);
  var tmp;
  if (null == t) {
    var tt = new TerminalDefault(value, isPattern);
    // Inline function 'kotlin.collections.set' call
    $this.a1c_1.m3(value, tt);
    tt.r1g_1 = $this.grammar;
    tmp = tt;
  } else {
    var tmp_0;
    if (isPattern === t.isPattern) {
      tmp_0 = t;
    } else {
      throw IllegalStateException.y1('Error terminal defined as both pattern and literal!');
    }
    tmp = tmp_0;
  }
  return tmp;
}
var Companion_instance_13;
function Companion_getInstance_15() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
function GrammarAbstract$allResolvedGrammarRule$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.extends;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedGrammarRule$delegate.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = element.resolved;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allResolvedGrammarRule;
      tmp$ret$0 = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    var rules = toMutableOrderedSet(tmp$ret$2);
    var tmp1_forEach = this$0.grammarRule;
    var tmp0_iterator_0 = tmp1_forEach.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedGrammarRule$delegate.<anonymous>.<anonymous>' call
      if (element_0.isOverride) {
        var tmp$ret$5;
        // Inline function 'kotlin.collections.find' call
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_1 = rules.u();
          while (tmp0_iterator_1.h1()) {
            var element_1 = tmp0_iterator_1.j1();
            var tmp$ret$3;
            // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedGrammarRule$delegate.<anonymous>.<anonymous>.<anonymous>' call
            tmp$ret$3 = element_1.name === element_0.name;
            if (tmp$ret$3) {
              tmp$ret$4 = element_1;
              break $l$block;
            }
          }
          tmp$ret$4 = null;
        }
        tmp$ret$5 = tmp$ret$4;
        var tmp0_elvis_lhs = tmp$ret$5;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp0_error = 'GrammarRule ' + element_0.name + ' is marked as override, but there is no super rule with that name to override.';
          throw IllegalStateException.y1(toString(tmp0_error));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var overridden = tmp;
        rules.f1(overridden);
        rules.e1(element_0);
      } else if (rules.w(element_0)) {
      } else {
        rules.e1(element_0);
      }
    }
    return rules;
  };
}
function GrammarAbstract$allResolvedTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = toSet(this$0.allResolvedGrammarRule);
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedTerminal$delegate.<anonymous>.<anonymous>' call
      var tmp0_subject = element.isLeaf;
      var tmp;
      switch (tmp0_subject) {
        case true:
          tmp = setOf(element.compressedLeaf);
          break;
        case false:
          tmp = element.rhs.allTerminal;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function GrammarAbstract$allResolvedSkipTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedSkipTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.isSkip;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_flatMap = tmp$ret$2;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator_0 = tmp1_flatMap.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedSkipTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$3 = element_0.rhs.allTerminal;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    return toSet(tmp$ret$5);
  };
}
function GrammarAbstract$allResolvedNonTerminalRule$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedNonTerminalRule$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = !element.isLeaf;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function GrammarAbstract$allResolvedPreferenceRuleRule$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.extends;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedPreferenceRuleRule$delegate.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = element.resolved;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.allResolvedPreferenceRuleRule;
      tmp$ret$0 = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    var rules = toMutableOrderedSet(tmp$ret$2);
    return plus_4(rules, this$0.preferenceRule);
  };
}
function GrammarAbstract$allResolvedEmbeddedRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.allResolvedGrammarRule;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedEmbeddedRules$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.rhs.allEmbedded;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function GrammarAbstract$allResolvedEmbeddedGrammars$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_mapNotNull = this$0.allResolvedEmbeddedRules;
    var tmp$ret$2;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = tmp0_mapNotNull.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedEmbeddedGrammars$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.embeddedGrammarReference.resolved;
      var tmp0_safe_receiver = tmp$ret$0;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        tmp$ret$1 = Unit_getInstance();
      }
    }
    tmp$ret$2 = tmp0_mapNotNullTo;
    tmp$ret$3 = tmp$ret$2;
    var egs = toSet(tmp$ret$3);
    var tmp$ret$6;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator_0 = egs.u();
    while (tmp0_iterator_0.h1()) {
      var element_0 = tmp0_iterator_0.j1();
      var tmp$ret$4;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.GrammarAbstract.allResolvedEmbeddedGrammars$delegate.<anonymous>.<anonymous>' call
      tmp$ret$4 = element_0.allResolvedEmbeddedGrammars;
      var list = tmp$ret$4;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$5 = tmp0_flatMapTo;
    tmp$ret$6 = tmp$ret$5;
    return plus_0(egs, toSet(tmp$ret$6));
  };
}
function allResolvedGrammarRule$factory() {
  return getPropertyCallableRef('allResolvedGrammarRule', 1, KProperty1, function (receiver) {
    return receiver.allResolvedGrammarRule;
  }, null);
}
function allResolvedTerminal$factory() {
  return getPropertyCallableRef('allResolvedTerminal', 1, KProperty1, function (receiver) {
    return receiver.allResolvedTerminal;
  }, null);
}
function allResolvedSkipTerminal$factory() {
  return getPropertyCallableRef('allResolvedSkipTerminal', 1, KProperty1, function (receiver) {
    return receiver.allResolvedSkipTerminal;
  }, null);
}
function allResolvedNonTerminalRule$factory() {
  return getPropertyCallableRef('allResolvedNonTerminalRule', 1, KProperty1, function (receiver) {
    return receiver.allResolvedNonTerminalRule;
  }, null);
}
function allResolvedPreferenceRuleRule$factory() {
  return getPropertyCallableRef('allResolvedPreferenceRuleRule', 1, KProperty1, function (receiver) {
    return receiver.allResolvedPreferenceRuleRule;
  }, null);
}
function allResolvedEmbeddedRules$factory() {
  return getPropertyCallableRef('allResolvedEmbeddedRules', 1, KProperty1, function (receiver) {
    return receiver.allResolvedEmbeddedRules;
  }, null);
}
function allResolvedEmbeddedGrammars$factory() {
  return getPropertyCallableRef('allResolvedEmbeddedGrammars', 1, KProperty1, function (receiver) {
    return receiver.allResolvedEmbeddedGrammars;
  }, null);
}
function toRegEx($this, value) {
  return Companion_getInstance().db(value);
}
function GrammarRuleAbstract$Companion$compressRuleItem$lambda(it) {
  return '(' + it.x1h_1 + ')';
}
function GrammarRuleAbstract$Companion$compressRuleItem$lambda_0(it) {
  return '(' + it.x1h_1 + ')';
}
var Companion_instance_14;
function Companion_getInstance_16() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function GrammarRuleAbstract$compressedLeaf$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_16().compressRuleItem(this$0.name, this$0.rhs);
  };
}
function compressedLeaf$factory() {
  return getPropertyCallableRef('compressedLeaf', 1, KProperty1, function (receiver) {
    return receiver.compressedLeaf;
  }, null);
}
function ConcatenationDefault$allTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.j1k_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ConcatenationDefault.allTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allTerminal;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ConcatenationDefault$allNonTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.j1k_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ConcatenationDefault.allNonTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allNonTerminal;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ConcatenationDefault$allEmbedded$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.j1k_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ConcatenationDefault.allEmbedded$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allEmbedded;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ChoiceAbstract$allTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.alternative;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ChoiceAbstract.allTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allTerminal;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ChoiceAbstract$allNonTerminal$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.alternative;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ChoiceAbstract.allNonTerminal$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allNonTerminal;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function ChoiceAbstract$allEmbedded$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.alternative;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.grammar.grammar.asm.ChoiceAbstract.allEmbedded$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.allEmbedded;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return toSet(tmp$ret$2);
  };
}
function allTerminal$factory() {
  return getPropertyCallableRef('allTerminal', 1, KProperty1, function (receiver) {
    return receiver.allTerminal;
  }, null);
}
function allNonTerminal$factory() {
  return getPropertyCallableRef('allNonTerminal', 1, KProperty1, function (receiver) {
    return receiver.allNonTerminal;
  }, null);
}
function allEmbedded$factory() {
  return getPropertyCallableRef('allEmbedded', 1, KProperty1, function (receiver) {
    return receiver.allEmbedded;
  }, null);
}
function allTerminal$factory_0() {
  return getPropertyCallableRef('allTerminal', 1, KProperty1, function (receiver) {
    return receiver.allTerminal;
  }, null);
}
function allNonTerminal$factory_0() {
  return getPropertyCallableRef('allNonTerminal', 1, KProperty1, function (receiver) {
    return receiver.allNonTerminal;
  }, null);
}
function allEmbedded$factory_0() {
  return getPropertyCallableRef('allEmbedded', 1, KProperty1, function (receiver) {
    return receiver.allEmbedded;
  }, null);
}
function createRules_1($this) {
  var b = new GrammarBuilderDefault(new NamespaceDefault('net.akehurst.language.agl'), 'AglStyle');
  b.skip('WHITESPACE', true).concatenation([b.terminalPattern('\\s+')]);
  b.skip('MULTI_LINE_COMMENT', true).concatenation([b.terminalPattern('/\\*[^*]*\\*+([^*/][^*]*\\*+)*/')]);
  b.skip('SINGLE_LINE_COMMENT', true).concatenation([b.terminalPattern('//[^\\n\\r]*')]);
  b.rule('declarations').concatenation([b.nonTerminal('rootIdentifiables'), b.nonTerminal('scopes'), b.nonTerminal('referencesOpt')]);
  b.rule('rootIdentifiables').multi(0, -1, b.nonTerminal('identifiable'));
  b.rule('scopes').multi(0, -1, b.nonTerminal('scope'));
  b.rule('scope').concatenation([b.terminalLiteral('scope'), b.nonTerminal('typeReference'), b.terminalLiteral('{'), b.nonTerminal('identifiables'), b.terminalLiteral('}')]);
  b.rule('identifiables').multi(0, -1, b.nonTerminal('identifiable'));
  b.rule('identifiable').concatenation([b.terminalLiteral('identify'), b.nonTerminal('typeReference'), b.terminalLiteral('by'), b.nonTerminal('propertyReferenceOrNothing')]);
  b.rule('referencesOpt').optional(b.nonTerminal('references'));
  b.rule('references').concatenation([b.terminalLiteral('references'), b.terminalLiteral('{'), b.nonTerminal('referenceDefinitions'), b.terminalLiteral('}')]);
  b.rule('referenceDefinitions').multi(0, -1, b.nonTerminal('referenceDefinition'));
  b.rule('referenceDefinition').concatenation([b.terminalLiteral('in'), b.nonTerminal('typeReference'), b.terminalLiteral('property'), b.nonTerminal('propertyReference'), b.terminalLiteral('refers-to'), b.nonTerminal('typeReferences')]);
  b.rule('typeReferences').separatedList(1, -1, b.terminalLiteral('|'), b.nonTerminal('typeReference'));
  b.rule('typeReference').concatenation([b.nonTerminal('IDENTIFIER')]);
  b.rule('propertyReferenceOrNothing').choiceLongestFromConcatenationItem([b.terminalLiteral('\xA7nothing'), b.nonTerminal('propertyReference')]);
  b.rule('propertyReference').concatenation([b.nonTerminal('IDENTIFIER')]);
  b.leaf('IDENTIFIER').concatenation([b.terminalPattern('[a-zA-Z_][a-zA-Z_0-9-]*')]);
  return b.grammar.grammarRule;
}
var AglScopesGrammar_instance;
function AglScopesGrammar_getInstance() {
  if (AglScopesGrammar_instance === VOID)
    new AglScopesGrammar();
  return AglScopesGrammar_instance;
}
function declarations($this, nodeInfo, children, sentence) {
  var asm = new ScopeModelAgl();
  var tmp = children.p(0);
  var rootIdentifiables = (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(1);
  var scopes = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(2);
  var referencesOpt = (tmp_1 == null ? true : isInterface(tmp_1, List)) ? tmp_1 : THROW_CCE();
  var tmp0_safe_receiver = asm.scopes.u3(Companion_getInstance_17().ROOT_SCOPE_TYPE_NAME);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.identifiables;
  if (tmp1_safe_receiver == null)
    null;
  else
    tmp1_safe_receiver.k1(rootIdentifiables);
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = scopes.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser.declarations.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = asm.scopes;
    var tmp1_set = element.scopeFor;
    tmp0_set.m3(tmp1_set, element);
  }
  if (referencesOpt == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser.declarations.<anonymous>' call
    asm.references.k1(referencesOpt);
  }
  return asm;
}
function rootIdentifiables($this, nodeInfo, children, sentence) {
  return isInterface(children, List) ? children : THROW_CCE();
}
function scopes($this, nodeInfo, children, sentence) {
  return isInterface(children, List) ? children : THROW_CCE();
}
function scope($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var typeReference = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var identifiables = (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE();
  var scope = new ScopeDefinition(typeReference);
  scope.identifiables.k1(identifiables);
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.locationMap;
  var tmp1_set = new PropertyValue(scope, 'typeReference');
  var tmp2_set = ensureNotNull($this.locationMap.u3(typeReference));
  tmp0_set.m3(tmp1_set, tmp2_set);
  return scope;
}
function identifiables($this, nodeInfo, children, sentence) {
  var tmp0_elvis_lhs = isInterface(children, List) ? children : THROW_CCE();
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
}
function identifiable($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var typeName = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var propertyName = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var identifiable = new Identifiable(typeName, propertyName);
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.locationMap;
  var tmp1_set = new PropertyValue(identifiable, 'typeReference');
  var tmp2_set = ensureNotNull($this.locationMap.u3(typeName));
  tmp0_set.m3(tmp1_set, tmp2_set);
  // Inline function 'kotlin.collections.set' call
  var tmp3_set = $this.locationMap;
  var tmp4_set = new PropertyValue(identifiable, 'propertyName');
  var tmp5_set = ensureNotNull($this.locationMap.u3(propertyName));
  tmp3_set.m3(tmp4_set, tmp5_set);
  return identifiable;
}
function referencesOpt($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  return (tmp == null ? true : isInterface(tmp, List)) ? tmp : THROW_CCE();
}
function references($this, nodeInfo, children, sentence) {
  var tmp = children.p(2);
  return (!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE();
}
function referenceDefinitions($this, nodeInfo, children, sentence) {
  return isInterface(children, List) ? children : THROW_CCE();
}
function referenceDefinition($this, nodeInfo, children, sentence) {
  var tmp = children.p(1);
  var inTypeName = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  var tmp_0 = children.p(3);
  var referringPropertyName = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
  var tmp_1 = children.p(5);
  var typeReferences = (!(tmp_1 == null) ? isInterface(tmp_1, List) : false) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(typeReferences, 10));
  var tmp0_iterator = typeReferences.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser.referenceDefinition.<anonymous>' call
    tmp$ret$0 = item.ri_1;
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var def = new ReferenceDefinition(inTypeName, referringPropertyName, tmp0_mapTo);
  // Inline function 'kotlin.collections.set' call
  var tmp0_set = $this.locationMap;
  var tmp1_set = new PropertyValue(def, 'in');
  var tmp2_set = ensureNotNull($this.locationMap.u3(inTypeName));
  tmp0_set.m3(tmp1_set, tmp2_set);
  // Inline function 'kotlin.collections.set' call
  var tmp3_set = $this.locationMap;
  var tmp4_set = new PropertyValue(def, 'propertyReference');
  var tmp5_set = ensureNotNull($this.locationMap.u3(referringPropertyName));
  tmp3_set.m3(tmp4_set, tmp5_set);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator_0 = typeReferences.u();
  while (tmp0_iterator_0.h1()) {
    var item_0 = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser.referenceDefinition.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp6_anonymous = checkIndexOverflow(tmp1);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set_0 = $this.locationMap;
    var tmp1_set_0 = new PropertyValue(def, 'typeReferences[' + tmp6_anonymous + ']');
    var tmp2_set_0 = item_0.si_1;
    tmp0_set_0.m3(tmp1_set_0, tmp2_set_0);
  }
  return def;
}
function typeReferences($this, nodeInfo, children, sentence) {
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
  var tmp0_mapIndexed = ListSeparatedArrayList.u1f(children).a11();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var tmp0_mapIndexedTo = ArrayList.f4(collectionSizeOrDefault(tmp0_mapIndexed, 10));
  var index = 0;
  var tmp0_iterator = tmp0_mapIndexed.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$1;
    // Inline function 'net.akehurst.language.agl.grammar.scopes.AglScopesSyntaxAnalyser.typeReferences.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    checkIndexOverflow(tmp1);
    var ref = typeof item === 'string' ? item : THROW_CCE();
    tmp$ret$1 = new Pair(ref, sentence.v1f(nodeInfo.node));
    tmp0_mapIndexedTo.e1(tmp$ret$1);
  }
  return tmp0_mapIndexedTo;
}
function propertyReferenceOrNothing($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  var text = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  return text === '\xA7nothing' ? Companion_getInstance_17().IDENTIFY_BY_NOTHING : text;
}
function typeReference($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
}
function propertyReference($this, nodeInfo, children, sentence) {
  var tmp = children.p(0);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
}
function AglScopesSyntaxAnalyser$declarations$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return declarations($boundThis, p0, p1, p2);
  };
  l.callableName = 'declarations';
  return l;
}
function AglScopesSyntaxAnalyser$rootIdentifiables$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return rootIdentifiables($boundThis, p0, p1, p2);
  };
  l.callableName = 'rootIdentifiables';
  return l;
}
function AglScopesSyntaxAnalyser$scopes$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return scopes($boundThis, p0, p1, p2);
  };
  l.callableName = 'scopes';
  return l;
}
function AglScopesSyntaxAnalyser$scope$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return scope($boundThis, p0, p1, p2);
  };
  l.callableName = 'scope';
  return l;
}
function AglScopesSyntaxAnalyser$identifiables$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return identifiables($boundThis, p0, p1, p2);
  };
  l.callableName = 'identifiables';
  return l;
}
function AglScopesSyntaxAnalyser$identifiable$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return identifiable($boundThis, p0, p1, p2);
  };
  l.callableName = 'identifiable';
  return l;
}
function AglScopesSyntaxAnalyser$referencesOpt$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return referencesOpt($boundThis, p0, p1, p2);
  };
  l.callableName = 'referencesOpt';
  return l;
}
function AglScopesSyntaxAnalyser$references$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return references($boundThis, p0, p1, p2);
  };
  l.callableName = 'references';
  return l;
}
function AglScopesSyntaxAnalyser$referenceDefinitions$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return referenceDefinitions($boundThis, p0, p1, p2);
  };
  l.callableName = 'referenceDefinitions';
  return l;
}
function AglScopesSyntaxAnalyser$referenceDefinition$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return referenceDefinition($boundThis, p0, p1, p2);
  };
  l.callableName = 'referenceDefinition';
  return l;
}
function AglScopesSyntaxAnalyser$typeReferences$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return typeReferences($boundThis, p0, p1, p2);
  };
  l.callableName = 'typeReferences';
  return l;
}
function AglScopesSyntaxAnalyser$propertyReferenceOrNothing$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return propertyReferenceOrNothing($boundThis, p0, p1, p2);
  };
  l.callableName = 'propertyReferenceOrNothing';
  return l;
}
function AglScopesSyntaxAnalyser$typeReference$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return typeReference($boundThis, p0, p1, p2);
  };
  l.callableName = 'typeReference';
  return l;
}
function AglScopesSyntaxAnalyser$propertyReference$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return propertyReference($boundThis, p0, p1, p2);
  };
  l.callableName = 'propertyReference';
  return l;
}
function ScopeModelAgl$Companion$fromString$lambda$lambda($context) {
  return function ($this$semanticAnalysis) {
    $this$semanticAnalysis.context($context);
    return Unit_getInstance();
  };
}
function ScopeModelAgl$Companion$fromString$lambda($context) {
  return function ($this$options) {
    $this$options.semanticAnalysis(ScopeModelAgl$Companion$fromString$lambda$lambda($context));
    return Unit_getInstance();
  };
}
var Companion_instance_15;
function Companion_getInstance_17() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
function _get_aglGrammarNamespace__uctayx($this) {
  var tmp = $this.r1n_1.namespace.u3($this.q1n_1);
  var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.y1('Internal error');
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function _get_aglStyleNamespace__s6eo75($this) {
  var tmp = $this.t1n_1.namespace.u3($this.s1n_1);
  var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.y1('');
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
var Companion_instance_16;
function Companion_getInstance_18() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function provideForTerminalItem($this, nextExpected, context) {
  var tmp0_elvis_lhs = _get_aglStyleNamespace__s6eo75(Companion_getInstance_18()).findTypeUsageForRule(nextExpected.owningRule.name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.y1('Should not be null');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var itemType = tmp;
  switch (nextExpected.owningRule.name) {
    case 'LITERAL':
      return LITERAL($this, nextExpected, itemType, context);
    case 'PATTERN':
      return PATTERN($this, nextExpected, itemType, context);
    case 'IDENTIFIER':
      return IDENTIFIER($this, nextExpected, itemType, context);
    case 'META_IDENTIFIER':
      return META_IDENTIFIER($this, nextExpected, itemType, context);
    case 'STYLE_ID':
      return STYLE_ID($this, nextExpected, itemType, context);
    case 'STYLE_VALUE':
      return STYLE_VALUE($this, nextExpected, itemType, context);
    case 'selectorAndComposition':
      return selectorAndComposition($this, nextExpected, itemType, context);
    case 'rule':
      return rule_0($this, nextExpected, itemType, context);
    case 'style':
      return style($this, nextExpected, itemType, context);
    default:
      return emptyList();
  }
}
function LITERAL($this, nextExpected, ti, context) {
  var tmp0_safe_receiver = context.rootScope.items.u3('LITERAL');
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3();
  var scopeItems = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(scopeItems, 10));
  var tmp0_iterator = scopeItems.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.LITERAL.<anonymous>' call
    // Inline function 'kotlin.also' call
    var tmp0_also = new CompletionItem(CompletionItemKind_LITERAL_getInstance(), item, 'LITERAL');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.LITERAL.<anonymous>.<anonymous>' call
    tmp0_also.description = 'Reference to a literal value used in the grammar. Literals are enclosed in single quotes or leaf rules.';
    tmp0_mapTo.e1(tmp0_also);
  }
  return tmp0_mapTo;
}
function PATTERN($this, nextExpected, ti, context) {
  var tmp0_safe_receiver = context.rootScope.items.u3('PATTERN');
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3();
  var scopeItems = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(scopeItems, 10));
  var tmp0_iterator = scopeItems.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.PATTERN.<anonymous>' call
    // Inline function 'kotlin.also' call
    var tmp0_also = new CompletionItem(CompletionItemKind_LITERAL_getInstance(), item, 'PATTERN');
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.PATTERN.<anonymous>.<anonymous>' call
    tmp0_also.description = 'Reference to a pattern value (regular expression) used in the grammar. Patterns are enclosed in double quotes or leaf rules.';
    tmp0_mapTo.e1(tmp0_also);
  }
  return tmp0_mapTo;
}
function IDENTIFIER($this, nextExpected, ti, context) {
  var tmp0_safe_receiver = context.rootScope.items.u3(Companion_getInstance_18().u1n_1.type.qualifiedName);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k3();
  var scopeItems = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(scopeItems, 10));
  var tmp0_iterator = scopeItems.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.agl.grammar.style.AglStyleCompletionProvider.IDENTIFIER.<anonymous>' call
    tmp$ret$0 = new CompletionItem(CompletionItemKind_LITERAL_getInstance(), item, Companion_getInstance_18().u1n_1.type.name);
    tmp0_mapTo.e1(tmp$ret$0);
  }
  return tmp0_mapTo;
}
function META_IDENTIFIER($this, nextExpected, ti, context) {
  return listOf(new CompletionItem(CompletionItemKind_LITERAL_getInstance(), '$keyword', 'META_IDENTIFIER'));
}
function STYLE_ID($this, nextExpected, ti, context) {
  return listOf_0([new CompletionItem(CompletionItemKind_LITERAL_getInstance(), 'foreground', 'STYLE_ID'), new CompletionItem(CompletionItemKind_LITERAL_getInstance(), 'background', 'STYLE_ID'), new CompletionItem(CompletionItemKind_LITERAL_getInstance(), 'font-style', 'STYLE_ID'), new CompletionItem(CompletionItemKind_SEGMENT_getInstance(), '<STYLE_ID>: <STYLE_VALUE>;', 'style')]);
}
function STYLE_VALUE($this, nextExpected, ti, context) {
  return listOf_0([new CompletionItem(CompletionItemKind_LITERAL_getInstance(), '<colour>', 'STYLE_VALUE'), new CompletionItem(CompletionItemKind_LITERAL_getInstance(), 'bold', 'STYLE_VALUE'), new CompletionItem(CompletionItemKind_LITERAL_getInstance(), 'italic', 'STYLE_VALUE')]);
}
function selectorAndComposition($this, nextExpected, ti, context) {
  return listOf(new CompletionItem(CompletionItemKind_LITERAL_getInstance(), ',', 'selectorAndComposition'));
}
function rule_0($this, nextExpected, ti, context) {
  var tmp;
  if (isInterface(nextExpected, Terminal)) {
    var tmp_0;
    switch (nextExpected.name) {
      case "'{'":
        tmp_0 = listOf_0([new CompletionItem(CompletionItemKind_LITERAL_getInstance(), '{', 'rule'), new CompletionItem(CompletionItemKind_SEGMENT_getInstance(), '{\n  <STYLE_ID>: <STYLE_VALUE>;\n}', 'rule')]);
        break;
      case "'}'":
        tmp_0 = listOf(new CompletionItem(CompletionItemKind_LITERAL_getInstance(), '}', 'rule'));
        break;
      default:
        var tmp0_error = 'Internal error: RuleItem ' + nextExpected + ' not handled';
        throw IllegalStateException.y1(toString(tmp0_error));
    }
    tmp = tmp_0;
  } else {
    var tmp1_error = 'Internal error: RuleItem ' + nextExpected + ' not handled';
    throw IllegalStateException.y1(toString(tmp1_error));
  }
  return tmp;
}
function style($this, nextExpected, ti, context) {
  var tmp;
  if (isInterface(nextExpected, Terminal)) {
    var tmp_0;
    switch (nextExpected.name) {
      case "':'":
        tmp_0 = listOf(new CompletionItem(CompletionItemKind_LITERAL_getInstance(), ':', 'style'));
        break;
      case "';'":
        tmp_0 = listOf(new CompletionItem(CompletionItemKind_LITERAL_getInstance(), ';', 'style'));
        break;
      default:
        var tmp0_error = 'Internal error: RuleItem ' + nextExpected + ' not handled';
        throw IllegalStateException.y1(toString(tmp0_error));
    }
    tmp = tmp_0;
  } else {
    var tmp1_error = 'Internal error: RuleItem ' + nextExpected + ' not handled';
    throw IllegalStateException.y1(toString(tmp1_error));
  }
  return tmp;
}
function createRules_2($this) {
  var b = new GrammarBuilderDefault(new NamespaceDefault('net.akehurst.language.agl'), 'AglStyle');
  b.skip('WHITESPACE').concatenation([b.terminalPattern('\\s+')]);
  b.skip('MULTI_LINE_COMMENT').concatenation([b.terminalPattern('/\\*[^*]*\\*+([^*/][^*]*\\*+)*/')]);
  b.skip('SINGLE_LINE_COMMENT').concatenation([b.terminalPattern('//[^\\n\\r]*')]);
  b.rule('rules').multi(0, -1, b.nonTerminal('rule'));
  b.rule('rule').concatenation([b.nonTerminal('selectorExpression'), b.terminalLiteral('{'), b.nonTerminal('styleList'), b.terminalLiteral('}')]);
  b.rule('selectorExpression').choiceLongestFromConcatenationItem([b.nonTerminal('selectorAndComposition'), b.nonTerminal('selectorSingle')]);
  b.rule('selectorAndComposition').separatedList(2, -1, b.terminalLiteral(','), b.nonTerminal('selectorSingle'));
  b.rule('selectorSingle').choiceLongestFromConcatenationItem([b.nonTerminal('LITERAL'), b.nonTerminal('PATTERN'), b.nonTerminal('IDENTIFIER'), b.nonTerminal('META_IDENTIFIER')]);
  b.leaf('LITERAL').concatenation([b.terminalPattern("'([^'\\\\]|\\\\.)*'")]);
  b.leaf('PATTERN').concatenation([b.terminalPattern('"([^"\\\\]|\\\\.)*"')]);
  b.leaf('IDENTIFIER').concatenation([b.terminalPattern('[a-zA-Z_][a-zA-Z_0-9-]*')]);
  b.leaf('META_IDENTIFIER').concatenation([b.terminalPattern('[\\$][a-zA-Z_][a-zA-Z_0-9-]*')]);
  b.rule('styleList').multi(0, -1, b.nonTerminal('style'));
  b.rule('style').concatenation([b.nonTerminal('STYLE_ID'), b.terminalLiteral(':'), b.nonTerminal('STYLE_VALUE'), b.terminalLiteral(';')]);
  b.leaf('STYLE_ID').concatenation([b.terminalPattern('[-a-zA-Z_][-a-zA-Z_0-9]*')]);
  b.leaf('STYLE_VALUE').concatenation([b.terminalPattern('[^;: \\t\\n\\x0B\\f\\r]+')]);
  return b.grammar.grammarRule;
}
var AglStyleGrammar_instance;
function AglStyleGrammar_getInstance() {
  if (AglStyleGrammar_instance === VOID)
    new AglStyleGrammar();
  return AglStyleGrammar_instance;
}
function _get_aglGrammarNamespace__uctayx_0($this) {
  var tmp = $this.m1o_1.namespace.u3($this.l1o_1);
  var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException.y1('Internal error');
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
var Companion_instance_17;
function Companion_getInstance_19() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
var Companion_instance_18;
function Companion_getInstance_20() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
function AglStyleSyntaxAnalyser$rules$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.v1o(p0, p1, p2);
  };
  l.callableName = 'rules';
  return l;
}
function AglStyleSyntaxAnalyser$rule$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.w1o(p0, p1, p2);
  };
  l.callableName = 'rule';
  return l;
}
function AglStyleSyntaxAnalyser$selectorExpression$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.x1o(p0, p1, p2);
  };
  l.callableName = 'selectorExpression';
  return l;
}
function AglStyleSyntaxAnalyser$selectorAndComposition$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.y1o(p0, p1, p2);
  };
  l.callableName = 'selectorAndComposition';
  return l;
}
function AglStyleSyntaxAnalyser$selectorSingle$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.z1o(p0, p1, p2);
  };
  l.callableName = 'selectorSingle';
  return l;
}
function AglStyleSyntaxAnalyser$styleList$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.a1p(p0, p1, p2);
  };
  l.callableName = 'styleList';
  return l;
}
function AglStyleSyntaxAnalyser$style$ref($boundThis) {
  var l = function (p0, p1, p2) {
    return $boundThis.b1p(p0, p1, p2);
  };
  l.callableName = 'style';
  return l;
}
function AglStyleModelDefault$Companion$fromString$lambda$lambda($context) {
  return function ($this$semanticAnalysis) {
    $this$semanticAnalysis.context($context);
    return Unit_getInstance();
  };
}
function AglStyleModelDefault$Companion$fromString$lambda($context) {
  return function ($this$options) {
    $this$options.semanticAnalysis(AglStyleModelDefault$Companion$fromString$lambda$lambda($context));
    return Unit_getInstance();
  };
}
var Companion_instance_19;
function Companion_getInstance_21() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
function AglStyleModelDefault$toString$lambda(it) {
  var tmp = it.styles.k3();
  var stylesStr = joinToString(tmp, '\n  ', VOID, VOID, VOID, VOID, AglStyleModelDefault$toString$lambda$lambda);
  return trimIndent('\n' + joinToString(it.selector, VOID, VOID, VOID, VOID, VOID, AglStyleModelDefault$toString$lambda$lambda_0) + ' {\n  ' + stylesStr + '\n}\n');
}
function AglStyleModelDefault$toString$lambda$lambda(it) {
  return it.name + ': ' + it.value + ';';
}
function AglStyleModelDefault$toString$lambda$lambda_0(it) {
  return it.value;
}
function GrammarTypeNamespaceAbstract$asString$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract.asString.<anonymous>' call
  var tmp = a.o3();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract.asString.<anonymous>' call
  tmp$ret$1 = b.o3();
  return compareValues(tmp, tmp$ret$1);
}
function GrammarTypeNamespaceAbstract$asString$lambda_0(this$0) {
  return function (it) {
    return it.o3() + '->' + it.p3().signature(this$0, 0);
  };
}
function GrammarTypeNamespaceAbstract$asString$lambda_1(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract.asString.<anonymous>' call
  var tmp = a.o3();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.grammarTypeModel.GrammarTypeNamespaceAbstract.asString.<anonymous>' call
  tmp$ret$1 = b.o3();
  return compareValues(tmp, tmp$ret$1);
}
function GrammarTypeNamespaceAbstract$asString$lambda_2(this$0) {
  return function (it) {
    return it.p3().asString(this$0);
  };
}
function InputFromString$Companion$eolPositions$lambda(it) {
  return it.qb().sc_1;
}
var Companion_instance_20;
function Companion_getInstance_22() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function matchLiteral($this, position, terminalRule) {
  var rhs = terminalRule.i11();
  var tmp;
  if (rhs instanceof RuntimeRuleRhsLiteral) {
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    var tmp0_isEmpty = rhs.n12_1;
    if (charSequenceLength(tmp0_isEmpty) === 0) {
      throw IllegalStateException.y1('Zero length literals are not permitted.');
    } else {
      var match = $this.t1p(position, terminalRule);
      var tmp_1;
      if (match) {
        var tmp_2 = terminalRule.i11();
        var text = (tmp_2 instanceof RuntimeRuleRhsLiteral ? tmp_2 : THROW_CCE()).n12_1;
        var eolPositions = emptyList();
        tmp_1 = new MatchResult(text, eolPositions);
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  } else {
    throw IllegalStateException.y1('Should not happen');
  }
  return tmp;
}
function matchRegEx2($this, position, regex) {
  var tmp0_safe_receiver = regex.nb($this.r1p_1.u1p(), position);
  var matchedText = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p3();
  var tmp;
  if (null == matchedText ? true : 0 === matchedText.length) {
    tmp = null;
  } else {
    var eolPositions = Companion_getInstance_22().p1p(matchedText);
    tmp = new MatchResult(matchedText, eolPositions);
  }
  return tmp;
}
function tryCreateLeaf($this, terminalRuntimeRule, atInputPosition) {
  var tmp;
  var tmp_0 = terminalRuntimeRule.i11();
  if (tmp_0 instanceof RuntimeRuleRhsEmpty) {
    var leaf = new CompleteTreeDataNode(terminalRuntimeRule, atInputPosition, atInputPosition, atInputPosition, 0);
    $this.s1p_1.c1q(terminalRuntimeRule, atInputPosition, leaf);
    tmp = leaf;
  } else {
    var match = $this.v1p(atInputPosition, terminalRuntimeRule);
    var tmp_1;
    if (null == match) {
      $this.s1p_1.c1q(terminalRuntimeRule, atInputPosition, Companion_getInstance_22().o1p_1);
      tmp_1 = Companion_getInstance_22().o1p_1;
    } else {
      var nextInputPosition = atInputPosition + match.matchedText.length | 0;
      var leaf_0 = new CompleteTreeDataNode(terminalRuntimeRule, atInputPosition, nextInputPosition, nextInputPosition, 0);
      $this.s1p_1.c1q(terminalRuntimeRule, atInputPosition, leaf_0);
      tmp_1 = leaf_0;
    }
    tmp = tmp_1;
  }
  return tmp;
}
var Companion_instance_21;
function Companion_getInstance_23() {
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
function growHead($this, head, possibleEndOfText, growArgs) {
  return head.cy() ? growGoal($this, head, possibleEndOfText, growArgs) : head.c1r() ? growComplete($this, head, possibleEndOfText, growArgs) : growIncomplete($this, head, possibleEndOfText, growArgs);
}
function growGoal($this, head, possibleEndOfText, growArgs) {
  var tmp;
  if (head.c1r()) {
    $this.j1r_1.b1s(head);
    $this.j1r_1.c1s(head);
    Debug_getInstance();
    if (false) {
      var tmp_0 = Debug_getInstance();
      var tmp_1 = IndentDelta_NONE_getInstance();
      tmp_0.uz(tmp_1, RuntimeParser$growGoal$lambda(head));
    }
    tmp = false;
  } else {
    var grown = false;
    // Inline function 'kotlin.collections.mutableSetOf' call
    var transTaken = LinkedHashSet.r8();
    var transitions = head.u1q_1.i14($this.d1r_1.w14());
    Debug_getInstance();
    if (false) {
      var tmp_2 = Debug_getInstance();
      var tmp_3 = IndentDelta_NONE_getInstance();
      tmp_2.uz(tmp_3, RuntimeParser$growGoal$lambda_0(transitions));
    }
    var tmp0_iterator = transitions.u();
    while (tmp0_iterator.h1()) {
      var tr = tmp0_iterator.j1();
      var tmp_4;
      switch (tr.g15_1.bc_1) {
        case 2:
          tmp_4 = doWidth($this, head, tr, possibleEndOfText, growArgs);
          break;
        case 4:
          tmp_4 = $this.u1r(head, tr, possibleEndOfText, growArgs);
          break;
        default:
          throw IllegalStateException.y1('Internal Error: should only have WIDTH or EMBED transitions here');
      }
      var b = tmp_4;
      if (b) {
        transTaken.e1(tr);
      }
      grown = grown ? true : b;
    }
    if (growArgs.p1q_1 ? transTaken.o() > 1 : false) {
      ambiguity($this, head, transTaken, possibleEndOfText);
    }
    if (!grown) {
      doNoTransitionsTaken($this, head);
    }
    tmp = grown;
  }
  return tmp;
}
function growIncomplete($this, head, possibleEndOfText, growArgs) {
  var grown = false;
  var prevSet = $this.j1r_1.d1s(head);
  // Inline function 'kotlin.collections.mutableSetOf' call
  var transTaken = LinkedHashSet.r8();
  var tmp0_iterator = prevSet.u();
  while (tmp0_iterator.h1()) {
    var previous = tmp0_iterator.j1();
    var transitions = head.u1q_1.o14(previous.e1s());
    Debug_getInstance();
    if (false) {
      var tmp = Debug_getInstance();
      var tmp_0 = IndentDelta_NONE_getInstance();
      tmp.uz(tmp_0, RuntimeParser$growIncomplete$lambda(transitions));
    }
    var tmp1_iterator = transitions.u();
    while (tmp1_iterator.h1()) {
      var tr = tmp1_iterator.j1();
      var tmp_1;
      switch (tr.g15_1.bc_1) {
        case 2:
          tmp_1 = doWidth($this, head, tr, possibleEndOfText, growArgs);
          break;
        case 4:
          tmp_1 = $this.u1r(head, tr, possibleEndOfText, growArgs);
          break;
        default:
          throw IllegalStateException.y1('Internal Error: should only have WIDTH or EMBED transitions here');
      }
      var b = tmp_1;
      if (b) {
        transTaken.e1(tr);
      }
      grown = grown ? true : b;
    }
  }
  if (growArgs.p1q_1 ? transTaken.o() > 1 : false) {
    ambiguity($this, head, transTaken, possibleEndOfText);
  }
  if (!grown) {
    doNoTransitionsTaken($this, head);
  }
  return grown;
}
function growComplete($this, head, possibleEndOfText, growArgs) {
  var headGrownHeight = false;
  var headGrownGraft = false;
  var prevSet = $this.j1r_1.d1s(head);
  // Inline function 'kotlin.collections.mutableMapOf' call
  var dropPrevs = LinkedHashMap.n8();
  var tmp0_iterator = prevSet.u();
  while (tmp0_iterator.h1()) {
    var previous = tmp0_iterator.j1();
    var prevGrownHeight = false;
    var prevGrownGraft = false;
    var prevPrevSet = $this.j1r_1.d1s(previous);
    if (prevPrevSet.y()) {
      var tmp1_container = growComplete2($this, head, previous, null, possibleEndOfText, growArgs);
      var h = tmp1_container.ti();
      var g = tmp1_container.ui();
      prevGrownHeight = prevGrownHeight ? true : h;
      prevGrownGraft = prevGrownGraft ? true : g;
    } else {
      var tmp2_iterator = prevPrevSet.u();
      while (tmp2_iterator.h1()) {
        var prevPrev = tmp2_iterator.j1();
        var tmp3_container = growComplete2($this, head, previous, prevPrev, possibleEndOfText, growArgs);
        var h_0 = tmp3_container.ti();
        var g_0 = tmp3_container.ui();
        prevGrownHeight = prevGrownHeight ? true : h_0;
        prevGrownGraft = prevGrownGraft ? true : g_0;
      }
    }
    if (!prevGrownHeight) {
      // Inline function 'kotlin.collections.set' call
      var tmp0_set = prevGrownGraft;
      dropPrevs.m3(previous, tmp0_set);
    }
    headGrownHeight = headGrownHeight ? true : prevGrownHeight;
    headGrownGraft = headGrownGraft ? true : prevGrownGraft;
  }
  if (!headGrownHeight ? !headGrownGraft : false) {
    doNoTransitionsTaken($this, head);
  } else if (headGrownHeight ? !headGrownGraft : false) {
    $this.j1r_1.c1s(head);
    Debug_getInstance();
    if (false) {
      var tmp = Debug_getInstance();
      var tmp_0 = IndentDelta_NONE_getInstance();
      tmp.uz(tmp_0, RuntimeParser$growComplete$lambda(head));
    }
  } else if (!headGrownHeight ? headGrownGraft : false) {
    $this.j1r_1.c1s(head);
    Debug_getInstance();
    if (false) {
      var tmp_1 = Debug_getInstance();
      var tmp_2 = IndentDelta_NONE_getInstance();
      tmp_1.uz(tmp_2, RuntimeParser$growComplete$lambda_0(head));
    }
  } else if (headGrownHeight ? headGrownGraft : false) {
    $this.j1r_1.c1s(head);
    Debug_getInstance();
    if (false) {
      var tmp_3 = Debug_getInstance();
      var tmp_4 = IndentDelta_NONE_getInstance();
      tmp_3.uz(tmp_4, RuntimeParser$growComplete$lambda_1(head));
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = dropPrevs.l3().u();
  while (tmp0_iterator_0.h1()) {
    var element = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete.<anonymous>' call
    if (element.p3()) {
      $this.j1r_1.c1s(element.o3());
      Debug_getInstance();
      if (false) {
        var tmp_5 = Debug_getInstance();
        var tmp_6 = IndentDelta_NONE_getInstance();
        tmp_5.uz(tmp_6, RuntimeParser$growComplete$lambda_2(element));
      }
    } else {
      doNoTransitionsTaken($this, element.o3());
    }
  }
  return headGrownHeight ? true : headGrownGraft;
}
function matchedLookahead($this, position, lookahead, possibleEndOfText, runtimeLhs) {
  var tmp;
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(lookahead, 10));
  var tmp0_iterator = lookahead.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    tmp$ret$0 = item.t11_1.q13();
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var accumulator = Companion_getInstance_8().xw_1;
  var tmp0_iterator_0 = tmp0_mapTo.u();
  while (tmp0_iterator_0.h1()) {
    var element = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    accumulator = accumulator.iy(element);
  }
  var lh = accumulator;
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
  var tmp0_iterator_1 = possibleEndOfText.u();
  while (tmp0_iterator_1.h1()) {
    var item_0 = tmp0_iterator_1.j1();
    var tmp$ret$5;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    tmp$ret$5 = item_0.q13();
    tmp0_mapTo_0.e1(tmp$ret$5);
  }
  var accumulator_0 = Companion_getInstance_8().xw_1;
  var tmp0_iterator_2 = tmp0_mapTo_0.u();
  while (tmp0_iterator_2.h1()) {
    var element_0 = tmp0_iterator_2.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    accumulator_0 = accumulator_0.iy(element_0);
  }
  var eot = accumulator_0;
  // Inline function 'kotlin.collections.fold' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(runtimeLhs, 10));
  var tmp0_iterator_3 = runtimeLhs.u();
  while (tmp0_iterator_3.h1()) {
    var item_1 = tmp0_iterator_3.j1();
    var tmp$ret$10;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    tmp$ret$10 = item_1.q13();
    tmp0_mapTo_1.e1(tmp$ret$10);
  }
  var accumulator_1 = Companion_getInstance_8().xw_1;
  var tmp0_iterator_4 = tmp0_mapTo_1.u();
  while (tmp0_iterator_4.h1()) {
    var element_1 = tmp0_iterator_4.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.matchedLookahead.<anonymous>' call
    accumulator_1 = accumulator_1.iy(element_1);
  }
  var rt = accumulator_1;
  var lookingAt = $this.j1r_1.f1s(lh, eot, rt, position);
  var resolved = lh.l17(eot, rt);
  tmp = new Pair(lookingAt, resolved);
  return tmp;
}
function growComplete2($this, head, previous, prevPrev, possibleEndOfText, parseArgs) {
  var grownHeight = false;
  var grownGraft = false;
  var tmp = previous.e1s();
  var tmp1_elvis_lhs = prevPrev == null ? null : prevPrev.e1s();
  var transitions = head.u1q_1.q14(tmp, tmp1_elvis_lhs == null ? $this.d1r_1.w14() : tmp1_elvis_lhs);
  var tmp_0;
  if (parseArgs.l1q_1) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(transitions, 10));
    var tmp0_iterator = transitions.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
      tmp$ret$0 = new Pair(item, Companion_getInstance_8().zw_1);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp_0 = tmp0_mapTo;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = transitions.u();
    while (tmp0_iterator_0.h1()) {
      var element = tmp0_iterator_0.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
      var lh = matchedLookahead($this, head.x1q_1, element.h15_1, possibleEndOfText, previous.u1q_1.r1r_1);
      var tmp0_safe_receiver = lh.ri_1 ? new Pair(element, lh.si_1) : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
      }
    }
    tmp_0 = tmp0_mapNotNullTo;
  }
  var transWithValidLookahead = tmp_0;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(transWithValidLookahead, 10));
  var tmp0_iterator_1 = transWithValidLookahead.u();
  while (tmp0_iterator_1.h1()) {
    var item_0 = tmp0_iterator_1.j1();
    var tmp$ret$7;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
    tmp$ret$7 = item_0.ri_1;
    tmp0_mapTo_0.e1(tmp$ret$7);
  }
  var tmp0_iterator_2 = minus_0(transitions, tmp0_mapTo_0).u();
  while (tmp0_iterator_2.h1()) {
    var element_0 = tmp0_iterator_2.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
    switch (element_0.g15_1.bc_1) {
      case 0:
        recordFailedHeightLh($this, parseArgs, head.x1q_1, element_0, previous.u1q_1.r1r_1, possibleEndOfText);
        break;
      case 1:
        recordFailedGraftLH($this, parseArgs, head.x1q_1, element_0, previous.u1q_1.r1r_1, possibleEndOfText);
        break;
      case 3:
        recordFailedGraftLH($this, parseArgs, head.x1q_1, element_0, previous.u1q_1.r1r_1, possibleEndOfText);
        break;
      default:
        // Inline function 'kotlin.error' call

        throw IllegalStateException.y1('Internal Error: should never happen');
    }
  }
  var trans2 = resolvePrecedence($this, transWithValidLookahead, head);
  Debug_getInstance();
  if (false) {
    var tmp_1 = Debug_getInstance();
    var tmp_2 = IndentDelta_NONE_getInstance();
    tmp_1.uz(tmp_2, RuntimeParser$growComplete2$lambda(trans2));
  }
  if (parseArgs.p1q_1 ? trans2.o() > 1 : false) {
    ambiguity($this, head, trans2, possibleEndOfText);
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var tmp0_groupByTo = LinkedHashMap.n8();
  var tmp0_iterator_3 = trans2.u();
  while (tmp0_iterator_3.h1()) {
    var element_1 = tmp0_iterator_3.j1();
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
    var key = element_1.f15_1.c14();
    // Inline function 'kotlin.collections.getOrPut' call
    var value = tmp0_groupByTo.u3(key);
    var tmp_3;
    if (value == null) {
      // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
      var answer = ArrayList.i4();
      tmp0_groupByTo.m3(key, answer);
      tmp_3 = answer;
    } else {
      tmp_3 = value;
    }
    var list = tmp_3;
    list.e1(element_1);
  }
  var grouped = tmp0_groupByTo;
  // Inline function 'kotlin.collections.iterator' call
  var tmp2_iterator = grouped.l3().u();
  while (tmp2_iterator.h1()) {
    var grp = tmp2_iterator.j1();
    if (1 === grp.p3().o()) {
      var tr = grp.p3().p(0);
      switch (tr.g15_1.bc_1) {
        case 0:
          var b = doHeight($this, head, previous, tr, possibleEndOfText, parseArgs);
          grownHeight = grownHeight ? true : b;
          break;
        case 1:
          var b_0 = doGraft($this, head, previous, prevPrev, tr, possibleEndOfText, parseArgs);
          grownGraft = grownGraft ? true : b_0;
          break;
        case 3:
          var b_1 = doGoal($this, head, previous, tr, possibleEndOfText, parseArgs);
          grownGraft = grownGraft ? true : b_1;
          break;
        default:
          // Inline function 'kotlin.error' call

          throw IllegalStateException.y1('Internal Error: should only have GOAL, HEIGHT or GRAFT transitions here');
      }
    } else {
      // Inline function 'kotlin.collections.filter' call
      var tmp1_filter = grp.p3();
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList.i4();
      var tmp0_iterator_4 = tmp1_filter.u();
      while (tmp0_iterator_4.h1()) {
        var element_2 = tmp0_iterator_4.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
        if (element_2.g15_1.equals(ParseAction_GRAFT_getInstance())) {
          tmp0_filterTo.e1(element_2);
        }
      }
      var tmp_4 = tmp0_filterTo;
      var tmp_5 = RuntimeParser$growComplete2$lambda_0;
      var trgs = sortedWith(tmp_4, new sam$kotlin_Comparator$0_3(tmp_5));
      // Inline function 'kotlin.collections.filter' call
      var tmp2_filter = grp.p3();
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo_0 = ArrayList.i4();
      var tmp0_iterator_5 = tmp2_filter.u();
      while (tmp0_iterator_5.h1()) {
        var element_3 = tmp0_iterator_5.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.growComplete2.<anonymous>' call
        if (element_3.g15_1.equals(ParseAction_HEIGHT_getInstance())) {
          tmp0_filterTo_0.e1(element_3);
        }
      }
      var trhs = tmp0_filterTo_0;
      var tmp_6;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!trgs.y()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_6 = !trhs.y();
      } else {
        tmp_6 = false;
      }
      if (tmp_6) {
        var doneIt = false;
        var i = 0;
        while (!doneIt ? i < trgs.o() : false) {
          var b_2 = doGraft($this, head, previous, prevPrev, trgs.p(i), possibleEndOfText, parseArgs);
          grownGraft = grownGraft ? true : b_2;
          doneIt = doneIt ? true : b_2;
          i = i + 1 | 0;
        }
        i = 0;
        while (!doneIt ? i < trhs.o() : false) {
          var b_3 = doHeight($this, head, previous, trhs.p(i), possibleEndOfText, parseArgs);
          grownHeight = grownHeight ? true : b_3;
          doneIt = doneIt ? true : b_3;
          i = i + 1 | 0;
        }
      } else {
        var tmp4_iterator = grp.p3().u();
        while (tmp4_iterator.h1()) {
          var tr_0 = tmp4_iterator.j1();
          switch (tr_0.g15_1.bc_1) {
            case 0:
              var b_4 = doHeight($this, head, previous, tr_0, possibleEndOfText, parseArgs);
              grownHeight = grownHeight ? true : b_4;
              break;
            case 1:
              var b_5 = doGraft($this, head, previous, prevPrev, tr_0, possibleEndOfText, parseArgs);
              grownGraft = grownGraft ? true : b_5;
              break;
            case 3:
              var b_6 = doGoal($this, head, previous, tr_0, possibleEndOfText, parseArgs);
              grownGraft = grownGraft ? true : b_6;
              break;
            default:
              // Inline function 'kotlin.error' call

              throw IllegalStateException.y1('Internal Error: should only have HEIGHT or GRAFT or GOAL transitions here');
          }
        }
      }
    }
  }
  return new Pair(grownHeight, grownGraft);
}
function resolvePrecedence($this, transitions, head) {
  var tmp;
  if (2 > transitions.o()) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(transitions, 10));
    var tmp0_iterator = transitions.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
      tmp$ret$0 = item.ri_1;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp = tmp0_mapTo;
  } else {
    var precRules = $this.d1r_1.r15(head.e1s());
    var tmp_0;
    if (null == precRules) {
      // Inline function 'kotlin.collections.groupBy' call
      // Inline function 'kotlin.collections.groupByTo' call
      var tmp0_groupByTo = LinkedHashMap.n8();
      var tmp0_iterator_0 = transitions.u();
      while (tmp0_iterator_0.h1()) {
        var element = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        var key = element.ri_1.f15_1.c14();
        // Inline function 'kotlin.collections.getOrPut' call
        var value = tmp0_groupByTo.u3(key);
        var tmp_1;
        if (value == null) {
          // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
          var answer = ArrayList.i4();
          tmp0_groupByTo.m3(key, answer);
          tmp_1 = answer;
        } else {
          tmp_1 = value;
        }
        var list = tmp_1;
        list.e1(element);
      }
      var toGrp = tmp0_groupByTo;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo = ArrayList.i4();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = toGrp.l3().u();
      while (tmp0_iterator_1.h1()) {
        var element_0 = tmp0_iterator_1.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        // Inline function 'kotlin.collections.groupBy' call
        var tmp0_groupBy = element_0.p3();
        // Inline function 'kotlin.collections.groupByTo' call
        var tmp0_groupByTo_0 = LinkedHashMap.n8();
        var tmp0_iterator_2 = tmp0_groupBy.u();
        while (tmp0_iterator_2.h1()) {
          var element_1 = tmp0_iterator_2.j1();
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
          var key_0 = element_1.ri_1.g15_1;
          // Inline function 'kotlin.collections.getOrPut' call
          var value_0 = tmp0_groupByTo_0.u3(key_0);
          var tmp_2;
          if (value_0 == null) {
            // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
            var answer_0 = ArrayList.i4();
            tmp0_groupByTo_0.m3(key_0, answer_0);
            tmp_2 = answer_0;
          } else {
            tmp_2 = value_0;
          }
          var list_0 = tmp_2;
          list_0.e1(element_1);
        }
        var actGrp = tmp0_groupByTo_0;
        var tmp_3;
        if (2 > actGrp.o()) {
          // Inline function 'kotlin.collections.map' call
          var tmp1_map = element_0.p3();
          // Inline function 'kotlin.collections.mapTo' call
          var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp1_map, 10));
          var tmp0_iterator_3 = tmp1_map.u();
          while (tmp0_iterator_3.h1()) {
            var item_0 = tmp0_iterator_3.j1();
            var tmp$ret$14;
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
            tmp$ret$14 = item_0.ri_1;
            tmp0_mapTo_0.e1(tmp$ret$14);
          }
          tmp_3 = tmp0_mapTo_0;
        } else {
          var grafts = ensureNotNull(actGrp.u3(ParseAction_GRAFT_getInstance()));
          var tmp_4 = RuntimeParser$resolvePrecedence$lambda;
          sortedWith(grafts, new sam$kotlin_Comparator$0_4(tmp_4));
          tmp_3 = listOf(last(grafts).ri_1);
        }
        var list_1 = tmp_3;
        addAll(tmp0_flatMapTo, list_1);
      }
      tmp_0 = tmp0_flatMapTo;
    } else if (2 > transitions.o()) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(transitions, 10));
      var tmp0_iterator_4 = transitions.u();
      while (tmp0_iterator_4.h1()) {
        var item_1 = tmp0_iterator_4.j1();
        var tmp$ret$20;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        tmp$ret$20 = item_1.ri_1;
        tmp0_mapTo_1.e1(tmp$ret$20);
      }
      tmp_0 = tmp0_mapTo_1;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_5 = transitions.u();
      while (tmp0_iterator_5.h1()) {
        var element_2 = tmp0_iterator_5.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        var tr = element_2.ti();
        var lh = element_2.ui();
        var lhf = lh;
        var prec = precRules.i1s(tr.f15_1.yy_1, lhf);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(prec, 10));
        var tmp0_iterator_6 = prec.u();
        while (tmp0_iterator_6.h1()) {
          var item_2 = tmp0_iterator_6.j1();
          var tmp$ret$23;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
          tmp$ret$23 = new Pair(tr, item_2);
          tmp0_mapTo_2.e1(tmp$ret$23);
        }
        var list_2 = tmp0_mapTo_2;
        addAll(tmp0_flatMapTo_0, list_2);
      }
      var precedence = tmp0_flatMapTo_0;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo_3 = ArrayList.f4(collectionSizeOrDefault(precedence, 10));
      var tmp0_iterator_7 = precedence.u();
      while (tmp0_iterator_7.h1()) {
        var item_3 = tmp0_iterator_7.j1();
        var tmp$ret$29;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        tmp$ret$29 = item_3.si_1.j1s_1;
        tmp0_mapTo_3.e1(tmp$ret$29);
      }
      var tmp0_elvis_lhs = maxOrNull(tmp0_mapTo_3);
      var max = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList.i4();
      var tmp0_iterator_8 = precedence.u();
      while (tmp0_iterator_8.h1()) {
        var element_3 = tmp0_iterator_8.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        if (max === element_3.si_1.j1s_1) {
          tmp0_filterTo.e1(element_3);
        }
      }
      var maxPrec = tmp0_filterTo;
      // Inline function 'kotlin.collections.groupBy' call
      // Inline function 'kotlin.collections.groupByTo' call
      var tmp0_groupByTo_1 = LinkedHashMap.n8();
      var tmp0_iterator_9 = maxPrec.u();
      while (tmp0_iterator_9.h1()) {
        var element_4 = tmp0_iterator_9.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        var key_1 = new Pair(element_4.ri_1.f15_1.lz(), element_4.si_1.n1s_1);
        // Inline function 'kotlin.collections.getOrPut' call
        var value_1 = tmp0_groupByTo_1.u3(key_1);
        var tmp_5;
        if (value_1 == null) {
          // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
          var answer_1 = ArrayList.i4();
          tmp0_groupByTo_1.m3(key_1, answer_1);
          tmp_5 = answer_1;
        } else {
          tmp_5 = value_1;
        }
        var list_3 = tmp_5;
        list_3.e1(element_4);
      }
      var byTarget = tmp0_groupByTo_1;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_1 = ArrayList.i4();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_10 = byTarget.l3().u();
      while (tmp0_iterator_10.h1()) {
        var element_5 = tmp0_iterator_10.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
        var tmp_6;
        switch (element_5.o3().si_1.bc_1) {
          case 0:
            tmp_6 = element_5.p3();
            break;
          case 1:
            var tmp_7;
            if (element_5.o3().ri_1.p(0).gn()) {
              // Inline function 'kotlin.collections.filter' call
              var tmp0_filter = element_5.p3();
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_0 = ArrayList.i4();
              var tmp0_iterator_11 = tmp0_filter.u();
              while (tmp0_iterator_11.h1()) {
                var element_6 = tmp0_iterator_11.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (element_6.ri_1.g15_1.equals(ParseAction_GRAFT_getInstance())) {
                  tmp0_filterTo_0.e1(element_6);
                }
              }
              var grafts_0 = tmp0_filterTo_0;
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_1 = ArrayList.i4();
              var tmp0_iterator_12 = grafts_0.u();
              while (tmp0_iterator_12.h1()) {
                var element_7 = tmp0_iterator_12.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (!element_7.ri_1.f15_1.yy_1.p(0).vx()) {
                  tmp0_filterTo_1.e1(element_7);
                }
              }
              var left = tmp0_filterTo_1;
              var tmp_8;
              switch (left.y()) {
                case true:
                  tmp_8 = grafts_0;
                  break;
                case false:
                  tmp_8 = left;
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp_7 = tmp_8;
            } else {
              // Inline function 'kotlin.collections.filter' call
              var tmp1_filter = element_5.p3();
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_2 = ArrayList.i4();
              var tmp0_iterator_13 = tmp1_filter.u();
              while (tmp0_iterator_13.h1()) {
                var element_8 = tmp0_iterator_13.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (element_8.ri_1.g15_1.equals(ParseAction_GRAFT_getInstance())) {
                  tmp0_filterTo_2.e1(element_8);
                }
              }
              tmp_7 = tmp0_filterTo_2;
            }

            tmp_6 = tmp_7;
            break;
          case 2:
            var tmp_9;
            if (element_5.o3().ri_1.p(0).gn()) {
              // Inline function 'kotlin.collections.filter' call
              var tmp2_filter = element_5.p3();
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_3 = ArrayList.i4();
              var tmp0_iterator_14 = tmp2_filter.u();
              while (tmp0_iterator_14.h1()) {
                var element_9 = tmp0_iterator_14.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (element_9.ri_1.g15_1.equals(ParseAction_HEIGHT_getInstance())) {
                  tmp0_filterTo_3.e1(element_9);
                }
              }
              var heights = tmp0_filterTo_3;
              // Inline function 'kotlin.collections.filter' call
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_4 = ArrayList.i4();
              var tmp0_iterator_15 = heights.u();
              while (tmp0_iterator_15.h1()) {
                var element_10 = tmp0_iterator_15.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (!element_10.ri_1.f15_1.yy_1.p(0).vx()) {
                  tmp0_filterTo_4.e1(element_10);
                }
              }
              var right = tmp0_filterTo_4;
              var tmp_10;
              switch (right.y()) {
                case true:
                  tmp_10 = heights;
                  break;
                case false:
                  tmp_10 = right;
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp_9 = tmp_10;
            } else {
              // Inline function 'kotlin.collections.filter' call
              var tmp3_filter = element_5.p3();
              // Inline function 'kotlin.collections.filterTo' call
              var tmp0_filterTo_5 = ArrayList.i4();
              var tmp0_iterator_16 = tmp3_filter.u();
              while (tmp0_iterator_16.h1()) {
                var element_11 = tmp0_iterator_16.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>.<anonymous>' call
                if (element_11.ri_1.g15_1.equals(ParseAction_HEIGHT_getInstance())) {
                  tmp0_filterTo_5.e1(element_11);
                }
              }
              tmp_9 = tmp0_filterTo_5;
            }

            tmp_6 = tmp_9;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var list_4 = tmp_6;
        addAll(tmp0_flatMapTo_1, list_4);
      }
      var assoc = tmp0_flatMapTo_1;
      var tmp_11;
      if (assoc.o() === 0) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_4 = ArrayList.f4(collectionSizeOrDefault(maxPrec, 10));
        var tmp0_iterator_17 = maxPrec.u();
        while (tmp0_iterator_17.h1()) {
          var item_4 = tmp0_iterator_17.j1();
          var tmp$ret$62;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
          tmp$ret$62 = item_4.ri_1;
          tmp0_mapTo_4.e1(tmp$ret$62);
        }
        tmp_11 = tmp0_mapTo_4;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_5 = ArrayList.f4(collectionSizeOrDefault(assoc, 10));
        var tmp0_iterator_18 = assoc.u();
        while (tmp0_iterator_18.h1()) {
          var item_5 = tmp0_iterator_18.j1();
          var tmp$ret$65;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.resolvePrecedence.<anonymous>' call
          tmp$ret$65 = item_5.ri_1;
          tmp0_mapTo_5.e1(tmp$ret$65);
        }
        tmp_11 = tmp0_mapTo_5;
      }
      tmp_0 = tmp_11;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function doNoTransitionsTaken($this, head) {
  $this.j1r_1.c1s(head);
  Debug_getInstance();
  if (false) {
    var tmp = Debug_getInstance();
    var tmp_0 = IndentDelta_NONE_getInstance();
    tmp.uz(tmp_0, RuntimeParser$doNoTransitionsTaken$lambda(head));
  }
}
function doGoal($this, head, previous, transition, possibleEndOfText, growArgs) {
  var tmp;
  if (growArgs.n1q_1) {
    tmp = false;
  } else {
    var tmp_0;
    if (transition.j15_1.g16(ensureNotNull(previous).y1q_1)) {
      var runtimeLhs = head.u1q_1.r1r_1;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_filter = transition.h15_1;
      // Inline function 'kotlin.collections.filterTo' call
      var tmp0_filterTo = ArrayList.i4();
      var tmp0_iterator = tmp0_filter.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doGoal.<anonymous>' call
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(possibleEndOfText, Collection)) {
            tmp_1 = possibleEndOfText.y();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          var tmp0_iterator_0 = possibleEndOfText.u();
          while (tmp0_iterator_0.h1()) {
            var element_0 = tmp0_iterator_0.j1();
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doGoal.<anonymous>.<anonymous>' call
            var tmp$ret$1;
            $l$block_1: {
              // Inline function 'kotlin.collections.any' call
              var tmp_2;
              if (isInterface(runtimeLhs, Collection)) {
                tmp_2 = runtimeLhs.y();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$1 = false;
                break $l$block_1;
              }
              var tmp0_iterator_1 = runtimeLhs.u();
              while (tmp0_iterator_1.h1()) {
                var element_1 = tmp0_iterator_1.j1();
                // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doGoal.<anonymous>.<anonymous>.<anonymous>' call
                if ($this.j1r_1.o1s(element.t11_1, element_0, element_1, head.x1q_1)) {
                  tmp$ret$1 = true;
                  break $l$block_1;
                }
              }
              tmp$ret$1 = false;
            }
            if (tmp$ret$1) {
              tmp$ret$0 = true;
              break $l$block_2;
            }
          }
          tmp$ret$0 = false;
        }
        if (tmp$ret$0) {
          tmp0_filterTo.e1(element);
        }
      }
      var lhWithMatch = tmp0_filterTo;
      // Inline function 'kotlin.collections.isNotEmpty' call
      var hasLh = !lhWithMatch.y();
      var tmp_3;
      if (growArgs.l1q_1 ? true : hasLh) {
        Debug_getInstance();
        if (false) {
          var tmp_4 = Debug_getInstance();
          var tmp_5 = IndentDelta_NONE_getInstance();
          tmp_4.uz(tmp_5, RuntimeParser$doGoal$lambda(head, transition));
        }
        tmp_3 = $this.j1r_1.p1s(head, previous, null, transition.f15_1, runtimeLhs, growArgs.k1q_1);
      } else {
        tmp_3 = false;
      }
      tmp_0 = tmp_3;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function doWidth($this, head, transition, possibleEndOfText, parseArgs) {
  var tmp;
  if (parseArgs.m1q_1) {
    tmp = false;
  } else if (parseArgs.n1q_1 ? transition.f15_1.z13().q11() : false) {
    tmp = false;
  } else {
    var l = $this.j1r_1.v1r_1.h1q(transition.f15_1.z13(), head.x1q_1);
    var tmp_0;
    if (!(null == l)) {
      // Inline function 'kotlin.collections.reduce' call
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = transition.h15_1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>' call
        tmp$ret$0 = item.t11_1;
        tmp0_mapTo.e1(tmp$ret$0);
      }
      var iterator = tmp0_mapTo.u();
      if (!iterator.h1())
        throw UnsupportedOperationException.j6("Empty collection can't be reduced.");
      var accumulator = iterator.j1();
      while (iterator.h1()) {
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>' call
        var tmp2_anonymous = accumulator;
        var tmp3_anonymous = iterator.j1();
        accumulator = tmp2_anonymous.k12($this.d1r_1, tmp3_anonymous);
      }
      var lh = accumulator;
      var runtimeLhs = head.u1q_1.r1r_1;
      var skipData = $this.w1s(l.s1s_1, runtimeLhs, lh, possibleEndOfText, parseArgs);
      var tmp1_safe_receiver = skipData == null ? null : skipData.root;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.d1t_1;
      var nextInputPositionAfterSkip = tmp2_elvis_lhs == null ? l.s1s_1 : tmp2_elvis_lhs;
      var tmp$ret$5;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(possibleEndOfText, Collection)) {
          tmp_1 = possibleEndOfText.y();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$5 = false;
          break $l$block_2;
        }
        var tmp0_iterator_0 = possibleEndOfText.u();
        while (tmp0_iterator_0.h1()) {
          var element = tmp0_iterator_0.j1();
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>' call
          var tmp$ret$6;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_2;
            if (isInterface(runtimeLhs, Collection)) {
              tmp_2 = runtimeLhs.y();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$6 = false;
              break $l$block_1;
            }
            var tmp0_iterator_1 = runtimeLhs.u();
            while (tmp0_iterator_1.h1()) {
              var element_0 = tmp0_iterator_1.j1();
              // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>.<anonymous>' call
              if ($this.j1r_1.o1s(lh, element, element_0, nextInputPositionAfterSkip)) {
                tmp$ret$6 = true;
                break $l$block_1;
              }
            }
            tmp$ret$6 = false;
          }
          if (tmp$ret$6) {
            tmp$ret$5 = true;
            break $l$block_2;
          }
        }
        tmp$ret$5 = false;
      }
      var hasLh = tmp$ret$5;
      var tmp_3;
      if (parseArgs.l1q_1 ? true : hasLh) {
        var startPosition = l.r1s_1;
        var nextInputPosition = l.s1s_1;
        Debug_getInstance();
        if (false) {
          var tmp_4 = Debug_getInstance();
          var tmp_5 = IndentDelta_NONE_getInstance();
          tmp_4.uz(tmp_5, RuntimeParser$doWidth$lambda(head, transition));
        }
        tmp_3 = $this.j1r_1.j1t(head, transition.f15_1, setOf(Companion_getInstance_4().d12_1), startPosition, nextInputPosition, skipData);
      } else {
        var tmp_6;
        var tmp_7;
        if (!(null == $this.o1r_1)) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp_7 = !$this.o1r_1.l1r_1.y();
        } else {
          tmp_7 = false;
        }
        if (tmp_7) {
          // Inline function 'kotlin.collections.maxOf' call
          var iterator_0 = $this.o1r_1.l1r_1.u();
          if (!iterator_0.h1())
            throw NoSuchElementException.u1();
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>' call
          var maxValue = iterator_0.j1().h1t_1;
          while (iterator_0.h1()) {
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doWidth.<anonymous>' call
            var v = iterator_0.j1().h1t_1;
            if (compareTo(maxValue, v) < 0) {
              maxValue = v;
            }
          }
          tmp_6 = maxValue;
        } else {
          tmp_6 = nextInputPositionAfterSkip;
        }
        var pos = tmp_6;
        recordFailedWidthLH($this, parseArgs, pos, transition, runtimeLhs, possibleEndOfText);
        tmp_3 = false;
      }
      tmp_0 = tmp_3;
    } else {
      recordFailedWidthTo($this, parseArgs, head.x1q_1, transition);
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function doHeight($this, head, previous, transition, possibleEndOfText, parseArgs) {
  var tmp;
  if (parseArgs.n1q_1) {
    tmp = false;
  } else {
    var runtimeLhs = ensureNotNull(previous).u1q_1.r1r_1;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = transition.h15_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var tmp0_flatMapTo_0 = ArrayList.i4();
      var tmp0_iterator_0 = possibleEndOfText.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var tmp0_mapNotNullTo = ArrayList.i4();
        // Inline function 'kotlin.collections.forEach' call
        var tmp0_iterator_1 = runtimeLhs.u();
        while (tmp0_iterator_1.h1()) {
          var element_1 = tmp0_iterator_1.j1();
          // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>.<anonymous>.<anonymous>' call
          var b = $this.j1r_1.o1s(element.t11_1, element_0, element_1, head.x1q_1);
          var tmp0_safe_receiver = b ? new Triple(element_0, element_1, element.u11_1) : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
          }
        }
        var list = tmp0_mapNotNullTo;
        addAll(tmp0_flatMapTo_0, list);
      }
      var list_0 = tmp0_flatMapTo_0;
      addAll(tmp0_flatMapTo, list_0);
    }
    var lhWithMatch = tmp0_flatMapTo;
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasLh = !lhWithMatch.y();
    var tmp_0;
    if (parseArgs.l1q_1 ? true : hasLh) {
      var tmp_1;
      if (parseArgs.l1q_1) {
        // Inline function 'kotlin.collections.flatMap' call
        var tmp1_flatMap = transition.h15_1;
        // Inline function 'kotlin.collections.flatMapTo' call
        var tmp0_flatMapTo_1 = ArrayList.i4();
        var tmp0_iterator_2 = tmp1_flatMap.u();
        while (tmp0_iterator_2.h1()) {
          var element_2 = tmp0_iterator_2.j1();
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>' call
          var up = element_2.u11_1;
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var tmp0_flatMapTo_2 = ArrayList.i4();
          var tmp0_iterator_3 = possibleEndOfText.u();
          while (tmp0_iterator_3.h1()) {
            var element_3 = tmp0_iterator_3.j1();
            // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(runtimeLhs, 10));
            var tmp0_iterator_4 = runtimeLhs.u();
            while (tmp0_iterator_4.h1()) {
              var item = tmp0_iterator_4.j1();
              var tmp$ret$11;
              // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>.<anonymous>.<anonymous>' call
              var tmp_2;
              if (up.w11_1 ? true : up.x11_1) {
                tmp_2 = $this.d1r_1.q15(up.r13(element_3, item));
              } else {
                tmp_2 = up;
              }
              tmp$ret$11 = tmp_2;
              tmp0_mapTo.e1(tmp$ret$11);
            }
            var list_1 = tmp0_mapTo;
            addAll(tmp0_flatMapTo_2, list_1);
          }
          var list_2 = tmp0_flatMapTo_2;
          addAll(tmp0_flatMapTo_1, list_2);
        }
        tmp_1 = toSet(tmp0_flatMapTo_1);
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(lhWithMatch, 10));
        var tmp0_iterator_5 = lhWithMatch.u();
        while (tmp0_iterator_5.h1()) {
          var item_0 = tmp0_iterator_5.j1();
          var tmp$ret$20;
          // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.doHeight.<anonymous>' call
          var eot = item_0.pl_1;
          var rt = item_0.ql_1;
          var up_0 = item_0.rl_1;
          var tmp_3;
          if (up_0.w11_1 ? true : up_0.x11_1) {
            tmp_3 = $this.d1r_1.q15(up_0.r13(eot, rt));
          } else {
            tmp_3 = up_0;
          }
          tmp$ret$20 = tmp_3;
          tmp0_mapTo_0.e1(tmp$ret$20);
        }
        tmp_1 = toSet(tmp0_mapTo_0);
      }
      var newRuntimeLhs = tmp_1;
      Debug_getInstance();
      if (false) {
        var tmp_4 = Debug_getInstance();
        var tmp_5 = IndentDelta_NONE_getInstance();
        tmp_4.uz(tmp_5, RuntimeParser$doHeight$lambda(head, transition));
      }
      tmp_0 = $this.j1r_1.k1t(head, previous, transition.f15_1, newRuntimeLhs, parseArgs.k1q_1);
    } else {
      recordFailedHeightLh($this, parseArgs, head.x1q_1, transition, runtimeLhs, possibleEndOfText);
      tmp_0 = false;
    }
    return tmp_0;
  }
  return tmp;
}
function doGraft($this, head, previous, prevPrev, transition, possibleEndOfText, parseArgs) {
  var tmp;
  if (parseArgs.n1q_1) {
    tmp = false;
  } else {
    var tmp_0;
    if (transition.j15_1.g16(ensureNotNull(previous).y1q_1)) {
      var runtimeLhs = previous.u1q_1.r1r_1;
      var lhWithMatch = matchedLookahead($this, head.x1q_1, transition.h15_1, possibleEndOfText, runtimeLhs);
      var hasLh = lhWithMatch.ri_1;
      var tmp_1;
      if (parseArgs.l1q_1 ? true : hasLh) {
        Debug_getInstance();
        if (false) {
          var tmp_2 = Debug_getInstance();
          var tmp_3 = IndentDelta_NONE_getInstance();
          tmp_2.uz(tmp_3, RuntimeParser$doGraft$lambda(head, transition));
        }
        tmp_1 = $this.j1r_1.p1s(head, previous, prevPrev, transition.f15_1, runtimeLhs, parseArgs.k1q_1);
      } else {
        recordFailedGraftLH($this, parseArgs, head.x1q_1, transition, runtimeLhs, possibleEndOfText);
        tmp_1 = false;
      }
      tmp_0 = tmp_1;
    } else {
      recordFailedGraftRTG($this, parseArgs, head.x1q_1, transition, previous.y1q_1);
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function tryParseSkipUntilNone($this, possibleEndOfSkip, startPosition, growArgs) {
  var tmp;
  if ($this.f1r_1) {
    var key = new Pair(startPosition, possibleEndOfSkip);
    var tmp_0;
    if ($this.n1r_1.r3(key)) {
      tmp_0 = $this.n1r_1.u3(key);
    } else {
      var skipData = $this.o1r_1 == null ? null : tryParseSkip($this, possibleEndOfSkip, startPosition, growArgs);
      // Inline function 'kotlin.collections.set' call
      $this.n1r_1.m3(key, skipData);
      tmp_0 = skipData;
    }
    tmp = tmp_0;
  } else {
    tmp = tryParseSkip($this, possibleEndOfSkip, startPosition, growArgs);
  }
  return tmp;
}
function tryParseSkip($this, possibleEndOfSkip, startPosition, growArgs) {
  Debug_getInstance();
  if (false) {
    println('*** Start skip Parser');
  }
  ensureNotNull($this.o1r_1).e1q();
  $this.o1r_1.l1t(startPosition, possibleEndOfSkip, growArgs);
  do {
    $this.o1r_1.o1t(possibleEndOfSkip, growArgs);
  }
   while ($this.o1r_1.j1r_1.n1t() ? $this.o1r_1.j1r_1.m1t().y() ? true : !$this.o1r_1.j1r_1.a1s_1 : false);
  Debug_getInstance();
  if (false) {
    println('*** End skip Parser');
  }
  var tmp;
  if ($this.o1r_1.j1r_1.m1t().y()) {
    tmp = null;
  } else {
    tmp = $this.o1r_1.j1r_1.z1r_1.q1t_1;
  }
  return tmp;
}
function ambiguity($this, head, trans, possibleEndOfText) {
  var tmp = head.u1q_1.q1r_1.lz();
  var from = joinToString(tmp, ',', VOID, VOID, VOID, VOID, RuntimeParser$ambiguity$lambda);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(trans, 10));
  var tmp0_iterator = trans.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$21;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>' call
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = item.h15_1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator_0 = tmp0_map.u();
    while (tmp0_iterator_0.h1()) {
      var item_0 = tmp0_iterator_0.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      tmp$ret$0 = item_0.t11_1.q13();
      tmp0_mapTo_0.e1(tmp$ret$0);
    }
    var accumulator = Companion_getInstance_8().xw_1;
    var tmp0_iterator_1 = tmp0_mapTo_0.u();
    while (tmp0_iterator_1.h1()) {
      var element = tmp0_iterator_1.j1();
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      accumulator = accumulator.iy(element);
    }
    var lh = accumulator;
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(possibleEndOfText, 10));
    var tmp0_iterator_2 = possibleEndOfText.u();
    while (tmp0_iterator_2.h1()) {
      var item_1 = tmp0_iterator_2.j1();
      var tmp$ret$5;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      tmp$ret$5 = item_1.q13();
      tmp0_mapTo_1.e1(tmp$ret$5);
    }
    var accumulator_0 = Companion_getInstance_8().xw_1;
    var tmp0_iterator_3 = tmp0_mapTo_1.u();
    while (tmp0_iterator_3.h1()) {
      var element_0 = tmp0_iterator_3.j1();
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      accumulator_0 = accumulator_0.iy(element_0);
    }
    var eot = accumulator_0;
    // Inline function 'kotlin.collections.fold' call
    // Inline function 'kotlin.collections.map' call
    var tmp7_map = head.u1q_1.r1r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(tmp7_map, 10));
    var tmp0_iterator_4 = tmp7_map.u();
    while (tmp0_iterator_4.h1()) {
      var item_2 = tmp0_iterator_4.j1();
      var tmp$ret$10;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      tmp$ret$10 = item_2.q13();
      tmp0_mapTo_2.e1(tmp$ret$10);
    }
    var accumulator_1 = Companion_getInstance_8().xw_1;
    var tmp0_iterator_5 = tmp0_mapTo_2.u();
    while (tmp0_iterator_5.h1()) {
      var element_1 = tmp0_iterator_5.j1();
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      accumulator_1 = accumulator_1.iy(element_1);
    }
    var rt = accumulator_1;
    var lhr = lh.l17(eot, rt).b12();
    // Inline function 'kotlin.collections.map' call
    var tmp11_map = item.f15_1.yy_1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_3 = ArrayList.f4(collectionSizeOrDefault(tmp11_map, 10));
    var tmp0_iterator_6 = tmp11_map.u();
    while (tmp0_iterator_6.h1()) {
      var item_3 = tmp0_iterator_6.j1();
      var tmp$ret$15;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      tmp$ret$15 = '(' + item_3.qx_1.mz() + ',' + item_3.rx_1 + ')';
      tmp0_mapTo_3.e1(tmp$ret$15);
    }
    var tmp_0 = tmp0_mapTo_3;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo_4 = ArrayList.f4(collectionSizeOrDefault(lhr, 10));
    var tmp0_iterator_7 = lhr.u();
    while (tmp0_iterator_7.h1()) {
      var item_4 = tmp0_iterator_7.j1();
      var tmp$ret$18;
      // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>.<anonymous>' call
      tmp$ret$18 = item_4.mz();
      tmp0_mapTo_4.e1(tmp$ret$18);
    }
    tmp$ret$21 = '' + tmp_0 + ' on ' + tmp0_mapTo_4;
    tmp0_mapTo.e1(tmp$ret$21);
  }
  var ambigStr = tmp0_mapTo;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_5 = ArrayList.f4(collectionSizeOrDefault(trans, 10));
  var tmp0_iterator_8 = trans.u();
  while (tmp0_iterator_8.h1()) {
    var item_5 = tmp0_iterator_8.j1();
    var tmp$ret$24;
    // Inline function 'net.akehurst.language.agl.parser.RuntimeParser.ambiguity.<anonymous>' call
    tmp$ret$24 = item_5.g15_1;
    tmp0_mapTo_5.e1(tmp$ret$24);
  }
  var ambigOn = toSet(tmp0_mapTo_5);
  var ambigOnStr = joinToString(ambigOn, '/', VOID, VOID, VOID, VOID, RuntimeParser$ambiguity$lambda_0);
  var tmp_1;
  if (ambigStr.o() === 1) {
    tmp_1 = first_0(ambigStr);
  } else {
    tmp_1 = joinToString(ambigStr, '\n    ', '\n    ', '\n', VOID, VOID, RuntimeParser$ambiguity$lambda_1);
  }
  var into = tmp_1;
  var loc = $this.h1r_1.j1q(head.x1q_1, 1);
  $this.i1r_1.raise(LanguageIssueKind_WARNING_getInstance(), LanguageProcessorPhase_GRAMMAR_getInstance(), loc, 'Ambiguity in parse (on ' + ambigOnStr + '):\n  (' + from + ') into ' + into, ambigOn);
}
function recordFailedWidthTo($this, parseArgs, position, transition) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonWidthTo(position, transition));
  }
}
function recordFailedWidthLH($this, parseArgs, position, transition, runtimeLhs, possibleEndOfText) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonLookahead(position, transition, runtimeLhs, possibleEndOfText));
  }
}
function recordFailedEmbedded($this, parseArgs, position, transition, failedEmbeddedReasons) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonEmbedded(position, transition, failedEmbeddedReasons));
  }
}
function recordFailedHeightLh($this, parseArgs, position, transition, runtimeLhs, possibleEndOfText) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonLookahead(position, transition, runtimeLhs, possibleEndOfText));
  }
}
function recordFailedGraftRTG($this, parseArgs, position, transition, prevNumNonSkipChildren) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonGraftRTG(position, transition, prevNumNonSkipChildren));
  }
}
function recordFailedGraftLH($this, parseArgs, position, transition, runtimeLhs, possibleEndOfText) {
  if (parseArgs.o1q_1) {
    $this.l1r_1.e1(new FailedParseReasonLookahead(position, transition, runtimeLhs, possibleEndOfText));
  }
}
function RuntimeParser$grow3$lambda(it) {
  return 0;
}
function RuntimeParser$growGoal$lambda($head) {
  return function () {
    return 'Dropped: ' + $head;
  };
}
function RuntimeParser$growGoal$lambda$lambda(it) {
  return '  ' + it;
}
function RuntimeParser$growGoal$lambda_0($transitions) {
  return function () {
    return 'Choices:\n' + joinToString($transitions, '\n', VOID, VOID, VOID, VOID, RuntimeParser$growGoal$lambda$lambda);
  };
}
function RuntimeParser$growIncomplete$lambda$lambda(it) {
  return '  ' + it;
}
function RuntimeParser$growIncomplete$lambda($transitions) {
  return function () {
    return 'Choices:\n' + joinToString($transitions, '\n', VOID, VOID, VOID, VOID, RuntimeParser$growIncomplete$lambda$lambda);
  };
}
function RuntimeParser$growComplete$lambda($head) {
  return function () {
    return 'Dropped: ' + $head;
  };
}
function RuntimeParser$growComplete$lambda_0($head) {
  return function () {
    return 'Dropped: ' + $head;
  };
}
function RuntimeParser$growComplete$lambda_1($head) {
  return function () {
    return 'Dropped: ' + $head;
  };
}
function RuntimeParser$growComplete$lambda_2($element) {
  return function () {
    return 'Dropped: ' + $element;
  };
}
function RuntimeParser$growComplete2$lambda$lambda(it) {
  return '  ' + it;
}
function RuntimeParser$growComplete2$lambda($trans2) {
  return function () {
    return 'Choices:\n' + joinToString($trans2, '\n', VOID, VOID, VOID, VOID, RuntimeParser$growComplete2$lambda$lambda);
  };
}
function RuntimeParser$growComplete2$lambda_0(t1, t2) {
  var p1 = first_0(t1.f15_1.yy_1).sx_1;
  var p2 = first_0(t2.f15_1.yy_1).sx_1;
  var tmp;
  if (p1 === p2) {
    tmp = 0;
  } else {
    Companion_getInstance_29();
    if (-1 === p1) {
      tmp = 1;
    } else {
      Companion_getInstance_29();
      if (-1 === p2) {
        tmp = -1;
      } else {
        if (p1 > p2) {
          tmp = 1;
        } else {
          if (p1 < p2) {
            tmp = -1;
          } else {
            tmp = 0;
          }
        }
      }
    }
  }
  return tmp;
}
function RuntimeParser$resolvePrecedence$lambda(t1, t2) {
  var p1 = first_0(t1.ri_1.f15_1.yy_1).sx_1;
  var p2 = first_0(t2.ri_1.f15_1.yy_1).sx_1;
  var tmp;
  if (p1 === p2) {
    tmp = 0;
  } else {
    Companion_getInstance_29();
    if (-1 === p1) {
      tmp = 1;
    } else {
      Companion_getInstance_29();
      if (-1 === p2) {
        tmp = -1;
      } else {
        if (p1 > p2) {
          tmp = 1;
        } else {
          if (p1 < p2) {
            tmp = -1;
          } else {
            tmp = 0;
          }
        }
      }
    }
  }
  return tmp;
}
function RuntimeParser$doNoTransitionsTaken$lambda($head) {
  return function () {
    return 'Dropped stack with Head: ' + $head;
  };
}
function RuntimeParser$doGoal$lambda($head, $transition) {
  return function () {
    return 'For ' + $head + ', taking: ' + $transition;
  };
}
function RuntimeParser$doWidth$lambda($head, $transition) {
  return function () {
    return 'For ' + $head + ', taking: ' + $transition;
  };
}
function RuntimeParser$doHeight$lambda($head, $transition) {
  return function () {
    return 'For ' + $head + ', taking: ' + $transition;
  };
}
function RuntimeParser$doGraft$lambda($head, $transition) {
  return function () {
    return 'For ' + $head + ', taking: ' + $transition;
  };
}
function RuntimeParser$doEmbedded$lambda($head, $transition) {
  return function () {
    return 'For ' + $head + ', taking: ' + $transition;
  };
}
function RuntimeParser$ambiguity$lambda(it) {
  return it.mz();
}
function RuntimeParser$ambiguity$lambda_0(it) {
  return '' + it;
}
function RuntimeParser$ambiguity$lambda_1(it) {
  return it;
}
function createRuntimeParser($this, goalRuleName, input, automatonKind, cacheSkip) {
  var goalRule = $this.k1u_1.pu(goalRuleName);
  var s0 = $this.k1u_1.m11(goalRuleName, automatonKind).w14();
  var skipStateSet = $this.k1u_1.h1u();
  return new RuntimeParser(s0.zy_1, skipStateSet, cacheSkip, goalRule, input, $this.m1u_1);
}
function addParseIssue($this, input, rp, nextExpected, seasons, maxNumHeads) {
  var lastLocation = nextExpected.ri_1;
  var exp = nextExpected.si_1;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(exp, 10));
  var tmp0_iterator = exp.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.addParseIssue.<anonymous>' call
    tmp$ret$0 = item.mz();
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var expected = toSet(tmp0_mapTo);
  var errorPos = lastLocation.position + lastLocation.length | 0;
  var errorLength = 1;
  var location = input.j1q(errorPos, errorLength);
  var contextInText = rp.j1r_1.v1r_1.d1q(location.position);
  $this.m1u_1.error(location, contextInText, expected);
}
function findNextExpectedAfterError3($this, input, failedParseReasons, automatonKind, stateSet) {
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = failedParseReasons.u();
  if (!iterator.h1())
    throw NoSuchElementException.u1();
  // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
  var maxValue = iterator.j1().h1t_1;
  while (iterator.h1()) {
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
    var v = iterator.j1().h1t_1;
    if (compareTo(maxValue, v) < 0) {
      maxValue = v;
    }
  }
  var max = maxValue;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var tmp0_filterTo = ArrayList.i4();
  var tmp0_iterator = failedParseReasons.u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
    if (element.h1t_1 === max) {
      tmp0_filterTo.e1(element);
    }
  }
  var maxReasons = tmp0_filterTo;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(maxReasons, 10));
  var tmp0_iterator_0 = maxReasons.u();
  while (tmp0_iterator_0.h1()) {
    var item = tmp0_iterator_0.j1();
    var tmp$ret$18;
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
    var tmp;
    if (item instanceof FailedParseReasonWidthTo) {
      tmp = new Pair(input.j1q(item.h1t_1, 0), setOf(item.i1t_1.f15_1.z13()));
    } else {
      if (item instanceof FailedParseReasonGraftRTG) {
        var exp = item.i1t_1.j15_1.h16(item.w1u_1);
        tmp = new Pair(input.j1q(item.h1t_1, 0), exp);
      } else {
        if (item instanceof FailedParseReasonLookahead) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0_flatMap = item.t1u_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var tmp0_flatMapTo = ArrayList.i4();
          var tmp0_iterator_1 = tmp0_flatMap.u();
          while (tmp0_iterator_1.h1()) {
            var element_0 = tmp0_iterator_1.j1();
            // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>.<anonymous>' call
            // Inline function 'kotlin.collections.flatMap' call
            var tmp0_flatMap_0 = item.s1u_1;
            // Inline function 'kotlin.collections.flatMapTo' call
            var tmp0_flatMapTo_0 = ArrayList.i4();
            var tmp0_iterator_2 = tmp0_flatMap_0.u();
            while (tmp0_iterator_2.h1()) {
              var element_1 = tmp0_iterator_2.j1();
              // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.collections.flatMap' call
              var tmp0_flatMap_1 = item.i1t_1.h15_1;
              // Inline function 'kotlin.collections.flatMapTo' call
              var tmp0_flatMapTo_1 = ArrayList.i4();
              var tmp0_iterator_3 = tmp0_flatMap_1.u();
              while (tmp0_iterator_3.h1()) {
                var element_2 = tmp0_iterator_3.j1();
                // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var list = element_2.t11_1.r13(element_0, element_1).b12();
                addAll(tmp0_flatMapTo_1, list);
              }
              var list_0 = tmp0_flatMapTo_1;
              addAll(tmp0_flatMapTo_0, list_0);
            }
            var list_1 = tmp0_flatMapTo_0;
            addAll(tmp0_flatMapTo, list_1);
          }
          var expected = toSet(tmp0_flatMapTo);
          var terms = stateSet.uw();
          // Inline function 'kotlin.collections.flatMap' call
          var tmp1_flatMap = stateSet.n15();
          // Inline function 'kotlin.collections.flatMapTo' call
          var tmp0_flatMapTo_2 = ArrayList.i4();
          var tmp0_iterator_4 = tmp1_flatMap.u();
          while (tmp0_iterator_4.h1()) {
            var element_3 = tmp0_iterator_4.j1();
            // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>.<anonymous>' call
            var list_2 = element_3.n11();
            addAll(tmp0_flatMapTo_2, list_2);
          }
          var embeddedSkipTerms = toSet(tmp0_flatMapTo_2);
          var exp_0 = minus_1(expected, minus_1(embeddedSkipTerms, terms));
          tmp = new Pair(input.j1q(item.h1t_1, 0), exp_0);
        } else {
          if (item instanceof FailedParseReasonEmbedded) {
            var tmp_0 = first_0(item.i1t_1.f15_1.lz()).i11();
            var embeddedRhs = tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE();
            var embeddedStateSet = embeddedRhs.k11_1.m11(embeddedRhs.l11_1.mz(), automatonKind);
            var x = findNextExpectedAfterError3($this, input, item.p1u_1, automatonKind, embeddedStateSet);
            var embeddedRuntimeRuleSet = embeddedRhs.k11_1;
            var embeddedTerms = embeddedRuntimeRuleSet.m11(embeddedRhs.l11_1.mz(), automatonKind).uw();
            var tmp1_safe_receiver = $this.k1u_1.h1u();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.uw();
            var skipTerms = tmp2_elvis_lhs == null ? emptySet() : tmp2_elvis_lhs;
            var exp_1 = minus_1(x.si_1, minus_1(skipTerms, embeddedTerms));
            tmp = new Pair(x.ri_1, exp_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    tmp$ret$18 = tmp;
    tmp0_mapTo.e1(tmp$ret$18);
  }
  var x_0 = tmp0_mapTo;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var tmp0_groupByTo = LinkedHashMap.n8();
  var tmp0_iterator_5 = x_0.u();
  while (tmp0_iterator_5.h1()) {
    var element_4 = tmp0_iterator_5.j1();
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
    var key = element_4.ri_1.position;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = tmp0_groupByTo.u3(key);
    var tmp_1;
    if (value == null) {
      // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
      var answer = ArrayList.i4();
      tmp0_groupByTo.m3(key, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list_3 = tmp_1;
    list_3.e1(element_4);
  }
  var y = tmp0_groupByTo;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo_0 = ArrayList.f4(y.o());
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_6 = y.l3().u();
  while (tmp0_iterator_6.h1()) {
    var item_0 = tmp0_iterator_6.j1();
    var tmp$ret$30;
    // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>' call
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap_2 = item_0.p3();
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo_3 = ArrayList.i4();
    var tmp0_iterator_7 = tmp0_flatMap_2.u();
    while (tmp0_iterator_7.h1()) {
      var element_5 = tmp0_iterator_7.j1();
      // Inline function 'net.akehurst.language.agl.parser.ScanOnDemandParser.findNextExpectedAfterError3.<anonymous>.<anonymous>' call
      var list_4 = element_5.si_1;
      addAll(tmp0_flatMapTo_3, list_4);
    }
    var m = toSet(tmp0_flatMapTo_3);
    tmp$ret$30 = new Pair(input.j1q(item_0.o3(), 0), m);
    tmp0_mapTo_0.e1(tmp$ret$30);
  }
  var m_0 = tmp0_mapTo_0;
  return first_0(m_0);
}
function Scanner$scan$lambda(l1, l2) {
  return (!l1.isPattern ? l2.isPattern : false) ? 1 : (l1.isPattern ? !l2.isPattern : false) ? -1 : l1.location.length > l2.location.length ? 1 : l2.location.length > l1.location.length ? -1 : 0;
}
function _get__eolPositions__1oecae($this) {
  // Inline function 'kotlin.getValue' call
  _eolPositions$factory();
  return $this.j1v_1.p3();
}
function SentenceDefault$_eolPositions$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_22().p1p(this$0.i1v_1);
  };
}
function _eolPositions$factory() {
  return getPropertyCallableRef('_eolPositions', 1, KProperty1, function (receiver) {
    return _get__eolPositions__1oecae(receiver);
  }, null);
}
function Agl$configurationDefault$lambda($this$configuration) {
  $this$configuration.targetGrammarName(null);
  $this$configuration.defaultGoalRuleName(null);
  $this$configuration.typeModelResolver(Agl$configurationDefault$lambda$lambda);
  $this$configuration.scopeModelResolver(Agl$configurationDefault$lambda$lambda_0);
  $this$configuration.syntaxAnalyserResolver(Agl$configurationDefault$lambda$lambda_1);
  $this$configuration.semanticAnalyserResolver(Agl$configurationDefault$lambda$lambda_2);
  $this$configuration.styleResolver(Agl$configurationDefault$lambda$lambda_3);
  $this$configuration.formatterResolver(Agl$configurationDefault$lambda$lambda_4);
  $this$configuration.completionProvider(Agl$configurationDefault$lambda$lambda_5);
  return Unit_getInstance();
}
function Agl$configurationDefault$lambda$lambda(p) {
  return new ProcessResultDefault(TypeModelFromGrammar_getInstance().r19(ensureNotNull(p.grammar)), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function Agl$configurationDefault$lambda$lambda_0(p) {
  return Companion_getInstance_17().fromString(ContextFromTypeModel.new_net_akehurst_language_agl_syntaxAnalyser_ContextFromTypeModel(ensureNotNull(p.grammar).qualifiedName, p.typeModel), '');
}
function Agl$configurationDefault$lambda$lambda_1(p) {
  return new ProcessResultDefault(new SyntaxAnalyserDefault(ensureNotNull(p.grammar).qualifiedName, p.typeModel, p.scopeModel), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function Agl$configurationDefault$lambda$lambda_2(p) {
  return new ProcessResultDefault(new SemanticAnalyserDefault(p.scopeModel), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function Agl$configurationDefault$lambda$lambda_3(p) {
  return Companion_getInstance_21().fromString(ContextFromGrammar.new_net_akehurst_language_agl_grammar_grammar_ContextFromGrammar(ensureNotNull(p.grammar)), '');
}
function Agl$configurationDefault$lambda$lambda_4(p) {
  return Companion_getInstance_13().fromString(ContextFromTypeModel.new_net_akehurst_language_agl_syntaxAnalyser_ContextFromTypeModel(ensureNotNull(p.grammar).qualifiedName, p.typeModel), '');
}
function Agl$configurationDefault$lambda$lambda_5(p) {
  return new ProcessResultDefault(new CompletionProviderDefault(ensureNotNull(p.grammar), p.typeModel, p.scopeModel), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function Agl$processorFromStringDefault$lambda$lambda($scopeModelStr) {
  return function (p) {
    return Companion_getInstance_17().fromString(ContextFromTypeModel.new_net_akehurst_language_agl_syntaxAnalyser_ContextFromTypeModel(ensureNotNull(p.grammar).qualifiedName, p.typeModel), $scopeModelStr);
  };
}
function Agl$processorFromStringDefault$lambda$lambda_0($styleModelStr) {
  return function (p) {
    return Companion_getInstance_21().fromString(ContextFromGrammar.new_net_akehurst_language_agl_grammar_grammar_ContextFromGrammar(ensureNotNull(p.grammar)), $styleModelStr);
  };
}
function Agl$processorFromStringDefault$lambda$lambda_1($formatterModelStr) {
  return function (p) {
    return Companion_getInstance_13().fromString(ContextFromTypeModel.new_net_akehurst_language_agl_syntaxAnalyser_ContextFromTypeModel(ensureNotNull(p.grammar).qualifiedName, p.typeModel), $formatterModelStr);
  };
}
function Agl$processorFromStringDefault$lambda($scopeModelStr, $styleModelStr, $formatterModelStr) {
  return function ($this$configuration) {
    var tmp;
    if (!(null == $scopeModelStr)) {
      $this$configuration.scopeModelResolver(Agl$processorFromStringDefault$lambda$lambda($scopeModelStr));
      tmp = Unit_getInstance();
    }
    var tmp_0;
    if (!(null == $styleModelStr)) {
      $this$configuration.styleResolver(Agl$processorFromStringDefault$lambda$lambda_0($styleModelStr));
      tmp_0 = Unit_getInstance();
    }
    var tmp_1;
    if (!(null == $formatterModelStr)) {
      $this$configuration.formatterResolver(Agl$processorFromStringDefault$lambda$lambda_1($formatterModelStr));
      tmp_1 = Unit_getInstance();
    }
    return Unit_getInstance();
  };
}
var Agl_instance;
function Agl_getInstance() {
  if (Agl_instance === VOID)
    new Agl_0();
  return Agl_instance;
}
function LanguageDefinitionAbstract$_set_scopeModel_$lambda_vpsoum($value) {
  return function (it) {
    return new ProcessResultDefault($value, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
  };
}
function LanguageDefinitionAbstract$_set_style_$lambda_f7taq6($value) {
  return function (it) {
    return new ProcessResultDefault($value, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
  };
}
function LanguageDefinitionAbstract$_processor_cache$lambda(this$0, $buildForDefaultGoal) {
  return function () {
    var g = this$0.grammar;
    var tmp;
    if (null == g) {
      tmp = null;
    } else {
      var proc = Agl_getInstance().processorFromGrammar(g, this$0.configuration);
      if ($buildForDefaultGoal) {
        proc.buildFor(null);
      }
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_forEach = this$0.processorObservers;
      var tmp0_iterator = tmp0_forEach.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract._processor_cache.<anonymous>.<anonymous>' call
        element(null, proc);
      }
      tmp = proc;
    }
    return tmp;
  };
}
function LanguageDefinitionAbstract$_processor_cache$lambda_0(this$0) {
  return function (old) {
    var tmp0_forEach = this$0.processorObservers;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionAbstract._processor_cache.<anonymous>.<anonymous>.<anonymous>' call
      element(old, null);
    }
    return Unit_getInstance();
  };
}
function grammar$factory() {
  return getPropertyCallableRef('grammar', 1, KMutableProperty1, function (receiver) {
    return receiver.grammar;
  }, function (receiver, value) {
    return receiver.grammar = value;
  });
}
function grammar$factory_0() {
  return getPropertyCallableRef('grammar', 1, KMutableProperty1, function (receiver) {
    return receiver.grammar;
  }, function (receiver, value) {
    return receiver.grammar = value;
  });
}
function targetGrammarName$factory() {
  return getPropertyCallableRef('targetGrammarName', 1, KMutableProperty1, function (receiver) {
    return receiver.targetGrammarName;
  }, function (receiver, value) {
    return receiver.targetGrammarName = value;
  });
}
function targetGrammarName$factory_0() {
  return getPropertyCallableRef('targetGrammarName', 1, KMutableProperty1, function (receiver) {
    return receiver.targetGrammarName;
  }, function (receiver, value) {
    return receiver.targetGrammarName = value;
  });
}
function defaultGoalRule$factory() {
  return getPropertyCallableRef('defaultGoalRule', 1, KMutableProperty1, function (receiver) {
    return receiver.defaultGoalRule;
  }, function (receiver, value) {
    return receiver.defaultGoalRule = value;
  });
}
function defaultGoalRule$factory_0() {
  return getPropertyCallableRef('defaultGoalRule', 1, KMutableProperty1, function (receiver) {
    return receiver.defaultGoalRule;
  }, function (receiver, value) {
    return receiver.defaultGoalRule = value;
  });
}
function _scopeModelResolver$factory() {
  return getPropertyCallableRef('_scopeModelResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._scopeModelResolver;
  }, function (receiver, value) {
    return receiver._scopeModelResolver = value;
  });
}
function _scopeModelResolver$factory_0() {
  return getPropertyCallableRef('_scopeModelResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._scopeModelResolver;
  }, function (receiver, value) {
    return receiver._scopeModelResolver = value;
  });
}
function _typeModelResolver$factory() {
  return getPropertyCallableRef('_typeModelResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._typeModelResolver;
  }, function (receiver, value) {
    return receiver._typeModelResolver = value;
  });
}
function _typeModelResolver$factory_0() {
  return getPropertyCallableRef('_typeModelResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._typeModelResolver;
  }, function (receiver, value) {
    return receiver._typeModelResolver = value;
  });
}
function _syntaxAnalyserResolver$factory() {
  return getPropertyCallableRef('_syntaxAnalyserResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._syntaxAnalyserResolver;
  }, function (receiver, value) {
    return receiver._syntaxAnalyserResolver = value;
  });
}
function _syntaxAnalyserResolver$factory_0() {
  return getPropertyCallableRef('_syntaxAnalyserResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._syntaxAnalyserResolver;
  }, function (receiver, value) {
    return receiver._syntaxAnalyserResolver = value;
  });
}
function _semanticAnalyserResolver$factory() {
  return getPropertyCallableRef('_semanticAnalyserResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._semanticAnalyserResolver;
  }, function (receiver, value) {
    return receiver._semanticAnalyserResolver = value;
  });
}
function _semanticAnalyserResolver$factory_0() {
  return getPropertyCallableRef('_semanticAnalyserResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._semanticAnalyserResolver;
  }, function (receiver, value) {
    return receiver._semanticAnalyserResolver = value;
  });
}
function _formatterResolver$factory() {
  return getPropertyCallableRef('_formatterResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._formatterResolver;
  }, function (receiver, value) {
    return receiver._formatterResolver = value;
  });
}
function _formatterResolver$factory_0() {
  return getPropertyCallableRef('_formatterResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._formatterResolver;
  }, function (receiver, value) {
    return receiver._formatterResolver = value;
  });
}
function _styleResolver$factory() {
  return getPropertyCallableRef('_styleResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._styleResolver;
  }, function (receiver, value) {
    return receiver._styleResolver = value;
  });
}
function _styleResolver$factory_0() {
  return getPropertyCallableRef('_styleResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._styleResolver;
  }, function (receiver, value) {
    return receiver._styleResolver = value;
  });
}
function _completionProviderResolver$factory() {
  return getPropertyCallableRef('_completionProviderResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._completionProviderResolver;
  }, function (receiver, value) {
    return receiver._completionProviderResolver = value;
  });
}
function _completionProviderResolver$factory_0() {
  return getPropertyCallableRef('_completionProviderResolver', 1, KMutableProperty1, function (receiver) {
    return receiver._completionProviderResolver;
  }, function (receiver, value) {
    return receiver._completionProviderResolver = value;
  });
}
function updateConfiguration($this, configuration) {
  $this.k20_1 = false;
  $this.targetGrammarName = configuration.targetGrammarName;
  $this.defaultGoalRule = configuration.defaultGoalRuleName;
  $this._typeModelResolver = configuration.typeModelResolver;
  $this._scopeModelResolver = configuration.scopeModelResolver;
  $this._syntaxAnalyserResolver = configuration.syntaxAnalyserResolver;
  $this._semanticAnalyserResolver = configuration.semanticAnalyserResolver;
  $this._formatterResolver = configuration.formatterResolver;
  $this._styleResolver = configuration.styleResolver;
  $this._completionProviderResolver = configuration.completionProvider;
  $this.k20_1 = true;
}
function updateGrammarStr($this, oldValue, newValue) {
  if (!(oldValue == newValue)) {
    var res = Agl_getInstance().grammarFromString(newValue, $this.j20_1);
    $this._issues.addAll(res.issues);
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!res.issues.errors.y()) {
      tmp = null;
    } else {
      if (null == $this.targetGrammarName) {
        var tmp0_safe_receiver = res.asm;
        tmp = tmp0_safe_receiver == null ? null : lastOrNull(tmp0_safe_receiver);
      } else {
        var tmp1_safe_receiver = res.asm;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.collections.lastOrNull' call
            var iterator = tmp1_safe_receiver.v(tmp1_safe_receiver.o());
            while (iterator.g2()) {
              var element = iterator.h2();
              // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionDefault.updateGrammarStr.<anonymous>' call
              if (element.name === $this.targetGrammarName) {
                tmp$ret$2 = element;
                break $l$block;
              }
            }
            tmp$ret$2 = null;
          }
          tmp_0 = tmp$ret$2;
        }
        tmp = tmp_0;
      }
    }
    $this.grammar = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = $this.grammarStrObservers.u();
    while (tmp0_iterator.h1()) {
      var element_0 = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.processor.LanguageDefinitionDefault.updateGrammarStr.<anonymous>' call
      element_0(oldValue, newValue);
    }
  }
}
function updateScopeModelStr($this, oldValue, newValue) {
  if (!(oldValue == newValue)) {
    $this._scopeModelResolver = LanguageDefinitionDefault$updateScopeModelStr$lambda(newValue);
  }
}
function updateStyleStr($this, oldValue, newValue) {
  if (!(oldValue == newValue)) {
    $this._styleResolver = LanguageDefinitionDefault$updateStyleStr$lambda(newValue);
  }
}
function LanguageDefinitionDefault$updateScopeModelStr$lambda($newValue) {
  return function (it) {
    var tmp;
    if (null == $newValue) {
      tmp = new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
    } else {
      tmp = ensureNotNull(Agl_getInstance().registry.agl.scopes.processor).process($newValue);
    }
    return tmp;
  };
}
function LanguageDefinitionDefault$updateStyleStr$lambda($newValue) {
  return function (it) {
    var tmp;
    if (null == $newValue) {
      tmp = new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
    } else {
      tmp = ensureNotNull(Agl_getInstance().registry.agl.style.processor).process($newValue);
    }
    return tmp;
  };
}
function grammarStr$factory() {
  return getPropertyCallableRef('grammarStr', 1, KMutableProperty1, function (receiver) {
    return receiver.u1x();
  }, function (receiver, value) {
    return receiver.t1x(value);
  });
}
function grammarStr$factory_0() {
  return getPropertyCallableRef('grammarStr', 1, KMutableProperty1, function (receiver) {
    return receiver.u1x();
  }, function (receiver, value) {
    return receiver.t1x(value);
  });
}
function scopeModelStr$factory() {
  return getPropertyCallableRef('scopeModelStr', 1, KMutableProperty1, function (receiver) {
    return receiver.c1y();
  }, function (receiver, value) {
    return receiver.b1y(value);
  });
}
function scopeModelStr$factory_0() {
  return getPropertyCallableRef('scopeModelStr', 1, KMutableProperty1, function (receiver) {
    return receiver.c1y();
  }, function (receiver, value) {
    return receiver.b1y(value);
  });
}
function styleStr$factory() {
  return getPropertyCallableRef('styleStr', 1, KMutableProperty1, function (receiver) {
    return receiver.j1y();
  }, function (receiver, value) {
    return receiver.i1y(value);
  });
}
function styleStr$factory_0() {
  return getPropertyCallableRef('styleStr', 1, KMutableProperty1, function (receiver) {
    return receiver.j1y();
  }, function (receiver, value) {
    return receiver.i1y(value);
  });
}
function _get__scanner__baey98($this) {
  // Inline function 'kotlin.getValue' call
  _scanner$factory();
  return $this.s21_1.p3();
}
function defaultOptions($this, options) {
  var opts = options == null ? $this.optionsDefault() : options;
  if (null == opts.parse.goalRuleName) {
    opts.parse.goalRuleName = $this.d22();
  }
  return opts;
}
function LanguageProcessorAbstract$_scanner$delegate$lambda(this$0) {
  return function () {
    return new Scanner(this$0.h1f());
  };
}
function LanguageProcessorAbstract$parser$delegate$lambda(this$0) {
  return function () {
    return new ScanOnDemandParser(this$0.h1f());
  };
}
function LanguageProcessorAbstract$spptParser$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.associate' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.u1g().allResolvedEmbeddedGrammars;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.spptParser$delegate.<anonymous>.<anonymous>' call
      var cvt = new ConverterToRuntimeRules(item);
      var rrs = cvt.h1f();
      tmp$ret$0 = new Pair(item.name, rrs);
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_associate = tmp$ret$2;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associate, 10)), 16);
    var tmp$ret$4;
    // Inline function 'kotlin.collections.associateTo' call
    var tmp0_associateTo = LinkedHashMap.o8(capacity);
    var tmp0_iterator_0 = tmp1_associate.u();
    while (tmp0_iterator_0.h1()) {
      var element = tmp0_iterator_0.j1();
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.spptParser$delegate.<anonymous>.<anonymous>' call
      tmp$ret$3 = element;
      var tmp0_plusAssign = tmp$ret$3;
      tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
    }
    tmp$ret$4 = tmp0_associateTo;
    tmp$ret$5 = tmp$ret$4;
    var tmp0_elvis_lhs = tmp$ret$5;
    var embeddedRuntimeRuleSets = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
    var tmp = this$0.e22();
    return new SPPTParserDefault((tmp instanceof ScanOnDemandParser ? tmp : THROW_CCE()).k1u_1, embeddedRuntimeRuleSets);
  };
}
function LanguageProcessorAbstract$defaultGoalRuleName$delegate$lambda(this$0) {
  return function () {
    var tmp1_elvis_lhs = this$0.o1z().defaultGoalRuleName;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_firstOrNull = this$0.u1g().options;
        var tmp0_iterator = tmp0_firstOrNull.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          var tmp$ret$0;
          // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.defaultGoalRuleName$delegate.<anonymous>.<anonymous>' call
          tmp$ret$0 = element.name === 'defaultGoal';
          if (tmp$ret$0) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver = tmp$ret$1;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.first' call
        var tmp1_first = this$0.u1g().grammarRule;
        var tmp0_iterator_0 = tmp1_first.u();
        while (tmp0_iterator_0.h1()) {
          var element_0 = tmp0_iterator_0.j1();
          var tmp$ret$2;
          // Inline function 'net.akehurst.language.agl.processor.LanguageProcessorAbstract.defaultGoalRuleName$delegate.<anonymous>.<anonymous>' call
          tmp$ret$2 = !element_0.isSkip;
          if (tmp$ret$2) {
            tmp$ret$3 = element_0;
            break $l$block_0;
          }
        }
        throw NoSuchElementException.ad('Collection contains no element matching the predicate.');
      }
      tmp_0 = tmp$ret$3.name;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  };
}
function LanguageProcessorAbstract$typeModel$delegate$lambda$lambda($this$grammarTypeModel) {
  return Unit_getInstance();
}
function LanguageProcessorAbstract$typeModel$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().typeModelResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      tmp = grammarTypeModel('empty', '<Empty>', 'None', VOID, LanguageProcessorAbstract$typeModel$delegate$lambda$lambda);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    return tmp;
  };
}
function LanguageProcessorAbstract$scopeModel$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().scopeModelResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
    return tmp3_elvis_lhs == null ? new ScopeModelAgl() : tmp3_elvis_lhs;
  };
}
function LanguageProcessorAbstract$syntaxAnalyser$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().syntaxAnalyserResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
  };
}
function LanguageProcessorAbstract$semanticAnalyser$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().semanticAnalyserResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
  };
}
function LanguageProcessorAbstract$formatterModel$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().formatterResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
  };
}
function LanguageProcessorAbstract$formatter$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().formatterResolver;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    return new FormatterSimple(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm);
  };
}
function LanguageProcessorAbstract$completionProvider$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.o1z().completionProvider;
    var res = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(this$0);
    var tmp1_safe_receiver = res;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this$0.w1b().addAll(res.issues);
      tmp$ret$0 = Unit_getInstance();
    }
    var tmp2_safe_receiver = res;
    return tmp2_safe_receiver == null ? null : tmp2_safe_receiver.asm;
  };
}
function _scanner$factory() {
  return getPropertyCallableRef('_scanner', 1, KProperty1, function (receiver) {
    return _get__scanner__baey98(receiver);
  }, null);
}
function parser$factory() {
  return getPropertyCallableRef('parser', 1, KProperty1, function (receiver) {
    return receiver.e22();
  }, null);
}
function spptParser$factory() {
  return getPropertyCallableRef('spptParser', 1, KProperty1, function (receiver) {
    return receiver.g22();
  }, null);
}
function defaultGoalRuleName$factory() {
  return getPropertyCallableRef('defaultGoalRuleName', 1, KProperty1, function (receiver) {
    return receiver.d22();
  }, null);
}
function typeModel$factory() {
  return getPropertyCallableRef('typeModel', 1, KProperty1, function (receiver) {
    return receiver.q1b();
  }, null);
}
function scopeModel$factory() {
  return getPropertyCallableRef('scopeModel', 1, KProperty1, function (receiver) {
    return receiver.r1b();
  }, null);
}
function syntaxAnalyser$factory() {
  return getPropertyCallableRef('syntaxAnalyser', 1, KProperty1, function (receiver) {
    return receiver.e1y();
  }, null);
}
function semanticAnalyser$factory() {
  return getPropertyCallableRef('semanticAnalyser', 1, KProperty1, function (receiver) {
    return receiver.f1y();
  }, null);
}
function formatterModel$factory() {
  return getPropertyCallableRef('formatterModel', 1, KProperty1, function (receiver) {
    return receiver.h22();
  }, null);
}
function formatter$factory() {
  return getPropertyCallableRef('formatter', 1, KProperty1, function (receiver) {
    return receiver.g1y();
  }, null);
}
function completionProvider$factory() {
  return getPropertyCallableRef('completionProvider', 1, KProperty1, function (receiver) {
    return receiver.i22();
  }, null);
}
function _get__converterToRuntimeRules__crqnio($this) {
  // Inline function 'kotlin.getValue' call
  _converterToRuntimeRules$factory();
  return $this.l23_1.p3();
}
function LanguageProcessorDefault$_converterToRuntimeRules$delegate$lambda(this$0) {
  return function () {
    return new ConverterToRuntimeRules(this$0.j23_1);
  };
}
function LanguageProcessorDefault$runtimeRuleSet$delegate$lambda(this$0) {
  return function () {
    return _get__converterToRuntimeRules__crqnio(this$0).h1f();
  };
}
function LanguageProcessorDefault$mapToGrammar$lambda(this$0) {
  return function (ruleSetNumber, ruleNumber) {
    return _get__converterToRuntimeRules__crqnio(this$0).j1f(ruleSetNumber, ruleNumber);
  };
}
function _converterToRuntimeRules$factory() {
  return getPropertyCallableRef('_converterToRuntimeRules', 1, KProperty1, function (receiver) {
    return _get__converterToRuntimeRules__crqnio(receiver);
  }, null);
}
function runtimeRuleSet$factory_0() {
  return getPropertyCallableRef('runtimeRuleSet', 1, KProperty1, function (receiver) {
    return receiver.h1f();
  }, null);
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda(it) {
  return new ProcessResultDefault(TypeModelFromGrammar_getInstance().r19(AglGrammarGrammar_getInstance()), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_0(it) {
  return new ProcessResultDefault(new ScopeModelAgl(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_1(it) {
  return new ProcessResultDefault(new AglGrammarSyntaxAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_2(this$0) {
  return function (it) {
    return new ProcessResultDefault(new AglGrammarSemanticAnalyser(this$0), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
  };
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_3(it) {
  return new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_4(it) {
  var tmp = Agl_getInstance();
  var tmp_0 = ensureNotNull(Agl_getInstance().registry.agl.style.processor);
  var tmp_1 = ensureNotNull(Agl_getInstance().registry.agl.style.processor).optionsDefault();
  AglGrammarGrammar_getInstance();
  return tmp.fromString(tmp_0, tmp_1, "'namespace' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'grammar' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'extends' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'override' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'skip' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'leaf' {\n  foreground: darkgreen;\n  font-style: bold;\n}\nLITERAL {\n  foreground: blue;\n}\nPATTERN {\n  foreground: darkblue;\n}\nIDENTIFIER {\n  foreground: darkred;\n  font-style: italic;\n}");
}
function LanguageRegistryDefault$agl$o$grammar$lambda$lambda_5(it) {
  return new ProcessResultDefault(new AglGrammarCompletionProvider(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$grammar$lambda(this$0) {
  return function ($this$configuration) {
    $this$configuration.targetGrammarName(AglGrammarGrammar_getInstance().name);
    AglGrammarGrammar_getInstance();
    $this$configuration.defaultGoalRuleName('grammarDefinition');
    $this$configuration.typeModelResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda);
    $this$configuration.scopeModelResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_0);
    $this$configuration.syntaxAnalyserResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_1);
    $this$configuration.semanticAnalyserResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_2(this$0));
    $this$configuration.formatterResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_3);
    $this$configuration.styleResolver(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_4);
    $this$configuration.completionProvider(LanguageRegistryDefault$agl$o$grammar$lambda$lambda_5);
    return Unit_getInstance();
  };
}
function LanguageRegistryDefault$agl$o$scopes$lambda($this$configuration) {
  $this$configuration.targetGrammarName(AglScopesGrammar_getInstance().name);
  AglScopesGrammar_getInstance();
  $this$configuration.defaultGoalRuleName('declarations');
  $this$configuration.typeModelResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda);
  $this$configuration.scopeModelResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_0);
  $this$configuration.syntaxAnalyserResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_1);
  $this$configuration.semanticAnalyserResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_2);
  $this$configuration.formatterResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_3);
  $this$configuration.styleResolver(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_4);
  $this$configuration.completionProvider(LanguageRegistryDefault$agl$o$scopes$lambda$lambda_5);
  return Unit_getInstance();
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda(it) {
  return new ProcessResultDefault(TypeModelFromGrammar_getInstance().r19(AglScopesGrammar_getInstance()), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_0(it) {
  return new ProcessResultDefault(new ScopeModelAgl(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_1(it) {
  return new ProcessResultDefault(new AglScopesSyntaxAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_2(it) {
  return new ProcessResultDefault(new AglScopesSemanticAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_3(it) {
  return new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_4(it) {
  var tmp = Agl_getInstance();
  var tmp_0 = ensureNotNull(Agl_getInstance().registry.agl.style.processor);
  var tmp_1 = ensureNotNull(Agl_getInstance().registry.agl.style.processor).optionsDefault();
  AglScopesGrammar_getInstance();
  return tmp.fromString(tmp_0, tmp_1, "'scope' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'identify' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'by' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'references' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'in' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'property' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'refers-to' {\n  foreground: darkgreen;\n  font-style: bold;\n}\n'|' {\n  foreground: darkgreen;\n  font-style: bold;\n}");
}
function LanguageRegistryDefault$agl$o$scopes$lambda$lambda_5(it) {
  return new ProcessResultDefault(new AglScopesCompletionProvider(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda($this$configuration) {
  $this$configuration.targetGrammarName(AglFormatGrammar_getInstance().name);
  AglFormatGrammar_getInstance();
  $this$configuration.defaultGoalRuleName('unit');
  $this$configuration.typeModelResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda);
  $this$configuration.scopeModelResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_0);
  $this$configuration.syntaxAnalyserResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_1);
  $this$configuration.semanticAnalyserResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_2);
  $this$configuration.formatterResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_3);
  $this$configuration.styleResolver(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_4);
  $this$configuration.completionProvider(LanguageRegistryDefault$agl$o$formatter$lambda$lambda_5);
  return Unit_getInstance();
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda(it) {
  return new ProcessResultDefault(TypeModelFromGrammar_getInstance().r19(AglFormatGrammar_getInstance()), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_0(it) {
  return new ProcessResultDefault(new ScopeModelAgl(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_1(it) {
  return new ProcessResultDefault(new AglFormatSyntaxAnalyser(ensureNotNull(it.grammar).qualifiedName, ensureNotNull(it.typeModel), ensureNotNull(it.scopeModel)), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_2(it) {
  return new ProcessResultDefault(new AglFormatSemanticAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_3(it) {
  return new ProcessResultDefault(null, new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_4(it) {
  var tmp = Agl_getInstance();
  var tmp_0 = ensureNotNull(Agl_getInstance().registry.agl.style.processor);
  var tmp_1 = ensureNotNull(Agl_getInstance().registry.agl.style.processor).optionsDefault();
  AglFormatGrammar_getInstance();
  return tmp.fromString(tmp_0, tmp_1, '\n    ');
}
function LanguageRegistryDefault$agl$o$formatter$lambda$lambda_5(it) {
  return new ProcessResultDefault(new AglFormatCompletionProvider(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$style$lambda($this$configuration) {
  $this$configuration.targetGrammarName(AglStyleGrammar_getInstance().name);
  AglStyleGrammar_getInstance();
  $this$configuration.defaultGoalRuleName('rules');
  $this$configuration.typeModelResolver(LanguageRegistryDefault$agl$o$style$lambda$lambda);
  $this$configuration.scopeModelResolver(LanguageRegistryDefault$agl$o$style$lambda$lambda_0);
  $this$configuration.syntaxAnalyserResolver(LanguageRegistryDefault$agl$o$style$lambda$lambda_1);
  $this$configuration.semanticAnalyserResolver(LanguageRegistryDefault$agl$o$style$lambda$lambda_2);
  $this$configuration.styleResolver(LanguageRegistryDefault$agl$o$style$lambda$lambda_3);
  $this$configuration.completionProvider(LanguageRegistryDefault$agl$o$style$lambda$lambda_4);
  return Unit_getInstance();
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda(it) {
  return new ProcessResultDefault(TypeModelFromGrammar_getInstance().r19(ensureNotNull(it.grammar)), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda_0(it) {
  return new ProcessResultDefault(new ScopeModelAgl(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda_1(it) {
  return new ProcessResultDefault(new AglStyleSyntaxAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda_2(it) {
  return new ProcessResultDefault(new AglStyleSemanticAnalyser(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda_3(it) {
  var tmp = Agl_getInstance();
  var tmp_0 = ensureNotNull(Agl_getInstance().registry.agl.style.processor);
  var tmp_1 = ensureNotNull(Agl_getInstance().registry.agl.style.processor).optionsDefault();
  AglStyleGrammar_getInstance();
  return tmp.fromString(tmp_0, tmp_1, 'META_IDENTIFIER {\n  foreground: orange;\n  font-style: bold;\n}\nIDENTIFIER {\n  foreground: blue;\n  font-style: bold;\n}\nLITERAL {\n  foreground: blue;\n  font-style: bold;\n}\nPATTERN {\n  foreground: darkblue;\n  font-style: bold;\n}\nSTYLE_ID {\n  foreground: darkred;\n  font-style: italic;\n}');
}
function LanguageRegistryDefault$agl$o$style$lambda$lambda_4(it) {
  return new ProcessResultDefault(new AglStyleCompletionProvider(), new IssueHolder(LanguageProcessorPhase_ALL_getInstance()));
}
function plus_3(_this__u8e3s4, other) {
  var issues = new IssueHolder(LanguageProcessorPhase_ALL_getInstance());
  issues.addAll(_this__u8e3s4);
  issues.addAll(other);
  return issues;
}
function IssueHolder$toString$lambda(it) {
  return '' + it;
}
function createState($this, isSplit) {
  var state = new State($this.m26_1, isSplit);
  $this.m26_1 = $this.m26_1 + 1 | 0;
  $this.l26_1.e1(state);
  return state;
}
function cloneState($this, orig, nullTransitions, map) {
  var tmp;
  if (null == orig) {
    tmp = null;
  } else {
    var clone = map.u3(orig);
    var tmp_0;
    if (null == clone) {
      var c = createState($this, orig.q26_1);
      // Inline function 'kotlin.collections.set' call
      map.m3(orig, c);
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = orig.r26_1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.regex.RegexMatcherBuilder.cloneState.<anonymous>' call
        tmp$ret$0 = $this.s26(item, nullTransitions, map);
        tmp0_mapTo.e1(tmp$ret$0);
      }
      var ctrans = tmp0_mapTo;
      c.r26_1.k1(ctrans);
      tmp_0 = c;
    } else {
      tmp_0 = clone;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function regexMatcher(pattern) {
  return (new RegexParser(pattern)).v27();
}
var Companion_instance_22;
function Companion_getInstance_24() {
  if (Companion_instance_22 === VOID)
    new Companion_22();
  return Companion_instance_22;
}
function matches($this, matcher, text, pos) {
  var tmp;
  switch (matcher.w27_1.bc_1) {
    case 0:
      throw IllegalStateException.y1('should not happen');
    case 1:
      tmp = true;
      break;
    case 2:
      var nextPos = pos + 1 | 0;
      tmp = nextPos === charSequenceLength(text) ? true : charSequenceGet(text, pos) === _Char___init__impl__6a9atx(10);
      break;
    case 3:
      tmp = !matches($this, matcher.b28_1, text, pos);
      break;
    case 4:
      tmp = charSequenceGet(text, pos) === matcher.x27_1;
      break;
    case 5:
      var opts = matcher.z27_1;
      var inductionVariable = 0;
      var last = opts.length;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (matches($this, opts[i], text, pos)) {
            return true;
          }
        }
         while (inductionVariable < last);
      return false;
    case 6:
      var containsLower = matcher.a28_1;
      var containsUpper = matcher.y27_1;
      var containsArg = charSequenceGet(text, pos);
      tmp = containsLower <= containsArg ? containsArg <= containsUpper : false;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var EscapeKind_SINGLE_instance;
var EscapeKind_OPTIONS_instance;
var EscapeKind_LITERAL_instance;
var EscapeKind_entriesInitialized;
function EscapeKind_initEntries() {
  if (EscapeKind_entriesInitialized)
    return Unit_getInstance();
  EscapeKind_entriesInitialized = true;
  EscapeKind_SINGLE_instance = new EscapeKind('SINGLE', 0);
  EscapeKind_OPTIONS_instance = new EscapeKind('OPTIONS', 1);
  EscapeKind_LITERAL_instance = new EscapeKind('LITERAL', 2);
}
var Companion_instance_23;
function Companion_getInstance_25() {
  if (Companion_instance_23 === VOID)
    new Companion_23();
  return Companion_instance_23;
}
function next($this) {
  var c = charSequenceGet($this.s27_1, $this.t27_1);
  $this.t27_1 = $this.t27_1 + 1 | 0;
  return c;
}
function parsePattern($this) {
  var postfix = new MutableStack();
  var opStack = new MutableStack();
  var needConcat = new MutableStack();
  needConcat.v1a(false);
  if ($this.r27_1.length > 0) {
    var c = next($this);
    try {
      while ($this.t27_1 <= $this.r27_1.length) {
        var tmp0_subject = c;
        if (tmp0_subject === _Char___init__impl__6a9atx(92)) {
          var escaped_matchers = parsePatternEscape($this);
          switch (escaped_matchers.ri_1.bc_1) {
            case 0:
              var tmp = escaped_matchers.si_1;
              var matcher = tmp instanceof CharacterMatcher ? tmp : THROW_CCE();
              var tmp_0 = Companion_getInstance_25().PREC_LITERAL;
              postfix.v1a(new Pair(tmp_0, RegexParser$parsePattern$lambda($this, matcher)));
              if (needConcat.w1a()) {
                while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
                  postfix.v1a(opStack.w1a());
                }
                var tmp_1 = Companion_getInstance_25().PREC_CONCAT;
                opStack.v1a(new Pair(tmp_1, RegexParser$parsePattern$lambda_0($this)));
              }

              needConcat.v1a(true);
              break;
            case 2:
              var tmp_2 = escaped_matchers.si_1;
              var literal = isCharSequence(tmp_2) ? tmp_2 : THROW_CCE();
              if (charSequenceLength(literal) > 0) {
                var cc = charSequenceGet(literal, 0);
                var tmp_3 = Companion_getInstance_25().PREC_LITERAL;
                postfix.v1a(new Pair(tmp_3, RegexParser$parsePattern$lambda_1($this, cc)));
                if (needConcat.w1a()) {
                  while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
                    postfix.v1a(opStack.w1a());
                  }
                  var tmp_4 = Companion_getInstance_25().PREC_CONCAT;
                  opStack.v1a(new Pair(tmp_4, RegexParser$parsePattern$lambda_2($this)));
                }
                var i = 1;
                while (i < charSequenceLength(literal)) {
                  var d = charSequenceGet(literal, i);
                  var tmp_5 = Companion_getInstance_25().PREC_LITERAL;
                  postfix.v1a(new Pair(tmp_5, RegexParser$parsePattern$lambda_3($this, d)));
                  var tmp_6 = Companion_getInstance_25().PREC_CONCAT;
                  opStack.v1a(new Pair(tmp_6, RegexParser$parsePattern$lambda_4($this)));
                  i = i + 1 | 0;
                }
                needConcat.v1a(true);
              }

              break;
            case 1:
              // Inline function 'kotlin.TODO' call

              throw NotImplementedError.eg();
          }
          c = next($this);
        } else if (tmp0_subject === _Char___init__impl__6a9atx(46)) {
          var tmp_7 = Companion_getInstance_25().PREC_LITERAL;
          postfix.v1a(new Pair(tmp_7, RegexParser$parsePattern$lambda_5($this)));
          if (needConcat.w1a()) {
            while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
              postfix.v1a(opStack.w1a());
            }
            var tmp_8 = Companion_getInstance_25().PREC_CONCAT;
            opStack.v1a(new Pair(tmp_8, RegexParser$parsePattern$lambda_6($this)));
          }
          needConcat.v1a(true);
          c = next($this);
        } else if (tmp0_subject === _Char___init__impl__6a9atx(36)) {
          var tmp_9 = Companion_getInstance_25().PREC_LITERAL;
          postfix.v1a(new Pair(tmp_9, RegexParser$parsePattern$lambda_7($this)));
          if (needConcat.w1a()) {
            while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
              postfix.v1a(opStack.w1a());
            }
            var tmp_10 = Companion_getInstance_25().PREC_CONCAT;
            opStack.v1a(new Pair(tmp_10, RegexParser$parsePattern$lambda_8($this)));
          }
          needConcat.v1a(true);
          c = next($this);
        } else if (tmp0_subject === _Char___init__impl__6a9atx(91)) {
          var options = parseCharacterClass($this);
          var tmp_11 = Companion_getInstance_25().PREC_LITERAL;
          postfix.v1a(new Pair(tmp_11, RegexParser$parsePattern$lambda_9($this, options)));
          if (needConcat.w1a()) {
            while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
              postfix.v1a(opStack.w1a());
            }
            var tmp_12 = Companion_getInstance_25().PREC_CONCAT;
            opStack.v1a(new Pair(tmp_12, RegexParser$parsePattern$lambda_10($this)));
          }
          needConcat.v1a(true);
          c = next($this);
        } else if (tmp0_subject === _Char___init__impl__6a9atx(40)) {
          needConcat.v1a(false);
          var tmp_13 = Companion_getInstance_25().PREC_GROUP_OPEN;
          opStack.v1a(new Pair(tmp_13, RegexParser$parsePattern$lambda_11));
          c = next($this);
          if (c === _Char___init__impl__6a9atx(63)) {
            // Inline function 'kotlin.TODO' call
            var tmp0_TODO = $this.r27_1;
            throw NotImplementedError.eg('An operation is not implemented: ' + tmp0_TODO);
          }
        } else if (tmp0_subject === _Char___init__impl__6a9atx(124)) {
          while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CHOICE : false) {
            postfix.v1a(opStack.w1a());
          }
          var tmp_14 = Companion_getInstance_25().PREC_CHOICE;
          opStack.v1a(new Pair(tmp_14, RegexParser$parsePattern$lambda_12($this)));
          needConcat.w1a();
          needConcat.v1a(false);
          c = next($this);
        } else if (tmp0_subject === _Char___init__impl__6a9atx(63)) {
          var tmp_15 = Companion_getInstance_25().PREC_MULTI_01;
          postfix.v1a(new Pair(tmp_15, RegexParser$parsePattern$lambda_13($this)));
          c = next($this);
          var tmp5_subject = c;
          if (tmp5_subject === _Char___init__impl__6a9atx(63)) {
            // Inline function 'kotlin.TODO' call
            throw NotImplementedError.eg();
          } else if (tmp5_subject === _Char___init__impl__6a9atx(43)) {
            // Inline function 'kotlin.TODO' call
            throw NotImplementedError.eg();
          }
        } else if (tmp0_subject === _Char___init__impl__6a9atx(43)) {
          var tmp_16 = Companion_getInstance_25().PREC_MULTI_1n;
          postfix.v1a(new Pair(tmp_16, RegexParser$parsePattern$lambda_14($this)));
          c = next($this);
          var tmp6_subject = c;
          if (tmp6_subject === _Char___init__impl__6a9atx(63)) {
            // Inline function 'kotlin.TODO' call
            var tmp2_TODO = $this.r27_1;
            throw NotImplementedError.eg('An operation is not implemented: ' + tmp2_TODO);
          } else if (tmp6_subject === _Char___init__impl__6a9atx(43)) {
            // Inline function 'kotlin.TODO' call
            var tmp3_TODO = $this.r27_1;
            throw NotImplementedError.eg('An operation is not implemented: ' + tmp3_TODO);
          }
        } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
          var tmp_17 = Companion_getInstance_25().PREC_MULTI_0n;
          postfix.v1a(new Pair(tmp_17, RegexParser$parsePattern$lambda_15($this)));
          c = next($this);
          var tmp7_subject = c;
          if (tmp7_subject === _Char___init__impl__6a9atx(63)) {
            // Inline function 'kotlin.TODO' call
            var tmp4_TODO = $this.r27_1;
            throw NotImplementedError.eg('An operation is not implemented: ' + tmp4_TODO);
          } else if (tmp7_subject === _Char___init__impl__6a9atx(43)) {
            // Inline function 'kotlin.TODO' call
            var tmp5_TODO = $this.r27_1;
            throw NotImplementedError.eg('An operation is not implemented: ' + tmp5_TODO);
          }
        } else if (tmp0_subject === _Char___init__impl__6a9atx(123)) {
          var nb = StringBuilder.qa();
          c = next($this);
          while (_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false) {
            nb.b8(c);
            c = next($this);
          }
          var tmp8_elvis_lhs = toIntOrNull(nb.toString(), 10);
          var tmp_18;
          if (tmp8_elvis_lhs == null) {
            throw IllegalStateException.y1('Counted repetition must be one of the forms {n} | {n,} | {n,m} where n and m are numbers');
          } else {
            tmp_18 = tmp8_elvis_lhs;
          }
          var n = tmp_18;
          var tmp9_subject = c;
          if (tmp9_subject === _Char___init__impl__6a9atx(125)) {
            var tmp_19 = Companion_getInstance_25().PREC_REP;
            postfix.v1a(new Pair(tmp_19, RegexParser$parsePattern$lambda_16($this, n)));
            c = next($this);
          } else if (tmp9_subject === _Char___init__impl__6a9atx(44)) {
            c = next($this);
            if (c === _Char___init__impl__6a9atx(125)) {
              var tmp_20 = Companion_getInstance_25().PREC_REP;
              postfix.v1a(new Pair(tmp_20, RegexParser$parsePattern$lambda_17($this, n)));
              c = next($this);
            } else {
              var mb = StringBuilder.qa();
              mb.b8(c);
              c = next($this);
              while (_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false) {
                mb.b8(c);
                c = next($this);
              }
              var tmp11_elvis_lhs = toIntOrNull(mb.toString(), 10);
              var tmp_21;
              if (tmp11_elvis_lhs == null) {
                throw IllegalStateException.y1('Counted repetition must be one of the forms {n} | {n,} | {n,m} where n and m are numbers');
              } else {
                tmp_21 = tmp11_elvis_lhs;
              }
              var m = tmp_21;
              if (c === _Char___init__impl__6a9atx(125)) {
                var tmp_22 = Companion_getInstance_25().PREC_REP;
                postfix.v1a(new Pair(tmp_22, RegexParser$parsePattern$lambda_18($this, n, m)));
                c = next($this);
              } else {
                // Inline function 'kotlin.error' call
                throw IllegalStateException.y1('Counted repetition must be one of the forms {n} | {n,} | {n,m} where n and m are numbers');
              }
            }
          } else {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.y1('Counted repetition must be one of the forms {n} | {n,} | {n,m} where n and m are numbers');
          }
        } else if (tmp0_subject === _Char___init__impl__6a9atx(41)) {
          while (!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) {
            postfix.v1a(opStack.w1a());
          }
          if (!opStack.k17() ? opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN : false) {
            opStack.w1a();
          }
          needConcat.w1a();
          if (needConcat.w1a()) {
            while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
              postfix.v1a(opStack.w1a());
            }
            var tmp_23 = Companion_getInstance_25().PREC_CONCAT;
            opStack.v1a(new Pair(tmp_23, RegexParser$parsePattern$lambda_19($this)));
          }
          needConcat.v1a(true);
          c = next($this);
        } else {
          var cc_0 = c;
          var tmp_24 = Companion_getInstance_25().PREC_LITERAL;
          postfix.v1a(new Pair(tmp_24, RegexParser$parsePattern$lambda_20($this, cc_0)));
          if (needConcat.w1a()) {
            while ((!opStack.k17() ? !(opStack.o1a().ri_1 === Companion_getInstance_25().PREC_GROUP_OPEN) : false) ? opStack.o1a().ri_1 < Companion_getInstance_25().PREC_CONCAT : false) {
              postfix.v1a(opStack.w1a());
            }
            var tmp_25 = Companion_getInstance_25().PREC_CONCAT;
            opStack.v1a(new Pair(tmp_25, RegexParser$parsePattern$lambda_21($this)));
          }
          needConcat.v1a(true);
          c = next($this);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        // Inline function 'kotlin.text.substring' call
        var tmp9_substring = $this.r27_1;
        // Inline function 'kotlin.comparisons.maxOf' call
        var tmp6_maxOf = $this.t27_1 - 5 | 0;
        var tmp10_substring = Math.max(0, tmp6_maxOf);
        // Inline function 'kotlin.comparisons.minOf' call
        var tmp7_minOf = $this.r27_1.length;
        var tmp8_minOf = $this.t27_1;
        var tmp11_substring = Math.min(tmp7_minOf, tmp8_minOf);
        // Inline function 'kotlin.js.asDynamic' call
        var before = tmp9_substring.substring(tmp10_substring, tmp11_substring);
        // Inline function 'kotlin.text.substring' call
        var tmp16_substring = $this.r27_1;
        // Inline function 'kotlin.comparisons.maxOf' call
        var tmp12_maxOf = $this.r27_1.length;
        var tmp13_maxOf = $this.t27_1 - 5 | 0;
        var tmp17_substring = Math.max(tmp12_maxOf, tmp13_maxOf);
        // Inline function 'kotlin.comparisons.minOf' call
        var tmp14_minOf = $this.r27_1.length;
        var tmp15_minOf = $this.t27_1 + 5 | 0;
        var tmp18_substring = Math.min(tmp14_minOf, tmp15_minOf);
        // Inline function 'kotlin.js.asDynamic' call
        var after = tmp16_substring.substring(tmp17_substring, tmp18_substring);
        var posStr = before + '^' + after;
        // Inline function 'kotlin.error' call
        var tmp19_error = 'Failed to parse regex "' + $this.r27_1 + '" at position ' + $this.t27_1 + ', "' + posStr + '", ' + t.message;
        throw IllegalStateException.y1(toString(tmp19_error));
      } else {
        throw $p;
      }
    }
    while (!opStack.k17()) {
      postfix.v1a(opStack.w1a());
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = postfix.c29().u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.language.agl.regex.RegexParser.parsePattern.<anonymous>' call
      element.si_1();
    }
  }
  $this.u27_1.q27();
}
function parsePatternEscape($this) {
  var c = next($this);
  var tmp0_subject = c;
  var tmp;
  if (tmp0_subject === _Char___init__impl__6a9atx(92)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(40)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(124)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(91)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(46)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(36)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(63)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(43)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), c));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(116)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(9)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(110)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(10)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(114)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(13)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(102)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(12)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(97)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(7)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(101)) {
    tmp = new Pair(EscapeKind_SINGLE_getInstance(), new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(27)));
  } else if (tmp0_subject === _Char___init__impl__6a9atx(99)) {
    throw NotImplementedError.eg('An operation is not implemented: Control char');
  } else if (tmp0_subject === _Char___init__impl__6a9atx(100)) {
    tmp = Companion_getInstance_25().PREDEFINED_DIGIT;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(68)) {
    tmp = Companion_getInstance_25().PREDEFINED_DIGIT_NEGATED;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(82)) {
    tmp = Companion_getInstance_25().PREDEFINED_UNICODE_LINEBREAK;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(115)) {
    tmp = Companion_getInstance_25().PREDEFINED_WHITESPACE;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(83)) {
    tmp = Companion_getInstance_25().PREDEFINED_WHITESPACE_NEGATED;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(119)) {
    tmp = Companion_getInstance_25().PREDEFINED_WORD;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(87)) {
    tmp = Companion_getInstance_25().PREDEFINED_WORD_NEGATED;
  } else if (tmp0_subject === _Char___init__impl__6a9atx(48)) {
    throw NotImplementedError.eg('An operation is not implemented: Octal value');
  } else if (tmp0_subject === _Char___init__impl__6a9atx(120)) {
    throw NotImplementedError.eg('An operation is not implemented: hex value');
  } else if (tmp0_subject === _Char___init__impl__6a9atx(117)) {
    throw NotImplementedError.eg('An operation is not implemented: unicode hex value');
  } else if (tmp0_subject === _Char___init__impl__6a9atx(81)) {
    var sb = StringBuilder.qa();
    var end = false;
    c = next($this);
    while (!end) {
      if (c === _Char___init__impl__6a9atx(92)) {
        c = next($this);
        if (_Char___init__impl__6a9atx(69) === c) {
          end = true;
        } else {
          sb.b8(c);
        }
      } else {
        sb.b8(c);
        c = next($this);
      }
    }
    tmp = new Pair(EscapeKind_LITERAL_getInstance(), sb.toString());
  } else {
    var tmp0_TODO = '' + new Char(c) + ' at ' + $this.t27_1 + ' in ' + $this.r27_1;
    throw NotImplementedError.eg('An operation is not implemented: ' + tmp0_TODO);
  }
  return tmp;
}
function parseCharacterClass($this) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var options = ArrayList.i4();
  var c = parseNextCharOrEscape($this);
  var tmp;
  if (_Char___init__impl__6a9atx(94) === c) {
    c = parseNextCharOrEscape($this);
    tmp = true;
  } else {
    tmp = false;
  }
  var negated = tmp;
  var f = c;
  while (!(c === _Char___init__impl__6a9atx(93))) {
    c = parseNextCharOrEscape($this);
    var tmp0_subject = c;
    if (tmp0_subject === _Char___init__impl__6a9atx(93)) {
      options.e1(new CharacterMatcher(MatcherKind_LITERAL_getInstance(), f));
    } else if (tmp0_subject === _Char___init__impl__6a9atx(45)) {
      c = parseNextCharOrEscape($this);
      if (c === _Char___init__impl__6a9atx(93)) {
        options.e1(new CharacterMatcher(MatcherKind_LITERAL_getInstance(), f));
        options.e1(new CharacterMatcher(MatcherKind_LITERAL_getInstance(), _Char___init__impl__6a9atx(45)));
      } else {
        options.e1(new CharacterMatcher(MatcherKind_RANGE_getInstance(), f, c));
        c = parseNextCharOrEscape($this);
        f = c;
      }
    } else {
      options.e1(new CharacterMatcher(MatcherKind_LITERAL_getInstance(), f));
      f = c;
    }
  }
  var tmp_0;
  if (negated) {
    var tmp_1 = MatcherKind_NEGATED_getInstance();
    var tmp$ret$4;
    // Inline function 'kotlin.arrayOf' call
    var tmp_2 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$1 = copyToArray(options);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$4 = [new CharacterMatcher(tmp_2, VOID, VOID, tmp$ret$1)];
    tmp_0 = new CharacterMatcher(tmp_1, VOID, VOID, tmp$ret$4);
  } else {
    var tmp_3 = MatcherKind_ONE_OF_getInstance();
    var tmp$ret$5;
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp$ret$5 = copyToArray(options);
    tmp_0 = new CharacterMatcher(tmp_3, VOID, VOID, tmp$ret$5);
  }
  return tmp_0;
}
function parseNextCharOrEscape($this) {
  var c = next($this);
  return c === _Char___init__impl__6a9atx(92) ? parseCharacterClassEscape($this) : c;
}
function parseCharacterClassEscape($this) {
  var c = next($this);
  var tmp;
  if (c === _Char___init__impl__6a9atx(92)) {
    tmp = _Char___init__impl__6a9atx(92);
  } else if (c === _Char___init__impl__6a9atx(36)) {
    tmp = _Char___init__impl__6a9atx(36);
  } else if (c === _Char___init__impl__6a9atx(116)) {
    tmp = _Char___init__impl__6a9atx(9);
  } else if (c === _Char___init__impl__6a9atx(110)) {
    tmp = _Char___init__impl__6a9atx(10);
  } else if (c === _Char___init__impl__6a9atx(114)) {
    tmp = _Char___init__impl__6a9atx(13);
  } else if (c === _Char___init__impl__6a9atx(102)) {
    tmp = _Char___init__impl__6a9atx(12);
  } else if (c === _Char___init__impl__6a9atx(97)) {
    tmp = _Char___init__impl__6a9atx(7);
  } else if (c === _Char___init__impl__6a9atx(101)) {
    tmp = _Char___init__impl__6a9atx(27);
  } else if (c === _Char___init__impl__6a9atx(99)) {
    throw NotImplementedError.eg('An operation is not implemented: Control char');
  } else if (c === _Char___init__impl__6a9atx(117)) {
    var unicodeChar = parseUnicode($this);
    tmp = unicodeChar;
  } else if (c === _Char___init__impl__6a9atx(120)) {
    tmp = parseHex($this);
  } else {
    var tmp0_error = "Unknown escape code '" + new Char(c) + "' in character class, at position " + $this.t27_1 + ' in ' + $this.r27_1 + ', ';
    throw IllegalStateException.y1(toString(tmp0_error));
  }
  return tmp;
}
function parseHex($this) {
  var tmp0_elvis_lhs = toHexInt($this, next($this), 16);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp0_error = 'Cannot parse Hex, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp0_error));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var hex = tmp;
  var tmp_0 = hex;
  var tmp1_elvis_lhs = toHexInt($this, next($this), 1);
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp1_error = 'Cannot parse Hex, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp1_error));
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  hex = tmp_0 + tmp_1 | 0;
  return numberToChar(hex);
}
function parseUnicode($this) {
  var tmp0_elvis_lhs = toHexInt($this, next($this), 4096);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp0_error = 'Cannot parse Unicode, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp0_error));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var unicode = tmp;
  var tmp_0 = unicode;
  var tmp1_elvis_lhs = toHexInt($this, next($this), 256);
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp1_error = 'Cannot parse Unicode, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp1_error));
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  unicode = tmp_0 + tmp_1 | 0;
  var tmp_2 = unicode;
  var tmp2_elvis_lhs = toHexInt($this, next($this), 16);
  var tmp_3;
  if (tmp2_elvis_lhs == null) {
    var tmp2_error = 'Cannot parse Unicode, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp2_error));
  } else {
    tmp_3 = tmp2_elvis_lhs;
  }
  unicode = tmp_2 + tmp_3 | 0;
  var tmp_4 = unicode;
  var tmp3_elvis_lhs = toHexInt($this, next($this), 1);
  var tmp_5;
  if (tmp3_elvis_lhs == null) {
    var tmp3_error = 'Cannot parse Unicode, at position ' + $this.t27_1;
    throw IllegalStateException.y1(toString(tmp3_error));
  } else {
    tmp_5 = tmp3_elvis_lhs;
  }
  unicode = tmp_4 + tmp_5 | 0;
  return numberToChar(unicode);
}
function toHexInt($this, c, power) {
  var v = toIntOrNull(toString_0(c), 16);
  return null == v ? null : imul(v, power);
}
function RegexParser$parsePattern$lambda(this$0, $matcher) {
  return function () {
    this$0.u27_1.j27($matcher);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_0(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_1(this$0, $cc) {
  return function () {
    this$0.u27_1.i27($cc);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_2(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_3(this$0, $d) {
  return function () {
    this$0.u27_1.i27($d);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_4(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_5(this$0) {
  return function () {
    this$0.u27_1.d27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_6(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_7(this$0) {
  return function () {
    this$0.u27_1.h27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_8(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_9(this$0, $options) {
  return function () {
    this$0.u27_1.j27($options);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_10(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_11() {
  return Unit_getInstance();
}
function RegexParser$parsePattern$lambda_12(this$0) {
  return function () {
    this$0.u27_1.l27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_13(this$0) {
  return function () {
    this$0.u27_1.m27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_14(this$0) {
  return function () {
    this$0.u27_1.n27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_15(this$0) {
  return function () {
    this$0.u27_1.o27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_16(this$0, $n) {
  return function () {
    this$0.u27_1.p27($n, $n);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_17(this$0, $n) {
  return function () {
    this$0.u27_1.p27($n, -1);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_18(this$0, $n, $m) {
  return function () {
    this$0.u27_1.p27($n, $m);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_19(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_20(this$0, $cc) {
  return function () {
    this$0.u27_1.i27($cc);
    return Unit_getInstance();
  };
}
function RegexParser$parsePattern$lambda_21(this$0) {
  return function () {
    this$0.u27_1.k27();
    return Unit_getInstance();
  };
}
function EscapeKind_SINGLE_getInstance() {
  EscapeKind_initEntries();
  return EscapeKind_SINGLE_instance;
}
function EscapeKind_LITERAL_getInstance() {
  EscapeKind_initEntries();
  return EscapeKind_LITERAL_instance;
}
var Companion_instance_24;
function Companion_getInstance_26() {
  if (Companion_instance_24 === VOID)
    new Companion_24();
  return Companion_instance_24;
}
var MatcherKind_EMPTY_instance;
var MatcherKind_ANY_instance;
var MatcherKind_END_OF_LINE_OR_INPUT_instance;
var MatcherKind_NEGATED_instance;
var MatcherKind_LITERAL_instance;
var MatcherKind_ONE_OF_instance;
var MatcherKind_RANGE_instance;
var MatcherKind_entriesInitialized;
function MatcherKind_initEntries() {
  if (MatcherKind_entriesInitialized)
    return Unit_getInstance();
  MatcherKind_entriesInitialized = true;
  MatcherKind_EMPTY_instance = new MatcherKind('EMPTY', 0);
  MatcherKind_ANY_instance = new MatcherKind('ANY', 1);
  MatcherKind_END_OF_LINE_OR_INPUT_instance = new MatcherKind('END_OF_LINE_OR_INPUT', 2);
  MatcherKind_NEGATED_instance = new MatcherKind('NEGATED', 3);
  MatcherKind_LITERAL_instance = new MatcherKind('LITERAL', 4);
  MatcherKind_ONE_OF_instance = new MatcherKind('ONE_OF', 5);
  MatcherKind_RANGE_instance = new MatcherKind('RANGE', 6);
}
var TransitionKind_MATCHER_instance;
var TransitionKind_EMPTY_instance;
var TransitionKind_END_OF_LINE_OR_INPUT_instance;
var TransitionKind_entriesInitialized;
function TransitionKind_initEntries() {
  if (TransitionKind_entriesInitialized)
    return Unit_getInstance();
  TransitionKind_entriesInitialized = true;
  TransitionKind_MATCHER_instance = new TransitionKind('MATCHER', 0);
  TransitionKind_EMPTY_instance = new TransitionKind('EMPTY', 1);
  TransitionKind_END_OF_LINE_OR_INPUT_instance = new TransitionKind('END_OF_LINE_OR_INPUT', 2);
}
function addNextStates(nextStates, next) {
  var tmp;
  if (null == next) {
    tmp = false;
  } else {
    var tmp_0;
    if (next.q26_1) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp0_any = next.r26_1;
        var tmp_1;
        if (isInterface(tmp0_any, Collection)) {
          tmp_1 = tmp0_any.y();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = tmp0_any.u();
        while (tmp0_iterator.h1()) {
          var element = tmp0_iterator.j1();
          // Inline function 'net.akehurst.language.agl.regex.addNextStates.<anonymous>' call
          if (addNextStates(nextStates, element.x26_1)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp_0 = tmp$ret$0;
    } else {
      nextStates.e1(next);
      tmp_0 = equals(next, Companion_getInstance_24().t26_1);
    }
    tmp = tmp_0;
  }
  return tmp;
}
function MatcherKind_EMPTY_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_EMPTY_instance;
}
function MatcherKind_ANY_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_ANY_instance;
}
function MatcherKind_END_OF_LINE_OR_INPUT_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_END_OF_LINE_OR_INPUT_instance;
}
function MatcherKind_NEGATED_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_NEGATED_instance;
}
function MatcherKind_LITERAL_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_LITERAL_instance;
}
function MatcherKind_ONE_OF_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_ONE_OF_instance;
}
function MatcherKind_RANGE_getInstance() {
  MatcherKind_initEntries();
  return MatcherKind_RANGE_instance;
}
function TransitionKind_MATCHER_getInstance() {
  TransitionKind_initEntries();
  return TransitionKind_MATCHER_instance;
}
function TransitionKind_EMPTY_getInstance() {
  TransitionKind_initEntries();
  return TransitionKind_EMPTY_instance;
}
var MergeOptions_PREFER_EXISTING_instance;
var MergeOptions_PREFER_NEW_instance;
var MergeOptions_UNDECIDABLE_instance;
var MergeOptions_KEEP_BOTH_AS_ALTERNATIVES_instance;
var MergeOptions_entriesInitialized;
function MergeOptions_initEntries() {
  if (MergeOptions_entriesInitialized)
    return Unit_getInstance();
  MergeOptions_entriesInitialized = true;
  MergeOptions_PREFER_EXISTING_instance = new MergeOptions('PREFER_EXISTING', 0);
  MergeOptions_PREFER_NEW_instance = new MergeOptions('PREFER_NEW', 1);
  MergeOptions_UNDECIDABLE_instance = new MergeOptions('UNDECIDABLE', 2);
  MergeOptions_KEEP_BOTH_AS_ALTERNATIVES_instance = new MergeOptions('KEEP_BOTH_AS_ALTERNATIVES', 3);
}
var Companion_instance_25;
function Companion_getInstance_27() {
  if (Companion_instance_25 === VOID)
    new Companion_25();
  return Companion_instance_25;
}
function addGrowingHead($this, oldHead, next) {
  if (null == oldHead) {
    $this.y1r_1.k29(next);
  } else {
    $this.y1r_1.j29(oldHead, next);
    var new_0 = Unit_getInstance();
  }
}
function preferNewCompleteParentFirstChild($this, oldParent, newParent, child, previous) {
  $this.z1r_1.m29(newParent.l29(), child, false);
  addGrowingHead($this, previous, newParent);
  return true;
}
function preferNewCompleteParentLastChild($this, oldParent, newParent, child, previous) {
  $this.z1r_1.n29(oldParent, newParent.l29(), child, false);
  $this.o29(oldParent);
  addGrowingHead($this, previous, newParent);
  return true;
}
function preferExistingCompleteParentFirstChild($this, oldParent, newParent, child, previous) {
  return false;
}
function preferExistingCompleteParentLastChild($this, oldParent, newParent, child, previous) {
  return false;
}
function keepBothCompleteParentsFirstChild($this, oldParent, newParent, child, previous) {
  $this.z1r_1.m29(newParent.l29(), child, true);
  addGrowingHead($this, previous, newParent);
  return true;
}
function keepBothCompleteParentsLastChild($this, oldParent, newParent, child, previous) {
  $this.z1r_1.n29(oldParent, newParent.l29(), child, true);
  addGrowingHead($this, previous, newParent);
  return true;
}
function useExistingCompleteParentFirstChild($this, newParent, child, previous) {
  addGrowingHead($this, previous, newParent);
  return true;
}
function useExistingCompleteParentLastChild($this, newParent, child, previous) {
  addGrowingHead($this, previous, newParent);
  return true;
}
function mergeDecisionOnLength($this, existingParent, newParent, ifEqual) {
  var existingLength = existingParent.e1t_1 - existingParent.c1t_1 | 0;
  var newLength = newParent.e1t_1 - newParent.c1t_1 | 0;
  return newLength > existingLength ? MergeOptions_PREFER_NEW_getInstance() : existingLength > newLength ? MergeOptions_PREFER_EXISTING_getInstance() : ifEqual();
}
function mergeDecisionOnPriority($this, existingParent, newParent, ifEqual) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!((existingParent.b1t_1.a14() ? newParent.b1t_1.a14() : false) ? equals(existingParent.b1t_1.lz(), newParent.b1t_1.lz()) : false)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var existingPriority = existingParent.e14().p(0);
  var newPriority = newParent.e14().p(0);
  return newPriority > existingPriority ? MergeOptions_PREFER_NEW_getInstance() : existingPriority > newPriority ? MergeOptions_PREFER_EXISTING_getInstance() : ifEqual();
}
function mergeDecision($this, existingParent, newParent) {
  var tmp;
  if (newParent.b1t_1.a14()) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(newParent.b1t_1.b14().o() === 1)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.y1(toString(message));
      }
    }
    var tmp_0;
    switch (newParent.b1t_1.f14().bc_1) {
      case 0:
        throw IllegalStateException.y1('should never happen');
      case 2:
        tmp_0 = mergeDecisionOnLength($this, existingParent, newParent, ParseGraph$mergeDecision$lambda($this, existingParent, newParent));
        break;
      case 3:
        tmp_0 = mergeDecisionOnPriority($this, existingParent, newParent, ParseGraph$mergeDecision$lambda_0($this, existingParent, newParent));
        break;
      case 1:
        tmp_0 = MergeOptions_KEEP_BOTH_AS_ALTERNATIVES_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  } else {
    tmp = mergeDecisionOnLength($this, existingParent, newParent, ParseGraph$mergeDecision$lambda_1);
  }
  return tmp;
}
function doRecordGoal($this, goal) {
  $this.z1r_1.q1t_1.setRoot(goal);
  $this.x1r_1.e1(goal);
  $this.a1s_1 = $this.v1r_1.f1q(goal.e1t_1);
}
function prevOfToString($this, n) {
  var prev = toList($this.y1r_1.p29(n));
  var tmp;
  if (prev.y()) {
    tmp = '';
  } else if (1 === prev.o()) {
    var p = first_0(prev);
    tmp = ' --> ' + p + prevOfToString($this, p);
  } else {
    var p_0 = first_0(prev);
    tmp = ' -' + prev.o() + '-> ' + p_0 + prevOfToString($this, p_0);
  }
  return tmp;
}
function ParseGraph$_gss$lambda(parent, child) {
  var tmp;
  if (parent.x1q_1 < child.x1q_1) {
    tmp = 1;
  } else if (parent.x1q_1 > child.x1q_1) {
    tmp = -1;
  } else {
    var tmp_0;
    if (parent.e1s().vx() ? child.e1s().vx() : false) {
      var tmp_1;
      if (equals(parent.e1s().lz(), child.e1s().lz())) {
        var tmp_2;
        if (parent.e1s().a14() ? child.e1s().a14() : false) {
          tmp_2 = parent.e1s().e14().p(0) > child.e1s().e14().p(0) ? 1 : parent.e1s().e14().p(0) < child.e1s().e14().p(0) ? -1 : 0;
        } else if (parent.e1s().a14()) {
          tmp_2 = -1;
        } else if (child.e1s().a14()) {
          tmp_2 = 1;
        } else {
          tmp_2 = 0;
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = parent.v1q_1 < child.v1q_1 ? -1 : parent.v1q_1 > child.v1q_1 ? 1 : 0;
      }
      tmp_0 = tmp_1;
    } else if (parent.e1s().vx()) {
      tmp_0 = -1;
    } else if (child.e1s().vx()) {
      tmp_0 = 1;
    } else {
      tmp_0 = parent.v1q_1 < child.v1q_1 ? -1 : parent.v1q_1 > child.v1q_1 ? 1 : 0;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function ParseGraph$mergeDecision$lambda$lambda() {
  return MergeOptions_UNDECIDABLE_getInstance();
}
function ParseGraph$mergeDecision$lambda(this$0, $existingParent, $newParent) {
  return function () {
    return mergeDecisionOnPriority(this$0, $existingParent, $newParent, ParseGraph$mergeDecision$lambda$lambda);
  };
}
function ParseGraph$mergeDecision$lambda$lambda_0() {
  return MergeOptions_UNDECIDABLE_getInstance();
}
function ParseGraph$mergeDecision$lambda_0(this$0, $existingParent, $newParent) {
  return function () {
    return mergeDecisionOnLength(this$0, $existingParent, $newParent, ParseGraph$mergeDecision$lambda$lambda_0);
  };
}
function ParseGraph$mergeDecision$lambda_1() {
  return MergeOptions_UNDECIDABLE_getInstance();
}
function ParseGraph$dropStackWithHead$lambda(this$0) {
  return function (n) {
    this$0.r29(n);
    return Unit_getInstance();
  };
}
function ParseGraph$toString$lambda(this$0) {
  return function (h) {
    var p = prevOfToString(this$0, h);
    return '' + h + p;
  };
}
function MergeOptions_PREFER_EXISTING_getInstance() {
  MergeOptions_initEntries();
  return MergeOptions_PREFER_EXISTING_instance;
}
function MergeOptions_PREFER_NEW_getInstance() {
  MergeOptions_initEntries();
  return MergeOptions_PREFER_NEW_instance;
}
function MergeOptions_UNDECIDABLE_getInstance() {
  MergeOptions_initEntries();
  return MergeOptions_UNDECIDABLE_instance;
}
function MergeOptions_KEEP_BOTH_AS_ALTERNATIVES_getInstance() {
  MergeOptions_initEntries();
  return MergeOptions_KEEP_BOTH_AS_ALTERNATIVES_instance;
}
function RuntimeState$uncompressed$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.q1r_1.yy_1;
    var tmp$ret$4;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$3;
      // Inline function 'net.akehurst.language.agl.runtime.graph.RuntimeState.uncompressed$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = this$0.r1r_1;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator_0 = tmp0_map.u();
      while (tmp0_iterator_0.h1()) {
        var item = tmp0_iterator_0.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.runtime.graph.RuntimeState.uncompressed$delegate.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$0 = new StateInfoUncompressed(element, item.b12());
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var list = tmp$ret$3;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$4 = tmp0_flatMapTo;
    tmp$ret$5 = tmp$ret$4;
    return toSet(tmp$ret$5);
  };
}
function RuntimeState$toString$lambda(it) {
  var tmp = it.b12();
  return joinToString(tmp, VOID, VOID, VOID, VOID, VOID, RuntimeState$toString$lambda$lambda);
}
function RuntimeState$toString$lambda$lambda(it) {
  return it.mz();
}
function setGrowingChildren($this, parent, children) {
  Debug_getInstance();
  if (false) {
    var tmp = Debug_getInstance();
    var tmp_0 = IndentDelta_NONE_getInstance();
    tmp.uz(tmp_0, TreeData$setGrowingChildren$lambda(parent, children));
  }
  // Inline function 'kotlin.collections.set' call
  $this.r1t_1.m3(parent, children);
}
function removeGrowingNode($this, gni) {
  Debug_getInstance();
  if (false) {
    var tmp = Debug_getInstance();
    var tmp_0 = IndentDelta_NONE_getInstance();
    tmp.uz(tmp_0, TreeData$removeGrowingNode$lambda(gni));
  }
  return $this.r1t_1.q3(gni);
}
function TreeData$setGrowingChildren$lambda($parent, $children) {
  return function () {
    return 'Set growing children: ' + $parent + ' = ' + $children;
  };
}
function TreeData$removeGrowingNode$lambda($gni) {
  return function () {
    return 'Remove growing parent: ' + $gni;
  };
}
function CompleteNodeIndex$firstRule$delegate$lambda(this$0) {
  return function () {
    var tmp = this$0.b1t_1.yy_1.p(0).qx_1;
    return tmp instanceof RuntimeRule ? tmp : THROW_CCE();
  };
}
function CompleteNodeIndex$toString$lambda(it) {
  return it.mz();
}
var Companion_instance_26;
function Companion_getInstance_28() {
  if (Companion_instance_26 === VOID)
    new Companion_26();
  return Companion_instance_26;
}
function GrowingNodeIndex$complete$delegate$lambda(this$0) {
  return function () {
    return new CompleteNodeIndex(this$0.u1q_1.q1r_1, this$0.v1q_1, this$0.w1q_1, this$0.x1q_1);
  };
}
function GrowingNodeIndex$toString$lambda(it) {
  return it.mz();
}
function GrowingNodeIndex$toString$lambda_0(it) {
  return it;
}
function complete$factory() {
  return getPropertyCallableRef('complete', 1, KProperty1, function (receiver) {
    return receiver.l29();
  }, null);
}
var Companion_instance_27;
function Companion_getInstance_29() {
  if (Companion_instance_27 === VOID)
    new Companion_27();
  return Companion_instance_27;
}
function _StateNumber___init__impl__9xx5q7(value) {
  return value;
}
function _StateNumber___get_value__impl__2zl2l($this) {
  return $this;
}
var Assoc_NONE_instance;
var Assoc_LEFT_instance;
var Assoc_RIGHT_instance;
var Assoc_entriesInitialized;
function Assoc_initEntries() {
  if (Assoc_entriesInitialized)
    return Unit_getInstance();
  Assoc_entriesInitialized = true;
  Assoc_NONE_instance = new Assoc('NONE', 0);
  Assoc_LEFT_instance = new Assoc('LEFT', 1);
  Assoc_RIGHT_instance = new Assoc('RIGHT', 2);
}
function Assoc_LEFT_getInstance() {
  Assoc_initEntries();
  return Assoc_LEFT_instance;
}
function Assoc_RIGHT_getInstance() {
  Assoc_initEntries();
  return Assoc_RIGHT_instance;
}
function _get__rhs__d2tz9p($this) {
  var tmp = $this.qw_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('_rhs');
  }
}
function RuntimeRule$asTerminalRulePosition$delegate$lambda(this$0) {
  return function () {
    Companion_getInstance_29();
    return new RulePosition(this$0, 0, -1);
  };
}
function asTerminalRulePosition$factory() {
  return getPropertyCallableRef('asTerminalRulePosition', 1, KProperty1, function (receiver) {
    return receiver.vw();
  }, null);
}
var RuntimeRuleKind_GOAL_instance;
var RuntimeRuleKind_NON_TERMINAL_instance;
var RuntimeRuleKind_TERMINAL_instance;
var RuntimeRuleKind_EMBEDDED_instance;
var RuntimeRuleKind_entriesInitialized;
function RuntimeRuleKind_initEntries() {
  if (RuntimeRuleKind_entriesInitialized)
    return Unit_getInstance();
  RuntimeRuleKind_entriesInitialized = true;
  RuntimeRuleKind_GOAL_instance = new RuntimeRuleKind('GOAL', 0);
  RuntimeRuleKind_NON_TERMINAL_instance = new RuntimeRuleKind('NON_TERMINAL', 1);
  RuntimeRuleKind_TERMINAL_instance = new RuntimeRuleKind('TERMINAL', 2);
  RuntimeRuleKind_EMBEDDED_instance = new RuntimeRuleKind('EMBEDDED', 3);
}
function RuntimeRuleKind_TERMINAL_getInstance() {
  RuntimeRuleKind_initEntries();
  return RuntimeRuleKind_TERMINAL_instance;
}
var Companion_instance_28;
function Companion_getInstance_30() {
  if (Companion_instance_28 === VOID)
    new Companion_28();
  return Companion_instance_28;
}
function RuntimeRuleRhsPattern$regex$delegate$lambda(this$0) {
  return function () {
    return Regex.hb(this$0.p12_1);
  };
}
var Companion_instance_29;
function Companion_getInstance_31() {
  if (Companion_instance_29 === VOID)
    new Companion_29();
  return Companion_instance_29;
}
function _get__rulePositions__zi96g4($this) {
  // Inline function 'kotlin.collections.mapIndexedNotNull' call
  var tmp0_mapIndexedNotNull = $this.l2b_1;
  // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
  var tmp0_mapIndexedNotNullTo = ArrayList.i4();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var tmp0_iterator = tmp0_mapIndexedNotNull.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var tmp0_anonymous = checkIndexOverflow(tmp1);
    // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleRhsConcatenation.<get-_rulePositions>.<anonymous>' call
    var tmp;
    Companion_getInstance_29();
    if (0 === tmp0_anonymous) {
      tmp = null;
    } else {
      tmp = new RulePosition($this.x2a_1, 0, tmp0_anonymous);
    }
    var tmp0_safe_receiver = tmp;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp0_mapIndexedNotNullTo.e1(tmp0_safe_receiver);
    }
  }
  var tmp_0 = tmp0_mapIndexedNotNullTo;
  Companion_getInstance_29();
  return plus_2(tmp_0, new RulePosition($this.x2a_1, 0, -1));
}
function RuntimeRuleRhsConcatenation$_get_asString_$lambda_a0weeq(it) {
  return it.mz();
}
function RuntimeRuleRhsConcatenation$toString$lambda(it) {
  return it.mz() + '[' + it.nw_1 + ']';
}
function RuntimeRuleRhsChoice$_get_asString_$lambda_pebp4n(it) {
  return it.i2b();
}
function RuntimeRuleRhsChoice$toString$lambda(it) {
  return '' + it;
}
var RuntimeRuleChoiceKind_NONE_instance;
var RuntimeRuleChoiceKind_AMBIGUOUS_instance;
var RuntimeRuleChoiceKind_LONGEST_PRIORITY_instance;
var RuntimeRuleChoiceKind_PRIORITY_LONGEST_instance;
var RuntimeRuleChoiceKind_entriesInitialized;
function RuntimeRuleChoiceKind_initEntries() {
  if (RuntimeRuleChoiceKind_entriesInitialized)
    return Unit_getInstance();
  RuntimeRuleChoiceKind_entriesInitialized = true;
  RuntimeRuleChoiceKind_NONE_instance = new RuntimeRuleChoiceKind('NONE', 0);
  RuntimeRuleChoiceKind_AMBIGUOUS_instance = new RuntimeRuleChoiceKind('AMBIGUOUS', 1);
  RuntimeRuleChoiceKind_LONGEST_PRIORITY_instance = new RuntimeRuleChoiceKind('LONGEST_PRIORITY', 2);
  RuntimeRuleChoiceKind_PRIORITY_LONGEST_instance = new RuntimeRuleChoiceKind('PRIORITY_LONGEST', 3);
}
var Companion_instance_30;
function Companion_getInstance_32() {
  if (Companion_instance_30 === VOID)
    new Companion_30();
  return Companion_instance_30;
}
function RuntimeRuleChoiceKind_AMBIGUOUS_getInstance() {
  RuntimeRuleChoiceKind_initEntries();
  return RuntimeRuleChoiceKind_AMBIGUOUS_instance;
}
function RuntimeRuleChoiceKind_LONGEST_PRIORITY_getInstance() {
  RuntimeRuleChoiceKind_initEntries();
  return RuntimeRuleChoiceKind_LONGEST_PRIORITY_instance;
}
function RuntimeRuleChoiceKind_PRIORITY_LONGEST_getInstance() {
  RuntimeRuleChoiceKind_initEntries();
  return RuntimeRuleChoiceKind_PRIORITY_LONGEST_instance;
}
function regex$factory() {
  return getPropertyCallableRef('regex', 1, KProperty1, function (receiver) {
    return receiver.g1q();
  }, null);
}
function RuntimeRuleSet$Companion$numberForGrammar$lambda(it) {
  var tmp0_this = Companion_getInstance_33();
  var tmp1 = tmp0_this.s12_1;
  tmp0_this.s12_1 = tmp1 + 1 | 0;
  return tmp1;
}
var Companion_instance_31;
function Companion_getInstance_33() {
  if (Companion_instance_31 === VOID)
    new Companion_31();
  return Companion_instance_31;
}
function RuntimeRuleSet$goalRuleFor$lambda(this$0) {
  return function (it) {
    var ug = it;
    Companion_getInstance_33();
    Companion_getInstance_33();
    var gr = new RuntimeRule(this$0.yt_1, -1, '<GOAL>', false);
    gr.f1g(new RuntimeRuleRhsGoal(gr, ug));
    return gr;
  };
}
function RuntimeRuleSet$skipRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.au_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.skipRules$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = element.pw_1;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
}
function RuntimeRuleSet$skipTerminals$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.h1u();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.uw();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
}
function RuntimeRuleSet$nonSkipRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$3;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$2;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_filter = this$0.au_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.filterTo' call
    var tmp0_filterTo = ArrayList.i4();
    var tmp0_iterator = tmp0_filter.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.nonSkipRules$delegate.<anonymous>.<anonymous>' call
      tmp$ret$0 = !element.pw_1;
      if (tmp$ret$0) {
        tmp0_filterTo.e1(element);
      }
    }
    tmp$ret$1 = tmp0_filterTo;
    tmp$ret$2 = tmp$ret$1;
    var tmp1_toTypedArray = tmp$ret$2;
    tmp$ret$3 = copyToArray(tmp1_toTypedArray);
    return tmp$ret$3;
  };
}
function RuntimeRuleSet$nonSkipTerminals$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.au_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.nonSkipTerminals$delegate.<anonymous>.<anonymous>' call
      var tmp;
      if (element.ny()) {
        var tmp_0 = element.i11();
        tmp = toList((tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE()).k11_1.h1v());
      } else if (element.s10() ? !element.pw_1 : false) {
        tmp = listOf(element);
      } else {
        tmp = emptyList();
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
}
function RuntimeRuleSet$terminalRules$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0_flatMap = this$0.au_1;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator = tmp0_flatMap.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.terminalRules$delegate.<anonymous>.<anonymous>' call
      var tmp;
      if (element.ny()) {
        var tmp_0 = element.i11();
        tmp = toList((tmp_0 instanceof RuntimeRuleRhsEmbedded ? tmp_0 : THROW_CCE()).k11_1.a1v());
      } else if (element.s10()) {
        tmp = listOf(element);
      } else {
        tmp = emptyList();
      }
      tmp$ret$0 = tmp;
      var list = tmp$ret$0;
      addAll(tmp0_flatMapTo, list);
    }
    tmp$ret$1 = tmp0_flatMapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
}
function RuntimeRuleSet$skipParserStateSet$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.y2b().y()) {
      tmp = null;
    } else {
      var tmp$ret$3;
      // Inline function 'kotlin.also' call
      Companion_getInstance_33();
      Companion_getInstance_33();
      var tmp0_also = new RuntimeRule(this$0.yt_1, -4, '<SKIP-CHOICE>', false);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.skipParserStateSet$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'kotlin.collections.map' call
      var tmp0_map = this$0.y2b();
      var tmp$ret$1;
      // Inline function 'kotlin.collections.mapTo' call
      var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
      var tmp0_iterator = tmp0_map.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.skipParserStateSet$delegate.<anonymous>.<anonymous>.<anonymous>' call
        tmp$ret$0 = new RuntimeRuleRhsConcatenation(tmp0_also, listOf(item));
        tmp0_mapTo.e1(tmp$ret$0);
      }
      tmp$ret$1 = tmp0_mapTo;
      tmp$ret$2 = tmp$ret$1;
      var options = tmp$ret$2;
      var rhs = new RuntimeRuleRhsChoice(tmp0_also, RuntimeRuleChoiceKind_LONGEST_PRIORITY_getInstance(), options);
      tmp0_also.f1g(rhs);
      tmp$ret$3 = tmp0_also;
      var skipChoiceRule = tmp$ret$3;
      var tmp$ret$4;
      // Inline function 'kotlin.also' call
      Companion_getInstance_33();
      Companion_getInstance_33();
      var tmp1_also = new RuntimeRule(this$0.yt_1, -3, '<SKIP-MULTI>', false);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.skipParserStateSet$delegate.<anonymous>.<anonymous>' call
      tmp1_also.f1g(new RuntimeRuleRhsListSimple(tmp1_also, 1, -1, skipChoiceRule));
      tmp$ret$4 = tmp1_also;
      var skipMultiRule = tmp$ret$4;
      var tmp0_this = this$0;
      var tmp1 = tmp0_this.ou_1;
      tmp0_this.ou_1 = tmp1 + 1 | 0;
      var ss = new ParserStateSet(tmp1, this$0, skipMultiRule, true, AutomatonKind_LOOKAHEAD_1_getInstance(), false);
      tmp = ss;
    }
    return tmp;
  };
}
function RuntimeRuleSet$toString$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.toString.<anonymous>' call
  var tmp = a.mz();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.runtime.structure.RuntimeRuleSet.toString.<anonymous>' call
  tmp$ret$1 = b.mz();
  return compareValues(tmp, tmp$ret$1);
}
function skipRules$factory() {
  return getPropertyCallableRef('skipRules', 1, KProperty1, function (receiver) {
    return receiver.y2b();
  }, null);
}
function skipTerminals$factory() {
  return getPropertyCallableRef('skipTerminals', 1, KProperty1, function (receiver) {
    return receiver.n11();
  }, null);
}
function nonSkipTerminals$factory() {
  return getPropertyCallableRef('nonSkipTerminals', 1, KProperty1, function (receiver) {
    return receiver.h1v();
  }, null);
}
function terminalRules$factory() {
  return getPropertyCallableRef('terminalRules', 1, KProperty1, function (receiver) {
    return receiver.a1v();
  }, null);
}
function skipParserStateSet$factory() {
  return getPropertyCallableRef('skipParserStateSet', 1, KProperty1, function (receiver) {
    return receiver.h1u();
  }, null);
}
function CountTreesVisitor$visitBranch$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.sppt.CountTreesVisitor.visitBranch.<anonymous>' call
  var tmp = a.o3();
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.sppt.CountTreesVisitor.visitBranch.<anonymous>' call
  tmp$ret$1 = b.o3();
  return compareValues(tmp, tmp$ret$1);
}
function _get__tokensByLine__ebyq43($this) {
  // Inline function 'kotlin.getValue' call
  _tokensByLine$factory();
  return $this.j2c_1.p3();
}
function SPPTFromTreeData$_tokensByLine$delegate$lambda(this$0) {
  return function () {
    var visitor = new TokensByLineVisitor(this$0.g2c_1);
    visitor.p2c(this$0, emptyList());
    return visitor.o2c_1;
  };
}
function SPPTFromTreeData$asSentence$delegate$lambda(this$0) {
  return function () {
    var walker = new SpptWalkerToInputSentence(this$0.g2c_1);
    this$0.f2c_1.traverseTreeDepthFirst(walker, false);
    return walker.s2c();
  };
}
function SPPTFromTreeData$countTrees$delegate$lambda(this$0) {
  return function () {
    return (new CountTreesVisitor()).visitTree(this$0, Unit_getInstance());
  };
}
function SPPTFromTreeData$toStringAll$delegate$lambda(this$0) {
  return function () {
    return this$0.toStringAllWithIndent('  ', true);
  };
}
function _tokensByLine$factory() {
  return getPropertyCallableRef('_tokensByLine', 1, KProperty1, function (receiver) {
    return _get__tokensByLine__ebyq43(receiver);
  }, null);
}
function asSentence$factory() {
  return getPropertyCallableRef('asSentence', 1, KProperty1, function (receiver) {
    return receiver.w2c();
  }, null);
}
function countTrees$factory() {
  return getPropertyCallableRef('countTrees', 1, KProperty1, function (receiver) {
    return receiver.x2c();
  }, null);
}
function toStringAll$factory() {
  return getPropertyCallableRef('toStringAll', 1, KProperty1, function (receiver) {
    return receiver.y2c();
  }, null);
}
function scanError($this) {
  // Inline function 'kotlin.text.substring' call
  var tmp1_substring = $this.k2d_1;
  // Inline function 'kotlin.comparisons.maxOf' call
  var tmp0_maxOf = $this.m2d_1.x2d_1 - 5 | 0;
  var tmp2_substring = Math.max(0, tmp0_maxOf);
  var tmp3_substring = $this.m2d_1.x2d_1;
  // Inline function 'kotlin.js.asDynamic' call
  var before = tmp1_substring.substring(tmp2_substring, tmp3_substring);
  // Inline function 'kotlin.text.substring' call
  var tmp6_substring = $this.k2d_1;
  var tmp7_substring = $this.m2d_1.x2d_1;
  // Inline function 'kotlin.comparisons.minOf' call
  var tmp4_minOf = $this.k2d_1.length;
  var tmp5_minOf = $this.m2d_1.x2d_1 + 5 | 0;
  var tmp8_substring = Math.min(tmp4_minOf, tmp5_minOf);
  // Inline function 'kotlin.js.asDynamic' call
  var after = tmp6_substring.substring(tmp7_substring, tmp8_substring);
  var seg = before + '^' + after;
  // Inline function 'kotlin.error' call
  var tmp9_error = 'Tree String invalid at position ' + $this.m2d_1.x2d_1 + ', ...' + seg + '...';
  throw IllegalStateException.y1(toString(tmp9_error));
}
function scanEmpty($this) {
  $this.m2d_1.j2e(Tokens_getInstance().z2d_1);
  $this.n2d_1 = $this.o2d_1;
  var emptyNode = emptyLeaf($this, $this.n2d_1, $this.o2d_1);
  $this.r2d_1.o1a().e1(emptyNode);
}
function scanLiteral($this) {
  var literal = $this.m2d_1.j2e(Tokens_getInstance().e2e_1);
  var textWithQuotes = literal;
  // Inline function 'kotlin.text.substring' call
  var tmp0_substring = textWithQuotes.length - 1 | 0;
  // Inline function 'kotlin.js.asDynamic' call
  var text = textWithQuotes.substring(1, tmp0_substring);
  var textUnescaped = Companion_getInstance_31().e1g(text);
  $this.n2d_1 = $this.o2d_1;
  $this.o2d_1 = $this.o2d_1 + textUnescaped.length | 0;
  var literalUnescaped = Companion_getInstance_31().e1g(literal);
  leaf($this, literalUnescaped, textUnescaped, $this.n2d_1, $this.o2d_1);
}
function scanLeafLiteral($this) {
  var literal = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().g2e_1);
  var textWithQuotes = $this.m2d_1.j2e(Tokens_getInstance().e2e_1);
  // Inline function 'kotlin.text.substring' call
  var tmp0_substring = textWithQuotes.length - 1 | 0;
  // Inline function 'kotlin.js.asDynamic' call
  var text = textWithQuotes.substring(1, tmp0_substring);
  var textUnescaped = Companion_getInstance_31().e1g(text);
  $this.n2d_1 = $this.o2d_1;
  $this.o2d_1 = $this.o2d_1 + textUnescaped.length | 0;
  var literalUnescaped = Companion_getInstance_31().e1g(literal);
  leaf($this, literalUnescaped, textUnescaped, $this.n2d_1, $this.o2d_1);
}
function scanPattern($this) {
  var pattern = $this.m2d_1.j2e(Tokens_getInstance().f2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().g2e_1);
  var textWithQuotes = $this.m2d_1.j2e(Tokens_getInstance().e2e_1);
  // Inline function 'kotlin.text.substring' call
  var tmp0_substring = textWithQuotes.length - 1 | 0;
  // Inline function 'kotlin.js.asDynamic' call
  var text = textWithQuotes.substring(1, tmp0_substring);
  var textUnescaped = Companion_getInstance_31().e1g(text);
  $this.n2d_1 = $this.o2d_1;
  $this.o2d_1 = $this.o2d_1 + textUnescaped.length | 0;
  var patternUnescaped = Companion_getInstance_30().e1g(pattern);
  leaf($this, patternUnescaped, textUnescaped, $this.n2d_1, $this.o2d_1);
}
function scanBranchStart($this) {
  var id = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().h2e_1);
  beginBranch($this, id, 0);
}
function scanBranchStartWithOption($this) {
  var id = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  var tmp$ret$1;
  // Inline function 'kotlin.text.substring' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp$ret$1 = $this.m2d_1.j2e(Tokens_getInstance().d2e_1).substring(1);
  var option = toInt(tmp$ret$1);
  $this.m2d_1.j2e(Tokens_getInstance().h2e_1);
  beginBranch($this, id, option);
}
function scanBranchEnd($this) {
  $this.m2d_1.j2e(Tokens_getInstance().i2e_1);
  endBranch($this);
}
function scanEmbedded($this) {
  var leafId = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().g2e_1);
  var embGram = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().c2e_1);
  var embGoal = $this.m2d_1.j2e(Tokens_getInstance().b2e_1);
  $this.m2d_1.j2e(Tokens_getInstance().h2e_1);
  beginEmbedded($this, leafId, embGram, embGoal);
  new RuleReference(new QName(embGram), embGoal);
}
function beginTree($this, rrs, oldTree) {
  var treeData = oldTree == null ? new TreeDataComplete(rrs.yt_1) : oldTree;
  $this.p2d_1.v1a(treeData);
  $this.s2d_1.v1a(rrs);
}
function endTree($this, userGoalNode) {
  var rrs = $this.s2d_1.w1a();
  var treeData = $this.p2d_1.w1a();
  var tmp$ret$0;
  // Inline function 'kotlin.collections.get' call
  var tmp0_get = rrs.fu_1;
  var tmp1_get = userGoalNode.q1s_1;
  tmp$ret$0 = (isInterface(tmp0_get, Map) ? tmp0_get : THROW_CCE()).u3(tmp1_get);
  var gr = ensureNotNull(tmp$ret$0);
  var pseudoRoot = new CompleteTreeDataNode(gr, userGoalNode.r1s_1, userGoalNode.s1s_1, userGoalNode.t1s_1, userGoalNode.u1s_1);
  treeData.setChildren(pseudoRoot, listOf(userGoalNode), false);
  treeData.setRoot(pseudoRoot);
  return treeData;
}
function emptyLeaf($this, startPosition, nextInputPosition) {
  var terminalRule = Companion_getInstance_33().p13_1;
  return new CompleteTreeDataNode(terminalRule, startPosition, nextInputPosition, nextInputPosition, 0);
}
function leaf($this, tag, text, startPosition, nextInputPosition) {
  $this.t2d_1.a8(text);
  var terminalRule = $this.s2d_1.o1a().z2b(tag);
  var leaf = new CompleteTreeDataNode(terminalRule, startPosition, nextInputPosition, nextInputPosition, 0);
  $this.r2d_1.o1a().e1(leaf);
}
function beginBranch($this, ruleName, option) {
  $this.q2d_1.v1a(new NodeStart(new RuleReference(null, ruleName), option, $this.n2d_1, $this.o2d_1));
  var tmp$ret$0;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp$ret$0 = ArrayList.i4();
  $this.r2d_1.v1a(tmp$ret$0);
}
function endBranch($this) {
  var lastNodeStart = $this.q2d_1.w1a();
  var ntRef = lastNodeStart.k2e_1;
  var rr = $this.s2d_1.o1a().pu(ntRef.p2e_1);
  var children = $this.r2d_1.w1a();
  var tmp0_safe_receiver = firstOrNull(children);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1s_1;
  var startPosition = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp2_safe_receiver = lastOrNull(children);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.s1s_1;
  var nextInputPosition = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
  var tmp4_safe_receiver = lastOrNull(children);
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.t1s_1;
  var nextInputNoSkip = tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs;
  var tn = new CompleteTreeDataNode(rr, startPosition, nextInputPosition, nextInputNoSkip, lastNodeStart.l2e_1);
  // Inline function 'kotlin.collections.isNotEmpty' call
  var isAlternative = !$this.p2d_1.o1a().childrenFor(tn).y();
  $this.p2d_1.o1a().setChildren(tn, children, isAlternative);
  if (ntRef.q2e()) {
    endEmbedded($this, tn);
  } else {
    $this.r2d_1.o1a().e1(tn);
  }
}
function beginEmbedded($this, embLeafName, embGramName, embGoalName) {
  $this.q2d_1.v1a(new NodeStart(new RuleReference(null, embLeafName), 0, $this.n2d_1, $this.o2d_1));
  $this.q2d_1.v1a(new NodeStart(new RuleReference(new QName(embGramName), embGoalName), 0, $this.n2d_1, $this.o2d_1));
  var tmp$ret$0;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp$ret$0 = ArrayList.i4();
  $this.r2d_1.v1a(tmp$ret$0);
  var tmp0_elvis_lhs = $this.l2d_1.u3(embGramName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp0_error = "No embedded RuntimeRuleSet with name '" + embGramName + "' passed to SPPTParser";
    throw IllegalStateException.y1(toString(tmp0_error));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var embrrs = tmp;
  $this.s2d_1.v1a(embrrs);
  var embTreeData = new TreeDataComplete(embrrs.yt_1);
  $this.p2d_1.v1a(embTreeData);
}
function endEmbedded($this, embUserRoot) {
  var lastNodeStart = $this.q2d_1.w1a();
  var embLeafName = lastNodeStart.k2e_1.p2e_1;
  var embTreeData = endTree($this, embUserRoot);
  var emRoot = ensureNotNull(embTreeData.root);
  var terminalRule = $this.s2d_1.o1a().z2b(embLeafName);
  var startPosition = emRoot.r1s_1;
  var nextInputPosition = emRoot.s1s_1;
  var nextInputNoSkip = emRoot.t1s_1;
  var leaf = new CompleteTreeDataNode(terminalRule, startPosition, nextInputPosition, nextInputNoSkip, 0);
  $this.r2d_1.o1a().e1(leaf);
  $this.p2d_1.o1a().setEmbeddedTreeFor(leaf, embTreeData);
  return embTreeData;
}
var Tokens_instance;
function Tokens_getInstance() {
  if (Tokens_instance === VOID)
    new Tokens();
  return Tokens_instance;
}
function SpptWalkerToInputSentence$_get_output_$lambda_e38anc(it) {
  return it.si_1;
}
function SpptWalkerToInputSentence$endBranch$lambda(it) {
  return it.si_1;
}
function _get_preferred__p9krn4(_this__u8e3s4, $this) {
  return new PreferredNode(_this__u8e3s4.rule, _this__u8e3s4.startPosition);
}
var Companion_instance_32;
function Companion_getInstance_34() {
  if (Companion_instance_32 === VOID)
    new Companion_32();
  return Companion_instance_32;
}
function setCompletedBy($this, parent, children, isAlternative) {
  var alternatives = $this.x1s_1.u3(parent);
  if (null == alternatives) {
    alternatives = mutableMapOf([to(parent.option, children)]);
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = $this.x1s_1;
    var tmp1_set = alternatives;
    tmp0_set.m3(parent, tmp1_set);
    if (isAlternative) {
      $this.y1s_1.q3(_get_preferred__p9krn4(parent, Companion_getInstance_34()));
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp2_set = $this.y1s_1;
      var tmp3_set = _get_preferred__p9krn4(parent, Companion_getInstance_34());
      tmp2_set.m3(tmp3_set, parent);
    }
  } else {
    if (isAlternative) {
      $this.y1s_1.q3(_get_preferred__p9krn4(parent, Companion_getInstance_34()));
    } else {
      // Inline function 'kotlin.collections.set' call
      var tmp4_set = $this.y1s_1;
      var tmp5_set = _get_preferred__p9krn4(parent, Companion_getInstance_34());
      tmp4_set.m3(tmp5_set, parent);
      alternatives.n1();
    }
    // Inline function 'kotlin.collections.set' call
    var tmp6_set = alternatives;
    var tmp7_set = parent.option;
    tmp6_set.m3(tmp7_set, children);
  }
}
var Companion_instance_33;
function Companion_getInstance_35() {
  if (Companion_instance_33 === VOID)
    new Companion_33();
  return Companion_instance_33;
}
function numSkipChildren($this, skipData) {
  var tmp;
  if (null == skipData) {
    tmp = 0;
  } else {
    var goal = ensureNotNull(skipData.root);
    var skipMulti = skipData.childrenFor(goal).p(0).si_1.p(0);
    var multi = skipData.childrenFor(skipMulti).p(0).si_1;
    tmp = multi.o();
  }
  return tmp;
}
function traverseSkipData($this, callback, skipDataAsTree, skipData) {
  if (!(null == skipData)) {
    if (skipDataAsTree) {
      var walker = new TreeDataWalkerDepthFirst(skipData);
      walker.n2f(callback, skipDataAsTree);
    } else {
      callback.skip(ensureNotNull(skipData.root).startPosition, ensureNotNull(skipData.root).nextInputPosition);
    }
  }
}
function traverseStackData($this, callback, skipDataAsTree, stackData) {
  if (stackData instanceof StackInfo) {
    if (stackData.p2f_1.rule.s10()) {
      traverseLeaf($this, callback, skipDataAsTree, stackData);
    } else {
      traverseBranch($this, callback, skipDataAsTree, stackData);
    }
  } else {
    if (stackData instanceof AlternativesInfo) {
      traverseAlternative($this, callback, skipDataAsTree, stackData);
    } else {
      throw IllegalStateException.y1('Internal Error: Should not happen');
    }
  }
}
function traverseAlternative($this, callback, skipDataAsTree, info) {
  if (0 === info.x2f_1.o()) {
    $this.i2f_1.w1a();
  } else {
    var altChildrenInfo = removeLast(info.x2f_1);
    var nodeInfo = altChildrenInfo.ri_1;
    var children = altChildrenInfo.si_1;
    $this.j2f_1.v1a(info);
    $this.j2f_1.v1a(nodeInfo);
    callback.beginBranch(nodeInfo);
    if (info.w2f_1) {
      traverseSkipData($this, callback, skipDataAsTree, $this.h2f_1.initialSkip);
    }
    var totChildrenIncSkip = children.o() + nodeInfo.u2f_1 | 0;
    var inductionVariable = children.o() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var ch = children.p(i);
        var propertyIndex = nodeInfo.p2f_1.rule.gn() ? 0 : i;
        var childOfTotal = new ChildInfo(propertyIndex, i, totChildrenIncSkip);
        $this.j2f_1.v1a(new StackInfo(false, ch, nodeInfo.q2f_1, nodeInfo.r2f_1, childOfTotal, emptyMap(), -1));
      }
       while (0 <= inductionVariable);
  }
}
function traverseBranch($this, callback, skipDataAsTree, info) {
  if (info.o2f_1) {
    callback.endBranch(info);
  } else {
    var altInfo = new AlternativesInfo(info.p2f_1, false);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp0_any = $this.i2f_1.c29();
      var tmp;
      if (isInterface(tmp0_any, Collection)) {
        tmp = tmp0_any.y();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_any.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
        if (equals(element.v2f_1, altInfo.v2f_1)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      callback.error('Loop in Tree, Grammar has a recursive path that does not consume any input.', TreeDataWalkerDepthFirst$traverseBranch$lambda($this));
    } else {
      // Inline function 'kotlin.collections.sortedBy' call
      var tmp1_sortedBy = $this.h2f_1.childrenFor(info.p2f_1);
      var tmp$ret$2;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = TreeDataWalkerDepthFirst$traverseBranch$lambda_0;
      tmp$ret$2 = new sam$kotlin_Comparator$0_10(tmp_0);
      var alternatives = sortedWith(tmp1_sortedBy, tmp$ret$2);
      $this.i2f_1.v1a(altInfo);
      $this.j2f_1.v1a(altInfo);
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(alternatives, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var tmp0_associateTo = LinkedHashMap.o8(capacity);
      var tmp0_iterator_0 = alternatives.u();
      while (tmp0_iterator_0.h1()) {
        var element_0 = tmp0_iterator_0.j1();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
        var tmp0_plusAssign = new Pair(element_0.ri_1, element_0.si_1.o());
        tmp0_associateTo.m3(tmp0_plusAssign.ri_1, tmp0_plusAssign.si_1);
      }
      var numChildrenAlternatives = tmp0_associateTo;
      var inductionVariable = alternatives.o() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp1_container = alternatives.p(i);
          var alt = tmp1_container.ti();
          var children = tmp1_container.ui();
          var altOfTotal = new AltInfo(alt, i, alternatives.o());
          // Inline function 'kotlin.collections.fold' call
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var tmp0_filterTo = ArrayList.i4();
          var tmp0_iterator_1 = children.u();
          while (tmp0_iterator_1.h1()) {
            var element_1 = tmp0_iterator_1.j1();
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
            if (element_1.rule.s10()) {
              tmp0_filterTo.e1(element_1);
            }
          }
          var accumulator = 0;
          var tmp0_iterator_2 = tmp0_filterTo.u();
          while (tmp0_iterator_2.h1()) {
            var element_2 = tmp0_iterator_2.j1();
            // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
            var tmp3_anonymous = accumulator;
            var tmp0_safe_receiver = $this.h2f_1.skipDataAfter(element_2);
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>.<anonymous>' call
              tmp_1 = tmp3_anonymous + numSkipChildren($this, tmp0_safe_receiver) | 0;
            }
            var tmp1_elvis_lhs = tmp_1;
            accumulator = tmp1_elvis_lhs == null ? tmp3_anonymous : tmp1_elvis_lhs;
          }
          var numSkipChildren_0 = accumulator;
          var stackData = new StackInfo(true, info.p2f_1, info.r2f_1, altOfTotal, info.s2f_1, numChildrenAlternatives, numSkipChildren_0);
          altInfo.x2f_1.e1(new Pair(stackData, children));
        }
         while (0 <= inductionVariable);
    }
  }
}
function traverseLeaf($this, callback, skipDataAsTree, info) {
  if (info.p2f_1.rule.ny()) {
    var tmp0_elvis_lhs = $this.h2f_1.embeddedFor(info.p2f_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = "Cannot find embedded TreeData for '" + info.p2f_1 + "'";
      throw IllegalStateException.y1(toString(tmp0_error));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ed = tmp;
    var numChildrenAlternatives = mapOf(to(0, 1));
    var tmp1_safe_receiver = $this.h2f_1.skipDataAfter(info.p2f_1);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseLeaf.<anonymous>' call
      tmp_0 = numSkipChildren($this, tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp_0;
    var numSkipChildren_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
    var stackData = new StackInfo(true, info.p2f_1, info.q2f_1, info.r2f_1, info.s2f_1, numChildrenAlternatives, numSkipChildren_0);
    callback.beginEmbedded(stackData);
    ed.traverseTreeDepthFirst(callback, skipDataAsTree);
    traverseSkipData($this, callback, skipDataAsTree, $this.h2f_1.skipDataAfter(info.p2f_1));
    callback.endEmbedded(stackData);
  } else {
    callback.leaf(info);
    traverseSkipData($this, callback, skipDataAsTree, $this.h2f_1.skipDataAfter(info.p2f_1));
  }
}
function TreeDataWalkerDepthFirst$traverse$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>' call
  var tmp = a.ri_1;
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverse.<anonymous>' call
  tmp$ret$1 = b.ri_1;
  return compareValues(tmp, tmp$ret$1);
}
function TreeDataWalkerDepthFirst$traverseBranch$lambda(this$0) {
  return function () {
    var tmp$ret$2;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this$0.i2f_1.c29();
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>.<anonymous>' call
      tmp$ret$0 = item.v2f_1;
      tmp0_mapTo.e1(tmp$ret$0);
    }
    tmp$ret$1 = tmp0_mapTo;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  };
}
function TreeDataWalkerDepthFirst$traverseBranch$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
  var tmp = a.ri_1;
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.agl.sppt.TreeDataWalkerDepthFirst.traverseBranch.<anonymous>' call
  tmp$ret$1 = b.ri_1;
  return compareValues(tmp, tmp$ret$1);
}
var Companion_instance_34;
function Companion_getInstance_36() {
  if (Companion_instance_34 === VOID)
    new Companion_34();
  return Companion_instance_34;
}
function createReferenceLocalToScope(_this__u8e3s4, scope, element) {
  var prop = _this__u8e3s4.getReferablePropertyNameFor(scope.forTypeName, element.typeName);
  return prop == null ? null : prop === Companion_getInstance_17().IDENTIFY_BY_NOTHING ? '' : element.getPropertyAsStringOrNull(prop);
}
function ScopeSimple$rootScope$delegate$lambda(this$0) {
  return function () {
    var s = this$0;
    while (!(null == s.parent))
      s = ensureNotNull(s.parent);
    return s;
  };
}
function ScopeSimple$path$delegate$lambda(this$0) {
  return function () {
    return null == this$0.parent ? emptyList() : plus_2(this$0.parent.path, this$0.forReferenceInParent);
  };
}
function rootScope$factory() {
  return getPropertyCallableRef('rootScope', 1, KProperty1, function (receiver) {
    return receiver.rootScope;
  }, null);
}
function path$factory() {
  return getPropertyCallableRef('path', 1, KProperty1, function (receiver) {
    return receiver.path;
  }, null);
}
function findBranchHandler($this, branchName, begin) {
  var tmp;
  if (begin) {
    var tmp_0 = $this.y1f_1.u3(branchName);
    tmp = (tmp_0 == null ? true : typeof tmp_0 === 'function') ? tmp_0 : THROW_CCE();
  } else {
    var tmp_1 = $this.x1f_1.u3(branchName);
    tmp = (tmp_1 == null ? true : typeof tmp_1 === 'function') ? tmp_1 : THROW_CCE();
  }
  return tmp;
}
function get_isEmptyMatch(_this__u8e3s4) {
  return _this__u8e3s4.startPosition === _this__u8e3s4.nextInputPosition;
}
var Companion_instance_35;
function Companion_getInstance_37() {
  if (Companion_instance_35 === VOID)
    new Companion_35();
  return Companion_instance_35;
}
function findTypeUsageForRule($this, ruleName) {
  var tmp = $this.typeModel.namespace.u3($this.grammarNamespaceQualifiedName);
  var ns = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  return ns == null ? null : ns.findTypeUsageForRule(ruleName);
}
function setAsm($this, value) {
  $this.k1b_1 = value;
}
function addAsmRoot($this, value) {
  ensureNotNull($this.k1b_1).addRoot(value);
}
function removeAsmRoot($this, value) {
  ensureNotNull($this.k1b_1).removeRoot(value);
}
function createAsmElement($this, path, name) {
  return ensureNotNull($this.k1b_1).createElement(path, name);
}
function pathFor($this, parentPath, parentType, nodeInfo) {
  var tmp;
  if (isInterface(parentType, PrimitiveType)) {
    tmp = parentPath;
  } else {
    if (isInterface(parentType, UnnamedSuperTypeType)) {
      tmp = parentPath;
    } else {
      if (isInterface(parentType, CollectionType)) {
        tmp = parentPath.plus(nodeInfo.child.index.toString());
      } else {
        if (isInterface(parentType, TupleType)) {
          var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
          var tmp_0;
          if (prop == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.pathFor.<anonymous>' call
            tmp_0 = parentPath.plus(prop.name);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? parentPath.plus('<error>') : tmp2_elvis_lhs;
        } else {
          if (isInterface(parentType, DataType)) {
            var tmp_1;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!parentType.subtypes.y()) {
              tmp_1 = parentPath;
            } else {
              var prop_0 = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
              var tmp_2;
              if (prop_0 == null) {
                tmp_2 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.pathFor.<anonymous>' call
                tmp_2 = parentPath.plus(prop_0.name);
              }
              var tmp4_elvis_lhs = tmp_2;
              tmp_1 = tmp4_elvis_lhs == null ? parentPath.plus('<error>') : tmp4_elvis_lhs;
            }
            tmp = tmp_1;
          } else {
            var tmp_3;
            if (equals(parentType, $this.typeModel.NothingType)) {
              tmp_3 = parentPath.plus('<error>');
            } else if (equals(parentType, $this.typeModel.AnyType)) {
              throw NotImplementedError.eg();
            } else {
              throw IllegalStateException.y1('Should not happen');
            }
            tmp = tmp_3;
          }
        }
      }
    }
  }
  return tmp;
}
function typeForNode($this, parentTypeUsage, nodeInfo) {
  var tmp;
  if (null == parentTypeUsage) {
    tmp = $this.typeModel.NothingType.instance();
  } else if (parentTypeUsage.isNullable) {
    tmp = typeForParentOptional($this, parentTypeUsage, nodeInfo);
  } else if (nodeInfo.node.rule.ny()) {
    tmp = typeForEmbedded($this, parentTypeUsage, nodeInfo);
  } else {
    var parentType = parentTypeUsage.type;
    var tmp_0;
    if (isInterface(parentType, PrimitiveType)) {
      tmp_0 = parentTypeUsage;
    } else {
      if (isInterface(parentType, UnnamedSuperTypeType)) {
        tmp_0 = typeForParentUnnamedSuperType($this, parentTypeUsage, nodeInfo);
      } else {
        if (isInterface(parentType, CollectionType)) {
          var tmp_1;
          if (equals(parentType, SimpleTypeModelStdLib_getInstance().List)) {
            tmp_1 = typeForParentListSimple($this, parentTypeUsage, nodeInfo);
          } else if (equals(parentType, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            tmp_1 = typeForParentListSeparated($this, parentTypeUsage, nodeInfo);
          } else {
            throw IllegalStateException.y1('Should not happen');
          }
          tmp_0 = tmp_1;
        } else {
          if (isInterface(parentType, TupleType)) {
            tmp_0 = typeForParentTuple($this, parentType, nodeInfo);
          } else {
            if (isInterface(parentType, DataType)) {
              tmp_0 = typeForParentElement($this, parentType, nodeInfo);
            } else {
              var tmp_2;
              if (equals(parentType, $this.typeModel.NothingType)) {
                tmp_2 = $this.typeModel.NothingType.instance();
              } else if (equals(parentType, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Shold not happen');
              }
              tmp_0 = tmp_2;
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeForParentOptional($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!parentTypeUsage.isNullable) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  return parentTypeUsage.notNullable();
}
function typeForEmbedded($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!nodeInfo.node.rule.ny()) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var type = parentTypeUsage.type;
  var tmp;
  if (isInterface(type, DataType)) {
    var prop = type.getPropertyByIndex(nodeInfo.child.propertyIndex);
    var tmp2_elvis_lhs = prop == null ? null : prop.typeInstance;
    tmp = tmp2_elvis_lhs == null ? $this.typeModel.NothingType.instance() : tmp2_elvis_lhs;
  } else {
    tmp = parentTypeUsage;
  }
  return tmp;
}
function typeForParentListSimple($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(parentTypeUsage.type, SimpleTypeModelStdLib_getInstance().List)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var itemTypeUse = parentTypeUsage.typeArguments.p(0);
  return itemTypeUse;
}
function typeForParentListSeparated($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(parentTypeUsage.type, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var index = nodeInfo.child.index % 2 | 0;
  var childTypeUse = parentTypeUsage.typeArguments.p(index);
  return childTypeUse;
}
function typeForParentUnnamedSuperType($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!parentTypeUsage.isNullable) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var tmp = parentTypeUsage.type;
  var tu = (isInterface(tmp, UnnamedSuperTypeType) ? tmp : THROW_CCE()).subtypes.p(nodeInfo.parentAlt.option);
  return tu;
}
function typeForParentTuple($this, parentType, nodeInfo) {
  var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
  return typeForProperty($this, prop, nodeInfo);
}
function typeForParentElement($this, parentType, nodeInfo) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!parentType.subtypes.y()) {
    var t = parentType.subtypes.p(nodeInfo.parentAlt.option);
    return t;
  } else {
    var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
    tmp = typeForProperty($this, prop, nodeInfo);
  }
  return tmp;
}
function typeForProperty($this, prop, nodeInfo) {
  var tmp;
  if (null == prop) {
    tmp = $this.typeModel.NothingType.instance();
  } else if (prop.typeInstance.isNullable) {
    tmp = prop.typeInstance;
  } else {
    var propType = prop.typeInstance.type;
    var tmp_0;
    if (isInterface(propType, PrimitiveType)) {
      tmp_0 = prop.typeInstance;
    } else {
      if (isInterface(propType, UnnamedSuperTypeType)) {
        var tu = resolveUnnamedSuperTypeSubtype($this, prop.typeInstance, nodeInfo);
        var tmp1_subject = tu.type;
        var tmp_1;
        if (isInterface(tmp1_subject, TupleType)) {
          tmp_1 = tu;
        } else {
          tmp_1 = prop.typeInstance;
        }
        tmp_0 = tmp_1;
      } else {
        if (isInterface(propType, CollectionType)) {
          tmp_0 = prop.typeInstance;
        } else {
          if (isInterface(propType, TupleType)) {
            tmp_0 = prop.typeInstance;
          } else {
            if (isInterface(propType, DataType)) {
              tmp_0 = prop.typeInstance;
            } else {
              var tmp_2;
              if (equals(propType, $this.typeModel.NothingType)) {
                tmp_2 = $this.typeModel.NothingType.instance();
              } else if (equals(propType, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Should not happen');
              }
              tmp_0 = tmp_2;
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  return tmp;
}
function resolveCompressed($this, p, typeUsage, nodeInfo) {
  var type = typeUsage.type;
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  if (isInterface(type, StructuredType)) {
    tmp_2 = nodeInfo.node.rule.e2b();
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = Companion_getInstance_37().hasOnyOneRhsItem;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = nodeInfo.node.rule.b15().p(0).p(0).s10();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = new DownData(p, new NodeTypes(typeUsage, SimpleTypeModelStdLib_getInstance().String));
  } else {
    var tmp_3;
    if (isInterface(type, DataType)) {
      tmp_3 = type.property.o() === 1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      var tmp_4;
      if (first(type.property.k3()).typeInstance.isNullable) {
        var fProp = first(type.property.k3());
        var pp = p.plus(fProp.name);
        tmp_4 = new DownData(pp, new NodeTypes(typeUsage, fProp.typeInstance));
      } else if (nodeInfo.node.rule.e2b()) {
        tmp_4 = new DownData(p, NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage));
      } else if (nodeInfo.node.rule.gn()) {
        var fProp_0 = first(type.property.k3());
        var pp_0 = p.plus(fProp_0.name);
        tmp_4 = new DownData(pp_0, new NodeTypes(typeUsage, fProp_0.typeInstance));
      } else {
        tmp_4 = new DownData(p, NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage));
      }
      tmp = tmp_4;
    } else {
      if (isInterface(type, UnnamedSuperTypeType)) {
        var tmp_5;
        if (nodeInfo.node.rule.a14()) {
          var tmp_6;
          var tmp_7 = type.subtypes.p(nodeInfo.alt.option).type;
          if (isInterface(tmp_7, TupleType)) {
            tmp_6 = new DownData(p, new NodeTypes(typeUsage, type.subtypes.p(nodeInfo.alt.option)));
          } else {
            tmp_6 = new DownData(p, NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage));
          }
          tmp_5 = tmp_6;
        } else {
          tmp_5 = new DownData(p, NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage));
        }
        tmp = tmp_5;
      } else {
        tmp = new DownData(p, NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage));
      }
    }
  }
  return tmp;
}
function resolveUnnamedSuperTypeSubtype($this, typeUse, nodeInfo) {
  var type = typeUse.type;
  var tmp;
  if (isInterface(type, UnnamedSuperTypeType)) {
    var tmp_0;
    var tmp_1;
    if (nodeInfo.node.rule.a14()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_1 = !type.subtypes.y();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var t = type.subtypes.p(nodeInfo.alt.option);
      tmp_0 = t;
    } else {
      tmp_0 = typeUse;
    }
    tmp = tmp_0;
  } else {
    tmp = typeUse;
  }
  return tmp;
}
function createValueFromLeaf($this, sentence, target) {
  return target.node.rule.q11() ? null : sentence.k1v(target.node);
}
function createValueFromBranch($this, sentence, downData, target, children) {
  var targetType = findTypeUsageForRule($this, target.node.rule.mz());
  var tmp;
  if (downData.typeUse.forNode.isNullable ? target.node.rule.e2b() : false) {
    var child = children.p(0);
    var tmp_0;
    if (null == child.value) {
      tmp_0 = null;
    } else {
      var nonOptChildren = listOf(new ChildData(child.nodeInfo, child.value));
      tmp_0 = child.value;
    }
    tmp = tmp_0;
  } else if (target.node.rule.ny()) {
    tmp = children.p(0).value;
  } else {
    var type = downData.typeUse.forNode.type;
    var tmp_1;
    if (isInterface(type, PrimitiveType)) {
      tmp_1 = createStringValueFromBranch($this, sentence, target);
    } else {
      if (isInterface(type, UnnamedSuperTypeType)) {
        var actualType = type.subtypes.p(target.alt.option).type;
        var tmp_2;
        if (isInterface(actualType, TupleType)) {
          tmp_2 = createValueFor($this, sentence, actualType, downData.path, new ChildData(target, children));
        } else {
          tmp_2 = children.p(0).value;
        }
        tmp_1 = tmp_2;
      } else {
        if (isInterface(type, CollectionType)) {
          var tmp_3;
          if (equals(type, SimpleTypeModelStdLib_getInstance().List)) {
            var tmp_4;
            var tmp_5;
            if (!(null == targetType) ? !equals(targetType.type, SimpleTypeModelStdLib_getInstance().List) : false) {
              var tmp_6 = targetType.type;
              tmp_5 = isInterface(tmp_6, DataType);
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              var tmp_7;
              if (target.node.rule.h2b()) {
                // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(children, 10));
                var tmp0_iterator = children.u();
                while (tmp0_iterator.h1()) {
                  var item = tmp0_iterator.j1();
                  var tmp$ret$0;
                  // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                  tmp$ret$0 = item.value;
                  tmp0_mapTo.e1(tmp$ret$0);
                }
                var tmp0_toSeparatedList = createListSimpleValueFromBranch($this, target, downData.path, tmp0_mapTo, type);
                tmp_7 = ListSeparatedArrayList.u1f(tmp0_toSeparatedList).a11();
              } else {
                // Inline function 'kotlin.collections.map' call
                // Inline function 'kotlin.collections.mapTo' call
                var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(children, 10));
                var tmp0_iterator_0 = children.u();
                while (tmp0_iterator_0.h1()) {
                  var item_0 = tmp0_iterator_0.j1();
                  var tmp$ret$4;
                  // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                  tmp$ret$4 = item_0.value;
                  tmp0_mapTo_0.e1(tmp$ret$4);
                }
                tmp_7 = createListSimpleValueFromBranch($this, target, downData.path, tmp0_mapTo_0, type);
              }
              var propValue = tmp_7;
              var tmp_8 = targetType.type;
              var propDecl = first((isInterface(tmp_8, DataType) ? tmp_8 : THROW_CCE()).property.k3());
              var el = createAsmElement($this, downData.path, targetType.type.name);
              setPropertyOrReferenceFromDeclaration($this, el, propDecl, propValue);
              tmp_4 = el;
            } else {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_1 = ArrayList.f4(collectionSizeOrDefault(children, 10));
              var tmp0_iterator_1 = children.u();
              while (tmp0_iterator_1.h1()) {
                var item_1 = tmp0_iterator_1.j1();
                var tmp$ret$7;
                // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                tmp$ret$7 = item_1.value;
                tmp0_mapTo_1.e1(tmp$ret$7);
              }
              tmp_4 = createListSimpleValueFromBranch($this, target, downData.path, tmp0_mapTo_1, type);
            }
            tmp_3 = tmp_4;
          } else if (equals(type, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            var tmp_9;
            var tmp_10;
            if (!(null == targetType) ? !equals(targetType.type, SimpleTypeModelStdLib_getInstance().ListSeparated) : false) {
              var tmp_11 = targetType.type;
              tmp_10 = isInterface(tmp_11, DataType);
            } else {
              tmp_10 = false;
            }
            if (tmp_10) {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_2 = ArrayList.f4(collectionSizeOrDefault(children, 10));
              var tmp0_iterator_2 = children.u();
              while (tmp0_iterator_2.h1()) {
                var item_2 = tmp0_iterator_2.j1();
                var tmp$ret$10;
                // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                tmp$ret$10 = item_2.value;
                tmp0_mapTo_2.e1(tmp$ret$10);
              }
              var propValue_0 = createListSeparatedValueFromBranch($this, target, downData.path, tmp0_mapTo_2, type);
              var tmp_12 = targetType.type;
              var propDecl_0 = first((isInterface(tmp_12, DataType) ? tmp_12 : THROW_CCE()).property.k3());
              var el_0 = createAsmElement($this, downData.path, targetType.type.name);
              setPropertyOrReferenceFromDeclaration($this, el_0, propDecl_0, propValue_0);
              tmp_9 = el_0;
            } else {
              // Inline function 'kotlin.collections.map' call
              // Inline function 'kotlin.collections.mapTo' call
              var tmp0_mapTo_3 = ArrayList.f4(collectionSizeOrDefault(children, 10));
              var tmp0_iterator_3 = children.u();
              while (tmp0_iterator_3.h1()) {
                var item_3 = tmp0_iterator_3.j1();
                var tmp$ret$13;
                // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                tmp$ret$13 = item_3.value;
                tmp0_mapTo_3.e1(tmp$ret$13);
              }
              tmp_9 = createListSeparatedValueFromBranch($this, target, downData.path, tmp0_mapTo_3, type);
            }
            tmp_3 = tmp_9;
          } else {
            throw IllegalStateException.y1('Should not happen');
          }
          tmp_1 = tmp_3;
        } else {
          if (isInterface(type, TupleType)) {
            tmp_1 = createTupleFrom($this, sentence, type, downData.path, new ChildData(target, children));
          } else {
            if (isInterface(type, DataType)) {
              var tmp_13;
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!type.subtypes.y()) {
                Debug_getInstance();
                if (false) {
                  // Inline function 'kotlin.check' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'kotlin.check' call
                  // Inline function 'kotlin.contracts.contract' call
                  if (!(1 === children.o())) {
                    // Inline function 'kotlin.check.<anonymous>' call
                    var message = 'Check failed.';
                    throw IllegalStateException.y1(toString(message));
                  }
                }
                tmp_13 = children.p(0).value;
              } else {
                var el_1 = createAsmElement($this, downData.path, type.name);
                var tmp3_iterator = type.property.k3().u();
                while (tmp3_iterator.h1()) {
                  var propDecl_1 = tmp3_iterator.j1();
                  var propType = propDecl_1.typeInstance.type;
                  var tmp_14;
                  if (isInterface(propType, PrimitiveType)) {
                    var childData = children.p(propDecl_1.index);
                    tmp_14 = createStringValueFromBranch($this, sentence, childData.nodeInfo);
                  } else {
                    if (isInterface(propType, CollectionType)) {
                      var tmp_15;
                      if (equals(propType, SimpleTypeModelStdLib_getInstance().List)) {
                        var tmp_16;
                        var tmp_17;
                        if (target.node.rule.g2b()) {
                          var tmp_18 = target.node.option;
                          Companion_getInstance_29();
                          tmp_17 = tmp_18 === 1;
                        } else {
                          tmp_17 = false;
                        }
                        if (tmp_17) {
                          tmp_16 = emptyList();
                        } else {
                          if (target.node.rule.gn()) {
                            // Inline function 'kotlin.collections.map' call
                            // Inline function 'kotlin.collections.mapTo' call
                            var tmp0_mapTo_4 = ArrayList.f4(collectionSizeOrDefault(children, 10));
                            var tmp0_iterator_4 = children.u();
                            while (tmp0_iterator_4.h1()) {
                              var item_4 = tmp0_iterator_4.j1();
                              var tmp$ret$18;
                              // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                              tmp$ret$18 = item_4.value;
                              tmp0_mapTo_4.e1(tmp$ret$18);
                            }
                            tmp_16 = createList($this, target, tmp0_mapTo_4);
                          } else {
                            var childData_0 = children.p(propDecl_1.index);
                            var tmp_19;
                            if (childData_0.nodeInfo.node.rule.gn()) {
                              var tmp_20;
                              if (null == childData_0.value) {
                                tmp_20 = emptyList();
                              } else {
                                var tmp_21 = childData_0.value;
                                if (!(tmp_21 == null) ? isInterface(tmp_21, List) : false) {
                                  var tmp_22 = childData_0.value;
                                  tmp_20 = createList($this, childData_0.nodeInfo, (!(tmp_22 == null) ? isInterface(tmp_22, List) : false) ? tmp_22 : THROW_CCE());
                                } else {
                                  var tmp_23 = childData_0.value;
                                  if (tmp_23 instanceof AsmElementSimple) {
                                    var tmp_24 = first(childData_0.value.properties.k3()).value;
                                    tmp_20 = (!(tmp_24 == null) ? isInterface(tmp_24, List) : false) ? tmp_24 : THROW_CCE();
                                  } else {
                                    tmp_20 = listOf(childData_0.value);
                                  }
                                }
                              }
                              tmp_19 = tmp_20;
                            } else {
                              var tmp3_error = "Internal Error: cannot create a ListSimple from '" + childData_0 + "'";
                              throw IllegalStateException.y1(toString(tmp3_error));
                            }
                            tmp_16 = tmp_19;
                          }
                        }
                        tmp_15 = tmp_16;
                      } else if (equals(propType, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
                        var childData_1 = children.p(propDecl_1.index);
                        var tmp_25;
                        if (childData_1.nodeInfo.node.rule.q11()) {
                          tmp_25 = emptyList();
                        } else if (target.node.rule.gn()) {
                          // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
                          // Inline function 'kotlin.collections.map' call
                          // Inline function 'kotlin.collections.mapTo' call
                          var tmp0_mapTo_5 = ArrayList.f4(collectionSizeOrDefault(children, 10));
                          var tmp0_iterator_5 = children.u();
                          while (tmp0_iterator_5.h1()) {
                            var item_5 = tmp0_iterator_5.j1();
                            var tmp$ret$21;
                            // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleAbstract.createValueFromBranch.<anonymous>' call
                            tmp$ret$21 = item_5.value;
                            tmp0_mapTo_5.e1(tmp$ret$21);
                          }
                          tmp_25 = ListSeparatedArrayList.u1f(tmp0_mapTo_5);
                        } else if (childData_1.nodeInfo.node.rule.gn()) {
                          var tmp_26;
                          var tmp_27 = childData_1.value;
                          if (!(tmp_27 == null) ? isInterface(tmp_27, List) : false) {
                            tmp_26 = childData_1.value;
                          } else {
                            var tmp_28 = childData_1.value;
                            if (tmp_28 instanceof AsmElementSimple) {
                              var tmp_29 = first(childData_1.value.properties.k3()).value;
                              tmp_26 = (!(tmp_29 == null) ? isInterface(tmp_29, List) : false) ? tmp_29 : THROW_CCE();
                            } else {
                              throw NotImplementedError.eg();
                            }
                          }
                          tmp_25 = tmp_26;
                        } else {
                          var tmp5_error = "Internal Error: cannot create a ListSeparated from '" + childData_1 + "'";
                          throw IllegalStateException.y1(toString(tmp5_error));
                        }
                        tmp_15 = tmp_25;
                      } else {
                        throw IllegalStateException.y1('Should not happen');
                      }
                      tmp_14 = tmp_15;
                    } else {
                      var childData_2 = children.p(propDecl_1.index);
                      tmp_14 = childData_2.value;
                    }
                  }
                  var propValue_1 = tmp_14;
                  setPropertyOrReferenceFromDeclaration($this, el_1, propDecl_1, propValue_1);
                }
                tmp_13 = el_1;
              }
              tmp_1 = tmp_13;
            } else {
              var tmp_30;
              if (equals(type, $this.typeModel.NothingType)) {
                throw IllegalStateException.y1("Internal Error: items should not have type 'NothingType'");
              } else if (equals(type, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Shold not happen');
              }
            }
          }
        }
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function createValueFor($this, sentence, type, path, childData) {
  var tmp;
  if (isInterface(type, PrimitiveType)) {
    tmp = createStringValueFromBranch($this, sentence, childData.nodeInfo);
  } else {
    if (isInterface(type, UnnamedSuperTypeType)) {
      throw NotImplementedError.eg();
    } else {
      if (isInterface(type, CollectionType)) {
        throw NotImplementedError.eg();
      } else {
        if (isInterface(type, TupleType)) {
          tmp = createTupleFrom($this, sentence, type, path, childData);
        } else {
          if (isInterface(type, DataType)) {
            var tmp_0 = childData.value;
            createElementFrom($this, sentence, type, path, (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE());
            tmp = Unit_getInstance();
          } else {
            var tmp_1;
            if (equals(type, $this.typeModel.NothingType)) {
              throw NotImplementedError.eg();
            } else if (equals(type, $this.typeModel.AnyType)) {
              throw NotImplementedError.eg();
            } else {
              throw IllegalStateException.y1('Shold not happen');
            }
          }
        }
      }
    }
  }
  return tmp;
}
function createStringValueFromBranch($this, sentence, target) {
  return target.node.startPosition === target.node.nextInputNoSkip ? null : sentence.k1v(target.node);
}
function createList($this, nodeData, list) {
  var tmp;
  if (nodeData.node.rule.g2b()) {
    tmp = list;
  } else if (nodeData.node.rule.h2b()) {
    var tmp_0 = nodeData.node.rule;
    var tmp_1 = (tmp_0 instanceof RuntimeRule ? tmp_0 : THROW_CCE()).i11();
    var rhs = tmp_1 instanceof RuntimeRuleRhsListSeparated ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (rhs.s2b_1.s10()) {
      // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
      tmp_2 = ListSeparatedArrayList.u1f(list).a11();
    } else {
      // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
      tmp_2 = ListSeparatedArrayList.u1f(list).i2h();
    }
    tmp = tmp_2;
  } else {
    throw IllegalStateException.y1('Internal error: List kind not handled');
  }
  return tmp;
}
function createListSimpleValueFromBranch($this, target, path, children, type) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(type, SimpleTypeModelStdLib_getInstance().List)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var tmp;
  if (target.node.rule.q11()) {
    tmp = emptyList();
  } else if (target.node.rule.gn()) {
    tmp = filterNotNull(children);
  } else {
    var tmp1_error = "Internal Error: cannot create a List from '" + target + "'";
    throw IllegalStateException.y1(toString(tmp1_error));
  }
  return tmp;
}
function createListSeparatedValueFromBranch($this, target, path, children, type) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(type, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var tmp;
  if (target.node.rule.q11()) {
    tmp = emptyList();
  } else if (target.node.rule.gn()) {
    // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
    var sList = ListSeparatedArrayList.u1f(children);
    tmp = sList;
  } else {
    var tmp1_error = "Internal Error: cannot create a List from '" + target + "'";
    throw IllegalStateException.y1(toString(tmp1_error));
  }
  return tmp;
}
function createTupleFrom($this, sentence, type, path, childData) {
  var el = createAsmElement($this, path, type.name);
  var v = childData.value;
  var tmp0_iterator = type.property.k3().u();
  while (tmp0_iterator.h1()) {
    var propDecl = tmp0_iterator.j1();
    var propType = propDecl.typeInstance;
    if (!(v == null) ? isInterface(v, List) : false) {
      var tmp = childData.value;
      var propChildData = ((!(tmp == null) ? isInterface(tmp, List) : false) ? tmp : THROW_CCE()).p(propDecl.index);
      var propValue = propChildData.value;
      setPropertyOrReferenceFromDeclaration($this, el, propDecl, propValue);
    } else {
      throw NotImplementedError.eg();
    }
  }
  return el;
}
function createElementFrom($this, sentence, type, path, children) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!type.subtypes.y()) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(1 === children.o())) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.y1(toString(message));
      }
    }
    children.p(0).value;
  } else {
    var el = createAsmElement($this, path, type.name);
    var tmp0_iterator = type.property.k3().u();
    while (tmp0_iterator.h1()) {
      var propDecl = tmp0_iterator.j1();
      var propPath = path.plus(propDecl.name);
      var propType = propDecl.typeInstance.type;
      var childData = children.p(propDecl.index);
      var tmp;
      if (isInterface(propType, PrimitiveType)) {
        tmp = createStringValueFromBranch($this, sentence, childData.nodeInfo);
      } else {
        if (isInterface(propType, CollectionType)) {
          var tmp_0;
          if (equals(propType, SimpleTypeModelStdLib_getInstance().List)) {
            var tmp_1;
            if (childData.nodeInfo.node.rule.q11()) {
              tmp_1 = emptyList();
            } else if (childData.nodeInfo.node.rule.gn()) {
              var tmp_2;
              var tmp_3 = childData.value;
              if (!(tmp_3 == null) ? isInterface(tmp_3, List) : false) {
                tmp_2 = childData.value;
              } else {
                var tmp_4 = childData.value;
                if (tmp_4 instanceof AsmElementSimple) {
                  var tmp_5 = first(childData.value.properties.k3()).value;
                  tmp_2 = (!(tmp_5 == null) ? isInterface(tmp_5, List) : false) ? tmp_5 : THROW_CCE();
                } else {
                  throw NotImplementedError.eg();
                }
              }
              tmp_1 = tmp_2;
            } else {
              var tmp2_error = "Internal Error: cannot create a List from '" + childData + "'";
              throw IllegalStateException.y1(toString(tmp2_error));
            }
            tmp_0 = tmp_1;
          } else if (equals(propType, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            throw NotImplementedError.eg();
          } else {
            throw IllegalStateException.y1('Should not happen');
          }
          tmp = tmp_0;
        } else {
          if (isInterface(propType, TupleType)) {
            tmp = createTupleFrom($this, sentence, propType, path, childData);
          } else {
            if (isInterface(propType, UnnamedSuperTypeType)) {
              var actualType = propType.subtypes.p(childData.nodeInfo.parentAlt.option).type;
              var tmp_6;
              if (isInterface(actualType, TupleType)) {
                tmp_6 = createTupleFrom($this, sentence, isInterface(actualType, TupleType) ? actualType : THROW_CCE(), path, childData);
              } else {
                throw NotImplementedError.eg();
              }
              tmp = tmp_6;
            } else {
              tmp = children.p(propDecl.index);
            }
          }
        }
      }
      var propValue = tmp;
      setPropertyOrReferenceFromDeclaration($this, el, propDecl, propValue);
    }
  }
}
function isReference($this, el, name) {
  var tmp0_safe_receiver = $this.scopeModel;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isReference(el.typeName, name);
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function setPropertyOrReferenceFromDeclaration($this, el, declaration, value) {
  var isRef = isReference($this, el, declaration.name);
  if (isRef) {
    el.setPropertyFromDeclaration(declaration, value, true);
  } else {
    el.setPropertyFromDeclaration(declaration, value, false);
  }
}
var Companion_instance_36;
function Companion_getInstance_38() {
  if (Companion_instance_36 === VOID)
    new Companion_36();
  return Companion_instance_36;
}
function findTypeUsageForRule_0($this, ruleName) {
  var tmp = $this.typeModel.namespace.u3($this.grammarNamespaceQualifiedName);
  var ns = (tmp == null ? true : isInterface(tmp, GrammarTypeNamespace)) ? tmp : THROW_CCE();
  return ns == null ? null : ns.findTypeUsageForRule(ruleName);
}
function pathFor_0($this, parentPath, parentType, nodeInfo) {
  var tmp;
  if (isInterface(parentType, PrimitiveType)) {
    tmp = parentPath;
  } else {
    if (isInterface(parentType, UnnamedSuperTypeType)) {
      tmp = parentPath;
    } else {
      if (isInterface(parentType, CollectionType)) {
        tmp = parentPath.plus(nodeInfo.child.index.toString());
      } else {
        if (isInterface(parentType, TupleType)) {
          var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
          var tmp_0;
          if (prop == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleStreamPushAbstract.pathFor.<anonymous>' call
            tmp_0 = parentPath.plus(prop.name);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? parentPath.plus('<error>') : tmp2_elvis_lhs;
        } else {
          if (isInterface(parentType, DataType)) {
            var tmp_1;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!parentType.subtypes.y()) {
              tmp_1 = parentPath;
            } else {
              var prop_0 = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
              var tmp_2;
              if (prop_0 == null) {
                tmp_2 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleStreamPushAbstract.pathFor.<anonymous>' call
                tmp_2 = parentPath.plus(prop_0.name);
              }
              var tmp4_elvis_lhs = tmp_2;
              tmp_1 = tmp4_elvis_lhs == null ? parentPath.plus('<error>') : tmp4_elvis_lhs;
            }
            tmp = tmp_1;
          } else {
            var tmp_3;
            if (equals(parentType, $this.typeModel.NothingType)) {
              tmp_3 = parentPath.plus('<error>');
            } else if (equals(parentType, $this.typeModel.AnyType)) {
              throw NotImplementedError.eg();
            } else {
              throw IllegalStateException.y1('Shold not happen');
            }
            tmp = tmp_3;
          }
        }
      }
    }
  }
  return tmp;
}
function typeForNode_0($this, parentTypeUsage, nodeInfo) {
  var tmp;
  if (null == parentTypeUsage) {
    tmp = $this.typeModel.NothingType.instance();
  } else if (parentTypeUsage.isNullable) {
    tmp = typeForParentOptional_0($this, parentTypeUsage, nodeInfo);
  } else if (nodeInfo.node.rule.ny()) {
    tmp = typeForEmbedded_0($this, parentTypeUsage, nodeInfo);
  } else {
    var parentType = parentTypeUsage.type;
    var tmp_0;
    if (isInterface(parentType, PrimitiveType)) {
      tmp_0 = parentTypeUsage;
    } else {
      if (isInterface(parentType, UnnamedSuperTypeType)) {
        tmp_0 = typeForParentUnnamedSuperType_0($this, parentTypeUsage, nodeInfo);
      } else {
        if (isInterface(parentType, CollectionType)) {
          var tmp_1;
          if (equals(parentType, SimpleTypeModelStdLib_getInstance().List)) {
            tmp_1 = typeForParentListSimple_0($this, parentTypeUsage, nodeInfo);
          } else if (equals(parentType, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            tmp_1 = typeForParentListSeparated_0($this, parentTypeUsage, nodeInfo);
          } else {
            throw IllegalStateException.y1('Should not happen');
          }
          tmp_0 = tmp_1;
        } else {
          if (isInterface(parentType, TupleType)) {
            tmp_0 = typeForParentTuple_0($this, parentType, nodeInfo);
          } else {
            if (isInterface(parentType, DataType)) {
              tmp_0 = typeForParentElement_0($this, parentType, nodeInfo);
            } else {
              var tmp_2;
              if (equals(parentType, $this.typeModel.NothingType)) {
                tmp_2 = $this.typeModel.NothingType.instance();
              } else if (equals(parentType, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Shold not happen');
              }
              tmp_0 = tmp_2;
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeForParentOptional_0($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!parentTypeUsage.isNullable) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  return parentTypeUsage.notNullable();
}
function typeForEmbedded_0($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!nodeInfo.node.rule.ny()) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var type = parentTypeUsage.type;
  var tmp;
  if (isInterface(type, DataType)) {
    var prop = type.getPropertyByIndex(nodeInfo.child.propertyIndex);
    var tmp2_elvis_lhs = prop == null ? null : prop.typeInstance;
    tmp = tmp2_elvis_lhs == null ? $this.typeModel.NothingType.instance() : tmp2_elvis_lhs;
  } else {
    tmp = parentTypeUsage;
  }
  return tmp;
}
function typeForParentListSimple_0($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(parentTypeUsage.type, SimpleTypeModelStdLib_getInstance().List)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var itemTypeUse = parentTypeUsage.typeArguments.p(0);
  return itemTypeUse;
}
function typeForParentListSeparated_0($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!equals(parentTypeUsage.type, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var index = nodeInfo.child.index % 2 | 0;
  var childTypeUse = parentTypeUsage.typeArguments.p(index);
  return childTypeUse;
}
function typeForParentUnnamedSuperType_0($this, parentTypeUsage, nodeInfo) {
  Debug_getInstance();
  if (false) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!parentTypeUsage.isNullable) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.y1(toString(message));
    }
  }
  var tmp = parentTypeUsage.type;
  var tu = (isInterface(tmp, UnnamedSuperTypeType) ? tmp : THROW_CCE()).subtypes.p(nodeInfo.parentAlt.option);
  return tu;
}
function typeForParentTuple_0($this, parentType, nodeInfo) {
  var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
  return typeForProperty_0($this, prop, nodeInfo);
}
function typeForParentElement_0($this, parentType, nodeInfo) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!parentType.subtypes.y()) {
    var t = parentType.subtypes.p(nodeInfo.parentAlt.option);
    return t;
  } else {
    var prop = parentType.getPropertyByIndex(nodeInfo.child.propertyIndex);
    tmp = typeForProperty_0($this, prop, nodeInfo);
  }
  return tmp;
}
function typeForProperty_0($this, prop, nodeInfo) {
  var tmp;
  if (null == prop) {
    tmp = $this.typeModel.NothingType.instance();
  } else if (prop.typeInstance.isNullable) {
    tmp = prop.typeInstance;
  } else {
    var propType = prop.typeInstance.type;
    var tmp_0;
    if (isInterface(propType, PrimitiveType)) {
      tmp_0 = prop.typeInstance;
    } else {
      if (isInterface(propType, UnnamedSuperTypeType)) {
        var tu = resolveUnnamedSuperTypeSubtype_0($this, prop.typeInstance, nodeInfo);
        var tmp1_subject = tu.type;
        var tmp_1;
        if (isInterface(tmp1_subject, TupleType)) {
          tmp_1 = tu;
        } else {
          tmp_1 = prop.typeInstance;
        }
        tmp_0 = tmp_1;
      } else {
        if (isInterface(propType, CollectionType)) {
          tmp_0 = prop.typeInstance;
        } else {
          if (isInterface(propType, TupleType)) {
            tmp_0 = prop.typeInstance;
          } else {
            if (isInterface(propType, DataType)) {
              tmp_0 = prop.typeInstance;
            } else {
              var tmp_2;
              if (equals(propType, $this.typeModel.NothingType)) {
                tmp_2 = $this.typeModel.NothingType.instance();
              } else if (equals(propType, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Shold not happen');
              }
              tmp_0 = tmp_2;
            }
          }
        }
      }
    }
    tmp = tmp_0;
  }
  return tmp;
}
function resolveCompressed_0($this, typeUsage, nodeInfo) {
  var type = typeUsage.type;
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  if (isInterface(type, StructuredType)) {
    tmp_2 = nodeInfo.node.rule.e2b();
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = Companion_getInstance_38().hasOnyOneRhsItem;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = nodeInfo.node.rule.b15().p(0).p(0).s10();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = new NodeTypes(typeUsage, SimpleTypeModelStdLib_getInstance().String);
  } else {
    var tmp_3;
    if (isInterface(type, DataType)) {
      tmp_3 = type.property.o() === 1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp = first(type.property.k3()).typeInstance.isNullable ? new NodeTypes(typeUsage, first(type.property.k3()).typeInstance) : nodeInfo.node.rule.e2b() ? NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage) : nodeInfo.node.rule.gn() ? new NodeTypes(typeUsage, first(type.property.k3()).typeInstance) : NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage);
    } else {
      if (isInterface(type, UnnamedSuperTypeType)) {
        var tmp_4;
        if (nodeInfo.node.rule.a14()) {
          var tmp_5;
          var tmp_6 = type.subtypes.p(nodeInfo.alt.option).type;
          if (isInterface(tmp_6, TupleType)) {
            tmp_5 = new NodeTypes(typeUsage, type.subtypes.p(nodeInfo.alt.option));
          } else {
            tmp_5 = NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage);
          }
          tmp_4 = tmp_5;
        } else {
          tmp_4 = NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage);
        }
        tmp = tmp_4;
      } else {
        tmp = NodeTypes.new_net_akehurst_language_agl_syntaxAnalyser_NodeTypes(typeUsage);
      }
    }
  }
  return tmp;
}
function resolveUnnamedSuperTypeSubtype_0($this, typeUse, nodeInfo) {
  var type = typeUse.type;
  var tmp;
  if (isInterface(type, UnnamedSuperTypeType)) {
    var tmp_0;
    var tmp_1;
    if (nodeInfo.node.rule.a14()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_1 = !type.subtypes.y();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var t = type.subtypes.p(nodeInfo.alt.option);
      tmp_0 = t;
    } else {
      tmp_0 = typeUse;
    }
    tmp = tmp_0;
  } else {
    tmp = typeUse;
  }
  return tmp;
}
function createValueFromBranch_0($this, sentence, downData, target, children) {
  var targetType = findTypeUsageForRule_0($this, target.node.rule.mz());
  var tmp;
  if (downData.typeUse.forNode.isNullable ? target.node.rule.e2b() : false) {
    var child = children.p(0);
    var tmp_0;
    if (null == child.value) {
      tmp_0 = null;
    } else {
      var nonOptChildren = listOf(new ChildData(child.nodeInfo, child.value));
      tmp_0 = child.value;
    }
    tmp = tmp_0;
  } else if (target.node.rule.ny()) {
    tmp = children.p(0).value;
  } else {
    var type = downData.typeUse.forNode.type;
    var tmp_1;
    if (isInterface(type, PrimitiveType)) {
      var tmp_2 = SimpleTypeModelStdLib_getInstance().String.type;
      createPrimitiveValue($this, sentence, isInterface(tmp_2, PrimitiveType) ? tmp_2 : THROW_CCE(), target);
      tmp_1 = Unit_getInstance();
    } else {
      if (isInterface(type, UnnamedSuperTypeType)) {
        var actualType = type.subtypes.p(target.alt.option).type;
        var tmp_3;
        if (isInterface(actualType, TupleType)) {
          tmp_3 = createValueFor_0($this, sentence, actualType, downData.path, new ChildData(target, children));
        } else {
          tmp_3 = children.p(0).value;
        }
        tmp_1 = tmp_3;
      } else {
        if (isInterface(type, CollectionType)) {
          if (equals(type, SimpleTypeModelStdLib_getInstance().List)) {
            var tmp_4;
            if (!(null == targetType) ? !equals(targetType.type, SimpleTypeModelStdLib_getInstance().List) : false) {
              var tmp_5 = targetType.type;
              tmp_4 = isInterface(tmp_5, DataType);
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              $this.finishList();
              var tmp_6 = targetType.type;
              var elType = isInterface(tmp_6, DataType) ? tmp_6 : THROW_CCE();
              var propDecl = first(elType.property.k3());
              setPropertyOrReferenceFromDeclaration_0($this, elType, propDecl);
              $this.finishAsmElement(downData.path, elType);
            } else {
              $this.finishList();
            }
          } else if (equals(type, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
            var tmp_7;
            if (!(null == targetType) ? !equals(targetType.type, SimpleTypeModelStdLib_getInstance().ListSeparated) : false) {
              var tmp_8 = targetType.type;
              tmp_7 = isInterface(tmp_8, DataType);
            } else {
              tmp_7 = false;
            }
            if (tmp_7) {
              $this.finishListSeparated();
              var tmp_9 = targetType.type;
              var elType_0 = isInterface(tmp_9, DataType) ? tmp_9 : THROW_CCE();
              var propDecl_0 = first(elType_0.property.k3());
              setPropertyOrReferenceFromDeclaration_0($this, elType_0, propDecl_0);
              $this.finishAsmElement(downData.path, elType_0);
            } else {
              $this.finishListSeparated();
            }
          } else {
            // Inline function 'kotlin.error' call
            throw IllegalStateException.y1('Should not happen');
          }
          tmp_1 = Unit_getInstance();
        } else {
          if (isInterface(type, TupleType)) {
            createTupleFrom_0($this, sentence, type, downData.path, new ChildData(target, children));
            tmp_1 = Unit_getInstance();
          } else {
            if (isInterface(type, DataType)) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!type.subtypes.y()) {
                var tmp3_iterator = type.property.k3().u();
                while (tmp3_iterator.h1()) {
                  var propDecl_1 = tmp3_iterator.j1();
                  var propType = propDecl_1.typeInstance.type;
                  if (isInterface(propType, PrimitiveType)) {
                    var childData = children.p(propDecl_1.index);
                    var tmp_10 = SimpleTypeModelStdLib_getInstance().String.type;
                    createPrimitiveValue($this, sentence, isInterface(tmp_10, PrimitiveType) ? tmp_10 : THROW_CCE(), childData.nodeInfo);
                  } else {
                    if (isInterface(propType, CollectionType)) {
                      if (equals(propType, SimpleTypeModelStdLib_getInstance().List)) {
                        var tmp_11;
                        if (target.node.rule.g2b()) {
                          var tmp_12 = target.node.option;
                          Companion_getInstance_29();
                          tmp_11 = tmp_12 === 1;
                        } else {
                          tmp_11 = false;
                        }
                        if (tmp_11) {
                          emptyList();
                        } else {
                          if (target.node.rule.gn()) {
                            // Inline function 'kotlin.collections.map' call
                            // Inline function 'kotlin.collections.mapTo' call
                            var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(children, 10));
                            var tmp0_iterator = children.u();
                            while (tmp0_iterator.h1()) {
                              var item = tmp0_iterator.j1();
                              var tmp$ret$1;
                              // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleStreamPushAbstract.createValueFromBranch.<anonymous>' call
                              tmp$ret$1 = item.value;
                              tmp0_mapTo.e1(tmp$ret$1);
                            }
                            createList_0($this, target, tmp0_mapTo);
                          } else {
                            var childData_0 = children.p(propDecl_1.index);
                            if (childData_0.nodeInfo.node.rule.gn()) {
                              if (null == childData_0.value) {
                                emptyList();
                              } else {
                                var tmp_13 = childData_0.value;
                                if (!(tmp_13 == null) ? isInterface(tmp_13, List) : false) {
                                  var tmp_14 = childData_0.value;
                                  createList_0($this, childData_0.nodeInfo, (!(tmp_14 == null) ? isInterface(tmp_14, List) : false) ? tmp_14 : THROW_CCE());
                                } else {
                                  var tmp_15 = childData_0.value;
                                  if (tmp_15 instanceof AsmElementSimple) {
                                    var tmp_16 = first(childData_0.value.properties.k3()).value;
                                    if (!(!(tmp_16 == null) ? isInterface(tmp_16, List) : false))
                                      THROW_CCE();
                                  } else {
                                    listOf(childData_0.value);
                                  }
                                }
                              }
                            } else {
                              // Inline function 'kotlin.error' call
                              var tmp1_error = "Internal Error: cannot create a ListSimple from '" + childData_0 + "'";
                              throw IllegalStateException.y1(toString(tmp1_error));
                            }
                          }
                        }
                      } else if (equals(propType, SimpleTypeModelStdLib_getInstance().ListSeparated)) {
                        var childData_1 = children.p(propDecl_1.index);
                        if (childData_1.nodeInfo.node.rule.q11()) {
                          emptyList();
                        } else if (target.node.rule.gn()) {
                          // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
                          // Inline function 'kotlin.collections.map' call
                          // Inline function 'kotlin.collections.mapTo' call
                          var tmp0_mapTo_0 = ArrayList.f4(collectionSizeOrDefault(children, 10));
                          var tmp0_iterator_0 = children.u();
                          while (tmp0_iterator_0.h1()) {
                            var item_0 = tmp0_iterator_0.j1();
                            var tmp$ret$4;
                            // Inline function 'net.akehurst.language.agl.syntaxAnalyser.SyntaxAnalyserSimpleStreamPushAbstract.createValueFromBranch.<anonymous>' call
                            tmp$ret$4 = item_0.value;
                            tmp0_mapTo_0.e1(tmp$ret$4);
                          }
                          ListSeparatedArrayList.u1f(tmp0_mapTo_0);
                        } else if (childData_1.nodeInfo.node.rule.gn()) {
                          var tmp_17 = childData_1.value;
                          if (!(!(tmp_17 == null) ? isInterface(tmp_17, List) : false)) {
                            var tmp_18 = childData_1.value;
                            if (tmp_18 instanceof AsmElementSimple) {
                              var tmp_19 = first(childData_1.value.properties.k3()).value;
                              if (!(!(tmp_19 == null) ? isInterface(tmp_19, List) : false))
                                THROW_CCE();
                            } else {
                              throw NotImplementedError.eg();
                            }
                          }
                        } else {
                          // Inline function 'kotlin.error' call
                          var tmp3_error = "Internal Error: cannot create a ListSeparated from '" + childData_1 + "'";
                          throw IllegalStateException.y1(toString(tmp3_error));
                        }
                      } else {
                        // Inline function 'kotlin.error' call
                        throw IllegalStateException.y1('Should not happen');
                      }
                    }
                  }
                  setPropertyOrReferenceFromDeclaration_0($this, type, propDecl_1);
                }
                $this.finishAsmElement(downData.path, type);
              }
              tmp_1 = Unit_getInstance();
            } else {
              var tmp_20;
              if (equals(type, $this.typeModel.NothingType)) {
                throw IllegalStateException.y1("Internal Error: items should not have type 'NothingType'");
              } else if (equals(type, $this.typeModel.AnyType)) {
                throw NotImplementedError.eg();
              } else {
                throw IllegalStateException.y1('Shold not happen');
              }
            }
          }
        }
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function createValueFor_0($this, sentence, type, path, childData) {
  if (isInterface(type, PrimitiveType)) {
    var tmp = SimpleTypeModelStdLib_getInstance().String.type;
    createPrimitiveValue($this, sentence, isInterface(tmp, PrimitiveType) ? tmp : THROW_CCE(), childData.nodeInfo);
  } else {
    if (isInterface(type, UnnamedSuperTypeType)) {
      // Inline function 'kotlin.TODO' call
      throw NotImplementedError.eg();
    } else {
      if (isInterface(type, CollectionType)) {
        // Inline function 'kotlin.TODO' call
        throw NotImplementedError.eg();
      } else {
        if (isInterface(type, TupleType)) {
          createTupleFrom_0($this, sentence, type, path, childData);
        } else {
          if (isInterface(type, DataType)) {
            var tmp_0 = childData.value;
            createElementFrom_0($this, sentence, type, path, (!(tmp_0 == null) ? isInterface(tmp_0, List) : false) ? tmp_0 : THROW_CCE());
          } else {
            if (equals(type, $this.typeModel.NothingType)) {
              // Inline function 'kotlin.TODO' call
              throw NotImplementedError.eg();
            } else if (equals(type, $this.typeModel.AnyType)) {
              // Inline function 'kotlin.TODO' call
              throw NotImplementedError.eg();
            } else {
              // Inline function 'kotlin.error' call
              throw IllegalStateException.y1('Shold not happen');
            }
          }
        }
      }
    }
  }
  return Unit_getInstance();
}
function createPrimitiveValue($this, sentence, type, nodeInfo) {
  var text = nodeInfo.node.rule.q11() ? null : sentence.k1v(nodeInfo.node);
  $this.primitive(type, text);
}
function createList_0($this, nodeData, list) {
  var tmp;
  if (nodeData.node.rule.g2b()) {
    tmp = list;
  } else if (nodeData.node.rule.h2b()) {
    var tmp_0 = nodeData.node.rule;
    var tmp_1 = (tmp_0 instanceof RuntimeRule ? tmp_0 : THROW_CCE()).i11();
    var rhs = tmp_1 instanceof RuntimeRuleRhsListSeparated ? tmp_1 : THROW_CCE();
    var tmp_2;
    if (rhs.s2b_1.s10()) {
      // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
      tmp_2 = ListSeparatedArrayList.u1f(list).a11();
    } else {
      // Inline function 'net.akehurst.language.agl.collections.toSeparatedList' call
      tmp_2 = ListSeparatedArrayList.u1f(list).i2h();
    }
    tmp = tmp_2;
  } else {
    throw IllegalStateException.y1('Internal error: List kind not handled');
  }
  return tmp;
}
function createTupleFrom_0($this, sentence, type, path, childData) {
  var tmp0_iterator = type.property.k3().u();
  while (tmp0_iterator.h1()) {
    var propDecl = tmp0_iterator.j1();
    setPropertyOrReferenceFromDeclaration_0($this, type, propDecl);
  }
  $this.finishTuple(path);
}
function createElementFrom_0($this, sentence, type, path, children) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!type.subtypes.y()) {
    Debug_getInstance();
    if (false) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(1 === children.o())) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.y1(toString(message));
      }
    }
    children.p(0).value;
  } else {
    var tmp0_iterator = type.property.k3().u();
    while (tmp0_iterator.h1()) {
      var propDecl = tmp0_iterator.j1();
      var propPath = path.plus(propDecl.name);
      var propType = propDecl.typeInstance.type;
      var childData = children.p(propDecl.index);
      if (isInterface(propType, PrimitiveType)) {
        var text = childData.nodeInfo.node.rule.q11() ? null : sentence.k1v(childData.nodeInfo.node);
        $this.primitive(propType, text);
      } else {
        if (isInterface(propType, CollectionType)) {
          $this.finishList();
        } else {
          if (isInterface(propType, TupleType)) {
            createTupleFrom_0($this, sentence, propType, path, childData);
          } else {
            if (isInterface(propType, UnnamedSuperTypeType)) {
              var actualType = propType.subtypes.p(childData.nodeInfo.parentAlt.option).type;
              if (isInterface(actualType, TupleType)) {
                createTupleFrom_0($this, sentence, actualType, path, childData);
              } else {
                // Inline function 'kotlin.TODO' call
                throw NotImplementedError.eg();
              }
            } else {
              children.p(propDecl.index);
            }
          }
        }
      }
      setPropertyOrReferenceFromDeclaration_0($this, type, propDecl);
    }
    $this.finishAsmElement(path, type);
  }
}
function isReference_0($this, elType, name) {
  var tmp0_safe_receiver = $this.scopeModel;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isReference(elType.name, name);
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function setPropertyOrReferenceFromDeclaration_0($this, elType, declaration) {
  var isRef = isReference_0($this, elType, declaration.name);
  $this.finishProperty(declaration, isRef);
}
var Companion_instance_37;
function Companion_getInstance_39() {
  if (Companion_instance_37 === VOID)
    new Companion_37();
  return Companion_instance_37;
}
function AsmSimple$Companion$asStringAny$lambda($indent, $newIndent) {
  return function (it) {
    var tmp0_safe_receiver = it;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : Companion_getInstance_40().y2h(tmp0_safe_receiver, $indent, $newIndent);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  };
}
var Companion_instance_38;
function Companion_getInstance_40() {
  if (Companion_instance_38 === VOID)
    new Companion_38();
  return Companion_instance_38;
}
function traverseDepthFirst$traverse($callback, propertyName, element) {
  if (element instanceof AsmElementSimple) {
    $callback.beforeElement(propertyName, element);
    var tmp = element.properties.k3();
    var tmp_0 = AsmSimple$traverseDepthFirst$traverse$lambda;
    var props = sortedWith(tmp, new sam$kotlin_Comparator$0_11(tmp_0));
    var tmp1_iterator = props.u();
    while (tmp1_iterator.h1()) {
      var prop = tmp1_iterator.j1();
      $callback.property(element, prop);
      var pv = prop.value;
      traverseDepthFirst$traverse($callback, prop.name, pv);
    }
    $callback.afterElement(propertyName, element);
  } else {
    if (!(element == null) ? isInterface(element, List) : false) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = element.u();
      while (tmp0_iterator.h1()) {
        var element_0 = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.api.asm.AsmSimple.traverseDepthFirst.traverse.<anonymous>' call
        traverseDepthFirst$traverse($callback, propertyName, element_0);
      }
    }
  }
}
function AsmSimple$asString$lambda($indent, $currentIndent) {
  return function (it) {
    return Companion_getInstance_40().y2h(it, $indent, $currentIndent);
  };
}
function AsmSimple$traverseDepthFirst$traverse$lambda(a, b) {
  var aIdx = a.childIndex;
  var bIdx = b.childIndex;
  return aIdx > bIdx ? 1 : aIdx < bIdx ? -1 : 0;
}
function AsmElementSimple$_get_propertiesOrdered_$lambda_5oy69n(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.<get-propertiesOrdered>.<anonymous>' call
  var tmp = a.childIndex;
  var tmp$ret$1;
  // Inline function 'net.akehurst.language.api.asm.AsmElementSimple.<get-propertiesOrdered>.<anonymous>' call
  tmp$ret$1 = b.childIndex;
  return compareValues(tmp, tmp$ret$1);
}
function AsmElementSimple$asString$lambda($indent, $newIndent) {
  return function (it) {
    var tmp;
    if (it.isReference) {
      var tmp_0 = it.value;
      var ref = tmp_0 instanceof AsmElementReference ? tmp_0 : THROW_CCE();
      tmp = it.name + ' = ' + ref;
    } else if (null == it.value) {
      tmp = it.name + ' = null';
    } else {
      tmp = it.name + ' = ' + Companion_getInstance_40().y2h(it.value, $indent, $newIndent);
    }
    return tmp;
  };
}
function asmSimple(scopeModel, context, resolveReferences, init) {
  scopeModel = scopeModel === VOID ? new ScopeModelAgl() : scopeModel;
  context = context === VOID ? null : context;
  resolveReferences = resolveReferences === VOID ? true : resolveReferences;
  var b = new AsmSimpleBuilder(scopeModel, context, resolveReferences);
  init(b);
  return b.build();
}
function AsmSimpleBuilder$build$lambda(this$0) {
  return function (ref) {
    return this$0.m2i_1.elementIndex.u3(ref);
  };
}
function _get__elementScope__jy0q92($this) {
  // Inline function 'kotlin.getValue' call
  _elementScope$factory();
  return $this.s2i_1.p3();
}
function _property($this, name, value) {
  $this.r2i_1.setProperty(name, value, false, 0);
}
function AsmElementSimpleBuilder$_elementScope$delegate$lambda($_parentScope, this$0, $_asmPath) {
  return function () {
    var tmp0_safe_receiver = $_parentScope;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'net.akehurst.language.api.asm.AsmElementSimpleBuilder._elementScope$delegate.<anonymous>.<anonymous>' call
      var tmp_0;
      if (this$0.o2i_1.isScopeDefinition(this$0.r2i_1.typeName)) {
        var tmp0_elvis_lhs = createReferenceLocalToScope(this$0.o2i_1, $_parentScope, this$0.r2i_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          var tmp0_error = 'Trying to create child scope but cannot create a reference for ' + this$0.r2i_1;
          throw IllegalStateException.y1(toString(tmp0_error));
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var refInParent = tmp_1;
        var newScope = $_parentScope.createOrGetChildScope(refInParent, this$0.r2i_1.typeName, this$0.r2i_1.asmPath);
        // Inline function 'kotlin.collections.set' call
        var tmp1_set = this$0.p2i_1;
        tmp1_set.m3($_asmPath, newScope);
        tmp_0 = newScope;
      } else {
        tmp_0 = $_parentScope;
      }
      tmp$ret$0 = tmp_0;
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    return tmp;
  };
}
function _elementScope$factory() {
  return getPropertyCallableRef('_elementScope', 1, KProperty1, function (receiver) {
    return _get__elementScope__jy0q92(receiver);
  }, null);
}
var Companion_instance_39;
function Companion_getInstance_41() {
  if (Companion_instance_39 === VOID)
    new Companion_39();
  return Companion_instance_39;
}
var ParseAction_HEIGHT_instance;
var ParseAction_GRAFT_instance;
var ParseAction_WIDTH_instance;
var ParseAction_GOAL_instance;
var ParseAction_EMBED_instance;
function values() {
  return [ParseAction_HEIGHT_getInstance(), ParseAction_GRAFT_getInstance(), ParseAction_WIDTH_getInstance(), ParseAction_GOAL_getInstance(), ParseAction_EMBED_getInstance()];
}
function valueOf(value) {
  switch (value) {
    case 'HEIGHT':
      return ParseAction_HEIGHT_getInstance();
    case 'GRAFT':
      return ParseAction_GRAFT_getInstance();
    case 'WIDTH':
      return ParseAction_WIDTH_getInstance();
    case 'GOAL':
      return ParseAction_GOAL_getInstance();
    case 'EMBED':
      return ParseAction_EMBED_getInstance();
    default:
      ParseAction_initEntries();
      THROW_ISE();
      break;
  }
}
var ParseAction_entriesInitialized;
function ParseAction_initEntries() {
  if (ParseAction_entriesInitialized)
    return Unit_getInstance();
  ParseAction_entriesInitialized = true;
  ParseAction_HEIGHT_instance = new ParseAction('HEIGHT', 0);
  ParseAction_GRAFT_instance = new ParseAction('GRAFT', 1);
  ParseAction_WIDTH_instance = new ParseAction('WIDTH', 2);
  ParseAction_GOAL_instance = new ParseAction('GOAL', 3);
  ParseAction_EMBED_instance = new ParseAction('EMBED', 4);
}
function ParseAction_HEIGHT_getInstance() {
  ParseAction_initEntries();
  return ParseAction_HEIGHT_instance;
}
function ParseAction_GRAFT_getInstance() {
  ParseAction_initEntries();
  return ParseAction_GRAFT_instance;
}
function ParseAction_WIDTH_getInstance() {
  ParseAction_initEntries();
  return ParseAction_WIDTH_instance;
}
function ParseAction_GOAL_getInstance() {
  ParseAction_initEntries();
  return ParseAction_GOAL_instance;
}
function ParseAction_EMBED_getInstance() {
  ParseAction_initEntries();
  return ParseAction_EMBED_instance;
}
function formatModel(init) {
  var b = new FormatModelBuilder();
  init(b);
  return b.build();
}
function _get__exp__d2m08d($this) {
  var tmp = $this.f2j_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('_exp');
  }
}
function grammar$factory_1() {
  return getPropertyCallableRef('grammar', 1, KProperty1, function (receiver) {
    return receiver.u1g();
  }, null);
}
var Associativity_LEFT_instance;
var Associativity_RIGHT_instance;
function values_0() {
  return [Associativity_LEFT_getInstance(), Associativity_RIGHT_getInstance()];
}
function valueOf_0(value) {
  switch (value) {
    case 'LEFT':
      return Associativity_LEFT_getInstance();
    case 'RIGHT':
      return Associativity_RIGHT_getInstance();
    default:
      Associativity_initEntries();
      THROW_ISE();
      break;
  }
}
var Associativity_entriesInitialized;
function Associativity_initEntries() {
  if (Associativity_entriesInitialized)
    return Unit_getInstance();
  Associativity_entriesInitialized = true;
  Associativity_LEFT_instance = new Associativity('LEFT', 0);
  Associativity_RIGHT_instance = new Associativity('RIGHT', 1);
}
function Associativity_LEFT_getInstance() {
  Associativity_initEntries();
  return Associativity_LEFT_instance;
}
function Associativity_RIGHT_getInstance() {
  Associativity_initEntries();
  return Associativity_RIGHT_instance;
}
var OverrideKind_REPLACE_instance;
var OverrideKind_APPEND_ALTERNATIVE_instance;
function values_1() {
  return [OverrideKind_REPLACE_getInstance(), OverrideKind_APPEND_ALTERNATIVE_getInstance()];
}
function valueOf_1(value) {
  switch (value) {
    case 'REPLACE':
      return OverrideKind_REPLACE_getInstance();
    case 'APPEND_ALTERNATIVE':
      return OverrideKind_APPEND_ALTERNATIVE_getInstance();
    default:
      OverrideKind_initEntries();
      THROW_ISE();
      break;
  }
}
var OverrideKind_entriesInitialized;
function OverrideKind_initEntries() {
  if (OverrideKind_entriesInitialized)
    return Unit_getInstance();
  OverrideKind_entriesInitialized = true;
  OverrideKind_REPLACE_instance = new OverrideKind('REPLACE', 0);
  OverrideKind_APPEND_ALTERNATIVE_instance = new OverrideKind('APPEND_ALTERNATIVE', 1);
}
function OverrideKind_REPLACE_getInstance() {
  OverrideKind_initEntries();
  return OverrideKind_REPLACE_instance;
}
function OverrideKind_APPEND_ALTERNATIVE_getInstance() {
  OverrideKind_initEntries();
  return OverrideKind_APPEND_ALTERNATIVE_instance;
}
var SeparatedListKind_Flat_instance;
var SeparatedListKind_Left_instance;
var SeparatedListKind_Right_instance;
function values_2() {
  return [SeparatedListKind_Flat_getInstance(), SeparatedListKind_Left_getInstance(), SeparatedListKind_Right_getInstance()];
}
function valueOf_2(value) {
  switch (value) {
    case 'Flat':
      return SeparatedListKind_Flat_getInstance();
    case 'Left':
      return SeparatedListKind_Left_getInstance();
    case 'Right':
      return SeparatedListKind_Right_getInstance();
    default:
      SeparatedListKind_initEntries();
      THROW_ISE();
      break;
  }
}
var SeparatedListKind_entriesInitialized;
function SeparatedListKind_initEntries() {
  if (SeparatedListKind_entriesInitialized)
    return Unit_getInstance();
  SeparatedListKind_entriesInitialized = true;
  SeparatedListKind_Flat_instance = new SeparatedListKind('Flat', 0);
  SeparatedListKind_Left_instance = new SeparatedListKind('Left', 1);
  SeparatedListKind_Right_instance = new SeparatedListKind('Right', 2);
}
function SeparatedListKind_Flat_getInstance() {
  SeparatedListKind_initEntries();
  return SeparatedListKind_Flat_instance;
}
function SeparatedListKind_Left_getInstance() {
  SeparatedListKind_initEntries();
  return SeparatedListKind_Left_instance;
}
function SeparatedListKind_Right_getInstance() {
  SeparatedListKind_initEntries();
  return SeparatedListKind_Right_instance;
}
function grammarTypeModel(namespaceQualifiedName, name, rootTypeName, imports, init) {
  imports = imports === VOID ? listOf(SimpleTypeModelStdLib_getInstance()) : imports;
  var model = new TypeModelSimple(name);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(imports, 10));
  var tmp0_iterator = imports.u();
  while (tmp0_iterator.h1()) {
    var item = tmp0_iterator.j1();
    var tmp$ret$0;
    // Inline function 'net.akehurst.language.agl.grammarTypeModel.grammarTypeModel.<anonymous>' call
    tmp$ret$0 = item.qualifiedName;
    tmp0_mapTo.e1(tmp$ret$0);
  }
  var b = new GrammarTypeModelBuilder(namespaceQualifiedName, toMutableList(tmp0_mapTo));
  init(b);
  var ns = b.eo();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_0 = imports.u();
  while (tmp0_iterator_0.h1()) {
    var element = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.grammarTypeModel.grammarTypeModel.<anonymous>' call
    model.addNamespace(element);
  }
  model.addNamespace(ns);
  model.resolveImports();
  return model;
}
var Message_instance;
function Message_getInstance() {
  if (Message_instance === VOID)
    new Message();
  return Message_instance;
}
function init_net_akehurst_language_api_parser_ParseTreeException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.b2k_1);
}
var AutomatonKind_LOOKAHEAD_NONE_instance;
var AutomatonKind_LOOKAHEAD_SIMPLE_instance;
var AutomatonKind_LOOKAHEAD_1_instance;
function values_3() {
  return [AutomatonKind_LOOKAHEAD_NONE_getInstance(), AutomatonKind_LOOKAHEAD_SIMPLE_getInstance(), AutomatonKind_LOOKAHEAD_1_getInstance()];
}
function valueOf_3(value) {
  switch (value) {
    case 'LOOKAHEAD_NONE':
      return AutomatonKind_LOOKAHEAD_NONE_getInstance();
    case 'LOOKAHEAD_SIMPLE':
      return AutomatonKind_LOOKAHEAD_SIMPLE_getInstance();
    case 'LOOKAHEAD_1':
      return AutomatonKind_LOOKAHEAD_1_getInstance();
    default:
      AutomatonKind_initEntries();
      THROW_ISE();
      break;
  }
}
var AutomatonKind_entriesInitialized;
function AutomatonKind_initEntries() {
  if (AutomatonKind_entriesInitialized)
    return Unit_getInstance();
  AutomatonKind_entriesInitialized = true;
  AutomatonKind_LOOKAHEAD_NONE_instance = new AutomatonKind('LOOKAHEAD_NONE', 0);
  AutomatonKind_LOOKAHEAD_SIMPLE_instance = new AutomatonKind('LOOKAHEAD_SIMPLE', 1);
  AutomatonKind_LOOKAHEAD_1_instance = new AutomatonKind('LOOKAHEAD_1', 2);
}
var AutomatonKind_api_instance;
function AutomatonKind_api_getInstance() {
  if (AutomatonKind_api_instance === VOID)
    new AutomatonKind_api_0();
  return AutomatonKind_api_instance;
}
function AutomatonKind_LOOKAHEAD_NONE_getInstance() {
  AutomatonKind_initEntries();
  return AutomatonKind_LOOKAHEAD_NONE_instance;
}
function AutomatonKind_LOOKAHEAD_SIMPLE_getInstance() {
  AutomatonKind_initEntries();
  return AutomatonKind_LOOKAHEAD_SIMPLE_instance;
}
function AutomatonKind_LOOKAHEAD_1_getInstance() {
  AutomatonKind_initEntries();
  return AutomatonKind_LOOKAHEAD_1_instance;
}
var CompletionItemKind_LITERAL_instance;
var CompletionItemKind_PATTERN_instance;
var CompletionItemKind_SEGMENT_instance;
function values_4() {
  return [CompletionItemKind_LITERAL_getInstance(), CompletionItemKind_PATTERN_getInstance(), CompletionItemKind_SEGMENT_getInstance()];
}
function valueOf_4(value) {
  switch (value) {
    case 'LITERAL':
      return CompletionItemKind_LITERAL_getInstance();
    case 'PATTERN':
      return CompletionItemKind_PATTERN_getInstance();
    case 'SEGMENT':
      return CompletionItemKind_SEGMENT_getInstance();
    default:
      CompletionItemKind_initEntries();
      THROW_ISE();
      break;
  }
}
var CompletionItemKind_entriesInitialized;
function CompletionItemKind_initEntries() {
  if (CompletionItemKind_entriesInitialized)
    return Unit_getInstance();
  CompletionItemKind_entriesInitialized = true;
  CompletionItemKind_LITERAL_instance = new CompletionItemKind('LITERAL', 0);
  CompletionItemKind_PATTERN_instance = new CompletionItemKind('PATTERN', 1);
  CompletionItemKind_SEGMENT_instance = new CompletionItemKind('SEGMENT', 2);
}
function CompletionItemKind_LITERAL_getInstance() {
  CompletionItemKind_initEntries();
  return CompletionItemKind_LITERAL_instance;
}
function CompletionItemKind_PATTERN_getInstance() {
  CompletionItemKind_initEntries();
  return CompletionItemKind_PATTERN_instance;
}
function CompletionItemKind_SEGMENT_getInstance() {
  CompletionItemKind_initEntries();
  return CompletionItemKind_SEGMENT_instance;
}
var LanguageIssueKind_ERROR_instance;
var LanguageIssueKind_WARNING_instance;
var LanguageIssueKind_INFORMATION_instance;
function values_5() {
  return [LanguageIssueKind_ERROR_getInstance(), LanguageIssueKind_WARNING_getInstance(), LanguageIssueKind_INFORMATION_getInstance()];
}
function valueOf_5(value) {
  switch (value) {
    case 'ERROR':
      return LanguageIssueKind_ERROR_getInstance();
    case 'WARNING':
      return LanguageIssueKind_WARNING_getInstance();
    case 'INFORMATION':
      return LanguageIssueKind_INFORMATION_getInstance();
    default:
      LanguageIssueKind_initEntries();
      THROW_ISE();
      break;
  }
}
var LanguageIssueKind_entriesInitialized;
function LanguageIssueKind_initEntries() {
  if (LanguageIssueKind_entriesInitialized)
    return Unit_getInstance();
  LanguageIssueKind_entriesInitialized = true;
  LanguageIssueKind_ERROR_instance = new LanguageIssueKind('ERROR', 0);
  LanguageIssueKind_WARNING_instance = new LanguageIssueKind('WARNING', 1);
  LanguageIssueKind_INFORMATION_instance = new LanguageIssueKind('INFORMATION', 2);
}
var LanguageProcessorPhase_GRAMMAR_instance;
var LanguageProcessorPhase_PARSE_instance;
var LanguageProcessorPhase_SYNTAX_ANALYSIS_instance;
var LanguageProcessorPhase_SEMANTIC_ANALYSIS_instance;
var LanguageProcessorPhase_INTERPRETER_instance;
var LanguageProcessorPhase_GENERATOR_instance;
var LanguageProcessorPhase_FORMATTER_instance;
var LanguageProcessorPhase_ALL_instance;
function values_6() {
  return [LanguageProcessorPhase_GRAMMAR_getInstance(), LanguageProcessorPhase_PARSE_getInstance(), LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance(), LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance(), LanguageProcessorPhase_INTERPRETER_getInstance(), LanguageProcessorPhase_GENERATOR_getInstance(), LanguageProcessorPhase_FORMATTER_getInstance(), LanguageProcessorPhase_ALL_getInstance()];
}
function valueOf_6(value) {
  switch (value) {
    case 'GRAMMAR':
      return LanguageProcessorPhase_GRAMMAR_getInstance();
    case 'PARSE':
      return LanguageProcessorPhase_PARSE_getInstance();
    case 'SYNTAX_ANALYSIS':
      return LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance();
    case 'SEMANTIC_ANALYSIS':
      return LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance();
    case 'INTERPRETER':
      return LanguageProcessorPhase_INTERPRETER_getInstance();
    case 'GENERATOR':
      return LanguageProcessorPhase_GENERATOR_getInstance();
    case 'FORMATTER':
      return LanguageProcessorPhase_FORMATTER_getInstance();
    case 'ALL':
      return LanguageProcessorPhase_ALL_getInstance();
    default:
      LanguageProcessorPhase_initEntries();
      THROW_ISE();
      break;
  }
}
var LanguageProcessorPhase_entriesInitialized;
function LanguageProcessorPhase_initEntries() {
  if (LanguageProcessorPhase_entriesInitialized)
    return Unit_getInstance();
  LanguageProcessorPhase_entriesInitialized = true;
  LanguageProcessorPhase_GRAMMAR_instance = new LanguageProcessorPhase('GRAMMAR', 0);
  LanguageProcessorPhase_PARSE_instance = new LanguageProcessorPhase('PARSE', 1);
  LanguageProcessorPhase_SYNTAX_ANALYSIS_instance = new LanguageProcessorPhase('SYNTAX_ANALYSIS', 2);
  LanguageProcessorPhase_SEMANTIC_ANALYSIS_instance = new LanguageProcessorPhase('SEMANTIC_ANALYSIS', 3);
  LanguageProcessorPhase_INTERPRETER_instance = new LanguageProcessorPhase('INTERPRETER', 4);
  LanguageProcessorPhase_GENERATOR_instance = new LanguageProcessorPhase('GENERATOR', 5);
  LanguageProcessorPhase_FORMATTER_instance = new LanguageProcessorPhase('FORMATTER', 6);
  LanguageProcessorPhase_ALL_instance = new LanguageProcessorPhase('ALL', 7);
}
function LanguageIssueKind_ERROR_getInstance() {
  LanguageIssueKind_initEntries();
  return LanguageIssueKind_ERROR_instance;
}
function LanguageIssueKind_WARNING_getInstance() {
  LanguageIssueKind_initEntries();
  return LanguageIssueKind_WARNING_instance;
}
function LanguageIssueKind_INFORMATION_getInstance() {
  LanguageIssueKind_initEntries();
  return LanguageIssueKind_INFORMATION_instance;
}
function LanguageProcessorPhase_GRAMMAR_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_GRAMMAR_instance;
}
function LanguageProcessorPhase_PARSE_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_PARSE_instance;
}
function LanguageProcessorPhase_SYNTAX_ANALYSIS_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_SYNTAX_ANALYSIS_instance;
}
function LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_SEMANTIC_ANALYSIS_instance;
}
function LanguageProcessorPhase_INTERPRETER_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_INTERPRETER_instance;
}
function LanguageProcessorPhase_GENERATOR_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_GENERATOR_instance;
}
function LanguageProcessorPhase_FORMATTER_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_FORMATTER_instance;
}
function LanguageProcessorPhase_ALL_getInstance() {
  LanguageProcessorPhase_initEntries();
  return LanguageProcessorPhase_ALL_instance;
}
function LeafData$metaTags$delegate$lambda(this$0) {
  return function () {
    var map = mutableMapOf([to('$keyword', "'[a-zA-Z_][a-zA-Z0-9_-]*'")]);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var tmp0_mapNotNullTo = ArrayList.i4();
    // Inline function 'kotlin.collections.forEach' call
    var tmp$ret$0;
    // Inline function 'kotlin.collections.iterator' call
    tmp$ret$0 = map.l3().u();
    var tmp0_iterator = tmp$ret$0;
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      var tmp$ret$2;
      // Inline function 'net.akehurst.language.api.sppt.LeafData.metaTags$delegate.<anonymous>.<anonymous>' call
      var tmp;
      var tmp$ret$1;
      // Inline function 'kotlin.text.matches' call
      var tmp0_matches = this$0.name;
      var tmp1_matches = Regex.hb(element.p3());
      tmp$ret$1 = tmp1_matches.ib(tmp0_matches);
      if (tmp$ret$1) {
        tmp = element.o3();
      } else {
        tmp = null;
      }
      tmp$ret$2 = tmp;
      var tmp0_safe_receiver = tmp$ret$2;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp$ret$3;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        tmp0_mapNotNullTo.e1(tmp0_safe_receiver);
        tmp$ret$3 = Unit_getInstance();
      }
    }
    tmp$ret$4 = tmp0_mapNotNullTo;
    tmp$ret$5 = tmp$ret$4;
    return tmp$ret$5;
  };
}
function metaTags$factory() {
  return getPropertyCallableRef('metaTags', 1, KProperty1, function (receiver) {
    return receiver.metaTags;
  }, null);
}
function AglStyleRule$toCss$lambda(it) {
  return it.value;
}
function AglStyleRule$toCss$lambda_0(it) {
  return it.toCss();
}
var AglStyleSelectorKind_LITERAL_instance;
var AglStyleSelectorKind_PATTERN_instance;
var AglStyleSelectorKind_RULE_NAME_instance;
var AglStyleSelectorKind_META_instance;
function values_7() {
  return [AglStyleSelectorKind_LITERAL_getInstance(), AglStyleSelectorKind_PATTERN_getInstance(), AglStyleSelectorKind_RULE_NAME_getInstance(), AglStyleSelectorKind_META_getInstance()];
}
function valueOf_7(value) {
  switch (value) {
    case 'LITERAL':
      return AglStyleSelectorKind_LITERAL_getInstance();
    case 'PATTERN':
      return AglStyleSelectorKind_PATTERN_getInstance();
    case 'RULE_NAME':
      return AglStyleSelectorKind_RULE_NAME_getInstance();
    case 'META':
      return AglStyleSelectorKind_META_getInstance();
    default:
      AglStyleSelectorKind_initEntries();
      THROW_ISE();
      break;
  }
}
var AglStyleSelectorKind_entriesInitialized;
function AglStyleSelectorKind_initEntries() {
  if (AglStyleSelectorKind_entriesInitialized)
    return Unit_getInstance();
  AglStyleSelectorKind_entriesInitialized = true;
  AglStyleSelectorKind_LITERAL_instance = new AglStyleSelectorKind('LITERAL', 0);
  AglStyleSelectorKind_PATTERN_instance = new AglStyleSelectorKind('PATTERN', 1);
  AglStyleSelectorKind_RULE_NAME_instance = new AglStyleSelectorKind('RULE_NAME', 2);
  AglStyleSelectorKind_META_instance = new AglStyleSelectorKind('META', 3);
}
function AglStyleSelectorKind_LITERAL_getInstance() {
  AglStyleSelectorKind_initEntries();
  return AglStyleSelectorKind_LITERAL_instance;
}
function AglStyleSelectorKind_PATTERN_getInstance() {
  AglStyleSelectorKind_initEntries();
  return AglStyleSelectorKind_PATTERN_instance;
}
function AglStyleSelectorKind_RULE_NAME_getInstance() {
  AglStyleSelectorKind_initEntries();
  return AglStyleSelectorKind_RULE_NAME_instance;
}
function AglStyleSelectorKind_META_getInstance() {
  AglStyleSelectorKind_initEntries();
  return AglStyleSelectorKind_META_instance;
}
function check($this) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var next = LinkedHashMap.n8();
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator = $this.h29_1.j3().u();
  while (tmp0_iterator.h1()) {
    var element = tmp0_iterator.j1();
    // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var tmp0_set = LinkedHashSet.r8();
    next.m3(element, tmp0_set);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.filter' call
  var tmp1_filter = $this.i29_1.l3();
  // Inline function 'kotlin.collections.filterTo' call
  var tmp0_filterTo = ArrayList.i4();
  var tmp0_iterator_0 = tmp1_filter.u();
  while (tmp0_iterator_0.h1()) {
    var element_0 = tmp0_iterator_0.j1();
    // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>' call
    if (element_0.p3() === 0) {
      tmp0_filterTo.e1(element_0);
    }
  }
  // Inline function 'kotlin.collections.mapTo' call
  var tmp0_mapTo = ArrayList.f4(collectionSizeOrDefault(tmp0_filterTo, 10));
  var tmp0_iterator_1 = tmp0_filterTo.u();
  while (tmp0_iterator_1.h1()) {
    var item = tmp0_iterator_1.j1();
    var tmp$ret$5;
    // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>' call
    tmp$ret$5 = item.o3();
    tmp0_mapTo.e1(tmp$ret$5);
  }
  var heads = tmp0_mapTo;
  var check = toList(heads);
  $l$loop: while (true) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!!check.y()) {
      break $l$loop;
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp4_flatMap = check;
    // Inline function 'kotlin.collections.flatMapTo' call
    var tmp0_flatMapTo = ArrayList.i4();
    var tmp0_iterator_2 = tmp4_flatMap.u();
    while (tmp0_iterator_2.h1()) {
      var element_1 = tmp0_iterator_2.j1();
      // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>' call
      var prev = ensureNotNull($this.h29_1.u3(element_1));
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_3 = prev.u();
      while (tmp0_iterator_3.h1()) {
        var element_2 = tmp0_iterator_3.j1();
        // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>.<anonymous>' call
        ensureNotNull(next.u3(element_2)).e1(element_1);
      }
      var list = prev;
      addAll(tmp0_flatMapTo, list);
    }
    var p = tmp0_flatMapTo;
    check = p;
  }
  var tmp$ret$12;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    if (next.y()) {
      tmp$ret$12 = false;
      break $l$block_0;
    }
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_4 = next.l3().u();
    while (tmp0_iterator_4.h1()) {
      var element_3 = tmp0_iterator_4.j1();
      // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.check.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element_3.o3();
      // Inline function 'kotlin.collections.component2' call
      var v = element_3.p3();
      if (!($this.i29_1.u3(k) === v.o())) {
        tmp$ret$12 = true;
        break $l$block_0;
      }
    }
    tmp$ret$12 = false;
  }
  if (tmp$ret$12) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException.y1('GSS is broken');
  }
}
function removeStack($this, node, ifDropped) {
  var count = $this.i29_1.u3(node);
  var tmp;
  switch (count) {
    case null:
      tmp = true;
      break;
    case 0:
      $this.i29_1.q3(node);
      var prev = ensureNotNull($this.h29_1.q3(node));
      // Inline function 'kotlin.collections.forEach' call

      var tmp0_iterator = prev.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.agl.collections.GraphStructuredStack.removeStack.<anonymous>' call
        var c = ensureNotNull($this.i29_1.u3(element));
        // Inline function 'kotlin.collections.set' call
        var tmp0_set = $this.i29_1;
        var tmp1_set = c - 1 | 0;
        tmp0_set.m3(element, tmp1_set);
        removeStack($this, element, ifDropped);
      }

      ifDropped(node);
      tmp = true;
      break;
    default:
      tmp = false;
      break;
  }
  return tmp;
}
function prevOfToString_0($this, n) {
  var prev = toList($this.p29(n));
  var tmp;
  if (prev.y()) {
    tmp = '';
  } else if (1 === prev.o()) {
    var p = first_0(prev);
    tmp = ' --> ' + p + prevOfToString_0($this, p);
  } else {
    var p_0 = first_0(prev);
    tmp = ' -' + prev.o() + '-> ' + p_0 + prevOfToString_0($this, p_0);
  }
  return tmp;
}
function GraphStructuredStack$toString$lambda(this$0) {
  return function (h) {
    var p = prevOfToString_0(this$0, h.o3());
    return '' + h.o3() + p;
  };
}
function lazyMap(accessor) {
  return new LazyMap(accessor);
}
function lazyMutableMapNonNull(accessor) {
  return new LazyMutableMapNonNull(accessor);
}
function MutableQueue$toString$lambda(it) {
  return toString_1(it);
}
function mutableQueueOf(elements) {
  var stack = new MutableQueue();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = elements.length;
  while (inductionVariable < last) {
    var element = elements[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'net.akehurst.language.collections.mutableQueueOf.<anonymous>' call
    stack.x10(element);
  }
  return stack;
}
function mutableStackOf(elements) {
  var stack = new MutableStack();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = elements.length;
  while (inductionVariable < last) {
    var element = elements[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'net.akehurst.language.collections.mutableStackOf.<anonymous>' call
    stack.v1a(element);
  }
  return stack;
}
function toMutableOrderedSet(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, Collection)) {
    tmp = MutableOrderedSetImpl.w2p(_this__u8e3s4);
  } else {
    tmp = MutableOrderedSetImpl.w2p(toMutableSet(_this__u8e3s4));
  }
  return tmp;
}
function plus_4(_this__u8e3s4, elements) {
  var result = toMutableList(_this__u8e3s4);
  addAll(result, elements);
  return OrderedSetImpl.y2p(result);
}
function init_net_akehurst_language_agl_collections_MutableOrderedSetImpl(_this__u8e3s4) {
}
function init_net_akehurst_language_agl_collections_OrderedSetImpl(_this__u8e3s4) {
}
function binaryHeap(comparator) {
  return new BinaryHeapComparable(comparator);
}
function BinaryHeapComparable$iterator$o$_sorted$lambda(this$0) {
  return function (a, b) {
    return this$0.z2p_1.compare(b.o3(), a.o3());
  };
}
function parentIndexOf($this, childIndex) {
  return (childIndex - 1 | 0) / 2 | 0;
}
function leftChildIndexOf($this, parentIndex) {
  return imul(2, parentIndex) + 1 | 0;
}
function rightChildIndexOf($this, parentIndex) {
  return imul(2, parentIndex) + 2 | 0;
}
function upHeap($this, index, elementKey) {
  var tmp;
  if (1 === $this.o()) {
    tmp = index;
  } else {
    var elementIndex = index;
    var parentIndex = parentIndexOf($this, elementIndex);
    var parentKey = $this.a2q_1.p(parentIndex).o3();
    while (!equals(parentKey, elementKey) ? 0 > $this.z2p_1.compare(parentKey, elementKey) : false) {
      $this.d2q(parentIndex, elementIndex);
      elementIndex = parentIndex;
      parentIndex = parentIndexOf($this, elementIndex);
      parentKey = $this.a2q_1.p(parentIndex).o3();
    }
    tmp = elementIndex;
  }
  return tmp;
}
function downHeap($this, index) {
  var leftChildIndex = leftChildIndexOf($this, index);
  var rightChildIndex = rightChildIndexOf($this, index);
  var smallest = index;
  if (leftChildIndex < $this.a2q_1.o() ? 0 < $this.z2p_1.compare($this.a2q_1.p(leftChildIndex).o3(), $this.a2q_1.p(smallest).o3()) : false) {
    smallest = leftChildIndex;
  }
  if (rightChildIndex < $this.a2q_1.o() ? 0 < $this.z2p_1.compare($this.a2q_1.p(rightChildIndex).o3(), $this.a2q_1.p(smallest).o3()) : false) {
    smallest = rightChildIndex;
  }
  var tmp;
  if (!(smallest === index)) {
    $this.d2q(index, smallest);
    tmp = downHeap($this, smallest);
  } else {
    tmp = index;
  }
  return tmp;
}
function BinaryHeapComparable$toString$lambda(it) {
  return toString(it);
}
var IndentDelta_NONE_instance;
var IndentDelta_INC_BEFORE_instance;
var IndentDelta_INC_AFTER_instance;
var IndentDelta_DEC_BEFORE_instance;
var IndentDelta_DEC_AFTER_instance;
var IndentDelta_entriesInitialized;
function IndentDelta_initEntries() {
  if (IndentDelta_entriesInitialized)
    return Unit_getInstance();
  IndentDelta_entriesInitialized = true;
  IndentDelta_NONE_instance = new IndentDelta('NONE', 0);
  IndentDelta_INC_BEFORE_instance = new IndentDelta('INC_BEFORE', 1);
  IndentDelta_INC_AFTER_instance = new IndentDelta('INC_AFTER', 2);
  IndentDelta_DEC_BEFORE_instance = new IndentDelta('DEC_BEFORE', 3);
  IndentDelta_DEC_AFTER_instance = new IndentDelta('DEC_AFTER', 4);
}
function IndentDelta_NONE_getInstance() {
  IndentDelta_initEntries();
  return IndentDelta_NONE_instance;
}
function IndentDelta_INC_AFTER_getInstance() {
  IndentDelta_initEntries();
  return IndentDelta_INC_AFTER_instance;
}
function IndentDelta_DEC_BEFORE_getInstance() {
  IndentDelta_initEntries();
  return IndentDelta_DEC_BEFORE_instance;
}
var Debug_instance;
function Debug_getInstance() {
  if (Debug_instance === VOID)
    new Debug();
  return Debug_instance;
}
function debug(indentDelta, lazyMessage) {
  return Debug_getInstance().uz(indentDelta, lazyMessage);
}
var UNINITIALIZED_VALUE_instance;
function UNINITIALIZED_VALUE_getInstance() {
  if (UNINITIALIZED_VALUE_instance === VOID)
    new UNINITIALIZED_VALUE();
  return UNINITIALIZED_VALUE_instance;
}
var Companion_instance_40;
function Companion_getInstance_42() {
  if (Companion_instance_40 === VOID)
    new Companion_40();
  return Companion_instance_40;
}
function CachedValue$resetAction$lambda(it) {
  return Unit_getInstance();
}
function cached(initializer) {
  return new CachedValue(initializer);
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(AutomatonBuilder, 'AutomatonBuilder', interfaceMeta);
setMetadataFor(AutomatonBuilderDefault, 'AutomatonBuilderDefault', classMeta, VOID, [AutomatonBuilder]);
setMetadataFor(TransitionBuilder, 'TransitionBuilder', interfaceMeta);
setMetadataFor(TransitionBuilderDefault, 'TransitionBuilderDefault', classMeta, VOID, [TransitionBuilder]);
setMetadataFor(BuildCacheAbstract, 'BuildCacheAbstract', classMeta);
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(BuildCacheLC1, 'BuildCacheLC1', classMeta);
setMetadataFor(FirstFollowCache3, 'FirstFollowCache3', classMeta);
setMetadataFor(FirstOfResult, 'FirstOfResult', classMeta);
setMetadataFor(Companion_0, 'Companion', objectMeta);
setMetadataFor(FirstOf, 'FirstOf', classMeta);
setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(Companion_1, 'Companion', objectMeta);
setMetadataFor(Lookahead, 'Lookahead', classMeta);
setMetadataFor(Companion_2, 'Companion', objectMeta);
setMetadataFor(LookaheadSet, 'LookaheadSet', classMeta);
setMetadataFor(Companion_3, 'Companion', objectMeta);
setMetadataFor(ParserState, 'ParserState', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(Automaton, 'Automaton', interfaceMeta);
protoOf(ParserStateSet).asString = asString;
setMetadataFor(ParserStateSet, 'ParserStateSet', classMeta, VOID, [Automaton]);
setMetadataFor(RuntimeTransitionCalculator, 'RuntimeTransitionCalculator', classMeta);
setMetadataFor(ToEndMultiGraftRuntimeGuard, 'ToEndMultiGraftRuntimeGuard', classMeta);
setMetadataFor(ToItemMultiGraftRuntimeGuard, 'ToItemMultiGraftRuntimeGuard', classMeta);
setMetadataFor(ToEndSListGraftRuntimeGuard, 'ToEndSListGraftRuntimeGuard', classMeta);
setMetadataFor(ToItemSListGraftRuntimeGuard, 'ToItemSListGraftRuntimeGuard', classMeta);
setMetadataFor(ToSeparatorSListGraftRuntimeGuard, 'ToSeparatorSListGraftRuntimeGuard', classMeta);
setMetadataFor(DefaultRuntimeGuard, 'DefaultRuntimeGuard', objectMeta);
setMetadataFor(Companion_4, 'Companion', objectMeta);
setMetadataFor(Transition, 'Transition', classMeta);
setMetadataFor(Companion_5, 'Companion', objectMeta);
setMetadataFor(TransitionCacheLC1, 'TransitionCacheLC1', classMeta);
setMetadataFor(CompleteKey, 'CompleteKey', classMeta);
setMetadataFor(IncompleteKey, 'IncompleteKey', classMeta);
setMetadataFor(Companion_6, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(LookaheadSetPart, 'LookaheadSetPart', classMeta);
setMetadataFor(StateInfo, 'StateInfo', classMeta);
setMetadataFor(TransInfo, 'TransInfo', classMeta);
setMetadataFor(Companion_7, 'Companion', objectMeta);
setMetadataFor(LookaheadInfoPart, 'LookaheadInfoPart', classMeta);
setMetadataFor(WidthInfo, 'WidthInfo', classMeta);
setMetadataFor(ParentNext, 'ParentNext', classMeta);
setMetadataFor(FirstTerminalInfo, 'FirstTerminalInfo', classMeta);
setMetadataFor(ClosureItem, 'ClosureItem', interfaceMeta);
setMetadataFor(ClosureItemAbstractGraph, 'ClosureItemAbstractGraph', classMeta, VOID, [ClosureItem]);
setMetadataFor(ClosureItemRootGraph, 'ClosureItemRootGraph', classMeta, VOID, [ClosureItemAbstractGraph, ClosureItem]);
setMetadataFor(ClosureItemChildGraph, 'ClosureItemChildGraph', classMeta, VOID, [ClosureItemAbstractGraph, ClosureItem]);
setMetadataFor(Companion_8, 'Companion', objectMeta);
setMetadataFor(ClosureGraph, 'ClosureGraph', classMeta);
setMetadataFor(CompletionProvider, 'CompletionProvider', interfaceMeta);
setMetadataFor(CompletionProviderAbstract, 'CompletionProviderAbstract', classMeta, VOID, [CompletionProvider]);
setMetadataFor(CompletionProviderDefault, 'CompletionProviderDefault', classMeta);
setMetadataFor(TypeModelFromGrammar, 'TypeModelFromGrammar', objectMeta);
setMetadataFor(Companion_9, 'Companion', objectMeta);
setMetadataFor(GrammarTypeNamespace, 'GrammarTypeNamespace', interfaceMeta, VOID, [TypeNamespace]);
setMetadataFor(GrammarTypeNamespaceAbstract, 'GrammarTypeNamespaceAbstract', classMeta, VOID, [TypeNamespaceAbstract, GrammarTypeNamespace]);
setMetadataFor(GrammarTypeNamespaceFromGrammar, 'GrammarTypeNamespaceFromGrammar', classMeta);
setMetadataFor(AsmSimpleTreeWalker, 'AsmSimpleTreeWalker', interfaceMeta);
setMetadataFor(ReferenceResolverDefault, 'ReferenceResolverDefault', classMeta, VOID, [AsmSimpleTreeWalker]);
setMetadataFor(SemanticAnalyserDefault$buildScope$1, VOID, classMeta, VOID, [AsmSimpleTreeWalker]);
setMetadataFor(SemanticAnalyser, 'SemanticAnalyser', interfaceMeta);
protoOf(SemanticAnalyserDefault).analyse = analyse;
setMetadataFor(SemanticAnalyserDefault, 'SemanticAnalyserDefault', classMeta, VOID, [SemanticAnalyser]);
setMetadataFor(Companion_10, 'Companion', objectMeta);
setMetadataFor(SyntaxAnalyser, 'SyntaxAnalyser', interfaceMeta);
protoOf(SyntaxAnalyserFromTreeDataAbstract).configure = configure;
setMetadataFor(SyntaxAnalyserFromTreeDataAbstract, 'SyntaxAnalyserFromTreeDataAbstract', classMeta, VOID, [SyntaxAnalyser]);
protoOf(SyntaxAnalyserSimpleAbstract).configure = configure;
setMetadataFor(SyntaxAnalyserSimpleAbstract, 'SyntaxAnalyserSimpleAbstract', classMeta);
protoOf(SyntaxAnalyserDefault).configure = configure;
setMetadataFor(SyntaxAnalyserDefault, 'SyntaxAnalyserDefault', classMeta);
setMetadataFor(TypeModelFromGrammarConfigurationDefault, 'TypeModelFromGrammarConfigurationDefault', classMeta);
setMetadataFor(Formatter, 'Formatter', interfaceMeta);
setMetadataFor(FormatterSimple, 'FormatterSimple', classMeta, VOID, [Formatter]);
setMetadataFor(AglFormatCompletionProvider, 'AglFormatCompletionProvider', classMeta);
setMetadataFor(Grammar, 'Grammar', interfaceMeta);
setMetadataFor(GrammarAbstract, 'GrammarAbstract', classMeta, VOID, [Grammar]);
setMetadataFor(AglFormatGrammar, 'AglFormatGrammar', objectMeta);
protoOf(AglFormatSemanticAnalyser).analyse = analyse;
setMetadataFor(AglFormatSemanticAnalyser, 'AglFormatSemanticAnalyser', classMeta, VOID, [SemanticAnalyser]);
protoOf(AglFormatSyntaxAnalyser).configure = configure;
setMetadataFor(AglFormatSyntaxAnalyser, 'AglFormatSyntaxAnalyser', classMeta, VOID, [SyntaxAnalyser]);
setMetadataFor(Companion_11, 'Companion', objectMeta);
setMetadataFor(AglFormatterModel, 'AglFormatterModel', interfaceMeta);
setMetadataFor(AglFormatterModelDefault, 'AglFormatterModelDefault', classMeta, VOID, [AglFormatterModel]);
setMetadataFor(AglFormatterRule, 'AglFormatterRule', interfaceMeta);
setMetadataFor(AglFormatterRuleDefault, 'AglFormatterRuleDefault', classMeta, VOID, [AglFormatterRule]);
setMetadataFor(AglFormatExpression, 'AglFormatExpression', interfaceMeta);
setMetadataFor(AglFormatExpressionDefault, 'AglFormatExpressionDefault', classMeta, VOID, [AglFormatExpression]);
setMetadataFor(AglGrammarCompletionProvider, 'AglGrammarCompletionProvider', classMeta);
setMetadataFor(AglGrammarGrammar, 'AglGrammarGrammar', objectMeta);
setMetadataFor(Companion_12, 'Companion', objectMeta);
protoOf(AglGrammarSemanticAnalyser).analyse = analyse;
setMetadataFor(AglGrammarSemanticAnalyser, 'AglGrammarSemanticAnalyser', classMeta, VOID, [SemanticAnalyser]);
protoOf(SyntaxAnalyserByMethodRegistrationAbstract).configure = configure;
setMetadataFor(SyntaxAnalyserByMethodRegistrationAbstract, 'SyntaxAnalyserByMethodRegistrationAbstract', classMeta);
protoOf(AglGrammarSyntaxAnalyser).configure = configure;
setMetadataFor(AglGrammarSyntaxAnalyser, 'AglGrammarSyntaxAnalyser', classMeta);
setMetadataFor(SentenceContext, 'SentenceContext', interfaceMeta);
setMetadataFor(ContextFromGrammar, 'ContextFromGrammar', classMeta, VOID, [SentenceContext]);
setMetadataFor(ConverterToRuntimeRules, 'ConverterToRuntimeRules', classMeta);
setMetadataFor(GrammarContext, 'GrammarContext', classMeta);
setMetadataFor(PseudoRuleNames, 'PseudoRuleNames', classMeta);
setMetadataFor(RuleBuilder, 'RuleBuilder', classMeta);
setMetadataFor(GrammarBuilderDefault, 'GrammarBuilderDefault', classMeta);
setMetadataFor(Companion_13, 'Companion', objectMeta);
setMetadataFor(GrammarDefault, 'GrammarDefault', classMeta);
setMetadataFor(GrammarOption, 'GrammarOption', interfaceMeta);
setMetadataFor(GrammarOptionDefault, 'GrammarOptionDefault', classMeta, VOID, [GrammarOption]);
setMetadataFor(GrammarReference, 'GrammarReference', interfaceMeta);
setMetadataFor(GrammarReferenceDefault, 'GrammarReferenceDefault', classMeta, VOID, [GrammarReference]);
setMetadataFor(GrammarItem, 'GrammarItem', interfaceMeta);
setMetadataFor(GrammarItemAbstract, 'GrammarItemAbstract', classMeta, VOID, [GrammarItem]);
setMetadataFor(RuleItem, 'RuleItem', interfaceMeta);
setMetadataFor(ConcatenationItem, 'ConcatenationItem', interfaceMeta, VOID, [RuleItem]);
setMetadataFor(SimpleItem, 'SimpleItem', interfaceMeta, VOID, [ConcatenationItem]);
setMetadataFor(TangibleItem, 'TangibleItem', interfaceMeta, VOID, [SimpleItem]);
setMetadataFor(Terminal, 'Terminal', interfaceMeta, VOID, [TangibleItem, GrammarItem]);
setMetadataFor(RuleItemAbstract, 'RuleItemAbstract', classMeta, VOID, [RuleItem]);
setMetadataFor(CompressedLeafRule, 'CompressedLeafRule', classMeta, VOID, [Terminal, RuleItemAbstract]);
setMetadataFor(Companion_14, 'Companion', objectMeta);
setMetadataFor(GrammarRule, 'GrammarRule', interfaceMeta, VOID, [GrammarItem]);
setMetadataFor(GrammarRuleAbstract, 'GrammarRuleAbstract', classMeta, VOID, [GrammarItemAbstract, GrammarRule]);
setMetadataFor(Namespace, 'Namespace', interfaceMeta);
setMetadataFor(NamespaceDefault, 'NamespaceDefault', classMeta, VOID, [Namespace]);
setMetadataFor(NodeType, 'NodeType', interfaceMeta);
setMetadataFor(NodeTypeDefault, 'NodeTypeDefault', classMeta, VOID, [NodeType]);
setMetadataFor(NormalRule, 'NormalRule', interfaceMeta, VOID, [GrammarRule]);
setMetadataFor(NormalRuleDefault, 'NormalRuleDefault', classMeta, VOID, [GrammarRuleAbstract, NormalRule]);
setMetadataFor(OverrideRule, 'OverrideRule', interfaceMeta, VOID, [GrammarRule]);
setMetadataFor(OverrideRuleDefault, 'OverrideRuleDefault', classMeta, VOID, [GrammarRuleAbstract, OverrideRule]);
setMetadataFor(PreferenceRule, 'PreferenceRule', interfaceMeta, VOID, [GrammarItem]);
setMetadataFor(PreferenceRuleDefault, 'PreferenceRuleDefault', classMeta, VOID, [GrammarItemAbstract, PreferenceRule]);
setMetadataFor(PreferenceOption, 'PreferenceOption', interfaceMeta);
setMetadataFor(PreferenceOptionDefault, 'PreferenceOptionDefault', classMeta, VOID, [PreferenceOption]);
setMetadataFor(Concatenation, 'Concatenation', interfaceMeta, VOID, [RuleItem]);
setMetadataFor(ConcatenationDefault, 'ConcatenationDefault', classMeta, VOID, [RuleItemAbstract, Concatenation]);
setMetadataFor(Choice, 'Choice', interfaceMeta, VOID, [RuleItem]);
setMetadataFor(ChoiceAbstract, 'ChoiceAbstract', classMeta, VOID, [RuleItemAbstract, Choice]);
setMetadataFor(ChoiceLongest, 'ChoiceLongest', interfaceMeta, VOID, [Choice]);
setMetadataFor(ChoiceLongestDefault, 'ChoiceLongestDefault', classMeta, VOID, [ChoiceAbstract, ChoiceLongest]);
setMetadataFor(ChoicePriority, 'ChoicePriority', interfaceMeta, VOID, [Choice]);
setMetadataFor(ChoicePriorityDefault, 'ChoicePriorityDefault', classMeta, VOID, [ChoiceAbstract, ChoicePriority]);
setMetadataFor(ChoiceAmbiguous, 'ChoiceAmbiguous', interfaceMeta, VOID, [Choice]);
setMetadataFor(ChoiceAmbiguousDefault, 'ChoiceAmbiguousDefault', classMeta, VOID, [ChoiceAbstract, ChoiceAmbiguous]);
setMetadataFor(ConcatenationItemAbstract, 'ConcatenationItemAbstract', classMeta, VOID, [RuleItemAbstract, ConcatenationItem]);
setMetadataFor(OptionalItem, 'OptionalItem', interfaceMeta, VOID, [ConcatenationItem]);
setMetadataFor(OptionalItemDefault, 'OptionalItemDefault', classMeta, VOID, [ConcatenationItemAbstract, OptionalItem]);
setMetadataFor(SimpleItemAbstract, 'SimpleItemAbstract', classMeta, VOID, [ConcatenationItemAbstract, SimpleItem]);
setMetadataFor(Group, 'Group', interfaceMeta, VOID, [SimpleItem]);
setMetadataFor(GroupDefault, 'GroupDefault', classMeta, VOID, [SimpleItemAbstract, Group]);
setMetadataFor(TangibleItemAbstract, 'TangibleItemAbstract', classMeta, VOID, [SimpleItemAbstract, TangibleItem]);
setMetadataFor(EmptyRule, 'EmptyRule', interfaceMeta, VOID, [TangibleItem]);
setMetadataFor(EmptyRuleDefault, 'EmptyRuleDefault', classMeta, VOID, [TangibleItemAbstract, EmptyRule]);
setMetadataFor(TerminalDefault, 'TerminalDefault', classMeta, VOID, [TangibleItemAbstract, Terminal]);
setMetadataFor(NonTerminal, 'NonTerminal', interfaceMeta, VOID, [TangibleItem]);
setMetadataFor(NonTerminalDefault, 'NonTerminalDefault', classMeta, VOID, [TangibleItemAbstract, NonTerminal]);
setMetadataFor(Embedded, 'Embedded', interfaceMeta, VOID, [TangibleItem]);
setMetadataFor(EmbeddedDefault, 'EmbeddedDefault', classMeta, VOID, [TangibleItemAbstract, Embedded]);
setMetadataFor(ListOfItems, 'ListOfItems', interfaceMeta, VOID, [ConcatenationItem]);
setMetadataFor(ListOfItemsAbstract, 'ListOfItemsAbstract', classMeta, VOID, [ConcatenationItemAbstract, ListOfItems]);
setMetadataFor(SimpleList, 'SimpleList', interfaceMeta, VOID, [ListOfItems]);
setMetadataFor(SimpleListDefault, 'SimpleListDefault', classMeta, VOID, [ListOfItemsAbstract, SimpleList]);
setMetadataFor(SeparatedList, 'SeparatedList', interfaceMeta, VOID, [ListOfItems]);
setMetadataFor(SeparatedListDefault, 'SeparatedListDefault', classMeta, VOID, [ListOfItemsAbstract, SeparatedList]);
setMetadataFor(AglScopesCompletionProvider, 'AglScopesCompletionProvider', classMeta);
setMetadataFor(AglScopesGrammar, 'AglScopesGrammar', objectMeta);
protoOf(AglScopesSemanticAnalyser).analyse = analyse;
setMetadataFor(AglScopesSemanticAnalyser, 'AglScopesSemanticAnalyser', classMeta, VOID, [SemanticAnalyser]);
setMetadataFor(PropertyValue, 'PropertyValue', classMeta);
protoOf(AglScopesSyntaxAnalyser).configure = configure;
setMetadataFor(AglScopesSyntaxAnalyser, 'AglScopesSyntaxAnalyser', classMeta);
setMetadataFor(Companion_15, 'Companion', objectMeta);
setMetadataFor(ScopeModel, 'ScopeModel', interfaceMeta);
setMetadataFor(ScopeModelAgl, 'ScopeModelAgl', classMeta, VOID, [ScopeModel]);
setMetadataFor(ScopeDefinition, 'ScopeDefinition', classMeta);
setMetadataFor(Identifiable, 'Identifiable', classMeta);
setMetadataFor(ReferenceDefinition, 'ReferenceDefinition', classMeta);
setMetadataFor(Companion_16, 'Companion', objectMeta);
setMetadataFor(AglStyleCompletionProvider, 'AglStyleCompletionProvider', classMeta, VOID, [CompletionProvider]);
setMetadataFor(AglStyleGrammar, 'AglStyleGrammar', objectMeta);
setMetadataFor(Companion_17, 'Companion', objectMeta);
protoOf(AglStyleSemanticAnalyser).analyse = analyse;
setMetadataFor(AglStyleSemanticAnalyser, 'AglStyleSemanticAnalyser', classMeta, VOID, [SemanticAnalyser]);
setMetadataFor(Companion_18, 'Companion', objectMeta);
protoOf(AglStyleSyntaxAnalyser).configure = configure;
setMetadataFor(AglStyleSyntaxAnalyser, 'AglStyleSyntaxAnalyser', classMeta);
setMetadataFor(Companion_19, 'Companion', objectMeta);
setMetadataFor(AglStyleModel, 'AglStyleModel', interfaceMeta);
setMetadataFor(AglStyleModelDefault, 'AglStyleModelDefault', classMeta, VOID, [AglStyleModel]);
setMetadataFor(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(GrammarTypeNamespaceSimple, 'GrammarTypeNamespaceSimple', classMeta);
setMetadataFor(Companion_20, 'Companion', objectMeta);
setMetadataFor(InputFromString, 'InputFromString', classMeta);
setMetadataFor(GrowArgs, 'GrowArgs', classMeta);
setMetadataFor(Companion_21, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(RuntimeParser, 'RuntimeParser', classMeta);
setMetadataFor(ScanOnDemandParser, 'ScanOnDemandParser', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(Scanner, 'Scanner', classMeta);
setMetadataFor(SentenceDefault, 'SentenceDefault', classMeta);
setMetadataFor(FailedParseReason, 'FailedParseReason', classMeta);
setMetadataFor(FailedParseReasonWidthTo, 'FailedParseReasonWidthTo', classMeta);
setMetadataFor(FailedParseReasonGraftRTG, 'FailedParseReasonGraftRTG', classMeta);
setMetadataFor(FailedParseReasonLookahead, 'FailedParseReasonLookahead', classMeta);
setMetadataFor(FailedParseReasonEmbedded, 'FailedParseReasonEmbedded', classMeta);
setMetadataFor(Agl_0, 'Agl', objectMeta);
setMetadataFor(FormatterAbstract, 'FormatterAbstract', classMeta, VOID, [Formatter]);
setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_1, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_2, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_3, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_4, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_5, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_6, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_7, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_8, VOID, classMeta);
setMetadataFor(LanguageDefinition, 'LanguageDefinition', interfaceMeta);
setMetadataFor(LanguageDefinitionAbstract, 'LanguageDefinitionAbstract', classMeta, VOID, [LanguageDefinition]);
setMetadataFor(_no_name_provided__qut3iv_9, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_10, VOID, classMeta);
setMetadataFor(_no_name_provided__qut3iv_11, VOID, classMeta);
setMetadataFor(LanguageDefinitionDefault, 'LanguageDefinitionDefault', classMeta);
setMetadataFor(LanguageDefinitionFromAsm, 'LanguageDefinitionFromAsm', classMeta);
setMetadataFor(LanguageProcessor, 'LanguageProcessor', interfaceMeta);
protoOf(LanguageProcessorAbstract).buildFor = buildFor;
protoOf(LanguageProcessorAbstract).parse = parse;
protoOf(LanguageProcessorAbstract).syntaxAnalysis = syntaxAnalysis;
protoOf(LanguageProcessorAbstract).semanticAnalysis = semanticAnalysis;
protoOf(LanguageProcessorAbstract).process = process;
protoOf(LanguageProcessorAbstract).format = format;
protoOf(LanguageProcessorAbstract).formatAsm = formatAsm;
protoOf(LanguageProcessorAbstract).expectedTerminalsAt = expectedTerminalsAt;
protoOf(LanguageProcessorAbstract).expectedItemsAt = expectedItemsAt;
setMetadataFor(LanguageProcessorAbstract, 'LanguageProcessorAbstract', classMeta, VOID, [LanguageProcessor]);
protoOf(LanguageProcessorDefault).buildFor = buildFor;
protoOf(LanguageProcessorDefault).parse = parse;
protoOf(LanguageProcessorDefault).syntaxAnalysis = syntaxAnalysis;
protoOf(LanguageProcessorDefault).semanticAnalysis = semanticAnalysis;
protoOf(LanguageProcessorDefault).process = process;
protoOf(LanguageProcessorDefault).format = format;
protoOf(LanguageProcessorDefault).formatAsm = formatAsm;
protoOf(LanguageProcessorDefault).expectedTerminalsAt = expectedTerminalsAt;
protoOf(LanguageProcessorDefault).expectedItemsAt = expectedItemsAt;
setMetadataFor(LanguageProcessorDefault, 'LanguageProcessorDefault', classMeta);
protoOf(LanguageProcessorFromGenerated).buildFor = buildFor;
protoOf(LanguageProcessorFromGenerated).parse = parse;
protoOf(LanguageProcessorFromGenerated).syntaxAnalysis = syntaxAnalysis;
protoOf(LanguageProcessorFromGenerated).semanticAnalysis = semanticAnalysis;
protoOf(LanguageProcessorFromGenerated).process = process;
protoOf(LanguageProcessorFromGenerated).format = format;
protoOf(LanguageProcessorFromGenerated).formatAsm = formatAsm;
protoOf(LanguageProcessorFromGenerated).expectedTerminalsAt = expectedTerminalsAt;
protoOf(LanguageProcessorFromGenerated).expectedItemsAt = expectedItemsAt;
setMetadataFor(LanguageProcessorFromGenerated, 'LanguageProcessorFromGenerated', classMeta);
setMetadataFor(AglLanguages, 'AglLanguages', interfaceMeta);
setMetadataFor(LanguageRegistryDefault$agl$1, VOID, classMeta, VOID, [AglLanguages]);
setMetadataFor(GrammarRegistry, 'GrammarRegistry', interfaceMeta);
setMetadataFor(LanguageRegistry, 'LanguageRegistry', interfaceMeta, VOID, [GrammarRegistry]);
setMetadataFor(LanguageRegistryDefault, 'LanguageRegistryDefault', classMeta, VOID, [LanguageRegistry]);
setMetadataFor(IssueCollection, 'IssueCollection', interfaceMeta, VOID, [Collection]);
setMetadataFor(IssueHolder, 'IssueHolder', classMeta, VOID, [IssueCollection]);
setMetadataFor(LanguageProcessorResult, 'LanguageProcessorResult', classMeta);
setMetadataFor(ParseResult, 'ParseResult', interfaceMeta);
setMetadataFor(ParseResultDefault, 'ParseResultDefault', classMeta, VOID, [ParseResult]);
setMetadataFor(SyntaxAnalysisResult, 'SyntaxAnalysisResult', interfaceMeta);
setMetadataFor(SyntaxAnalysisResultDefault, 'SyntaxAnalysisResultDefault', classMeta, VOID, [SyntaxAnalysisResult]);
setMetadataFor(SemanticAnalysisResult, 'SemanticAnalysisResult', interfaceMeta);
setMetadataFor(SemanticAnalysisResultDefault, 'SemanticAnalysisResultDefault', classMeta, VOID, [SemanticAnalysisResult]);
setMetadataFor(ProcessResult, 'ProcessResult', interfaceMeta);
setMetadataFor(ProcessResultDefault, 'ProcessResultDefault', classMeta, VOID, [ProcessResult]);
setMetadataFor(FormatResult, 'FormatResult', interfaceMeta);
setMetadataFor(FormatResultDefault, 'FormatResultDefault', classMeta, VOID, [FormatResult]);
setMetadataFor(ExpectedAtResult, 'ExpectedAtResult', interfaceMeta);
setMetadataFor(ExpectedAtResultDefault, 'ExpectedAtResultDefault', classMeta, VOID, [ExpectedAtResult]);
setMetadataFor(RegexMatcherBuilder, 'RegexMatcherBuilder', classMeta);
setMetadataFor(Companion_22, 'Companion', objectMeta);
setMetadataFor(RegexMatcher, 'RegexMatcher', interfaceMeta);
protoOf(RegexMatcherImpl).match = match;
setMetadataFor(RegexMatcherImpl, 'RegexMatcherImpl', classMeta, VOID, [RegexMatcher]);
setMetadataFor(EscapeKind, 'EscapeKind', classMeta);
setMetadataFor(Companion_23, 'Companion', objectMeta);
setMetadataFor(RegexParser, 'RegexParser', classMeta);
setMetadataFor(Companion_24, 'Companion', objectMeta);
setMetadataFor(CharacterMatcher, 'CharacterMatcher', classMeta);
setMetadataFor(MatcherKind, 'MatcherKind', classMeta);
setMetadataFor(State, 'State', classMeta);
setMetadataFor(Fragment, 'Fragment', classMeta);
setMetadataFor(Transition_0, 'Transition', classMeta);
setMetadataFor(TransitionKind, 'TransitionKind', classMeta);
setMetadataFor(CompletedNodesStore, 'CompletedNodesStore', classMeta);
setMetadataFor(ToProcessTriple, 'ToProcessTriple', classMeta);
setMetadataFor(Companion_25, 'Companion', objectMeta);
setMetadataFor(MergeOptions, 'MergeOptions', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(ParseGraph, 'ParseGraph', classMeta);
setMetadataFor(RuntimeState, 'RuntimeState', classMeta);
setMetadataFor(StateInfoUncompressed, 'StateInfoUncompressed', classMeta);
setMetadataFor(TreeData, 'TreeData', classMeta);
setMetadataFor(SpptDataNode, 'SpptDataNode', interfaceMeta);
setMetadataFor(CompleteNodeIndex, 'CompleteNodeIndex', classMeta, VOID, [SpptDataNode]);
setMetadataFor(Companion_26, 'Companion', objectMeta);
setMetadataFor(GrowingNodeIndex, 'GrowingNodeIndex', classMeta);
setMetadataFor(Companion_27, 'Companion', objectMeta);
setMetadataFor(RulePosition, 'RulePosition', classMeta);
setMetadataFor(RuleOption, 'RuleOption', classMeta);
setMetadataFor(Assoc, 'Assoc', classMeta);
setMetadataFor(RuntimePreferenceOption, 'RuntimePreferenceOption', classMeta);
setMetadataFor(RuntimePreferenceRule, 'RuntimePreferenceRule', classMeta);
setMetadataFor(RuntimeRule, 'RuntimeRule', classMeta);
setMetadataFor(RuntimeRuleKind, 'RuntimeRuleKind', classMeta);
setMetadataFor(Companion_28, 'Companion', objectMeta);
setMetadataFor(RuntimeRuleRhs, 'RuntimeRuleRhs', classMeta);
setMetadataFor(RuntimeRuleRhsTerminal, 'RuntimeRuleRhsTerminal', classMeta);
setMetadataFor(RuntimeRuleRhsPattern, 'RuntimeRuleRhsPattern', classMeta);
setMetadataFor(Companion_29, 'Companion', objectMeta);
setMetadataFor(RuntimeRuleRhsLiteral, 'RuntimeRuleRhsLiteral', classMeta);
setMetadataFor(RuntimeRuleRhsEmbedded, 'RuntimeRuleRhsEmbedded', classMeta);
setMetadataFor(RuntimeRuleRhsNonTerminal, 'RuntimeRuleRhsNonTerminal', classMeta);
setMetadataFor(RuntimeRuleRhsConcatenation, 'RuntimeRuleRhsConcatenation', classMeta);
setMetadataFor(RuntimeRuleRhsChoice, 'RuntimeRuleRhsChoice', classMeta);
setMetadataFor(RuntimeRuleRhsOptional, 'RuntimeRuleRhsOptional', classMeta);
setMetadataFor(RuntimeRuleRhsList, 'RuntimeRuleRhsList', classMeta);
setMetadataFor(RuntimeRuleRhsListSimple, 'RuntimeRuleRhsListSimple', classMeta);
setMetadataFor(RuntimeRuleRhsListSeparated, 'RuntimeRuleRhsListSeparated', classMeta);
setMetadataFor(RuntimeRuleChoiceKind, 'RuntimeRuleChoiceKind', classMeta);
setMetadataFor(RuntimeRuleRhsGoal, 'RuntimeRuleRhsGoal', classMeta);
setMetadataFor(RuntimeRuleRhsEmpty, 'RuntimeRuleRhsEmpty', classMeta);
setMetadataFor(RuntimeRuleRhsCommonTerminal, 'RuntimeRuleRhsCommonTerminal', classMeta);
setMetadataFor(Companion_30, 'Companion', objectMeta);
setMetadataFor(Companion_31, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_7, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(RuntimeRuleSet, 'RuntimeRuleSet', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_8, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(SharedPackedParseTreeVisitor, 'SharedPackedParseTreeVisitor', interfaceMeta);
protoOf(CountTreesVisitor).visitNode = visitNode;
setMetadataFor(CountTreesVisitor, 'CountTreesVisitor', classMeta, VOID, [SharedPackedParseTreeVisitor]);
setMetadataFor(SharedPackedParseTree, 'SharedPackedParseTree', interfaceMeta);
protoOf(SPPTFromTreeData).toStringAllWithIndent = toStringAllWithIndent;
setMetadataFor(SPPTFromTreeData, 'SPPTFromTreeData', classMeta, VOID, [SharedPackedParseTree]);
setMetadataFor(SPPTParser, 'SPPTParser', interfaceMeta);
protoOf(SPPTParserDefault).parse = parse_0;
setMetadataFor(SPPTParserDefault, 'SPPTParserDefault', classMeta, VOID, [SPPTParser]);
setMetadataFor(TreeParser, 'TreeParser', classMeta);
setMetadataFor(SimpleScanner, 'SimpleScanner', classMeta);
setMetadataFor(Tokens, 'Tokens', objectMeta);
setMetadataFor(NodeStart, 'NodeStart', classMeta);
setMetadataFor(RuleReference, 'RuleReference', classMeta);
setMetadataFor(QName, 'QName', classMeta);
setMetadataFor(SpptWalker, 'SpptWalker', interfaceMeta);
setMetadataFor(SpptWalkerToInputSentence, 'SpptWalkerToInputSentence', classMeta, VOID, [SpptWalker]);
setMetadataFor(SpptWalkerToString, 'SpptWalkerToString', classMeta, VOID, [SpptWalker]);
setMetadataFor(ToStringVisitor, 'ToStringVisitor', classMeta);
setMetadataFor(TokensByLineVisitor$visitTree$callback$1, VOID, classMeta, VOID, [SpptWalker]);
setMetadataFor(TokensByLineVisitor, 'TokensByLineVisitor', classMeta);
setMetadataFor(CompleteTreeDataNode, 'CompleteTreeDataNode', classMeta, VOID, [SpptDataNode]);
setMetadataFor(Companion_32, 'Companion', objectMeta);
setMetadataFor(TreeDataComplete, 'TreeDataComplete', classMeta);
setMetadataFor(PreferredNode, 'PreferredNode', classMeta);
setMetadataFor(Companion_33, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_9, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_10, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(TreeDataWalkerDepthFirst, 'TreeDataWalkerDepthFirst', classMeta);
setMetadataFor(StackData, 'StackData', interfaceMeta);
setMetadataFor(AlternativesInfo, 'AlternativesInfo', classMeta, VOID, [StackData]);
setMetadataFor(SpptDataNodeInfo, 'SpptDataNodeInfo', interfaceMeta);
setMetadataFor(StackInfo, 'StackInfo', classMeta, VOID, [SpptDataNodeInfo, StackData]);
setMetadataFor(Companion_34, 'Companion', objectMeta);
setMetadataFor(ContextFromTypeModel, 'ContextFromTypeModel', classMeta, VOID, [SentenceContext]);
setMetadataFor(ContextSimple, 'ContextSimple', classMeta, VOID, [SentenceContext]);
setMetadataFor(Scope, 'Scope', interfaceMeta);
setMetadataFor(ScopeSimple, 'ScopeSimple', classMeta, VOID, [Scope]);
setMetadataFor(SyntaxAnalyserByMethodRegistrationAbstract$walkTree$walker$1, VOID, classMeta, VOID, [SpptWalker]);
setMetadataFor(NodeTypes, 'NodeTypes', classMeta);
setMetadataFor(DownData, 'DownData', classMeta);
setMetadataFor(ChildData, 'ChildData', classMeta);
setMetadataFor(Companion_35, 'Companion', objectMeta);
setMetadataFor(SyntaxAnalyserSimpleAbstract$walkTree$walker$1, VOID, classMeta, VOID, [SpptWalker]);
setMetadataFor(Companion_36, 'Companion', objectMeta);
setMetadataFor(SyntaxAnalyserSimpleStreamPushAbstract$walkTree$walker$1, VOID, classMeta, VOID, [SpptWalker]);
protoOf(SyntaxAnalyserSimpleStreamPushAbstract).configure = configure;
setMetadataFor(SyntaxAnalyserSimpleStreamPushAbstract, 'SyntaxAnalyserSimpleStreamPushAbstract', classMeta);
setMetadataFor(Companion_37, 'Companion', objectMeta);
setMetadataFor(AsmElementPath, 'AsmElementPath', classMeta);
setMetadataFor(Companion_38, 'Companion', objectMeta);
setMetadataFor(sam$kotlin_Comparator$0_11, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(AsmSimple, 'AsmSimple', classMeta);
setMetadataFor(sam$kotlin_Comparator$0_12, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(AsmElementSimple, 'AsmElementSimple', classMeta);
setMetadataFor(AsmElementReference, 'AsmElementReference', classMeta);
setMetadataFor(AsmElementProperty, 'AsmElementProperty', classMeta);
setMetadataFor(AsmSimpleBuilder, 'AsmSimpleBuilder', classMeta);
setMetadataFor(AsmElementSimpleBuilder, 'AsmElementSimpleBuilder', classMeta);
setMetadataFor(ListAsmElementSimpleBuilder, 'ListAsmElementSimpleBuilder', classMeta);
setMetadataFor(AsmSimpleBuilderMarker, 'AsmSimpleBuilderMarker', classMeta);
setMetadataFor(Companion_39, 'Companion', objectMeta);
setMetadataFor(ParseAction, 'ParseAction', classMeta);
setMetadataFor(AglAutomatonDslMarker, 'AglAutomatonDslMarker', classMeta);
setMetadataFor(FormatModelBuilder, 'FormatModelBuilder', classMeta);
setMetadataFor(FormatExpressionBuilder, 'FormatExpressionBuilder', classMeta);
setMetadataFor(GrammarExeception, 'GrammarExeception', classMeta);
setMetadataFor(GrammarLoader, 'GrammarLoader', interfaceMeta);
setMetadataFor(GrammarRegistry_0, 'GrammarRegistry', interfaceMeta);
setMetadataFor(Associativity, 'Associativity', classMeta);
setMetadataFor(OverrideKind, 'OverrideKind', classMeta);
setMetadataFor(GrammarRuleItemNotFoundException, 'GrammarRuleItemNotFoundException', classMeta);
setMetadataFor(GrammarRuleNotFoundException, 'GrammarRuleNotFoundException', classMeta);
setMetadataFor(SeparatedListKind, 'SeparatedListKind', classMeta);
setMetadataFor(GrammarTypeModelBuilder, 'GrammarTypeModelBuilder', classMeta);
setMetadataFor(Message, 'Message', objectMeta);
setMetadataFor(InputLocation, 'InputLocation', classMeta);
setMetadataFor(ParseTreeException, 'ParseTreeException', classMeta);
setMetadataFor(ParserConstructionFailedException, 'ParserConstructionFailedException', classMeta);
setMetadataFor(ParserException, 'ParserException', classMeta);
setMetadataFor(ParserTerminatedException, 'ParserTerminatedException', classMeta);
setMetadataFor(ParseFailedException, 'ParseFailedException', classMeta);
setMetadataFor(AutomatonKind, 'AutomatonKind', classMeta);
setMetadataFor(AutomatonKind_api_0, 'AutomatonKind_api', objectMeta);
setMetadataFor(CompletionItemKind, 'CompletionItemKind', classMeta);
setMetadataFor(CompletionItem, 'CompletionItem', classMeta);
setMetadataFor(LanguageProcessorException, 'LanguageProcessorException', classMeta);
setMetadataFor(LanguageIssueKind, 'LanguageIssueKind', classMeta);
setMetadataFor(LanguageProcessorPhase, 'LanguageProcessorPhase', classMeta);
setMetadataFor(LanguageIssue, 'LanguageIssue', classMeta);
setMetadataFor(LanguageProcessorConfiguration, 'LanguageProcessorConfiguration', interfaceMeta);
setMetadataFor(ParseOptions, 'ParseOptions', interfaceMeta);
setMetadataFor(SyntaxAnalysisOptions, 'SyntaxAnalysisOptions', interfaceMeta);
setMetadataFor(SemanticAnalysisOptions, 'SemanticAnalysisOptions', interfaceMeta);
setMetadataFor(CompletionProviderOptions, 'CompletionProviderOptions', interfaceMeta);
setMetadataFor(ProcessOptions, 'ProcessOptions', interfaceMeta);
setMetadataFor(LanguageProcessorConfigurationBuilder, 'LanguageProcessorConfigurationBuilder', classMeta);
setMetadataFor(ProcessOptionsBuilder, 'ProcessOptionsBuilder', classMeta);
setMetadataFor(ParseOptionsBuilder, 'ParseOptionsBuilder', classMeta);
setMetadataFor(SyntaxAnalysisOptionsBuilder, 'SyntaxAnalysisOptionsBuilder', classMeta);
setMetadataFor(SemanticAnalysisOptionsBuilder, 'SemanticAnalysisOptionsBuilder', classMeta);
setMetadataFor(CompletionProviderOptionsBuilder, 'CompletionProviderOptionsBuilder', classMeta);
setMetadataFor(LanguageProcessorConfigurationDefault, 'LanguageProcessorConfigurationDefault', classMeta, VOID, [LanguageProcessorConfiguration]);
setMetadataFor(LanguageProcessorConfigurationDslMarker, 'LanguageProcessorConfigurationDslMarker', classMeta);
setMetadataFor(ParseOptionsDefault, 'ParseOptionsDefault', classMeta, VOID, [ParseOptions]);
setMetadataFor(SyntaxAnalysisOptionsDefault, 'SyntaxAnalysisOptionsDefault', classMeta, VOID, [SyntaxAnalysisOptions]);
setMetadataFor(SemanticAnalysisOptionsDefault, 'SemanticAnalysisOptionsDefault', classMeta, VOID, [SemanticAnalysisOptions]);
setMetadataFor(CompletionProviderOptionsDefault, 'CompletionProviderOptionsDefault', classMeta, VOID, [CompletionProviderOptions]);
setMetadataFor(ProcessOptionsDefault, 'ProcessOptionsDefault', classMeta, VOID, [ProcessOptions]);
setMetadataFor(ProcessOptionsDslMarker, 'ProcessOptionsDslMarker', classMeta);
setMetadataFor(MatchResult, 'MatchResult', classMeta);
setMetadataFor(SPPTNode, 'SPPTNode', interfaceMeta);
setMetadataFor(SPPTBranch, 'SPPTBranch', interfaceMeta, VOID, [SPPTNode]);
setMetadataFor(SPPTException, 'SPPTException', classMeta);
setMetadataFor(SPPTLeaf, 'SPPTLeaf', interfaceMeta, VOID, [SPPTNode]);
setMetadataFor(SPPTNodeIdentity, 'SPPTNodeIdentity', interfaceMeta);
setMetadataFor(ChildInfo, 'ChildInfo', classMeta);
setMetadataFor(AltInfo, 'AltInfo', classMeta);
setMetadataFor(LeafData, 'LeafData', classMeta);
setMetadataFor(AglStyleRule, 'AglStyleRule', classMeta);
setMetadataFor(AglStyleSelectorKind, 'AglStyleSelectorKind', classMeta);
setMetadataFor(AglStyleSelector, 'AglStyleSelector', classMeta);
setMetadataFor(AglStyle, 'AglStyle', classMeta);
setMetadataFor(GraphStructuredStack, 'GraphStructuredStack', classMeta);
setMetadataFor(LazyMap, 'LazyMap', classMeta, VOID, [Map]);
setMetadataFor(LazyMutableMapNonNull, 'LazyMutableMapNonNull', classMeta, VOID, [Map, MutableMap]);
setMetadataFor(ListSeparatedArrayList, 'ListSeparatedArrayList', classMeta, VOID, [AbstractList, List]);
setMetadataFor(MutableQueue, 'MutableQueue', classMeta);
setMetadataFor(MutableStack, 'MutableStack', classMeta);
setMetadataFor(OrderedSet, 'OrderedSet', interfaceMeta, VOID, [Set]);
setMetadataFor(MutableOrderedSetImpl, 'MutableOrderedSetImpl', classMeta, VOID, [OrderedSet, MutableSet]);
setMetadataFor(OrderedSetImpl, 'OrderedSetImpl', classMeta, VOID, [OrderedSet]);
setMetadataFor(Entry, 'Entry', interfaceMeta);
setMetadataFor(Entry_0, 'Entry', classMeta, VOID, [Entry]);
setMetadataFor(sam$kotlin_Comparator$0_13, 'sam$kotlin_Comparator$0', classMeta);
setMetadataFor(BinaryHeapComparable$iterator$1, VOID, classMeta);
setMetadataFor(BinaryHeapComparable, 'BinaryHeapComparable', classMeta, VOID, [Iterable]);
setMetadataFor(IndentDelta, 'IndentDelta', classMeta);
setMetadataFor(Debug, 'Debug', objectMeta);
setMetadataFor(UNINITIALIZED_VALUE, 'UNINITIALIZED_VALUE', objectMeta);
setMetadataFor(Companion_40, 'Companion', objectMeta);
setMetadataFor(CachedValue, 'CachedValue', classMeta);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
GrammarBuilderDefault.RuleBuilder = RuleBuilder;
GrammarRuleAbstract.Companion.CompressedLeafRule = CompressedLeafRule;
AglScopesSyntaxAnalyser.PropertyValue = PropertyValue;
var Agl = {getInstance: Agl_getInstance};
ParseAction.values = values;
ParseAction.valueOf = valueOf;
OverrideKind.values = values_1;
OverrideKind.valueOf = valueOf_1;
SeparatedListKind.values = values_2;
SeparatedListKind.valueOf = valueOf_2;
AutomatonKind.values = values_3;
AutomatonKind.valueOf = valueOf_3;
var AutomatonKind_api = {getInstance: AutomatonKind_api_getInstance};
CompletionItemKind.values = values_4;
CompletionItemKind.valueOf = valueOf_4;
LanguageIssueKind.values = values_5;
LanguageIssueKind.valueOf = valueOf_5;
LanguageProcessorPhase.values = values_6;
LanguageProcessorPhase.valueOf = valueOf_6;
AglStyleSelectorKind.values = values_7;
AglStyleSelectorKind.valueOf = valueOf_7;
export {
  BuildConfig,
  AglFormatterModelDefault,
  AglFormatterRuleDefault,
  AglFormatExpressionDefault,
  AglGrammarSemanticAnalyser,
  ContextFromGrammar,
  GrammarContext,
  GrammarBuilderDefault,
  GrammarDefault,
  GrammarOptionDefault,
  GrammarReferenceDefault,
  GrammarAbstract,
  GrammarItemAbstract,
  GrammarRuleAbstract,
  NamespaceDefault,
  NodeTypeDefault,
  NormalRuleDefault,
  OverrideRuleDefault,
  PreferenceRuleDefault,
  PreferenceOptionDefault,
  RuleItemAbstract,
  ConcatenationDefault,
  ChoiceAbstract,
  ChoiceLongestDefault,
  ChoicePriorityDefault,
  ChoiceAmbiguousDefault,
  ConcatenationItemAbstract,
  OptionalItemDefault,
  SimpleItemAbstract,
  GroupDefault,
  TangibleItemAbstract,
  EmptyRuleDefault,
  TerminalDefault,
  NonTerminalDefault,
  EmbeddedDefault,
  ListOfItemsAbstract,
  SimpleListDefault,
  SeparatedListDefault,
  AglScopesSyntaxAnalyser,
  ScopeModelAgl,
  ScopeDefinition,
  Identifiable,
  ReferenceDefinition,
  Agl,
  FormatterAbstract,
  LanguageDefinitionAbstract,
  plus_3,
  IssueHolder,
  LanguageProcessorResult,
  ParseResultDefault,
  SyntaxAnalysisResultDefault,
  SemanticAnalysisResultDefault,
  ProcessResultDefault,
  FormatResultDefault,
  ExpectedAtResultDefault,
  regexMatcher,
  CompleteTreeDataNode,
  TreeDataComplete,
  ContextFromTypeModel,
  ContextSimple,
  createReferenceLocalToScope,
  ScopeSimple,
  SyntaxAnalyserByMethodRegistrationAbstract,
  SyntaxAnalyserFromTreeDataAbstract,
  NodeTypes,
  DownData,
  ChildData,
  SyntaxAnalyserSimpleAbstract,
  SyntaxAnalyserSimpleStreamPushAbstract,
  AsmElementPath,
  AsmSimple,
  AsmElementSimple,
  AsmElementReference,
  AsmElementProperty,
  asmSimple,
  AsmSimpleBuilder,
  AsmElementSimpleBuilder,
  ListAsmElementSimpleBuilder,
  ParseAction,
  formatModel,
  FormatModelBuilder,
  FormatExpressionBuilder,
  GrammarExeception,
  OverrideKind,
  GrammarRuleItemNotFoundException,
  GrammarRuleNotFoundException,
  SeparatedListKind,
  InputLocation,
  ParseTreeException,
  ParserConstructionFailedException,
  ParserException,
  ParserTerminatedException,
  ParseFailedException,
  AutomatonKind,
  AutomatonKind_api,
  CompletionItemKind,
  CompletionItem,
  LanguageProcessorException,
  LanguageIssueKind,
  LanguageProcessorPhase,
  LanguageIssue,
  LanguageProcessorConfigurationBuilder,
  ProcessOptionsBuilder,
  ParseOptionsBuilder,
  SyntaxAnalysisOptionsBuilder,
  SemanticAnalysisOptionsBuilder,
  CompletionProviderOptionsBuilder,
  SPPTException,
  ChildInfo,
  AltInfo,
  LeafData,
  AglStyleRule,
  AglStyleSelectorKind,
  AglStyleSelector,
  AglStyle,
};
export {
  LanguageProcessorPhase_ALL_getInstance as a,
  LanguageProcessorPhase_SEMANTIC_ANALYSIS_getInstance as b,
  AglStyleSelectorKind_LITERAL_getInstance as c,
  analyse as d,
  configure as e,
  TypeModelFromGrammar_getInstance as f,
  Companion_getInstance_14 as g,
  Agl_getInstance as h,
  ListSeparatedArrayList as i,
  ChoiceAbstract as j,
  ChoiceAmbiguousDefault as k,
  ChoiceLongestDefault as l,
  ChoicePriorityDefault as m,
  ConcatenationDefault as n,
  ConcatenationItemAbstract as o,
  EmbeddedDefault as p,
  EmptyRuleDefault as q,
  GrammarAbstract as r,
  GrammarBuilderDefault as s,
  GrammarDefault as t,
  GrammarItemAbstract as u,
  GrammarOptionDefault as v,
  GrammarReferenceDefault as w,
  GrammarRuleAbstract as x,
  GroupDefault as y,
  ListOfItemsAbstract as z,
  NamespaceDefault as a1,
  NodeTypeDefault as b1,
  NonTerminalDefault as c1,
  NormalRuleDefault as d1,
  OptionalItemDefault as e1,
  OverrideRuleDefault as f1,
  PreferenceOptionDefault as g1,
  PreferenceRuleDefault as h1,
  RuleItemAbstract as i1,
  SeparatedListDefault as j1,
  SimpleItemAbstract as k1,
  SimpleListDefault as l1,
  TangibleItemAbstract as m1,
  TerminalDefault as n1,
  AglGrammarGrammar as o1,
  AglGrammarSemanticAnalyser as p1,
  AglGrammarSyntaxAnalyser as q1,
  ContextFromGrammar as r1,
  ConverterToRuntimeRules as s1,
  GrammarContext as t1,
  AglScopesGrammar as u1,
  AglScopesSyntaxAnalyser as v1,
  Identifiable as w1,
  ReferenceDefinition as x1,
  ScopeDefinition as y1,
  ScopeModelAgl as z1,
  AglStyleGrammar as a2,
  AglStyleModelDefault as b2,
  AglStyleSyntaxAnalyser as c2,
  GrammarTypeModelBuilder as d2,
  GrammarTypeNamespaceAbstract as e2,
  GrammarTypeNamespaceSimple as f2,
  IssueHolder as g2,
  ProcessResultDefault as h2,
  SemanticAnalysisResultDefault as i2,
  AlternativesInfo as j2,
  CompleteTreeDataNode as k2,
  CountTreesVisitor as l2,
  NodeStart as m2,
  PreferredNode as n2,
  QName as o2,
  RuleReference as p2,
  SPPTFromTreeData as q2,
  SPPTParserDefault as r2,
  SimpleScanner as s2,
  StackData as t2,
  StackInfo as u2,
  ToStringVisitor as v2,
  TokensByLineVisitor as w2,
  Tokens as x2,
  TreeDataComplete as y2,
  TreeDataWalkerDepthFirst as z2,
  TreeParser as a3,
  ChildData as b3,
  ContextFromTypeModel as c3,
  ContextSimple as d3,
  DownData as e3,
  NodeTypes as f3,
  ScopeSimple as g3,
  SyntaxAnalyserByMethodRegistrationAbstract as h3,
  SyntaxAnalyserFromTreeDataAbstract as i3,
  SyntaxAnalyserSimpleAbstract as j3,
  SyntaxAnalyserSimpleStreamPushAbstract as k3,
  SemanticAnalyser as l3,
  AsmElementPath as m3,
  AsmElementProperty as n3,
  AsmElementReference as o3,
  AsmElementSimpleBuilder as p3,
  AsmElementSimple as q3,
  AsmSimpleBuilderMarker as r3,
  AsmSimpleBuilder as s3,
  AsmSimpleTreeWalker as t3,
  AsmSimple as u3,
  ListAsmElementSimpleBuilder as v3,
  Scope as w3,
  AglAutomatonDslMarker as x3,
  AutomatonBuilder as y3,
  Automaton as z3,
  values as a4,
  ParseAction as b4,
  TransitionBuilder as c4,
  ChoiceAmbiguous as d4,
  ChoiceLongest as e4,
  ChoicePriority as f4,
  Choice as g4,
  ConcatenationItem as h4,
  Concatenation as i4,
  Embedded as j4,
  EmptyRule as k4,
  GrammarExeception as l4,
  GrammarItem as m4,
  GrammarLoader as n4,
  GrammarOption as o4,
  GrammarReference as p4,
  GrammarRegistry_0 as q4,
  GrammarRuleItemNotFoundException as r4,
  GrammarRuleNotFoundException as s4,
  GrammarRule as t4,
  Grammar as u4,
  Group as v4,
  ListOfItems as w4,
  Namespace as x4,
  NodeType as y4,
  NonTerminal as z4,
  NormalRule as a5,
  OptionalItem as b5,
  values_1 as c5,
  OverrideKind as d5,
  OverrideRule as e5,
  PreferenceOption as f5,
  PreferenceRule as g5,
  RuleItem as h5,
  values_2 as i5,
  SeparatedListKind as j5,
  SeparatedList as k5,
  SimpleItem as l5,
  SimpleList as m5,
  TangibleItem as n5,
  Terminal as o5,
  GrammarTypeNamespace as p5,
  InputLocation as q5,
  ParseFailedException as r5,
  ParseTreeException as s5,
  ParserConstructionFailedException as t5,
  ParserException as u5,
  ParserTerminatedException as v5,
  values_3 as w5,
  AutomatonKind_api_0 as x5,
  AutomatonKind as y5,
  values_4 as z5,
  CompletionItemKind as a6,
  CompletionItem as b6,
  CompletionProviderOptionsBuilder as c6,
  CompletionProviderOptionsDefault as d6,
  CompletionProviderOptions as e6,
  CompletionProvider as f6,
  ExpectedAtResult as g6,
  FormatResult as h6,
  Formatter as i6,
  GrammarRegistry as j6,
  IssueCollection as k6,
  LanguageDefinition as l6,
  values_5 as m6,
  LanguageIssueKind as n6,
  LanguageIssue as o6,
  LanguageProcessorConfigurationBuilder as p6,
  LanguageProcessorConfigurationDefault as q6,
  LanguageProcessorConfigurationDslMarker as r6,
  LanguageProcessorConfiguration as s6,
  LanguageProcessorException as t6,
  values_6 as u6,
  LanguageProcessorPhase as v6,
  LanguageProcessor as w6,
  LanguageRegistry as x6,
  ParseOptionsBuilder as y6,
  ParseOptionsDefault as z6,
  ParseOptions as a7,
  ParseResult as b7,
  ProcessOptionsBuilder as c7,
  ProcessOptionsDefault as d7,
  ProcessOptionsDslMarker as e7,
  ProcessOptions as f7,
  ProcessResult as g7,
  SemanticAnalysisOptionsBuilder as h7,
  SemanticAnalysisOptionsDefault as i7,
  SemanticAnalysisOptions as j7,
  SemanticAnalysisResult as k7,
  SentenceContext as l7,
  SyntaxAnalysisOptionsBuilder as m7,
  SyntaxAnalysisOptionsDefault as n7,
  SyntaxAnalysisOptions as o7,
  SyntaxAnalysisResult as p7,
  SpptWalker as q7,
  AglStyleModel as r7,
  AglStyleRule as s7,
  values_7 as t7,
  AglStyleSelectorKind as u7,
  AglStyleSelector as v7,
  AglStyle as w7,
  mutableStackOf as x7,
};
//endregion

//# sourceMappingURL=net.akehurst.language-agl-processor.mjs.map
